import './main.css';var $t = Object.defineProperty;
var jt = (t, e, a) => e in t ? $t(t, e, { enumerable: !0, configurable: !0, writable: !0, value: a }) : t[e] = a;
var J0 = (t, e, a) => jt(t, typeof e != "symbol" ? e + "" : e, a);
import * as Wt from "@mui/material";
import { selectClasses as Ut, createTheme as r1, ThemeProvider as qt, useTheme as ya, Avatar as Yt, Divider as _a, Rating as Kt, TextField as wa, InputAdornment as de, styled as Ta, Box as V, Tooltip as Xt, Popover as Qt, Typography as R, Link as w0, Button as D0, Paper as Jt, Grid as h0, useMediaQuery as V1, AppBar as e2, Toolbar as a2, IconButton as v1, Popper as t2, Tabs as O1, Tab as E1, Accordion as we, AccordionSummary as Te, AccordionDetails as Se, Container as a1, Chip as Oe } from "@mui/material";
export * from "@mui/material";
import * as r2 from "@mui/x-date-pickers";
export * from "@mui/x-date-pickers";
import { jsxs as h, jsx as r, Fragment as H0 } from "react/jsx-runtime";
import * as M0 from "react";
import d0, { createContext as i2, useState as Z0, useEffect as F0, useMemo as Ee, useContext as Sa, cloneElement as Ma, useRef as W0, useCallback as He } from "react";
function g0() {
  return g0 = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var a = arguments[e];
      for (var i in a) ({}).hasOwnProperty.call(a, i) && (t[i] = a[i]);
    }
    return t;
  }, g0.apply(null, arguments);
}
var P0 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function L0(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function n2(t) {
  if (t.__esModule) return t;
  var e = t.default;
  if (typeof e == "function") {
    var a = function i() {
      return this instanceof i ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    a.prototype = e.prototype;
  } else a = {};
  return Object.defineProperty(a, "__esModule", { value: !0 }), Object.keys(t).forEach(function(i) {
    var n = Object.getOwnPropertyDescriptor(t, i);
    Object.defineProperty(a, i, n.get ? n : {
      enumerable: !0,
      get: function() {
        return t[i];
      }
    });
  }), a;
}
var Aa = { exports: {} };
(function(t, e) {
  (function(a, i) {
    t.exports = i();
  })(P0, function() {
    var a = 1e3, i = 6e4, n = 36e5, o = "millisecond", d = "second", s = "minute", c = "hour", m = "day", f = "week", p = "month", b = "quarter", y = "year", v = "date", g = "Invalid Date", _ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, M = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, S = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(C) {
      var P = ["th", "st", "nd", "rd"], x = C % 100;
      return "[" + C + (P[(x - 20) % 10] || P[x] || P[0]) + "]";
    } }, O = function(C, P, x) {
      var w = String(C);
      return !w || w.length >= P ? C : "" + Array(P + 1 - w.length).join(x) + C;
    }, I = { s: O, z: function(C) {
      var P = -C.utcOffset(), x = Math.abs(P), w = Math.floor(x / 60), L = x % 60;
      return (P <= 0 ? "+" : "-") + O(w, 2, "0") + ":" + O(L, 2, "0");
    }, m: function C(P, x) {
      if (P.date() < x.date()) return -C(x, P);
      var w = 12 * (x.year() - P.year()) + (x.month() - P.month()), L = P.clone().add(w, p), j = x - L < 0, A = P.clone().add(w + (j ? -1 : 1), p);
      return +(-(w + (x - L) / (j ? L - A : A - L)) || 0);
    }, a: function(C) {
      return C < 0 ? Math.ceil(C) || 0 : Math.floor(C);
    }, p: function(C) {
      return { M: p, y, w: f, d: m, D: v, h: c, m: s, s: d, ms: o, Q: b }[C] || String(C || "").toLowerCase().replace(/s$/, "");
    }, u: function(C) {
      return C === void 0;
    } }, z = "en", $ = {};
    $[z] = S;
    var Q = "$isDayjsObject", i0 = function(C) {
      return C instanceof F || !(!C || !C[Q]);
    }, N = function C(P, x, w) {
      var L;
      if (!P) return z;
      if (typeof P == "string") {
        var j = P.toLowerCase();
        $[j] && (L = j), x && ($[j] = x, L = j);
        var A = P.split("-");
        if (!L && A.length > 1) return C(A[0]);
      } else {
        var E = P.name;
        $[E] = P, L = E;
      }
      return !w && L && (z = L), L || !w && z;
    }, Z = function(C, P) {
      if (i0(C)) return C.clone();
      var x = typeof P == "object" ? P : {};
      return x.date = C, x.args = arguments, new F(x);
    }, k = I;
    k.l = N, k.i = i0, k.w = function(C, P) {
      return Z(C, { locale: P.$L, utc: P.$u, x: P.$x, $offset: P.$offset });
    };
    var F = function() {
      function C(x) {
        this.$L = N(x.locale, null, !0), this.parse(x), this.$x = this.$x || x.x || {}, this[Q] = !0;
      }
      var P = C.prototype;
      return P.parse = function(x) {
        this.$d = function(w) {
          var L = w.date, j = w.utc;
          if (L === null) return /* @__PURE__ */ new Date(NaN);
          if (k.u(L)) return /* @__PURE__ */ new Date();
          if (L instanceof Date) return new Date(L);
          if (typeof L == "string" && !/Z$/i.test(L)) {
            var A = L.match(_);
            if (A) {
              var E = A[2] - 1 || 0, q = (A[7] || "0").substring(0, 3);
              return j ? new Date(Date.UTC(A[1], E, A[3] || 1, A[4] || 0, A[5] || 0, A[6] || 0, q)) : new Date(A[1], E, A[3] || 1, A[4] || 0, A[5] || 0, A[6] || 0, q);
            }
          }
          return new Date(L);
        }(x), this.init();
      }, P.init = function() {
        var x = this.$d;
        this.$y = x.getFullYear(), this.$M = x.getMonth(), this.$D = x.getDate(), this.$W = x.getDay(), this.$H = x.getHours(), this.$m = x.getMinutes(), this.$s = x.getSeconds(), this.$ms = x.getMilliseconds();
      }, P.$utils = function() {
        return k;
      }, P.isValid = function() {
        return this.$d.toString() !== g;
      }, P.isSame = function(x, w) {
        var L = Z(x);
        return this.startOf(w) <= L && L <= this.endOf(w);
      }, P.isAfter = function(x, w) {
        return Z(x) < this.startOf(w);
      }, P.isBefore = function(x, w) {
        return this.endOf(w) < Z(x);
      }, P.$g = function(x, w, L) {
        return k.u(x) ? this[w] : this.set(L, x);
      }, P.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, P.valueOf = function() {
        return this.$d.getTime();
      }, P.startOf = function(x, w) {
        var L = this, j = !!k.u(w) || w, A = k.p(x), E = function(D, K) {
          var n0 = k.w(L.$u ? Date.UTC(L.$y, K, D) : new Date(L.$y, K, D), L);
          return j ? n0 : n0.endOf(m);
        }, q = function(D, K) {
          return k.w(L.toDate()[D].apply(L.toDate("s"), (j ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(K)), L);
        }, W = this.$W, Y = this.$M, X = this.$D, e0 = "set" + (this.$u ? "UTC" : "");
        switch (A) {
          case y:
            return j ? E(1, 0) : E(31, 11);
          case p:
            return j ? E(1, Y) : E(0, Y + 1);
          case f:
            var J = this.$locale().weekStart || 0, t0 = (W < J ? W + 7 : W) - J;
            return E(j ? X - t0 : X + (6 - t0), Y);
          case m:
          case v:
            return q(e0 + "Hours", 0);
          case c:
            return q(e0 + "Minutes", 1);
          case s:
            return q(e0 + "Seconds", 2);
          case d:
            return q(e0 + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, P.endOf = function(x) {
        return this.startOf(x, !1);
      }, P.$set = function(x, w) {
        var L, j = k.p(x), A = "set" + (this.$u ? "UTC" : ""), E = (L = {}, L[m] = A + "Date", L[v] = A + "Date", L[p] = A + "Month", L[y] = A + "FullYear", L[c] = A + "Hours", L[s] = A + "Minutes", L[d] = A + "Seconds", L[o] = A + "Milliseconds", L)[j], q = j === m ? this.$D + (w - this.$W) : w;
        if (j === p || j === y) {
          var W = this.clone().set(v, 1);
          W.$d[E](q), W.init(), this.$d = W.set(v, Math.min(this.$D, W.daysInMonth())).$d;
        } else E && this.$d[E](q);
        return this.init(), this;
      }, P.set = function(x, w) {
        return this.clone().$set(x, w);
      }, P.get = function(x) {
        return this[k.p(x)]();
      }, P.add = function(x, w) {
        var L, j = this;
        x = Number(x);
        var A = k.p(w), E = function(Y) {
          var X = Z(j);
          return k.w(X.date(X.date() + Math.round(Y * x)), j);
        };
        if (A === p) return this.set(p, this.$M + x);
        if (A === y) return this.set(y, this.$y + x);
        if (A === m) return E(1);
        if (A === f) return E(7);
        var q = (L = {}, L[s] = i, L[c] = n, L[d] = a, L)[A] || 1, W = this.$d.getTime() + x * q;
        return k.w(W, this);
      }, P.subtract = function(x, w) {
        return this.add(-1 * x, w);
      }, P.format = function(x) {
        var w = this, L = this.$locale();
        if (!this.isValid()) return L.invalidDate || g;
        var j = x || "YYYY-MM-DDTHH:mm:ssZ", A = k.z(this), E = this.$H, q = this.$m, W = this.$M, Y = L.weekdays, X = L.months, e0 = L.meridiem, J = function(K, n0, G, m0) {
          return K && (K[n0] || K(w, j)) || G[n0].slice(0, m0);
        }, t0 = function(K) {
          return k.s(E % 12 || 12, K, "0");
        }, D = e0 || function(K, n0, G) {
          var m0 = K < 12 ? "AM" : "PM";
          return G ? m0.toLowerCase() : m0;
        };
        return j.replace(M, function(K, n0) {
          return n0 || function(G) {
            switch (G) {
              case "YY":
                return String(w.$y).slice(-2);
              case "YYYY":
                return k.s(w.$y, 4, "0");
              case "M":
                return W + 1;
              case "MM":
                return k.s(W + 1, 2, "0");
              case "MMM":
                return J(L.monthsShort, W, X, 3);
              case "MMMM":
                return J(X, W);
              case "D":
                return w.$D;
              case "DD":
                return k.s(w.$D, 2, "0");
              case "d":
                return String(w.$W);
              case "dd":
                return J(L.weekdaysMin, w.$W, Y, 2);
              case "ddd":
                return J(L.weekdaysShort, w.$W, Y, 3);
              case "dddd":
                return Y[w.$W];
              case "H":
                return String(E);
              case "HH":
                return k.s(E, 2, "0");
              case "h":
                return t0(1);
              case "hh":
                return t0(2);
              case "a":
                return D(E, q, !0);
              case "A":
                return D(E, q, !1);
              case "m":
                return String(q);
              case "mm":
                return k.s(q, 2, "0");
              case "s":
                return String(w.$s);
              case "ss":
                return k.s(w.$s, 2, "0");
              case "SSS":
                return k.s(w.$ms, 3, "0");
              case "Z":
                return A;
            }
            return null;
          }(K) || A.replace(":", "");
        });
      }, P.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, P.diff = function(x, w, L) {
        var j, A = this, E = k.p(w), q = Z(x), W = (q.utcOffset() - this.utcOffset()) * i, Y = this - q, X = function() {
          return k.m(A, q);
        };
        switch (E) {
          case y:
            j = X() / 12;
            break;
          case p:
            j = X();
            break;
          case b:
            j = X() / 3;
            break;
          case f:
            j = (Y - W) / 6048e5;
            break;
          case m:
            j = (Y - W) / 864e5;
            break;
          case c:
            j = Y / n;
            break;
          case s:
            j = Y / i;
            break;
          case d:
            j = Y / a;
            break;
          default:
            j = Y;
        }
        return L ? j : k.a(j);
      }, P.daysInMonth = function() {
        return this.endOf(p).$D;
      }, P.$locale = function() {
        return $[this.$L];
      }, P.locale = function(x, w) {
        if (!x) return this.$L;
        var L = this.clone(), j = N(x, w, !0);
        return j && (L.$L = j), L;
      }, P.clone = function() {
        return k.w(this.$d, this);
      }, P.toDate = function() {
        return new Date(this.valueOf());
      }, P.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, P.toISOString = function() {
        return this.$d.toISOString();
      }, P.toString = function() {
        return this.$d.toUTCString();
      }, C;
    }(), U = F.prototype;
    return Z.prototype = U, [["$ms", o], ["$s", d], ["$m", s], ["$H", c], ["$W", m], ["$M", p], ["$y", y], ["$D", v]].forEach(function(C) {
      U[C[1]] = function(P) {
        return this.$g(P, C[0], C[1]);
      };
    }), Z.extend = function(C, P) {
      return C.$i || (C(P, F, Z), C.$i = !0), Z;
    }, Z.locale = N, Z.isDayjs = i0, Z.unix = function(C) {
      return Z(1e3 * C);
    }, Z.en = $[z], Z.Ls = $, Z.p = {}, Z;
  });
})(Aa);
var o2 = Aa.exports;
const y0 = /* @__PURE__ */ L0(o2);
var za = { exports: {} };
(function(t, e) {
  (function(a, i) {
    t.exports = i();
  })(P0, function() {
    var a = "week", i = "year";
    return function(n, o, d) {
      var s = o.prototype;
      s.week = function(c) {
        if (c === void 0 && (c = null), c !== null) return this.add(7 * (c - this.week()), "day");
        var m = this.$locale().yearStart || 1;
        if (this.month() === 11 && this.date() > 25) {
          var f = d(this).startOf(i).add(1, i).date(m), p = d(this).endOf(a);
          if (f.isBefore(p)) return 1;
        }
        var b = d(this).startOf(i).date(m).startOf(a).subtract(1, "millisecond"), y = this.diff(b, a, !0);
        return y < 0 ? d(this).startOf("week").week() : Math.ceil(y);
      }, s.weeks = function(c) {
        return c === void 0 && (c = null), this.week(c);
      };
    };
  });
})(za);
var s2 = za.exports;
const l2 = /* @__PURE__ */ L0(s2);
var xa = { exports: {} };
(function(t, e) {
  (function(a, i) {
    t.exports = i();
  })(P0, function() {
    var a = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, i = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d\d/, o = /\d\d?/, d = /\d*[^-_:/,()\s\d]+/, s = {}, c = function(g) {
      return (g = +g) + (g > 68 ? 1900 : 2e3);
    }, m = function(g) {
      return function(_) {
        this[g] = +_;
      };
    }, f = [/[+-]\d\d:?(\d\d)?|Z/, function(g) {
      (this.zone || (this.zone = {})).offset = function(_) {
        if (!_ || _ === "Z") return 0;
        var M = _.match(/([+-]|\d\d)/g), S = 60 * M[1] + (+M[2] || 0);
        return S === 0 ? 0 : M[0] === "+" ? -S : S;
      }(g);
    }], p = function(g) {
      var _ = s[g];
      return _ && (_.indexOf ? _ : _.s.concat(_.f));
    }, b = function(g, _) {
      var M, S = s.meridiem;
      if (S) {
        for (var O = 1; O <= 24; O += 1) if (g.indexOf(S(O, 0, _)) > -1) {
          M = O > 12;
          break;
        }
      } else M = g === (_ ? "pm" : "PM");
      return M;
    }, y = { A: [d, function(g) {
      this.afternoon = b(g, !1);
    }], a: [d, function(g) {
      this.afternoon = b(g, !0);
    }], S: [/\d/, function(g) {
      this.milliseconds = 100 * +g;
    }], SS: [n, function(g) {
      this.milliseconds = 10 * +g;
    }], SSS: [/\d{3}/, function(g) {
      this.milliseconds = +g;
    }], s: [o, m("seconds")], ss: [o, m("seconds")], m: [o, m("minutes")], mm: [o, m("minutes")], H: [o, m("hours")], h: [o, m("hours")], HH: [o, m("hours")], hh: [o, m("hours")], D: [o, m("day")], DD: [n, m("day")], Do: [d, function(g) {
      var _ = s.ordinal, M = g.match(/\d+/);
      if (this.day = M[0], _) for (var S = 1; S <= 31; S += 1) _(S).replace(/\[|\]/g, "") === g && (this.day = S);
    }], M: [o, m("month")], MM: [n, m("month")], MMM: [d, function(g) {
      var _ = p("months"), M = (p("monthsShort") || _.map(function(S) {
        return S.slice(0, 3);
      })).indexOf(g) + 1;
      if (M < 1) throw new Error();
      this.month = M % 12 || M;
    }], MMMM: [d, function(g) {
      var _ = p("months").indexOf(g) + 1;
      if (_ < 1) throw new Error();
      this.month = _ % 12 || _;
    }], Y: [/[+-]?\d+/, m("year")], YY: [n, function(g) {
      this.year = c(g);
    }], YYYY: [/\d{4}/, m("year")], Z: f, ZZ: f };
    function v(g) {
      var _, M;
      _ = g, M = s && s.formats;
      for (var S = (g = _.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(N, Z, k) {
        var F = k && k.toUpperCase();
        return Z || M[k] || a[k] || M[F].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(U, C, P) {
          return C || P.slice(1);
        });
      })).match(i), O = S.length, I = 0; I < O; I += 1) {
        var z = S[I], $ = y[z], Q = $ && $[0], i0 = $ && $[1];
        S[I] = i0 ? { regex: Q, parser: i0 } : z.replace(/^\[|\]$/g, "");
      }
      return function(N) {
        for (var Z = {}, k = 0, F = 0; k < O; k += 1) {
          var U = S[k];
          if (typeof U == "string") F += U.length;
          else {
            var C = U.regex, P = U.parser, x = N.slice(F), w = C.exec(x)[0];
            P.call(Z, w), N = N.replace(w, "");
          }
        }
        return function(L) {
          var j = L.afternoon;
          if (j !== void 0) {
            var A = L.hours;
            j ? A < 12 && (L.hours += 12) : A === 12 && (L.hours = 0), delete L.afternoon;
          }
        }(Z), Z;
      };
    }
    return function(g, _, M) {
      M.p.customParseFormat = !0, g && g.parseTwoDigitYear && (c = g.parseTwoDigitYear);
      var S = _.prototype, O = S.parse;
      S.parse = function(I) {
        var z = I.date, $ = I.utc, Q = I.args;
        this.$u = $;
        var i0 = Q[1];
        if (typeof i0 == "string") {
          var N = Q[2] === !0, Z = Q[3] === !0, k = N || Z, F = Q[2];
          Z && (F = Q[2]), s = this.$locale(), !N && F && (s = M.Ls[F]), this.$d = function(x, w, L) {
            try {
              if (["x", "X"].indexOf(w) > -1) return new Date((w === "X" ? 1e3 : 1) * x);
              var j = v(w)(x), A = j.year, E = j.month, q = j.day, W = j.hours, Y = j.minutes, X = j.seconds, e0 = j.milliseconds, J = j.zone, t0 = /* @__PURE__ */ new Date(), D = q || (A || E ? 1 : t0.getDate()), K = A || t0.getFullYear(), n0 = 0;
              A && !E || (n0 = E > 0 ? E - 1 : t0.getMonth());
              var G = W || 0, m0 = Y || 0, A0 = X || 0, V0 = e0 || 0;
              return J ? new Date(Date.UTC(K, n0, D, G, m0, A0, V0 + 60 * J.offset * 1e3)) : L ? new Date(Date.UTC(K, n0, D, G, m0, A0, V0)) : new Date(K, n0, D, G, m0, A0, V0);
            } catch {
              return /* @__PURE__ */ new Date("");
            }
          }(z, i0, $), this.init(), F && F !== !0 && (this.$L = this.locale(F).$L), k && z != this.format(i0) && (this.$d = /* @__PURE__ */ new Date("")), s = {};
        } else if (i0 instanceof Array) for (var U = i0.length, C = 1; C <= U; C += 1) {
          Q[1] = i0[C - 1];
          var P = M.apply(this, Q);
          if (P.isValid()) {
            this.$d = P.$d, this.$L = P.$L, this.init();
            break;
          }
          C === U && (this.$d = /* @__PURE__ */ new Date(""));
        }
        else O.call(this, I);
      };
    };
  });
})(xa);
var d2 = xa.exports;
const c2 = /* @__PURE__ */ L0(d2);
var Pa = { exports: {} };
(function(t, e) {
  (function(a, i) {
    t.exports = i();
  })(P0, function() {
    var a = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" };
    return function(i, n, o) {
      var d = n.prototype, s = d.format;
      o.en.formats = a, d.format = function(c) {
        c === void 0 && (c = "YYYY-MM-DDTHH:mm:ssZ");
        var m = this.$locale().formats, f = function(p, b) {
          return p.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(y, v, g) {
            var _ = g && g.toUpperCase();
            return v || b[g] || a[g] || b[_].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(M, S, O) {
              return S || O.slice(1);
            });
          });
        }(c, m === void 0 ? {} : m);
        return s.call(this, f);
      };
    };
  });
})(Pa);
var u2 = Pa.exports;
const h2 = /* @__PURE__ */ L0(u2);
var Za = { exports: {} };
(function(t, e) {
  (function(a, i) {
    t.exports = i();
  })(P0, function() {
    return function(a, i, n) {
      i.prototype.isBetween = function(o, d, s, c) {
        var m = n(o), f = n(d), p = (c = c || "()")[0] === "(", b = c[1] === ")";
        return (p ? this.isAfter(m, s) : !this.isBefore(m, s)) && (b ? this.isBefore(f, s) : !this.isAfter(f, s)) || (p ? this.isBefore(m, s) : !this.isAfter(m, s)) && (b ? this.isAfter(f, s) : !this.isBefore(f, s));
      };
    };
  });
})(Za);
var m2 = Za.exports;
const f2 = /* @__PURE__ */ L0(m2);
var Ca = { exports: {} };
(function(t, e) {
  (function(a, i) {
    t.exports = i();
  })(P0, function() {
    return function(a, i) {
      var n = i.prototype, o = n.format;
      n.format = function(d) {
        var s = this, c = this.$locale();
        if (!this.isValid()) return o.bind(this)(d);
        var m = this.$utils(), f = (d || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(p) {
          switch (p) {
            case "Q":
              return Math.ceil((s.$M + 1) / 3);
            case "Do":
              return c.ordinal(s.$D);
            case "gggg":
              return s.weekYear();
            case "GGGG":
              return s.isoWeekYear();
            case "wo":
              return c.ordinal(s.week(), "W");
            case "w":
            case "ww":
              return m.s(s.week(), p === "w" ? 1 : 2, "0");
            case "W":
            case "WW":
              return m.s(s.isoWeek(), p === "W" ? 1 : 2, "0");
            case "k":
            case "kk":
              return m.s(String(s.$H === 0 ? 24 : s.$H), p === "k" ? 1 : 2, "0");
            case "X":
              return Math.floor(s.$d.getTime() / 1e3);
            case "x":
              return s.$d.getTime();
            case "z":
              return "[" + s.offsetName() + "]";
            case "zzz":
              return "[" + s.offsetName("long") + "]";
            default:
              return p;
          }
        });
        return o.bind(this)(f);
      };
    };
  });
})(Ca);
var p2 = Ca.exports;
const g2 = /* @__PURE__ */ L0(p2), Le = /* @__PURE__ */ new Set();
function v2(t, e = "warning") {
  if (process.env.NODE_ENV === "production")
    return;
  const a = Array.isArray(t) ? t.join(`
`) : t;
  Le.has(a) || (Le.add(a), e === "error" ? console.error(a) : console.warn(a));
}
y0.extend(h2);
y0.extend(l2);
y0.extend(f2);
y0.extend(g2);
const b2 = {
  // Year
  YY: "year",
  YYYY: {
    sectionType: "year",
    contentType: "digit",
    maxLength: 4
  },
  // Month
  M: {
    sectionType: "month",
    contentType: "digit",
    maxLength: 2
  },
  MM: "month",
  MMM: {
    sectionType: "month",
    contentType: "letter"
  },
  MMMM: {
    sectionType: "month",
    contentType: "letter"
  },
  // Day of the month
  D: {
    sectionType: "day",
    contentType: "digit",
    maxLength: 2
  },
  DD: "day",
  Do: {
    sectionType: "day",
    contentType: "digit-with-letter"
  },
  // Day of the week
  d: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 2
  },
  dd: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  ddd: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  dddd: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  // Meridiem
  A: "meridiem",
  a: "meridiem",
  // Hours
  H: {
    sectionType: "hours",
    contentType: "digit",
    maxLength: 2
  },
  HH: "hours",
  h: {
    sectionType: "hours",
    contentType: "digit",
    maxLength: 2
  },
  hh: "hours",
  // Minutes
  m: {
    sectionType: "minutes",
    contentType: "digit",
    maxLength: 2
  },
  mm: "minutes",
  // Seconds
  s: {
    sectionType: "seconds",
    contentType: "digit",
    maxLength: 2
  },
  ss: "seconds"
}, y2 = {
  year: "YYYY",
  month: "MMMM",
  monthShort: "MMM",
  dayOfMonth: "D",
  dayOfMonthFull: "Do",
  weekday: "dddd",
  weekdayShort: "dd",
  hours24h: "HH",
  hours12h: "hh",
  meridiem: "A",
  minutes: "mm",
  seconds: "ss",
  fullDate: "ll",
  keyboardDate: "L",
  shortDate: "MMM D",
  normalDate: "D MMMM",
  normalDateWithWeekday: "ddd, MMM D",
  fullTime: "LT",
  fullTime12h: "hh:mm A",
  fullTime24h: "HH:mm",
  keyboardDateTime: "L LT",
  keyboardDateTime12h: "L hh:mm A",
  keyboardDateTime24h: "L HH:mm"
}, B1 = ["Missing UTC plugin", "To be able to use UTC or timezones, you have to enable the `utc` plugin", "Find more information on https://mui.com/x/react-date-pickers/timezone/#day-js-and-utc"].join(`
`), ke = ["Missing timezone plugin", "To be able to use timezones, you have to enable both the `utc` and the `timezone` plugin", "Find more information on https://mui.com/x/react-date-pickers/timezone/#day-js-and-timezone"].join(`
`), _2 = (t, e) => e ? (...a) => t(...a).locale(e) : t;
class G3 {
  constructor({
    locale: e,
    formats: a
  } = {}) {
    this.isMUIAdapter = !0, this.isTimezoneCompatible = !0, this.lib = "dayjs", this.dayjs = void 0, this.locale = void 0, this.formats = void 0, this.escapedCharacters = {
      start: "[",
      end: "]"
    }, this.formatTokenMap = b2, this.setLocaleToValue = (i) => {
      const n = this.getCurrentLocaleCode();
      return n === i.locale() ? i : i.locale(n);
    }, this.hasUTCPlugin = () => typeof y0.utc < "u", this.hasTimezonePlugin = () => typeof y0.tz < "u", this.isSame = (i, n, o) => {
      const d = this.setTimezone(n, this.getTimezone(i));
      return i.format(o) === d.format(o);
    }, this.cleanTimezone = (i) => {
      switch (i) {
        case "default":
          return;
        case "system":
          return y0.tz.guess();
        default:
          return i;
      }
    }, this.createSystemDate = (i) => {
      if (this.hasUTCPlugin() && this.hasTimezonePlugin()) {
        const n = y0.tz.guess();
        return n !== "UTC" ? y0.tz(i, n) : y0(i);
      }
      return y0(i);
    }, this.createUTCDate = (i) => {
      if (!this.hasUTCPlugin())
        throw new Error(B1);
      return y0.utc(i);
    }, this.createTZDate = (i, n) => {
      if (!this.hasUTCPlugin())
        throw new Error(B1);
      if (!this.hasTimezonePlugin())
        throw new Error(ke);
      const o = i !== void 0 && !i.endsWith("Z");
      return y0(i).tz(this.cleanTimezone(n), o);
    }, this.getLocaleFormats = () => {
      const i = y0.Ls, n = this.locale || "en";
      let o = i[n];
      return o === void 0 && (process.env.NODE_ENV !== "production" && v2(["MUI X: Your locale has not been found.", "Either the locale key is not a supported one. Locales supported by dayjs are available here: https://github.com/iamkun/dayjs/tree/dev/src/locale.", "Or you forget to import the locale from 'dayjs/locale/{localeUsed}'", "fallback on English locale."]), o = i.en), o.formats;
    }, this.adjustOffset = (i) => {
      if (!this.hasTimezonePlugin())
        return i;
      const n = this.getTimezone(i);
      if (n !== "UTC") {
        const o = i.tz(this.cleanTimezone(n), !0);
        if (o.$offset === (i.$offset ?? 0))
          return i;
        i.$offset = o.$offset;
      }
      return i;
    }, this.date = (i, n = "default") => {
      if (i === null)
        return null;
      let o;
      return n === "UTC" ? o = this.createUTCDate(i) : n === "system" || n === "default" && !this.hasTimezonePlugin() ? o = this.createSystemDate(i) : o = this.createTZDate(i, n), this.locale === void 0 ? o : o.locale(this.locale);
    }, this.getInvalidDate = () => y0(/* @__PURE__ */ new Date("Invalid date")), this.getTimezone = (i) => {
      var n;
      if (this.hasTimezonePlugin()) {
        const o = (n = i.$x) == null ? void 0 : n.$timezone;
        if (o)
          return o;
      }
      return this.hasUTCPlugin() && i.isUTC() ? "UTC" : "system";
    }, this.setTimezone = (i, n) => {
      if (this.getTimezone(i) === n)
        return i;
      if (n === "UTC") {
        if (!this.hasUTCPlugin())
          throw new Error(B1);
        return i.utc();
      }
      if (n === "system")
        return i.local();
      if (!this.hasTimezonePlugin()) {
        if (n === "default")
          return i;
        throw new Error(ke);
      }
      return y0.tz(i, this.cleanTimezone(n));
    }, this.toJsDate = (i) => i.toDate(), this.parse = (i, n) => i === "" ? null : this.dayjs(i, n, this.locale, !0), this.getCurrentLocaleCode = () => this.locale || "en", this.is12HourCycleInCurrentLocale = () => /A|a/.test(this.getLocaleFormats().LT || ""), this.expandFormat = (i) => {
      const n = this.getLocaleFormats(), o = (d) => d.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (s, c, m) => c || m.slice(1));
      return i.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (d, s, c) => {
        const m = c && c.toUpperCase();
        return s || n[c] || o(n[m]);
      });
    }, this.isValid = (i) => i == null ? !1 : i.isValid(), this.format = (i, n) => this.formatByString(i, this.formats[n]), this.formatByString = (i, n) => this.dayjs(i).format(n), this.formatNumber = (i) => i, this.isEqual = (i, n) => i === null && n === null ? !0 : i === null || n === null ? !1 : i.toDate().getTime() === n.toDate().getTime(), this.isSameYear = (i, n) => this.isSame(i, n, "YYYY"), this.isSameMonth = (i, n) => this.isSame(i, n, "YYYY-MM"), this.isSameDay = (i, n) => this.isSame(i, n, "YYYY-MM-DD"), this.isSameHour = (i, n) => i.isSame(n, "hour"), this.isAfter = (i, n) => i > n, this.isAfterYear = (i, n) => this.hasUTCPlugin() ? !this.isSameYear(i, n) && i.utc() > n.utc() : i.isAfter(n, "year"), this.isAfterDay = (i, n) => this.hasUTCPlugin() ? !this.isSameDay(i, n) && i.utc() > n.utc() : i.isAfter(n, "day"), this.isBefore = (i, n) => i < n, this.isBeforeYear = (i, n) => this.hasUTCPlugin() ? !this.isSameYear(i, n) && i.utc() < n.utc() : i.isBefore(n, "year"), this.isBeforeDay = (i, n) => this.hasUTCPlugin() ? !this.isSameDay(i, n) && i.utc() < n.utc() : i.isBefore(n, "day"), this.isWithinRange = (i, [n, o]) => i >= n && i <= o, this.startOfYear = (i) => this.adjustOffset(i.startOf("year")), this.startOfMonth = (i) => this.adjustOffset(i.startOf("month")), this.startOfWeek = (i) => this.adjustOffset(i.startOf("week")), this.startOfDay = (i) => this.adjustOffset(i.startOf("day")), this.endOfYear = (i) => this.adjustOffset(i.endOf("year")), this.endOfMonth = (i) => this.adjustOffset(i.endOf("month")), this.endOfWeek = (i) => this.adjustOffset(i.endOf("week")), this.endOfDay = (i) => this.adjustOffset(i.endOf("day")), this.addYears = (i, n) => this.adjustOffset(n < 0 ? i.subtract(Math.abs(n), "year") : i.add(n, "year")), this.addMonths = (i, n) => this.adjustOffset(n < 0 ? i.subtract(Math.abs(n), "month") : i.add(n, "month")), this.addWeeks = (i, n) => this.adjustOffset(n < 0 ? i.subtract(Math.abs(n), "week") : i.add(n, "week")), this.addDays = (i, n) => this.adjustOffset(n < 0 ? i.subtract(Math.abs(n), "day") : i.add(n, "day")), this.addHours = (i, n) => this.adjustOffset(n < 0 ? i.subtract(Math.abs(n), "hour") : i.add(n, "hour")), this.addMinutes = (i, n) => this.adjustOffset(n < 0 ? i.subtract(Math.abs(n), "minute") : i.add(n, "minute")), this.addSeconds = (i, n) => this.adjustOffset(n < 0 ? i.subtract(Math.abs(n), "second") : i.add(n, "second")), this.getYear = (i) => i.year(), this.getMonth = (i) => i.month(), this.getDate = (i) => i.date(), this.getHours = (i) => i.hour(), this.getMinutes = (i) => i.minute(), this.getSeconds = (i) => i.second(), this.getMilliseconds = (i) => i.millisecond(), this.setYear = (i, n) => this.adjustOffset(i.set("year", n)), this.setMonth = (i, n) => this.adjustOffset(i.set("month", n)), this.setDate = (i, n) => this.adjustOffset(i.set("date", n)), this.setHours = (i, n) => this.adjustOffset(i.set("hour", n)), this.setMinutes = (i, n) => this.adjustOffset(i.set("minute", n)), this.setSeconds = (i, n) => this.adjustOffset(i.set("second", n)), this.setMilliseconds = (i, n) => this.adjustOffset(i.set("millisecond", n)), this.getDaysInMonth = (i) => i.daysInMonth(), this.getWeekArray = (i) => {
      const n = this.setLocaleToValue(i), o = this.startOfWeek(this.startOfMonth(n)), d = this.endOfWeek(this.endOfMonth(n));
      let s = 0, c = o;
      const m = [];
      for (; c < d; ) {
        const f = Math.floor(s / 7);
        m[f] = m[f] || [], m[f].push(c), c = this.addDays(c, 1), s += 1;
      }
      return m;
    }, this.getWeekNumber = (i) => i.week(), this.getYearRange = ([i, n]) => {
      const o = this.startOfYear(i), d = this.endOfYear(n), s = [];
      let c = o;
      for (; this.isBefore(c, d); )
        s.push(c), c = this.addYears(c, 1);
      return s;
    }, this.dayjs = _2(y0, e), this.locale = e, this.formats = g0({}, y2, a), y0.extend(c2);
  }
  getDayOfWeek(e) {
    return e.day() + 1;
  }
}
const I3 = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_35_Acondicionamiento_fisico",
    "data-name": "35_Acondicionamiento_fisico",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ r(
        "path",
        {
          id: "_35_Acondicionamiento_fisico-2",
          "data-name": "35_Acondicionamiento_fisico",
          d: "M34.4,61.142A26.855,26.855,0,1,1,61.257,34.287,26.865,26.865,0,0,1,34.4,61.142Zm0-52.1A25.244,25.244,0,1,0,59.646,34.287,25.214,25.214,0,0,0,34.4,9.043Zm4.45,21.037a1.135,1.135,0,0,1,.212-.712c.425-.575.819-1.114,1.2-1.65C42,25.284,44,22.444,45.836,19.541a2.781,2.781,0,0,0,.521-2.067A2.452,2.452,0,0,0,44.52,15.5a2.346,2.346,0,0,0-2.574.886c-.214.27-.4.564-.588.85l-.116.179c-.344.529-.687,1.069-1.019,1.592-.7,1.1-1.421,2.238-2.185,3.319A4.41,4.41,0,0,1,34.4,24.246l-.131,0a4.621,4.621,0,0,1-3.778-2.213c-1.319-2.116-2.5-3.948-3.613-5.6a2.356,2.356,0,0,0-3.286-.661,2.484,2.484,0,0,0-.921,3.237,10.809,10.809,0,0,0,.68,1.163c1.779,2.658,3.743,5.468,6.179,8.846a2.112,2.112,0,0,1,.426,1.346c-.013.794-.006,1.6,0,2.38,0,.638.009,1.3,0,1.946,0,.174,0,.347,0,.52a8.613,8.613,0,0,1-.165,2.139c-.445,1.78-.892,3.592-1.322,5.345q-.351,1.428-.7,2.855c-.162.656-.33,1.312-.5,1.967-.358,1.408-.728,2.864-1.045,4.306a2.393,2.393,0,0,0,.474,2.058,2.586,2.586,0,0,0,2.031.943h.017a2.525,2.525,0,0,0,2.534-2.187l.075-.337c.359-1.6.729-3.26,1.154-4.877.331-1.259.66-2.542.979-3.782q.367-1.429.737-2.857a1.539,1.539,0,0,0,.035-.231.807.807,0,0,1,.162-.483c.006.015.014.028.02.041a.823.823,0,0,1,.061.148q.6,2.451,1.207,4.9.78,3.171,1.562,6.339c.046.187.085.379.122.564a6.038,6.038,0,0,0,.356,1.271,2.459,2.459,0,0,0,2.268,1.548,2.752,2.752,0,0,0,.831-.133,2.561,2.561,0,0,0,1.727-2.916c-.072-.381-.17-.765-.264-1.137-.031-.121-.063-.243-.092-.364q-.388-1.558-.781-3.112c-.64-2.55-1.3-5.186-1.935-7.785-.069-.283-.151-.566-.231-.841a8.131,8.131,0,0,1-.411-2.1c-.023-1.416-.018-2.857-.014-4.251Q38.855,31.162,38.852,30.08ZM27.8,52.107a17.147,17.147,0,0,1,.465-2.094c.067-.252.134-.509.2-.765,1.028-4.118,1.972-7.87,2.887-11.469a7.47,7.47,0,0,0,.251-1.926c-.013-1.867-.023-3.87.006-5.868a2.463,2.463,0,0,0-.509-1.547q-.738-1.031-1.479-2.059c-1.7-2.352-3.449-4.787-5.058-7.258-.032-.049-.066-.1-.1-.149-.085-.128-.172-.259-.248-.393a.969.969,0,0,1,.321-1.46c.448-.259.895-.087,1.256.479l.716,1.119c.865,1.348,1.757,2.742,2.622,4.122a6.053,6.053,0,0,0,7.63,2.515A6.235,6.235,0,0,0,39.7,22.871c.749-1.217,1.534-2.441,2.291-3.625q.453-.706.9-1.411l.06-.093a3.3,3.3,0,0,1,.334-.468.814.814,0,0,1,1.026-.168.928.928,0,0,1,.478,1.017,2.7,2.7,0,0,1-.386.784c-2.531,3.706-4.52,6.525-6.448,9.138a3.333,3.333,0,0,0-.777,2.312,30.2,30.2,0,0,1,.008,3.326,19.078,19.078,0,0,0,.72,5.9c.737,2.781,1.438,5.619,2.118,8.366q.408,1.648.819,3.3a4.163,4.163,0,0,1,.16.965.915.915,0,0,1-.713,1.023,1.025,1.025,0,0,1-1.1-.632,11.314,11.314,0,0,1-.387-1.328q-1.165-4.713-2.325-9.426l-1.053-4.277c-.028-.115-.055-.232-.079-.348-.053-.237-.107-.481-.184-.718a.8.8,0,0,0-.757-.639h-.023a.76.76,0,0,0-.719.589,7.814,7.814,0,0,0-.237.868l-.068.288q-.325,1.308-.652,2.617c-.54,2.161-1.1,4.4-1.618,6.6-.273,1.161-.571,2.337-.859,3.473q-.226.889-.449,1.781c-.012.047-.023.095-.034.143a1.363,1.363,0,0,1-.358.771.965.965,0,0,1-1.1.173C27.913,53,27.766,52.678,27.8,52.107ZM34.43,21.662c.043,0,.086,0,.13,0a3.806,3.806,0,0,0,2.621-1.127,3.881,3.881,0,0,0,1.219-2.8,4.182,4.182,0,0,0-1.324-3.057,3.663,3.663,0,0,0-2.451-.991c-.074,0-.147,0-.221.008a3.724,3.724,0,0,0-2.74,1.061,4.053,4.053,0,0,0-1.254,2.894A3.825,3.825,0,0,0,34.43,21.662Zm-2.59-4.179a2.409,2.409,0,0,1,2.5-2.356h.024A2.475,2.475,0,0,1,36.937,17.7a2.5,2.5,0,0,1-2.529,2.511H34.39A2.567,2.567,0,0,1,31.84,17.483Z",
          transform: "translate(-4.547 -4.432)",
          fill: "#ee2b7b"
        }
      )
    ]
  }
), F3 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_24_Plazo_6_meses",
    "data-name": "24_Plazo_6_meses",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h("g", { id: "_24_Plazo_6_meses-2", "data-name": "24_Plazo_6_meses", transform: "translate(-2.3 -2.5)", children: [
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40912",
            "data-name": "Trazado 40912",
            d: "M52,11.4H47.2V9.3a.736.736,0,0,0-.8-.8.789.789,0,0,0-.8.8v2.1H36.7V9.3a.736.736,0,0,0-.8-.8.789.789,0,0,0-.8.8v2.1H26.3V9.3a.736.736,0,0,0-.8-.8.789.789,0,0,0-.8.8v2.1H15.8V9.3a.8.8,0,1,0-1.6,0v2.1H9.5a4.225,4.225,0,0,0-4.2,4.2V49.1a4.225,4.225,0,0,0,4.2,4.2h28a.713.713,0,0,0,.7-.8.789.789,0,0,0-.8-.8H9.4a2.582,2.582,0,0,1-2.6-2.6V15.6A2.582,2.582,0,0,1,9.4,13h4.8v2.2a.789.789,0,0,0,.8.8c.4,0,.7-.4.8-.8V13h8.9v2.2a.789.789,0,0,0,.8.8c.4,0,.7-.4.8-.8V13h8.8v2.2a.8.8,0,1,0,1.6,0V13h8.9v2.2a.8.8,0,1,0,1.6,0V13H52a2.582,2.582,0,0,1,2.6,2.6V33.9a.8.8,0,1,0,1.6,0V15.6A4.225,4.225,0,0,0,52,11.4Z",
            fill: "#ee2b7b"
          }
        ),
        /* @__PURE__ */ r("g", { id: "Grupo_16635", "data-name": "Grupo 16635", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40913",
            "data-name": "Trazado 40913",
            d: "M49.4,56.5A10.3,10.3,0,1,1,59.7,46.2,10.285,10.285,0,0,1,49.4,56.5Zm0-19.1a8.8,8.8,0,1,0,8.8,8.8A8.813,8.813,0,0,0,49.4,37.4Z",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ h("g", { id: "Grupo_16640", "data-name": "Grupo 16640", children: [
          /* @__PURE__ */ r("g", { id: "Grupo_16636", "data-name": "Grupo 16636", children: /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_40914",
              "data-name": "Trazado 40914",
              d: "M13.7,20.6h4.2a.43.43,0,0,1,.4.4v4.2a.43.43,0,0,1-.4.4H13.7a.43.43,0,0,1-.4-.4V21C13.4,20.8,13.5,20.6,13.7,20.6Z",
              fill: "#ee2b7b"
            }
          ) }),
          /* @__PURE__ */ r("g", { id: "Grupo_16637", "data-name": "Grupo 16637", children: /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_40915",
              "data-name": "Trazado 40915",
              d: "M23.8,20.6H28a.43.43,0,0,1,.4.4v4.2a.43.43,0,0,1-.4.4H23.8a.43.43,0,0,1-.4-.4V21A.43.43,0,0,1,23.8,20.6Z",
              fill: "#ee2b7b"
            }
          ) }),
          /* @__PURE__ */ r("g", { id: "Grupo_16638", "data-name": "Grupo 16638", children: /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_40916",
              "data-name": "Trazado 40916",
              d: "M33.8,20.6H38a.43.43,0,0,1,.4.4v4.2a.43.43,0,0,1-.4.4H33.8a.43.43,0,0,1-.4-.4V21C33.5,20.8,33.6,20.6,33.8,20.6Z",
              fill: "#ee2b7b"
            }
          ) }),
          /* @__PURE__ */ r("g", { id: "Grupo_16639", "data-name": "Grupo 16639", children: /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_40917",
              "data-name": "Trazado 40917",
              d: "M43.9,20.6h4.2a.43.43,0,0,1,.4.4v4.2a.43.43,0,0,1-.4.4H43.9a.43.43,0,0,1-.4-.4V21A.43.43,0,0,1,43.9,20.6Z",
              fill: "#ee2b7b"
            }
          ) })
        ] }),
        /* @__PURE__ */ h("g", { id: "Grupo_16644", "data-name": "Grupo 16644", children: [
          /* @__PURE__ */ r("g", { id: "Grupo_16641", "data-name": "Grupo 16641", children: /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_40918",
              "data-name": "Trazado 40918",
              d: "M13.7,30.7h4.2a.43.43,0,0,1,.4.4v4.2a.43.43,0,0,1-.4.4H13.7a.43.43,0,0,1-.4-.4V31.1C13.4,30.9,13.5,30.7,13.7,30.7Z",
              fill: "#ee2b7b"
            }
          ) }),
          /* @__PURE__ */ r("g", { id: "Grupo_16642", "data-name": "Grupo 16642", children: /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_40919",
              "data-name": "Trazado 40919",
              d: "M23.8,30.7H28a.43.43,0,0,1,.4.4v4.2a.43.43,0,0,1-.4.4H23.8a.43.43,0,0,1-.4-.4V31.1A.43.43,0,0,1,23.8,30.7Z",
              fill: "#ee2b7b"
            }
          ) }),
          /* @__PURE__ */ r("g", { id: "Grupo_16643", "data-name": "Grupo 16643", children: /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_40920",
              "data-name": "Trazado 40920",
              d: "M33.8,30.7H38a.43.43,0,0,1,.4.4v4.2a.43.43,0,0,1-.4.4H33.8a.43.43,0,0,1-.4-.4V31.1C33.5,30.9,33.6,30.7,33.8,30.7Z",
              fill: "#ee2b7b"
            }
          ) })
        ] }),
        /* @__PURE__ */ h("g", { id: "Grupo_16647", "data-name": "Grupo 16647", children: [
          /* @__PURE__ */ r("g", { id: "Grupo_16645", "data-name": "Grupo 16645", children: /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_40921",
              "data-name": "Trazado 40921",
              d: "M13.7,40.8h4.2a.43.43,0,0,1,.4.4v4.2a.43.43,0,0,1-.4.4H13.7a.43.43,0,0,1-.4-.4V41.2C13.4,41,13.5,40.8,13.7,40.8Z",
              fill: "#ee2b7b"
            }
          ) }),
          /* @__PURE__ */ r("g", { id: "Grupo_16646", "data-name": "Grupo 16646", children: /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_40922",
              "data-name": "Trazado 40922",
              d: "M23.8,40.8H28a.43.43,0,0,1,.4.4v4.2a.43.43,0,0,1-.4.4H23.8a.43.43,0,0,1-.4-.4V41.2A.43.43,0,0,1,23.8,40.8Z",
              fill: "#ee2b7b"
            }
          ) })
        ] }),
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40923",
            "data-name": "Trazado 40923",
            d: "M46.757,48.805A2.725,2.725,0,0,0,48.7,51.053a.206.206,0,0,1,.167.235c-.008.165-.005.33,0,.495a.623.623,0,0,0,1.245.005,2.81,2.81,0,0,0,0-.4c-.021-.2.049-.3.253-.365A2.728,2.728,0,0,0,52.23,48.05a2.763,2.763,0,0,0-2.7-2.4,1.5,1.5,0,0,1-.351-2.969,1.507,1.507,0,0,1,1.619.736,1.957,1.957,0,0,1,.205.8.624.624,0,0,0,1.241-.023,2.047,2.047,0,0,0-.02-.436A2.718,2.718,0,0,0,50.289,41.5a.214.214,0,0,1-.175-.248c.009-.165.006-.33,0-.495a.611.611,0,0,0-.621-.591.6.6,0,0,0-.622.588,3.469,3.469,0,0,0,0,.456c.015.178-.056.252-.226.306a2.771,2.771,0,0,0-1.911,2.842,2.805,2.805,0,0,0,2.124,2.473c.281.069.567.05.849.1a1.432,1.432,0,0,1,1.2,1.008,1.493,1.493,0,0,1-1.9,1.883A1.478,1.478,0,0,1,47.988,48.4a.652.652,0,0,0-.178-.429.624.624,0,0,0-.684-.147.646.646,0,0,0-.4.674A2.354,2.354,0,0,0,46.757,48.805Z",
            fill: "#ee2b7b"
          }
        )
      ] })
    ]
  }
), D3 = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_37_Rehabilitacion_fisica",
    "data-name": "37_Rehabilitacion_fisica",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_37_Rehabilitacion_fisica-2",
          "data-name": "37_Rehabilitacion_fisica",
          transform: "translate(10.309 1.469)",
          children: [
            /* @__PURE__ */ r("g", { id: "Grupo_16895", "data-name": "Grupo 16895", transform: "translate(0.692 15.504)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41297",
                "data-name": "Trazado 41297",
                d: "M16.924,57.37a4.554,4.554,0,0,1-2-.5l-.5-.2a4.613,4.613,0,0,1-2.1-5.811l3.507-7.815h-5.01C3.8,43.041.692,38.532.692,34.024.692,31.118,5.4,21.7,6.8,18.894a5.564,5.564,0,0,1,5.41-2.905l23.245,1.9A4.648,4.648,0,0,1,39.667,22.4a4.276,4.276,0,0,1-4.308,4.308l-16.631-.2-3.607,5.11,9.418,2.505a6.005,6.005,0,0,1,3.808,3.306,5.879,5.879,0,0,1-.3,5.01L20.933,54.966A4.723,4.723,0,0,1,16.924,57.37Zm-5.11-39.677a4.232,4.232,0,0,0-3.406,2C5.4,25.508,2.5,32.221,2.5,34.024c0,3.507,2.2,7.314,8.417,7.314h6.313a.671.671,0,0,1,.7.4.785.785,0,0,1,.1.8l-4.108,9.018a2.679,2.679,0,0,0,1.3,3.507l.5.2a3.015,3.015,0,0,0,3.708-1.1l7.114-12.524a3.97,3.97,0,0,0-2.505-5.811L13.418,33.023a1.025,1.025,0,0,1-.6-.5.757.757,0,0,1,.1-.8l4.609-6.513a1.275,1.275,0,0,1,.7-.4l17.264.2A2.653,2.653,0,0,0,38.1,22.4,2.911,2.911,0,0,0,35.491,19.6l-23.476-1.9Z",
                transform: "translate(-0.692 -15.945)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16896", "data-name": "Grupo 16896", transform: "translate(10.026 0.531)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41298",
                "data-name": "Trazado 41298",
                d: "M16.911,13.751a6.61,6.61,0,1,1,6.61-6.61A6.635,6.635,0,0,1,16.911,13.751Zm0-11.621a5.01,5.01,0,1,0,5.01,5.01A5.049,5.049,0,0,0,16.911,2.13Z",
                transform: "translate(-10.301 -0.531)",
                fill: "#ee2b7b"
              }
            ) })
          ]
        }
      )
    ]
  }
), R3 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_23_icono_acompañamiento",
    "data-name": "23_icono_acompañamiento",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h("g", { id: "_23_icono_acompañamiento-2", "data-name": "23_icono_acompañamiento", children: [
        /* @__PURE__ */ r("g", { id: "Grupo_16544", "data-name": "Grupo 16544", transform: "translate(7.196 8)", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40792",
            "data-name": "Trazado 40792",
            d: "M13.445,20.689a6.345,6.345,0,1,1,6.345-6.345A6.376,6.376,0,0,1,13.445,20.689Zm0-10.847a4.5,4.5,0,1,0,4.5,4.5A4.543,4.543,0,0,0,13.445,9.842Z",
            transform: "translate(-7.1 -8)",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16545", "data-name": "Grupo 16545", transform: "translate(41.886 8)", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40793",
            "data-name": "Trazado 40793",
            d: "M47.345,20.689a6.345,6.345,0,1,1,6.345-6.345A6.376,6.376,0,0,1,47.345,20.689Zm0-10.847a4.5,4.5,0,1,0,4.5,4.5A4.543,4.543,0,0,0,47.345,9.842Z",
            transform: "translate(-41 -8)",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40794",
            "data-name": "Trazado 40794",
            d: "M49.868,20.7H46.593a9.495,9.495,0,0,0-7.265,3.275L30.936,33.7l-8.391-9.721A9.854,9.854,0,0,0,15.28,20.7H7.912C6.07,20.7,3,21.519,3,27.045V50.581a.921.921,0,0,0,1.842,0V27.045c0-4.5,2.251-4.5,2.968-4.5h7.47A7.487,7.487,0,0,1,21.113,25.2l9.005,10.335c.1.1.1.2.2.307h.1l2.251,2.661a2.32,2.32,0,1,1-3.479,3.07l-8.391-9.721a.926.926,0,0,0-1.023-.307.983.983,0,0,0-.614.921V50.683a.917.917,0,0,0,.921.921.945.945,0,0,0,.921-1.023V35.026L27.764,42.8a4.418,4.418,0,0,0,5.935.409l.307-.307.1-.1,6.754-7.777V50.683a.917.917,0,0,0,.921.921.945.945,0,0,0,.921-1.023V32.468a.9.9,0,0,0-.614-.921,1.038,1.038,0,0,0-1.023.307l-6.14,7.061a4.924,4.924,0,0,0-.819-1.637l-1.944-2.149,8.6-9.926a7.487,7.487,0,0,1,5.833-2.661h3.275a5.459,5.459,0,0,1,5.424,5.424V50.581a.917.917,0,0,0,.921.921,1.1,1.1,0,0,0,1.023-.819V28.068A7.337,7.337,0,0,0,49.868,20.7Z",
            transform: "translate(0 0.296)",
            fill: "#ee2b7b"
          }
        )
      ] })
    ]
  }
), B3 = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_02_icono_acompañamiento",
    "data-name": "02_icono_acompañamiento",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ r(
        "path",
        {
          id: "_02_icono_acompañamiento-2",
          "data-name": "02_icono_acompañamiento",
          d: "M58.216,16.969a.739.739,0,0,0-1.068-.178L49.4,22.221,41.568,11.627l13.8-9.615A.739.739,0,0,0,55.545.944.739.739,0,0,0,54.477.766L40.411,10.559,32.131,9.312a4.347,4.347,0,0,0-2.76.445l-3.2,1.692L18.6,10.826,4.8,1.211a.739.739,0,0,0-1.068.178A.739.739,0,0,0,3.91,2.457l13.176,9.081L10.5,22.577,1.6,16.613a.739.739,0,0,0-1.068.178A.739.739,0,0,0,.7,17.859l13.087,8.547a2.87,2.87,0,0,0-.534,1.87,2.7,2.7,0,0,0,1.068,1.87,2.35,2.35,0,0,0,1.692.623.8.8,0,0,0,.445-.089v.178a2.7,2.7,0,0,0,1.068,1.87,2.35,2.35,0,0,0,1.692.623.8.8,0,0,0,.445-.089v.089a2.7,2.7,0,0,0,1.068,1.87,2.35,2.35,0,0,0,1.692.623,1.515,1.515,0,0,0,.623-.089,2.537,2.537,0,0,0,1.068,1.692,2.35,2.35,0,0,0,1.692.623,3.188,3.188,0,0,0,2.226-.979l1.157-1.513c.089-.089.089-.178.178-.267l.8.8a2.647,2.647,0,0,0,1.781.712,2.523,2.523,0,0,0,2.226-1.157,3.374,3.374,0,0,0,.534-1.157,1.257,1.257,0,0,0,.8.089,2.906,2.906,0,0,0,2.226-1.157,2.759,2.759,0,0,0,.534-1.157,3.039,3.039,0,0,0,3.472-.8,2.237,2.237,0,0,0,.534-1.246c.979.534,2.137.089,3.116-.979a2.887,2.887,0,0,0,.356-3.027l12.286-8.19A.739.739,0,0,0,58.216,16.969ZM29.995,11.182a2.745,2.745,0,0,1,1.87-.356l8.19,1.246,8.012,10.861L44.684,25.07,35.96,18.393h0a.741.741,0,0,0,.534-.89.789.789,0,0,0-.89-.534c-2.226.534-6.677-.623-6.677-.623a.789.789,0,0,0-.89.534l-.178.623c-.445,1.513-1.513,3.917-3.472,3.472-1.157-.267-1.424-.356-1.246-1.87l.445-3.472a3.2,3.2,0,0,1,1.513-1.87ZM15.305,28.987a1.236,1.236,0,0,1-.445-.89,1.274,1.274,0,0,1,.267-.979l.712-.89a1.315,1.315,0,0,1,1.781-.178,1.236,1.236,0,0,1,.445.89,1.274,1.274,0,0,1-.267.979l-.712.89A1.27,1.27,0,0,1,15.305,28.987Zm3.116,2.582a1.236,1.236,0,0,1-.445-.89,1.274,1.274,0,0,1,.267-.979l1.246-1.513a1.43,1.43,0,0,1,.979-.445A1.2,1.2,0,0,1,21.715,28.9a1.274,1.274,0,0,1-.267.979L20.2,31.391A1.27,1.27,0,0,1,18.421,31.569Zm3.2,2.582a1.236,1.236,0,0,1-.445-.89,1.274,1.274,0,0,1,.267-.979l.623-.89.623-.623c.089-.089.089-.178.178-.267a1.223,1.223,0,0,1,1.6.089,1.236,1.236,0,0,1,.445.89.782.782,0,0,1-.089.623h0l-1.157,1.424c-.089.178-.267.267-.356.445A1.165,1.165,0,0,1,21.626,34.151Zm6.41.534L26.879,36.11a1.27,1.27,0,0,1-1.781.178,1.236,1.236,0,0,1-.445-.89c-.089-.267.089-.623.178-.89L25.9,33.261c.089-.089.089-.178.178-.267a1.315,1.315,0,0,1,1.781-.178,1.236,1.236,0,0,1,.445.89A1.274,1.274,0,0,1,28.036,34.685Zm16.2-6.321a1.236,1.236,0,0,1-.89.445,1,1,0,0,1-.979-.267l-.712-.623-.267-.267-4.718-4.1a.727.727,0,0,0-1.068.089.751.751,0,0,0-.178.623.635.635,0,0,0,.267.534L40.5,28.987a1.34,1.34,0,0,1,.089,1.6,1.236,1.236,0,0,1-.89.445,1,1,0,0,1-.979-.267l-1.335-1.157h0L34.09,26.762a.727.727,0,0,0-1.068.089.81.81,0,0,0,.089,1.068L36.4,30.768a1.27,1.27,0,0,1,.178,1.781,1.236,1.236,0,0,1-.89.445,1,1,0,0,1-.979-.267l-.445-.356c-.178-.178-.267-.356-.445-.534l-2.315-2.048a.727.727,0,0,0-1.068.089.848.848,0,0,0-.178.623.808.808,0,0,0,.267.623L33.2,33.35a1.294,1.294,0,0,1-1.068,1.87,1.432,1.432,0,0,1-.979-.267l-1.246-1.157h-.089v-.267a2.7,2.7,0,0,0-1.068-1.87,3.454,3.454,0,0,0-2.226-.534,2.525,2.525,0,0,0-1.068-1.781,3.1,3.1,0,0,0-2.137-.534V28.72a2.7,2.7,0,0,0-1.068-1.87,2.811,2.811,0,0,0-2.76-.356,3.037,3.037,0,0,0-.979-1.6,2.865,2.865,0,0,0-3.828.356l-3.027-1.692,6.766-11.217,5.431.445a5,5,0,0,0-1.692,2.493l-.445,3.561c-.267,2.226.356,3.116,2.4,3.561a1.736,1.736,0,0,0,.712.089c1.335,0,3.294-.623,4.362-4.54a33.834,33.834,0,0,0,4.362.623h0s7.389,5.787,10.594,8.012A1.474,1.474,0,0,1,44.239,28.364Z",
          transform: "translate(0.628 10.39)",
          fill: "#ee2b7b"
        }
      )
    ]
  }
), $3 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_39_sueño_reparador",
    "data-name": "39_sueño_reparador",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_39_sueño_reparador-2",
          "data-name": "39_sueño_reparador",
          transform: "translate(2.324 7.345)",
          children: [
            /* @__PURE__ */ h("g", { id: "Grupo_16901", "data-name": "Grupo 16901", transform: "translate(0.676 10.657)", children: [
              /* @__PURE__ */ r("g", { id: "Grupo_16897", "data-name": "Grupo 16897", transform: "translate(9.658 12.977)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41299",
                  "data-name": "Trazado 41299",
                  d: "M23.547,43.33H21.179a.675.675,0,0,1-.568-.284l-9.472-9.472a.871.871,0,0,1-.095-1.137l5.968-7.1a.873.873,0,1,1,1.326,1.137l-5.4,6.536,8.715,8.715h1.8l13.83-9.472a.724.724,0,0,1,.474-.189H53.574V29.311a2.749,2.749,0,0,0-2.747-2.747H24.684a.853.853,0,0,1,0-1.705H50.827a4.447,4.447,0,0,1,4.452,4.452v3.6a.849.849,0,0,1-.853.853H38.04L24.021,43.141C23.831,43.235,23.736,43.33,23.547,43.33Z",
                  transform: "translate(-10.872 -24.859)",
                  fill: "#ee2b7b"
                }
              ) }),
              /* @__PURE__ */ r("g", { id: "Grupo_16898", "data-name": "Grupo 16898", transform: "translate(5.946 2.268)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41300",
                  "data-name": "Trazado 41300",
                  d: "M11.4,33.066h-3.6a.849.849,0,0,1-.853-.853V18A4.447,4.447,0,0,1,11.4,13.553H15a.675.675,0,0,1,.568.284l5.683,5.683h6.725a.774.774,0,0,1,.853.758c0,.095.284,2.747-1.231,4.357a4.206,4.206,0,0,1-3.221,1.326h-7.1a.675.675,0,0,1-.568-.284l-4.736-4.736A.871.871,0,1,1,13.2,19.71l4.547,4.547h6.725a2.35,2.35,0,0,0,1.894-.758,3.641,3.641,0,0,0,.758-2.273H20.972a.675.675,0,0,1-.568-.284L14.72,15.258H11.5A2.749,2.749,0,0,0,8.753,18V31.361H11.5a.849.849,0,0,1,.853.853A1.007,1.007,0,0,1,11.4,33.066Z",
                  transform: "translate(-6.953 -13.553)",
                  fill: "#ee2b7b"
                }
              ) }),
              /* @__PURE__ */ r("g", { id: "Grupo_16899", "data-name": "Grupo 16899", transform: "translate(25.525 20.271)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41301",
                  "data-name": "Trazado 41301",
                  d: "M55.311,46.1h-3.6a.844.844,0,0,1-.758-.474l-2.179-4.263H27.936c-.474,0-.269-.379-.269-.853a.849.849,0,0,1,.853-.853H49.343a.844.844,0,0,1,.758.474L52.279,44.4h2.179V33.412a.853.853,0,0,1,1.705,0v11.84A.849.849,0,0,1,55.311,46.1Z",
                  transform: "translate(-27.623 -32.559)",
                  fill: "#ee2b7b"
                }
              ) }),
              /* @__PURE__ */ r("g", { id: "Grupo_16900", "data-name": "Grupo 16900", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41302",
                  "data-name": "Trazado 41302",
                  d: "M5.128,44.975h-3.6a.849.849,0,0,1-.853-.853V12.012a.849.849,0,0,1,.853-.853H7.5a.849.849,0,0,1,.853.853v5.968a.853.853,0,0,1-1.705,0V12.864H2.381V43.175H4.56l2.179-4.263a.966.966,0,0,1,.758-.474H18.2a.853.853,0,0,1,0,1.705H7.97L5.791,44.407A.692.692,0,0,1,5.128,44.975Z",
                  transform: "translate(-0.676 -11.159)",
                  fill: "#ee2b7b"
                }
              ) })
            ] }),
            /* @__PURE__ */ r("g", { id: "Grupo_16902", "data-name": "Grupo 16902", transform: "translate(9.413 1.655)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41303",
                "data-name": "Trazado 41303",
                d: "M14.828,11.512a4.928,4.928,0,1,1,4.928-4.928A4.947,4.947,0,0,1,14.828,11.512Zm0-8.347a3.419,3.419,0,1,0,3.419,3.419A3.446,3.446,0,0,0,14.828,3.165Z",
                transform: "translate(-9.9 -1.655)",
                fill: "#ee2b7b"
              }
            ) })
          ]
        }
      )
    ]
  }
), j3 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_33_afiliados_tarifa_A_B",
    "data-name": "33_afiliados_tarifa_A_B",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_33_afiliados_tarifa_A_B-2",
          "data-name": "33_afiliados_tarifa_A_B",
          transform: "translate(1.506 7.694)",
          children: [
            /* @__PURE__ */ h("g", { id: "Grupo_16669", "data-name": "Grupo 16669", transform: "translate(0.494 0.306)", children: [
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40951",
                  "data-name": "Trazado 40951",
                  d: "M56.613,40.18V37.965a.794.794,0,0,0-.738-.738H32.984a.794.794,0,0,0-.738.738V40.18a3.231,3.231,0,1,1-6.461,0V11.751a5.246,5.246,0,0,0-1.326-3.473H44.21a3.452,3.452,0,0,1,3.275,3.391V34.56a.644.644,0,1,0,1.282-.1V11.567A4.727,4.727,0,0,0,44.06,6.859H32.892V5.013A4.727,4.727,0,0,0,28.184.306H5.2A4.727,4.727,0,0,0,.494,5.013V7.229a.794.794,0,0,0,.738.738H5.94a.794.794,0,0,0,.738-.738A.794.794,0,0,0,5.94,6.49H1.919V4.868A3.484,3.484,0,0,1,5.386,1.637,3.4,3.4,0,0,1,8.616,5.013V27.166a4.754,4.754,0,0,0,4.523,4.707h8.584a.728.728,0,0,0,.738-.738.794.794,0,0,0-.738-.738H16.444a4.436,4.436,0,0,0,1.268-3.231v-15.6a3.563,3.563,0,0,1,3.549-3.231,3.505,3.505,0,0,1,3.231,3.415V40.088A4.727,4.727,0,0,0,29.2,44.795H52.09A4.436,4.436,0,0,0,56.613,40.18ZM16.37,11.567v15.6a3.231,3.231,0,0,1-6.461,0V5.013A4.8,4.8,0,0,0,8.616,1.637h19.66a3.4,3.4,0,0,1,3.231,3.376V6.859H21.077A4.727,4.727,0,0,0,16.37,11.567ZM55.321,40.088a3.27,3.27,0,0,1-3.231,3.231H32.279a4.8,4.8,0,0,0,1.292-3.374V38.468l21.75.143Z",
                  transform: "translate(-0.494 -0.306)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40952",
                  "data-name": "Trazado 40952",
                  d: "M46.77,28.183a.738.738,0,0,0,0-1.477H32.832a.738.738,0,0,0,0,1.477Z",
                  transform: "translate(-2.927 -2.339)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40953",
                  "data-name": "Trazado 40953",
                  d: "M47.17,30.506H33.232a.738.738,0,1,0,0,1.477H47.17a.738.738,0,0,0,0-1.477Z",
                  transform: "translate(-2.958 -2.631)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40954",
                  "data-name": "Trazado 40954",
                  d: "M47.17,34.706H33.232a.738.738,0,1,0,0,1.477H47.17a.738.738,0,0,0,0-1.477Z",
                  transform: "translate(-2.958 -2.955)",
                  fill: "#ee2b7b"
                }
              )
            ] }),
            /* @__PURE__ */ r("g", { id: "Grupo_16670", "data-name": "Grupo 16670", transform: "translate(34.639 11.197)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40955",
                "data-name": "Trazado 40955",
                d: "M38.238,18.9a.616.616,0,0,1,.64.5v.369a1.2,1.2,0,0,0,1.292,1.015,1.294,1.294,0,0,0,1.292-1.108,1.359,1.359,0,0,0-1.385-1.569,2.463,2.463,0,0,1-.738-4.8c.185-.092.185-.092.185-.277V12.66a.6.6,0,0,1,.554-.554.532.532,0,0,1,.554.554v.462c0,.092.092.185.185.277a2.5,2.5,0,0,1,1.661,1.661,1.8,1.8,0,0,1,.092.738.6.6,0,0,1-.554.554.532.532,0,0,1-.554-.554c-.092-.738-.369-1.2-1.015-1.292a1.376,1.376,0,0,0-1.661,1.015,1.3,1.3,0,0,0,1.108,1.569,2.032,2.032,0,0,1,.738.092A2.447,2.447,0,0,1,42.478,19.4a2.323,2.323,0,0,1-1.661,2.492c-.277.092-.277.092-.277.369v.277a.6.6,0,0,1-.554.554.532.532,0,0,1-.554-.554v-.462c0-.092,0-.185-.185-.185a2.48,2.48,0,0,1-1.754-2.031C37.432,19.057,37.872,18.938,38.238,18.9Z",
                transform: "translate(-37.488 -12.106)",
                fill: "#ee2b7b"
              }
            ) })
          ]
        }
      )
    ]
  }
), W3 = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_45_no_afiliados_comfama",
    "data-name": "45_no_afiliados_comfama",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_45_no_afiliados_comfama-2",
          "data-name": "45_no_afiliados_comfama",
          transform: "translate(-2 -0.9)",
          children: [
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41013",
                "data-name": "Trazado 41013",
                d: "M32.386,31.7a6.686,6.686,0,1,0,6.686,6.686A6.762,6.762,0,0,0,32.386,31.7Zm5.329,6.686a5.329,5.329,0,1,1-5.329-5.329A5.376,5.376,0,0,1,37.715,38.386Z",
                transform: "translate(-0.643 -0.833)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41014",
                "data-name": "Trazado 41014",
                d: "M32.243,46.7c-6.686,0-11.143,3.391-11.143,8.43v3.294a.764.764,0,0,0,.775.775.713.713,0,0,0,.775-.775V55.13c0-4.748,4.845-6.976,9.689-6.976s9.689,2.132,9.689,6.976v3.294a.764.764,0,0,0,.775.775.713.713,0,0,0,.775-.775V55.13C43.385,50.091,38.928,46.7,32.243,46.7Z",
                transform: "translate(-0.5 -1.299)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41015",
                "data-name": "Trazado 41015",
                d: "M24.881,25.3a.625.625,0,0,0,.581-.581V22.3c0-3.585,3.585-5.135,7.17-5.135s7.17,1.55,7.17,5.135V24.72a.581.581,0,1,0,1.163,0V22.3c0-3.779-3.391-6.3-8.333-6.3S24.3,18.519,24.3,22.3V24.72A.514.514,0,0,0,24.881,25.3Z",
                transform: "translate(-0.6 -0.345)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41016",
                "data-name": "Trazado 41016",
                d: "M32.738,14.977a5.038,5.038,0,1,0,0-10.077A5.13,5.13,0,0,0,27.7,9.938,5.066,5.066,0,0,0,32.738,14.977ZM28.766,9.938a3.973,3.973,0,1,1,7.945,0,3.929,3.929,0,0,1-3.973,3.973A4.054,4.054,0,0,1,28.766,9.938Z",
                transform: "translate(-0.706)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41017",
                "data-name": "Trazado 41017",
                d: "M51.132,26.064a5.232,5.232,0,1,0,0-10.464A5.338,5.338,0,0,0,45.9,20.832,5.21,5.21,0,0,0,51.132,26.064Zm-4.166-5.232A4.069,4.069,0,1,1,51.035,24.9,4.032,4.032,0,0,1,46.966,20.832Z",
                transform: "translate(-1.271 -0.333)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41018",
                "data-name": "Trazado 41018",
                d: "M51.02,27.3c-5.232,0-8.72,2.616-8.72,6.589v2.519a.581.581,0,1,0,1.163,0V33.889c0-3.682,3.779-5.329,7.461-5.329s7.461,1.647,7.461,5.329v2.519a.581.581,0,1,0,1.163,0V33.889C59.644,29.916,56.155,27.3,51.02,27.3Z",
                transform: "translate(-1.159 -0.696)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41019",
                "data-name": "Trazado 41019",
                d: "M13.732,26.064a5.232,5.232,0,1,0,0-10.464A5.338,5.338,0,0,0,8.5,20.832,5.273,5.273,0,0,0,13.732,26.064ZM9.663,20.832A4.069,4.069,0,1,1,13.732,24.9,3.973,3.973,0,0,1,9.663,20.832Z",
                transform: "translate(-0.109 -0.333)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41020",
                "data-name": "Trazado 41020",
                d: "M21.181,36.408a.581.581,0,0,0,1.163,0V33.889c0-3.876-3.488-6.589-8.72-6.589S5,29.916,5,33.889v2.519a.625.625,0,0,0,.581.581.625.625,0,0,0,.581-.581V33.889c0-3.682,3.779-5.329,7.461-5.329s7.461,1.647,7.461,5.329v2.519Z",
                transform: "translate(0 -0.696)",
                fill: "#ee2b7b"
              }
            )
          ]
        }
      )
    ]
  }
), U3 = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_18_icono_agil_pertinente",
    "data-name": "18_icono_agil_pertinente",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ r(
        "path",
        {
          id: "_18_icono_agil_pertinente-2",
          "data-name": "18_icono_agil_pertinente",
          d: "M9.3,26.779h0a.865.865,0,0,0-.785-.883H2.231a.774.774,0,0,0-.785.785h0a.774.774,0,0,0,.785.785h6.28A.7.7,0,0,0,9.3,26.779ZM52.671,25.9h-6.28a.774.774,0,0,0-.785.785h0a.774.774,0,0,0,.785.785h6.28a.774.774,0,0,0,.785-.785h0C53.554,26.288,53.162,25.9,52.671,25.9ZM11.75,35.807a.909.909,0,0,0-1.178-.294l-5.4,3.14a.909.909,0,0,0-.294,1.178h0a.909.909,0,0,0,1.178.294l5.4-3.14a1.035,1.035,0,0,0,.294-1.178Zm31.4-18.154a.909.909,0,0,0,1.178.294l5.4-3.14a.909.909,0,0,0,.294-1.178h0a.909.909,0,0,0-1.178-.294l-5.4,3.14a.936.936,0,0,0-.294,1.178ZM36.577,10.98h0a.936.936,0,0,0,1.178-.294l3.14-5.4A.936.936,0,0,0,40.6,4.111h0a.936.936,0,0,0-1.178.294l-3.14,5.4A.822.822,0,0,0,36.577,10.98ZM27.353,8.625h0a.865.865,0,0,0,.883-.785V1.461a.774.774,0,0,0-.785-.785h0a.774.774,0,0,0-.785.785v6.28A.734.734,0,0,0,27.353,8.625ZM17.245,10.685a.909.909,0,0,0,1.178.294h0A.909.909,0,0,0,18.717,9.8l-3.14-5.4A.909.909,0,0,0,14.4,4.111a.909.909,0,0,0-.294,1.178ZM49.727,38.653l-5.4-3.14a.858.858,0,0,0-.883,1.472l5.4,3.14a.936.936,0,0,0,1.178-.294A.822.822,0,0,0,49.727,38.653ZM11.455,16.573l-5.4-3.14a.936.936,0,0,0-1.178.294.84.84,0,0,0,.294,1.178l5.4,3.14a.936.936,0,0,0,1.178-.294A.822.822,0,0,0,11.455,16.573ZM34.418,25.9h-.785a.361.361,0,0,0-.294.1,5.691,5.691,0,0,0-1.178-2.846.211.211,0,0,0,.2-.2l.589-.589a.893.893,0,0,0,0-1.178h0a.893.893,0,0,0-1.178,0l-.589.589c-.1.1-.1.2-.2.2a5.231,5.231,0,0,0-2.944-1.178c0-.1.1-.2.1-.294v-.785a.785.785,0,0,0-1.57,0V20.5a.36.36,0,0,0,.1.294,6.6,6.6,0,0,0-2.944,1.276c0-.1-.1-.2-.2-.294l-.491-.491a.833.833,0,0,0-1.178,1.178l.589.589c.1.1.2.2.294.2a5.691,5.691,0,0,0-1.178,2.846.59.59,0,0,0-.393-.1h-.785a.785.785,0,1,0,0,1.57h.785c.2,0,.294-.1.393-.1a5.343,5.343,0,0,0,1.276,2.944c-.2,0-.294.1-.491.2l-.589.589a.833.833,0,0,0,1.178,1.178l.589-.589a.75.75,0,0,0,.2-.491,6.154,6.154,0,0,0,2.944,1.276.59.59,0,0,0-.1.393v.785a.785.785,0,1,0,1.57,0v-.785a.59.59,0,0,0-.1-.393,5.525,5.525,0,0,0,2.944-1.178.744.744,0,0,0,.2.393l.589.589A.833.833,0,1,0,32.946,31.2l-.589-.589c-.1-.1-.2-.2-.294-.2a5.765,5.765,0,0,0,1.276-2.944c.1,0,.2.1.294.1h.785a.774.774,0,0,0,.785-.785A.865.865,0,0,0,34.418,25.9Zm-6.967,5.3a4.416,4.416,0,1,1,4.416-4.416A4.4,4.4,0,0,1,27.451,31.2ZM20.872,45.159a1.023,1.023,0,0,1-1.045-1.044,14.432,14.432,0,0,0-3.246-9.226A14.359,14.359,0,0,1,13.3,24.381a14.338,14.338,0,0,1,12.47-12.627l1.471,0a13.838,13.838,0,0,1,9.679,3.6,14.278,14.278,0,0,1,4.763,10.5,13.924,13.924,0,0,1-2.95,8.692,15.75,15.75,0,0,0-3.246,9.561c.151.5-.007.721-.081.8a.992.992,0,0,1-.63.248h-13.9Zm9.153-7.114c.85.356.863.8.776,1.14L30.067,43.4h3.981l.013-.281a17.171,17.171,0,0,1,3.457-9.548,12.112,12.112,0,0,0,2.57-7.544,12.933,12.933,0,0,0-4.111-9.258,12.065,12.065,0,0,0-8.239-3.093H26.231a12.39,12.39,0,0,0-11.01,10.984,12.579,12.579,0,0,0,2.744,9.255,14.927,14.927,0,0,1,3.618,9.2l.013.281h3.983l-.733-4.03a.548.548,0,0,1,.06-.449,1.191,1.191,0,0,1,.727-.552l.264.009a1.156,1.156,0,0,1,.893.8l.7,4.22h.847l.532-4.614a.913.913,0,0,1,.879-.744h.278Zm5.644,9.543a.838.838,0,0,1-.863.863H20.941a.838.838,0,0,1-.863-.863.765.765,0,0,1,.863-.864H34.806A.839.839,0,0,1,35.669,47.589ZM34.43,50.725a.838.838,0,0,1-.863.864H22.179a.839.839,0,0,1-.864-.864.765.765,0,0,1,.864-.864H33.568A.839.839,0,0,1,34.43,50.725ZM32.677,54.1l-.01.027a5.049,5.049,0,0,1-4.329,2.741h-.825a4.839,4.839,0,0,1-4.22-2.568l-.157-.315a.863.863,0,0,1-.1-.618.688.688,0,0,1,.386-.419.816.816,0,0,1,.454-.117.671.671,0,0,1,.582.407l.164.33a3.191,3.191,0,0,0,2.885,1.739h.825a3.365,3.365,0,0,0,2.885-1.9A.763.763,0,0,1,31.967,53L32.5,53C32.8,53.1,32.763,53.654,32.677,54.1Z",
          transform: "translate(2.554 1.324)",
          fill: "#ee2b7b"
        }
      )
    ]
  }
), q3 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_41_alertas_mercado",
    "data-name": "41_alertas_mercado",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_41_alertas_mercado-2",
          "data-name": "41_alertas_mercado",
          transform: "translate(-0.5 -1.201)",
          children: [
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40985",
                "data-name": "Trazado 40985",
                d: "M54.54,28.472a9.456,9.456,0,0,0-6.371-4.966,47.324,47.324,0,0,1-15.647-6.84c-.468-.375-.937-.562-1.312-.843h0a7.837,7.837,0,0,0-4.5-2.53c-2.811-.468-5.809.843-8.339,3.748a.732.732,0,0,0,1.124.937c2.249-2.53,4.685-3.654,7.027-3.279,2.342.468,4.4,2.436,5.715,5.622a22.535,22.535,0,0,1,1.031,11.9,22.946,22.946,0,0,1-4.685,11.056c-2.249,2.717-4.778,3.935-7.215,3.56-1.968-.281-3.654-1.687-4.966-3.935a.755.755,0,1,0-1.312.75c1.5,2.623,3.56,4.31,6,4.685a4.562,4.562,0,0,0,1.124.094,8.588,8.588,0,0,0,5.434-2.061c1.312-.094,2.53-.187,3.654-.375,1.687-.187,3.279-.375,4.966-.468a19.587,19.587,0,0,0,1.5,2.717,1.293,1.293,0,0,0,.375.281,14.332,14.332,0,0,0,4.4.75c2.811,0,5.9-1.031,7.5-4.31a9.211,9.211,0,0,0,3.467-2.811,7.447,7.447,0,0,0,1.031-13.68Zm2.53,7.683a6.007,6.007,0,0,1-4.029,4.591.515.515,0,0,0-.468.281,8.172,8.172,0,0,1-3.279,2.623.732.732,0,0,0-.375.375c-2.436,5.341-8.714,3.654-10.025,3.186-.562-.937-1.031-1.874-1.5-2.811a.955.955,0,0,0-.75-.468c-1.968.094-3.842.375-5.622.562a8.251,8.251,0,0,0-1.593.187c.094-.187.281-.281.375-.468A24.746,24.746,0,0,0,34.77,32.5a24.744,24.744,0,0,0-1.124-12.743,2.931,2.931,0,0,0-.468-.937,43.868,43.868,0,0,0,14.71,6.09,8.4,8.4,0,0,1,5.528,4.4.732.732,0,0,0,.375.375A6.127,6.127,0,0,1,57.069,36.156Z",
                transform: "translate(-0.725 0)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40986",
                "data-name": "Trazado 40986",
                d: "M16.242,39.467A.773.773,0,0,0,15.3,39L5.467,41.9A.773.773,0,0,0,5,42.84a.785.785,0,0,0,.75.562h.187l9.838-3A.773.773,0,0,0,16.242,39.467Z",
                transform: "translate(-0.093 -1.625)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40987",
                "data-name": "Trazado 40987",
                d: "M17.188,24.01c.094.094.187.094.375.094a.583.583,0,0,0,.562-.375.665.665,0,0,0-.187-1.031L9.224,16.889a.665.665,0,0,0-1.031.187A.894.894,0,0,0,8.475,18.2Z",
                transform: "translate(-0.29 -0.222)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40988",
                "data-name": "Trazado 40988",
                d: "M24.285,28.679a1.057,1.057,0,0,1,1.031-.281l5.06.468a.755.755,0,0,0,.187-1.5L25.5,26.9a3.018,3.018,0,0,0-2.155.562A5.833,5.833,0,0,0,21.193,31.3a5.924,5.924,0,0,0,.75,4.31,2.821,2.821,0,0,0,1.78,1.218l4.872,1.218h.187a1.428,1.428,0,0,0,.937-.562.779.779,0,0,0-.562-.937l-4.966-1.218a1.5,1.5,0,0,1-.843-.656,4.386,4.386,0,0,1-.562-3.186A4.333,4.333,0,0,1,24.285,28.679Z",
                transform: "translate(-1.109 -0.862)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40989",
                "data-name": "Trazado 40989",
                d: "M14.837,32.179a.8.8,0,0,0,.75-.656.9.9,0,0,0-.656-.843L4.343,28.9a.755.755,0,0,0-.187,1.5l10.681,1.78Z",
                transform: "translate(0 -0.99)",
                fill: "#ee2b7b"
              }
            )
          ]
        }
      )
    ]
  }
), Y3 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_28_icono_aliados",
    "data-name": "28_icono_aliados",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ r(
        "path",
        {
          id: "_28_icono_aliados-2",
          "data-name": "28_icono_aliados",
          d: "M58.24,45.894l-7.623-7.623a17.89,17.89,0,0,0-2.635-7.529A10.951,10.951,0,0,0,49.394,25.1V22.273l8.752-8.752a.8.8,0,0,0-1.129-1.129l-8.94,8.94a.671.671,0,0,0-.282.565v3.2a10.516,10.516,0,0,1-.847,4.141c-.471-.659-1.035-1.223-1.6-1.882L37.442,19.45c-.188-.188-.376-.282-.471-.376l-3.388-3.388c-.376-.376-.753-.659-1.129-1.035a17.35,17.35,0,0,1,6.305-1.976c.188-.094.376-.094.565-.282L46.1,5.616a.859.859,0,0,0,0-1.129.859.859,0,0,0-1.129,0L38.477,10.98a18.56,18.56,0,0,0-7.623,2.635,11.482,11.482,0,0,0-5.835-1.506H22.2L14.574,4.487a.859.859,0,0,0-1.129,0,.859.859,0,0,0,0,1.129l7.905,7.811a.671.671,0,0,0,.565.282h3.2a10.321,10.321,0,0,1,7.34,3.011L34.43,18.7a3.692,3.692,0,0,0-1.318.753l-.188.188a2.589,2.589,0,0,0-.753,1.412l-1.506-1.506a3.012,3.012,0,0,0-4.329,0l-.188.188a3.457,3.457,0,0,0-.847,1.506,3.019,3.019,0,0,0-3.482.565l-.188.188a3.019,3.019,0,0,0-.565,3.482,3.261,3.261,0,0,0-1.506.753l-.188.188a2.725,2.725,0,0,0-.941,2.164,3.063,3.063,0,0,0,.941,2.164l5.835,5.835a3.692,3.692,0,0,0-1.318.753l-.188.188a2.683,2.683,0,0,0-.753,1.318L17.3,33.1a17.183,17.183,0,0,1-4.8-10.164c-.094-.188-.094-.376-.282-.565L4.41,14.556a.859.859,0,0,0-1.129,0,.859.859,0,0,0,0,1.129L10.9,23.308a20.186,20.186,0,0,0,2.635,7.623,11.019,11.019,0,0,0-1.6,5.929v2.823L3.187,48.435a.859.859,0,0,0,0,1.129.671.671,0,0,0,.565.282c.188,0,.376-.094.659-.376l8.94-8.94a.671.671,0,0,0,.282-.565V36.86a11.165,11.165,0,0,1,.941-4.329c.471.565.941,1.129,1.506,1.694l7.529,7.529.094.094,4.141,4.141a11.92,11.92,0,0,0,1.223,1.035,19.024,19.024,0,0,1-6.4,2.07c-.188.094-.376.094-.565.282l-6.776,6.776a.859.859,0,0,0,0,1.129.671.671,0,0,0,.565.282.815.815,0,0,0,.659-.376l6.493-6.493a18.56,18.56,0,0,0,7.623-2.635,12.434,12.434,0,0,0,5.741,1.506H39.23l7.623,7.623a.671.671,0,0,0,.565.282.518.518,0,0,0,.471-.282.859.859,0,0,0,0-1.129l-7.717-7.811a.671.671,0,0,0-.565-.282H36.5a10.321,10.321,0,0,1-7.34-3.011L25.02,40.812a1.609,1.609,0,0,1,.188-2.353,1.365,1.365,0,0,1,1.976,0L31.419,42.6a.671.671,0,0,0,.565.282.813.813,0,0,0,.565-.282.859.859,0,0,0,0-1.129L20.6,29.613a1.973,1.973,0,0,1-.376-1.035,1.415,1.415,0,0,1,.376-1.035l.188-.188a1.283,1.283,0,0,1,1.694-.188l8.846,8.752a.671.671,0,0,0,.565.282.68.68,0,0,0,.565-.376.859.859,0,0,0,0-1.129l-9.6-9.6a1.365,1.365,0,0,1,0-1.976l.188-.188a1.365,1.365,0,0,1,1.976,0l1.035,1.035.094.094h0l8.47,8.47A.8.8,0,1,0,35.748,31.4l-8.47-8.47a1.365,1.365,0,0,1,0-1.976l.188-.188a1.365,1.365,0,0,1,1.976,0l8.47,8.47a.671.671,0,0,0,.565.282.71.71,0,0,0,.659-.376.859.859,0,0,0,0-1.129L33.772,22.65a1.626,1.626,0,0,1,.282-1.788,1.553,1.553,0,0,1,2.259-.188l7.905,7.905a17.78,17.78,0,0,1,2.164,2.635.092.092,0,0,0,.094.094,17.37,17.37,0,0,1,2.635,7.435c.094.188.094.376.282.565L57.2,47.118a.671.671,0,0,0,.565.282.585.585,0,0,0,.565-.376A1,1,0,0,0,58.24,45.894Z",
          transform: "translate(-0.975 -1.275)",
          fill: "#ee2b7b"
        }
      )
    ]
  }
), K3 = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_06_icono_alternativas_financiacion",
    "data-name": "06_icono_alternativas_financiacion",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_06_icono_alternativas_financiacion-2",
          "data-name": "06_icono_alternativas_financiacion",
          transform: "translate(-1.3 -1.398)",
          children: [
            /* @__PURE__ */ h("g", { id: "Grupo_16943", "data-name": "Grupo 16943", transform: "translate(3.3 28.273)", children: [
              /* @__PURE__ */ r("g", { id: "Grupo_16940", "data-name": "Grupo 16940", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41379",
                  "data-name": "Trazado 41379",
                  d: "M10.121,55.4H4.069a.769.769,0,1,1,0-1.537h6.052A1.272,1.272,0,0,0,11.37,52.61V31.186a1.272,1.272,0,0,0-1.249-1.249H4.069a.769.769,0,1,1,0-1.537h6.052a2.788,2.788,0,0,1,2.786,2.786V52.61A2.788,2.788,0,0,1,10.121,55.4Z",
                  transform: "translate(-3.3 -28.4)",
                  fill: "#ee2b7b"
                }
              ) }),
              /* @__PURE__ */ r("g", { id: "Grupo_16941", "data-name": "Grupo 16941", transform: "translate(13.03 3.459)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41380",
                  "data-name": "Trazado 41380",
                  d: "M42.823,41.607a.827.827,0,0,1-.769-.769v-.576a.963.963,0,0,0-.961-.961H33.5c-.192,0-.288-.1-.48-.1l-7.878-5.668H17.269a.769.769,0,1,1,0-1.537h8.07c.192,0,.288.1.48.1L33.7,37.764H41a2.543,2.543,0,0,1,2.5,2.5v.576A.64.64,0,0,1,42.823,41.607Z",
                  transform: "translate(-16.5 -32)",
                  fill: "#ee2b7b"
                }
              ) }),
              /* @__PURE__ */ r("g", { id: "Grupo_16942", "data-name": "Grupo 16942", transform: "translate(12.425 7.59)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41381",
                  "data-name": "Trazado 41381",
                  d: "M36.343,53.112a18.573,18.573,0,0,1-6.437-1.153,21.263,21.263,0,0,1-3.362-1.537c-.961-.48-1.825-.961-2.786-1.345a21.341,21.341,0,0,0-7.59-1.537.769.769,0,1,1,0-1.537,24.625,24.625,0,0,1,8.166,1.633,28.027,28.027,0,0,1,2.978,1.345,23.137,23.137,0,0,0,3.17,1.441c7.3,2.5,13.642-.1,17.581-2.786,1.057-.672,2.017-1.441,2.978-2.114a56.778,56.778,0,0,1,5-3.362l.288-.192a6.193,6.193,0,0,0,1.537-1.057,1.436,1.436,0,0,0,.48-1.729,2.368,2.368,0,0,0-2.017-1.249h-.1a9.694,9.694,0,0,0-4.323,1.633l-7.59,4.227c-.1,0-.1.1-.192.1-4.707,1.153-16.044.1-16.524,0a.775.775,0,0,1,.192-1.537c.1,0,11.336,1.153,15.852,0l7.494-4.227A10.874,10.874,0,0,1,56.23,36.3h.1a3.545,3.545,0,0,1,3.362,2.114,3.051,3.051,0,0,1-.865,3.362A6.879,6.879,0,0,1,57,43.025l-.288.1c-1.633.961-3.266,2.21-4.9,3.362-.961.769-2.017,1.441-3.074,2.21A19.811,19.811,0,0,1,36.343,53.112Z",
                  transform: "translate(-15.4 -36.3)",
                  fill: "#ee2b7b"
                }
              ) })
            ] }),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41382",
                "data-name": "Trazado 41382",
                d: "M45.881,29.534A10.568,10.568,0,1,1,56.449,18.966,10.537,10.537,0,0,1,45.881,29.534Zm0-19.6a9.031,9.031,0,1,0,9.031,9.031A9.02,9.02,0,0,0,45.881,9.935ZM42.808,21.808A3.064,3.064,0,0,0,45,24.335a.232.232,0,0,1,.187.264c-.009.185-.006.371,0,.556a.7.7,0,0,0,1.4.006,3.192,3.192,0,0,0,0-.45c-.024-.228.055-.336.284-.41a3.068,3.068,0,0,0,2.1-3.342,3.1,3.1,0,0,0-3.034-2.7,1.689,1.689,0,0,1-.395-3.338,1.694,1.694,0,0,1,1.821.827,2.194,2.194,0,0,1,.231.9.69.69,0,0,0,.721.619.682.682,0,0,0,.673-.645,2.316,2.316,0,0,0-.022-.49A3.055,3.055,0,0,0,46.779,13.6a.241.241,0,0,1-.2-.279c.01-.185.007-.371,0-.556a.687.687,0,0,0-.7-.665.679.679,0,0,0-.7.661,3.974,3.974,0,0,0,0,.513c.017.2-.062.283-.255.344a3.115,3.115,0,0,0-2.148,3.2,3.154,3.154,0,0,0,2.388,2.78c.316.078.638.056.955.108a1.612,1.612,0,0,1,1.353,1.133,1.679,1.679,0,0,1-2.138,2.117,1.661,1.661,0,0,1-1.149-1.6.736.736,0,0,0-.2-.482.7.7,0,0,0-.769-.165.726.726,0,0,0-.444.758A2.69,2.69,0,0,0,42.808,21.808Z",
                transform: "translate(-0.458)",
                fill: "#ee2b7b"
              }
            )
          ]
        }
      )
    ]
  }
), X3 = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_38_aplica_subsidio",
    "data-name": "38_aplica_subsidio",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h("g", { id: "_38_aplica_subsidio-2", "data-name": "38_aplica_subsidio", transform: "translate(3.706 2.5)", children: [
        /* @__PURE__ */ r("g", { id: "Grupo_16683", "data-name": "Grupo 16683", transform: "translate(16.376 19.008)", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40978",
            "data-name": "Trazado 40978",
            d: "M33.419,19.577H16.332a.738.738,0,1,1,0-1.477H33.419a.738.738,0,0,1,0,1.477Z",
            transform: "translate(-15.594 -18.1)",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16684", "data-name": "Grupo 16684", transform: "translate(16.376 29.872)", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40979",
            "data-name": "Trazado 40979",
            d: "M27.512,29.877H16.332a.738.738,0,1,1,0-1.477h11.18a.738.738,0,0,1,0,1.477Z",
            transform: "translate(-15.594 -28.4)",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16685", "data-name": "Grupo 16685", transform: "translate(16.376 40.735)", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40980",
            "data-name": "Trazado 40980",
            d: "M23.926,40.177H16.332a.738.738,0,1,1,0-1.477h7.7a.721.721,0,0,1,.738.738A.815.815,0,0,1,23.926,40.177Z",
            transform: "translate(-15.594 -38.7)",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16686", "data-name": "Grupo 16686", transform: "translate(9.415 17.953)", children: /* @__PURE__ */ r(
          "circle",
          {
            id: "Elipse_78",
            "data-name": "Elipse 78",
            cx: "1.793",
            cy: "1.793",
            r: "1.793",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16687", "data-name": "Grupo 16687", transform: "translate(9.415 28.817)", children: /* @__PURE__ */ r(
          "circle",
          {
            id: "Elipse_79",
            "data-name": "Elipse 79",
            cx: "1.793",
            cy: "1.793",
            r: "1.793",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16688", "data-name": "Grupo 16688", transform: "translate(9.415 39.575)", children: /* @__PURE__ */ r(
          "circle",
          {
            id: "Elipse_80",
            "data-name": "Elipse 80",
            cx: "1.793",
            cy: "1.793",
            r: "1.793",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16689", "data-name": "Grupo 16689", transform: "translate(29.033 28.29)", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40981",
            "data-name": "Trazado 40981",
            d: "M39.09,49.893a11.5,11.5,0,1,1,11.5-11.5A11.523,11.523,0,0,1,39.09,49.893Zm.055-21.516A10.007,10.007,0,1,0,49.152,38.384,10.01,10.01,0,0,0,39.145,28.377Z",
            transform: "translate(-27.594 -26.9)",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16691", "data-name": "Grupo 16691", transform: "translate(34.583 33.405)", children: /* @__PURE__ */ r("g", { id: "Grupo_16690", "data-name": "Grupo 16690", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40982",
            "data-name": "Trazado 40982",
            d: "M42.81,43.721c-.211,0-.316,0-.422-.105L39.33,41.4l-3.059,2.215a.638.638,0,0,1-.844,0,.617.617,0,0,1-.316-.738l1.16-3.586-3.059-2.215a.617.617,0,0,1-.316-.738.779.779,0,0,1,.633-.527h3.8l1.16-3.586a.732.732,0,0,1,1.371,0l1.16,3.586h3.9a.591.591,0,0,1,.633.527c0,.316,0,.633-.316.738L42.177,39.5l1.16,3.375a.545.545,0,0,1-.316.738C43.021,43.721,42.81,43.721,42.81,43.721Z",
            transform: "translate(-32.856 -31.75)",
            fill: "#ee2b7b"
          }
        ) }) }),
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40983",
            "data-name": "Trazado 40983",
            d: "M29.877,51.7H2.982V13.418H13.212a.832.832,0,0,0,.844-.844V3.188H40.318v21.2a.844.844,0,0,0,1.688,0V2.344a.907.907,0,0,0-.844-.844h-29a1.131,1.131,0,0,0-.633.211L1.5,11.731a1.5,1.5,0,0,0-.211.633V52.548a.907.907,0,0,0,.844.844H29.877a.844.844,0,0,0,0-1.688ZM12.474,3.188v8.543H3.931Z",
            transform: "translate(0 0)",
            fill: "#ee2b7b"
          }
        )
      ] })
    ]
  }
), Q3 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_22_icono_aprende",
    "data-name": "22_icono_aprende",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h("g", { id: "_22_icono_aprende-2", "data-name": "22_icono_aprende", transform: "translate(1.576 7.246)", children: [
        /* @__PURE__ */ h("g", { id: "Grupo_16836", "data-name": "Grupo 16836", transform: "translate(0.424 18.092)", children: [
          /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41224",
              "data-name": "Trazado 41224",
              d: "M7.424,19.153h-6.2a.961.961,0,0,0-.8.9.789.789,0,0,0,.8.8h6.2a1.216,1.216,0,0,1,1.2,1.2v21.8a1.216,1.216,0,0,1-1.2,1.2h-6.2a.86.86,0,0,0-.8.8.789.789,0,0,0,.8.8h6.2a2.9,2.9,0,0,0,2.9-2.9v-21.7A2.9,2.9,0,0,0,7.424,19.153Z",
              transform: "translate(-0.424 -19.153)",
              fill: "#ee2b7b"
            }
          ),
          /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41225",
              "data-name": "Trazado 41225",
              d: "M14.124,24.353h8l8,5.7c.2.1.3.2.5.2h7.7a.9.9,0,0,1,.9.9v.6a.789.789,0,0,0,.8.8.983.983,0,0,0,.9-.7v-.6a2.647,2.647,0,0,0-2.6-2.6h-7.4l-8-5.7c-.2-.1-.3-.2-.5-.2h-8.3a.86.86,0,0,0-.8.8A.789.789,0,0,0,14.124,24.353Z",
              transform: "translate(-0.999 -19.153)",
              fill: "#ee2b7b"
            }
          ),
          /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41226",
              "data-name": "Trazado 41226",
              d: "M57.524,29.253a3.69,3.69,0,0,0-3.5-2.2h-.1a10.581,10.581,0,0,0-5.2,1.9l-7.6,4.3c-4.6,1.1-16,0-16.1,0a.8.8,0,0,0-.9.7.7.7,0,0,0,.7.9c.4.1,11.9,1.2,16.7,0,.1,0,.1-.1.2-.1l7.7-4.3c1-.6,2.8-1.7,4.3-1.7h.1a2.161,2.161,0,0,1,2,1.2,1.625,1.625,0,0,1-.5,1.7,9.062,9.062,0,0,1-1.6,1.1l-.3.1c-1.8,1.1-3.5,2.3-5.1,3.5-1,.8-2,1.5-3,2.2-4,2.8-10.4,5.5-17.8,2.9a23.017,23.017,0,0,1-3.2-1.5,27.51,27.51,0,0,0-3-1.4,24.107,24.107,0,0,0-8.3-1.7.86.86,0,0,0-.8.8.789.789,0,0,0,.8.8,20.824,20.824,0,0,1,7.7,1.6,22.791,22.791,0,0,1,2.8,1.3,21.1,21.1,0,0,0,3.4,1.6,21.739,21.739,0,0,0,6.6,1.1,22.8,22.8,0,0,0,13-4.4c1.1-.7,2.1-1.5,3.1-2.2a53.611,53.611,0,0,1,4.9-3.4l.2-.1a8.016,8.016,0,0,0,1.9-1.3A2.986,2.986,0,0,0,57.524,29.253Z",
              transform: "translate(-1.749 -19.153)",
              fill: "#ee2b7b"
            }
          )
        ] }),
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41227",
            "data-name": "Trazado 41227",
            d: "M31.68,18.392a.743.743,0,0,1-.226-.034.7.7,0,0,1-.432-.7V3.153a1.364,1.364,0,0,1,.189-.555A8.049,8.049,0,0,1,36.822.753a8.379,8.379,0,0,1,5.04,1.48l.06.045.06-.045a8.379,8.379,0,0,1,5.04-1.48,8.872,8.872,0,0,1,5.49,1.777c.135.1.162.123.21.123a.815.815,0,0,1,.1.5v14.4a.927.927,0,0,1-.456.717.288.288,0,0,1-.244.083,1.358,1.358,0,0,1-.556-.189,6.363,6.363,0,0,0-4.545-1.511c-3.064,0-4.6,1.422-4.6,1.6a.917.917,0,0,1-1.04-.08,6.431,6.431,0,0,0-4.56-1.52c-3.064,0-4.6,1.422-4.6,1.6a1.236,1.236,0,0,1-.542.139ZM47.023,2.153a6.791,6.791,0,0,0-4.364,1.318l-.035,12.747.146-.079a8.968,8.968,0,0,1,4.253-.986,9.309,9.309,0,0,1,4.256.989l.145.072V3.553A6.6,6.6,0,0,0,47.023,2.153Zm-10.2,13a8.968,8.968,0,0,1,4.253.986l.146.079V3.577a6.441,6.441,0,0,0-4.4-1.424A7.48,7.48,0,0,0,32.468,3.47l-.044,12.745.145-.072A9.29,9.29,0,0,1,36.824,15.153Z",
            transform: "translate(-1.325)",
            fill: "#ee2b7b"
          }
        ),
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41228",
            "data-name": "Trazado 41228",
            d: "M41.023,21.753a.775.775,0,0,1-.529-.271,2.153,2.153,0,0,0-1.17-.629h-10.1a.685.685,0,0,1-.7-.7V4.053a.7.7,0,0,1,1.4,0v15.4h9.5a3.3,3.3,0,0,1,1.94.78l1.06.02a3.551,3.551,0,0,1,2-.8h9.5V4.053a.686.686,0,0,1,.7-.7.758.758,0,0,1,.7.7v16.1a.686.686,0,0,1-.7.7h-10.2a2.147,2.147,0,0,0-1.17.629.532.532,0,0,1-.53.271h-1.7Z",
            transform: "translate(-1.325)",
            fill: "#ee2b7b"
          }
        )
      ] })
    ]
  }
), J3 = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_19_icono_aprender_haciendo",
    "data-name": "19_icono_aprender_haciendo",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_19_icono_aprender_haciendo-2",
          "data-name": "19_icono_aprender_haciendo",
          transform: "translate(1.412 9.488)",
          children: [
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40783",
                "data-name": "Trazado 40783",
                d: "M56.587,6.734H53.708V5.713c0-.186,0-.371-.186-.464a1.32,1.32,0,0,0-.557-.186l-10.122.743V4.6a3.924,3.924,0,0,0-3.9-3.9,3.734,3.734,0,0,0-3.065,1.579A4,4,0,0,0,32.627.512,3.875,3.875,0,0,0,29.47,2.184,3.875,3.875,0,0,0,26.312.512a4,4,0,0,0-3.25,1.764A3.777,3.777,0,0,0,19.811.512a3.944,3.944,0,0,0-3.9,3.993V5.9L4.86,5.062a.447.447,0,0,0-.557.186.709.709,0,0,0-.186.464V6.734H1.238a.635.635,0,0,0-.65.65v7.151a.635.635,0,0,0,.65.65H4.117v.929a.635.635,0,0,0,.65.65L16,16.3v4.55a7.672,7.672,0,0,0,1.207,3.9c.65.929,1.3,1.95,1.764,2.693a5.327,5.327,0,0,1,.371.65v11.33a.759.759,0,0,0,.743.836.813.813,0,0,0,.836-.743l-.093-11.7a1.01,1.01,0,0,0-.093-.464s-1.3-2.043-2.322-3.529a3.637,3.637,0,0,1-.836-2.415V11.563a5.027,5.027,0,0,1,5.015-3.9h9.937a2.465,2.465,0,0,1,2.507,2.322,2.118,2.118,0,0,1-.65,1.764,2.761,2.761,0,0,1-1.857.743H25.1a.7.7,0,0,0-.65.464.622.622,0,0,0,.279.743,14.063,14.063,0,0,1,6.129,11.515.635.635,0,0,0,.65.65.662.662,0,0,0,.65-.743A15.767,15.767,0,0,0,29.377,16.3H32.07l20.988.557c.186,0,.371,0,.464-.186a.709.709,0,0,0,.186-.464v-.929h2.879a.7.7,0,0,0,.65-.65V7.477A.662.662,0,0,0,56.587,6.734ZM39.035,2.091A2.5,2.5,0,0,1,41.542,4.6v6.594A2.5,2.5,0,0,1,39.035,13.7a2.583,2.583,0,0,1-2.507-2.136V4.041A2.592,2.592,0,0,1,39.035,2.091ZM26.312,2A2.5,2.5,0,0,1,28.82,4.505V6.27H23.8V4.505A2.5,2.5,0,0,1,26.312,2ZM1.981,13.792V8.034H4.117v5.758ZM5.51,15.464V6.548L16,7.384V15ZM17.49,8.684V4.505a2.507,2.507,0,0,1,5.015,0h0V6.27A6.528,6.528,0,0,0,17.49,8.684ZM32.534,6.27H30.213V3.762a2.5,2.5,0,0,1,4.922.65V7.106A4.564,4.564,0,0,0,32.534,6.27Zm.093,7.336a4.705,4.705,0,0,0,1.207-.186,2.634,2.634,0,0,1-1.207.371c-.279,0-.557-.093-.743-.093h.743Zm-4.55,1.022a6.592,6.592,0,0,0,1.3-.929v-.093h.093a4.539,4.539,0,0,0,1.672,1.3H28.262C28.262,14.814,28.169,14.721,28.077,14.628Zm24.424.836L33.927,15a3.945,3.945,0,0,0,1.95-1.486,3.875,3.875,0,0,0,3.157,1.672,3.924,3.924,0,0,0,3.9-3.9V7.291l9.565-.65v8.822Zm3.343-1.672H53.708V8.034h2.136Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40784",
                "data-name": "Trazado 40784",
                d: "M44.874,19.353a.683.683,0,0,0-.743.743V24.33c0,2.229-2.972,4.272-2.972,4.272a.668.668,0,0,0-.371.65l.093,11.515a.683.683,0,0,0,.743.743h.093a.562.562,0,0,0,.557-.279.408.408,0,0,0,.093-.464l-.093-11.144c1.022-.836,3.343-2.879,3.343-5.293V20.1A.683.683,0,0,0,44.874,19.353Z",
                transform: "translate(-2.868 -1.344)",
                fill: "#ee2b7b"
              }
            )
          ]
        }
      )
    ]
  }
), e4 = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_10_icono_aprendizaje_divertido",
    "data-name": "10_icono_aprendizaje_divertido",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ r(
        "g",
        {
          id: "_10_icono_aprendizaje_divertido-2",
          "data-name": "10_icono_aprendizaje_divertido",
          transform: "translate(-1.275 -1.475)",
          children: /* @__PURE__ */ h("g", { id: "XMLID_114_", transform: "translate(3.275 3.475)", children: [
            /* @__PURE__ */ r("g", { id: "XMLID_122_", transform: "translate(22.593 2.181)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40738",
                "data-name": "Trazado 40738",
                d: "M42.557,36.808a.724.724,0,0,1-.474-.19L36.014,30.55a.687.687,0,0,1,.569-1.138,2.162,2.162,0,0,0,1.8-.664,2.474,2.474,0,0,0,.664-1.612,2.221,2.221,0,0,0-.664-1.612,2.354,2.354,0,0,0-3.224-.116,2.5,2.5,0,0,0-.664,1.8.635.635,0,0,1-.379.664.6.6,0,0,1-.759-.19L27.29,21.73a.688.688,0,0,1,0-.948l5.974-5.974a.787.787,0,0,1,.759-.19.539.539,0,0,1,.379.664,2.151,2.151,0,0,0,.664,1.707,2.452,2.452,0,0,0,3.3,0,2.349,2.349,0,0,0,0-3.224,2.434,2.434,0,0,0-1.707-.664.953.953,0,0,1-.743-.379.6.6,0,0,1,.19-.759l5.974-5.974a.744.744,0,0,1,1.043,0L57.92,20.782a.688.688,0,0,1,0,.948l-4.931,4.931a3.44,3.44,0,0,1,1.8,3.129,3.609,3.609,0,0,1-6.733,1.8l-5.026,5.026A.724.724,0,0,1,42.557,36.808Zm-4.552-6.354,4.552,4.552L47.868,29.7a.738.738,0,0,1,.759-.19.6.6,0,0,1,.474.569,2.148,2.148,0,0,0,4.267-.379,2.061,2.061,0,0,0-1.8-2.086A.6.6,0,0,1,51,27.136a.738.738,0,0,1,.19-.759L56.4,21.161,42.557,7.411l-4.552,4.552a3.978,3.978,0,0,1,1.328.853,3.688,3.688,0,0,1-5.216,5.216,3.978,3.978,0,0,1-.853-1.328l-4.552,4.552,4.552,4.552a3.978,3.978,0,0,1,.853-1.328,3.652,3.652,0,0,1,6.259,2.655,3.982,3.982,0,0,1-1.043,2.655A3.187,3.187,0,0,1,38.006,30.455Z",
                transform: "translate(-27.1 -5.775)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "XMLID_121_", transform: "translate(2.371 22.096)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40739",
                "data-name": "Trazado 40739",
                d: "M21.256,58a.724.724,0,0,1-.474-.19L5.988,42.92a.744.744,0,0,1,0-1.043l5.026-5.026A3.978,3.978,0,0,1,9.687,36a3.725,3.725,0,0,1-1.043-2.655,4.075,4.075,0,0,1,1.043-2.655,3.721,3.721,0,0,1,5.216,0,3.978,3.978,0,0,1,.853,1.328l5.026-5.026a.744.744,0,0,1,1.043,0l5.026,5.026a3.978,3.978,0,0,1,.853-1.328A3.688,3.688,0,0,1,32.92,35.9a2.717,2.717,0,0,1-1.328,1.043l5.026,5.026a.688.688,0,0,1,0,.948l-5.69,5.69a.629.629,0,0,1-.664.19.6.6,0,0,1-.474-.569A2.222,2.222,0,0,0,27.7,46.524a2.158,2.158,0,0,0-.474,4.267.971.971,0,0,1,.569.474.586.586,0,0,1-.19.664l-5.69,5.69C21.635,57.9,21.446,58,21.256,58ZM7.506,42.446,21.351,56.291l4.457-4.457A3.585,3.585,0,1,1,30.739,46.9L35.2,42.446l-5.5-5.5a.787.787,0,0,1-.19-.759.539.539,0,0,1,.664-.379,2.332,2.332,0,0,0,1.675-4.1,2.4,2.4,0,0,0-3.238.075,2.3,2.3,0,0,0-.6,1.736.8.8,0,0,1-.379.664.6.6,0,0,1-.759-.19l-5.543-5.444L15.819,34c-.19.19-.527.4-.717.3-.474-.19-.605-.516-.521-.787a2.163,2.163,0,0,0-.468-1.9,2.432,2.432,0,0,0-3.364-.032,2.74,2.74,0,0,0-.779,1.856,2.08,2.08,0,0,0,.664,1.612,2.5,2.5,0,0,0,1.8.664.8.8,0,0,1,.664.379.6.6,0,0,1-.19.759Z",
                transform: "translate(-5.775 -26.775)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "XMLID_120_", transform: "translate(0.284 43.433)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40740",
                "data-name": "Trazado 40740",
                d: "M4.263,53.756a.724.724,0,0,1-.474-.19.744.744,0,0,1,0-1.043l3.035-3.035a.738.738,0,1,1,1.043,1.043L4.832,53.566A.8.8,0,0,1,4.263,53.756Z",
                transform: "translate(-3.575 -49.275)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "XMLID_119_", transform: "translate(7.112 50.355)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40741",
                "data-name": "Trazado 40741",
                d: "M11.463,61.056a.724.724,0,0,1-.474-.19.744.744,0,0,1,0-1.043l3.035-3.035a.738.738,0,1,1,1.043,1.043l-3.035,3.035A1.348,1.348,0,0,1,11.463,61.056Z",
                transform: "translate(-10.775 -56.575)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "XMLID_118_", transform: "translate(0 47.036)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40742",
                "data-name": "Trazado 40742",
                d: "M3.963,61.065a.724.724,0,0,1-.474-.19.744.744,0,0,1,0-1.043l6.638-6.543a.738.738,0,1,1,1.043,1.043L4.532,60.875A1.348,1.348,0,0,1,3.963,61.065Z",
                transform: "translate(-3.275 -53.075)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "XMLID_117_", transform: "translate(50.735 7.112)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40743",
                "data-name": "Trazado 40743",
                d: "M57.463,15.456a.724.724,0,0,1-.474-.19.744.744,0,0,1,0-1.043l3.035-3.035a.738.738,0,0,1,1.043,1.043l-3.129,3.035A.724.724,0,0,1,57.463,15.456Z",
                transform: "translate(-56.775 -10.975)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "XMLID_116_", transform: "translate(43.812 0.284)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40744",
                "data-name": "Trazado 40744",
                d: "M50.163,8.256a.724.724,0,0,1-.474-.19.744.744,0,0,1,0-1.043l3.035-3.035a.738.738,0,1,1,1.043,1.043L50.732,8.066A1.348,1.348,0,0,1,50.163,8.256Z",
                transform: "translate(-49.475 -3.775)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "XMLID_115_", transform: "translate(47.415)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40745",
                "data-name": "Trazado 40745",
                d: "M53.963,11.465a.724.724,0,0,1-.474-.19.744.744,0,0,1,0-1.043l6.638-6.543A.738.738,0,0,1,61.17,4.732l-6.638,6.543A1.348,1.348,0,0,1,53.963,11.465Z",
                transform: "translate(-53.275 -3.475)",
                fill: "#ee2b7b"
              }
            ) })
          ] })
        }
      )
    ]
  }
), a4 = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_26_icono_aprendizaje_inspiradores",
    "data-name": "26_icono_aprendizaje_inspiradores",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_26_icono_aprendizaje_inspiradores-2",
          "data-name": "26_icono_aprendizaje_inspiradores",
          transform: "translate(1.576 7.247)",
          children: [
            /* @__PURE__ */ h("g", { id: "Grupo_16547", "data-name": "Grupo 16547", transform: "translate(0.424 18.535)", children: [
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40804",
                  "data-name": "Trazado 40804",
                  d: "M7.189,19.153H1.2a.929.929,0,0,0-.773.87A.762.762,0,0,0,1.2,20.8H7.189a1.175,1.175,0,0,1,1.16,1.16V43.024a1.175,1.175,0,0,1-1.16,1.16H1.2a.831.831,0,0,0-.773.773.762.762,0,0,0,.773.773H7.189a2.8,2.8,0,0,0,2.8-2.8V21.956A2.8,2.8,0,0,0,7.189,19.153Z",
                  transform: "translate(-0.424 -19.153)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40805",
                  "data-name": "Trazado 40805",
                  d: "M14.1,24.3h7.731l7.731,5.509c.193.1.29.193.483.193h7.441a.866.866,0,0,1,.87.87v.58a.762.762,0,0,0,.773.773.95.95,0,0,0,.87-.677v-.58a2.559,2.559,0,0,0-2.513-2.513H30.333L22.6,22.946c-.193-.1-.29-.193-.483-.193H14.1a.831.831,0,0,0-.773.773A.762.762,0,0,0,14.1,24.3Z",
                  transform: "translate(-0.857 -19.274)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40806",
                  "data-name": "Trazado 40806",
                  d: "M56,29.179a3.566,3.566,0,0,0-3.382-2.126h-.1A10.226,10.226,0,0,0,47.5,28.889l-7.345,4.156c-4.446,1.063-15.463,0-15.559,0a.77.77,0,0,0-.87.677.678.678,0,0,0,.677.87c.387.1,11.5,1.16,16.139,0,.1,0,.1-.1.193-.1l7.441-4.156c.966-.58,2.706-1.643,4.156-1.643h.1a2.089,2.089,0,0,1,1.933,1.16,1.57,1.57,0,0,1-.483,1.643,8.758,8.758,0,0,1-1.546,1.063l-.29.1c-1.74,1.063-3.382,2.223-4.929,3.382-.966.773-1.933,1.45-2.9,2.126-3.866,2.706-10.051,5.315-17.2,2.8a22.244,22.244,0,0,1-3.093-1.45,26.586,26.586,0,0,0-2.9-1.353A23.3,23.3,0,0,0,13,36.524a.831.831,0,0,0-.773.773A.762.762,0,0,0,13,38.07a20.125,20.125,0,0,1,7.441,1.546,22.026,22.026,0,0,1,2.706,1.256,20.388,20.388,0,0,0,3.286,1.546,21.009,21.009,0,0,0,6.378,1.063A22.037,22.037,0,0,0,45.372,39.23c1.063-.676,2.029-1.45,3-2.126A51.811,51.811,0,0,1,53.1,33.818l.193-.1a7.747,7.747,0,0,0,1.836-1.256A2.886,2.886,0,0,0,56,29.179Z",
                  transform: "translate(-0.82 -19.418)",
                  fill: "#ee2b7b"
                }
              )
            ] }),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40807",
                "data-name": "Trazado 40807",
                d: "M31.658,17.8a.718.718,0,0,1-.218-.033.672.672,0,0,1-.417-.681V3.072a1.318,1.318,0,0,1,.183-.536A7.779,7.779,0,0,1,36.627.753,8.1,8.1,0,0,1,41.5,2.183l.058.043.058-.043A8.1,8.1,0,0,1,46.485.753,8.574,8.574,0,0,1,51.791,2.47c.13.1.157.119.2.119a.788.788,0,0,1,.1.483V16.989a.9.9,0,0,1-.441.693.279.279,0,0,1-.236.08,1.312,1.312,0,0,1-.537-.183,6.149,6.149,0,0,0-4.392-1.46c-2.961,0-4.446,1.374-4.446,1.546a.886.886,0,0,1-1.005-.077,6.215,6.215,0,0,0-4.407-1.469c-2.961,0-4.446,1.374-4.446,1.546a1.2,1.2,0,0,1-.524.134ZM46.486,2.106A6.563,6.563,0,0,0,42.268,3.38L42.235,15.7l.141-.076a8.667,8.667,0,0,1,4.11-.953,9,9,0,0,1,4.113.956l.14.07V3.459A6.375,6.375,0,0,0,46.486,2.106ZM36.629,14.67a8.667,8.667,0,0,1,4.11.953l.141.076V3.482a6.225,6.225,0,0,0-4.251-1.376,7.229,7.229,0,0,0-4.21,1.273L32.377,15.7l.14-.07A8.979,8.979,0,0,1,36.629,14.67Z",
                transform: "translate(-1.027 0)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40808",
                "data-name": "Trazado 40808",
                d: "M40.6,21.135a.749.749,0,0,1-.511-.262,2.081,2.081,0,0,0-1.131-.608H29.2a.662.662,0,0,1-.677-.677V4.029a.677.677,0,0,1,1.353,0V18.912h9.181a3.185,3.185,0,0,1,1.875.754l1.024.019a3.431,3.431,0,0,1,1.933-.773H53.07V4.03a.663.663,0,0,1,.677-.676.732.732,0,0,1,.676.676V19.589a.663.663,0,0,1-.676.677H43.889a2.075,2.075,0,0,0-1.131.608.514.514,0,0,1-.512.262H40.6Z",
                transform: "translate(-0.943 -0.087)",
                fill: "#ee2b7b"
              }
            )
          ]
        }
      )
    ]
  }
), t4 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_17_icono_asesoria",
    "data-name": "17_icono_asesoria",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ r(
        "path",
        {
          id: "_17_icono_asesoria-2",
          "data-name": "17_icono_asesoria",
          d: "M51.419,22.561a5.142,5.142,0,1,0-5.142-5.142A5.176,5.176,0,0,0,51.419,22.561Zm0-1.261A3.881,3.881,0,1,1,55.3,17.419,3.892,3.892,0,0,1,51.419,21.3Zm0,1.94c-4.948,0-8.344,2.62-8.344,6.306v2.426a.626.626,0,0,0,.582.582.559.559,0,0,0,.582-.582V29.546c0-3.493,3.59-5.045,7.179-5.045S58.6,26.053,58.6,29.546v2.426a.559.559,0,0,0,.582.582.626.626,0,0,0,.582-.582V29.546C59.763,25.762,56.367,23.24,51.419,23.24Zm-39.875-.679A5.142,5.142,0,1,0,6.4,17.419,5.176,5.176,0,0,0,11.544,22.561Zm0-1.261a3.881,3.881,0,1,1,3.881-3.881A3.892,3.892,0,0,1,11.544,21.3Zm0,1.94C6.6,23.24,3.2,25.859,3.2,29.546v2.426a.626.626,0,0,0,.582.582.559.559,0,0,0,.582-.582V29.546c0-3.493,3.59-5.045,7.179-5.045s7.179,1.552,7.179,5.045v2.426a.559.559,0,0,0,.582.582.626.626,0,0,0,.582-.582V29.546C19.887,25.762,16.492,23.24,11.544,23.24Zm20.083-7.956a5.142,5.142,0,1,0-5.142-5.142A5.176,5.176,0,0,0,31.627,15.284Zm0-8.926a3.881,3.881,0,1,1-3.881,3.881A3.956,3.956,0,0,1,31.627,6.358Zm0,9.6c-4.948,0-8.344,2.62-8.344,6.306V24.7a.626.626,0,0,0,.582.582.559.559,0,0,0,.582-.582V22.27c0-3.493,3.59-5.045,7.179-5.045s7.179,1.552,7.179,5.045V24.7a.559.559,0,0,0,.582.582.626.626,0,0,0,.582-.582V22.27C40.068,18.583,36.575,15.963,31.627,15.963Zm-6.4,26.389a6.4,6.4,0,1,0,6.4-6.4A6.46,6.46,0,0,0,25.224,42.353Zm6.4-5.045a5.045,5.045,0,1,1-5.045,5.045A5.072,5.072,0,0,1,31.627,37.308Zm0,12.613c-6.209,0-10.575,3.2-10.575,7.956v3.1a.729.729,0,0,0,.679.679.613.613,0,0,0,.679-.679v-3.1c0-4.56,4.657-6.694,9.314-6.694s9.314,2.037,9.314,6.694v3.1a.659.659,0,0,0,.679.679.729.729,0,0,0,.679-.679v-3.1C42.3,53.122,37.933,49.92,31.627,49.92Zm0-16.2a.729.729,0,0,1-.679-.679V26.927a.729.729,0,0,1,.679-.679.663.663,0,0,1,.679.679v6.112A.613.613,0,0,1,31.627,33.718Zm11.351,9.314c-.194,0-.291-.1-.485-.194a.736.736,0,0,1-.194-.388,1.639,1.639,0,0,1,.194-.485l4.851-4.948a.741.741,0,0,1,.485-.194c.194,0,.291.1.485.194a.544.544,0,0,1,0,.873l-4.851,4.948A1.639,1.639,0,0,1,42.978,43.032Zm-22.8,0c-.194,0-.291-.1-.485-.194l-4.754-4.851a.741.741,0,0,1-.194-.485c0-.194.1-.291.194-.485a.741.741,0,0,1,.485-.194c.194,0,.291.1.485.194l4.851,4.948a.544.544,0,0,1,0,.873A1.379,1.379,0,0,1,20.179,43.032Z",
          transform: "translate(-1.2 -3)",
          fill: "#ee2b7b"
        }
      )
    ]
  }
), r4 = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_04_capitalismo_consciente",
    "data-name": "04_capitalismo_consciente",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_04_capitalismo_consciente-2",
          "data-name": "04_capitalismo_consciente",
          transform: "translate(7.363 2.429)",
          children: [
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41032",
                "data-name": "Trazado 41032",
                d: "M11.476,14.571a13.289,13.289,0,0,0-6.2,6.6,14.934,14.934,0,0,0-1.4,6.9,4.671,4.671,0,0,0,.3,1.7,1.605,1.605,0,0,1-.3,1.6c-.3.3-.4.6-.7.9l-.1.2c-.3.3-.5.7-.8,1a14.166,14.166,0,0,0-1.4,2.3,3.655,3.655,0,0,0-.1,2.3,2.731,2.731,0,0,0,1.7,1.4.68.68,0,0,1,.4.3.6.6,0,0,1-.1.4,1.826,1.826,0,0,0,.4,2.1c.2.2.3.3.2.6a1.529,1.529,0,0,0,.4,1.8,1.814,1.814,0,0,1,.5,1.8,3.768,3.768,0,0,0,.8,2.7,3.847,3.847,0,0,0,2.6,1.3l4.8.3a1.889,1.889,0,0,1,1.3.7,3.926,3.926,0,0,1,.6,1.3c.3,1,.6,2.2.8,3.2a.789.789,0,0,0,.849.675c.94-.116.68-1,.645-1.162-.066-.3-.143-.643-.293-1.312a12.865,12.865,0,0,0-.8-2.6,3.5,3.5,0,0,0-3.4-2.4c-1.2,0-2.4-.1-3.7-.2l-.8-.1a1.75,1.75,0,0,1-1.4-.7,2.155,2.155,0,0,1-.4-1.6,3.177,3.177,0,0,0-.8-2.8c-.2-.2-.2-.3-.1-.6a1.384,1.384,0,0,0-.3-1.7.919.919,0,0,1-.2-1,1.7,1.7,0,0,0,0-1.4,1.837,1.837,0,0,0-1.2-.8c-.2,0-.3-.1-.5-.2-.6-.3-.7-.6-.5-1.3a6.117,6.117,0,0,1,.5-1.2c.1-.2,2.1-3,2.5-3.6a2.712,2.712,0,0,0,.3-2.3,3.926,3.926,0,0,1-.3-1.4,13.831,13.831,0,0,1,2.9-9.2,11.469,11.469,0,0,1,5.9-4,19.442,19.442,0,0,1,4.9-1.1c.621-.043.74-.349.723-.74s-.153-.765-.823-.76A19.071,19.071,0,0,0,11.476,14.571Z",
                transform: "translate(0 -1.353)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41033",
                "data-name": "Trazado 41033",
                d: "M34.476,36.471l-1.1,1.9a14.692,14.692,0,0,0-1.4,4.5,17.223,17.223,0,0,0-.4,3.9v3.9l.053,5.1a.873.873,0,0,0,.862.876.79.79,0,0,0,.786-.876c0-.8-.3-8.8,0-11.1a25.851,25.851,0,0,1,.9-4,19.277,19.277,0,0,1,1.9-3.8c.5-.9,1-2,1.5-3.1.2-.544-.406-1.042-.915-.935-.371.078-.546.059-.976,1.268A12.693,12.693,0,0,1,34.476,36.471Z",
                transform: "translate(-0.862 -1.353)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ h("g", { id: "Grupo_16716", "data-name": "Grupo 16716", transform: "translate(19.387 0.571)", children: [
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41034",
                  "data-name": "Trazado 41034",
                  d: "M30.676,4.771a.773.773,0,0,0,.8-.7v-2.7a.736.736,0,0,0-.8-.8.789.789,0,0,0-.8.8v2.7A.828.828,0,0,0,30.676,4.771Z",
                  transform: "translate(-20.476 -0.571)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41035",
                  "data-name": "Trazado 41035",
                  d: "M23.876,7.571a.759.759,0,0,0-.2-.5l-2-2a.7.7,0,0,0-1.2.5.764.764,0,0,0,.2.5l2,2a.843.843,0,0,0,.5.2A.633.633,0,0,0,23.876,7.571Z",
                  transform: "translate(-20.476 -0.571)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41036",
                  "data-name": "Trazado 41036",
                  d: "M44.976,13.971h-2.8a.736.736,0,0,0-.8.8.789.789,0,0,0,.8.8h2.8a.789.789,0,0,0,.8-.8A.841.841,0,0,0,44.976,13.971Z",
                  transform: "translate(-20.476 -0.571)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41037",
                  "data-name": "Trazado 41037",
                  d: "M40.776,4.071a.764.764,0,0,0-.5.2l-2,2a.725.725,0,0,0,0,1,.764.764,0,0,0,.5.2,1.421,1.421,0,0,0,.6-.2l2-2a.725.725,0,0,0,0-1A.735.735,0,0,0,40.776,4.071Z",
                  transform: "translate(-20.476 -0.571)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41038",
                  "data-name": "Trazado 41038",
                  d: "M31.176,6.171h-.9a8.712,8.712,0,0,0-7.6,7.7,8.791,8.791,0,0,0,2,6.4,8.452,8.452,0,0,1,1.9,5.4.789.789,0,0,0,.8.8h8.3a.764.764,0,0,0,.5-.2.56.56,0,0,0,.1-.6,9.229,9.229,0,0,1,1.9-5.6,8.493,8.493,0,0,0,1.8-5.3,8.724,8.724,0,0,0-2.9-6.4A8.486,8.486,0,0,0,31.176,6.171Zm1.9,18.9.4-2.3q.15-.6-.6-.9h-.2a.73.73,0,0,0-.7.6l-.3,2.6h-.2l-.4-2.4a.858.858,0,0,0-.7-.6h-.2c-.4.1-.7.5-.6.8l.4,2.2h-2a9.041,9.041,0,0,0-2.2-5.6,7.346,7.346,0,0,1-1.6-5.4,7.231,7.231,0,0,1,6.4-6.4h.9a6.986,6.986,0,0,1,4.8,1.8,7.512,7.512,0,0,1,2.4,5.4,7.1,7.1,0,0,1-1.5,4.4,10.467,10.467,0,0,0-2.1,5.8Z",
                  transform: "translate(-20.476 -0.571)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41039",
                  "data-name": "Trazado 41039",
                  d: "M35.576,26.871h-8.4a.736.736,0,0,0-.8.8.789.789,0,0,0,.8.8h8.4a.8.8,0,1,0,0-1.6Z",
                  transform: "translate(-20.476 -0.571)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41040",
                  "data-name": "Trazado 41040",
                  d: "M34.876,28.771h-6.9a.736.736,0,0,0-.8.8.789.789,0,0,0,.8.8h6.9a.8.8,0,1,0,0-1.6Z",
                  transform: "translate(-20.476 -0.571)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41041",
                  "data-name": "Trazado 41041",
                  d: "M34.076,30.671h-.3a.755.755,0,0,0-.7.4,1.751,1.751,0,0,1-1.5,1h-.5a1.65,1.65,0,0,1-1.5-.9l-.1-.2a.675.675,0,0,0-.6-.4.756.756,0,0,0-.4.1.693.693,0,0,0-.3,1l.1.2a3.2,3.2,0,0,0,2.8,1.7h.5a3.318,3.318,0,0,0,2.9-1.9C34.576,31.171,34.476,30.771,34.076,30.671Z",
                  transform: "translate(-20.476 -0.571)",
                  fill: "#ee2b7b"
                }
              )
            ] })
          ]
        }
      )
    ]
  }
), i4 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_27_icono_cercano",
    "data-name": "27_icono_cercano",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h("g", { id: "_27_icono_cercano-2", "data-name": "27_icono_cercano", transform: "translate(0.61 1.622)", children: [
        /* @__PURE__ */ h("g", { id: "Grupo_16840", "data-name": "Grupo 16840", children: [
          /* @__PURE__ */ r("g", { id: "Grupo_16838", "data-name": "Grupo 16838", children: /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41241",
              "data-name": "Trazado 41241",
              d: "M15,56.481h0a4.679,4.679,0,0,1-4.058-2.232C6.172,46.64.39,36.5.39,31.322a14.608,14.608,0,1,1,29.216,0c0,5.174-5.681,15.318-10.55,22.825A4.646,4.646,0,0,1,15,56.481ZM15,18.54A12.772,12.772,0,0,0,2.317,31.322c0,3.652,3.652,11.463,10.246,21.811a2.892,2.892,0,0,0,2.536,1.42h0a3.017,3.017,0,0,0,2.536-1.42c6.594-10.449,10.246-18.159,10.246-21.811A12.946,12.946,0,0,0,15,18.54Z",
              fill: "#ee2b7b"
            }
          ) }),
          /* @__PURE__ */ r("g", { id: "Grupo_16839", "data-name": "Grupo 16839", children: /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41242",
              "data-name": "Trazado 41242",
              d: "M15,39.133a7.811,7.811,0,1,1,7.811-7.811A7.814,7.814,0,0,1,15,39.133Zm0-13.695a5.884,5.884,0,1,0,5.884,5.884A5.889,5.889,0,0,0,15,25.438Z",
              fill: "#ee2b7b"
            }
          ) })
        ] }),
        /* @__PURE__ */ h("g", { id: "Grupo_16843", "data-name": "Grupo 16843", children: [
          /* @__PURE__ */ r("g", { id: "Grupo_16841", "data-name": "Grupo 16841", children: /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41243",
              "data-name": "Trazado 41243",
              d: "M48.238,26.375a3.561,3.561,0,0,1-2.921-1.558C42.2,19.949,38.5,13.425,38.5,10.017a9.639,9.639,0,1,1,19.278,0c0,3.408-3.7,9.932-6.816,14.8A2.994,2.994,0,0,1,48.238,26.375Zm0-24.286a8.013,8.013,0,0,0-7.984,7.984c0,2.267,2.366,7.392,6.6,14a1.657,1.657,0,0,0,2.76,0c4.14-6.6,6.6-11.729,6.6-14A7.951,7.951,0,0,0,48.238,2.089Z",
              fill: "#ee2b7b"
            }
          ) }),
          /* @__PURE__ */ r("g", { id: "Grupo_16842", "data-name": "Grupo 16842", children: /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41244",
              "data-name": "Trazado 41244",
              d: "M48.238,15.372a5.236,5.236,0,0,1-5.258-5.258,5.319,5.319,0,0,1,5.258-5.355A5.236,5.236,0,0,1,53.5,10.017,5.319,5.319,0,0,1,48.238,15.372Zm0-9a3.746,3.746,0,1,0,3.746,3.746A3.731,3.731,0,0,0,48.238,6.369Z",
              fill: "#ee2b7b"
            }
          ) })
        ] }),
        /* @__PURE__ */ h("g", { id: "Grupo_16844", "data-name": "Grupo 16844", children: [
          /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41245",
              "data-name": "Trazado 41245",
              d: "M16.929,56.184c.293-.287.564-.579.35-1s-.616-.47-1.065-.479c-.359-.007-.717-.058-1.076-.064a1.053,1.053,0,0,0-1.1.539c-.206.454.051.756.449,1.006Z",
              fill: "#ee2b7b"
            }
          ),
          /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41246",
              "data-name": "Trazado 41246",
              d: "M36.039,47.082a4.449,4.449,0,0,0,.007.712.808.808,0,0,0,.85.71.785.785,0,0,0,.894-.656,3.913,3.913,0,0,0-.049-1.654.764.764,0,0,0-.863-.6.8.8,0,0,0-.826.664,5.21,5.21,0,0,0-.008.829Z",
              fill: "#ee2b7b"
            }
          ),
          /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41247",
              "data-name": "Trazado 41247",
              d: "M37.6,25.543a4.963,4.963,0,0,0-2.029,1.19.591.591,0,0,0,.109.825.764.764,0,0,0,.9.232,16.2,16.2,0,0,0,1.682-.872.608.608,0,0,0,.267-.843A1.017,1.017,0,0,0,37.6,25.543Z",
              fill: "#ee2b7b"
            }
          ),
          /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41248",
              "data-name": "Trazado 41248",
              d: "M43.441,24.383c-.52.016-1.151,0-1.764.067a.665.665,0,0,0-.64.82.778.778,0,0,0,.807.7c.581.015,1.164.01,1.741-.028.478-.032.788-.286.767-.73S44.019,24.518,43.441,24.383Z",
              fill: "#ee2b7b"
            }
          ),
          /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41249",
              "data-name": "Trazado 41249",
              d: "M35.033,50.84a1.1,1.1,0,0,0-.613.217c-.382.275-.773.541-1.143.828a.68.68,0,0,0-.154,1.1.875.875,0,0,0,1.24.12,5.424,5.424,0,0,0,1.353-1.057.618.618,0,0,0,.078-.778A.949.949,0,0,0,35.033,50.84Z",
              fill: "#ee2b7b"
            }
          ),
          /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41250",
              "data-name": "Trazado 41250",
              d: "M22.168,56.106c.2-.022.563-.04.914-.1.516-.1.784-.408.724-.862a.769.769,0,0,0-.9-.648,16.266,16.266,0,0,0-1.682.131c-.478.066-.78.349-.743.788s.338.68.848.695C21.557,56.112,21.783,56.106,22.168,56.106Z",
              fill: "#ee2b7b"
            }
          ),
          /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41251",
              "data-name": "Trazado 41251",
              d: "M31.525,35.806a5.972,5.972,0,0,0,.524,1.6.819.819,0,0,0,1.005.406c.459-.128.718-.441.617-.866a10.058,10.058,0,0,0-.5-1.535.814.814,0,0,0-.991-.434A.745.745,0,0,0,31.525,35.806Z",
              fill: "#ee2b7b"
            }
          ),
          /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41252",
              "data-name": "Trazado 41252",
              d: "M35.682,42.988a.78.78,0,0,0,.733-1,8.845,8.845,0,0,0-.743-1.393.889.889,0,0,0-1.217-.3.675.675,0,0,0-.337,1.021c.219.412.443.822.684,1.224A.931.931,0,0,0,35.682,42.988Z",
              fill: "#ee2b7b"
            }
          ),
          /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41253",
              "data-name": "Trazado 41253",
              d: "M32.985,29.377c-.709.066-.882.621-1.1,1.107s-.619.975-.1,1.489a.886.886,0,0,0,1.4-.181,9.827,9.827,0,0,0,.659-1.422A.8.8,0,0,0,32.985,29.377Z",
              fill: "#ee2b7b"
            }
          ),
          /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41254",
              "data-name": "Trazado 41254",
              d: "M27.98,55.384a8.5,8.5,0,0,0,1.685-.391c.417-.149.646-.448.526-.855a.8.8,0,0,0-.949-.588,13.374,13.374,0,0,0-1.7.363c-.459.129-.7.445-.585.879C27.068,55.211,27.405,55.414,27.98,55.384Z",
              fill: "#ee2b7b"
            }
          )
        ] })
      ] })
    ]
  }
), n4 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_11_icono_certificado_b2",
    "data-name": "11_icono_certificado_b2",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_11_icono_certificado_b2-2",
          "data-name": "11_icono_certificado_b2",
          transform: "translate(-3 -3.4)",
          children: [
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40746",
                "data-name": "Trazado 40746",
                d: "M42.02,27.194h9.268A20.426,20.426,0,0,0,47.928,16.5,56.825,56.825,0,0,1,40.9,17.824,52.477,52.477,0,0,1,42.02,27.194Z",
                transform: "translate(0.608 0.205)",
                fill: "none"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40747",
                "data-name": "Trazado 40747",
                d: "M46.9,15.231A20.783,20.783,0,0,0,35.9,8a19.659,19.659,0,0,1,4.583,8.453Q43.691,16,46.9,15.231Z",
                transform: "translate(0.516 0.048)",
                fill: "none"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40748",
                "data-name": "Trazado 40748",
                d: "M31.3,7.3v9.879a60.787,60.787,0,0,0,7.435-.509C37.105,11.476,34.355,7.911,31.3,7.3Z",
                transform: "translate(0.431 0.035)",
                fill: "none"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40749",
                "data-name": "Trazado 40749",
                d: "M39.244,18.1a69.331,69.331,0,0,1-7.944.509v8.555h9.166A41.472,41.472,0,0,0,39.244,18.1Z",
                transform: "translate(0.431 0.235)",
                fill: "none"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40750",
                "data-name": "Trazado 40750",
                d: "M31.3,38.7v3.463A15.729,15.729,0,0,1,33.031,38.7,9.831,9.831,0,0,1,31.3,38.7Z",
                transform: "translate(0.431 0.615)",
                fill: "none"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40751",
                "data-name": "Trazado 40751",
                d: "M40.059,33.894a41.329,41.329,0,0,0,.407-5.194H31.3v8.555c1.018,0,2.037.1,3.157.1A12.735,12.735,0,0,1,40.059,33.894Z",
                transform: "translate(0.431 0.431)",
                fill: "none"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40752",
                "data-name": "Trazado 40752",
                d: "M50.052,34.811A20.372,20.372,0,0,0,51.274,28.7H42.006c0,1.63-.2,3.259-.306,4.787a15.256,15.256,0,0,1,2.241-.2A12.65,12.65,0,0,1,50.052,34.811Z",
                transform: "translate(0.623 0.431)",
                fill: "none"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40753",
                "data-name": "Trazado 40753",
                d: "M29.431,48.579h.2V38.7a60.787,60.787,0,0,0-7.435.509C23.728,44.3,26.376,47.866,29.431,48.579Z",
                transform: "translate(0.262 0.615)",
                fill: "none"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40754",
                "data-name": "Trazado 40754",
                d: "M20.5,27.164h9.166V18.609a69.331,69.331,0,0,1-7.944-.509A41.472,41.472,0,0,0,20.5,27.164Z",
                transform: "translate(0.231 0.235)",
                fill: "none"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40755",
                "data-name": "Trazado 40755",
                d: "M21.722,37.764a69.331,69.331,0,0,1,7.944-.509V28.7H20.5A41.472,41.472,0,0,0,21.722,37.764Z",
                transform: "translate(0.231 0.431)",
                fill: "none"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40756",
                "data-name": "Trazado 40756",
                d: "M22.2,16.67c2.444.306,4.991.407,7.435.509V7.3C26.579,7.911,23.83,11.476,22.2,16.67Z",
                transform: "translate(0.262 0.035)",
                fill: "none"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40757",
                "data-name": "Trazado 40757",
                d: "M14.2,40.62a20.829,20.829,0,0,0,11.1,7.333A20.875,20.875,0,0,1,20.616,39.5,44.459,44.459,0,0,0,14.2,40.62Z",
                transform: "translate(0.115 0.63)",
                fill: "none"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40758",
                "data-name": "Trazado 40758",
                d: "M25.1,7.9a21.389,21.389,0,0,0-11,7.231q3.208.764,6.416,1.222A22.866,22.866,0,0,1,25.1,7.9Z",
                transform: "translate(0.113 0.046)",
                fill: "none"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40759",
                "data-name": "Trazado 40759",
                d: "M20.188,17.924c-2.343-.306-4.685-.815-7.028-1.324A20.139,20.139,0,0,0,9.8,27.294h9.268A37.512,37.512,0,0,1,20.188,17.924Z",
                transform: "translate(0.033 0.207)",
                fill: "none"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40760",
                "data-name": "Trazado 40760",
                d: "M18.968,28.7H9.7a21.815,21.815,0,0,0,3.463,10.694A56.826,56.826,0,0,1,20.19,38.07,44.379,44.379,0,0,1,18.968,28.7Z",
                transform: "translate(0.031 0.431)",
                fill: "none"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40761",
                "data-name": "Trazado 40761",
                d: "M52.2,36.158a22.815,22.815,0,1,0-21.388,14.87h.815A13.426,13.426,0,1,0,52.2,36.158ZM25.212,7.946A19.659,19.659,0,0,0,20.629,16.4q-3.208-.458-6.416-1.222A22.034,22.034,0,0,1,25.212,7.946ZM13.194,16.705a56.826,56.826,0,0,0,7.028,1.324A43.4,43.4,0,0,0,19,27.3H9.731A21.444,21.444,0,0,1,13.194,16.705ZM9.731,29.131H19A42.535,42.535,0,0,0,20.222,38.4c-2.343.306-4.685.815-7.028,1.324A21.113,21.113,0,0,1,9.731,29.131Zm4.583,12.12q3.208-.764,6.416-1.222a19.579,19.579,0,0,0,4.685,8.453A20.108,20.108,0,0,1,14.315,41.25ZM29.9,49.3h-.2c-2.954-.713-5.6-4.379-7.231-9.37,2.444-.306,4.991-.407,7.435-.509Zm0-11.611a69.331,69.331,0,0,0-7.944.509,41.472,41.472,0,0,1-1.222-9.064H29.9Zm0-10.287H20.731a41.472,41.472,0,0,1,1.222-9.064,69.331,69.331,0,0,0,7.944.509Zm0-10.185a60.787,60.787,0,0,1-7.435-.509c1.63-5.194,4.379-8.759,7.435-9.37ZM50.674,35.241a14,14,0,0,0-6.213-1.528,16.654,16.654,0,0,0-2.241.2,36.592,36.592,0,0,0,.306-4.787h9.268A17.571,17.571,0,0,1,50.674,35.241ZM51.9,27.4H42.628a42.535,42.535,0,0,0-1.222-9.268c2.342-.306,4.685-.815,7.028-1.324A20.79,20.79,0,0,1,51.9,27.4Zm-4.481-12.12Q44.207,16.043,41,16.5a22.069,22.069,0,0,0-4.583-8.453A20.783,20.783,0,0,1,47.415,15.279ZM31.731,7.335c3.055.611,5.805,4.176,7.435,9.37-2.444.306-4.991.407-7.435.509Zm0,11.509a69.331,69.331,0,0,0,7.944-.509A41.472,41.472,0,0,1,40.9,27.4H31.731Zm0,10.287H40.9a41.329,41.329,0,0,1-.407,5.194,13.336,13.336,0,0,0-5.6,3.463c-1.018-.1-2.037-.1-3.157-.1V29.131Zm0,10.185a9.882,9.882,0,0,1,1.731.1,13.779,13.779,0,0,0-1.731,3.463ZM44.462,58.87a11.7,11.7,0,0,1-11.1-7.944,13.567,13.567,0,0,1-.509-1.935,9.881,9.881,0,0,1-.1-1.731A11.766,11.766,0,0,1,35.6,39.621a7.657,7.657,0,0,1,1.63-1.528,11.443,11.443,0,0,1,2.852-1.63l1.833-.611a10.045,10.045,0,0,1,2.444-.306,11.737,11.737,0,0,1,5.6,1.426,13.269,13.269,0,0,1,1.528,1.018A11.577,11.577,0,0,1,44.462,58.87Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ h("g", { id: "Grupo_16526", "data-name": "Grupo 16526", transform: "translate(38.656 43.186)", children: [
              /* @__PURE__ */ r("g", { id: "Grupo_16524", "data-name": "Grupo 16524", transform: "translate(0 0.102)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40762",
                  "data-name": "Trazado 40762",
                  d: "M38.1,50.544V42.6h2.648a3.745,3.745,0,0,1,2.037.509,1.9,1.9,0,0,1,.713,1.63,1.422,1.422,0,0,1-.306.917,1.584,1.584,0,0,1-.815.611,2.323,2.323,0,0,1,1.222.611,1.778,1.778,0,0,1,.407,1.222,2.1,2.1,0,0,1-.713,1.731,3.041,3.041,0,0,1-2.037.611H38.1v.1Zm1.324-4.583H40.85a1.721,1.721,0,0,0,1.018-.306,1.257,1.257,0,0,0,.407-.815.993.993,0,0,0-.407-.917,3.8,3.8,0,0,0-1.222-.2H39.322v2.241Zm0,1.018v2.546h1.833a1.521,1.521,0,0,0,1.018-.306,1.291,1.291,0,0,0,.407-.917.993.993,0,0,0-.407-.917,1.556,1.556,0,0,0-1.018-.407H39.424Z",
                  transform: "translate(-38.1 -42.6)",
                  fill: "#ee2b7b"
                }
              ) }),
              /* @__PURE__ */ r("g", { id: "Grupo_16525", "data-name": "Grupo 16525", transform: "translate(6.824)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40763",
                  "data-name": "Trazado 40763",
                  d: "M50.1,50.546H45v-.917l2.444-2.852a4.968,4.968,0,0,0,.815-1.222,1.514,1.514,0,0,0,.2-.917,1.051,1.051,0,0,0-1.12-1.12.993.993,0,0,0-.917.407,1.721,1.721,0,0,0-.306,1.018H44.8a2.234,2.234,0,0,1,.713-1.731,2.535,2.535,0,0,1,1.935-.713,2.4,2.4,0,0,1,1.731.611,2.15,2.15,0,0,1,.611,1.63,1.778,1.778,0,0,1-.407,1.222,6.554,6.554,0,0,1-1.222,1.528l-1.63,1.935h3.463l.1,1.12Z",
                  transform: "translate(-44.8 -42.5)",
                  fill: "#ee2b7b"
                }
              ) })
            ] })
          ]
        }
      )
    ]
  }
), o4 = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_03_certificados_requeridos",
    "data-name": "03_certificados_requeridos",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_03_certificados_requeridos-2",
          "data-name": "03_certificados_requeridos",
          transform: "translate(3.062 1.386)",
          children: [
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41319",
                "data-name": "Trazado 41319",
                d: "M21.438,8.714a2.7,2.7,0,1,0-2.7-2.7A2.689,2.689,0,0,0,21.438,8.714Zm0-3.7a.945.945,0,0,1,1,1,1.075,1.075,0,0,1-1,1,1,1,0,0,1,0-2Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41320",
                "data-name": "Trazado 41320",
                d: "M28.438,54.914h-23a2.9,2.9,0,0,1-2.9-2.9v-39.4a3.075,3.075,0,0,1,3-3h5.6v1.1a1.793,1.793,0,0,0,1.8,1.8h16.9c1,0,1.6-.6,1.5-1.8v-1h6.1a2.9,2.9,0,0,1,2.9,2.9v15.7a.789.789,0,0,0,.8.8,1.107,1.107,0,0,0,.9-.7v-15.7a4.653,4.653,0,0,0-4.6-4.6h-6.1v-.2a3.585,3.585,0,0,0-3.6-3.6h-1.3a5.5,5.5,0,0,0-10.4,0h-1.3a3.585,3.585,0,0,0-3.6,3.6v.1h-5.6a4.526,4.526,0,0,0-4.6,4.6v39.3a4.653,4.653,0,0,0,4.6,4.6h23a.709.709,0,0,0,.7-.8A.789.789,0,0,0,28.438,54.914Zm-15.6-47a2.006,2.006,0,0,1,2-2h1.9a.849.849,0,0,0,.8-.7,3.879,3.879,0,0,1,7.6,0,.849.849,0,0,0,.8.7h2a2.006,2.006,0,0,1,2,2v2.8c0,.1,0,.1-.1.1h-16.9c-.1,0-.1,0-.1-.1v-2.8Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41321",
                "data-name": "Trazado 41321",
                d: "M27.938,15.314c.5,0,.9-.4.8-.8a.789.789,0,0,0-.8-.8h-13.1a.8.8,0,0,0,0,1.6Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41322",
                "data-name": "Trazado 41322",
                d: "M45.238,40.514l-6,6-2.2-2.2a.849.849,0,0,0-1.2,1.2l2.8,2.8a1,1,0,0,0,1.2,0l6.6-6.6c.3-.4.4-.9,0-1.2A.91.91,0,0,0,45.238,40.514Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41323",
                "data-name": "Trazado 41323",
                d: "M41.138,32.314a12.1,12.1,0,1,0,12.1,12.1A12.078,12.078,0,0,0,41.138,32.314Zm0,22.5a10.4,10.4,0,1,1,10.4-10.4A10.457,10.457,0,0,1,41.138,54.814Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41324",
                "data-name": "Trazado 41324",
                d: "M33.438,22.014a.789.789,0,0,0-.8-.8h-18.7a.8.8,0,1,0,0,1.6h18.7C33.138,22.814,33.538,22.414,33.438,22.014Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41325",
                "data-name": "Trazado 41325",
                d: "M23.338,32.414h-9.4a.8.8,0,1,0,0,1.6h9.4a.86.86,0,0,0,.8-.8A.789.789,0,0,0,23.338,32.414Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41326",
                "data-name": "Trazado 41326",
                d: "M13.938,43.714a.86.86,0,0,0-.8.8.789.789,0,0,0,.8.8h9.4a.86.86,0,0,0,.8-.8.789.789,0,0,0-.8-.8Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41327",
                "data-name": "Trazado 41327",
                d: "M8.338,20.014a1.9,1.9,0,1,0,0,3.8,1.9,1.9,0,0,0,0-3.8Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41328",
                "data-name": "Trazado 41328",
                d: "M8.338,31.314a1.9,1.9,0,0,0,0,3.8,1.9,1.9,0,0,0,0-3.8Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41329",
                "data-name": "Trazado 41329",
                d: "M8.338,42.514a1.9,1.9,0,0,0,0,3.8,1.9,1.9,0,0,0,0-3.8Z",
                fill: "#ee2b7b"
              }
            )
          ]
        }
      )
    ]
  }
), s4 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_09_Icono_cinco_habitos",
    "data-name": "09_Icono_cinco_habitos",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ r(
        "path",
        {
          id: "_09_Icono_cinco_habitos-2",
          "data-name": "09_Icono_cinco_habitos",
          d: "M38.164,29.549c.2.2.3.4.5.6a11.532,11.532,0,0,0,8.116,3.307A11.362,11.362,0,0,0,54.9,30.15c4.409-4.409,4.008-18.838,4.008-19.439a.862.862,0,0,0-.8-.8c-.6,0-15.13-.4-19.439,4.008a11.546,11.546,0,0,0-1.6,14.329c-.6.8-1.2,1.6-1.7,2.4a21.973,21.973,0,0,0-2.3,4.91,23.731,23.731,0,0,0-3.307-9.118,23.528,23.528,0,0,0-1.9-2.505,11.064,11.064,0,0,0,2-6.413,11.291,11.291,0,0,0-3.407-8.116C22.032,5,7.6,5.4,7,5.4a.862.862,0,0,0-.8.8c0,.6-.3,15.13,4.008,19.439a11.291,11.291,0,0,0,8.116,3.407,11.462,11.462,0,0,0,8.116-3.407,2.657,2.657,0,0,0,.5-.6l1.5,2.1a23.636,23.636,0,0,1,3.307,12.124v3.607c-6.112.3-11.223,4.008-14.529,7.315-.135.123-.4.4-.5.5A34.193,34.193,0,0,0,13.415,54.6a3.272,3.272,0,0,0-.3,3.307,3.17,3.17,0,0,0,2.806,1.7H49.186a3.118,3.118,0,0,0,2.505-5.01c-1.9-2.605-8.818-11.122-18.237-11.623a23.29,23.29,0,0,1,3.307-11.523A13.331,13.331,0,0,1,38.164,29.549Zm1.7-14.529C43.174,11.813,53.9,11.512,57.2,11.512h.1c0,3.006-.2,14.128-3.507,17.435a9.919,9.919,0,0,1-13.928,0c-.2-.2-.4-.5-.6-.7a17.078,17.078,0,0,1,1.9-1.9,22.347,22.347,0,0,1,6.313-3.908,1.207,1.207,0,0,0,.5-.5v-.6a.1.1,0,0,1-.1-.1.779.779,0,0,0-1-.3,27.736,27.736,0,0,0-6.814,4.208c-.6.5-1.2,1.1-1.8,1.7A9.9,9.9,0,0,1,39.868,15.019Zm-14.73,9.519a9.463,9.463,0,0,1-6.914,2.906,9.629,9.629,0,0,1-6.914-2.906C8,21.232,7.8,10.21,7.8,7.1c3.106,0,14.128.2,17.335,3.607a9.463,9.463,0,0,1,2.906,6.914,9.33,9.33,0,0,1-1.4,4.91c-.5-.6-1.1-1.1-1.6-1.6a27.736,27.736,0,0,0-6.814-4.208.639.639,0,0,0-.6,0c-.2,0-.3.1-.4.3a.1.1,0,0,0-.1.1v.1c-.1.1,0,.3,0,.4a1.207,1.207,0,0,0,.5.5,22.9,22.9,0,0,1,6.413,3.908,9.783,9.783,0,0,1,1.8,1.7A5.019,5.019,0,0,1,25.138,24.539ZM34.986,44.7l13.3,13.308H45.178L31.852,44.479h.7A11.7,11.7,0,0,1,34.986,44.7ZM16.32,53.6a16.638,16.638,0,0,1,1.3-1.4l5.912,5.912H20.829Zm2.3-2.505a17.417,17.417,0,0,1,1.5-1.3l8.317,8.317H25.552Zm2.705-2.3,1.8-1.2L33.555,58.106H30.536Zm3.106-2a17.054,17.054,0,0,1,1.9-.9L38.465,58.006H35.733Zm3.407-1.5a16.017,16.017,0,0,1,2.1-.5c.23.239,13.227,13.227,13.227,13.227H40.469C40.469,57.906,27.844,45.28,27.844,45.28ZM14.617,57.2a1.531,1.531,0,0,1,.1-1.6,5.507,5.507,0,0,1,.7-.9l3.307,3.307H16.02A1.6,1.6,0,0,1,14.617,57.2Zm35.872-1.6a1.546,1.546,0,0,1,.1,1.6,1.207,1.207,0,0,1-.5.5L37.864,45.481C42.974,47.384,47.483,51.593,50.489,55.6Z",
          transform: "translate(-2.195 -2.391)",
          fill: "#ee2b7b"
        }
      )
    ]
  }
), l4 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_14_icono_comunidad",
    "data-name": "14_icono_comunidad",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ r(
        "path",
        {
          id: "_14_icono_comunidad-2",
          "data-name": "14_icono_comunidad",
          d: "M50.027,25.9a5.438,5.438,0,1,0-5.438-5.438A5.5,5.5,0,0,0,50.027,25.9Zm0-1.313a4.126,4.126,0,1,1,4.126-4.126A4.162,4.162,0,0,1,50.027,24.585Zm0,1.969c-5.251,0-8.814,2.719-8.814,6.657v2.532a.7.7,0,0,0,.656.656.637.637,0,0,0,.656-.656V33.212c0-3.657,3.751-5.345,7.6-5.345s7.6,1.594,7.6,5.345v2.532a.637.637,0,0,0,.656.656.7.7,0,0,0,.656-.656V33.212C58.841,29.274,55.278,26.555,50.027,26.555ZM12.614,25.9A5.438,5.438,0,1,0,7.176,20.46,5.442,5.442,0,0,0,12.614,25.9Zm0-1.313A4.126,4.126,0,1,1,16.74,20.46,4.162,4.162,0,0,1,12.614,24.585Zm0,1.969c-5.251,0-8.814,2.719-8.814,6.657v2.532a.7.7,0,0,0,.656.656.637.637,0,0,0,.656-.656V33.212c0-3.657,3.751-5.345,7.6-5.345s7.6,1.594,7.6,5.345v2.532a.637.637,0,0,0,.656.656.7.7,0,0,0,.656-.656V33.212C21.428,29.274,17.771,26.555,12.614,26.555ZM31.086,12.583a5.442,5.442,0,0,0,5.438-5.438A5.423,5.423,0,0,0,31.086,1.8a5.5,5.5,0,0,0-5.438,5.438A5.363,5.363,0,0,0,31.086,12.583Zm0-9.377a4.126,4.126,0,1,1-4.126,4.126A4.226,4.226,0,0,1,31.086,3.207Zm0,10.127c-5.251,0-8.814,2.719-8.814,6.657v2.532a.7.7,0,0,0,.656.656.592.592,0,0,0,.656-.656V19.991c0-3.657,3.751-5.345,7.6-5.345s7.6,1.594,7.6,5.345v2.532a.637.637,0,0,0,.656.656.7.7,0,0,0,.656-.656V19.991C39.9,16.053,36.243,13.333,31.086,13.333Zm-6.751,25.6a6.751,6.751,0,1,0,6.751-6.751A6.845,6.845,0,0,0,24.335,38.932Zm6.751-5.251a5.345,5.345,0,1,1-5.345,5.345A5.342,5.342,0,0,1,31.086,33.681Zm0,13.221c-6.564,0-11.158,3.376-11.158,8.345v3.282a.8.8,0,0,0,.75.75.687.687,0,0,0,.75-.75V55.247c0-4.782,4.876-7.033,9.846-7.033s9.846,2.157,9.846,7.033v3.282a.732.732,0,0,0,.75.75.8.8,0,0,0,.75-.75V55.247C42.245,50.278,37.65,46.9,31.086,46.9Z",
          transform: "translate(-1.8 -0.801)",
          fill: "#ee2b7b"
        }
      )
    ]
  }
), d4 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_04_icono_conciencia",
    "data-name": "04_icono_conciencia",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ r(
        "path",
        {
          id: "_04_icono_conciencia-2",
          "data-name": "04_icono_conciencia",
          d: "M39.664,45.857a7.976,7.976,0,0,0,.265-1.327,12.423,12.423,0,0,1,.8-2.742,3.76,3.76,0,0,1,3.626-2.565c1.327,0,2.565-.088,3.891-.177l.8-.088a2.2,2.2,0,0,0,1.5-.707,2.118,2.118,0,0,0,.442-1.68,3.269,3.269,0,0,1,.884-3.007.427.427,0,0,0,.088-.619,1.508,1.508,0,0,1,.354-1.769.913.913,0,0,0,.177-1.061c-.177-.619-.265-1.15,0-1.5a1.705,1.705,0,0,1,1.238-.884c.177-.088.354-.088.531-.177.619-.354.707-.619.531-1.327a5.227,5.227,0,0,0-.531-1.238c-.088-.177-2.3-3.184-2.653-3.8a2.612,2.612,0,0,1-.354-2.388,4.905,4.905,0,0,0,.265-1.5,15.171,15.171,0,0,0-3.1-9.728,12.165,12.165,0,0,0-6.279-4.245,22.841,22.841,0,0,0-7.782-1.327,16.346,16.346,0,0,0-2.034.088l-.707.088.531.265a7.777,7.777,0,0,1,.884.531,17.033,17.033,0,0,1,7.075,10.082c.884,3.537.884,6.367-.177,9.021-.619,1.5-1.415,3.1-2.122,4.422a10.85,10.85,0,0,0-.973,2.034,4.312,4.312,0,0,0-.265.619,18.963,18.963,0,0,0-1.68,5.66c-.354,2.476,0,10.612,0,11.5h0a.772.772,0,0,1-.884.8.81.81,0,0,1-.884-.8V41.169l-9.463,3.184L23.569,46.3a.78.78,0,0,1-.8.8.889.889,0,0,1-.8-.884c0-.088.354-8.667,0-11.32a18.08,18.08,0,0,0-1.68-5.66,4.312,4.312,0,0,0-.265-.619c-.354-.8-.884-1.857-.973-2.034a25.457,25.457,0,0,1-2.122-4.422,13.576,13.576,0,0,1-.177-9.021A16.772,16.772,0,0,1,23.834,3.053c.265-.177.619-.354.884-.531l.531-.354L24.63,2.08A16.346,16.346,0,0,0,22.6,1.992a22.476,22.476,0,0,0-7.782,1.327A12.165,12.165,0,0,0,8.535,7.563a14.863,14.863,0,0,0-3.1,9.728,4.905,4.905,0,0,0,.265,1.5,2.9,2.9,0,0,1-.354,2.388c-.442.619-2.565,3.626-2.653,3.8a5.227,5.227,0,0,0-.531,1.238c-.177.707-.088.973.531,1.327a1.257,1.257,0,0,0,.531.177,1.971,1.971,0,0,1,1.238.884,2.192,2.192,0,0,1,0,1.5.941.941,0,0,0,.177,1.061A1.508,1.508,0,0,1,5,32.945a.524.524,0,0,0,.088.619,3.525,3.525,0,0,1,.884,3.007,2.217,2.217,0,0,0,.442,1.68,1.889,1.889,0,0,0,1.5.707l.8.088c1.327.088,2.653.177,3.891.177a3.392,3.392,0,0,1,3.449,2.388c.354.8,1.238,4.068,1.327,4.51,0,.088.088.531-.088.707a.927.927,0,0,1-1.15.088,1.113,1.113,0,0,1-.354-.619h0c-.265-1.061-.619-2.3-.884-3.361a4.622,4.622,0,0,0-.619-1.327,1.679,1.679,0,0,0-1.327-.707L7.827,40.55a4.057,4.057,0,0,1-2.742-1.327,3.966,3.966,0,0,1-.8-2.83,1.919,1.919,0,0,0-.531-1.857,1.643,1.643,0,0,1-.442-1.857.547.547,0,0,0-.177-.619A2.048,2.048,0,0,1,2.7,29.849a.962.962,0,0,0,.088-.442c-.088,0-.177-.088-.442-.177a3.066,3.066,0,0,1-1.769-1.5,3.213,3.213,0,0,1,.088-2.388,14.23,14.23,0,0,1,1.5-2.476l.8-1.061.088-.177c.265-.354.442-.619.707-.973a1.732,1.732,0,0,0,.354-1.68A5.7,5.7,0,0,1,3.847,17.2a16.97,16.97,0,0,1,1.5-7.34A13.631,13.631,0,0,1,11.9,2.876,23.722,23.722,0,0,1,22.508.4h.354c.884,0,1.857,0,2.742.088a25.362,25.362,0,0,1,2.742.442C29.317.754,30.2.577,31.174.488,32.059.4,33.032.4,33.916.4h.354A22.354,22.354,0,0,1,44.882,2.876a13.262,13.262,0,0,1,6.544,6.987,14.962,14.962,0,0,1,1.5,7.34,6.605,6.605,0,0,1-.265,1.769,1.692,1.692,0,0,0,.354,1.68l.8,1.061.088.088a6.75,6.75,0,0,1,.707.973,10.307,10.307,0,0,1,1.5,2.476,2.837,2.837,0,0,1,.088,2.388,3.005,3.005,0,0,1-1.857,1.5.968.968,0,0,0-.354.177h0v.088a.669.669,0,0,0,.088.354,1.9,1.9,0,0,1-.442,2.211.547.547,0,0,0-.177.619,1.643,1.643,0,0,1-.442,1.857,2.151,2.151,0,0,0-.531,1.857,3.294,3.294,0,0,1-.8,2.83,3.719,3.719,0,0,1-2.742,1.327l-5.129.354a1.679,1.679,0,0,0-1.327.707,5.286,5.286,0,0,0-.707,1.415c-.354,1.061-.531,2.3-.8,3.272h0s-.088.884-.707.884C39.664,47.183,39.4,46.741,39.664,45.857ZM23.657,40.285V42.85l9.463-3.184V37.013Zm0-4.333h0v2.565l9.551-3.272v-.088a2.2,2.2,0,0,1,.088-.8c.088-.531.177-1.061.265-1.5l.088-.265Zm-.531-3.8v.177c.088.531.265,1.15.354,1.769v.177l10.612-3.626v-.088c.265-.707.531-1.5.8-2.122l.177-.354Zm-1.5-4.157.088.177a17.718,17.718,0,0,1,.884,2.3l.088.177,13.531-4.6v-.088c.619-1.15,1.238-2.3,1.415-2.742l.177-.354Zm-1.857-3.714.088.177a13.313,13.313,0,0,1,.973,1.946l.088.088L38.6,20.917v-.088a9.263,9.263,0,0,0,.442-2.653V17.91ZM18,20.3v.177a11.087,11.087,0,0,0,.8,2.211l.088.177,20.252-6.544v-.177c0-.265-.088-.531-.088-.8a10.283,10.283,0,0,0-.354-1.592l-.088-.177Zm-.177-4.687V15.7a14.442,14.442,0,0,0-.088,2.742v.265l20.34-6.633V11.9a14.11,14.11,0,0,0-.884-2.034L37.1,9.774Zm1.5-5.041h0a19.365,19.365,0,0,0-1.061,2.918l-.088.265L36.127,8.182l-.177-.177a19.435,19.435,0,0,0-1.769-2.034V5.883ZM28.344,2.7A14.157,14.157,0,0,0,22.6,5.883a11.2,11.2,0,0,0-1.857,2.211l-.265.442L32.766,4.645l-.354-.177A11.638,11.638,0,0,0,28.433,2.7Z",
          transform: "translate(1.614 6.6)",
          fill: "#ee2b7b"
        }
      )
    ]
  }
), c4 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_07_icono_conexion",
    "data-name": "07_icono_conexion",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h("g", { id: "_07_icono_conexion-2", "data-name": "07_icono_conexion", transform: "translate(2 -0.4)", children: [
        /* @__PURE__ */ r("g", { id: "Grupo_16514", "data-name": "Grupo 16514", transform: "translate(5.223 14.4)", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40708",
            "data-name": "Trazado 40708",
            d: "M13.835,30.07a7.835,7.835,0,1,1,7.835-7.835A7.858,7.858,0,0,1,13.835,30.07Zm0-14.19a6.355,6.355,0,1,0,6.355,6.355A6.391,6.391,0,0,0,13.835,15.88Z",
            transform: "translate(-6 -14.4)",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16515", "data-name": "Grupo 16515", transform: "translate(0 31.549)", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40709",
            "data-name": "Trazado 40709",
            d: "M25.332,48.551a.78.78,0,0,1-.783-.783v-3.83c0-5.746-5.833-8.27-11.491-8.27-5.746,0-11.491,2.525-11.491,8.27v3.83a.783.783,0,0,1-1.567,0v-3.83C0,38.1,5.223,34.1,13.058,34.1s13.058,3.917,13.058,9.837v3.83A.78.78,0,0,1,25.332,48.551Z",
            transform: "translate(0 -34.1)",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16516", "data-name": "Grupo 16516", transform: "translate(35.692 14.4)", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40710",
            "data-name": "Trazado 40710",
            d: "M48.835,30.07a7.835,7.835,0,1,1,7.835-7.835A7.858,7.858,0,0,1,48.835,30.07Zm0-14.19a6.355,6.355,0,1,0,6.355,6.355A6.391,6.391,0,0,0,48.835,15.88Z",
            transform: "translate(-41 -14.4)",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16517", "data-name": "Grupo 16517", transform: "translate(30.469 31.549)", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40711",
            "data-name": "Trazado 40711",
            d: "M60.332,48.551a.78.78,0,0,1-.783-.783v-3.83c0-5.746-5.833-8.27-11.491-8.27-5.745,0-11.491,2.525-11.491,8.27v3.83a.783.783,0,1,1-1.567,0v-3.83C35,38.1,40.223,34.1,48.058,34.1s13.058,3.917,13.058,9.837v3.83A.78.78,0,0,1,60.332,48.551Z",
            transform: "translate(-35 -34.1)",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16518", "data-name": "Grupo 16518", transform: "translate(27.357 15.38)", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40712",
            "data-name": "Trazado 40712",
            d: "M32.187,32.653a.657.657,0,0,1-.609-.348.723.723,0,0,1,.174-1.045,8.992,8.992,0,0,0,3.83-7.138A8.709,8.709,0,0,0,32.1,16.9a.749.749,0,1,1,.871-1.219,10.469,10.469,0,0,1,4.091,8.444,10.349,10.349,0,0,1-4.44,8.27A.8.8,0,0,1,32.187,32.653Z",
            transform: "translate(-31.426 -15.526)",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16519", "data-name": "Grupo 16519", transform: "translate(25.006 18.862)", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40713",
            "data-name": "Trazado 40713",
            d: "M29.487,29.514a.657.657,0,0,1-.609-.348.723.723,0,0,1,.174-1.045,4.386,4.386,0,0,0,1.915-3.569A4.62,4.62,0,0,0,29.226,20.9a.749.749,0,1,1,.871-1.219,6.008,6.008,0,0,1-.174,9.663A.563.563,0,0,1,29.487,29.514Z",
            transform: "translate(-28.726 -19.526)",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16520", "data-name": "Grupo 16520", transform: "translate(22.83 21.735)", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40714",
            "data-name": "Trazado 40714",
            d: "M26.987,27.156a.657.657,0,0,1-.609-.348.723.723,0,0,1,.174-1.045.914.914,0,0,0,.435-.783,1.3,1.3,0,0,0-.348-.783.749.749,0,0,1,.871-1.219,2.476,2.476,0,0,1,.958,2,2.7,2.7,0,0,1-1.045,2A.665.665,0,0,1,26.987,27.156Z",
            transform: "translate(-26.226 -22.826)",
            fill: "#ee2b7b"
          }
        ) })
      ] })
    ]
  }
), u4 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_12_icono_conexion_mundo",
    "data-name": "12_icono_conexion_mundo",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_12_icono_conexion_mundo-2",
          "data-name": "12_icono_conexion_mundo",
          transform: "translate(-3 -2.6)",
          children: [
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40764",
                "data-name": "Trazado 40764",
                d: "M12.627,34.6H6.816A.877.877,0,0,0,6,35.416a.8.8,0,0,0,.816.816h5.812a1.131,1.131,0,0,1,1.122,1.122v20.6a1.131,1.131,0,0,1-1.122,1.122H6.816A.877.877,0,0,0,6,59.886a.8.8,0,0,0,.816.816h5.812a2.677,2.677,0,0,0,2.753-2.753v-20.6A2.741,2.741,0,0,0,12.627,34.6Z",
                transform: "translate(0 0.587)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40765",
                "data-name": "Trazado 40765",
                d: "M18.069,39.266a.8.8,0,0,0,.816.816h7.545l7.545,5.4c.2.1.306.2.51.2h7.239a.877.877,0,0,1,.816.816v.612a.8.8,0,0,0,.816.816.79.79,0,0,0,.816-.714v-.612a2.524,2.524,0,0,0-2.549-2.549H34.688l-7.545-5.4c-.2-.1-.306-.2-.51-.2H20.821a.1.1,0,0,0-.1-.1,19.584,19.584,0,0,1-4.486-12.439,27.661,27.661,0,0,1,.408-4.18A9.933,9.933,0,0,0,19.6,24.584a11.106,11.106,0,0,0,2.651,1.223c.816.306.816.306.816.918,0,3.059.714,3.874,1.631,4.588.408.306.612.408.612,1.325v3.976a.8.8,0,0,0,.816.816.877.877,0,0,0,.816-.816V32.638a3,3,0,0,0-1.223-2.651c-.51-.408-1.02-.816-1.02-3.263a2.268,2.268,0,0,0-1.937-2.549,9.471,9.471,0,0,1-2.141-1.02,9.38,9.38,0,0,1-3.263-3.772A19.681,19.681,0,0,1,28.06,7.965c2.039,1.631,4.078,3.772,4.078,4.69,0,2.141-2.549,3.365-5,3.365-1.223,0-2.651,0-3.569,1.02a3.177,3.177,0,0,0-.612,2.447c.2,2.957,3.874,4.69,11.623,5.812,2.957.408,3.467,1.529,3.467,3.67,0,1.325-1.427,2.345-2.549,3.059-.612.51-1.122.816-1.325,1.223A5.589,5.589,0,0,1,31.425,35.8a10.746,10.746,0,0,1-1.122.714A.82.82,0,0,0,30,37.634a.77.77,0,0,0,.714.408.53.53,0,0,0,.408-.2c.306-.2.714-.408,1.02-.612A7.4,7.4,0,0,0,35.5,33.964a8.273,8.273,0,0,1,.816-.612c1.325-.816,3.365-2.141,3.365-4.384,0-2.753-.816-4.69-4.894-5.3-6.627-.918-9.992-2.345-10.2-4.282a1.4,1.4,0,0,1,.2-1.223c.408-.408,1.529-.408,2.345-.408,3.874,0,6.729-2.141,6.729-5.1,0-1.733-2.345-4.078-3.874-5.4a20.145,20.145,0,0,1,5.608-.816,18.346,18.346,0,0,1,6.729,1.223c-1.02,1.223-1.937,3.263-.408,4.69a5.34,5.34,0,0,0,3.67,1.223,18.9,18.9,0,0,0,4.384-.714,22.029,22.029,0,0,1,2.957,4.384,19.563,19.563,0,0,0-5.71-.918,4.371,4.371,0,0,0-3.772,1.529,3.372,3.372,0,0,0-.51,2.957c.612,2.039,2.447,2.651,3.874,3.161,1.733.612,2.651,1.02,2.855,2.549a4.079,4.079,0,0,1-1.02,2.447c-1.02,1.529-2.243,3.365-1.427,6.117a4.272,4.272,0,0,0,3.365,2.855,19.076,19.076,0,0,1-5.1,4.384.82.82,0,0,0-.306,1.122.683.683,0,0,0,.714.408c.2,0,.306,0,.306-.1a21.186,21.186,0,0,0,10.3-18.047,20.426,20.426,0,0,0-1.223-7.035,1.449,1.449,0,0,0-.2-.612,21,21,0,1,0-36.4,20.188C18.374,38.654,18.069,38.96,18.069,39.266ZM43.15,11.329c-.816-.918.612-2.549.816-2.855a21.037,21.037,0,0,1,4.69,3.161C47.127,12.145,44.374,12.655,43.15,11.329Zm8.564,25.184c-.612-.1-2.447-.408-2.855-1.835-.612-1.937.306-3.263,1.223-4.69a5.935,5.935,0,0,0,1.325-3.569c-.306-2.753-2.345-3.365-3.976-3.976-1.529-.51-2.447-.918-2.753-2.039a1.52,1.52,0,0,1,.2-1.427,3.2,3.2,0,0,1,2.447-.816,16.085,16.085,0,0,1,6.525,1.325,18.745,18.745,0,0,1,1.122,6.321A19.486,19.486,0,0,1,51.715,36.513Z",
                transform: "translate(0.166)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40766",
                "data-name": "Trazado 40766",
                d: "M59.72,44.241A3.648,3.648,0,0,0,56.356,42.1a10.307,10.307,0,0,0-5,1.835l-7.137,3.976c-4.384,1.02-15.09,0-15.192,0a.822.822,0,0,0-.2,1.631c.408.1,11.215,1.122,15.8,0,.1,0,.1-.1.2-.1l7.239-4.078a9.733,9.733,0,0,1,4.078-1.529,2.09,2.09,0,0,1,1.835,1.122,1.333,1.333,0,0,1-.408,1.529,7.237,7.237,0,0,1-1.427,1.02l-.2.1c-1.631,1.02-3.263,2.141-4.792,3.263A28.872,28.872,0,0,1,48.3,52.908c-3.772,2.549-9.788,5.1-16.721,2.651a28.047,28.047,0,0,1-3.059-1.427c-.918-.408-1.835-.918-2.855-1.325a21.232,21.232,0,0,0-7.851-1.631A.877.877,0,0,0,17,51.99a.8.8,0,0,0,.816.816,20.077,20.077,0,0,1,7.239,1.529,15.375,15.375,0,0,1,2.651,1.223,31.5,31.5,0,0,0,3.263,1.427,18.5,18.5,0,0,0,6.219,1.02,20.4,20.4,0,0,0,11.827-3.67c1.02-.612,2.651-1.733,3.569-2.447a43.861,43.861,0,0,1,4.588-2.957,7.21,7.21,0,0,0,1.835-1.223A3.7,3.7,0,0,0,59.72,44.241Z",
                transform: "translate(0.215 0.734)",
                fill: "#ee2b7b"
              }
            )
          ]
        }
      )
    ]
  }
), h4 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_06_icono_confianza",
    "data-name": "06_icono_confianza",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ r(
        "path",
        {
          id: "_06_icono_confianza-2",
          "data-name": "06_icono_confianza",
          d: "M58.236,45.892l-7.622-7.622a17.889,17.889,0,0,0-2.635-7.528A10.95,10.95,0,0,0,49.391,25.1V22.272l8.751-8.751a.8.8,0,1,0-1.129-1.129l-8.94,8.94a.671.671,0,0,0-.282.565v3.2a10.515,10.515,0,0,1-.847,4.14c-.471-.659-1.035-1.223-1.6-1.882l-7.9-7.9c-.188-.188-.376-.282-.471-.376l-3.388-3.388c-.376-.376-.753-.659-1.129-1.035a17.349,17.349,0,0,1,6.3-1.976c.188-.094.376-.094.565-.282L46.1,5.616a.859.859,0,0,0,0-1.129.859.859,0,0,0-1.129,0L38.475,10.98a18.559,18.559,0,0,0-7.622,2.635,11.482,11.482,0,0,0-5.834-1.506H22.2L14.573,4.487a.859.859,0,0,0-1.129,0,.859.859,0,0,0,0,1.129l7.9,7.81a.671.671,0,0,0,.565.282h3.2a10.321,10.321,0,0,1,7.34,3.011L34.429,18.7a3.692,3.692,0,0,0-1.317.753l-.188.188a2.589,2.589,0,0,0-.753,1.412l-1.506-1.506a3.012,3.012,0,0,0-4.329,0l-.188.188a3.457,3.457,0,0,0-.847,1.506,3.019,3.019,0,0,0-3.482.565l-.188.188a3.019,3.019,0,0,0-.565,3.482,3.261,3.261,0,0,0-1.506.753l-.188.188a2.725,2.725,0,0,0-.941,2.164,3.063,3.063,0,0,0,.941,2.164l5.834,5.834a3.692,3.692,0,0,0-1.317.753l-.188.188a2.683,2.683,0,0,0-.753,1.317L17.3,33.094a17.182,17.182,0,0,1-4.8-10.163c-.094-.188-.094-.376-.282-.565l-7.81-7.81a.859.859,0,0,0-1.129,0,.859.859,0,0,0,0,1.129L10.9,23.307a20.184,20.184,0,0,0,2.635,7.622,11.018,11.018,0,0,0-1.6,5.928v2.823L3.187,48.432a.859.859,0,0,0,0,1.129.671.671,0,0,0,.565.282c.188,0,.376-.094.659-.376l8.94-8.94a.671.671,0,0,0,.282-.565V36.858a11.164,11.164,0,0,1,.941-4.329c.471.565.941,1.129,1.506,1.694l7.528,7.528.094.094,4.14,4.14a11.92,11.92,0,0,0,1.223,1.035,19.023,19.023,0,0,1-6.4,2.07c-.188.094-.376.094-.565.282l-6.775,6.775a.859.859,0,0,0,0,1.129.671.671,0,0,0,.565.282.815.815,0,0,0,.659-.376l6.493-6.493a18.559,18.559,0,0,0,7.622-2.635,12.433,12.433,0,0,0,5.74,1.506h2.823l7.622,7.622a.671.671,0,0,0,.565.282.517.517,0,0,0,.471-.282.859.859,0,0,0,0-1.129l-7.716-7.81a.671.671,0,0,0-.565-.282H36.5a10.321,10.321,0,0,1-7.34-3.011l-4.14-4.14a1.608,1.608,0,0,1,.188-2.353,1.364,1.364,0,0,1,1.976,0l4.235,4.14a.671.671,0,0,0,.565.282.813.813,0,0,0,.565-.282.859.859,0,0,0,0-1.129L20.6,29.612a1.973,1.973,0,0,1-.376-1.035,1.415,1.415,0,0,1,.376-1.035l.188-.188a1.283,1.283,0,0,1,1.694-.188l8.846,8.751a.671.671,0,0,0,.565.282.68.68,0,0,0,.565-.376.859.859,0,0,0,0-1.129l-9.6-9.6a1.364,1.364,0,0,1,0-1.976l.188-.188a1.364,1.364,0,0,1,1.976,0l1.035,1.035.094.094h0l8.469,8.469A.8.8,0,0,0,35.746,31.4l-8.469-8.469a1.364,1.364,0,0,1,0-1.976l.188-.188a1.364,1.364,0,0,1,1.976,0l8.469,8.469a.671.671,0,0,0,.565.282.71.71,0,0,0,.659-.376.859.859,0,0,0,0-1.129L33.77,22.648a1.625,1.625,0,0,1,.282-1.788,1.552,1.552,0,0,1,2.258-.188l7.9,7.9a17.78,17.78,0,0,1,2.164,2.635.092.092,0,0,0,.094.094,17.368,17.368,0,0,1,2.635,7.434c.094.188.094.376.282.565l7.81,7.81a.671.671,0,0,0,.565.282.585.585,0,0,0,.565-.376A1,1,0,0,0,58.236,45.892Z",
          transform: "translate(-0.975 -1.275)",
          fill: "#ee2b7b"
        }
      )
    ]
  }
), m4 = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_03_Icono_consolidacion_financiera",
    "data-name": "03_Icono_consolidacion_financiera",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_03_Icono_consolidacion_financiera-2",
          "data-name": "03_Icono_consolidacion_financiera",
          transform: "translate(3.645 -0.34)",
          children: [
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41046",
                "data-name": "Trazado 41046",
                d: "M48.12,20.345a6.683,6.683,0,0,0-8.862,3.279,6.885,6.885,0,0,0-.178,5.14,6.777,6.777,0,0,0,3.457,3.722,6.3,6.3,0,0,0,2.836.62,6.669,6.669,0,0,0,2.3-.443A6.777,6.777,0,0,0,51.4,29.207,6.683,6.683,0,0,0,48.12,20.345Zm2.134,8.235a4.908,4.908,0,0,1-3.039,2.854,5.383,5.383,0,0,1-4.144-.184,4.908,4.908,0,0,1-2.854-3.039,5.383,5.383,0,0,1,.184-4.144,5.518,5.518,0,0,1,7.181-2.67A5.32,5.32,0,0,1,50.253,28.58Zm-4.074-2.569V23.682a.717.717,0,0,0-1.434,0v2.6a1.272,1.272,0,0,0,.179.537L46.717,28.7a.774.774,0,0,0,.537.269.657.657,0,0,0,.537-.179.816.816,0,0,0,0-1.075Z",
                transform: "translate(-1.307 -0.645)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41047",
                "data-name": "Trazado 41047",
                d: "M18.9,36.344a7.72,7.72,0,1,0,7.72-7.72A7.742,7.742,0,0,0,18.9,36.344Zm7.72-6.079a6.079,6.079,0,1,1-6.079,6.079A6.054,6.054,0,0,1,26.619,30.264Z",
                transform: "translate(-0.615 -0.956)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41048",
                "data-name": "Trazado 41048",
                d: "M26.437,46.024c-7.527,0-12.738,3.86-12.738,9.553v3.763a.83.83,0,0,0,.772.772.761.761,0,0,0,.772-.772V55.577c0-5.5,5.6-8.009,11.194-8.009S37.63,50.077,37.63,55.577v3.763a.761.761,0,0,0,.772.772.83.83,0,0,0,.772-.772V55.577C39.174,49.98,33.963,46.024,26.437,46.024Z",
                transform: "translate(-0.432 -1.566)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41049",
                "data-name": "Trazado 41049",
                d: "M4.562,35.95c-.161,0-.216-.023-.234-.04a.893.893,0,0,1-.353-.437L1.355,25.66a1.285,1.285,0,0,1,.083-.545l2.524-3.881a.828.828,0,0,1,.411-.322l6.2-1.643a.631.631,0,0,1,.151-.018.572.572,0,0,1,.583.453l3.416,12.883a.649.649,0,0,1-.078.493.532.532,0,0,1-.356.241C11.689,34.029,4.962,35.86,4.562,35.95Zm.6-13.991.75,2.677a.66.66,0,0,1-.08.5.54.54,0,0,1-.364.245l-2.788.751,2.288,8.338L13.4,32.276,10.222,20.658ZM2.508,25.241,5,24.686,4.38,22.472Z",
                transform: "translate(0 -0.627)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ h("g", { id: "Grupo_16721", "data-name": "Grupo 16721", transform: "translate(16.25 1.34)", children: [
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41050",
                  "data-name": "Trazado 41050",
                  d: "M19.455,10.937a.6.6,0,0,0-.6-.584c-.467-.006-.949,0-1.474,0a.6.6,0,0,0-.107,1.2,1.3,1.3,0,0,0,.279.031h.228l.6,0c.164,0,.333,0,.5-.006A.6.6,0,0,0,19.455,10.937Z",
                  transform: "translate(-16.791 -1.656)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41051",
                  "data-name": "Trazado 41051",
                  d: "M35.224,10.393c-.161,0-.315,0-.474,0l-.419,0c-.152,0-.3,0-.457,0a.622.622,0,0,0-.672.6.6.6,0,0,0,.163.437.672.672,0,0,0,.491.2q.4.006.8.006l.566,0a.608.608,0,0,0,.645-.616A.614.614,0,0,0,35.224,10.393Z",
                  transform: "translate(-17.366 -1.657)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41052",
                  "data-name": "Trazado 41052",
                  d: "M31.876,6.9a.607.607,0,0,0,.167.024.658.658,0,0,0,.445-.183c.226-.215.448-.436.67-.658l.339-.341a.674.674,0,0,0,.19-.436l0-.036a.59.59,0,0,0-.361-.518.611.611,0,0,0-.7.134q-.5.491-.987.985a.588.588,0,0,0-.178.583A.606.606,0,0,0,31.876,6.9Z",
                  transform: "translate(-17.304 -1.458)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41053",
                  "data-name": "Trazado 41053",
                  d: "M19.548,6.56l.126.127a.63.63,0,0,0,.452.2l.037,0a.607.607,0,0,0,.4-1.042c-.341-.346-.675-.685-1.017-1.018a.616.616,0,0,0-.439-.187.6.6,0,0,0-.424.191.59.59,0,0,0,.01.856C18.972,5.981,19.259,6.272,19.548,6.56Z",
                  transform: "translate(-16.851 -1.456)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41054",
                  "data-name": "Trazado 41054",
                  d: "M25.775,3.176v.179a.63.63,0,0,0,.176.463l.027.025a.607.607,0,0,0,1.017-.457c0-.486.007-.962,0-1.439a.619.619,0,0,0-.178-.443.6.6,0,0,0-.434-.165.59.59,0,0,0-.6.612C25.777,2.36,25.775,2.768,25.775,3.176Z",
                  transform: "translate(-17.106 -1.34)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41055",
                  "data-name": "Trazado 41055",
                  d: "M20.112,14.675a.563.563,0,0,0-.447.186l-.114.109c-.068.065-.135.129-.2.195l-.16.158c-.181.179-.363.357-.537.541a.6.6,0,0,0-.012.858.617.617,0,0,0,.442.185.564.564,0,0,0,.395-.154c.326-.314.671-.657,1.086-1.081a.57.57,0,0,0,.085-.67A.586.586,0,0,0,20.112,14.675Z",
                  transform: "translate(-16.85 -1.807)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41056",
                  "data-name": "Trazado 41056",
                  d: "M33.23,15.236,32.9,14.9a.651.651,0,0,0-.454-.2l0,.082h0l-.026-.081a.6.6,0,0,0-.516.345.58.58,0,0,0,.105.678c.3.309.654.673,1.012,1.023a.65.65,0,0,0,.458.2.613.613,0,0,0,.6-.594.67.67,0,0,0-.2-.473C33.66,15.663,33.446,15.45,33.23,15.236Z",
                  transform: "translate(-17.318 -1.808)",
                  fill: "#ee2b7b"
                }
              )
            ] }),
            /* @__PURE__ */ h("g", { id: "Grupo_16722", "data-name": "Grupo 16722", transform: "translate(20.066 5.392)", children: [
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41057",
                  "data-name": "Trazado 41057",
                  d: "M29.673,6.9a5.215,5.215,0,0,0-3.646-1.362l-.561,0A5.316,5.316,0,0,0,22,14.26a4.9,4.9,0,0,1,1.1,3.133.638.638,0,0,0,.646.645h4.975a.634.634,0,0,0,.418-.168.51.51,0,0,0,.108-.512,5.356,5.356,0,0,1,1.1-3.217,5.255,5.255,0,0,0,1.115-3.281A5.383,5.383,0,0,0,29.673,6.9Zm-2.61,8.071-.2-.021a.607.607,0,0,0-.581.507l-.09.791-.117-.7a.666.666,0,0,0-.565-.475l-.131,0-.038.01a.7.7,0,0,0-.43.334.445.445,0,0,0-.048.337l.2,1.124h-.826a5.624,5.624,0,0,0-1.329-3.294,4.273,4.273,0,0,1-.911-3.119,4.136,4.136,0,0,1,3.621-3.685h.533A3.963,3.963,0,0,1,28.874,7.8a4.38,4.38,0,0,1,1.367,3.116,4.1,4.1,0,0,1-.852,2.536l0,0a6.478,6.478,0,0,0-1.266,3.409h-.827l.2-1.172A.6.6,0,0,0,27.063,14.972Z",
                  transform: "translate(-20.745 -5.539)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41058",
                  "data-name": "Trazado 41058",
                  d: "M28.825,18.512H23.862a.544.544,0,0,0-.581.581.568.568,0,0,0,.581.58h.221a.536.536,0,0,0-.358.542.569.569,0,0,0,.581.581H24.6a.509.509,0,0,0-.243.289.568.568,0,0,0,.05.42l.061.122a2,2,0,0,0,1.749,1.06h.3a2.067,2.067,0,0,0,1.8-1.138l.024-.073c.086-.442-.052-.612-.2-.68h.255a.568.568,0,0,0,.58-.581.558.558,0,0,0-.37-.542h.234a.58.58,0,1,0,0-1.16ZM27.3,21.053a.944.944,0,0,1-.79.532h-.3a.874.874,0,0,1-.79-.472l-.059-.12a.557.557,0,0,0-.173-.2h2.455A.572.572,0,0,0,27.3,21.053Z",
                  transform: "translate(-20.834 -5.994)",
                  fill: "#ee2b7b"
                }
              )
            ] })
          ]
        }
      )
    ]
  }
), f4 = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_05_consulta_certificados",
    "data-name": "05_consulta_certificados",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_05_consulta_certificados-2",
          "data-name": "05_consulta_certificados",
          transform: "translate(3.023 3.446)",
          children: [
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41332",
                "data-name": "Trazado 41332",
                d: "M25.276,43.828a19.319,19.319,0,0,1-13.513-5.564A19.025,19.025,0,0,1,25.276,5.779a19.317,19.317,0,0,1,13.513,5.564,18.963,18.963,0,0,1,5.562,13.511,19.318,19.318,0,0,1-5.565,13.513A18.6,18.6,0,0,1,25.276,43.828Zm0-36.7a17.538,17.538,0,1,0,12.489,5.137A17.891,17.891,0,0,0,25.276,7.128Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41333",
                "data-name": "Trazado 41333",
                d: "M48.076,53.228a5.442,5.442,0,0,1-3.911-1.664L38.1,45.495l-.084.052a24.343,24.343,0,1,1,7.958-7.96l-.052.085,6.069,6.07a5.429,5.429,0,0,1,0,7.822A5.33,5.33,0,0,1,48.076,53.228Zm-9.9-9.25a1.339,1.339,0,0,1,.544.187l6.467,6.478a4.191,4.191,0,0,0,5.877-5.977l-6.5-6.4a.646.646,0,0,1-.084-.842A22.965,22.965,0,1,0,25.273,47.869h0a22.674,22.674,0,0,0,12.47-3.711A.459.459,0,0,1,38.177,43.978Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41334",
                "data-name": "Trazado 41334",
                d: "M17.731,35.917a1.6,1.6,0,0,1-1.6-1.6V16.387a1.6,1.6,0,0,1,1.6-1.6H32.516a1.45,1.45,0,0,1,1.06.442,1.65,1.65,0,0,1,.442,1.061V34.225a1.45,1.45,0,0,1-.442,1.06,1.643,1.643,0,0,1-1.06.442Zm0-19.745a.211.211,0,0,0-.215.215V34.32a.21.21,0,0,0,.215.214H32.516a.21.21,0,0,0,.215-.214V16.387a.211.211,0,0,0-.215-.215H17.732Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41335",
                "data-name": "Trazado 41335",
                d: "M22.416,18.772a.644.644,0,1,1,0-1.288h5.533a.644.644,0,0,1,0,1.288Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41336",
                "data-name": "Trazado 41336",
                d: "M23.588,26.812a.629.629,0,0,1,0-1.258h6.769a.629.629,0,0,1,0,1.258Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41337",
                "data-name": "Trazado 41337",
                d: "M23.588,22.224a.629.629,0,0,1,0-1.258h6.769a.629.629,0,0,1,0,1.258Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41338",
                "data-name": "Trazado 41338",
                d: "M23.588,31.844a.629.629,0,0,1,0-1.258h6.769a.629.629,0,0,1,0,1.258Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41339",
                "data-name": "Trazado 41339",
                d: "M19.655,27.777a.8.8,0,0,1-.334-.285l-.344-.688a.56.56,0,0,1-.017-.451.652.652,0,0,1,.313-.35.7.7,0,0,1,.312-.075.531.531,0,0,1,.49.284l.059.118.878-.683a.6.6,0,0,1,.36-.127.467.467,0,0,1,.424.262.6.6,0,0,1,.126.491.464.464,0,0,1-.25.311L20.2,27.624c-.088.148-.191.153-.368.153h-.173Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41340",
                "data-name": "Trazado 41340",
                d: "M19.74,32.421a.8.8,0,0,1-.334-.285l-.344-.688a.614.614,0,0,1,.3-.8.708.708,0,0,1,.312-.074.53.53,0,0,1,.49.285l.058.118.878-.683a.6.6,0,0,1,.36-.128.465.465,0,0,1,.424.263.6.6,0,0,1,.126.49.466.466,0,0,1-.25.312l-1.476,1.04a.467.467,0,0,1-.368.153Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41341",
                "data-name": "Trazado 41341",
                d: "M19.655,23.134a.8.8,0,0,1-.334-.284l-.344-.689a.615.615,0,0,1,.3-.8.7.7,0,0,1,.312-.074.53.53,0,0,1,.49.284l.059.118L21.012,21a.6.6,0,0,1,.36-.127.467.467,0,0,1,.424.262.6.6,0,0,1,.126.491.464.464,0,0,1-.25.311L20.193,23.07c-.066.064-.225.064-.365.064h-.173Z",
                fill: "#ee2b7b"
              }
            )
          ]
        }
      )
    ]
  }
), p4 = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_14_consulta_estado_solicitud",
    "data-name": "14_consulta_estado_solicitud",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_14_consulta_estado_solicitud-2",
          "data-name": "14_consulta_estado_solicitud",
          transform: "translate(0.3 -0.5)",
          children: [
            /* @__PURE__ */ h("g", { id: "Grupo_16591", "data-name": "Grupo 16591", transform: "translate(1.7 11.5)", children: [
              /* @__PURE__ */ r("g", { id: "Grupo_16586", "data-name": "Grupo 16586", transform: "translate(11.076 23.053)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40868",
                  "data-name": "Trazado 40868",
                  d: "M24.356,38.541H14.72a.71.71,0,0,1-.72-.72.663.663,0,0,1,.72-.72h9.635a.72.72,0,0,1,0,1.441Z",
                  transform: "translate(-14 -37.1)",
                  fill: "#ee2b7b"
                }
              ) }),
              /* @__PURE__ */ r("g", { id: "Grupo_16587", "data-name": "Grupo 16587", transform: "translate(11.076 30.617)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40869",
                  "data-name": "Trazado 40869",
                  d: "M24.536,46.941H14.72a.71.71,0,0,1-.72-.72.663.663,0,0,1,.72-.72h9.816a.72.72,0,0,1,0,1.441Z",
                  transform: "translate(-14 -45.5)",
                  fill: "#ee2b7b"
                }
              ) }),
              /* @__PURE__ */ r("g", { id: "Grupo_16588", "data-name": "Grupo 16588", transform: "translate(5.763 21.792)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40870",
                  "data-name": "Trazado 40870",
                  d: "M10.081,39.662a1.981,1.981,0,1,1,1.981-1.981A2,2,0,0,1,10.081,39.662Zm0-2.521a.519.519,0,0,0-.54.54.581.581,0,0,0,.54.54.519.519,0,0,0,.54-.54A.581.581,0,0,0,10.081,37.141Z",
                  transform: "translate(-8.1 -35.7)",
                  fill: "#ee2b7b"
                }
              ) }),
              /* @__PURE__ */ r("g", { id: "Grupo_16589", "data-name": "Grupo 16589", transform: "translate(5.763 29.357)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40871",
                  "data-name": "Trazado 40871",
                  d: "M10.081,48.062a1.981,1.981,0,1,1,1.981-1.981A2.061,2.061,0,0,1,10.081,48.062Zm0-2.521a.519.519,0,0,0-.54.54.6.6,0,0,0,.54.63.519.519,0,0,0,.54-.54C10.621,45.9,10.351,45.541,10.081,45.541Z",
                  transform: "translate(-8.1 -44.1)",
                  fill: "#ee2b7b"
                }
              ) }),
              /* @__PURE__ */ r("g", { id: "Grupo_16590", "data-name": "Grupo 16590", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40872",
                  "data-name": "Trazado 40872",
                  d: "M26.464,49.321H5.3a3.613,3.613,0,0,1-3.6-3.6V15.1a3.613,3.613,0,0,1,3.6-3.6H26.554a3.613,3.613,0,0,1,3.6,3.6V45.719A3.633,3.633,0,0,1,26.464,49.321ZM5.3,12.851A2.229,2.229,0,0,0,3.051,15.1V45.719A2.229,2.229,0,0,0,5.3,47.971H26.554a2.229,2.229,0,0,0,2.251-2.251V15.1a2.229,2.229,0,0,0-2.251-2.251Z",
                  transform: "translate(-1.7 -11.5)",
                  fill: "#ee2b7b"
                }
              ) })
            ] }),
            /* @__PURE__ */ h("g", { id: "Grupo_16597", "data-name": "Grupo 16597", transform: "translate(28.805 11.5)", children: [
              /* @__PURE__ */ r("g", { id: "Grupo_16592", "data-name": "Grupo 16592", transform: "translate(10.536 23.053)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40873",
                  "data-name": "Trazado 40873",
                  d: "M53.856,38.541H44.22a.71.71,0,0,1-.72-.72.663.663,0,0,1,.72-.72h9.635a.72.72,0,0,1,0,1.441Z",
                  transform: "translate(-43.5 -37.1)",
                  fill: "#ee2b7b"
                }
              ) }),
              /* @__PURE__ */ r("g", { id: "Grupo_16593", "data-name": "Grupo 16593", transform: "translate(10.536 30.617)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40874",
                  "data-name": "Trazado 40874",
                  d: "M54.036,46.941H44.22a.71.71,0,0,1-.72-.72.663.663,0,0,1,.72-.72h9.816a.72.72,0,0,1,0,1.441Z",
                  transform: "translate(-43.5 -45.5)",
                  fill: "#ee2b7b"
                }
              ) }),
              /* @__PURE__ */ r("g", { id: "Grupo_16594", "data-name": "Grupo 16594", transform: "translate(5.223 21.792)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40875",
                  "data-name": "Trazado 40875",
                  d: "M39.581,39.662a1.981,1.981,0,1,1,1.981-1.981A2.061,2.061,0,0,1,39.581,39.662Zm0-2.521a.519.519,0,0,0-.54.54.54.54,0,1,0,.54-.54Z",
                  transform: "translate(-37.6 -35.7)",
                  fill: "#ee2b7b"
                }
              ) }),
              /* @__PURE__ */ r("g", { id: "Grupo_16595", "data-name": "Grupo 16595", transform: "translate(5.223 29.357)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40876",
                  "data-name": "Trazado 40876",
                  d: "M39.581,48.062a1.981,1.981,0,1,1,1.981-1.981A2.129,2.129,0,0,1,39.581,48.062Zm0-2.521a.519.519,0,0,0-.54.54.54.54,0,1,0,.54-.54Z",
                  transform: "translate(-37.6 -44.1)",
                  fill: "#ee2b7b"
                }
              ) }),
              /* @__PURE__ */ r("g", { id: "Grupo_16596", "data-name": "Grupo 16596", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40877",
                  "data-name": "Trazado 40877",
                  d: "M56.564,49.321H35.4a3.613,3.613,0,0,1-3.6-3.6V15.1a3.613,3.613,0,0,1,3.6-3.6H56.654a3.613,3.613,0,0,1,3.6,3.6V45.719A3.752,3.752,0,0,1,56.564,49.321ZM35.4,12.851A2.229,2.229,0,0,0,33.151,15.1V45.719A2.229,2.229,0,0,0,35.4,47.971H56.654a2.229,2.229,0,0,0,2.251-2.251V15.1a2.229,2.229,0,0,0-2.251-2.251Z",
                  transform: "translate(-31.8 -11.5)",
                  fill: "#ee2b7b"
                }
              ) })
            ] }),
            /* @__PURE__ */ h("g", { id: "Grupo_16600", "data-name": "Grupo 16600", transform: "translate(9.805 17.714)", children: [
              /* @__PURE__ */ r("g", { id: "Grupo_16598", "data-name": "Grupo 16598", transform: "translate(0 0)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40878",
                  "data-name": "Trazado 40878",
                  d: "M16.914,30.827a6.214,6.214,0,1,1,6.214-6.214A6.226,6.226,0,0,1,16.914,30.827Zm0-11.076a4.863,4.863,0,1,0,4.863,4.863A4.843,4.843,0,0,0,16.914,19.751Z",
                  transform: "translate(-10.7 -18.4)",
                  fill: "#ee2b7b"
                }
              ) }),
              /* @__PURE__ */ r("g", { id: "Grupo_16599", "data-name": "Grupo 16599", transform: "translate(3.489 4.03)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40879",
                  "data-name": "Trazado 40879",
                  d: "M16.489,27.22h0a.688.688,0,0,1-.45-.18l-1.261-1.261a.7.7,0,1,1,.991-.991l.81.81L19.1,23.078a.7.7,0,0,1,.991.991L17.119,27.04A3.671,3.671,0,0,1,16.489,27.22Z",
                  transform: "translate(-14.575 -22.875)",
                  fill: "#ee2b7b"
                }
              ) })
            ] }),
            /* @__PURE__ */ h("g", { id: "Grupo_16605", "data-name": "Grupo 16605", transform: "translate(36.37 17.714)", children: [
              /* @__PURE__ */ r("g", { id: "Grupo_16601", "data-name": "Grupo 16601", transform: "translate(0 0)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40880",
                  "data-name": "Trazado 40880",
                  d: "M46.414,30.827a6.214,6.214,0,1,1,6.214-6.214A6.226,6.226,0,0,1,46.414,30.827Zm0-11.076a4.863,4.863,0,1,0,4.863,4.863A4.843,4.843,0,0,0,46.414,19.751Z",
                  transform: "translate(-40.2 -18.4)",
                  fill: "#ee2b7b"
                }
              ) }),
              /* @__PURE__ */ h("g", { id: "Grupo_16604", "data-name": "Grupo 16604", transform: "translate(4.03 4.03)", children: [
                /* @__PURE__ */ r("g", { id: "Grupo_16602", "data-name": "Grupo 16602", children: /* @__PURE__ */ r(
                  "path",
                  {
                    id: "Trazado_40881",
                    "data-name": "Trazado 40881",
                    d: "M45.328,27.22a.688.688,0,0,1-.45-.18.707.707,0,0,1,0-.991l2.972-2.972a.7.7,0,1,1,.991.991L45.868,27.04A.662.662,0,0,1,45.328,27.22Z",
                    transform: "translate(-44.675 -22.875)",
                    fill: "#ee2b7b"
                  }
                ) }),
                /* @__PURE__ */ r("g", { id: "Grupo_16603", "data-name": "Grupo 16603", children: /* @__PURE__ */ r(
                  "path",
                  {
                    id: "Trazado_40882",
                    "data-name": "Trazado 40882",
                    d: "M48.3,27.22a.688.688,0,0,1-.45-.18l-2.972-2.972a.7.7,0,1,1,.991-.991l2.972,2.972a.707.707,0,0,1,0,.991A.662.662,0,0,1,48.3,27.22Z",
                    transform: "translate(-44.675 -22.875)",
                    fill: "#ee2b7b"
                  }
                ) })
              ] })
            ] })
          ]
        }
      )
    ]
  }
), g4 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_04_icono_consultar",
    "data-name": "04_icono_consultar",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h("g", { id: "_04_icono_consultar-2", "data-name": "04_icono_consultar", transform: "translate(2 0.6)", children: [
        /* @__PURE__ */ r("g", { id: "Grupo_16753", "data-name": "Grupo 16753", transform: "translate(5.096 14.4)", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41125",
            "data-name": "Trazado 41125",
            d: "M13.644,29.689a7.644,7.644,0,1,1,7.644-7.644A7.667,7.667,0,0,1,13.644,29.689Zm0-13.845a6.2,6.2,0,1,0,6.2,6.2A6.235,6.235,0,0,0,13.644,15.844Z",
            transform: "translate(-6 -14.4)",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16754", "data-name": "Grupo 16754", transform: "translate(0 31.133)", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41126",
            "data-name": "Trazado 41126",
            d: "M24.717,48.2a.761.761,0,0,1-.764-.764V43.7c0-5.606-5.691-8.069-11.212-8.069-5.606,0-11.212,2.463-11.212,8.069v3.737a.764.764,0,0,1-1.529,0V43.7c0-5.691,5.1-9.6,12.741-9.6s12.741,3.822,12.741,9.6v3.737A.761.761,0,0,1,24.717,48.2Z",
            transform: "translate(0 -34.1)",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16755", "data-name": "Grupo 16755", transform: "translate(34.824 14.4)", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41127",
            "data-name": "Trazado 41127",
            d: "M48.644,29.689a7.644,7.644,0,1,1,7.644-7.644A7.667,7.667,0,0,1,48.644,29.689Zm0-13.845a6.2,6.2,0,1,0,6.2,6.2A6.235,6.235,0,0,0,48.644,15.844Z",
            transform: "translate(-41 -14.4)",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16756", "data-name": "Grupo 16756", transform: "translate(29.728 31.133)", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41128",
            "data-name": "Trazado 41128",
            d: "M59.717,48.2a.761.761,0,0,1-.764-.764V43.7c0-5.606-5.691-8.069-11.212-8.069-5.606,0-11.212,2.463-11.212,8.069v3.737a.764.764,0,1,1-1.529,0V43.7c0-5.691,5.1-9.6,12.741-9.6s12.741,3.822,12.741,9.6v3.737A.761.761,0,0,1,59.717,48.2Z",
            transform: "translate(-35 -34.1)",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16757", "data-name": "Grupo 16757", transform: "translate(26.692 15.356)", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41129",
            "data-name": "Trazado 41129",
            d: "M32.168,32.236a.641.641,0,0,1-.595-.34.705.705,0,0,1,.17-1.019,8.773,8.773,0,0,0,3.737-6.965,8.5,8.5,0,0,0-3.4-7.05.731.731,0,1,1,.849-1.189,10.215,10.215,0,0,1,3.992,8.239,10.1,10.1,0,0,1-4.332,8.069A.776.776,0,0,1,32.168,32.236Z",
            transform: "translate(-31.426 -15.526)",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16758", "data-name": "Grupo 16758", transform: "translate(24.399 18.753)", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41130",
            "data-name": "Trazado 41130",
            d: "M29.468,29.272a.641.641,0,0,1-.595-.34.705.705,0,0,1,.17-1.019,4.28,4.28,0,0,0,1.869-3.482,4.507,4.507,0,0,0-1.7-3.567.731.731,0,0,1,.849-1.189,5.862,5.862,0,0,1-.17,9.428A.549.549,0,0,1,29.468,29.272Z",
            transform: "translate(-28.726 -19.526)",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16759", "data-name": "Grupo 16759", transform: "translate(22.275 21.556)", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41131",
            "data-name": "Trazado 41131",
            d: "M26.968,27.051a.641.641,0,0,1-.595-.34.705.705,0,0,1,.17-1.019.892.892,0,0,0,.425-.764,1.265,1.265,0,0,0-.34-.764.731.731,0,0,1,.849-1.189,2.416,2.416,0,0,1,.934,1.954,2.629,2.629,0,0,1-1.019,1.954A.649.649,0,0,1,26.968,27.051Z",
            transform: "translate(-26.226 -22.826)",
            fill: "#ee2b7b"
          }
        ) })
      ] })
    ]
  }
), v4 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_36_control_bebe",
    "data-name": "36_control_bebe",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h("g", { id: "_36_control_bebe-2", "data-name": "36_control_bebe", transform: "translate(4.679 4.756)", children: [
        /* @__PURE__ */ h("g", { id: "Grupo_16866", "data-name": "Grupo 16866", children: [
          /* @__PURE__ */ r("g", { id: "Grupo_16861", "data-name": "Grupo 16861", children: /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41287",
              "data-name": "Trazado 41287",
              d: "M4.844,51.244a3.891,3.891,0,0,1-2.3-.7,4.4,4.4,0,0,1-2.1-3.5c-.6-9.6,1-17.6,4.6-23.8a24.948,24.948,0,0,1,10.6-10,4.6,4.6,0,0,1,4.4.2,4.406,4.406,0,0,1,2.1,3.8v3.7a.789.789,0,0,1-.8.8.736.736,0,0,1-.8-.8v-3.7a2.851,2.851,0,0,0-1.4-2.5,2.806,2.806,0,0,0-2.8-.1,24.37,24.37,0,0,0-9.9,9.4c-3.5,5.9-4.9,13.6-4.4,22.9a2.977,2.977,0,0,0,1.4,2.3,2.87,2.87,0,0,0,2.7.2l8.7-3.8a9.4,9.4,0,0,0,5.7-8.7v-8.9a.789.789,0,0,1,.8-.8.736.736,0,0,1,.8.8v8.9a10.9,10.9,0,0,1-6.7,10.1l-8.7,3.8A4.638,4.638,0,0,1,4.844,51.244Z",
              fill: "#ee2b7b"
            }
          ) }),
          /* @__PURE__ */ r("g", { id: "Grupo_16862", "data-name": "Grupo 16862", children: /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41288",
              "data-name": "Trazado 41288",
              d: "M46.644,51.244a3.922,3.922,0,0,1-1.8-.4l-8.7-3.8a11.052,11.052,0,0,1-6.7-10.1v-8.9a.8.8,0,0,1,1.6,0v8.9a9.4,9.4,0,0,0,5.7,8.7l8.7,3.8a2.869,2.869,0,0,0,2.7-.2,2.977,2.977,0,0,0,1.4-2.3c.6-9.3-.9-17-4.4-22.9a23.7,23.7,0,0,0-9.9-9.4,2.8,2.8,0,0,0-2.8.1,2.851,2.851,0,0,0-1.4,2.5v3.2a.8.8,0,0,1-1.6,0v-3.2a4.406,4.406,0,0,1,2.1-3.8,4.584,4.584,0,0,1,4.4-.2,26.1,26.1,0,0,1,10.6,10c3.6,6.2,5.2,14.2,4.6,23.8a4.351,4.351,0,0,1-2.1,3.5A4.423,4.423,0,0,1,46.644,51.244Z",
              fill: "#ee2b7b"
            }
          ) }),
          /* @__PURE__ */ r("g", { id: "Grupo_16863", "data-name": "Grupo 16863", children: /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41289",
              "data-name": "Trazado 41289",
              d: "M37.444,33.044a.773.773,0,0,1-.8-.7c-.3-6.5-5.9-10.4-8.3-11.8a3.449,3.449,0,0,1-1.7-2.9V1.044a.789.789,0,0,1,.8-.8.736.736,0,0,1,.8.8v16.6a1.922,1.922,0,0,0,.9,1.6c2.6,1.5,8.7,5.8,9,13.1.1.3-.2.7-.7.7Z",
              fill: "#ee2b7b"
            }
          ) }),
          /* @__PURE__ */ r("g", { id: "Grupo_16864", "data-name": "Grupo 16864", children: /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41290",
              "data-name": "Trazado 41290",
              d: "M14.444,33.044h0a.789.789,0,0,1-.8-.8c.3-7.2,6.4-11.5,9-13.1a1.7,1.7,0,0,0,.9-1.6V1.044a.789.789,0,0,1,.8-.8.736.736,0,0,1,.8.8v16.6a3.242,3.242,0,0,1-1.7,2.9c-2.4,1.4-8,5.3-8.3,11.8A.684.684,0,0,1,14.444,33.044Z",
              fill: "#ee2b7b"
            }
          ) }),
          /* @__PURE__ */ r("g", { id: "Grupo_16865", "data-name": "Grupo 16865", children: /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41291",
              "data-name": "Trazado 41291",
              d: "M34.844,34.644h0a.86.86,0,0,1-.8-.8,11.363,11.363,0,0,0-5.8-10.2,4.708,4.708,0,0,0-4.6,0,11.363,11.363,0,0,0-5.8,10.2.789.789,0,0,1-.8.8h0a.789.789,0,0,1-.8-.8,12.85,12.85,0,0,1,6.6-11.5,5.533,5.533,0,0,1,3.1-.8,6.806,6.806,0,0,1,3.1.8,12.978,12.978,0,0,1,6.6,11.6A.849.849,0,0,1,34.844,34.644Z",
              fill: "#ee2b7b"
            }
          ) })
        ] }),
        /* @__PURE__ */ r("g", { id: "Grupo_16867", "data-name": "Grupo 16867", children: /* @__PURE__ */ r(
          "circle",
          {
            id: "Elipse_81",
            "data-name": "Elipse 81",
            cx: "1.1",
            cy: "1.1",
            r: "1.1",
            transform: "translate(6.344 40.344)",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16868", "data-name": "Grupo 16868", children: /* @__PURE__ */ r(
          "circle",
          {
            id: "Elipse_82",
            "data-name": "Elipse 82",
            cx: "1.1",
            cy: "1.1",
            r: "1.1",
            transform: "translate(12.244 40.344)",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16869", "data-name": "Grupo 16869", children: /* @__PURE__ */ r(
          "circle",
          {
            id: "Elipse_83",
            "data-name": "Elipse 83",
            cx: "1.1",
            cy: "1.1",
            r: "1.1",
            transform: "translate(8.882 33.248)",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16870", "data-name": "Grupo 16870", children: /* @__PURE__ */ r(
          "circle",
          {
            id: "Elipse_84",
            "data-name": "Elipse 84",
            cx: "1.1",
            cy: "1.1",
            r: "1.1",
            transform: "translate(4.144 35.044)",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16871", "data-name": "Grupo 16871", children: /* @__PURE__ */ r(
          "circle",
          {
            id: "Elipse_85",
            "data-name": "Elipse 85",
            cx: "1.1",
            cy: "1.1",
            r: "1.1",
            transform: "translate(8.944 25.844)",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16872", "data-name": "Grupo 16872", children: /* @__PURE__ */ r(
          "circle",
          {
            id: "Elipse_86",
            "data-name": "Elipse 86",
            cx: "1.1",
            cy: "1.1",
            r: "1.1",
            transform: "translate(13.344 20.044)",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16873", "data-name": "Grupo 16873", children: /* @__PURE__ */ r(
          "circle",
          {
            id: "Elipse_87",
            "data-name": "Elipse 87",
            cx: "1.1",
            cy: "1.1",
            r: "1.1",
            transform: "translate(36.344 39.244)",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16874", "data-name": "Grupo 16874", children: /* @__PURE__ */ r(
          "circle",
          {
            id: "Elipse_88",
            "data-name": "Elipse 88",
            cx: "1.1",
            cy: "1.1",
            r: "1.1",
            transform: "translate(42.944 43.144)",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16875", "data-name": "Grupo 16875", children: /* @__PURE__ */ r(
          "circle",
          {
            id: "Elipse_89",
            "data-name": "Elipse 89",
            cx: "1.1",
            cy: "1.1",
            r: "1.1",
            transform: "translate(42.544 35.044)",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16876", "data-name": "Grupo 16876", children: /* @__PURE__ */ r(
          "circle",
          {
            id: "Elipse_90",
            "data-name": "Elipse 90",
            cx: "1.1",
            cy: "1.1",
            r: "1.1",
            transform: "translate(41.844 25.844)",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16877", "data-name": "Grupo 16877", children: /* @__PURE__ */ r(
          "circle",
          {
            id: "Elipse_91",
            "data-name": "Elipse 91",
            cx: "1.1",
            cy: "1.1",
            r: "1.1",
            transform: "translate(37.444 20.044)",
            fill: "#ee2b7b"
          }
        ) })
      ] })
    ]
  }
), b4 = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_13_icono_control_vacunas",
    "data-name": "13_icono_control_vacunas",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_13_icono_control_vacunas-2",
          "data-name": "13_icono_control_vacunas",
          transform: "translate(-2 -0.4)",
          children: [
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41195",
                "data-name": "Trazado 41195",
                d: "M50.9,44.793a.323.323,0,0,0-.185-.093c-.093,0-.185,0-.185.093L48.5,46.83l-.278-.278a.463.463,0,0,0-.741,0l-.37.37-.093.093h-.37a1.885,1.885,0,0,0-1.389.556l-4.446,4.446-.37-.37c-.093-.093-.093-.093-.185-.093s-.185,0-.185.093a.282.282,0,0,0,0,.37l.834.834-1.019,1.019-.185-.185a.993.993,0,0,0-.556-.185,1.316,1.316,0,0,0-.556.185.926.926,0,0,0,0,1.111l2.038,2.038a.926.926,0,0,0,1.111,0,.681.681,0,0,0,.185-.556,1.316,1.316,0,0,0-.185-.556l-.185-.185,1.019-1.019.834.834c.093.093.093.093.185.093a.3.3,0,0,0,.278-.278c0-.093,0-.185-.093-.185l-.278-.278,4.446-4.446A2.048,2.048,0,0,0,48.5,48.5a.091.091,0,0,0,.093-.093l.37-.37a.463.463,0,0,0,0-.741l-.278-.278,2.038-2.038.093-.093h0C51,44.978,51,44.793,50.9,44.793Zm-3.334,2.5.278-.37.834.834-.278.37ZM44.42,49.331l2.038,2.038-.463.463-.556-.556a.323.323,0,0,0-.185-.093c-.093,0-.185,0-.185.093-.093,0-.093.093-.093.185s0,.093.093.185l.556.556-.463.463-.556-.556a.323.323,0,0,0-.185-.093c-.093,0-.185,0-.185.093a.282.282,0,0,0,0,.37l.556.556-.463.463-.556-.556c-.093,0-.093-.093-.185-.093s-.185,0-.185.093a.323.323,0,0,0-.093.185c0,.093,0,.093.093.185l.556.556-.463.463-2.038-2.038Zm3.242.741-.556-.556c-.093,0-.093-.093-.185-.093s-.185,0-.185.093a.323.323,0,0,0-.093.185c0,.093,0,.093.093.185l.463.556-.463.463L44.7,48.868l1.019-1.019a1.393,1.393,0,0,1,1.019-.37h.278l1.111,1.111a1.376,1.376,0,0,1-.37,1.3Zm-6.113,5.187L40.53,54.24l1.019-1.019,1.019,1.019Zm.093,1.2-.093.093c-.093,0-.093,0-.185-.093l-2.038-2.038a.323.323,0,0,1-.093-.185c0-.093,0-.093.093-.185a.323.323,0,0,1,.185-.093c.093,0,.093,0,.185.093l2.038,2.038a.323.323,0,0,1,.093.185Z",
                transform: "translate(-2.096 -3.122)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41196",
                "data-name": "Trazado 41196",
                d: "M21.022,36.206H16.483a.731.731,0,0,1-.741-.741V30.927a.731.731,0,0,1,.741-.741h4.538a.731.731,0,0,1,.741.741v4.538A.8.8,0,0,1,21.022,36.206Zm-3.8-1.482h3.149V31.575H17.224Zm3.8,12.967H16.483a.731.731,0,0,1-.741-.741V42.412a.731.731,0,0,1,.741-.741h4.538a.731.731,0,0,1,.741.741V46.95A.8.8,0,0,1,21.022,47.691Zm-3.8-1.389h3.149V43.153H17.224ZM35.749,15.274a.633.633,0,0,0-.648-.648H22.874a.648.648,0,1,0,0,1.3H35.1A.633.633,0,0,0,35.749,15.274Zm4.538,17.691H24.634a.648.648,0,0,0,0,1.3H40.287a.648.648,0,0,0,0-1.3Zm0-11.392H24.634a.648.648,0,0,0,0,1.3H40.287a.648.648,0,0,0,0-1.3ZM29.543,44.264H24.634a.648.648,0,1,0,0,1.3h4.909a.648.648,0,0,0,0-1.3ZM20.837,20.739l-2.871,2.13L17.41,21.85a.684.684,0,0,0-1.2.648l.834,1.76a.615.615,0,0,0,.463.37h.185a.5.5,0,0,0,.463-.278l3.52-2.593a.658.658,0,1,0-.834-1.019ZM47.974,37.411V12.125a2.688,2.688,0,0,0-2.686-2.686H38.249V9.161A3.222,3.222,0,0,0,35.008,5.92h-1.3A5.18,5.18,0,0,0,28.895,2.4a5.09,5.09,0,0,0-4.816,3.52h-1.3A3.282,3.282,0,0,0,19.54,9.161v.185H12.686A2.688,2.688,0,0,0,10,12.033V51.581a2.688,2.688,0,0,0,2.686,2.686H34.73a10.633,10.633,0,0,0,8.058,3.612,10.911,10.911,0,0,0,5.187-20.469ZM12.686,52.878a1.266,1.266,0,0,1-1.3-1.3V11.94a1.266,1.266,0,0,1,1.3-1.3H19.54v1.111a1.561,1.561,0,0,0,1.575,1.575H36.86a1.413,1.413,0,0,0,1.389-1.575V10.736h7.039a1.266,1.266,0,0,1,1.3,1.3v24.73a10.231,10.231,0,0,0-3.8-.648A10.93,10.93,0,0,0,31.951,47.043a10.559,10.559,0,0,0,1.76,5.835H12.686Zm30.1,3.612a9.54,9.54,0,1,1,9.54-9.54A9.526,9.526,0,0,1,42.788,56.49ZM20.929,9.161a1.9,1.9,0,0,1,1.945-1.945h1.852a.8.8,0,0,0,.648-.556,3.683,3.683,0,0,1,7.224,0,.677.677,0,0,0,.648.556H35.1a1.9,1.9,0,0,1,1.945,1.945v2.593a.2.2,0,0,1-.185.185H21.114a.2.2,0,0,1-.185-.185Zm8.058.648A2.452,2.452,0,0,0,31.4,7.4a2.408,2.408,0,1,0-4.816,0A2.452,2.452,0,0,0,28.987,9.81Zm0-3.52a1.111,1.111,0,1,1,0,2.223A1.07,1.07,0,0,1,27.876,7.4,1.126,1.126,0,0,1,28.987,6.29Z",
                fill: "#ee2b7b"
              }
            )
          ]
        }
      )
    ]
  }
), y4 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_19_icono_controles",
    "data-name": "19_icono_controles",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h("g", { id: "_19_icono_controles-2", "data-name": "19_icono_controles", transform: "translate(-2.4 -2.6)", children: [
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41203",
            "data-name": "Trazado 41203",
            d: "M26.9,12.7A2.7,2.7,0,1,0,24.2,10,2.689,2.689,0,0,0,26.9,12.7Zm0-3.7a.945.945,0,0,1,1,1,1.075,1.075,0,0,1-1,1,1,1,0,0,1,0-2Z",
            fill: "#ee2b7b"
          }
        ),
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41204",
            "data-name": "Trazado 41204",
            d: "M33.9,58.9h-23A2.9,2.9,0,0,1,8,56V16.6a3.075,3.075,0,0,1,3-3h5.6v1.1a1.793,1.793,0,0,0,1.8,1.8H35.3c1,0,1.6-.6,1.5-1.8v-1h6.1a2.9,2.9,0,0,1,2.9,2.9V32.3a.789.789,0,0,0,.8.8,1.107,1.107,0,0,0,.9-.7V16.7a4.653,4.653,0,0,0-4.6-4.6H36.8v-.2a3.585,3.585,0,0,0-3.6-3.6H31.9a5.5,5.5,0,0,0-10.4,0H20.2a3.585,3.585,0,0,0-3.6,3.6V12H11a4.526,4.526,0,0,0-4.6,4.6V55.9A4.653,4.653,0,0,0,11,60.5H34a.709.709,0,0,0,.7-.8A.789.789,0,0,0,33.9,58.9Zm-15.6-47a2.006,2.006,0,0,1,2-2h1.9a.849.849,0,0,0,.8-.7,3.879,3.879,0,0,1,7.6,0,.849.849,0,0,0,.8.7h2a2.006,2.006,0,0,1,2,2v2.8c0,.1,0,.1-.1.1H18.4c-.1,0-.1,0-.1-.1Z",
            fill: "#ee2b7b"
          }
        ),
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41205",
            "data-name": "Trazado 41205",
            d: "M33.4,19.3c.5,0,.9-.4.8-.8a.789.789,0,0,0-.8-.8H20.3a.8.8,0,1,0,0,1.6Z",
            fill: "#ee2b7b"
          }
        ),
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41206",
            "data-name": "Trazado 41206",
            d: "M50.7,44.5l-6,6-2.2-2.2a.849.849,0,0,0-1.2,1.2l2.8,2.8a1,1,0,0,0,1.2,0l6.6-6.6c.3-.4.4-.9,0-1.2A.91.91,0,0,0,50.7,44.5Z",
            fill: "#ee2b7b"
          }
        ),
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41207",
            "data-name": "Trazado 41207",
            d: "M46.6,36.3A12.1,12.1,0,1,0,58.7,48.4,12.078,12.078,0,0,0,46.6,36.3Zm0,22.5A10.4,10.4,0,1,1,57,48.4,10.457,10.457,0,0,1,46.6,58.8Z",
            fill: "#ee2b7b"
          }
        ),
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41208",
            "data-name": "Trazado 41208",
            d: "M38.9,26a.789.789,0,0,0-.8-.8H19.4a.8.8,0,0,0,0,1.6H38.1C38.6,26.8,39,26.4,38.9,26Z",
            fill: "#ee2b7b"
          }
        ),
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41209",
            "data-name": "Trazado 41209",
            d: "M28.8,36.4H19.4a.8.8,0,1,0,0,1.6h9.4a.86.86,0,0,0,.8-.8A.789.789,0,0,0,28.8,36.4Z",
            fill: "#ee2b7b"
          }
        ),
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41210",
            "data-name": "Trazado 41210",
            d: "M19.4,47.7a.86.86,0,0,0-.8.8.789.789,0,0,0,.8.8h9.4a.86.86,0,0,0,.8-.8.789.789,0,0,0-.8-.8Z",
            fill: "#ee2b7b"
          }
        ),
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41211",
            "data-name": "Trazado 41211",
            d: "M13.8,24a1.9,1.9,0,1,0,1.9,1.9A1.967,1.967,0,0,0,13.8,24Z",
            fill: "#ee2b7b"
          }
        ),
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41212",
            "data-name": "Trazado 41212",
            d: "M13.8,35.3a1.9,1.9,0,1,0,1.9,1.9A1.967,1.967,0,0,0,13.8,35.3Z",
            fill: "#ee2b7b"
          }
        ),
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41213",
            "data-name": "Trazado 41213",
            d: "M13.8,46.5a1.9,1.9,0,1,0,1.9,1.9A1.967,1.967,0,0,0,13.8,46.5Z",
            fill: "#ee2b7b"
          }
        )
      ] })
    ]
  }
), _4 = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_40_credito_capital_trabajo",
    "data-name": "40_credito_capital_trabajo",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ r(
        "path",
        {
          id: "_40_credito_capital_trabajo-2",
          "data-name": "40_credito_capital_trabajo",
          d: "M57.19,41.431h-7.2L56.74,25.766a.875.875,0,0,0-.09-.81,1.111,1.111,0,0,0-.72-.36H36.572a.894.894,0,0,0-.72.54L31.08,36.119a3.589,3.589,0,0,0-2.161-.63H18.836V30.267a5.562,5.562,0,0,0-4.862-5.582,7.514,7.514,0,1,0-4.862-.09H7.672A5.648,5.648,0,0,0,2,30.267V49.624s0,.9.81.81a.728.728,0,0,0,.81-.81V30.357a4.035,4.035,0,0,1,4.051-4.051h5.4a4.035,4.035,0,0,1,4.051,4.051v6.032a.807.807,0,0,0,.81.81H28.83a2.076,2.076,0,0,1,1.8.99h0a1.022,1.022,0,0,1,.27.72v.45a2.191,2.191,0,0,1-2.161,2.161H12.714V33.959a.81.81,0,1,0-1.621,0v8.463a.807.807,0,0,0,.81.81h6.032a6.492,6.492,0,0,1,6.392,5.582l.09.81a.794.794,0,0,0,.81.81.848.848,0,0,0,.9-.9,7.6,7.6,0,0,0-3.241-6.3H40.444v6.392a.807.807,0,0,0,.81.81h.09a.957.957,0,0,0,.9-.81V43.232H57.19a.916.916,0,0,0,.81-.99A.807.807,0,0,0,57.19,41.431ZM5.781,17.573a5.852,5.852,0,1,1,5.852,5.852A5.84,5.84,0,0,1,5.781,17.573Zm31.511,8.643H54.849L48.277,41.431H32.161a4.007,4.007,0,0,0,.63-2.071,3.724,3.724,0,0,0-.45-1.711Z",
          transform: "translate(0 -0.1)",
          fill: "#ee2b7b"
        }
      )
    ]
  }
), w4 = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_08_credito_consumo_responsable",
    "data-name": "08_credito_consumo_responsable",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_08_credito_consumo_responsable-2",
          "data-name": "08_credito_consumo_responsable",
          transform: "translate(1 0.7)",
          children: [
            /* @__PURE__ */ h("g", { id: "Grupo_16560", "data-name": "Grupo 16560", transform: "translate(2 12.651)", children: [
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40835",
                  "data-name": "Trazado 40835",
                  d: "M42.525,41.645H15.157c-.351,0-.526-.439-.614-.877a1.876,1.876,0,0,1,1.4-2.105l24.736-4.035a.757.757,0,1,0-.263-1.491l-4.912.789.439-2.719a.757.757,0,1,0-1.491-.263l-.439,3.245-5.526.877V28.4h3.333a.789.789,0,0,0,0-1.579H28.49V20.505h1.4a.789.789,0,1,0,0-1.579H10.158l-1.579-5a.667.667,0,0,0-.7-.526H2.789a.789.789,0,1,0,0,1.579H7.263L13.4,34.452a.667.667,0,0,0,.7.526h.175a.8.8,0,0,0,.526-.965L13.052,28.4H19.1l1.14,7.982-4.649.789a3.405,3.405,0,0,0-2.631,3.772c.175,1.4.965,2.281,2.105,2.281H42.437a.865.865,0,0,0,.877-.789A.786.786,0,0,0,42.525,41.645ZM26.911,26.821h-6.4l-.877-6.316H27v6.316Zm-14.3,0-1.93-6.316h7.368l.877,6.316Zm8.07,1.579h6.228v6.93l-5.088.789Z",
                  transform: "translate(-2 -13.4)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40836",
                  "data-name": "Trazado 40836",
                  d: "M19.721,50A3.483,3.483,0,0,0,16.3,53.421a3.421,3.421,0,1,0,6.842,0A3.483,3.483,0,0,0,19.721,50Zm0,5.263a1.93,1.93,0,1,1,1.93-1.93A1.947,1.947,0,0,1,19.721,55.263Z",
                  transform: "translate(-3.757 -17.896)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40837",
                  "data-name": "Trazado 40837",
                  d: "M42.421,50A3.483,3.483,0,0,0,39,53.421,3.421,3.421,0,1,0,42.421,50Zm0,5.263a1.93,1.93,0,1,1,1.93-1.93A1.947,1.947,0,0,1,42.421,55.263Z",
                  transform: "translate(-6.545 -17.896)",
                  fill: "#ee2b7b"
                }
              )
            ] }),
            /* @__PURE__ */ r("g", { id: "Grupo_16561", "data-name": "Grupo 16561", transform: "translate(31.473 7.3)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40838",
                "data-name": "Trazado 40838",
                d: "M47.617,31.334A12.017,12.017,0,1,1,59.634,19.317,12.035,12.035,0,0,1,47.617,31.334Zm0-22.543A10.526,10.526,0,1,0,58.143,19.317,10.557,10.557,0,0,0,47.617,8.791Z",
                transform: "translate(-35.6 -7.3)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40839",
                "data-name": "Trazado 40839",
                d: "M52.456,16.712c.088.877-.614,1.14-1.053.877a1.008,1.008,0,0,1-.526-.789,1.983,1.983,0,0,0-1.228-1.842,2.06,2.06,0,0,0-2.105.263,1.831,1.831,0,0,0-.7,2.105,2.1,2.1,0,0,0,1.579,1.491,5.923,5.923,0,0,0,1.228.175,3.518,3.518,0,0,1,2.719,3.245,3.723,3.723,0,0,1-2.456,3.772c-.439.175-.439.175-.439.526v.526a.789.789,0,0,1-1.579,0v-.7c0-.263-.088-.263-.263-.351a3.586,3.586,0,0,1-2.456-2.544A1.735,1.735,0,0,1,45,22.589a.848.848,0,0,1,.789-.789c.526,0,.789.263.965.789.088.263.088.351.175.614a1.777,1.777,0,0,0,2.017,1.4,2.072,2.072,0,0,0,2.017-1.754,2.007,2.007,0,0,0-2.017-2.281,3.512,3.512,0,0,1-3.509-2.982,3.625,3.625,0,0,1,2.456-4.035c.263-.175.263-.175.263-.439v-.526a.789.789,0,0,1,1.579,0v.7c0,.175,0,.263.263.439A3.287,3.287,0,0,1,52.456,16.712Z",
                transform: "translate(-5.282 -0.553)",
                fill: "#ee2b7b"
              }
            )
          ]
        }
      )
    ]
  }
), T4 = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_01_credito_disminucion_ingresos",
    "data-name": "01_credito_disminucion_ingresos",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ r(
        "path",
        {
          id: "_01_credito_disminucion_ingresos-2",
          "data-name": "01_credito_disminucion_ingresos",
          d: "M41.8,25.539l-2.437,2.437c-.187.187-.281.281-.469.281a.668.668,0,0,1-.562-.281l-2.437-2.437a.663.663,0,0,1,.937-.937l1.406,1.406V17.667a.656.656,0,0,1,1.312,0v8.341L40.952,24.6a.626.626,0,0,1,.937,0A.721.721,0,0,1,41.8,25.539ZM2.9,12.887A3.22,3.22,0,0,1,6.087,9.7a3.081,3.081,0,0,1,3.187,3.093v.375L22.582,24.7,25.3,27.414a3.508,3.508,0,0,1,1.687-.469,3.16,3.16,0,0,1,3.187,3.187,3.424,3.424,0,0,1-.281,1.406l11.059,9.091,8.81,3.468a3.129,3.129,0,0,1,3.093-2.437,3.187,3.187,0,0,1,0,6.373A3.316,3.316,0,0,1,49.762,45.6L40.3,41.66c-.094,0-.094-.094-.187-.094L29.049,32.475a3.3,3.3,0,0,1-1.968.656,3.22,3.22,0,0,1-3.187-3.187,3.508,3.508,0,0,1,.469-1.687l-2.718-2.718L8.711,14.667A2.947,2.947,0,0,1,6.93,15.886V49.158a1.8,1.8,0,0,0,1.781,1.874h4.124V21.416a.656.656,0,1,1,1.312,0V51.032h5.061V27.508a.656.656,0,0,1,1.312,0V51.032h5.061V35.006a.656.656,0,0,1,1.312,0V51.032h5.061V39.973a.656.656,0,1,1,1.312,0V51.032h5.061v-7.4a.656.656,0,0,1,1.312,0v7.4H44.7V46.627a.656.656,0,1,1,1.312,0v4.405h7.029a3,3,0,0,0,2.905-3,.656.656,0,1,1,1.312,0,4.4,4.4,0,0,1-4.405,4.405H8.617a3.105,3.105,0,0,1-3.093-3.28V15.886A2.962,2.962,0,0,1,2.9,12.887ZM52.855,46.627a.564.564,0,0,0,.375-.094,1.751,1.751,0,0,0-.375-3.468,1.746,1.746,0,0,0-1.781,1.593v.187A1.78,1.78,0,0,0,52.855,46.627ZM26.987,31.913a2.1,2.1,0,0,0,.937-.281,1.811,1.811,0,0,0,.844-1.125c0-.094.094-.281.094-.375a1.78,1.78,0,0,0-1.781-1.781,1.189,1.189,0,0,0-.562.094,1.613,1.613,0,0,0-1.031,1.031,1.738,1.738,0,0,0-.187.656A1.649,1.649,0,0,0,26.987,31.913ZM6.087,14.667a1.78,1.78,0,0,0,1.781-1.781,1.843,1.843,0,0,0-1.781-1.781,1.781,1.781,0,1,0,0,3.562Zm52.2,7.967a7.42,7.42,0,0,0-7.4-7.4,7.4,7.4,0,1,0,7.4,7.4Zm-1.218-.094a6.186,6.186,0,1,1-6.186-6.186A6.241,6.241,0,0,1,57.073,22.54Zm-3.882-1.876c.053.534-.374.694-.641.534a.614.614,0,0,1-.321-.481,1.208,1.208,0,0,0-.749-1.123,1.256,1.256,0,0,0-1.283.16,1.116,1.116,0,0,0-.427,1.283,1.278,1.278,0,0,0,.963.909,3.607,3.607,0,0,0,.749.107,2.144,2.144,0,0,1,1.657,1.978,2.27,2.27,0,0,1-1.5,2.3c-.267.107-.267.107-.267.321v.321a.481.481,0,1,1-.962,0v-.427c0-.16-.053-.16-.16-.214a2.185,2.185,0,0,1-1.5-1.55,1.057,1.057,0,0,1-.107-.534.516.516,0,0,1,.481-.481c.321,0,.481.16.588.481.053.16.053.214.107.374a1.084,1.084,0,0,0,1.23.856,1.263,1.263,0,0,0,1.23-1.069,1.223,1.223,0,0,0-1.23-1.39A2.142,2.142,0,0,1,48.915,21.2a2.209,2.209,0,0,1,1.5-2.459c.16-.107.16-.107.16-.267v-.321a.481.481,0,1,1,.962,0v.427c0,.107,0,.16.16.267A2,2,0,0,1,53.191,20.664Z",
          transform: "translate(-0.9 -0.7)",
          fill: "#ee2b7b"
        }
      )
    ]
  }
), S4 = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_05_credito_estudiar_CESDE",
    "data-name": "05_credito_estudiar_CESDE",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_05_credito_estudiar_CESDE-2",
          "data-name": "05_credito_estudiar_CESDE",
          transform: "translate(-1.4 -1.459)",
          children: [
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40823",
                "data-name": "Trazado 40823",
                d: "M30.247,56.718a1.228,1.228,0,0,0-.1.581c-.1,1.356-.775,1.84-2.13,1.937h-3.97c-.484,0-.581-.291-.581-.678s.1-.678.581-.678H26.47c.387,0,.581-.1.581-.484-.1-.387-.194-.581-.581-.581H24.049c-.484,0-.581-.291-.581-.775s.194-.678.678-.678h3.486c.484.1.581-.1.581-.484s-.1-.581-.484-.581H22.984c-.387,0-.484.1-.484.484V59.72c0,.387.1.484.484.484,1.743,0,3.583.1,5.326,0,1.259-.1,2.421-.484,2.808-1.84a5.715,5.715,0,0,0,.194-1.356c.1-.968.484-1.549,1.549-1.646a15.69,15.69,0,0,1,2.13-.1V54.2a9.248,9.248,0,0,0-2.808.291A2.287,2.287,0,0,0,30.247,56.718Z",
                transform: "translate(-0.509 -1.572)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40824",
                "data-name": "Trazado 40824",
                d: "M41.436,54.4c-1.549-.1-3.1-.1-4.648-.1a.432.432,0,0,0-.387.291v5.617c1.549,0,2.905.1,4.261,0a3.886,3.886,0,0,0,1.453-.291,2.869,2.869,0,0,0,1.743-3.1A2.686,2.686,0,0,0,41.436,54.4Zm-.387,4.745c-.968.1-2.034,0-3,0-.194,0-.484-.194-.484-.387V55.849c0-.387.194-.484.484-.484h2.905c1.162.1,1.937.775,1.937,1.743A2.081,2.081,0,0,1,41.048,59.142Z",
                transform: "translate(-0.948 -1.575)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40825",
                "data-name": "Trazado 40825",
                d: "M50.233,59.333h-3.2c-.581,0-.678-.291-.678-.775.1-.484.194-.678.678-.678h2.421c.291,0,.484-.1.484-.484s-.1-.581-.581-.581H46.94c-.581,0-.678-.291-.678-.775s.194-.678.678-.678h3.1c.387,0,.678-.1.678-.581,0-.581-.291-.581-.678-.581H45.972c-.872,0-.872,0-.872.872v4.842c0,.291.194.484.775.484h4.358c.387,0,.678.1.678-.484C50.91,59.429,50.62,59.333,50.233,59.333Z",
                transform: "translate(-1.223 -1.572)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40826",
                "data-name": "Trazado 40826",
                d: "M17.395,55.364h3.486c.387,0,.484-.1.484-.484s0-.581-.484-.581c-1.259,0-2.615-.1-3.97,0A2.985,2.985,0,0,0,14.2,56.816a2.927,2.927,0,0,0,1.84,3.2,11.365,11.365,0,0,0,2.808.291h1.937c.387,0,.581-.1.581-.484,0-.484-.194-.581-.581-.581H17.395a1.956,1.956,0,1,1,0-3.874Z",
                transform: "translate(-0.246 -1.574)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40827",
                "data-name": "Trazado 40827",
                d: "M7.078,44.881H29.738a.873.873,0,0,1,.1.484.662.662,0,0,0,.678.678h2.712a.648.648,0,0,0,.678-.581,1.376,1.376,0,0,1,.194-.581H56.273a.662.662,0,0,0,.678-.678V11.084a.662.662,0,0,0-.678-.678H55.111a.678.678,0,1,0,0,1.356h.484V43.525H37.776l14.139-3.293a.707.707,0,0,0,.581-.678V5.177a.494.494,0,0,0-.387-.484.594.594,0,0,0-.581-.1l-15.3,4.745a7.485,7.485,0,0,0-4.358,3.874,7.391,7.391,0,0,0-4.455-3.874L11.726,4.5a.64.64,0,0,0-.581.1.837.837,0,0,0-.291.581V39.555a.728.728,0,0,0,.484.678l14.235,3.293H7.756V11.762h.581a.678.678,0,0,0,0-1.356H7.078a.662.662,0,0,0-.678.678V44.2A.662.662,0,0,0,7.078,44.881ZM36.711,10.6,51.14,6.145V39.071L34.58,42.847a2.58,2.58,0,0,0-1.937,1.646V16.216A5.843,5.843,0,0,1,36.711,10.6ZM12.21,6.145,27.027,10.6a5.81,5.81,0,0,1,4.164,5.617l-.1,28.471a2.28,2.28,0,0,0-1.84-1.743L12.21,38.974Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40828",
                "data-name": "Trazado 40828",
                d: "M56.369,47.8h-21.3a.662.662,0,0,0-.678.678.662.662,0,0,1-.678.678H30.223a.662.662,0,0,1-.678-.678.662.662,0,0,0-.678-.678H7.078a.678.678,0,0,0,0,1.356H28.189a2.106,2.106,0,0,0,1.937,1.356h3.486a2.106,2.106,0,0,0,1.937-1.356H56.369a.678.678,0,0,0,0-1.356Z",
                transform: "translate(0 -1.37)",
                fill: "#ee2b7b"
              }
            )
          ]
        }
      )
    ]
  }
), M4 = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_25_credito_facil_acceso",
    "data-name": "25_credito_facil_acceso",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_25_credito_facil_acceso-2",
          "data-name": "25_credito_facil_acceso",
          transform: "translate(0.972 0.572)",
          children: [
            /* @__PURE__ */ h("g", { id: "Grupo_16648", "data-name": "Grupo 16648", transform: "translate(24.242 2.5)", children: [
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40924",
                  "data-name": "Trazado 40924",
                  d: "M36.385,8.41a.744.744,0,0,0-1.075-.179L32.355,10.38V3.216a.716.716,0,1,0-1.433,0v7.075l-2.866-2.06a.77.77,0,1,0-.9,1.254l4.03,2.866c.179.09.269.179.448.179a.884.884,0,0,0,.537-.179l4.03-2.866A.744.744,0,0,0,36.385,8.41Z",
                  transform: "translate(-26.826 -2.5)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40925",
                  "data-name": "Trazado 40925",
                  d: "M26.982,55.719a.744.744,0,0,0,1.075.179l2.955-2.149v7.164a.716.716,0,1,0,1.433,0V53.839L35.31,55.9a.77.77,0,1,0,.9-1.254l-4.03-2.866c-.179-.09-.269-.179-.448-.179a.884.884,0,0,0-.537.179l-4.03,2.866A.744.744,0,0,0,26.982,55.719Z",
                  transform: "translate(-26.826 -7.63)",
                  fill: "#ee2b7b"
                }
              )
            ] }),
            /* @__PURE__ */ h("g", { id: "Grupo_16649", "data-name": "Grupo 16649", transform: "translate(2.1 24.642)", children: [
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40926",
                  "data-name": "Trazado 40926",
                  d: "M8.01,27.382a.744.744,0,0,0-.179,1.075L9.98,31.412H2.816a.716.716,0,0,0,0,1.433H9.891L7.831,35.71a.77.77,0,1,0,1.254.9l2.866-4.03c.09-.179.179-.269.179-.448a.884.884,0,0,0-.179-.537l-2.866-4.03A.744.744,0,0,0,8.01,27.382Z",
                  transform: "translate(-2.1 -27.226)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40927",
                  "data-name": "Trazado 40927",
                  d: "M55.319,36.785A.744.744,0,0,0,55.5,35.71l-2.149-2.955h7.164a.716.716,0,0,0,0-1.433H53.439l2.06-2.866a.77.77,0,1,0-1.254-.9l-2.866,4.03c-.09.179-.179.269-.179.448a.884.884,0,0,0,.179.537l2.866,4.03A.744.744,0,0,0,55.319,36.785Z",
                  transform: "translate(-7.23 -27.226)",
                  fill: "#ee2b7b"
                }
              )
            ] }),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40928",
                "data-name": "Trazado 40928",
                d: "M25.841,37.024a5.923,5.923,0,0,0,4.226,4.885.447.447,0,0,1,.362.51c-.017.358-.011.716,0,1.075a1.353,1.353,0,0,0,2.7.012,6.248,6.248,0,0,0,0-.869c-.047-.44.106-.65.55-.793a5.93,5.93,0,0,0,4.049-6.459,6,6,0,0,0-5.863-5.223A3.264,3.264,0,0,1,31.1,23.71a3.274,3.274,0,0,1,3.518,1.6,4.256,4.256,0,0,1,.446,1.747,1.332,1.332,0,0,0,1.394,1.2,1.318,1.318,0,0,0,1.3-1.246,4.452,4.452,0,0,0-.043-.947,5.9,5.9,0,0,0-4.207-4.9.467.467,0,0,1-.381-.538c.019-.358.013-.716,0-1.075a1.328,1.328,0,0,0-1.35-1.285,1.313,1.313,0,0,0-1.351,1.277,7.628,7.628,0,0,0,0,.991c.033.386-.121.548-.492.664a6.02,6.02,0,0,0-4.152,6.175,6.1,6.1,0,0,0,4.615,5.373c.611.15,1.233.107,1.846.208a3.116,3.116,0,0,1,2.614,2.189,3.246,3.246,0,0,1-4.131,4.092,3.211,3.211,0,0,1-2.221-3.084,1.422,1.422,0,0,0-.386-.932,1.356,1.356,0,0,0-1.486-.32,1.4,1.4,0,0,0-.858,1.465A5.075,5.075,0,0,0,25.841,37.024Z",
                transform: "translate(-2.474 -1.647)",
                fill: "#ee2b7b"
              }
            )
          ]
        }
      )
    ]
  }
), A4 = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_06_credito_hipotecario",
    "data-name": "06_credito_hipotecario",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_06_credito_hipotecario-2",
          "data-name": "06_credito_hipotecario",
          transform: "translate(1 0.8)",
          children: [
            /* @__PURE__ */ r("g", { id: "Grupo_16556", "data-name": "Grupo 16556", transform: "translate(6 3.2)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40829",
                "data-name": "Trazado 40829",
                d: "M45.451,55.861H8.426A2.416,2.416,0,0,1,6,53.435V5.626A2.416,2.416,0,0,1,8.426,3.2H45.451a2.416,2.416,0,0,1,2.426,2.426V20.544a.719.719,0,0,1-1.438,0V5.626a1,1,0,0,0-.989-.989H8.426a1,1,0,0,0-.989.989V53.435a1,1,0,0,0,.989.989H45.451a1,1,0,0,0,.989-.989V39.685a.719.719,0,1,1,1.438,0V53.435A2.475,2.475,0,0,1,45.451,55.861Z",
                transform: "translate(-6 -3.2)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16557", "data-name": "Grupo 16557", transform: "translate(13.369 27.104)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40830",
                "data-name": "Trazado 40830",
                d: "M39.632,31.238H14.919a.719.719,0,1,1,0-1.438H39.632a.719.719,0,1,1,0,1.438Z",
                transform: "translate(-14.2 -29.8)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16558", "data-name": "Grupo 16558", transform: "translate(13.369 35.551)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40831",
                "data-name": "Trazado 40831",
                d: "M30.286,40.638H14.919a.719.719,0,1,1,0-1.438H30.376a.773.773,0,0,1,.719.719A.787.787,0,0,1,30.286,40.638Z",
                transform: "translate(-14.2 -39.2)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16559", "data-name": "Grupo 16559", transform: "translate(13.369 44.089)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40832",
                "data-name": "Trazado 40832",
                d: "M22.468,50.138H14.919a.719.719,0,1,1,0-1.438h7.639a.773.773,0,0,1,.719.719A.792.792,0,0,1,22.468,50.138Z",
                transform: "translate(-14.2 -48.7)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40833",
                "data-name": "Trazado 40833",
                d: "M54.606,31.624,50.562,27.58a1.277,1.277,0,0,0-.539-.18.76.76,0,0,0-.539.18L36.992,40.071l-.09.18L34.3,46.9c-.09.27,0,.449.18.809a.74.74,0,0,0,.809.18l6.47-2.516a.681.681,0,0,0,.359-.18h.09L54.7,32.612A.817.817,0,0,0,54.606,31.624ZM37.8,41.868l2.516,2.516-4.044,1.528Zm3.774,1.8L38.52,40.61l11.5-11.5,3.055,3.055Z",
                transform: "translate(-2.864 -2.453)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40834",
                "data-name": "Trazado 40834",
                d: "M23.782,22.378a.709.709,0,0,1-.719-.719V16H21.625a.768.768,0,0,1-.539-.27l-.09-.09v-.09a.7.7,0,0,1,.18-.719L28.1,8.18A.76.76,0,0,1,28.635,8a.963.963,0,0,1,.539.18l6.92,6.65a.746.746,0,0,1,.18.719.712.712,0,0,1-.719.449H34.116V21.66a.673.673,0,0,1-.09.449.971.971,0,0,1-.629.27Zm8.9-1.438V15.279a.709.709,0,0,1,.719-.719h.359L28.545,9.618,23.422,14.56h.359a.709.709,0,0,1,.719.719v5.662h2.157V18.155a.709.709,0,0,1,.719-.719h2.516a.709.709,0,0,1,.719.719v2.786Zm-3.595,0V18.874H28.006v2.067Z",
                transform: "translate(-1.516 -0.486)",
                fill: "#ee2b7b"
              }
            )
          ]
        }
      )
    ]
  }
), z4 = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_02_credito_microempresas",
    "data-name": "02_credito_microempresas",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_02_credito_microempresas-2",
          "data-name": "02_credito_microempresas",
          transform: "translate(-0.052 1.303)",
          children: [
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40809",
                "data-name": "Trazado 40809",
                d: "M40.128,48.269h4.313a.507.507,0,0,0,.528-.528V43.428a.568.568,0,0,0-.528-.528H40.128a.568.568,0,0,0-.528.528v4.313A.568.568,0,0,0,40.128,48.269Zm.528-4.4h3.256v3.256H40.656Z",
                transform: "translate(-3.302 -5.059)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40810",
                "data-name": "Trazado 40810",
                d: "M40.128,57.069h4.313a.467.467,0,0,0,.528-.528V52.228a.568.568,0,0,0-.528-.528H40.128a.568.568,0,0,0-.528.528v4.313A.568.568,0,0,0,40.128,57.069Zm.528-4.313h3.256v3.256H40.656Z",
                transform: "translate(-3.302 -6.114)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40811",
                "data-name": "Trazado 40811",
                d: "M29.928,48.269h4.313a.507.507,0,0,0,.528-.528V43.428a.568.568,0,0,0-.528-.528H29.928a.568.568,0,0,0-.528.528v4.313A.568.568,0,0,0,29.928,48.269Zm.528-4.4h3.256v3.256H30.456V43.868Z",
                transform: "translate(-2.08 -5.059)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40812",
                "data-name": "Trazado 40812",
                d: "M24.141,51.7H19.828a.568.568,0,0,0-.528.528v4.313a.568.568,0,0,0,.528.528h4.313a.507.507,0,0,0,.528-.528V52.228A.568.568,0,0,0,24.141,51.7Zm-.528,4.313H20.356V52.756h3.256Z",
                transform: "translate(-0.869 -6.114)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40813",
                "data-name": "Trazado 40813",
                d: "M24.141,42.9H19.828a.568.568,0,0,0-.528.528v4.313a.568.568,0,0,0,.528.528h4.313a.568.568,0,0,0,.528-.528V43.428A.568.568,0,0,0,24.141,42.9Zm-.528,4.225H20.356V43.868h3.256Z",
                transform: "translate(-0.869 -5.059)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40814",
                "data-name": "Trazado 40814",
                d: "M40.128,39.369h4.313a.507.507,0,0,0,.528-.528V34.528A.568.568,0,0,0,44.441,34H40.128a.568.568,0,0,0-.528.528v4.313A.568.568,0,0,0,40.128,39.369Zm.528-4.313h3.256v3.256H40.656Z",
                transform: "translate(-3.302 -3.992)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40815",
                "data-name": "Trazado 40815",
                d: "M29.928,39.369h4.313a.507.507,0,0,0,.528-.528V34.528A.568.568,0,0,0,34.241,34H29.928a.568.568,0,0,0-.528.528v4.313A.568.568,0,0,0,29.928,39.369Zm.528-4.313h3.256v3.256H30.456V35.056Z",
                transform: "translate(-2.08 -3.992)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40816",
                "data-name": "Trazado 40816",
                d: "M24.141,34H19.828a.568.568,0,0,0-.528.528v4.313a.568.568,0,0,0,.528.528h4.313a.568.568,0,0,0,.528-.528V34.528A.568.568,0,0,0,24.141,34Zm-.528,4.313H20.356V35.056h3.256Z",
                transform: "translate(-0.869 -3.992)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40817",
                "data-name": "Trazado 40817",
                d: "M47.475,55.267H46.243V27.015a1.992,1.992,0,0,0-2.024-2.024h-1.76v-.528a2.079,2.079,0,0,0-1.76-2.024c-2.376-.352-5.809-.616-8.273-.7-.7,0-1.408-.088-2.112-.088a8.156,8.156,0,0,1,1.144-2.376.323.323,0,0,0,.088-.264c0-.7.176-7.041,4.137-10.385,3.609-2.992,9.417-2.464,11-2.376-.088,1.584-.616,7.041-4.225,10.033-2.64,2.2-6.513,2.64-8.977,2.64a22.13,22.13,0,0,1,3.961-6.249.56.56,0,1,0-.792-.792,24.232,24.232,0,0,0-4.4,7.393,1.116,1.116,0,0,0,.088.528.484.484,0,0,0,.44.264c2.464.088,7.217-.176,10.473-2.9,4.665-3.873,4.665-11.09,4.665-11.354a.558.558,0,0,0-.44-.528c-.352-.088-7.833-1.408-12.5,2.464-4.049,3.52-4.489,9.769-4.489,11.09a6.564,6.564,0,0,0-.616,1.056c-.176-.528-.352-1.056-.528-1.5.088-1.408.7-8.449-3.256-12.938C21.6.436,13.062.7,12.71.7a.493.493,0,0,0-.528.44c0,.264-1.144,8.185,3.344,13.2,3.168,3.52,8.361,4.577,11.178,4.929a.672.672,0,0,0,.44-.176.66.66,0,0,0,.088-.44,24.355,24.355,0,0,0-3.7-8.8.574.574,0,0,0-.968.616,26.479,26.479,0,0,1,3.344,7.745c-2.728-.44-7.041-1.584-9.681-4.489C12.71,9.765,12.974,3.6,13.15,1.844c1.848.088,8.449.44,12.058,4.4,3.873,4.313,2.992,11.442,2.9,12.234a.323.323,0,0,0,.088.264,10.324,10.324,0,0,1,.88,2.9h-1.5c-2.464.088-5.809.352-8.185.7a2,2,0,0,0-1.76,2.024V24.9h-1.76a1.992,1.992,0,0,0-2.024,2.024V55.179H12.622a.528.528,0,1,0,0,1.056H47.563a.486.486,0,1,0-.088-.968ZM15.087,27.015a.977.977,0,0,1,.968-.968h2.288a.568.568,0,0,0,.528-.528V24.463a.957.957,0,0,1,.792-.968c2.288-.352,5.721-.616,8.1-.7a42.807,42.807,0,0,1,4.753,0c2.376.088,5.721.352,8.1.7a1.031,1.031,0,0,1,.792.968v1.056a.568.568,0,0,0,.528.528h2.288a.977.977,0,0,1,.968.968V55.267H34.449V47.434a.568.568,0,0,0-.528-.528H26.264a.568.568,0,0,0-.528.528v7.833H15.087Zm15.49,20.947h2.816v7.305H30.577Zm-1.056,7.305H26.792V47.962h2.728Z",
                transform: "translate(0 0)",
                fill: "#ee2b7b"
              }
            )
          ]
        }
      )
    ]
  }
), x4 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_10_credito_salud",
    "data-name": "10_credito_salud",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h("g", { id: "_10_credito_salud-2", "data-name": "10_credito_salud", transform: "translate(0.8 -0.5)", children: [
        /* @__PURE__ */ r("g", { id: "Grupo_16562", "data-name": "Grupo 16562", transform: "translate(6.2 3.5)", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40842",
            "data-name": "Trazado 40842",
            d: "M46.389,57.086H8.695A2.484,2.484,0,0,1,6.2,54.591V5.995A2.484,2.484,0,0,1,8.695,3.5H46.3a2.484,2.484,0,0,1,2.495,2.495V21.146a.739.739,0,1,1-1.478,0V5.995A1.025,1.025,0,0,0,46.3,4.978H8.695A1.025,1.025,0,0,0,7.678,5.995V54.684A1.025,1.025,0,0,0,8.695,55.7H46.3a1.025,1.025,0,0,0,1.016-1.016V40.641a.739.739,0,1,1,1.478,0V54.591A2.466,2.466,0,0,1,46.389,57.086Z",
            transform: "translate(-6.2 -3.5)",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16563", "data-name": "Grupo 16563", transform: "translate(13.776 27.798)", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40843",
            "data-name": "Trazado 40843",
            d: "M40.269,31.278H15.139a.739.739,0,1,1,0-1.478h25.13a.8.8,0,0,1,.739.739A.729.729,0,0,1,40.269,31.278Z",
            transform: "translate(-14.4 -29.8)",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16564", "data-name": "Grupo 16564", transform: "translate(13.684 36.483)", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40844",
            "data-name": "Trazado 40844",
            d: "M30.745,40.678H15.039a.739.739,0,1,1,0-1.478H30.745a.8.8,0,0,1,.739.739A.729.729,0,0,1,30.745,40.678Z",
            transform: "translate(-14.3 -39.2)",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16565", "data-name": "Grupo 16565", transform: "translate(13.684 45.075)", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40845",
            "data-name": "Trazado 40845",
            d: "M22.8,49.978H15.039a.739.739,0,1,1,0-1.478H22.8a.8.8,0,0,1,.739.739A.729.729,0,0,1,22.8,49.978Z",
            transform: "translate(-14.3 -48.5)",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16566", "data-name": "Grupo 16566", transform: "translate(20.798 7.103)", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40846",
            "data-name": "Trazado 40846",
            d: "M31.793,22H26.712a.8.8,0,0,1-.739-.739V18.025H22.739A.8.8,0,0,1,22,17.286V12.2a.8.8,0,0,1,.739-.739h3.234V8.139a.8.8,0,0,1,.739-.739h5.081a.8.8,0,0,1,.739.739v3.234h3.234a.8.8,0,0,1,.739.739v5.081a.8.8,0,0,1-.739.739H32.532v3.234A.815.815,0,0,1,31.793,22Zm-4.342-1.478h3.6V17.193a.8.8,0,0,1,.739-.739h3.234v-3.6H31.793a.8.8,0,0,1-.739-.739V8.878h-3.6v3.234a.8.8,0,0,1-.739.739H23.478v3.6h3.234a.8.8,0,0,1,.739.739Z",
            transform: "translate(-22 -7.4)",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40847",
            "data-name": "Trazado 40847",
            d: "M54.877,32.242,50.72,28.085a1.313,1.313,0,0,0-.554-.185.781.781,0,0,0-.554.185L36.769,40.927a.09.09,0,0,1-.092.092h0V41.2L34,47.949c-.092.277,0,.462.185.832a.76.76,0,0,0,.832.185l6.652-2.587a.7.7,0,0,0,.37-.185h.092L54.969,33.259A.84.84,0,0,0,54.877,32.242ZM37.6,42.775l2.587,2.587L36.03,46.932Zm3.88,1.848-3.141-3.141L50.165,29.655,53.306,32.8Z",
            transform: "translate(-2.113 -1.857)",
            fill: "#ee2b7b"
          }
        )
      ] })
    ]
  }
), P4 = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_03_credito_sector_agro",
    "data-name": "03_credito_sector_agro",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_03_credito_sector_agro-2",
          "data-name": "03_credito_sector_agro",
          transform: "translate(0 0.3)",
          children: [
            /* @__PURE__ */ h("g", { id: "Grupo_16551", "data-name": "Grupo 16551", transform: "translate(3 26.992)", children: [
              /* @__PURE__ */ r("g", { id: "Grupo_16548", "data-name": "Grupo 16548", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40818",
                  "data-name": "Trazado 40818",
                  d: "M9.521,54.631H3.634a.634.634,0,0,1,0-1.268h5.8A1.238,1.238,0,0,0,10.7,52.1V31.536a1.238,1.238,0,0,0-1.268-1.268h-5.8a.634.634,0,1,1,0-1.268h5.8a2.628,2.628,0,0,1,2.627,2.627V52.1A2.592,2.592,0,0,1,9.521,54.631Z",
                  transform: "translate(-3 -29)",
                  fill: "#ee2b7b"
                }
              ) }),
              /* @__PURE__ */ r("g", { id: "Grupo_16549", "data-name": "Grupo 16549", transform: "translate(12.227 3.351)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40819",
                  "data-name": "Trazado 40819",
                  d: "M41.5,41.666a.619.619,0,0,1-.634-.634v-.543a1,1,0,0,0-1-1H32.622c-.181,0-.272,0-.362-.091l-7.608-5.434H17.134a.634.634,0,1,1,0-1.268h7.789c.181,0,.272,0,.362.091l7.608,5.434h6.974a2.4,2.4,0,0,1,2.355,2.355v.543A.789.789,0,0,1,41.5,41.666Z",
                  transform: "translate(-16.5 -32.7)",
                  fill: "#ee2b7b"
                }
              ) }),
              /* @__PURE__ */ r("g", { id: "Grupo_16550", "data-name": "Grupo 16550", transform: "translate(11.14 7.517)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40820",
                  "data-name": "Trazado 40820",
                  d: "M35.226,52.969a18.013,18.013,0,0,1-6.159-1.087,16.908,16.908,0,0,1-3.17-1.449,24.915,24.915,0,0,0-2.717-1.268,20.852,20.852,0,0,0-7.246-1.54.634.634,0,0,1,0-1.268,21.455,21.455,0,0,1,7.789,1.63,16.052,16.052,0,0,1,2.808,1.359A21.813,21.813,0,0,0,29.52,50.7c6.974,2.445,13.042-.091,16.846-2.717,1-.634,1.9-1.359,2.9-2.083,1.54-1.087,3.079-2.264,4.8-3.261l.272-.181a10.024,10.024,0,0,0,1.449-1,1.353,1.353,0,0,0,.453-1.63,2.059,2.059,0,0,0-1.993-1.177c-1.449-.091-3.261,1-4.166,1.54l-7.246,4.076c-.091,0-.091.091-.181.091-4.529,1.087-15.306.091-15.759,0a.681.681,0,1,1,.091-1.359c.091,0,10.868,1.087,15.125,0l7.155-3.985a10.251,10.251,0,0,1,4.8-1.721h.091a3.342,3.342,0,0,1,3.17,1.993,2.876,2.876,0,0,1-.815,3.17,10.457,10.457,0,0,1-1.721,1.268l-.272.091a41.584,41.584,0,0,0-4.619,3.17c-.906.725-1.9,1.359-2.9,2.083A21.235,21.235,0,0,1,35.226,52.969Z",
                  transform: "translate(-15.3 -37.3)",
                  fill: "#ee2b7b"
                }
              ) })
            ] }),
            /* @__PURE__ */ r("g", { id: "Grupo_16555", "data-name": "Grupo 16555", transform: "translate(30.103 7.7)", children: /* @__PURE__ */ h("g", { id: "Grupo_16554", "data-name": "Grupo 16554", children: [
              /* @__PURE__ */ r("g", { id: "Grupo_16552", "data-name": "Grupo 16552", transform: "translate(1.654)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40821",
                  "data-name": "Trazado 40821",
                  d: "M43.852,27.354A15.275,15.275,0,0,1,35.067,24a.5.5,0,0,1-.272-.453c0-.181-.634-5.434,2.9-8.785,2.264-2.083,4.981-2.445,7.517-2.717a13.087,13.087,0,0,0,5.706-1.63,5.944,5.944,0,0,0,1.54-2.264.681.681,0,0,1,.634-.453.762.762,0,0,1,.634.362,15.5,15.5,0,0,1-1.359,14.129,10.378,10.378,0,0,1-6.793,4.891A5.273,5.273,0,0,1,43.852,27.354ZM36.063,23.1c3.261,2.355,6.521,3.261,9.329,2.717a8.724,8.724,0,0,0,5.887-4.347A14.51,14.51,0,0,0,53,9.964a5.96,5.96,0,0,1-1.268,1.359c-1.9,1.359-4.166,1.63-6.34,1.9-2.536.272-4.891.634-6.793,2.445C36.063,18.206,36.063,22.01,36.063,23.1Z",
                  transform: "translate(-34.751 -7.7)",
                  fill: "#ee2b7b"
                }
              ) }),
              /* @__PURE__ */ r("g", { id: "Grupo_16553", "data-name": "Grupo 16553", transform: "translate(0 10.144)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40822",
                  "data-name": "Trazado 40822",
                  d: "M33.717,27.866a.333.333,0,0,1-.272-.091h-.091a.707.707,0,0,1-.362-.362.577.577,0,0,1,0-.543,13.38,13.38,0,0,1,7.517-6.883A15.585,15.585,0,0,1,45.22,18.9a.619.619,0,0,1,.634.634c0,.362-.272.815-.634.815a14.53,14.53,0,0,0-4.257,1,12.175,12.175,0,0,0-6.7,6.159A.612.612,0,0,1,33.717,27.866Z",
                  transform: "translate(-32.925 -18.9)",
                  fill: "#ee2b7b"
                }
              ) })
            ] }) })
          ]
        }
      )
    ]
  }
), Z4 = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_06_Icono_cubrir_imprevistos",
    "data-name": "06_Icono_cubrir_imprevistos",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_06_Icono_cubrir_imprevistos-2",
          "data-name": "06_Icono_cubrir_imprevistos",
          transform: "translate(0.3 0.5)",
          children: [
            /* @__PURE__ */ r("g", { id: "Grupo_16729", "data-name": "Grupo 16729", transform: "translate(21.315 22.663)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41066",
                "data-name": "Trazado 41066",
                d: "M31.685,39.015a1.3,1.3,0,0,1-.547-.182c-1.825-1.095-7.937-5.109-7.937-9.306A4.906,4.906,0,0,1,28.127,24.6a4.763,4.763,0,0,1,3.558,1.551A4.763,4.763,0,0,1,35.243,24.6a4.906,4.906,0,0,1,4.927,4.927c0,4.2-6.113,8.211-7.937,9.306A1.3,1.3,0,0,1,31.685,39.015Zm.274-1.551Zm-.547,0ZM28.127,26.151a3.428,3.428,0,0,0-3.376,3.376c0,3.284,5.565,6.934,6.934,7.755,1.369-.821,6.934-4.562,6.934-7.755a3.428,3.428,0,0,0-3.376-3.376A3.091,3.091,0,0,0,32.6,27.519a1.219,1.219,0,0,1-1.825,0A3.465,3.465,0,0,0,28.127,26.151Z",
                transform: "translate(-23.2 -24.6)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16731", "data-name": "Grupo 16731", transform: "translate(11.086 10.985)", children: /* @__PURE__ */ r("g", { id: "Grupo_16730", "data-name": "Grupo 16730", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41067",
                "data-name": "Trazado 41067",
                d: "M25.866,49.023a.549.549,0,0,1-.365-.091,1.456,1.456,0,0,1-.821-.639,1.255,1.255,0,0,1-.091-1,1.345,1.345,0,0,1,1.642-.912,1.456,1.456,0,0,1,.821.639,1.255,1.255,0,0,1,.091,1A1.2,1.2,0,0,1,25.866,49.023ZM20.027,46.2a1.472,1.472,0,0,1-.821-.274,1.369,1.369,0,0,1,1.642-2.19,1.551,1.551,0,0,1,.547.912,1.03,1.03,0,0,1-.274,1A1.59,1.59,0,0,1,20.027,46.2ZM15.648,41.36a1.56,1.56,0,0,1-1.186-.639l-.091-.182a1.33,1.33,0,0,1,2.372-1.186,1.267,1.267,0,0,1,.182,1,1.161,1.161,0,0,1-.639.821A1.063,1.063,0,0,1,15.648,41.36Zm-2.372-6.021A1.279,1.279,0,0,1,12,34.243a1.351,1.351,0,0,1,1.095-1.551h.182a1.479,1.479,0,0,1,1.46,1.095,1.267,1.267,0,0,1-.182,1,1.641,1.641,0,0,1-.821.547h-.456ZM48.4,32.054a1.4,1.4,0,0,1-1.369-1.369,1.367,1.367,0,0,1,1.369-1.46,1.4,1.4,0,0,1,1.369,1.369A1.424,1.424,0,0,1,48.4,32.054Zm-1.277-6.478a1.545,1.545,0,0,1-1.277-.821,1.866,1.866,0,0,1,0-1,1.867,1.867,0,0,1,.73-.73,1.374,1.374,0,0,1,1.733.639.319.319,0,0,1,.091.182,1.866,1.866,0,0,1,0,1,1.425,1.425,0,0,1-.73.73ZM43.748,20.1a1.465,1.465,0,0,1-1-.456,1.372,1.372,0,0,1-.365-1,1.123,1.123,0,0,1,.456-.912,1.407,1.407,0,0,1,1.916.091,1.326,1.326,0,0,1-.091,1.916A1.927,1.927,0,0,1,43.748,20.1Zm-5.2-3.923A1.3,1.3,0,0,1,38,16a1.61,1.61,0,0,1-.73-.821,1.255,1.255,0,0,1,.091-1,1.487,1.487,0,0,1,1.825-.639,1.623,1.623,0,0,1,.639.73,1.255,1.255,0,0,1-.091,1A1.228,1.228,0,0,1,38.548,16.179Zm-6.3-1.733h-.274a1.328,1.328,0,0,1-1.095-1.46A1.309,1.309,0,0,1,32.253,11.8a1.177,1.177,0,0,1,1,.456,1.03,1.03,0,0,1,.274,1A1.229,1.229,0,0,1,32.253,14.446Z",
                transform: "translate(-11.987 -11.8)",
                fill: "#ee2b7b"
              }
            ) }) }),
            /* @__PURE__ */ h("g", { id: "Grupo_16738", "data-name": "Grupo 16738", transform: "translate(1.7 2.5)", children: [
              /* @__PURE__ */ h("g", { id: "Grupo_16734", "data-name": "Grupo 16734", transform: "translate(19.798 28.83)", children: [
                /* @__PURE__ */ r("g", { id: "Grupo_16732", "data-name": "Grupo 16732", transform: "translate(0 1.642)", children: /* @__PURE__ */ r(
                  "path",
                  {
                    id: "Trazado_41068",
                    "data-name": "Trazado 41068",
                    d: "M37.176,60.168H26.958a3.558,3.558,0,1,1,0-7.116h6.3a4.272,4.272,0,0,1,.73-3.467c.912-1.277,6.934-8.576,8.485-10.127,1.095-1.095,4.2-3.558,9.944-3.558a.818.818,0,0,1,.821.821V47.3a.818.818,0,0,1-.821.821,2.683,2.683,0,0,0-2.007.821l-6.751,8.485A8.342,8.342,0,0,1,37.176,60.168ZM26.958,54.877a1.754,1.754,0,0,0-1.825,1.733,1.83,1.83,0,0,0,1.825,1.825H37.176a7.221,7.221,0,0,0,5.383-2.19L49.31,47.76a4.652,4.652,0,0,1,2.372-1.277v-8.85a11.574,11.574,0,0,0-7.937,3.1c-1.551,1.551-7.481,8.758-8.3,9.944a2.052,2.052,0,0,0-.091,2.646,1.763,1.763,0,0,0,2.555,0L42.833,48.4a.822.822,0,0,1,1.369.639.77.77,0,0,1-.182.639L39.092,54.6a3.616,3.616,0,0,1-4.744.274Z",
                    transform: "translate(-23.4 -35.9)",
                    fill: "#ee2b7b"
                  }
                ) }),
                /* @__PURE__ */ r("g", { id: "Grupo_16733", "data-name": "Grupo 16733", transform: "translate(28.374)", children: /* @__PURE__ */ r(
                  "path",
                  {
                    id: "Trazado_41069",
                    "data-name": "Trazado 41069",
                    d: "M61.707,49.7H57.055A2.55,2.55,0,0,1,54.5,47.146V36.655A2.55,2.55,0,0,1,57.055,34.1h4.653a.818.818,0,0,1,.821.821v14.05A.8.8,0,0,1,61.707,49.7Zm-4.653-14.05a1.012,1.012,0,0,0-1,1V47.146a1.012,1.012,0,0,0,1,1h3.832v-12.5Z",
                    transform: "translate(-54.5 -34.1)",
                    fill: "#ee2b7b"
                  }
                ) })
              ] }),
              /* @__PURE__ */ h("g", { id: "Grupo_16737", "data-name": "Grupo 16737", children: [
                /* @__PURE__ */ r("g", { id: "Grupo_16735", "data-name": "Grupo 16735", transform: "translate(6.478)", children: /* @__PURE__ */ r(
                  "path",
                  {
                    id: "Trazado_41070",
                    "data-name": "Trazado 41070",
                    d: "M9.621,26.768h0a.818.818,0,0,1-.821-.821V15.364a.818.818,0,0,1,.821-.821,2.683,2.683,0,0,0,2.007-.821L18.38,5.237A8.816,8.816,0,0,1,25.04,2.5H35.258a3.558,3.558,0,1,1,0,7.116h-6.3a4.272,4.272,0,0,1-.73,3.467C27.32,14.36,21.3,21.659,19.748,23.21A15.173,15.173,0,0,1,9.621,26.768Zm.821-10.583v8.85a11.574,11.574,0,0,0,7.937-3.1c1.551-1.551,7.481-8.758,8.3-9.944a2.052,2.052,0,0,0,.091-2.646,1.763,1.763,0,0,0-2.555,0l-4.927,4.927a.822.822,0,0,1-1.369-.639.869.869,0,0,1,.182-.639l4.927-4.927a3.616,3.616,0,0,1,4.744-.274h7.481a1.825,1.825,0,0,0,0-3.649H24.948a7.221,7.221,0,0,0-5.383,2.19l-6.751,8.485A4.894,4.894,0,0,1,10.442,16.185Z",
                    transform: "translate(-8.8 -2.5)",
                    fill: "#ee2b7b"
                  }
                ) }),
                /* @__PURE__ */ r("g", { id: "Grupo_16736", "data-name": "Grupo 16736", transform: "translate(0 10.309)", children: /* @__PURE__ */ r(
                  "path",
                  {
                    id: "Trazado_41071",
                    "data-name": "Trazado 41071",
                    d: "M7.174,29.4H2.521A.818.818,0,0,1,1.7,28.58V14.621a.818.818,0,0,1,.821-.821H7.174a2.55,2.55,0,0,1,2.555,2.555V26.846A2.494,2.494,0,0,1,7.174,29.4ZM3.342,27.85H7.174a1.012,1.012,0,0,0,1-1v-10.4a1.012,1.012,0,0,0-1-1H3.342Z",
                    transform: "translate(-1.7 -13.8)",
                    fill: "#ee2b7b"
                  }
                ) })
              ] })
            ] })
          ]
        }
      )
    ]
  }
), C4 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_21_icono_cuida_salud",
    "data-name": "21_icono_cuida_salud",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_21_icono_cuida_salud-2",
          "data-name": "21_icono_cuida_salud",
          transform: "translate(-1 -2.04)",
          children: [
            /* @__PURE__ */ h("g", { id: "Grupo_16835", "data-name": "Grupo 16835", transform: "translate(3 24.754)", children: [
              /* @__PURE__ */ r("g", { id: "Grupo_16832", "data-name": "Grupo 16832", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41220",
                  "data-name": "Trazado 41220",
                  d: "M10.2,55.9H3.8a.8.8,0,1,1,0-1.6h6.4A1.324,1.324,0,0,0,11.5,53V30.4a1.324,1.324,0,0,0-1.3-1.3H3.8a.8.8,0,1,1,0-1.6h6.4a2.9,2.9,0,0,1,2.9,2.9V53A2.9,2.9,0,0,1,10.2,55.9Z",
                  transform: "translate(-3 -27.5)",
                  fill: "#ee2b7b"
                }
              ) }),
              /* @__PURE__ */ r("g", { id: "Grupo_16833", "data-name": "Grupo 16833", transform: "translate(11.824 3.7)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41221",
                  "data-name": "Trazado 41221",
                  d: "M44,41.3a.86.86,0,0,1-.8-.8v-.6a1,1,0,0,0-1-1H34.3c-.2,0-.3-.1-.5-.1l-8.3-6H17.2a.8.8,0,0,1,0-1.6h8.5c.2,0,.3.1.5.1l8.3,6h7.7a2.647,2.647,0,0,1,2.6,2.6v.6A.789.789,0,0,1,44,41.3Z",
                  transform: "translate(-16.4 -31.2)",
                  fill: "#ee2b7b"
                }
              ) }),
              /* @__PURE__ */ r("g", { id: "Grupo_16834", "data-name": "Grupo 16834", transform: "translate(8.675 8.3)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41222",
                  "data-name": "Trazado 41222",
                  d: "M37.3,53.2A19.889,19.889,0,0,1,30.5,52,18.669,18.669,0,0,1,27,50.4c-1-.5-1.9-1-2.9-1.4a23.022,23.022,0,0,0-8-1.7.8.8,0,1,1,0-1.6,23.689,23.689,0,0,1,8.6,1.8A17.723,17.723,0,0,1,27.8,49a24.084,24.084,0,0,0,3.3,1.5c7.7,2.7,14.3-.1,18.5-3,1.1-.7,2.1-1.5,3.2-2.2,1.7-1.2,3.4-2.5,5.2-3.6l.3-.1a11.068,11.068,0,0,0,1.6-1.1,1.494,1.494,0,0,0,.5-1.8,2.282,2.282,0,0,0-2.1-1.3h-.1a10.091,10.091,0,0,0-4.5,1.7l-8,4.5c-.1,0-.1.1-.2.1-5,1.2-16.8.1-17.3,0a.806.806,0,0,1,.2-1.6c.1,0,11.9,1.2,16.7,0L53,37.7a11.008,11.008,0,0,1,5.3-1.9h.1A3.862,3.862,0,0,1,62,38.1a3.176,3.176,0,0,1-.9,3.5A11.545,11.545,0,0,1,59.2,43l-.2.1a45.914,45.914,0,0,0-5.1,3.5c-1.1.8-2.1,1.6-3.2,2.3C46.1,51.7,41.7,53.2,37.3,53.2Z",
                  transform: "translate(-15.3 -35.8)",
                  fill: "#ee2b7b"
                }
              ) })
            ] }),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41223",
                "data-name": "Trazado 41223",
                d: "M61.424,20.477a.809.809,0,0,0-.779-.408s-.156,0-.23,0c0,0-.509,0-.587,0a6.413,6.413,0,0,0,.44-3.282,6.536,6.536,0,0,0-5.98-5.689c-.157-.01-.312-.014-.465-.014A6.444,6.444,0,0,0,49.2,12.994a1.868,1.868,0,0,0-.151.174c-.055.069-.146.185-.191.186s-.14-.116-.2-.193a1.876,1.876,0,0,0-.143-.168,6.259,6.259,0,0,0-4.078-1.932c-.2-.014-.4-.021-.6-.021a6.335,6.335,0,0,0-5.646,3.2,6.219,6.219,0,0,0-.907,3.745,6.572,6.572,0,0,0,.62,2.422l-.426,0c-.074,0-.148,0-.286-.007a.791.791,0,0,0-.725.408l-.027.047v.491l.025.045a.81.81,0,0,0,.779.413l.2,0,.536.006c.127,0,.254,0,.463-.016a.843.843,0,0,1,.646.319q3.707,3.753,7.451,7.465a3.19,3.19,0,0,0,2.255.942,3.034,3.034,0,0,0,2.048-.792c.867-.79,7.381-7.294,8.1-8.151a.255.255,0,0,1,.229-.115l1.5.007a.8.8,0,0,0,.744-.409l.027-.046v-.491ZM48.79,29.1a1.928,1.928,0,0,1-1.349-.632l-6.666-6.663h1.562a.748.748,0,0,0,.869-.585l.879-2.154,1.782,4.974s.441,1.239.542,1.509a.743.743,0,0,0,.714.521h.005a.73.73,0,0,0,.664-.57l1.289-4.389.092.229c.211.521.42,1.038.623,1.556a.769.769,0,0,0,.715.555.757.757,0,0,0,.687-.514l1.851-4.087.154.361c.243.567.486,1.135.72,1.706a.81.81,0,0,0,.825.555s.735-.007,1.1-.007l1.293,0c-.989.992-5.195,5.2-5.241,5.246,0,0-1.4,1.4-1.771,1.766A1.938,1.938,0,0,1,48.79,29.1Zm9.536-9.142a.172.172,0,0,1-.195.117s-.983-.006-1.475-.006-.957,0-1.441.007c-.1,0-.117-.009-.162-.117-.289-.7-.586-1.4-.882-2.091l-.418-.98a.714.714,0,0,0-1.358-.025l-1.853,4.084-.867-2.15a.747.747,0,0,0-.715-.543h0a.732.732,0,0,0-.69.613l-1.241,4.211-2.191-6.109a1.009,1.009,0,0,0-.161-.319.7.7,0,0,0-.546-.273.742.742,0,0,0-.673.493q-.417,1-.823,2.007l-.4.993c-.066.158-.133.315-.191.476-.024.066-.029.066-.091.066,0,0-.791,0-1.186,0s-.767,0-1.154.007c-.059,0-.081-.006-.156-.127a5.137,5.137,0,0,1,3.253-7.7,5.743,5.743,0,0,1,1.216-.136,5.036,5.036,0,0,1,3.521,1.471c.171.162.336.329.5.5l.364.364a.807.807,0,0,0,.56.266.823.823,0,0,0,.558-.258c.157-.148.309-.3.459-.456a7.8,7.8,0,0,1,.848-.787,5.1,5.1,0,0,1,7.595,6.415Z",
                transform: "translate(-3.625)",
                fill: "#ee2b7b"
              }
            )
          ]
        }
      )
    ]
  }
), V4 = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_31_diferentes_tipos_financiacion",
    "data-name": "31_diferentes_tipos_financiacion",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ r(
        "path",
        {
          id: "_31_diferentes_tipos_financiacion-2",
          "data-name": "31_diferentes_tipos_financiacion",
          d: "M30.579,53.781H7.542V18.792h9.35a.76.76,0,0,0,.771-.771V9.442H37.712V20.431a.771.771,0,1,0,1.542,0V8.671a.829.829,0,0,0-.771-.771H15.928a1.033,1.033,0,0,0-.578.193L6.193,17.25A1.37,1.37,0,0,0,6,17.828V54.552a.829.829,0,0,0,.771.771H30.579a.771.771,0,1,0,0-1.542ZM16.217,9.442V17.25H8.41ZM54.676,23.708H36.362a2.386,2.386,0,0,0-2.41,2.41v26.7a2.469,2.469,0,0,0,2.41,2.506H54.676a2.469,2.469,0,0,0,2.41-2.506v-26.7A2.386,2.386,0,0,0,54.676,23.708Zm-6.362,30.17H42.628v-5.3h5.687Zm0-6.844H42.628v-5.2h5.687Zm0-6.747H42.628v-5.2h5.687ZM55.64,52.914a.966.966,0,0,1-.964.964H49.857V41.829H55.64Zm0-12.627H49.857v-5.2H55.64Zm0-6.747H38.29a.771.771,0,0,0,0,1.542h2.8v5.2h-2.8a.771.771,0,0,0,0,1.542h2.8v5.2h-2.8a.771.771,0,0,0,0,1.542h2.8v5.3H36.362a.966.966,0,0,1-.964-.964v-26.7a.966.966,0,0,1,.964-.964v-.1H54.676a.966.966,0,0,1,.964.964ZM19.072,37.774a4.026,4.026,0,0,0,2.872,3.321.3.3,0,0,1,.246.347c-.012.244-.008.487,0,.731a.92.92,0,0,0,1.838.008,4.168,4.168,0,0,0,0-.591c-.032-.3.072-.441.374-.539a4.031,4.031,0,0,0,2.753-4.391,4.079,4.079,0,0,0-3.986-3.55,2.218,2.218,0,0,1-.519-4.385,2.225,2.225,0,0,1,2.391,1.086,2.881,2.881,0,0,1,.3,1.188.906.906,0,0,0,.947.813.9.9,0,0,0,.885-.847,3.053,3.053,0,0,0-.029-.644,4.013,4.013,0,0,0-2.86-3.329.316.316,0,0,1-.258-.366c.013-.244.009-.487,0-.731a.9.9,0,0,0-.918-.873.893.893,0,0,0-.919.868,5.237,5.237,0,0,0,0,.674c.023.262-.082.372-.334.452a4.093,4.093,0,0,0-2.822,4.2,4.144,4.144,0,0,0,3.137,3.652c.415.1.838.073,1.254.142a2.118,2.118,0,0,1,1.776,1.488A2.206,2.206,0,0,1,22.4,39.276a2.183,2.183,0,0,1-1.509-2.1.968.968,0,0,0-.262-.633.921.921,0,0,0-1.009-.217.954.954,0,0,0-.583,1A3.485,3.485,0,0,0,19.072,37.774Z",
          transform: "translate(-2 -1.9)",
          fill: "#ee2b7b"
        }
      )
    ]
  }
), O4 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_03_icono_dormir",
    "data-name": "03_icono_dormir",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h("g", { id: "_03_icono_dormir-2", "data-name": "03_icono_dormir", transform: "translate(-2.5 -2.475)", children: [
        /* @__PURE__ */ r("g", { id: "Grupo_16746", "data-name": "Grupo 16746", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41118",
            "data-name": "Trazado 41118",
            d: "M44.3,21.3a.367.367,0,0,1-.3-.1l-7.6-3a.43.43,0,0,1-.4-.4.638.638,0,0,1,0-.6l.4-1a1.38,1.38,0,0,1,.3-.4l9.3-6L39.3,7.2A.926.926,0,0,1,38.9,6,1,1,0,0,1,40,5.5l7.6,3A.841.841,0,0,1,48,9.6l-.3.9a1.38,1.38,0,0,1-.3.4L37.8,17l6.8,2.6a1,1,0,0,1,.5,1.1A.838.838,0,0,1,44.3,21.3Z",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16747", "data-name": "Grupo 16747", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41119",
            "data-name": "Trazado 41119",
            d: "M56.6,27.9a.367.367,0,0,1-.3-.1l-5.9-2.3a1,1,0,0,1-.5-1.1l.3-.7a.781.781,0,0,1,.4-.4l6.7-4-4.8-1.9a1,1,0,0,1-.5-1.1,1,1,0,0,1,1.1-.5L59,18.1a1,1,0,0,1,.5,1.1l-.2.6a.781.781,0,0,1-.4.4L52,24.3l4.9,1.9a1,1,0,0,1,.5,1.1C57.2,27.6,56.9,27.9,56.6,27.9Z",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16748", "data-name": "Grupo 16748", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41120",
            "data-name": "Trazado 41120",
            d: "M55.5,42.7a.367.367,0,0,1-.3-.1l-4.8-1.9a1,1,0,0,1-.5-1.1l.2-.6a.781.781,0,0,1,.4-.4l5.1-3.1L52,34.1a.854.854,0,0,1,.6-1.6l4.8,1.9a1,1,0,0,1,.5.4.638.638,0,0,1,0,.6l-.2.5a.781.781,0,0,1-.4.4l-5.2,3.1,3.6,1.4a1,1,0,0,1,.5,1.1C56.1,42.5,55.8,42.7,55.5,42.7Z",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16749", "data-name": "Grupo 16749", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41121",
            "data-name": "Trazado 41121",
            d: "M23.8,39.7a.789.789,0,0,1-.8-.8V37.7c0-3.1-3-3.8-5.6-3.8-2.5,0-5.6.7-5.6,3.8v1.2a.8.8,0,0,1-1.6,0V37.7c0-1.7.7-5.5,7.2-5.5s7.2,3.8,7.2,5.5v1.2A.789.789,0,0,1,23.8,39.7Z",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16750", "data-name": "Grupo 16750", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41122",
            "data-name": "Trazado 41122",
            d: "M41.2,39.7a.789.789,0,0,1-.8-.8V37.7c0-3.1-3-3.8-5.6-3.8-2.5,0-5.6.7-5.6,3.8v1.2a.789.789,0,0,1-.8.8.86.86,0,0,1-.8-.8V37.7c0-1.7.7-5.5,7.2-5.5S42,36,42,37.7v1.2C42.1,39.4,41.7,39.7,41.2,39.7Z",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16751", "data-name": "Grupo 16751", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41123",
            "data-name": "Trazado 41123",
            d: "M45.9,59.5H42.4a1.02,1.02,0,0,1-.8-.5l-2.1-4.2H12.7L10.6,59a.792.792,0,0,1-.8.5H6.3a.789.789,0,0,1-.8-.8V42.4a.789.789,0,0,1,.8-.8H45.8a.789.789,0,0,1,.8.8V58.7A.709.709,0,0,1,45.9,59.5Zm-3-1.7H45V43.2H7.2V57.8H9.3l2.1-4.2a.792.792,0,0,1,.8-.5H40.1a1.02,1.02,0,0,1,.8.5Z",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16752", "data-name": "Grupo 16752", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41124",
            "data-name": "Trazado 41124",
            d: "M45.9,39.7a.789.789,0,0,1-.8-.8v-10c-3.6-1.8-11.4-3.1-18.9-3.1S10.9,27.1,7.3,28.9v10a.789.789,0,0,1-.8.8.86.86,0,0,1-.8-.8V28.4a.842.842,0,0,1,.4-.7c3.7-2.1,12-3.6,20.2-3.6,8.1,0,16.6,1.5,20.2,3.6a.755.755,0,0,1,.4.7V38.9A1.15,1.15,0,0,1,45.9,39.7Z",
            fill: "#ee2b7b"
          }
        ) })
      ] })
    ]
  }
), E4 = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_24_icono_durante_formacion",
    "data-name": "24_icono_durante_formacion",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_24_icono_durante_formacion-2",
          "data-name": "24_icono_durante_formacion",
          transform: "translate(0.1 -0.5)",
          children: [
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40795",
                "data-name": "Trazado 40795",
                d: "M47.584,40.885a.9.9,0,0,0-.839.839V54.2a.9.9,0,0,1-.839.839H9.417a.9.9,0,0,1-.839-.839V7.017a.9.9,0,0,1,.839-.839h36.49a.9.9,0,0,1,.839.839V21.7a.839.839,0,1,0,1.678,0V7.017A2.552,2.552,0,0,0,45.907,4.5H9.417A2.552,2.552,0,0,0,6.9,7.017V54.2a2.552,2.552,0,0,0,2.517,2.517h36.49A2.552,2.552,0,0,0,48.423,54.2V41.724A.9.9,0,0,0,47.584,40.885Z",
                transform: "translate(0 0)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40796",
                "data-name": "Trazado 40796",
                d: "M39.909,27.839A.9.9,0,0,0,39.071,27H14.639a.839.839,0,1,0,0,1.678H39.071C39.49,28.678,39.8,28.258,39.909,27.839Z",
                transform: "translate(0.335 1.093)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40797",
                "data-name": "Trazado 40797",
                d: "M30.682,35.839A.9.9,0,0,0,29.843,35h-15.2a.839.839,0,1,0,0,1.678h15.2A.9.9,0,0,0,30.682,35.839Z",
                transform: "translate(0.335 1.481)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40798",
                "data-name": "Trazado 40798",
                d: "M14.539,42.9a.839.839,0,1,0,0,1.678h7.55a.827.827,0,0,0,.839-.839.9.9,0,0,0-.839-.839Z",
                transform: "translate(0.33 1.865)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40799",
                "data-name": "Trazado 40799",
                d: "M52.512,29.033l-4.57-4.57a1.441,1.441,0,0,0-.609-.2.857.857,0,0,0-.609.2L32.848,38.374a1.691,1.691,0,0,0-.384.567c-.055.178-2.9,7.357-2.9,7.357-.1.305,0,.508.2.914a.836.836,0,0,0,.914.2l7.24-2.893a2.64,2.64,0,0,0,.808-.459L52.615,30.151A.925.925,0,0,0,52.512,29.033ZM33.521,40.61l2.844,2.844L31.8,45.18Zm4.266,2.031-3.453-3.453,13-13,3.453,3.453Z",
                transform: "translate(1.099 0.96)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ h("g", { id: "Grupo_16546", "data-name": "Grupo 16546", transform: "translate(15.794 9.208)", children: [
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40800",
                  "data-name": "Trazado 40800",
                  d: "M38.145,13.092a.605.605,0,0,0-.394-.459L27.005,9.055a.447.447,0,0,0-.431-.018l-10.788,3.6a.6.6,0,0,0,0,1.127l3.085,1.051v5.506a.6.6,0,0,0,.4.56,21.943,21.943,0,0,0,7.52,1.327,23.661,23.661,0,0,0,7.585-1.289.6.6,0,0,0,.406-.563V14.771c.795-.277,1.5-.505,2.044-.681l.137-.044v3.981a.611.611,0,0,0,.617.617.586.586,0,0,0,.617-.58V13.342A.593.593,0,0,0,38.145,13.092Zm-2.473.1-8.887,2.962L17.9,13.2l8.887-2.962ZM20.1,15.211l6.508,2.181.176.018c.036,0,.129,0,6.758-2.233V19.9a20.974,20.974,0,0,1-13.443,0Z",
                  transform: "translate(-15.382 -8.99)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40801",
                  "data-name": "Trazado 40801",
                  d: "M36.576,18.6a.611.611,0,0,0-.617.617V19.4a.617.617,0,0,0,1.233,0v-.181A.611.611,0,0,0,36.576,18.6Z",
                  transform: "translate(-14.383 -8.523)",
                  fill: "#ee2b7b"
                }
              )
            ] })
          ]
        }
      )
    ]
  }
), H4 = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_03_icono_ecosistema_creativo",
    "data-name": "03_icono_ecosistema_creativo",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ r(
        "path",
        {
          id: "_03_icono_ecosistema_creativo-2",
          "data-name": "03_icono_ecosistema_creativo",
          d: "M9.446,27.276h0a.882.882,0,0,0-.8-.9h-6.4a.789.789,0,0,0-.8.8h0a.789.789,0,0,0,.8.8h6.4A.709.709,0,0,0,9.446,27.276Zm44.2-.9h-6.4a.789.789,0,0,0-.8.8h0a.789.789,0,0,0,.8.8h6.4a.789.789,0,0,0,.8-.8h0C54.546,26.776,54.146,26.376,53.646,26.376Zm-41.7,10.1a.926.926,0,0,0-1.2-.3l-5.5,3.2a.926.926,0,0,0-.3,1.2h0a.926.926,0,0,0,1.2.3l5.5-3.2a1.054,1.054,0,0,0,.3-1.2Zm32-18.5a.926.926,0,0,0,1.2.3l5.5-3.2a.926.926,0,0,0,.3-1.2h0a.926.926,0,0,0-1.2-.3l-5.5,3.2a.954.954,0,0,0-.3,1.2Zm-6.7-6.8h0a.954.954,0,0,0,1.2-.3l3.2-5.5a.954.954,0,0,0-.3-1.2h0a.954.954,0,0,0-1.2.3l-3.2,5.5A.837.837,0,0,0,37.246,11.176Zm-9.4-2.4h0a.882.882,0,0,0,.9-.8v-6.5a.789.789,0,0,0-.8-.8h0a.789.789,0,0,0-.8.8v6.4A.748.748,0,0,0,27.846,8.776Zm-10.3,2.1a.926.926,0,0,0,1.2.3h0a.926.926,0,0,0,.3-1.2l-3.2-5.5a.926.926,0,0,0-1.2-.3.926.926,0,0,0-.3,1.2Zm33.1,28.5-5.5-3.2a.875.875,0,0,0-.9,1.5l5.5,3.2a.954.954,0,0,0,1.2-.3A.837.837,0,0,0,50.646,39.376Zm-39-22.5-5.5-3.2a.954.954,0,0,0-1.2.3.856.856,0,0,0,.3,1.2l5.5,3.2a.954.954,0,0,0,1.2-.3A.837.837,0,0,0,11.646,16.876Zm23.4,9.5h-.8a.367.367,0,0,0-.3.1,5.8,5.8,0,0,0-1.2-2.9.215.215,0,0,0,.2-.2l.6-.6a.91.91,0,0,0,0-1.2h0a.91.91,0,0,0-1.2,0l-.6.6c-.1.1-.1.2-.2.2a5.33,5.33,0,0,0-3-1.2c0-.1.1-.2.1-.3v-.8a.8.8,0,1,0-1.6,0v.8a.367.367,0,0,0,.1.3,6.72,6.72,0,0,0-3,1.3c0-.1-.1-.2-.2-.3l-.5-.5a.849.849,0,0,0-1.2,1.2l.6.6c.1.1.2.2.3.2a5.8,5.8,0,0,0-1.2,2.9.6.6,0,0,0-.4-.1h-.8a.8.8,0,0,0,0,1.6h.8c.2,0,.3-.1.4-.1a5.445,5.445,0,0,0,1.3,3c-.2,0-.3.1-.5.2l-.6.6a.849.849,0,0,0,1.2,1.2l.6-.6a.764.764,0,0,0,.2-.5,6.271,6.271,0,0,0,3,1.3.6.6,0,0,0-.1.4v.8a.8.8,0,1,0,1.6,0v-.8a.6.6,0,0,0-.1-.4,5.63,5.63,0,0,0,3-1.2.758.758,0,0,0,.2.4l.6.6a.849.849,0,0,0,1.2-1.2l-.6-.6c-.1-.1-.2-.2-.3-.2a5.875,5.875,0,0,0,1.3-3c.1,0,.2.1.3.1h.8a.789.789,0,0,0,.8-.8A.882.882,0,0,0,35.046,26.376Zm-7.1,5.4a4.5,4.5,0,1,1,4.5-4.5A4.481,4.481,0,0,1,27.946,31.776Zm-6.7,14.23a1.042,1.042,0,0,1-1.065-1.064,14.707,14.707,0,0,0-3.308-9.4,14.632,14.632,0,0,1-3.348-10.708A14.611,14.611,0,0,1,26.228,11.965l1.5,0A14.1,14.1,0,0,1,37.59,15.64a14.55,14.55,0,0,1,4.854,10.7A14.189,14.189,0,0,1,39.438,35.2a16.05,16.05,0,0,0-3.308,9.743c.154.514-.007.735-.083.812a1.011,1.011,0,0,1-.642.253H21.242Zm9.327-7.249c.866.363.879.811.791,1.162l-.748,4.3h4.057l.013-.286a17.5,17.5,0,0,1,3.523-9.73,12.342,12.342,0,0,0,2.619-7.688,13.179,13.179,0,0,0-4.189-9.434,12.3,12.3,0,0,0-8.4-3.152H26.7A12.625,12.625,0,0,0,15.483,25.12a12.819,12.819,0,0,0,2.8,9.431,15.211,15.211,0,0,1,3.687,9.38l.013.286h4.059l-.747-4.107a.558.558,0,0,1,.061-.458,1.214,1.214,0,0,1,.741-.562l.269.009a1.178,1.178,0,0,1,.91.819l.713,4.3h.863l.542-4.7a.931.931,0,0,1,.9-.758h.283Zm5.751,9.725a.854.854,0,0,1-.879.879H21.312a.854.854,0,0,1-.879-.879.78.78,0,0,1,.879-.88H35.441A.855.855,0,0,1,36.32,48.482Zm-1.262,3.2a.854.854,0,0,1-.879.88h-11.6a.855.855,0,0,1-.88-.88.78.78,0,0,1,.88-.88H34.179A.855.855,0,0,1,35.058,51.678Zm-1.787,3.441-.01.028A5.145,5.145,0,0,1,28.85,57.94h-.841a4.931,4.931,0,0,1-4.3-2.617L23.549,55a.88.88,0,0,1-.1-.63.7.7,0,0,1,.393-.427.831.831,0,0,1,.463-.119.684.684,0,0,1,.593.415l.167.336a3.252,3.252,0,0,0,2.94,1.772h.841a3.429,3.429,0,0,0,2.94-1.94.777.777,0,0,1,.759-.415l.543.006C33.4,54.1,33.359,54.662,33.271,55.119Z",
          transform: "translate(1.554 0.324)",
          fill: "#ee2b7b"
        }
      )
    ]
  }
), L4 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_17_icono_educacion",
    "data-name": "17_icono_educacion",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_17_icono_educacion-2",
          "data-name": "17_icono_educacion",
          transform: "translate(1.304 13.258)",
          children: [
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40781",
                "data-name": "Trazado 40781",
                d: "M56.188,10.516a.846.846,0,0,0-.559-.726L28.74.828A.545.545,0,0,0,28.167.82L1.258,9.79a.845.845,0,0,0-.562.785.834.834,0,0,0,.56.785l8.138,2.772v14.2a.832.832,0,0,0,.557.783,54.086,54.086,0,0,0,18.536,3.271A58.389,58.389,0,0,0,47.2,29.207a.834.834,0,0,0,.562-.785V14.039c2.182-.768,4.127-1.4,5.553-1.859.457-.148.859-.278,1.2-.39V22.624a.875.875,0,0,0,.883.883.8.8,0,0,0,.883-.793V10.937A.771.771,0,0,0,56.188,10.516Zm-3.467.058L28.488,18.652,4.255,10.574,28.488,2.5Zm-41.56,4.117,17.1,5.728.232.008c.159,0,13.079-4.334,17.509-5.827V27.767a52.959,52.959,0,0,1-34.837,0V14.691Z",
                transform: "translate(0 0)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40782",
                "data-name": "Trazado 40782",
                d: "M60.979,26.519a.875.875,0,0,0-.883.883v.453a.883.883,0,1,0,1.767,0V27.4A.876.876,0,0,0,60.979,26.519Z",
                transform: "translate(-5.582 -2.422)",
                fill: "#ee2b7b"
              }
            )
          ]
        }
      )
    ]
  }
), k4 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_20_icono_elegir",
    "data-name": "20_icono_elegir",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h("g", { id: "_20_icono_elegir-2", "data-name": "20_icono_elegir", transform: "translate(-4.012 -2.49)", children: [
        /* @__PURE__ */ r("g", { id: "Grupo_16830", "data-name": "Grupo 16830", children: /* @__PURE__ */ h("g", { id: "Grupo_16829", "data-name": "Grupo 16829", children: [
          /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41214",
              "data-name": "Trazado 41214",
              d: "M46.6,33.1c-.2,0-.4.1-.6.1a3.523,3.523,0,0,0-4.6-1.7,3.51,3.51,0,0,0-3.3-2.2,4.253,4.253,0,0,0-1.1.2v-9a3.6,3.6,0,1,0-7.2,0v9.872A4.65,4.65,0,0,0,25.891,34.9v7.6a10.932,10.932,0,0,0,4.1,8.2.764.764,0,0,0,.5.2.713.713,0,0,0,.6-.3c.3-.3.065-.935-.235-1.235a9.21,9.21,0,0,1-3.5-7v-7.6A2.99,2.99,0,0,1,29.8,31.987V38.6a.789.789,0,0,0,.8.8c.5,0,.619-.4.619-.8V20.5A2.207,2.207,0,0,1,33.5,18.4a2.051,2.051,0,0,1,2.1,2.1V30.8a.752.752,0,0,0,.5.7.619.619,0,0,0,.8-.1,2.389,2.389,0,0,1,1.4-.5,2.077,2.077,0,0,1,2.1,1.9c0,.3.2.5.5.7a.605.605,0,0,0,.8-.1,1.974,1.974,0,0,1,1.4-.6,2.041,2.041,0,0,1,2,1.5,1,1,0,0,0,.4.5.638.638,0,0,0,.6,0,2.354,2.354,0,0,1,.8-.2A2.051,2.051,0,0,1,49,36.7v8.8a5.664,5.664,0,0,1-1.7,4.1c-.4.4-.255,1.191.37,1.2a.816.816,0,0,0,.205-.022c.28-.071.432-.3.624-.544.162-.205.314-.418.456-.637A7.641,7.641,0,0,0,50.2,45.5V36.7A3.585,3.585,0,0,0,46.6,33.1Z",
              fill: "#ee2b7b"
            }
          ),
          /* @__PURE__ */ r("g", { id: "Grupo_16828", "data-name": "Grupo 16828", children: /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41215",
              "data-name": "Trazado 41215",
              d: "M50.4,60.5a.789.789,0,0,1-.8-.8V55.54c0-.3-.5-.7-1.1-.7H28.2c-.7,0-1.1.3-1.1.7V59.7a.8.8,0,1,1-1.6,0V55.4a2.494,2.494,0,0,1,2.7-2.2H48.4a2.494,2.494,0,0,1,2.7,2.2v4.3A.666.666,0,0,1,50.4,60.5Z",
              fill: "#ee2b7b"
            }
          ) })
        ] }) }),
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41216",
            "data-name": "Trazado 41216",
            d: "M48.343,4.491h-22.5a1.652,1.652,0,0,0-.62.177l-9.035,9.124a1.274,1.274,0,0,0-.177.62V50.995a.856.856,0,0,0,.8.8h8.9a.8.8,0,0,0,0-1.594H17.518V15.3h9.3a.793.793,0,0,0,.8-.8V6h19.93V25.4a.8.8,0,1,0,1.594,0V5.288A.856.856,0,0,0,48.343,4.491ZM26.2,13.792H18.4L26.2,6Z",
            fill: "#ee2b7b"
          }
        )
      ] })
    ]
  }
), N4 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_08_icono_emociones",
    "data-name": "08_icono_emociones",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h("g", { id: "_08_icono_emociones-2", "data-name": "08_icono_emociones", transform: "translate(-2.5 -2.5)", children: [
        /* @__PURE__ */ r("g", { id: "Grupo_16783", "data-name": "Grupo 16783", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41146",
            "data-name": "Trazado 41146",
            d: "M18.8,6.5A12.3,12.3,0,1,0,31.1,18.8,12.291,12.291,0,0,0,18.8,6.5Zm0,1.5A10.8,10.8,0,1,1,8,18.8,10.755,10.755,0,0,1,18.8,8Z",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16784", "data-name": "Grupo 16784", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41147",
            "data-name": "Trazado 41147",
            d: "M24.7,22.8a.734.734,0,0,0-.6-1.2.675.675,0,0,0-.6.4,5.525,5.525,0,0,1-4.7,2.4A5.651,5.651,0,0,1,14.1,22a.822.822,0,0,0-.6-.4.734.734,0,0,0-.6,1.2,6.95,6.95,0,0,0,5.9,3A6.95,6.95,0,0,0,24.7,22.8Z",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16785", "data-name": "Grupo 16785", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41148",
            "data-name": "Trazado 41148",
            d: "M46.2,6.5A12.3,12.3,0,1,0,58.5,18.8,12.291,12.291,0,0,0,46.2,6.5Zm0,1.5A10.8,10.8,0,1,1,35.4,18.8,10.755,10.755,0,0,1,46.2,8Z",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16786", "data-name": "Grupo 16786", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41149",
            "data-name": "Trazado 41149",
            d: "M42,22.1a.807.807,0,0,0,0,1.6h8.4a.807.807,0,0,0,0-1.6Z",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16787", "data-name": "Grupo 16787", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41150",
            "data-name": "Trazado 41150",
            d: "M18.8,33.9A12.3,12.3,0,1,0,31.1,46.2,12.291,12.291,0,0,0,18.8,33.9Zm0,1.5A10.8,10.8,0,1,1,8,46.2,10.755,10.755,0,0,1,18.8,35.4Z",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16788", "data-name": "Grupo 16788", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41151",
            "data-name": "Trazado 41151",
            d: "M12.9,51.2a.782.782,0,0,0,1.1,0A4.409,4.409,0,0,1,16.2,50a3.612,3.612,0,0,1,2.3.6,5.188,5.188,0,0,0,3.3.9,5.853,5.853,0,0,0,3.3-1.7.713.713,0,0,0,.1-1.1.782.782,0,0,0-1.1,0A4.01,4.01,0,0,1,21.6,50a3.455,3.455,0,0,1-2.4-.7,4.549,4.549,0,0,0-3.3-.8,4.932,4.932,0,0,0-2.6,1.3c-.6.6-.7,1.1-.4,1.4Z",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16789", "data-name": "Grupo 16789", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41152",
            "data-name": "Trazado 41152",
            d: "M14.8,41.4a1.3,1.3,0,1,0,1.3,1.3A1.324,1.324,0,0,0,14.8,41.4Z",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16790", "data-name": "Grupo 16790", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41153",
            "data-name": "Trazado 41153",
            d: "M22.8,41.4a1.3,1.3,0,1,0,1.3,1.3A1.324,1.324,0,0,0,22.8,41.4Z",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16791", "data-name": "Grupo 16791", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41154",
            "data-name": "Trazado 41154",
            d: "M46.2,33.9A12.3,12.3,0,1,0,58.5,46.2,12.291,12.291,0,0,0,46.2,33.9Zm0,1.5A10.8,10.8,0,1,1,35.4,46.2,10.755,10.755,0,0,1,46.2,35.4Z",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16792", "data-name": "Grupo 16792", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41155",
            "data-name": "Trazado 41155",
            d: "M46.2,48a6.926,6.926,0,0,0-5.9,3.1.71.71,0,0,0,.2,1.1.829.829,0,0,0,1.1-.3,5.525,5.525,0,0,1,4.7-2.4A5.651,5.651,0,0,1,51,51.9a.8.8,0,0,0,1.1.3c.4-.2.4-.7.2-1.2A8.022,8.022,0,0,0,46.2,48Z",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16793", "data-name": "Grupo 16793", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41156",
            "data-name": "Trazado 41156",
            d: "M42.2,41.4a1.3,1.3,0,1,0,1.3,1.3A1.324,1.324,0,0,0,42.2,41.4Z",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16794", "data-name": "Grupo 16794", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41157",
            "data-name": "Trazado 41157",
            d: "M50.2,41.4a1.3,1.3,0,1,0,1.3,1.3A1.324,1.324,0,0,0,50.2,41.4Z",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16795", "data-name": "Grupo 16795", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41158",
            "data-name": "Trazado 41158",
            d: "M14.8,14a1.3,1.3,0,1,0,1.3,1.3A1.324,1.324,0,0,0,14.8,14Z",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16796", "data-name": "Grupo 16796", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41159",
            "data-name": "Trazado 41159",
            d: "M22.8,14a1.3,1.3,0,1,0,1.3,1.3A1.324,1.324,0,0,0,22.8,14Z",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16797", "data-name": "Grupo 16797", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41160",
            "data-name": "Trazado 41160",
            d: "M42.2,14a1.3,1.3,0,1,0,1.3,1.3A1.324,1.324,0,0,0,42.2,14Z",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16798", "data-name": "Grupo 16798", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41161",
            "data-name": "Trazado 41161",
            d: "M50.2,14a1.3,1.3,0,1,0,1.3,1.3A1.324,1.324,0,0,0,50.2,14Z",
            fill: "#ee2b7b"
          }
        ) })
      ] })
    ]
  }
), G4 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_41_encuentra_CIS",
    "data-name": "41_encuentra_CIS",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h("g", { id: "_41_encuentra_CIS-2", "data-name": "41_encuentra_CIS", transform: "translate(1.157 4.576)", children: [
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41306",
            "data-name": "Trazado 41306",
            d: "M47.006,10.224a5.3,5.3,0,1,0-5.3,5.3A5.335,5.335,0,0,0,47.006,10.224Zm-5.3,3.6a3.6,3.6,0,1,1,3.6-3.6A3.585,3.585,0,0,1,41.706,13.824Z",
            fill: "#ee2b7b"
          }
        ),
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41307",
            "data-name": "Trazado 41307",
            d: "M55.406,18.124,50,15.421a14.734,14.734,0,0,0,1.506-5.3,9.8,9.8,0,0,0-19.6,0A14.894,14.894,0,0,0,33.462,15.5L28.21,18.122,15.694,11.787a1.118,1.118,0,0,0-1.051-.042l-.063.032L1.343,18.444a1.02,1.02,0,0,0-.5.8v31.1a.963.963,0,0,0,.4.8.983.983,0,0,0,.9,0L15.2,44.47l12.678,6.387a1.7,1.7,0,0,0,.585.2,1.113,1.113,0,0,0,.579-.116l12.768-6.468,12.8,6.448a.937.937,0,0,0,.9.024.914.914,0,0,0,.4-.924v-31.1A.891.891,0,0,0,55.406,18.124Zm-41.2,25.039L2.643,48.944v-29.1l11.563-5.781v29.1Zm13.3,5.511-11.5-5.75v-29.1l11.5,5.75Zm13.3-5.7-11.5,5.75v-29.1l4.935-2.468c1.331,2.685,3.032,5.546,4.565,7.968a3.245,3.245,0,0,0,1.509,1.287c.023.011.047.017.07.028a3.472,3.472,0,0,0,.421.166Zm.741-18.019a1.576,1.576,0,0,1-1.241-.732c-4.2-6.6-6.6-11.7-6.6-14a8,8,0,1,1,16,0,14.562,14.562,0,0,1-1.661,5.247.656.656,0,0,0-.039.053,68.083,68.083,0,0,1-4.9,8.6A1.739,1.739,0,0,1,41.547,24.955ZM54.206,48.724l-11.6-5.8v-16.3a2.769,2.769,0,0,0,.691-.292,3.44,3.44,0,0,0,.315-.2c.053-.039.107-.074.158-.116a3.212,3.212,0,0,0,.836-.89c.9-1.4,1.832-2.931,2.715-4.478.662-1.146,1.315-2.341,1.885-3.522l5,2.5Z",
            fill: "#ee2b7b"
          }
        )
      ] })
    ]
  }
), I4 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_06_icono_equilibrio",
    "data-name": "06_icono_equilibrio",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_06_icono_equilibrio-2",
          "data-name": "06_icono_equilibrio",
          transform: "translate(-2.1 -2.252)",
          children: [
            /* @__PURE__ */ r("g", { id: "Grupo_16771", "data-name": "Grupo 16771", transform: "translate(3.492 34.092)", children: /* @__PURE__ */ r("g", { id: "Grupo_16770", "data-name": "Grupo 16770", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41138",
                "data-name": "Trazado 41138",
                d: "M4.185,34.5H59.977a.772.772,0,0,1,.783.783h0a.772.772,0,0,1-.783.783H4.185a.7.7,0,0,1-.685-.783h0A.7.7,0,0,1,4.185,34.5Z",
                transform: "translate(-3.5 -34.5)",
                fill: "#ee2b7b"
              }
            ) }) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16772", "data-name": "Grupo 16772", transform: "translate(41.567 15.495)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41139",
                "data-name": "Trazado 41139",
                d: "M51.8,34.293a9.4,9.4,0,1,1,9.4-9.4A9.527,9.527,0,0,1,51.8,34.293Zm0-17.031A7.635,7.635,0,1,0,59.431,24.9,7.645,7.645,0,0,0,51.8,17.262Z",
                transform: "translate(-42.4 -15.5)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16773", "data-name": "Grupo 16773", transform: "translate(46.124 26.708)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41140",
                "data-name": "Trazado 41140",
                d: "M51.9,30.621a5.577,5.577,0,0,1-4.7-2.349.82.82,0,0,1,.294-1.175.838.838,0,0,1,1.175.294,4.114,4.114,0,0,0,6.46,0,.856.856,0,1,1,1.468.881A5.577,5.577,0,0,1,51.9,30.621Z",
                transform: "translate(-47.056 -26.956)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16774", "data-name": "Grupo 16774", transform: "translate(44.779 20.878)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41141",
                "data-name": "Trazado 41141",
                d: "M46.581,23.936h-.2a.852.852,0,0,1-.685-.979A2.428,2.428,0,0,1,48.147,21a2.526,2.526,0,0,1,2.447,1.958.845.845,0,0,1-1.664.294.744.744,0,0,0-.783-.587.853.853,0,0,0-.783.587A.694.694,0,0,1,46.581,23.936Z",
                transform: "translate(-45.681 -21)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16775", "data-name": "Grupo 16775", transform: "translate(52.022 20.878)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41142",
                "data-name": "Trazado 41142",
                d: "M57.211,23.936a.94.94,0,0,1-.881-.685.744.744,0,0,0-.783-.587.853.853,0,0,0-.783.587.845.845,0,0,1-1.664-.294A2.428,2.428,0,0,1,55.547,21a2.526,2.526,0,0,1,2.447,1.958c.1.489-.2.881-.783.979Z",
                transform: "translate(-53.081 -21)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16777", "data-name": "Grupo 16777", transform: "translate(26.689 34.092)", children: /* @__PURE__ */ r("g", { id: "Grupo_16776", "data-name": "Grupo 16776", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41143",
                "data-name": "Trazado 41143",
                d: "M38.065,49.378H27.2L30.919,34.5h3.426ZM29.158,47.91h7.047L33.269,36.066H32.192Z",
                transform: "translate(-27.2 -34.5)",
                fill: "#ee2b7b"
              }
            ) }) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16779", "data-name": "Grupo 16779", transform: "translate(21.306 47.502)", children: /* @__PURE__ */ r("g", { id: "Grupo_16778", "data-name": "Grupo 16778", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41144",
                "data-name": "Trazado 41144",
                d: "M22.483,48.2H42.549a.772.772,0,0,1,.783.783h0a.772.772,0,0,1-.783.783H22.483a.772.772,0,0,1-.783-.783h0C21.8,48.494,22.092,48.2,22.483,48.2Z",
                transform: "translate(-21.7 -48.2)",
                fill: "#ee2b7b"
              }
            ) }) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16782", "data-name": "Grupo 16782", transform: "translate(3.1 15.252)", children: /* @__PURE__ */ r("g", { id: "Grupo_16781", "data-name": "Grupo 16781", children: /* @__PURE__ */ r("g", { id: "Grupo_16780", "data-name": "Grupo 16780", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41145",
                "data-name": "Trazado 41145",
                d: "M13.573,34.777l-.489-.489c-.1-.1-5.286-4.992-7.928-7.733h0A6.736,6.736,0,0,1,3.1,21.661a6.438,6.438,0,0,1,10.473-4.992,6.454,6.454,0,0,1,8.614.489,6.059,6.059,0,0,1,1.86,4.5,7.336,7.336,0,0,1-2.056,4.894c-2.741,2.741-7.928,7.635-7.928,7.733Zm-7.439-9.3c2.153,2.153,6.069,5.873,7.439,7.243,1.37-1.37,5.188-4.992,7.439-7.243a5.437,5.437,0,0,0,1.664-3.817,4.992,4.992,0,0,0-8.516-3.524l-.489.489-.489-.489a4.963,4.963,0,0,0-7.047,0,4.806,4.806,0,0,0-1.468,3.524,4.446,4.446,0,0,0,1.468,3.817Z",
                transform: "translate(-3.1 -15.252)",
                fill: "#ee2b7b"
              }
            ) }) }) })
          ]
        }
      )
    ]
  }
), F4 = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_24_icono_escucha_empatica",
    "data-name": "24_icono_escucha_empatica",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_24_icono_escucha_empatica-2",
          "data-name": "24_icono_escucha_empatica",
          transform: "translate(0.012 8.441)",
          children: [
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41232",
                "data-name": "Trazado 41232",
                d: "M23.188,34.659a.684.684,0,0,0-.7-.7H4.988v-17.6a.9.9,0,0,1,.9-.9h23a.773.773,0,0,0,.7-.8.684.684,0,0,0-.7-.7H5.988a2.433,2.433,0,0,0-2.4,2.4v17.6h-.6a2.006,2.006,0,0,0-2,2v.1l.4,2.3c.5,1.5,1.3,1.8,2,1.8h19.1c.4,0,.7-.5.7-.9a.684.684,0,0,0-.7-.7H3.388c-.1,0-.3,0-.5-.6l-.4-2.1a.458.458,0,0,1,.5-.4h19.5A.773.773,0,0,0,23.188,34.659Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41233",
                "data-name": "Trazado 41233",
                d: "M13.888,21.559a4.481,4.481,0,0,0,4.5,4.5,4.419,4.419,0,0,0,4.5-4.5,4.5,4.5,0,0,0-9,0Zm7.5-.1a3,3,0,1,1-3-3A2.945,2.945,0,0,1,21.388,21.459Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41234",
                "data-name": "Trazado 41234",
                d: "M18.488,27.359c-4,0-6.8,2.2-6.8,5.2a.684.684,0,0,0,.7.7,1.107,1.107,0,0,0,.9-.7c0-2.6,2.7-3.7,5.3-3.7a5.887,5.887,0,0,1,4.6,1.7.711.711,0,1,0,1.1-.9A7.239,7.239,0,0,0,18.488,27.359Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41235",
                "data-name": "Trazado 41235",
                d: "M41.488,23.359c-9.929,0-16.6,4.982-16.6,12.4v6.7c0,.45.538.8,1,.8a.783.783,0,0,0,.8-.8v-6.6c0-7.392,7.483-10.7,14.9-10.7s14.9,3.31,14.9,10.7v6.7a.783.783,0,0,0,.8.8.868.868,0,0,0,.8-.9v-6.6C58.088,28.383,51.417,23.359,41.488,23.359Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41236",
                "data-name": "Trazado 41236",
                d: "M41.488,21.359a10.4,10.4,0,1,0-10.4-10.4A10.412,10.412,0,0,0,41.488,21.359Zm0-19.1a8.71,8.71,0,0,1,8.7,8.7,8.816,8.816,0,0,1-8.7,8.7,8.7,8.7,0,1,1,0-17.4Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41237",
                "data-name": "Trazado 41237",
                d: "M5.288,36.359a.7.7,0,0,0,0,1.4h.3a.7.7,0,0,0,0-1.4Z",
                fill: "#ee2b7b"
              }
            )
          ]
        }
      )
    ]
  }
), D4 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_05_icono_experiencia",
    "data-name": "05_icono_experiencia",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_05_icono_experiencia-2",
          "data-name": "05_icono_experiencia",
          transform: "translate(0.3 0.5)",
          children: [
            /* @__PURE__ */ r("g", { id: "Grupo_16504", "data-name": "Grupo 16504", transform: "translate(21.26 22.606)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40702",
                "data-name": "Trazado 40702",
                d: "M31.661,38.974a1.293,1.293,0,0,1-.546-.182C29.3,37.7,23.2,33.7,23.2,29.513A4.892,4.892,0,0,1,28.113,24.6a4.749,4.749,0,0,1,3.548,1.547A4.749,4.749,0,0,1,35.209,24.6a4.892,4.892,0,0,1,4.913,4.913c0,4.185-6.1,8.188-7.915,9.28A1.293,1.293,0,0,1,31.661,38.974Zm.273-1.547Zm-.546,0ZM28.113,26.147a3.418,3.418,0,0,0-3.366,3.366c0,3.275,5.55,6.914,6.914,7.733,1.365-.819,6.914-4.549,6.914-7.733a3.418,3.418,0,0,0-3.366-3.366,3.082,3.082,0,0,0-2.638,1.365,1.216,1.216,0,0,1-1.82,0A3.455,3.455,0,0,0,28.113,26.147Z",
                transform: "translate(-23.2 -24.6)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16506", "data-name": "Grupo 16506", transform: "translate(11.059 10.961)", children: /* @__PURE__ */ r("g", { id: "Grupo_16505", "data-name": "Grupo 16505", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40703",
                "data-name": "Trazado 40703",
                d: "M25.827,48.918a.547.547,0,0,1-.364-.091,1.452,1.452,0,0,1-.819-.637,1.252,1.252,0,0,1-.091-1,1.341,1.341,0,0,1,1.638-.91,1.452,1.452,0,0,1,.819.637,1.252,1.252,0,0,1,.091,1A1.2,1.2,0,0,1,25.827,48.918ZM20,46.1a1.467,1.467,0,0,1-.819-.273,1.365,1.365,0,0,1,1.638-2.183,1.547,1.547,0,0,1,.546.91,1.027,1.027,0,0,1-.273,1A1.586,1.586,0,0,1,20,46.1Zm-4.367-4.822a1.555,1.555,0,0,1-1.183-.637l-.091-.182a1.326,1.326,0,0,1,2.365-1.183,1.263,1.263,0,0,1,.182,1,1.157,1.157,0,0,1-.637.819A1.06,1.06,0,0,1,15.638,41.276Zm-2.365-6A1.276,1.276,0,0,1,12,34.18a1.347,1.347,0,0,1,1.092-1.547h.182a1.475,1.475,0,0,1,1.456,1.092,1.263,1.263,0,0,1-.182,1,1.636,1.636,0,0,1-.819.546h-.455ZM48.3,32a1.4,1.4,0,0,1-1.365-1.365A1.363,1.363,0,0,1,48.3,29.176a1.4,1.4,0,0,1,1.365,1.365A1.42,1.42,0,0,1,48.3,32Zm-1.274-6.459a1.541,1.541,0,0,1-1.274-.819,1.861,1.861,0,0,1,0-1,1.862,1.862,0,0,1,.728-.728,1.37,1.37,0,0,1,1.729.637.318.318,0,0,1,.091.182,1.861,1.861,0,0,1,0,1,1.421,1.421,0,0,1-.728.728Zm-3.366-5.459a1.461,1.461,0,0,1-1-.455,1.368,1.368,0,0,1-.364-1,1.12,1.12,0,0,1,.455-.91,1.4,1.4,0,0,1,1.91.091,1.322,1.322,0,0,1-.091,1.91A1.921,1.921,0,0,1,43.658,20.079Zm-5.186-3.912a1.293,1.293,0,0,1-.546-.182,1.605,1.605,0,0,1-.728-.819,1.252,1.252,0,0,1,.091-1,1.483,1.483,0,0,1,1.82-.637,1.618,1.618,0,0,1,.637.728,1.252,1.252,0,0,1-.091,1A1.225,1.225,0,0,1,38.473,16.167ZM32.2,14.438h-.273a1.324,1.324,0,0,1-1.092-1.456A1.305,1.305,0,0,1,32.2,11.8a1.174,1.174,0,0,1,1,.455,1.027,1.027,0,0,1,.273,1A1.226,1.226,0,0,1,32.2,14.438Z",
                transform: "translate(-11.987 -11.8)",
                fill: "#ee2b7b"
              }
            ) }) }),
            /* @__PURE__ */ h("g", { id: "Grupo_16513", "data-name": "Grupo 16513", transform: "translate(1.7 2.5)", children: [
              /* @__PURE__ */ h("g", { id: "Grupo_16509", "data-name": "Grupo 16509", transform: "translate(19.742 28.748)", children: [
                /* @__PURE__ */ r("g", { id: "Grupo_16507", "data-name": "Grupo 16507", transform: "translate(0 1.638)", children: /* @__PURE__ */ r(
                  "path",
                  {
                    id: "Trazado_40704",
                    "data-name": "Trazado 40704",
                    d: "M37.137,60.1H26.948a3.548,3.548,0,0,1,0-7.1h6.277a4.26,4.26,0,0,1,.728-3.457c.91-1.274,6.914-8.552,8.461-10.1C43.506,38.356,46.6,35.9,52.33,35.9a.815.815,0,0,1,.819.819V47.272a.815.815,0,0,1-.819.819,2.675,2.675,0,0,0-2,.819L43.6,57.37A8.319,8.319,0,0,1,37.137,60.1ZM26.948,54.823a1.749,1.749,0,0,0-1.82,1.729,1.825,1.825,0,0,0,1.82,1.82H37.137A7.2,7.2,0,0,0,42.5,56.188l6.732-8.461A4.639,4.639,0,0,1,51.6,46.453V37.629a11.542,11.542,0,0,0-7.915,3.093c-1.547,1.547-7.46,8.734-8.279,9.916a2.046,2.046,0,0,0-.091,2.638,1.758,1.758,0,0,0,2.547,0l4.913-4.913A.819.819,0,0,1,44.143,49a.768.768,0,0,1-.182.637L39.048,54.55a3.606,3.606,0,0,1-4.731.273Z",
                    transform: "translate(-23.4 -35.9)",
                    fill: "#ee2b7b"
                  }
                ) }),
                /* @__PURE__ */ r("g", { id: "Grupo_16508", "data-name": "Grupo 16508", transform: "translate(28.294)", children: /* @__PURE__ */ r(
                  "path",
                  {
                    id: "Trazado_40705",
                    "data-name": "Trazado 40705",
                    d: "M61.687,49.657h-4.64A2.543,2.543,0,0,1,54.5,47.11V36.647A2.543,2.543,0,0,1,57.047,34.1h4.64a.815.815,0,0,1,.819.819v14.01A.8.8,0,0,1,61.687,49.657Zm-4.64-14.01a1.01,1.01,0,0,0-1,1V47.11a1.01,1.01,0,0,0,1,1h3.821V35.647Z",
                    transform: "translate(-54.5 -34.1)",
                    fill: "#ee2b7b"
                  }
                ) })
              ] }),
              /* @__PURE__ */ h("g", { id: "Grupo_16512", "data-name": "Grupo 16512", children: [
                /* @__PURE__ */ r("g", { id: "Grupo_16510", "data-name": "Grupo 16510", transform: "translate(6.459)", children: /* @__PURE__ */ r(
                  "path",
                  {
                    id: "Trazado_40706",
                    "data-name": "Trazado 40706",
                    d: "M9.619,26.7h0a.815.815,0,0,1-.819-.819V15.328a.815.815,0,0,1,.819-.819,2.675,2.675,0,0,0,2-.819l6.732-8.461A8.792,8.792,0,0,1,24.994,2.5H35.183a3.548,3.548,0,1,1,0,7.1H28.906a4.26,4.26,0,0,1-.728,3.457c-.91,1.274-6.914,8.552-8.461,10.1A15.13,15.13,0,0,1,9.619,26.7Zm.819-10.553v8.825a11.542,11.542,0,0,0,7.915-3.093c1.547-1.547,7.46-8.734,8.279-9.916a2.046,2.046,0,0,0,.091-2.638,1.758,1.758,0,0,0-2.547,0l-4.913,4.913A.819.819,0,0,1,17.9,13.6a.866.866,0,0,1,.182-.637L22.992,8.05a3.606,3.606,0,0,1,4.731-.273h7.46a1.82,1.82,0,0,0,0-3.639H24.9a7.2,7.2,0,0,0-5.368,2.183L12.8,14.782A4.88,4.88,0,0,1,10.438,16.146Z",
                    transform: "translate(-8.8 -2.5)",
                    fill: "#ee2b7b"
                  }
                ) }),
                /* @__PURE__ */ r("g", { id: "Grupo_16511", "data-name": "Grupo 16511", transform: "translate(0 10.28)", children: /* @__PURE__ */ r(
                  "path",
                  {
                    id: "Trazado_40707",
                    "data-name": "Trazado 40707",
                    d: "M7.159,29.357H2.519a.815.815,0,0,1-.819-.819V14.619a.815.815,0,0,1,.819-.819h4.64a2.543,2.543,0,0,1,2.547,2.547V26.81A2.487,2.487,0,0,1,7.159,29.357ZM3.338,27.81H7.159a1.01,1.01,0,0,0,1-1V16.438a1.01,1.01,0,0,0-1-1H3.338Z",
                    transform: "translate(-1.7 -13.8)",
                    fill: "#ee2b7b"
                  }
                ) })
              ] })
            ] })
          ]
        }
      )
    ]
  }
), R4 = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_05_icono_experiencias_comfama",
    "data-name": "05_icono_experiencias_comfama",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_05_icono_experiencias_comfama-2",
          "data-name": "05_icono_experiencias_comfama",
          transform: "translate(-0.899 -1.5)",
          children: [
            /* @__PURE__ */ h("g", { id: "Grupo_16935", "data-name": "Grupo 16935", transform: "translate(2.9 26.218)", children: [
              /* @__PURE__ */ r("g", { id: "Grupo_16932", "data-name": "Grupo 16932", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41372",
                  "data-name": "Trazado 41372",
                  d: "M9.919,54.4H3.765a.865.865,0,0,1,0-1.731H9.919a1.111,1.111,0,0,0,1.154-1.154V29.784a1.111,1.111,0,0,0-1.154-1.154H3.765a.865.865,0,1,1,0-1.731H9.919A3,3,0,0,1,12.9,29.881V51.61A3.032,3.032,0,0,1,9.919,54.4Z",
                  transform: "translate(-2.9 -26.9)",
                  fill: "#ee2b7b"
                }
              ) }),
              /* @__PURE__ */ r("g", { id: "Grupo_16933", "data-name": "Grupo 16933", transform: "translate(12.974 3.558)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41373",
                  "data-name": "Trazado 41373",
                  d: "M42.937,40.5a.862.862,0,0,1-.865-.865v-.577a.862.862,0,0,0-.865-.865h-7.6A.734.734,0,0,1,33.13,38l-7.98-5.673H17.265a.865.865,0,1,1,0-1.731h8.173a.734.734,0,0,1,.481.192l7.98,5.673h7.307a2.585,2.585,0,0,1,2.6,2.6v.577C43.9,40.023,43.514,40.5,42.937,40.5Z",
                  transform: "translate(-16.4 -30.6)",
                  fill: "#ee2b7b"
                }
              ) }),
              /* @__PURE__ */ r("g", { id: "Grupo_16934", "data-name": "Grupo 16934", transform: "translate(11.715 8.077)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41374",
                  "data-name": "Trazado 41374",
                  d: "M36.445,52.126a19.123,19.123,0,0,1-6.538-1.154,17.95,17.95,0,0,1-3.365-1.538c-.961-.481-1.827-.961-2.788-1.346a23.174,23.174,0,0,0-7.788-1.538.865.865,0,0,1,0-1.731,22.776,22.776,0,0,1,8.269,1.731,28.479,28.479,0,0,1,2.981,1.442,23.156,23.156,0,0,0,3.173,1.442c7.307,2.6,13.653-.1,17.691-2.884,1.058-.673,2.019-1.442,2.981-2.115,1.635-1.154,3.269-2.4,5.1-3.461l.288-.192a6.2,6.2,0,0,0,1.538-1.058,1.459,1.459,0,0,0,.481-1.538,1.927,1.927,0,0,0-1.923-1.154,9.7,9.7,0,0,0-4.327,1.635l-7.692,4.327c-.1,0-.1.1-.192.1-4.807,1.154-16.249.1-16.73,0a.871.871,0,1,1,.192-1.731c.1,0,11.442,1.154,15.961.1l7.5-4.231A10.719,10.719,0,0,1,56.54,35.3,3.833,3.833,0,0,1,60.1,37.608a3.2,3.2,0,0,1-.865,3.461,8.675,8.675,0,0,1-1.923,1.346l-.288.192a44.146,44.146,0,0,0-4.9,3.365c-1.058.769-2.019,1.538-3.077,2.211A24.2,24.2,0,0,1,36.445,52.126Z",
                  transform: "translate(-15.1 -35.3)",
                  fill: "#ee2b7b"
                }
              ) })
            ] }),
            /* @__PURE__ */ r("g", { id: "Grupo_16936", "data-name": "Grupo 16936", transform: "translate(31.345 9.5)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41375",
                "data-name": "Trazado 41375",
                d: "M43.365,31.326A10.853,10.853,0,0,1,32.5,20.461,10.865,10.865,0,1,1,43.365,31.326Zm0-20A9.134,9.134,0,1,0,52.5,20.461,9.192,9.192,0,0,0,43.365,11.327Z",
                transform: "translate(-32.5 -9.5)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16937", "data-name": "Grupo 16937", transform: "translate(36.691 22.626)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41376",
                "data-name": "Trazado 41376",
                d: "M43.579,27.237a6.344,6.344,0,0,1-5.384-2.692.907.907,0,1,1,1.538-.961,4.807,4.807,0,0,0,7.692,0,.907.907,0,1,1,1.538.961A6.344,6.344,0,0,1,43.579,27.237Z",
                transform: "translate(-38.056 -23.156)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16938", "data-name": "Grupo 16938", transform: "translate(35.178 15.75)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41377",
                "data-name": "Trazado 41377",
                d: "M41.211,19.269a.924.924,0,0,1-.865-.673,1.079,1.079,0,0,0-2.115,0,.886.886,0,1,1-1.731-.385A2.787,2.787,0,0,1,39.288,16a2.886,2.886,0,0,1,2.788,2.211.886.886,0,0,1-.673,1.058Z",
                transform: "translate(-36.481 -16)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16939", "data-name": "Grupo 16939", transform: "translate(43.637 15.75)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41378",
                "data-name": "Trazado 41378",
                d: "M46.165,19.269h-.192a.886.886,0,0,1-.673-1.058A2.787,2.787,0,0,1,48.088,16a2.886,2.886,0,0,1,2.788,2.211.886.886,0,1,1-1.731.385,1.079,1.079,0,0,0-2.115,0A.924.924,0,0,1,46.165,19.269Z",
                transform: "translate(-45.281 -16)",
                fill: "#ee2b7b"
              }
            ) })
          ]
        }
      )
    ]
  }
), B4 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_08_icono_exploracion",
    "data-name": "08_icono_exploracion",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_08_icono_exploracion-2",
          "data-name": "08_icono_exploracion",
          transform: "translate(3.646 -0.34)",
          children: [
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40715",
                "data-name": "Trazado 40715",
                d: "M48.192,20.35a6.734,6.734,0,0,0-8.93,3.3,6.937,6.937,0,0,0-.179,5.179,6.829,6.829,0,0,0,3.483,3.75,6.353,6.353,0,0,0,2.858.625,6.719,6.719,0,0,0,2.322-.446,6.829,6.829,0,0,0,3.75-3.483A6.734,6.734,0,0,0,48.192,20.35Zm2.15,8.3a4.945,4.945,0,0,1-3.062,2.876,5.424,5.424,0,0,1-4.175-.186,4.945,4.945,0,0,1-2.876-3.062,5.424,5.424,0,0,1,.186-4.175,5.56,5.56,0,0,1,7.236-2.69A5.361,5.361,0,0,1,50.341,28.647Zm-4.105-2.588V23.712a.722.722,0,1,0-1.445,0V26.33a1.281,1.281,0,0,0,.181.542l1.806,1.9a.78.78,0,0,0,.542.271.662.662,0,0,0,.542-.181.823.823,0,0,0,0-1.083Z",
                transform: "translate(-1.033 -0.51)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40716",
                "data-name": "Trazado 40716",
                d: "M18.9,36.4a7.778,7.778,0,1,0,7.778-7.778A7.8,7.8,0,0,0,18.9,36.4Zm7.778-6.126A6.126,6.126,0,1,1,20.552,36.4,6.1,6.1,0,0,1,26.677,30.277Z",
                transform: "translate(-0.486 -0.755)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40717",
                "data-name": "Trazado 40717",
                d: "M26.533,46.024c-7.584,0-12.834,3.889-12.834,9.626v3.792a.836.836,0,0,0,.778.778.767.767,0,0,0,.778-.778V55.65c0-5.542,5.639-8.07,11.279-8.07s11.279,2.528,11.279,8.07v3.792a.767.767,0,0,0,.778.778.836.836,0,0,0,.778-.778V55.65C39.368,50.01,34.118,46.024,26.533,46.024Z",
                transform: "translate(-0.342 -1.237)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40718",
                "data-name": "Trazado 40718",
                d: "M4.586,36.077c-.162,0-.218-.023-.236-.04a.9.9,0,0,1-.356-.44L1.355,25.709a1.3,1.3,0,0,1,.084-.549l2.544-3.911a.835.835,0,0,1,.414-.325l6.251-1.656a.636.636,0,0,1,.152-.018.577.577,0,0,1,.587.456l3.442,12.981a.653.653,0,0,1-.079.5.536.536,0,0,1-.359.243C11.767,34.142,4.989,35.986,4.586,36.077Zm.6-14.1.755,2.7a.665.665,0,0,1-.081.5.545.545,0,0,1-.367.247l-2.809.756L5,34.585l8.5-2.21L10.29,20.669ZM2.517,25.286l2.514-.559L4.4,22.5Z",
                transform: "translate(0 -0.496)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ h("g", { id: "Grupo_16521", "data-name": "Grupo 16521", transform: "translate(16.364 1.34)", children: [
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40719",
                  "data-name": "Trazado 40719",
                  d: "M19.476,10.941a.6.6,0,0,0-.608-.588c-.471-.006-.956,0-1.485,0a.609.609,0,0,0-.108,1.206,1.312,1.312,0,0,0,.281.031h.229l.6,0c.165,0,.335,0,.508-.006A.6.6,0,0,0,19.476,10.941Z",
                  transform: "translate(-16.791 -1.589)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40720",
                  "data-name": "Trazado 40720",
                  d: "M35.239,10.393c-.162,0-.317,0-.477,0l-.422,0c-.154,0-.306,0-.461,0a.626.626,0,0,0-.677.6.606.606,0,0,0,.164.44.677.677,0,0,0,.495.2q.4.006.8.006l.571,0a.612.612,0,0,0,.65-.62A.619.619,0,0,0,35.239,10.393Z",
                  transform: "translate(-17.245 -1.59)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40721",
                  "data-name": "Trazado 40721",
                  d: "M31.88,6.921a.612.612,0,0,0,.168.024A.663.663,0,0,0,32.5,6.76c.228-.217.451-.439.675-.663l.341-.343a.68.68,0,0,0,.192-.439l0-.036a.594.594,0,0,0-.364-.522.616.616,0,0,0-.7.135q-.5.494-.995.993a.593.593,0,0,0-.179.587A.611.611,0,0,0,31.88,6.921Z",
                  transform: "translate(-17.197 -1.433)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40722",
                  "data-name": "Trazado 40722",
                  d: "M19.556,6.575l.127.128a.635.635,0,0,0,.455.205l.037,0a.611.611,0,0,0,.4-1.05c-.343-.349-.681-.69-1.025-1.026a.621.621,0,0,0-.442-.189.609.609,0,0,0-.427.193.6.6,0,0,0,.01.862C18.975,5.992,19.265,6.284,19.556,6.575Z",
                  transform: "translate(-16.838 -1.431)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40723",
                  "data-name": "Trazado 40723",
                  d: "M25.775,3.19v.181a.635.635,0,0,0,.177.467l.027.025A.612.612,0,0,0,27,3.4c0-.49.007-.969,0-1.45a.623.623,0,0,0-.179-.446.609.609,0,0,0-.438-.166.6.6,0,0,0-.6.616C25.777,2.368,25.775,2.779,25.775,3.19Z",
                  transform: "translate(-17.04 -1.34)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40724",
                  "data-name": "Trazado 40724",
                  d: "M20.125,14.675a.567.567,0,0,0-.45.188l-.115.11c-.068.065-.136.13-.2.2l-.161.159c-.183.18-.366.36-.542.545a.6.6,0,0,0-.012.864.622.622,0,0,0,.445.187.568.568,0,0,0,.4-.156c.329-.316.676-.662,1.094-1.089a.574.574,0,0,0,.086-.675A.59.59,0,0,0,20.125,14.675Z",
                  transform: "translate(-16.837 -1.709)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40725",
                  "data-name": "Trazado 40725",
                  d: "M33.241,15.24l-.335-.335a.656.656,0,0,0-.457-.205l0,.083h0l-.026-.082a.6.6,0,0,0-.52.348.584.584,0,0,0,.106.684c.3.311.659.678,1.02,1.031a.655.655,0,0,0,.462.2.618.618,0,0,0,.606-.6.675.675,0,0,0-.205-.476C33.674,15.67,33.459,15.455,33.241,15.24Z",
                  transform: "translate(-17.208 -1.71)",
                  fill: "#ee2b7b"
                }
              )
            ] }),
            /* @__PURE__ */ h("g", { id: "Grupo_16522", "data-name": "Grupo 16522", transform: "translate(20.208 5.423)", children: [
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40726",
                  "data-name": "Trazado 40726",
                  d: "M29.741,6.911a5.255,5.255,0,0,0-3.673-1.372l-.565,0a5.357,5.357,0,0,0-3.493,8.786,4.94,4.94,0,0,1,1.11,3.157.643.643,0,0,0,.65.65h5.013a.639.639,0,0,0,.421-.169.514.514,0,0,0,.109-.516,5.4,5.4,0,0,1,1.111-3.242A5.3,5.3,0,0,0,31.549,10.9,5.423,5.423,0,0,0,29.741,6.911Zm-2.63,8.132-.206-.021a.612.612,0,0,0-.585.51l-.09.8-.118-.709a.671.671,0,0,0-.569-.478l-.132,0-.038.01a.7.7,0,0,0-.434.336.448.448,0,0,0-.049.339l.2,1.133h-.832a5.667,5.667,0,0,0-1.339-3.319A4.305,4.305,0,0,1,22,10.494a4.167,4.167,0,0,1,3.648-3.713h.537a3.993,3.993,0,0,1,2.747,1.041,4.413,4.413,0,0,1,1.378,3.14,4.134,4.134,0,0,1-.859,2.555l0,0a6.527,6.527,0,0,0-1.276,3.435h-.833l.2-1.181A.6.6,0,0,0,27.111,15.043Z",
                  transform: "translate(-20.745 -5.539)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40727",
                  "data-name": "Trazado 40727",
                  d: "M28.867,18.512h-5a.548.548,0,0,0-.585.585.572.572,0,0,0,.585.584h.223a.54.54,0,0,0-.361.546.573.573,0,0,0,.585.585h.295a.513.513,0,0,0-.245.291.573.573,0,0,0,.051.423l.061.123a2.018,2.018,0,0,0,1.762,1.069h.3a2.083,2.083,0,0,0,1.809-1.146l.024-.074c.087-.445-.053-.616-.2-.685h.257A.572.572,0,0,0,29,20.227a.562.562,0,0,0-.372-.546h.235a.584.584,0,1,0,0-1.169Zm-1.536,2.56a.951.951,0,0,1-.8.536h-.3a.88.88,0,0,1-.8-.475l-.059-.121a.561.561,0,0,0-.174-.2H27.68A.577.577,0,0,0,27.331,21.072Z",
                  transform: "translate(-20.815 -5.898)",
                  fill: "#ee2b7b"
                }
              )
            ] })
          ]
        }
      )
    ]
  }
), $4 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_30_icono_familiar",
    "data-name": "30_icono_familiar",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ r(
        "path",
        {
          id: "_30_icono_familiar-2",
          "data-name": "30_icono_familiar",
          d: "M7.465,47.847h-6a.8.8,0,1,1,0-1.6h6a1.155,1.155,0,0,0,1.2-1.2v-21a1.155,1.155,0,0,0-1.2-1.2h-6a.8.8,0,1,1,0-1.6h6a2.862,2.862,0,0,1,2.8,2.8v21A2.8,2.8,0,0,1,7.465,47.847Zm31.5-13.6a.86.86,0,0,1-.8-.8v-.6a.9.9,0,0,0-.9-.9h-7.4c-.2,0-.3-.1-.5-.1l-7.6-5.6h-7.7a.8.8,0,1,1,0-1.6h7.9c.2,0,.3.1.5.1l7.7,5.5h7.1a2.476,2.476,0,0,1,2.5,2.5v.6A.817.817,0,0,1,38.965,34.247Zm-6.3,11.1a19.9,19.9,0,0,1-6.3-1.1,33.1,33.1,0,0,1-3.3-1.5c-.9-.5-1.8-.9-2.7-1.3a21.642,21.642,0,0,0-7.4-1.5.8.8,0,1,1,0-1.6,22.3,22.3,0,0,1,8,1.6,25.909,25.909,0,0,1,2.9,1.4,29.173,29.173,0,0,0,3.1,1.4c7.1,2.5,13.3-.1,17.2-2.8,1-.7,2-1.4,2.9-2.1,1.6-1.1,3.2-2.3,4.9-3.3l.2-.1a5.6,5.6,0,0,0,1.5-1,1.517,1.517,0,0,0,.5-1.6,1.938,1.938,0,0,0-1.9-1.1h-.1a9.238,9.238,0,0,0-4.2,1.6l-7.4,4.2c-.1,0-.1.1-.2.1-4.6,1.2-15.7.1-16.2,0a.806.806,0,0,1,.2-1.6c.1,0,11.1,1.1,15.5,0l7.3-4.1a10.1,10.1,0,0,1,5-1.8h.1a3.727,3.727,0,0,1,3.4,2.1,3.177,3.177,0,0,1-.8,3.3,20.278,20.278,0,0,1-1.8,1.3l-.2.1c-1.6,1-3.2,2.1-4.8,3.2l-3,2.1A22.358,22.358,0,0,1,32.665,45.347ZM40.318,4.678c.1.085.188.17.281.256l.59.547c.025.023.052.05.078.078a1.171,1.171,0,0,0,.222.2.484.484,0,0,0,.194.07h0l.061,0a.96.96,0,0,0,.615-.354l.768-.715c.07-.064.143-.128.215-.191.154-.136.314-.277.458-.432a1.58,1.58,0,0,0,.045-2.154A1.51,1.51,0,0,0,42.71,1.46a1.7,1.7,0,0,0-.967.294,1.7,1.7,0,0,0-.968-.293H40.77a1.581,1.581,0,0,0-1.114.515,1.558,1.558,0,0,0,.088,2.164C39.928,4.326,40.124,4.5,40.318,4.678ZM41.34,2.57c.028.031.055.061.08.086a.418.418,0,0,0,.5.051,1.089,1.089,0,0,0,.2-.151.83.83,0,0,1,.155-.117.746.746,0,0,1,.337-.074.689.689,0,0,1,.509.2.693.693,0,0,1-.031.953L41.757,4.77,40.429,3.52a.649.649,0,0,1-.062-.932.919.919,0,0,1,.535-.222.589.589,0,0,1,.3.071A.7.7,0,0,1,41.34,2.57ZM37.323,9.453h.012a2.4,2.4,0,1,0-2.4-2.411,2.409,2.409,0,0,0,2.387,2.411Zm-1.382-2.42a1.4,1.4,0,0,1,1.4-1.363V5.5l.009.175a1.379,1.379,0,1,1-1.4,1.362Zm10.036,2.42h.009a2.365,2.365,0,0,0,1.688-.7,2.408,2.408,0,0,0-1.7-4.1,2.349,2.349,0,0,0-1.687.707,2.408,2.408,0,0,0,1.688,4.1ZM44.588,7.041A1.4,1.4,0,0,1,45.98,5.67V5.5l0,.175a1.4,1.4,0,0,1,1.4,1.37,1.364,1.364,0,0,1-.4.973,1.436,1.436,0,0,1-2,0A1.362,1.362,0,0,1,44.588,7.041Zm6.29,9.5c-.222-1.328-.463-2.644-.717-3.912a3.682,3.682,0,0,0-2.723-2.985,4.316,4.316,0,0,0-1.271-.137h-.518a3.813,3.813,0,0,0-3.058,1.4c-.081.1-.114.074-.167.062a1.843,1.843,0,0,0-.889-.026c-.094.022-.115.047-.219-.124a2.118,2.118,0,0,0-1.924-1.129h-.069c-1.205.03-2.409.02-3.62.009l-.54,0a1.689,1.689,0,0,0-1.171.445,3.772,3.772,0,0,0-1.234,2.829c-.022.572-.017,1.147-.011,1.7v.19c0,.188,0,.377,0,.565l0,.752c0,.585,0,1.169,0,1.754a1.286,1.286,0,0,0,1.24,1.336,1.065,1.065,0,0,0,.14-.008.772.772,0,0,1,.132,0h0a.543.543,0,0,1,.005.146q-.048,1.04-.092,2.08l-.063,1.474c-.013.279-.028.558-.044.844l0,.08c-.027.494-.055.987-.064,1.48a1.844,1.844,0,0,0,.749,1.558,1.908,1.908,0,0,0,1.158.4h0a2,2,0,0,0,1.384-.589c.017-.016.041-.039.032-.042a.145.145,0,0,1,.041.03,2,2,0,0,0,1.356.6h0a2.1,2.1,0,0,0,1.185-.415c.036-.024.049-.028.047-.029a.124.124,0,0,1,.042.028A1.4,1.4,0,0,0,41.9,27c.062-.042.079-.041.136,0a1.423,1.423,0,0,0,2.07-.249l0,0,0,0a1.268,1.268,0,0,0,1.8.338c.048-.031.065-.031.072-.031s.023,0,.081.039a1.2,1.2,0,0,0,.913.211,1.353,1.353,0,0,0,1.134-1.4l.111-1.22c.112-1.229.226-2.459.331-3.689.008-.1.009-.108.124-.108.265.007.531.009.8,0a.59.59,0,0,0,.44-.192.548.548,0,0,0,.107-.437c-.051-.416-.1-.831-.171-1.244A.306.306,0,0,1,50,18.668,2.12,2.12,0,0,0,50.878,16.542Zm-8.968-4.8.005.175A1.4,1.4,0,0,1,43.3,13.3a1.331,1.331,0,0,1-.394.957,1.41,1.41,0,0,1-1.012.419,1.384,1.384,0,0,1-1.386-1.373,1.42,1.42,0,0,1,1.4-1.393V11.74Zm6.687.805a.5.5,0,1,0-.977.221c.081.435.168.869.255,1.3l.334,1.667c.193.959.386,1.917.571,2.878.05.256.082.516.113.776.018.144.035.288.056.43,0,.028,0,.043.005.048a.246.246,0,0,1-.062.006l-1.933,0q-.912,0-1.826,0a.2.2,0,0,1-.059-.007.356.356,0,0,1-.012-.115c0-.1,0-.211,0-.316a5.4,5.4,0,0,0-.082-1.2,3.135,3.135,0,0,0-3.073-2.5,3.175,3.175,0,0,0-1.537.4l-.026.014v-.035c0-.243,0-.487,0-.746v-.245a2.282,2.282,0,0,0,1.516.573h.088a2.251,2.251,0,0,0,2.138-1.432,2.28,2.28,0,0,0-.455-2.6,1.3,1.3,0,0,1-.176-.216,1.114,1.114,0,0,1,.209-.212,2.6,2.6,0,0,1,1.739-.7c.111,0,.222,0,.333-.008h.051a5.944,5.944,0,0,1,1.089.035,2.754,2.754,0,0,1,2.314,2.362l.061.327q.309,1.669.615,3.339a1.263,1.263,0,0,1-.219,1.022l-.027.042a.434.434,0,0,0-.007-.047q-.378-1.866-.752-3.733l-.221-1.1A1.866,1.866,0,0,0,48.6,12.545Zm-3.124,9.862v1.82q0,.84,0,1.681c0,.39-.211.4-.295.4s-.266,0-.3-.4c-.1-1.171-.214-2.342-.326-3.535-.008-.086,0-.09.011-.1a1.278,1.278,0,0,0,.508-1.171l-.007-.083a.392.392,0,0,1,0-.1.525.525,0,0,1,.2-.038c.075,0,.153.013.214.017a.281.281,0,0,1,0,.077l0,.056Q45.473,21.717,45.473,22.407Zm-2.025-.357q0,1.1,0,2.207v1.278a1.649,1.649,0,0,1-.038.406.47.47,0,0,1-.461.367.455.455,0,0,1-.446-.347,1.148,1.148,0,0,1-.03-.326V22.393a1.028,1.028,0,0,0-.011-.219.49.49,0,0,0-.97.012,1.349,1.349,0,0,0-.01.21v3.2a1.4,1.4,0,0,1-.034.354.453.453,0,0,1-.4.359l-.047,0a.474.474,0,0,1-.446-.3.825.825,0,0,1-.054-.332c0-.435,0-3.2,0-3.609s-.16-.584-.569-.616c-.145-.011-.17-.056-.17-.176q0-.422,0-.842c0-.566-.008-1.152.013-1.731a2.14,2.14,0,0,1,2.011-1.97c.05,0,.1,0,.146,0a2.168,2.168,0,0,1,2.059,1.7,2.406,2.406,0,0,1,.054.507c0,.762-.005,1.523,0,2.285,0,.173-.035.225-.174.249A.511.511,0,0,0,43.448,22.05Zm-5.6-3.436c-.012-.367-.215-.6-.518-.6s-.5.243-.5.62q0,3.328,0,6.655a1.127,1.127,0,0,1-.107.553.931.931,0,0,1-1.021.455.892.892,0,0,1-.686-.873c.014-.6.044-1.209.073-1.814l.036-.757q.031-.672.07-1.346c.161-2.917.168-5.8.151-8.483a1.118,1.118,0,0,0-.005-.153.51.51,0,0,0-.489-.489h-.035a.5.5,0,0,0-.484.481,1.69,1.69,0,0,0-.008.224l0,4.825c0,.3-.134.343-.274.345a.251.251,0,0,1-.27-.25.965.965,0,0,1,0-.107V16.244c0-1.11,0-2.221.008-3.332a2.89,2.89,0,0,1,.638-1.781,1.076,1.076,0,0,1,.909-.445c1.341.011,2.67.013,4.045,0a1.18,1.18,0,0,1,1.066.619c.037.058.037.076.037.078a.149.149,0,0,1-.048.048,2.31,2.31,0,0,0-.7.883.28.28,0,0,0-.025.058.708.708,0,0,0-.375.761q0,.964,0,1.929,0,.89,0,1.78a.716.716,0,0,1-.113.412,3.081,3.081,0,0,0-.469,1.657c0,.38,0,.759,0,1.14v.229c0,.306,0,.61,0,.916a1.173,1.173,0,0,0,.719,1.186c.042.018.055.023.055.135v3.242a.711.711,0,0,1-.619.546.9.9,0,0,1-1.05-.882c-.005-.706,0-1.413,0-2.12V22.033C37.847,21.687,37.847,18.663,37.846,18.614Zm8.644,2.455c0-.117.019-.151.029-.161a.158.158,0,0,1,.1-.021l.055,0c.087.007.173.009.263.009l.41,0a1.137,1.137,0,0,0,.19-.007.926.926,0,0,1-.005.213c-.035.456-.077.911-.119,1.366l-.29,3.156c-.01.127-.021.254-.034.379a.307.307,0,0,1-.311.307.292.292,0,0,1-.277-.328c0-.492,0-.983,0-1.475V22.82C46.5,22.237,46.5,21.653,46.49,21.069Z",
          transform: "translate(1.335 5.54)",
          fill: "#ee2b7b"
        }
      )
    ]
  }
), j4 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_01_icono_financiacion",
    "data-name": "01_icono_financiacion",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(255,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_01_icono_financiacion-2",
          "data-name": "01_icono_financiacion",
          transform: "translate(0.152 5.192)",
          children: [
            /* @__PURE__ */ r("g", { id: "Grupo_16502", "data-name": "Grupo 16502", transform: "translate(0.848 0.808)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40698",
                "data-name": "Trazado 40698",
                d: "M30.514,24.769a.735.735,0,0,0-.666-.761,22.324,22.324,0,0,1-5.42-.856V19.824h0v-.1c0-3.328-5.134-5.9-11.79-5.9-6.561,0-11.79,2.567-11.79,5.9s5.134,5.9,11.79,5.9c4.564,0,8.462-1.236,10.459-3.138v3.708c-.1,2.092-4.469,4.374-10.554,4.374S2.179,28.192,2.179,26.1V24.959a.65.65,0,0,0-.666-.666.65.65,0,0,0-.666.666V39.031c0,3.328,5.23,5.9,11.885,5.9s11.885-2.567,11.7-5.9V37.319a22.064,22.064,0,0,0,3.613.666.65.65,0,0,0,.666-.666.735.735,0,0,0-.666-.761,18.846,18.846,0,0,1-3.613-.666V30.854a27.605,27.605,0,0,0,3.233.666.764.764,0,0,0,.1-1.521,15.838,15.838,0,0,1-3.328-.666V24.578a24.038,24.038,0,0,0,5.42.761A.636.636,0,0,0,30.514,24.769ZM12.638,24.2c-6.085,0-10.364-2.377-10.364-4.469,0-2.187,4.184-4.469,10.364-4.469S23,17.542,23,19.729C23,21.821,18.818,24.2,12.638,24.2Zm0,19.207c-6.275,0-10.459-2.282-10.459-4.469V35.323c2,1.9,5.9,3.138,10.459,3.138S21.1,37.224,23.1,35.323v3.613C23.1,41.123,18.914,43.4,12.638,43.4ZM23.1,32.47h0c0,2.092-4.279,4.469-10.459,4.469-5.8,0-9.889-2.092-10.459-4.184v-3.9c2,1.9,5.9,3.138,10.459,3.138S21.1,30.759,23.1,28.857ZM44.586,20.11a18.523,18.523,0,0,0-2.377.19V6.7c0-3.328-5.23-5.9-11.885-5.9-6.466,0-11.6,2.472-11.79,5.7v5.61a.65.65,0,0,0,.666.666c.38,0,.761-.38.666-.666V9.46c2,1.9,5.9,3.138,10.554,3.138s8.557-1.236,10.459-3.138v3.708c0,2.187-4.184,4.469-10.459,4.469-1.046,0-2.092-.1-3.043-.19-.38-.1-.666.19-.761.57s.19.666.57.761c1.046.1,2.092.19,3.233.19,4.564,0,8.462-1.236,10.459-3.043v4.659a14.312,14.312,0,1,0,3.708-.475ZM30.418,11.172c-6.18,0-10.459-2.377-10.459-4.469s4.279-4.469,10.459-4.469S40.878,4.611,40.878,6.7C40.782,8.89,36.6,11.172,30.418,11.172ZM44.586,47.208A12.836,12.836,0,1,1,57.422,34.372,12.843,12.843,0,0,1,44.586,47.208Z",
                transform: "translate(-0.848 -0.808)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16503", "data-name": "Grupo 16503", transform: "translate(40.896 25.185)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40699",
                "data-name": "Trazado 40699",
                d: "M43.009,38.886a3.925,3.925,0,0,0,2.8,3.238.3.3,0,0,1,.24.338c-.011.237-.008.475,0,.713a.9.9,0,0,0,1.792.007,4.147,4.147,0,0,0,0-.575c-.031-.291.07-.431.365-.526A3.93,3.93,0,0,0,50.891,37.8,3.978,3.978,0,0,0,47,34.337a2.164,2.164,0,0,1-.506-4.278,2.171,2.171,0,0,1,2.332,1.059,2.807,2.807,0,0,1,.295,1.158.884.884,0,0,0,.924.793.874.874,0,0,0,.862-.826,2.953,2.953,0,0,0-.029-.628,3.913,3.913,0,0,0-2.789-3.247.309.309,0,0,1-.252-.357c.012-.237.009-.475,0-.713a.881.881,0,0,0-.895-.852.871.871,0,0,0-.9.847,5.239,5.239,0,0,0,0,.658c.023.257-.08.362-.326.44a3.989,3.989,0,0,0-2.752,4.093,4.04,4.04,0,0,0,3.06,3.562c.405.1.818.071,1.223.138a2.066,2.066,0,0,1,1.732,1.452A2.152,2.152,0,0,1,46.25,40.35a2.126,2.126,0,0,1-1.472-2.044.944.944,0,0,0-.256-.618.9.9,0,0,0-.985-.211.93.93,0,0,0-.569.972C42.98,38.6,42.983,38.743,43.009,38.886Z",
                transform: "translate(-42.968 -26.446)",
                fill: "#ee2b7b"
              }
            ) })
          ]
        }
      )
    ]
  }
), W4 = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_18_icono_fortalecimiento",
    "data-name": "18_icono_fortalecimiento",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_18_icono_fortalecimiento-2",
          "data-name": "18_icono_fortalecimiento",
          transform: "translate(7 7)",
          children: [
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41199",
                "data-name": "Trazado 41199",
                d: "M46.375,19.23V29.375a2.93,2.93,0,0,1-2.547,2.307c-.3.036-.337.252-.337.5,0,.74,0,1.479,0,2.219,0,2.763.009,5.525-.005,8.287a2.991,2.991,0,0,1-1.741,2.9,2.885,2.885,0,0,1-3.292-.46c-.234-.194-.374-.141-.576.028a2.891,2.891,0,0,1-2.443.695,3.05,3.05,0,0,1-2.56-3.155c-.016-1.66,0-3.321-.005-4.982,0-1.811-.006-3.623,0-5.434,0-.376-.094-.568-.518-.62a2.449,2.449,0,0,1-1.939-1.337c-.314-.608-.736-.3-1.119-.266-.416.039-.274.41-.275.652q-.012,5.888-.006,11.775a3.17,3.17,0,0,1-1.944,3.106,3.105,3.105,0,0,1-3.6-.62c-.22-.2-.348-.2-.555.007a3.136,3.136,0,0,1-2.114.911,3.281,3.281,0,0,1-3.439-3.264c-.012-4,0-8-.008-12,0-.224.088-.557-.272-.563s-.761-.377-1.065.195a2.6,2.6,0,0,1-2.084,1.421c-.3.035-.428.172-.422.467.007.362,0,.725,0,1.087,0,3.14.005,6.28,0,9.42a3.014,3.014,0,0,1-1.745,2.939,2.885,2.885,0,0,1-3.292-.463c-.236-.2-.375-.134-.576.033a2.9,2.9,0,0,1-2.444.692,3.061,3.061,0,0,1-2.556-3.2c-.016-2.053-.005-4.106-.005-6.159,0-1.4-.007-2.808,0-4.212,0-.379-.1-.607-.525-.611a1.554,1.554,0,0,1-.523-.134A3.088,3.088,0,0,1,0,29.374V19.229c.045-.144.092-.287.133-.432a4.58,4.58,0,0,1,4.61-3.485c2.339,0,4.679,0,7.018,0a4.794,4.794,0,0,1,1.9.376c.512.217.512.217.694-.317a4.994,4.994,0,0,1,4.905-3.507q3.984,0,7.969,0a4.543,4.543,0,0,1,.766.044,4.972,4.972,0,0,1,4.08,3.6c.113.336.227.4.537.237a3.934,3.934,0,0,1,1.789-.429c2.521-.008,5.041-.014,7.562,0a4.218,4.218,0,0,1,2.636.945A5.088,5.088,0,0,1,46.375,19.23ZM18.869,30.6q0,5.91,0,11.819a1.789,1.789,0,1,0,3.56-.011c.007-1.253,0-2.506,0-3.758q0-3.737,0-7.472c0-.562.285-.9.732-.912s.76.342.773.918c0,.136,0,.272,0,.408v8.649c0,.8-.018,1.6.011,2.4A1.775,1.775,0,0,0,27.5,42.6c.008-.287,0-.574,0-.86q0-11.547,0-23.094c0-.64.267-.977.752-.982s.753.331.755.97c0,1.208,0,2.415,0,3.623q0,2.875,0,5.751c0,.514.1.585.595.441A1.626,1.626,0,0,0,30.782,26.8c.011-3.321.034-6.642-.016-9.962a3.516,3.516,0,0,0-3.614-3.467q-3.962-.006-7.924,0a3.814,3.814,0,0,0-.676.041A3.637,3.637,0,0,0,15.583,17.2q-.01,4.619,0,9.237a4.458,4.458,0,0,0,.029.633A1.628,1.628,0,0,0,16.63,28.4c.581.248.727.142.727-.483q0-4.551,0-9.1a3.162,3.162,0,0,1,.014-.5.739.739,0,0,1,1.454-.082,2.638,2.638,0,0,1,.04.63Q18.871,24.732,18.869,30.6Zm-6.9,1.584q0-5.072,0-10.143c0-.226,0-.453.018-.679.047-.567.342-.888.782-.867s.715.368.741.923c.007.151,0,.3,0,.453v7.426c0,.136,0,.272,0,.408.016.455.194.563.6.364a1.4,1.4,0,0,0,.689-.75.428.428,0,0,0-.035-.469,4.166,4.166,0,0,1-.748-2.735c.012-2.611,0-5.222.012-7.834a1,1,0,0,0-.5-.936,3.011,3.011,0,0,0-1.664-.515c-2.445-.013-4.891-.029-7.335,0a3.072,3.072,0,0,0-3.049,2.994c-.041,2.987-.015,5.976-.012,8.964a1.413,1.413,0,0,0,.565,1.136.674.674,0,0,0,.662.206c.276-.109.18-.389.181-.6.006-2.581,0-5.162.007-7.743a3.377,3.377,0,0,1,.063-.718.68.68,0,0,1,.718-.569.678.678,0,0,1,.706.584,4.468,4.468,0,0,1,.059.81q0,10.166,0,20.331c0,.241,0,.483.011.724a1.479,1.479,0,0,0,2.956.009c.016-.271.018-.543.018-.815q0-4.506,0-9.011a3.833,3.833,0,0,1,.067-.809.658.658,0,0,1,.686-.543.688.688,0,0,1,.721.5,2.225,2.225,0,0,1,.073.762q0,4.529,0,9.056c0,.287,0,.574.015.86a1.459,1.459,0,0,0,1.254,1.4,1.515,1.515,0,0,0,1.609-.913,2.556,2.556,0,0,0,.109-.983Q11.967,37.321,11.966,32.181Zm22.453-.007q0,4.143,0,8.286c0,.845-.016,1.691.02,2.535a1.462,1.462,0,0,0,1.469,1.377,1.48,1.48,0,0,0,1.478-1.416c.014-.256.017-.513.017-.769q0-4.551,0-9.1a4.013,4.013,0,0,1,.043-.676.682.682,0,0,1,.71-.628.689.689,0,0,1,.753.632,4.226,4.226,0,0,1,.042.721c.007,3.26,0,6.52.02,9.78a1.448,1.448,0,0,0,1.429,1.46,1.479,1.479,0,0,0,1.525-1.416c.017-.24.013-.483.013-.724q0-10.074,0-20.149c0-.256,0-.514.022-.769.051-.532.352-.843.777-.824s.706.352.742.875c.009.135.006.272.006.407v4.256c0,1.223,0,2.445,0,3.668,0,.454.194.57.6.362a1.376,1.376,0,0,0,.8-1.275c.01-2.988.032-5.977-.009-8.965a3.085,3.085,0,0,0-3.089-3c-2.415-.01-4.83,0-7.244,0a3.153,3.153,0,0,0-1.593.445,1.122,1.122,0,0,0-.617,1.1c.026,2.686.011,5.373.012,8.059a3.864,3.864,0,0,1-.562,2.158.851.851,0,0,0,.239,1.334c.192.149.411.309.66.211.275-.109.174-.391.175-.6.007-2.6,0-5.192.007-7.788a2.969,2.969,0,0,1,.06-.673.687.687,0,0,1,.724-.564.68.68,0,0,1,.7.587,4.244,4.244,0,0,1,.058.765Q34.421,27.012,34.419,32.174Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41200",
                "data-name": "Trazado 41200",
                d: "M28.116,4.932A4.926,4.926,0,1,1,23.207,0,4.933,4.933,0,0,1,28.116,4.932ZM23.206,8.35a3.367,3.367,0,0,0,3.4-3.419,3.417,3.417,0,1,0-6.833.022A3.387,3.387,0,0,0,23.206,8.35Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41201",
                "data-name": "Trazado 41201",
                d: "M38.164,13.723A4.557,4.557,0,0,1,33.676,9.2a4.5,4.5,0,0,1,9.006.033A4.551,4.551,0,0,1,38.164,13.723ZM41.173,9.2a2.994,2.994,0,0,0-5.988.041A2.994,2.994,0,0,0,41.173,9.2Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41202",
                "data-name": "Trazado 41202",
                d: "M8.217,13.723A4.557,4.557,0,0,1,3.7,9.234a4.553,4.553,0,0,1,4.49-4.517A4.546,4.546,0,0,1,12.7,9.2,4.554,4.554,0,0,1,8.217,13.723Zm2.978-4.485A3.042,3.042,0,0,0,8.2,6.225a2.993,2.993,0,0,0,0,5.986A3.042,3.042,0,0,0,11.195,9.238Z",
                fill: "#ee2b7b"
              }
            )
          ]
        }
      )
    ]
  }
), U4 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_21_garantia",
    "data-name": "21_garantia",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h("g", { id: "_21_garantia-2", "data-name": "21_garantia", transform: "translate(-2.2 -2.475)", children: [
        /* @__PURE__ */ r("g", { id: "Grupo_16626", "data-name": "Grupo 16626", transform: "translate(9.2 4.475)", children: /* @__PURE__ */ r("g", { id: "Grupo_16625", "data-name": "Grupo 16625", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40901",
            "data-name": "Trazado 40901",
            d: "M32.14,59.634a1.4,1.4,0,0,1-.591-.2l-8.172-5.71A33.378,33.378,0,0,1,9.2,26.455V15.33a1.047,1.047,0,0,1,.886-.985h.2a48.772,48.772,0,0,0,19.2-8.073L31.648,4.7a.9.9,0,0,1,1.181,0L34.306,5.78a48.272,48.272,0,0,0,19.1,8.369l.886.2a.959.959,0,0,1,.788.985V26.849A32.676,32.676,0,0,1,41.2,53.53l-8.467,6.006C32.534,59.536,32.337,59.634,32.14,59.634ZM11.268,16.216V26.455a31.328,31.328,0,0,0,13.291,25.6L32.14,57.37l7.876-5.513a30.493,30.493,0,0,0,13-25.008V16.216A51.543,51.543,0,0,1,33.125,7.453l-.886-.591L30.663,7.946A53.115,53.115,0,0,1,11.268,16.216Zm29.34,36.428Z",
            transform: "translate(-9.2 -4.475)",
            fill: "#ee2b7b"
          }
        ) }) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16628", "data-name": "Grupo 16628", transform: "translate(18.836 20.964)", children: /* @__PURE__ */ r("g", { id: "Grupo_16627", "data-name": "Grupo 16627", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40902",
            "data-name": "Trazado 40902",
            d: "M28.8,43.8a.908.908,0,0,1-.7-.3l-8.6-8.6a.967.967,0,0,1,0-1.4l4.4-4.4a1.088,1.088,0,0,1,1.5,0l3.5,3.5L39.8,21.7a1.088,1.088,0,0,1,1.5,0l4.4,4.4a1.087,1.087,0,0,1,0,1.5l-16,16A3.711,3.711,0,0,1,28.8,43.8Zm-7.1-9.7,7.1,7.1L43.3,26.7l-2.9-2.9L29.5,34.6a1.087,1.087,0,0,1-1.5,0l-3.5-3.5Z",
            transform: "translate(-19.2 -21.4)",
            fill: "#ee2b7b"
          }
        ) }) })
      ] })
    ]
  }
), q4 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_02_icono_acompañamiento",
    "data-name": "02_icono_acompañamiento",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h("g", { id: "_03_icono_ingles", "data-name": "03_icono_ingles", transform: "translate(-2.975 -2.975)", children: [
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40700",
            "data-name": "Trazado 40700",
            d: "M59.1,35.4A3.039,3.039,0,0,0,57,32.3a2.911,2.911,0,0,0,1.9-3,24.92,24.92,0,0,0-4.6-12,5.847,5.847,0,0,0,.4-1.9,5.015,5.015,0,0,0-5-5,4.058,4.058,0,0,0-1.9.4A25.269,25.269,0,0,0,35.5,6a2.754,2.754,0,0,0-3,2,4.2,4.2,0,0,0-.9-1.4A2.635,2.635,0,0,0,29.5,6a24.689,24.689,0,0,0-12.3,4.8,4.333,4.333,0,0,0-1.9-.4,5.081,5.081,0,0,0-5,5,4.058,4.058,0,0,0,.4,1.9A26.18,26.18,0,0,0,6,29.5a2.474,2.474,0,0,0,.7,2.1,3.126,3.126,0,0,0,1.1.9,2.73,2.73,0,0,0-1.2.9A2.635,2.635,0,0,0,6,35.5a25.5,25.5,0,0,0,4.7,12.3,4.058,4.058,0,0,0-.4,1.9,5.015,5.015,0,0,0,5,5,4.058,4.058,0,0,0,1.9-.4A26.139,26.139,0,0,0,29.5,59h.3a2.9,2.9,0,0,0,2.7-1.7A2.7,2.7,0,0,0,35.2,59c3.1-.3,8.7-1.5,12.5-4.7a4.477,4.477,0,0,0,2,.4A5,5,0,0,0,54.4,48,25.819,25.819,0,0,0,59.1,35.4Zm-1.6,0a24.4,24.4,0,0,1-4,11.1,4.871,4.871,0,0,0-2.4-1.6A22.558,22.558,0,0,0,54.8,35a1.193,1.193,0,0,1,.5-.9,1.689,1.689,0,0,1,1-.3A1.456,1.456,0,0,1,57.5,35.4Zm0-6a1.414,1.414,0,1,1-2.8.4,21.479,21.479,0,0,0-3.5-9.7,4.825,4.825,0,0,0,2.2-1.5A23.819,23.819,0,0,1,57.5,29.4ZM53.2,15.3a3.478,3.478,0,0,1-3.5,3.5,3.543,3.543,0,0,1-3.5-3.5,3.478,3.478,0,0,1,3.5-3.5A3.543,3.543,0,0,1,53.2,15.3ZM34.4,7.8a1.689,1.689,0,0,1,1-.3,26.73,26.73,0,0,1,11.1,4.1A4.422,4.422,0,0,0,45,13.9a22.558,22.558,0,0,0-9.9-3.7,1.193,1.193,0,0,1-.9-.5,1.689,1.689,0,0,1-.3-1A.811.811,0,0,1,34.4,7.8Zm-4.8-.2a1.929,1.929,0,0,1,1,.3,1.05,1.05,0,0,1,.5.9,1.929,1.929,0,0,1-.3,1,1.05,1.05,0,0,1-.9.5A22.4,22.4,0,0,0,20,13.9a5.131,5.131,0,0,0-1.5-2.3A26.564,26.564,0,0,1,29.6,7.6ZM15.3,11.8a3.478,3.478,0,0,1,3.5,3.5,3.5,3.5,0,0,1-7,0A3.478,3.478,0,0,1,15.3,11.8ZM7.5,29.6a25.744,25.744,0,0,1,4-10.9,4.689,4.689,0,0,0,2.4,1.5A22.014,22.014,0,0,0,10.3,30a1.521,1.521,0,0,1-1.6,1.2,1.1,1.1,0,0,1-1-.6A2.959,2.959,0,0,1,7.5,29.6Zm0,5.8a1.929,1.929,0,0,1,.3-1,1.05,1.05,0,0,1,.9-.5,1.929,1.929,0,0,1,1,.3,1.05,1.05,0,0,1,.5.9A21.968,21.968,0,0,0,13.8,45a5.131,5.131,0,0,0-2.3,1.5A26.564,26.564,0,0,1,7.5,35.4Zm4.3,14.2a3.5,3.5,0,1,1,7,0,3.5,3.5,0,1,1-7,0Zm17.8,8a25.748,25.748,0,0,1-11.1-4.1A5.131,5.131,0,0,0,20,51.2a22.5,22.5,0,0,0,10,3.7,1.193,1.193,0,0,1,.9.5,1.689,1.689,0,0,1,.3,1A1.456,1.456,0,0,1,29.6,57.6Zm3.3-3.3a1.612,1.612,0,0,0-.4.7c-.1-.2-.2-.3-.3-.5a2.654,2.654,0,0,0-1.9-1.1,21.651,21.651,0,0,1-10-3.9,4.975,4.975,0,0,0-4.7-4.7,20.13,20.13,0,0,1-3.8-9.9A3.113,3.113,0,0,0,10.7,33a2.092,2.092,0,0,0-.6-.4A3.01,3.01,0,0,0,12,30.4a22.081,22.081,0,0,1,3.9-10,5.031,5.031,0,0,0,4.5-4.7,21.711,21.711,0,0,1,9.9-3.9,3.113,3.113,0,0,0,1.9-1.1,2.01,2.01,0,0,0,.4-.8,4.053,4.053,0,0,0,.5.9A2.654,2.654,0,0,0,35,11.9a20.775,20.775,0,0,1,9.8,3.8,5.069,5.069,0,0,0,4.8,4.7,20.273,20.273,0,0,1,3.7,9.7A2.923,2.923,0,0,0,55,32.5a2.186,2.186,0,0,0-.5.3,2.654,2.654,0,0,0-1.1,1.9,20.384,20.384,0,0,1-4,10,5.117,5.117,0,0,0-4.6,4.6,21.711,21.711,0,0,1-9.9,3.9A3.09,3.09,0,0,0,32.9,54.3Zm2.6,3.1a1.383,1.383,0,0,1-1.6-1.2,1.929,1.929,0,0,1,.3-1,1.05,1.05,0,0,1,.9-.5,21.583,21.583,0,0,0,9.8-3.6,5.131,5.131,0,0,0,1.5,2.3A24.05,24.05,0,0,1,35.5,57.4Zm14.2-4.3a3.543,3.543,0,0,1-3.5-3.5,3.478,3.478,0,0,1,3.5-3.5,3.543,3.543,0,0,1,3.5,3.5A3.478,3.478,0,0,1,49.7,53.1Z",
            fill: "#ee2b7b"
          }
        ),
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40701",
            "data-name": "Trazado 40701",
            d: "M49.5,32.5a17,17,0,1,0-17,17A17.115,17.115,0,0,0,49.5,32.5ZM17,33.3h6.7a32.875,32.875,0,0,0,.9,6.6,45.909,45.909,0,0,0-5.1,1A15.264,15.264,0,0,1,17,33.3Zm2.5-9.2c1.7.4,3.4.7,5.1,1a32.875,32.875,0,0,0-.9,6.6H17A15.264,15.264,0,0,1,19.5,24.1ZM48,31.7H41.3a32.875,32.875,0,0,0-.9-6.6,45.909,45.909,0,0,0,5.1-1A15.264,15.264,0,0,1,48,31.7Zm-8.2,0H33.3v-6a34.349,34.349,0,0,0,5.6-.4A31.854,31.854,0,0,1,39.8,31.7Zm-6.5-7.5V17.3c2.1.5,4,3,5.2,6.6A45.329,45.329,0,0,1,33.3,24.2Zm-1.6-6.9v6.9a45.329,45.329,0,0,1-5.2-.3C27.7,20.3,29.6,17.8,31.7,17.3Zm0,8.4v6H25.2a30.854,30.854,0,0,1,.9-6.4C27.9,25.5,29.8,25.6,31.7,25.7Zm-6.5,7.6h6.5v6.1a35.167,35.167,0,0,0-5.6.4A32.875,32.875,0,0,1,25.2,33.3Zm6.5,7.5v6.9c-2.1-.5-4-3-5.2-6.6A45.329,45.329,0,0,1,31.7,40.8Zm1.6,6.9V40.8a45.329,45.329,0,0,1,5.2.3C37.3,44.7,35.4,47.2,33.3,47.7Zm0-8.3V33.3h6.5a30.854,30.854,0,0,1-.9,6.4A52.528,52.528,0,0,0,33.3,39.4Zm8-6.1H48a14.344,14.344,0,0,1-2.5,7.6c-1.7-.4-3.4-.7-5.1-1A32.875,32.875,0,0,0,41.3,33.3Zm3.3-10.5a37.346,37.346,0,0,1-4.6.9,14.237,14.237,0,0,0-3.5-6.2A15.612,15.612,0,0,1,44.6,22.8ZM28.5,17.5A16.075,16.075,0,0,0,25,23.6a37.347,37.347,0,0,1-4.6-.9A16.081,16.081,0,0,1,28.5,17.5ZM20.4,42.2a37.346,37.346,0,0,1,4.6-.9,14.237,14.237,0,0,0,3.5,6.2A15.612,15.612,0,0,1,20.4,42.2Zm16.1,5.3A16.075,16.075,0,0,0,40,41.4a37.346,37.346,0,0,1,4.6.9A16.519,16.519,0,0,1,36.5,47.5Z",
            fill: "#ee2b7b"
          }
        )
      ] })
    ]
  }
), Y4 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_06_glosario",
    "data-name": "06_glosario",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h("g", { id: "_06_glosario-2", "data-name": "06_glosario", transform: "translate(2.179 7.976)", children: [
        /* @__PURE__ */ h("g", { id: "Grupo_16914", "data-name": "Grupo 16914", transform: "translate(0.821 1.024)", children: [
          /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41342",
              "data-name": "Trazado 41342",
              d: "M51.888,1.024H3.557A2.744,2.744,0,0,0,.821,3.76V34.673a2.744,2.744,0,0,0,2.736,2.736H22.068v4.1H19.059a.821.821,0,1,0,0,1.641H36.385a.821.821,0,1,0,0-1.641H33.376v-4.1H51.888a2.744,2.744,0,0,0,2.736-2.736V3.76A2.744,2.744,0,0,0,51.888,1.024ZM3.557,2.574H51.888A1.207,1.207,0,0,1,53.073,3.76V28.016H2.371V3.76A1.207,1.207,0,0,1,3.557,2.574ZM31.735,41.513H23.71v-4.1h8.025Zm20.153-5.654H3.557a1.207,1.207,0,0,1-1.185-1.185V29.658h50.7v5.015A1.207,1.207,0,0,1,51.888,35.859Z",
              transform: "translate(-0.821 -1.024)",
              fill: "#ee2b7b"
            }
          ),
          /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41343",
              "data-name": "Trazado 41343",
              d: "M31.972,34.824h-3.83a.821.821,0,0,0,0,1.641h3.83a.821.821,0,0,0,0-1.641Z",
              transform: "translate(-3.155 -4.001)",
              fill: "#ee2b7b"
            }
          )
        ] }),
        /* @__PURE__ */ h("g", { id: "Grupo_16915", "data-name": "Grupo 16915", transform: "translate(9.563 8.684)", children: [
          /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41344",
              "data-name": "Trazado 41344",
              d: "M26.129,22.647h4.833a3.569,3.569,0,0,0,3.648-3.739A3.7,3.7,0,0,0,32.6,15.625a3.582,3.582,0,0,0,1-2.553,3.658,3.658,0,0,0-3.648-3.648h-3.83a.817.817,0,0,0-.821.821V21.826A.817.817,0,0,0,26.129,22.647Zm.821-11.581h3.1a2.1,2.1,0,0,1,0,4.195h-3.1Zm0,5.836h4.012a2.1,2.1,0,1,1,0,4.195H26.949Z",
              transform: "translate(-11.721 -9.424)",
              fill: "#ee2b7b"
            }
          ),
          /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41345",
              "data-name": "Trazado 41345",
              d: "M11.229,22.747a.817.817,0,0,0,.821-.821v-3.1h6.2v3.009a.817.817,0,0,0,.821.821.646.646,0,0,0,.638-.73V14.175a4.651,4.651,0,1,0-9.3,0v7.751A.817.817,0,0,0,11.229,22.747ZM15.15,11.074a3.075,3.075,0,0,1,3.1,3.1v3.009h-6.2V14.175A3.075,3.075,0,0,1,15.15,11.074Z",
              transform: "translate(-10.408 -9.433)",
              fill: "#ee2b7b"
            }
          ),
          /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41346",
              "data-name": "Trazado 41346",
              d: "M44.859,22.655a4.651,4.651,0,0,0,4.468-3.283.808.808,0,1,0-1.55-.456,3.119,3.119,0,0,1-3.009,2.28,3.075,3.075,0,0,1-3.1-3.1v-3.83a3.075,3.075,0,0,1,3.1-3.1,3.041,3.041,0,0,1,3.009,2.28.808.808,0,1,0,1.55-.456,4.635,4.635,0,0,0-9.119,1.185V18A4.67,4.67,0,0,0,44.859,22.655Z",
              transform: "translate(-13.033 -9.433)",
              fill: "#ee2b7b"
            }
          )
        ] })
      ] })
    ]
  }
), K4 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_11_icono_habitos",
    "data-name": "11_icono_habitos",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h("g", { id: "_11_icono_habitos-2", "data-name": "11_icono_habitos", transform: "translate(-2 -2.4)", children: [
        /* @__PURE__ */ h("g", { id: "Grupo_16807", "data-name": "Grupo 16807", children: [
          /* @__PURE__ */ r("g", { id: "Grupo_16804", "data-name": "Grupo 16804", children: /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41172",
              "data-name": "Trazado 41172",
              d: "M11,54.6H4.9a.9.9,0,0,1,0-1.8H11a1.216,1.216,0,0,0,1.2-1.2V30A1.216,1.216,0,0,0,11,28.8H4.9a.9.9,0,1,1,0-1.8H11a3.009,3.009,0,0,1,3,3V51.7A2.925,2.925,0,0,1,11,54.6Z",
              fill: "#ee2b7b"
            }
          ) }),
          /* @__PURE__ */ r("g", { id: "Grupo_16805", "data-name": "Grupo 16805", children: /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41173",
              "data-name": "Trazado 41173",
              d: "M43.6,40.5a.9.9,0,0,1-.9-.9V39a.9.9,0,0,0-.9-.9H34.2a.764.764,0,0,1-.5-.2l-8-5.7H17.8a.9.9,0,0,1,0-1.8H26a.764.764,0,0,1,.5.2l8,5.7h7.4a2.582,2.582,0,0,1,2.6,2.6v.6A.923.923,0,0,1,43.6,40.5Z",
              fill: "#ee2b7b"
            }
          ) }),
          /* @__PURE__ */ r("g", { id: "Grupo_16806", "data-name": "Grupo 16806", children: /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41174",
              "data-name": "Trazado 41174",
              d: "M37.1,52a21.739,21.739,0,0,1-6.6-1.1,21.1,21.1,0,0,1-3.4-1.6A22.791,22.791,0,0,0,24.3,48a20.824,20.824,0,0,0-7.7-1.6.9.9,0,0,1,0-1.8,24.107,24.107,0,0,1,8.3,1.7,27.51,27.51,0,0,1,3,1.4,23.017,23.017,0,0,0,3.2,1.5c7.3,2.6,13.7-.1,17.7-2.8,1-.7,2-1.4,3-2.2a45.2,45.2,0,0,1,5.1-3.4l.2-.1a5.826,5.826,0,0,0,1.5-1.1,1.517,1.517,0,0,0,.5-1.6,1.893,1.893,0,0,0-1.9-1.1h-.1c-1.5,0-3.3,1.1-4.3,1.7l-7.7,4.3c-.1,0-.1.1-.2.1-4.8,1.2-16.2.1-16.7,0a.906.906,0,0,1,.2-1.8c.1,0,11.4,1.1,16,.1l7.5-4.2a10.659,10.659,0,0,1,5.3-1.9,3.626,3.626,0,0,1,3.5,2.3,3.176,3.176,0,0,1-.9,3.5,5.863,5.863,0,0,1-1.9,1.3l-.2.1c-1.7,1-3.3,2.2-4.9,3.3-1,.7-2,1.5-3.1,2.2A22.477,22.477,0,0,1,37.1,52Z",
              fill: "#ee2b7b"
            }
          ) })
        ] }),
        /* @__PURE__ */ r("g", { id: "Grupo_16808", "data-name": "Grupo 16808", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41175",
            "data-name": "Trazado 41175",
            d: "M43.4,32.2A10.9,10.9,0,1,1,54.3,21.3,10.926,10.926,0,0,1,43.4,32.2Zm0-20a9.1,9.1,0,1,0,9.1,9.1A9.133,9.133,0,0,0,43.4,12.2Z",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16809", "data-name": "Grupo 16809", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41176",
            "data-name": "Trazado 41176",
            d: "M43.4,27.6A6.284,6.284,0,0,1,38,24.9a.875.875,0,1,1,1.5-.9,4.644,4.644,0,0,0,3.9,1.9A4.405,4.405,0,0,0,47.3,24a.875.875,0,0,1,1.5.9A6.673,6.673,0,0,1,43.4,27.6Z",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16810", "data-name": "Grupo 16810", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41177",
            "data-name": "Trazado 41177",
            d: "M41.1,19.9a.961.961,0,0,1-.9-.7,1.011,1.011,0,0,0-1.1-.8,1.084,1.084,0,0,0-1.1.8.841.841,0,0,1-1,.7.921.921,0,0,1-.7-1.1,2.89,2.89,0,0,1,2.8-2.3,2.792,2.792,0,0,1,2.8,2.3.921.921,0,0,1-.7,1.1Z",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16811", "data-name": "Grupo 16811", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41178",
            "data-name": "Trazado 41178",
            d: "M49.5,19.9a.961.961,0,0,1-.9-.7,1.011,1.011,0,0,0-1.1-.8,1.206,1.206,0,0,0-1.1.8.922.922,0,1,1-1.8-.4,2.8,2.8,0,0,1,2.8-2.2,2.885,2.885,0,0,1,2.8,2.2.921.921,0,0,1-.7,1.1Z",
            fill: "#ee2b7b"
          }
        ) })
      ] })
    ]
  }
), X4 = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_23_icono_herraminetas_educacion",
    "data-name": "23_icono_herraminetas_educacion",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_23_icono_herraminetas_educacion-2",
          "data-name": "23_icono_herraminetas_educacion",
          transform: "translate(-2.48 -2.48)",
          children: [
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41229",
                "data-name": "Trazado 41229",
                d: "M54.762,31.765,57.7,30.6a1.141,1.141,0,0,0,.6-1.2L57,23.7a1.084,1.084,0,0,0-1.1-.8l-6,.3A18.628,18.628,0,0,0,46.3,18l2.4-5.5a1.094,1.094,0,0,0-.4-1.3L43.4,8.1a1.058,1.058,0,0,0-1.4.2l-4,4.5a18.834,18.834,0,0,0-6.2-1.1L29.6,6.1a1.141,1.141,0,0,0-1.2-.6L22.7,6.8a1.084,1.084,0,0,0-.8,1.1l.3,6A18.628,18.628,0,0,0,17,17.5l-5.5-2.4a1.094,1.094,0,0,0-1.3.4L7.1,20.4a1.393,1.393,0,0,0,.2,1.5l4.5,4a18.834,18.834,0,0,0-1.1,6.2L5.1,34.3a1.141,1.141,0,0,0-.6,1.2l1.3,5.7a1.084,1.084,0,0,0,1.1.8l6-.3a18.628,18.628,0,0,0,3.6,5.2l-2.4,5.5a1.094,1.094,0,0,0,.4,1.3l4.9,3.1a1.058,1.058,0,0,0,1.4-.2l4-4.5A18.834,18.834,0,0,0,31,53.2L33.2,59a1.141,1.141,0,0,0,1.2.6l5.7-1.3a1.084,1.084,0,0,0,.8-1.1l-.195-4.1A12.692,12.692,0,0,0,47.7,55.2a12.774,12.774,0,0,0,7.062-23.435ZM34.8,57.1l-2.2-5.4a1.2,1.2,0,0,0-1-.7,20.033,20.033,0,0,1-6.9-1.2,1.314,1.314,0,0,0-1.2.3l-3.9,4.3-3.4-2.2,2.3-5.3a1.063,1.063,0,0,0-.2-1.2,17.784,17.784,0,0,1-4-5.7,1.1,1.1,0,0,0-1-.6l-5.8.3-.9-3.9L12,33.6a1.2,1.2,0,0,0,.7-1,20.033,20.033,0,0,1,1.2-6.9,1.314,1.314,0,0,0-.3-1.2L9.3,20.6l2.2-3.4,5.3,2.3a1.063,1.063,0,0,0,1.2-.2,17.784,17.784,0,0,1,5.7-4,1.1,1.1,0,0,0,.6-1L24,8.5l3.9-.9L30.1,13a1.2,1.2,0,0,0,1,.7A20.033,20.033,0,0,1,38,14.9a1.314,1.314,0,0,0,1.2-.3l3.9-4.3,3.4,2.2-2.3,5.3a1.063,1.063,0,0,0,.2,1.2,17.784,17.784,0,0,1,4,5.7,1.1,1.1,0,0,0,1,.6l5.8-.3.9,3.9-3.884,1.554a12.366,12.366,0,0,0-8.993-.015A11.469,11.469,0,0,0,22.3,26.6a11.685,11.685,0,0,0,3.4,16,11.537,11.537,0,0,0,9.307,1.362,12.8,12.8,0,0,0,3.5,7.323L38.7,56.2Zm.13-15.281A9.636,9.636,0,0,1,26.9,40.8,9.418,9.418,0,0,1,37,24.9a9.2,9.2,0,0,1,4.249,6.492A12.869,12.869,0,0,0,34.93,41.819ZM47.7,53.2A10.9,10.9,0,1,1,58.6,42.3,10.926,10.926,0,0,1,47.7,53.2Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ h("g", { id: "Grupo_16837", "data-name": "Grupo 16837", children: [
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41230",
                  "data-name": "Trazado 41230",
                  d: "M56.152,40.584a.5.5,0,0,0-.326-.372l-7.708-2.566a.384.384,0,0,0-.359-.016L40.01,40.212a.494.494,0,0,0,0,.934l2.171.739v3.907a.5.5,0,0,0,.328.465,15.819,15.819,0,0,0,5.424.956,17.029,17.029,0,0,0,5.467-.928.5.5,0,0,0,.337-.468V41.856c.563-.195,1.063-.357,1.436-.478v2.77a.5.5,0,0,0,.509.508.484.484,0,0,0,.508-.482V40.783A.511.511,0,0,0,56.152,40.584Zm-2.3.051-5.92,1.973-5.919-1.973,5.919-1.973Zm-10.46,1.591,4.4,1.473.141.015c.034,0,.1,0,4.59-1.512v3.121a14.391,14.391,0,0,1-9.13,0v-3.1Z",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41231",
                  "data-name": "Trazado 41231",
                  d: "M55.68,44.887a.5.5,0,0,0-.509.509v.13a.508.508,0,1,0,1.017,0V45.4A.5.5,0,0,0,55.68,44.887Z",
                  fill: "#ee2b7b"
                }
              )
            ] })
          ]
        }
      )
    ]
  }
), Q4 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_07_icono_humanidad",
    "data-name": "07_icono_humanidad",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ r(
        "path",
        {
          id: "_07_icono_humanidad-2",
          "data-name": "07_icono_humanidad",
          d: "M19.3,9.2a.665.665,0,0,1-.269-.1,4.422,4.422,0,0,1-.585-.543l-1.27-1.177c-.608-.563-1.242-1.109-1.828-1.695a2.962,2.962,0,0,1-.179-4.133A3.052,3.052,0,0,1,17.322.569a3.39,3.39,0,0,1,2.066.719A3.2,3.2,0,0,1,21.455.569a2.869,2.869,0,0,1,2.156.989,3.046,3.046,0,0,1-.09,4.133c-.434.471-.953.884-1.422,1.318L20.6,8.4C20.27,8.7,19.8,9.266,19.3,9.2ZM17.572,1.761h0a2.323,2.323,0,0,0-1.378.551,1.778,1.778,0,0,0,.092,2.572l3.123,2.94,3.123-2.94a1.86,1.86,0,0,0,.092-2.572,1.87,1.87,0,0,0-1.378-.551,2,2,0,0,0-.895.2c-.3.149-.492.425-.776.583a.535.535,0,0,1-.626-.048,3.52,3.52,0,0,0-.536-.528A1.656,1.656,0,0,0,17.572,1.761Zm-4.68,53.695a3.955,3.955,0,0,1-2.667-1.2.493.493,0,0,0-.327-.163.519.519,0,0,0-.346.2,3.965,3.965,0,0,1-2.716,1.16,3.73,3.73,0,0,1-2.266-.791,3.6,3.6,0,0,1-1.463-3.044c.023-1.114.085-2.228.146-3.342.033-.607.067-1.213.094-1.82l.137-3.172c.063-1.491.126-2.982.2-4.472a.787.787,0,0,0-.113-.591.505.505,0,0,0-.39-.126,2.078,2.078,0,0,0-.211.013,2.1,2.1,0,0,1-.261.016,2.394,2.394,0,0,1-2.292-2.5C.406,34.364.408,33.108.411,31.852l.005-1.616c0-.543-.005-1.086-.011-1.631-.011-1.2-.023-2.434.024-3.647a7.761,7.761,0,0,1,2.528-5.817,3.27,3.27,0,0,1,2.268-.863l1.161.009c1.311.011,2.622.022,3.933.022,1.288,0,2.576-.01,3.863-.042l.142,0a4.2,4.2,0,0,1,3.813,2.247c.149.247.311.47.643.47a.992.992,0,0,0,.241-.032,2.832,2.832,0,0,1,.683-.081,4.618,4.618,0,0,1,1.051.137.83.83,0,0,0,.2.025.673.673,0,0,0,.535-.281,7.845,7.845,0,0,1,6.289-2.88l1.112,0a8.974,8.974,0,0,1,2.626.279,7.567,7.567,0,0,1,5.6,6.133c.542,2.7,1.06,5.528,1.538,8.4A4.2,4.2,0,0,1,36.9,36.9a1.014,1.014,0,0,0-.456,1.1c.145.883.256,1.772.366,2.661a.823.823,0,0,1-.147.651.905.905,0,0,1-.678.279c-.287.016-.575.022-.862.022s-.546-.005-.819-.012h0c-.44,0-.613.168-.648.577-.228,2.645-.47,5.288-.71,7.932l-.24,2.624c-.145,1.587-.822,2.436-2.132,2.674a2.085,2.085,0,0,1-.379.035,2.338,2.338,0,0,1-1.308-.431.677.677,0,0,0-.384-.146A.65.65,0,0,0,28.14,55a2.611,2.611,0,0,1-1.411.453,2.447,2.447,0,0,1-1.95-1.09c-.088-.115-.176-.218-.295-.218-.1,0-.189.074-.3.194a2.855,2.855,0,0,1-2.126,1.12,3.361,3.361,0,0,1-1.838-.647.548.548,0,0,0-.709.007,3.145,3.145,0,0,1-1.769.638,2.884,2.884,0,0,1-1.873-.8.506.506,0,0,0-.326-.15.59.59,0,0,0-.32.128A4.148,4.148,0,0,1,12.892,55.456ZM4.552,24.047a.724.724,0,0,1,.678.719,2.319,2.319,0,0,1,.01.277c.036,5.8.021,11.963-.327,18.232-.053.967-.105,1.933-.15,2.9l-.068,1.41c-.068,1.376-.136,2.751-.168,4.127A2.292,2.292,0,0,0,6.29,53.963a2.394,2.394,0,0,0,.558.067A2.355,2.355,0,0,0,8.9,52.8a2.758,2.758,0,0,0,.277-1.372q-.005-7.158,0-14.313c0-.6.264-.955.7-.957s.718.35.737.936c0,.1,0,7.338,0,7.338v2.157c0,1.711-.005,3.422.007,5.133a2.286,2.286,0,0,0,2.3,2.3,2.542,2.542,0,0,0,.386-.03,1.874,1.874,0,0,0,1.65-1.546l0-6.971a.58.58,0,0,0-.345-.636,2.148,2.148,0,0,1-1.318-2.2q0-.986,0-1.973c0-.98,0-1.958.006-2.937a6.254,6.254,0,0,1,.948-3.364,1.925,1.925,0,0,0,.3-1.09q-.007-1.913,0-3.825,0-2.075-.005-4.151c0-.6.038-1.045.586-1.291a.6.6,0,0,0,.242-.315,4.609,4.609,0,0,1,1.382-1.748.493.493,0,0,0,.119-.78,2.918,2.918,0,0,0-2.609-1.5c-1.434.015-2.83.021-4.225.021q-2.237,0-4.474-.019h0a2.688,2.688,0,0,0-2.253,1.1,6.576,6.576,0,0,0-1.451,4.06c-.021,2.573-.018,5.147-.016,7.719l0,3c0,.091,0,.182.009.274a.91.91,0,0,0,.954.872c.449-.005.965-.2.966-1.116l0-10.379a3.5,3.5,0,0,1,.013-.439.7.7,0,0,1,.7-.7Zm15.238,8.6c-.114,0-.226,0-.341.013a4.98,4.98,0,0,0-4.674,4.6c-.043,1.245-.034,2.512-.026,3.737,0,.6.008,1.206.006,1.808a.671.671,0,0,0,.715.754c.686.053.874.256.876.949,0,.885,0,6.825,0,7.76a2.124,2.124,0,0,0,.145.861,1.4,1.4,0,0,0,1.306.878q.063,0,.129-.005a1.348,1.348,0,0,0,1.185-1.05,3.315,3.315,0,0,0,.087-.86V45.217a2.6,2.6,0,0,1,.016-.4.634.634,0,0,1,.665-.6.644.644,0,0,1,.679.586,1.909,1.909,0,0,1,.018.39v6.984a2.772,2.772,0,0,0,.081.81A1.353,1.353,0,0,0,21.975,54a1.392,1.392,0,0,0,1.357-1.073,3.905,3.905,0,0,0,.093-.965V49.218q0-2.375-.005-4.747c0-.539.185-.812.606-.886a.775.775,0,0,0,.684-.908c-.012-1.635-.009-3.272,0-4.908a5.669,5.669,0,0,0-.121-1.169A5.052,5.052,0,0,0,19.79,32.647Zm7.152,8.929a1.5,1.5,0,0,0-.581.11c-.273.114-.243.4-.221.6.005.053.011.105.012.154a2.376,2.376,0,0,1-.932,2.2.521.521,0,0,0-.179.559c.242,2.563.477,5.081.7,7.6.09,1,.605,1.209,1.023,1.209.667-.022,1.01-.461,1.012-1.235q.005-1.807,0-3.616V46.229q0-1.978,0-3.955l.005-.105c.011-.166.029-.417-.222-.5A2.043,2.043,0,0,0,26.941,41.575Zm2.283,7.54c0,1.27,0,2.54.005,3.809A.985.985,0,0,0,30.188,54h0a1.025,1.025,0,0,0,1.053-.993c.03-.275.053-.55.075-.826l.623-6.784c.092-.981.183-1.961.259-2.943.031-.387.04-.6-.074-.72s-.325-.127-.7-.128l-.885.01c-.179,0-.355,0-.532-.017-.052,0-.1-.006-.146-.006a.635.635,0,0,0-.482.158.815.815,0,0,0-.167.617c.023,1.253.018,2.5.014,3.757v2.988ZM19.736,31.259a6.374,6.374,0,0,1,6.243,5.083,11.359,11.359,0,0,1,.167,2.5c0,.228,0,.457,0,.686,0,.268.005.636.528.636q1.968-.005,3.927-.005c1.385,0,4.158,0,4.158,0a.517.517,0,0,0,.416-.137.488.488,0,0,0,.078-.407c-.044-.306-.081-.613-.118-.919-.07-.568-.139-1.135-.247-1.7-.4-2.09-.825-4.177-1.244-6.264l-.7-3.51c-.187-.932-.374-1.864-.548-2.8a.7.7,0,0,1,.519-.863.836.836,0,0,1,.163-.017.714.714,0,0,1,.686.578c.042.146.07.3.1.447l.474,2.374q.806,4.016,1.617,8.03a.9.9,0,0,1,.011.127c.007.143.017.359.232.4H36.2a.507.507,0,0,0,.439-.3l.059-.088a3.066,3.066,0,0,0,.526-2.476q-.655-3.591-1.322-7.183l-.13-.7a6.283,6.283,0,0,0-5.285-5.383,8.585,8.585,0,0,0-1.43-.1c-.329,0-.658.011-.987.022-.272.009-.543.018-.814.021a5.962,5.962,0,0,0-3.988,1.595c-.364.323-.564.5-.576.71s.151.384.474.743a4.537,4.537,0,0,1,.915,5.2,4.492,4.492,0,0,1-4.268,2.853l-.18,0a4.779,4.779,0,0,1-3.479-1.568L16,28.712l0,1.107c0,.661,0,1.271-.006,1.88,0,.232.009.372.089.453a.208.208,0,0,0,.156.061.835.835,0,0,0,.373-.136A6.459,6.459,0,0,1,19.736,31.259Zm0-8.962a3.431,3.431,0,0,0-3.384,3.368A3.35,3.35,0,0,0,19.7,29h0a3.4,3.4,0,0,0,2.445-1.013,3.244,3.244,0,0,0,.956-2.327A3.4,3.4,0,0,0,19.75,22.3ZM9.873,17a4.811,4.811,0,0,1-4.761-4.8A4.773,4.773,0,1,1,9.9,17H9.873ZM9.9,8.87a3.376,3.376,0,0,0-3.377,3.3,3.353,3.353,0,0,0,3.308,3.388h0a3.345,3.345,0,1,0,.088-6.69H9.9ZM28.487,17a4.773,4.773,0,0,1-4.741-4.759,4.823,4.823,0,0,1,1.381-3.411,4.684,4.684,0,0,1,3.359-1.407,4.8,4.8,0,0,1,3.383,8.18A4.708,4.708,0,0,1,28.505,17Zm0-8.134a3.378,3.378,0,0,0-3.368,3.319,3.281,3.281,0,0,0,.96,2.36,3.391,3.391,0,0,0,4.831,0,3.282,3.282,0,0,0,.963-2.359A3.381,3.381,0,0,0,28.5,8.87Z",
          transform: "translate(10.605 2.431)",
          fill: "#ee2b7b"
        }
      )
    ]
  }
), J4 = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_47_inerbargabilidad",
    "data-name": "47_inerbargabilidad",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ r(
        "path",
        {
          id: "_47_inerbargabilidad-2",
          "data-name": "47_inerbargabilidad",
          d: "M52.332,24.291l-7.98-7.755V4.621a.648.648,0,0,0-.675-.675H35.7a.648.648,0,0,0-.675.675V7.678L27.942.935A1.739,1.739,0,0,0,25.582.8l-3.935,3.82L.855,24.291A1.535,1.535,0,0,0,.4,25.527a2.357,2.357,0,0,0,.45,1.237l1.574,1.574a1.737,1.737,0,0,0,2.36.112l1.124-1.012V46.995a.648.648,0,0,0,.675.675H46.864c.45,0,.684-.26.684-.787V27.2l.973,1.124a1.873,1.873,0,0,0,1.237.45c.45,0,.541-.1,1-.439l1.69-1.644C52.785,26.356,53.547,25.505,52.332,24.291ZM46.15,46.207H14.567l-1.124-.112H7.393V26.088l19.2-17.421a.342.342,0,0,1,.45,0L46.151,26.088V46.207Zm5.283-20.456-1.678,1.574a.342.342,0,0,1-.45,0L27.829,7.655a1.611,1.611,0,0,0-1.124-.45,1.691,1.691,0,0,0-1.237.45L4,27.437a.342.342,0,0,1-.45,0L1.81,25.695A.348.348,0,0,1,1.7,25.47c0-.112,0-.112.112-.225L26.481,1.811c.112-.112.112-.112.225-.112a.413.413,0,0,1,.337.112l8.317,7.98a.666.666,0,0,0,.787.112c.225-.112.143-.45.143-.675V5.3h6.826V16.852a.764.764,0,0,0,.225.582L51.658,25.3C51.77,25.414,51.545,25.639,51.432,25.751ZM35.091,31.808A2.794,2.794,0,0,0,32.649,29.4c-.107-.01-.107-.013-.106-.111,0-.687.01-1.488,0-2.275a7.01,7.01,0,0,0-.1-1.182,5.468,5.468,0,0,0-6.16-4.477,5.339,5.339,0,0,0-4.253,3.134,5.6,5.6,0,0,0-.523,2.475c0,.592,0,1.182,0,1.774V29.3a.551.551,0,0,1,0,.088.131.131,0,0,1-.049.013,2.783,2.783,0,0,0-2.522,2.772c-.009,1.906-.02,4.066,0,6.194a2.7,2.7,0,0,0,1.609,2.522,3.063,3.063,0,0,0,1.407.275l2.3,0h7.848a2.957,2.957,0,0,0,1.824-.523,2.772,2.772,0,0,0,1.189-2.346q.007-1.95,0-3.9v-1.95A5.184,5.184,0,0,0,35.091,31.808ZM22.746,27.886c0-.164,0-.334,0-.511a7.866,7.866,0,0,1,.07-1.327,4.309,4.309,0,0,1,3.82-3.5,4.2,4.2,0,0,1,3.322,1.147,4.03,4.03,0,0,1,1.311,2.666,18.713,18.713,0,0,1,.039,1.88c0,.368-.009.737,0,1.1,0,.026,0,.04,0,.043a.166.166,0,0,1-.057,0c-.246,0-.5-.012-.753,0-.09.008-.107-.01-.108-.01s-.018-.018-.017-.115c.01-.771.01-1.583,0-2.415a3.431,3.431,0,0,0-.723-2.114,3.335,3.335,0,0,0-2.628-1.277,3.283,3.283,0,0,0-.937.136,3.33,3.33,0,0,0-2.38,2.887c-.047.585-.039,1.178-.034,1.753,0,.322.008.645,0,.978a.528.528,0,0,0,.007.164,2.932,2.932,0,0,1-.392.007c-.146,0-.293,0-.438,0-.084.007-.1-.008-.1-.008s-.015-.019-.012-.1c.009-.307.007-.614.006-.951Zm2.171-.016q0-.53,0-1.059a2.129,2.129,0,0,1,2.111-2.124h0a2.128,2.128,0,0,1,2.108,2.128c0,.34,0,.681,0,1.022,0,.482,0,.966,0,1.449a.207.207,0,0,1-.012.095.192.192,0,0,1-.088.012h-.008c-.494-.006-.987,0-1.483,0H26.409c-.458,0-.916,0-1.374.006-.106-.008-.108-.014-.108-.014s-.016-.018-.015-.117C24.918,28.8,24.917,28.334,24.917,27.87ZM33.886,32.3v5.931A1.57,1.57,0,0,1,32.2,39.926H21.884a1.572,1.572,0,0,1-1.714-1.707V32.288A1.563,1.563,0,0,1,21.848,30.6q5.177-.006,10.354,0A1.57,1.57,0,0,1,33.886,32.3Zm-7.239-.74a2.468,2.468,0,0,0-1.96,1.587,2.385,2.385,0,0,0,.389,2.406,1.307,1.307,0,0,1,.337,1.039.5.5,0,0,0,0,.054l.133.018h-.132l0,.2c0,.227,0,.461.024.7A1.608,1.608,0,0,0,27.021,39h.007a1.606,1.606,0,0,0,1.593-1.445,10.117,10.117,0,0,0,.025-1.062c0-.125,0-.25,0-.376a.37.37,0,0,1,.128-.309,2.355,2.355,0,0,0,.76-1.849,2.49,2.49,0,0,0-.888-1.84A2.532,2.532,0,0,0,26.646,31.561Zm.761,5.641v.117c0,.18-.059.4-.316.438a.376.376,0,0,1-.3-.077.425.425,0,0,1-.137-.321c-.007-.2,0-.406,0-.609l0-.4h0v-.1c0-.175,0-.35,0-.524a.713.713,0,0,0-.338-.654,1.278,1.278,0,0,1-.552-.953,1.291,1.291,0,0,1,.423-1.032,1.227,1.227,0,0,1,.928-.321,1.274,1.274,0,0,1,.9.464,1.292,1.292,0,0,1,.272.991,1.172,1.172,0,0,1-.49.812.823.823,0,0,0-.391.767C27.421,36.264,27.414,36.741,27.408,37.2Z",
          transform: "translate(3.595 5.598)",
          fill: "#ee2b7b"
        }
      )
    ]
  }
), eo = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_01_informacion_valor",
    "data-name": "01_informacion_valor",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_01_informacion_valor-2",
          "data-name": "01_informacion_valor",
          transform: "translate(4.706 3.5)",
          children: [
            /* @__PURE__ */ r("g", { id: "Grupo_16903", "data-name": "Grupo 16903", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41308",
                "data-name": "Trazado 41308",
                d: "M32.494,19.5h-16.2a.7.7,0,0,1,0-1.4h16.2a.7.7,0,1,1,0,1.4Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16904", "data-name": "Grupo 16904", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41309",
                "data-name": "Trazado 41309",
                d: "M26.894,29.8h-10.6a.7.7,0,0,1,0-1.4h10.6a.7.7,0,0,1,0,1.4Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16905", "data-name": "Grupo 16905", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41310",
                "data-name": "Trazado 41310",
                d: "M23.494,40.1h-7.2a.7.7,0,0,1,0-1.4h7.3a.684.684,0,0,1,.7.7A.773.773,0,0,1,23.494,40.1Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16906", "data-name": "Grupo 16906", children: /* @__PURE__ */ r(
              "circle",
              {
                id: "Elipse_92",
                "data-name": "Elipse 92",
                cx: "1.7",
                cy: "1.7",
                r: "1.7",
                transform: "translate(8.994 17.1)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16907", "data-name": "Grupo 16907", children: /* @__PURE__ */ r(
              "circle",
              {
                id: "Elipse_93",
                "data-name": "Elipse 93",
                cx: "1.7",
                cy: "1.7",
                r: "1.7",
                transform: "translate(8.994 27.4)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16908", "data-name": "Grupo 16908", children: /* @__PURE__ */ r(
              "circle",
              {
                id: "Elipse_94",
                "data-name": "Elipse 94",
                cx: "1.7",
                cy: "1.7",
                r: "1.7",
                transform: "translate(8.994 37.6)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16909", "data-name": "Grupo 16909", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41311",
                "data-name": "Trazado 41311",
                d: "M38.494,48.7a10.9,10.9,0,1,1,10.9-10.9A10.926,10.926,0,0,1,38.494,48.7Zm.052-20.4a9.488,9.488,0,1,0,9.488,9.488A9.491,9.491,0,0,0,38.546,28.3Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16911", "data-name": "Grupo 16911", children: /* @__PURE__ */ r("g", { id: "Grupo_16910", "data-name": "Grupo 16910", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41312",
                "data-name": "Trazado 41312",
                d: "M42.294,43.1c-.2,0-.3,0-.4-.1l-2.9-2.1-2.9,2.1a.6.6,0,0,1-.8,0,.585.585,0,0,1-.3-.7l1.1-3.4-2.9-2.1a.585.585,0,0,1-.3-.7.738.738,0,0,1,.6-.5h3.6l1.1-3.4a.694.694,0,0,1,1.3,0l1.1,3.4h3.7a.56.56,0,0,1,.6.5c0,.3,0,.6-.3.7l-2.9,2.3,1.1,3.2a.517.517,0,0,1-.3.7C42.494,43.1,42.294,43.1,42.294,43.1Z",
                fill: "#ee2b7b"
              }
            ) }) }),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41313",
                "data-name": "Trazado 41313",
                d: "M28.394,49.1H2.894V12.8h9.7a.789.789,0,0,0,.8-.8V3.1h24.9V23.2a.8.8,0,0,0,1.6,0V2.3a.86.86,0,0,0-.8-.8h-27.5a1.072,1.072,0,0,0-.6.2l-9.5,9.5a1.421,1.421,0,0,0-.2.6V49.9a.86.86,0,0,0,.8.8h26.3a.8.8,0,0,0,0-1.6Zm-16.5-46v8.1h-8.1Z",
                fill: "#ee2b7b"
              }
            )
          ]
        }
      )
    ]
  }
), ao = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_16_icono_interdisciplinario",
    "data-name": "16_icono_interdisciplinario",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_16_icono_interdisciplinario-2",
          "data-name": "16_icono_interdisciplinario",
          transform: "translate(-2.201 -4.1)",
          children: [
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41197",
                "data-name": "Trazado 41197",
                d: "M13.5,57.3a4.086,4.086,0,0,0-.568-.246,5.744,5.744,0,0,1-.587-.244A4.039,4.039,0,0,1,10.2,53.2V23.4a4.114,4.114,0,0,1,4.3-4.3H28.9c.9,0,1.2.3,1.2,1.2v4.8c0,.461.145.587.468.695a3.663,3.663,0,0,1-.092,7.108.648.648,0,0,0-.477.7v3.1a.612.612,0,0,0,.068.531.666.666,0,0,0,.532.168h5.3c.729.093.994.438.9,1.188a2.834,2.834,0,0,0-.1,1.333,1.9,1.9,0,0,0,1.868,1.424,2.252,2.252,0,0,0,.449-.046A1.97,1.97,0,0,0,40.4,39.19a2.854,2.854,0,0,0-.051-.456A2.794,2.794,0,0,1,40.3,38.3a.788.788,0,0,1,.72-.8,1.222,1.222,0,0,1,.58-.1H47c1.045,0,1.3.256,1.3,1.3V51a12.21,12.21,0,0,1,0,2.689A3.817,3.817,0,0,1,45.274,57.2h-.007a.214.214,0,0,0-.138.076L45.1,57.3Zm15.635-8.319c.7,0,.965.3.965,1.117V55c0,.432.117.7.7.7H44a2.454,2.454,0,0,0,1.662-.521A1.887,1.887,0,0,0,46.6,53.5a21.659,21.659,0,0,1,.1-2.489V39.6c0-.354-.145-.5-.5-.5H42.546c-.355,0-.5.145-.5.5a3.585,3.585,0,0,1-3.23,3.5c-.069,0-.139.005-.208.005A3.43,3.43,0,0,1,35.2,40.08a.835.835,0,0,1-.025-.309.541.541,0,0,0-.216-.554.882.882,0,0,0-.505-.142c-.078,0-.156.006-.234.013s-.145.013-.217.013H30.7c-.454,0-.6.146-.6.6V44c0,.815-.262,1.118-.968,1.118a3.158,3.158,0,0,1-.323-.018h0a2.055,2.055,0,0,0-1.791.943,1.764,1.764,0,0,0,0,2.012,1.717,1.717,0,0,0,1.526.963,1.8,1.8,0,0,0,.271-.02C28.926,48.988,29.035,48.982,29.135,48.982ZM12.509,39.2c-.663,0-.709.046-.709.7v6.7c0,.737.011,1.464.023,2.187.022,1.4.045,2.85-.023,4.309a2.478,2.478,0,0,0,2.633,2.6H28c.46,0,.608-.146.608-.6,0-1.28,0-2.6-.1-3.808,0-.46-.26-.583-.575-.687a3.067,3.067,0,0,1-1.879-1.07,3.567,3.567,0,0,1-.777-3.483A3.7,3.7,0,0,1,27.928,43.6c.457-.112.583-.262.583-.7V39.8c0-.454-.148-.6-.608-.6H23.852c-.543,0-.816-.244-.913-.816A2.038,2.038,0,0,0,21.016,36.6a1.878,1.878,0,0,0-2.023,1.682c-.093.729-.322.918-1.116.918H12.509Zm8.507-4.325a3.558,3.558,0,0,1,3.353,2.173.647.647,0,0,0,.7.461H28c.46,0,.608-.147.608-.607V32.394a.906.906,0,0,1,.979-1.028,1.951,1.951,0,0,1,.224.014,1.993,1.993,0,0,0,.276.02,1.778,1.778,0,0,0,1.541-.822,1.953,1.953,0,0,0,0-2.132,1.831,1.831,0,0,0-1.544-.88,2.059,2.059,0,0,0-.279.02c-.113.011-.223.018-.323.018-.714,0-.979-.307-.979-1.133V21.61c0-.663-.046-.709-.709-.709H14.433A2.284,2.284,0,0,0,11.9,23.433V36.8a.634.634,0,0,0,.709.709h4.354a.654.654,0,0,0,.7-.475A3.554,3.554,0,0,1,21.016,34.875Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41198",
                "data-name": "Trazado 41198",
                d: "M45.309,35.136a3.7,3.7,0,0,1-2.929-1.4,2.861,2.861,0,0,1-.78-1.94c0-.454-.146-.6-.6-.6H36.2c-1.045,0-1.3-.255-1.3-1.3V24.6c0-.942.258-1.2,1.2-1.2a1.932,1.932,0,0,0,2-1.479,1.764,1.764,0,0,0-.953-2.211A2.057,2.057,0,0,0,36,19.5a.968.968,0,0,1-1.1-1.1V12.1c0-.71.319-1,1.1-1H50.8a4.011,4.011,0,0,1,4.1,4.1c.065,3.26.044,6.588.021,9.807C54.911,26.663,54.9,28.326,54.9,30c0,.942-.258,1.2-1.2,1.2H49.4c-.258,0-.6.062-.6.6a3.657,3.657,0,0,1-2.532,3.2A3.509,3.509,0,0,1,45.309,35.136ZM37.1,12.8c-.359,0-.505.148-.505.509v3.866c0,.469.145.6.474.707a3.591,3.591,0,0,1,2.868,3.566,3.67,3.67,0,0,1-2.859,3.564c-.323.108-.483.23-.483.608v3.256c0,.591.283.712.708.712h5.164a1.088,1.088,0,0,1,.893.326,1.135,1.135,0,0,1,.123.975,2.891,2.891,0,0,0-.1.937,1.869,1.869,0,0,0,1.607,1.831,1.9,1.9,0,0,0,.211.011,2.1,2.1,0,0,0,1.923-1.4,2.025,2.025,0,0,0,0-1.383,1.132,1.132,0,0,1,.125-.972,1.086,1.086,0,0,1,.892-.325h4.455c.476,0,.6-.153.706-.586l0-13.66A2.331,2.331,0,0,0,50.768,12.8Z",
                fill: "#ee2b7b"
              }
            )
          ]
        }
      )
    ]
  }
), to = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_42_licencia_slang_storytel",
    "data-name": "42_licencia_slang_storytel",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_42_licencia_slang_storytel-2",
          "data-name": "42_licencia_slang_storytel",
          transform: "translate(-2.255 -2.412)",
          children: [
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40990",
                "data-name": "Trazado 40990",
                d: "M51,40.9l.6-.3a3.649,3.649,0,0,0,1.9-4.7,3.85,3.85,0,0,0-2.4-2.1,3.647,3.647,0,0,0,1.6-4.5,3.723,3.723,0,0,0-3.3-2.2,3.194,3.194,0,0,0-1.4.3l-2,.9A3.649,3.649,0,0,0,44.1,33a4.119,4.119,0,0,0,2.4,2.1l-.5.2A3.649,3.649,0,0,0,44.1,40a3.607,3.607,0,0,0,2.2,2l-.1.1a4.7,4.7,0,0,0-.9.6H23.5V15.6H47.4v8.7a.8.8,0,0,0,1.6,0V14.8h0v-3c0-2.3-1.2-4.3-4-4.3,0,0-17.2-.2-19.8,0-1.9.3-3.4,2.6-3.4,4.6v3.1a5.754,5.754,0,0,0-2-1.1A4.585,4.585,0,0,0,16,14c-1,.6-.9,1.7-.6,3.3a27.8,27.8,0,0,1-1.3,12.2c-1.3,4-2.5,7.7-2.8,11a15.621,15.621,0,0,0,6.3,14.1,14.89,14.89,0,0,0,8.7,2.9,13.107,13.107,0,0,0,5-1l11.3-4.8a9.723,9.723,0,0,0,1.8-.1c1.8-.3,3.6-1.4,3.9-3.1.1,0,.2-.1.3-.2l2.6-1.1A3.385,3.385,0,0,0,53,42.8,3.135,3.135,0,0,0,51,40.9Zm-5.4-8.6a2.118,2.118,0,0,1,1-2.6l2-.9A1.859,1.859,0,0,1,51,29.9a1.985,1.985,0,0,1-1,2.6l-2,.9A1.859,1.859,0,0,1,45.6,32.3Zm0,7.1a1.985,1.985,0,0,1,1-2.6l2.9-1.3a1.7,1.7,0,0,1,.7-.1,1.788,1.788,0,0,1,1.7,1.1,1.985,1.985,0,0,1-1,2.6L48,40.4A1.727,1.727,0,0,1,45.6,39.4ZM25.4,9.2c2.5-.3,19.6,0,19.6,0,2.6,0,2.4,3,2.4,3V14H23.5V12.1C23.5,10.9,24.3,9.3,25.4,9.2ZM30.6,55c-3.6,1.6-8.3.9-11.9-1.7a13.617,13.617,0,0,1-5.6-12.6c.2-3.1,1.4-6.8,2.7-10.6a28.055,28.055,0,0,0,1.3-12.9c-.1-.8-.2-1.7-.2-1.8a3.475,3.475,0,0,1,2.4.2,4.8,4.8,0,0,1,2.5,2.1V47.3a4.316,4.316,0,0,0,3.5,4.3c2.3.2,8.1.2,12.9.2Zm13.7-5.1c-3.4.3-15.4.3-18.8,0a2.7,2.7,0,0,1-2-2.6v-3H44.4a3.33,3.33,0,0,0,.1,2.2,3.448,3.448,0,0,0,2.1,2A3.179,3.179,0,0,1,44.3,49.9Zm6.4-4.2-2.6,1.1a1.518,1.518,0,0,1-2.1-.9,1.476,1.476,0,0,1,.3-1.8h0a2.092,2.092,0,0,1,.6-.4l2.6-1.1a1.268,1.268,0,0,1,.6-.1,1.634,1.634,0,0,1,1.5,1.1A1.749,1.749,0,0,1,50.7,45.7Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40991",
                "data-name": "Trazado 40991",
                d: "M38.1,46.3H32.2a.8.8,0,0,0,0,1.6h5.9a.86.86,0,0,0,.8-.8A.789.789,0,0,0,38.1,46.3Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40992",
                "data-name": "Trazado 40992",
                d: "M42.5,32H28.9a.86.86,0,0,0-.8.8.789.789,0,0,0,.8.8H42.5a.86.86,0,0,0,.8-.8A.789.789,0,0,0,42.5,32Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40993",
                "data-name": "Trazado 40993",
                d: "M42.5,25.7H28.9a.8.8,0,0,0,0,1.6H42.5a.86.86,0,0,0,.8-.8A.789.789,0,0,0,42.5,25.7Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40994",
                "data-name": "Trazado 40994",
                d: "M42.5,20.6H28.9a.86.86,0,0,0-.8.8.789.789,0,0,0,.8.8H42.5a.86.86,0,0,0,.8-.8A.789.789,0,0,0,42.5,20.6Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40995",
                "data-name": "Trazado 40995",
                d: "M28.9,37.2a.86.86,0,0,0-.8.8.789.789,0,0,0,.8.8H42.5a.86.86,0,0,0,.8-.8.789.789,0,0,0-.8-.8Z",
                fill: "#ee2b7b"
              }
            )
          ]
        }
      )
    ]
  }
), ro = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_12_icono_llegar_tiempo",
    "data-name": "12_icono_llegar_tiempo",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_12_icono_llegar_tiempo-2",
          "data-name": "12_icono_llegar_tiempo",
          transform: "translate(-2.5 -2.5)",
          children: [
            /* @__PURE__ */ r("g", { id: "Grupo_16812", "data-name": "Grupo 16812", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41179",
                "data-name": "Trazado 41179",
                d: "M32.5,59.5a27,27,0,1,1,27-27A27.015,27.015,0,0,1,32.5,59.5Zm0-51.8A24.8,24.8,0,1,0,57.3,32.5,24.8,24.8,0,0,0,32.5,7.7Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16813", "data-name": "Grupo 16813", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41180",
                "data-name": "Trazado 41180",
                d: "M32.5,34.9a2.4,2.4,0,1,1,2.4-2.4A2.433,2.433,0,0,1,32.5,34.9Zm0-2.6a.215.215,0,0,0-.2.2c0,.2.4.2.4,0A.215.215,0,0,0,32.5,32.3Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16814", "data-name": "Grupo 16814", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41181",
                "data-name": "Trazado 41181",
                d: "M19.5,33.6a1.1,1.1,0,1,1,0-2.2h13a1.1,1.1,0,0,1,0,2.2Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16815", "data-name": "Grupo 16815", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41182",
                "data-name": "Trazado 41182",
                d: "M32.5,33.6a.749.749,0,0,1-.5-.1,1.129,1.129,0,0,1-.4-1.5L41.9,14a1.1,1.1,0,0,1,1.9,1.1L33.4,33A.961.961,0,0,1,32.5,33.6Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16816", "data-name": "Grupo 16816", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41183",
                "data-name": "Trazado 41183",
                d: "M32.5,15.5a1.11,1.11,0,0,1-1.1-1.1V11.8a1.1,1.1,0,1,1,2.2,0v2.6A1.11,1.11,0,0,1,32.5,15.5Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16817", "data-name": "Grupo 16817", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41184",
                "data-name": "Trazado 41184",
                d: "M32.5,54.3a1.11,1.11,0,0,1-1.1-1.1V50.6a1.1,1.1,0,0,1,2.2,0v2.6A1.11,1.11,0,0,1,32.5,54.3Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16818", "data-name": "Grupo 16818", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41185",
                "data-name": "Trazado 41185",
                d: "M22.1,51.5a.749.749,0,0,1-.5-.1,1.129,1.129,0,0,1-.4-1.5l1.3-2.2a1.1,1.1,0,1,1,1.9,1.1L23.1,51A1.231,1.231,0,0,1,22.1,51.5Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16819", "data-name": "Grupo 16819", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41186",
                "data-name": "Trazado 41186",
                d: "M14.6,44a1.05,1.05,0,0,1-.9-.5,1.129,1.129,0,0,1,.4-1.5l2.2-1.3a1.1,1.1,0,0,1,1.1,1.9l-2.2,1.3A3.536,3.536,0,0,0,14.6,44Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16820", "data-name": "Grupo 16820", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41187",
                "data-name": "Trazado 41187",
                d: "M48.2,24.5a1.05,1.05,0,0,1-.9-.5,1.129,1.129,0,0,1,.4-1.5l2.2-1.3A1.1,1.1,0,1,1,51,23.1l-2.2,1.3A1.268,1.268,0,0,1,48.2,24.5Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16821", "data-name": "Grupo 16821", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41188",
                "data-name": "Trazado 41188",
                d: "M14.4,33.6H11.8a1.1,1.1,0,1,1,0-2.2h2.6a1.1,1.1,0,1,1,0,2.2Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16822", "data-name": "Grupo 16822", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41189",
                "data-name": "Trazado 41189",
                d: "M53.2,33.6H50.6a1.1,1.1,0,0,1,0-2.2h2.6a1.1,1.1,0,0,1,0,2.2Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16823", "data-name": "Grupo 16823", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41190",
                "data-name": "Trazado 41190",
                d: "M16.8,24.5a.749.749,0,0,1-.5-.1L14,23.1a1.1,1.1,0,0,1,1.1-1.9l2.2,1.3a1.129,1.129,0,0,1,.4,1.5A1.05,1.05,0,0,1,16.8,24.5Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16824", "data-name": "Grupo 16824", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41191",
                "data-name": "Trazado 41191",
                d: "M50.4,44a.749.749,0,0,1-.5-.1l-2.2-1.3a1.1,1.1,0,1,1,1.1-1.9L51,42a1.129,1.129,0,0,1,.4,1.5A1.231,1.231,0,0,1,50.4,44Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16825", "data-name": "Grupo 16825", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41192",
                "data-name": "Trazado 41192",
                d: "M23.4,17.9a1.05,1.05,0,0,1-.9-.5l-1.3-2.2a1.1,1.1,0,0,1,1.9-1.1l1.3,2.2a1.129,1.129,0,0,1-.4,1.5C23.8,17.8,23.6,17.9,23.4,17.9Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16826", "data-name": "Grupo 16826", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41193",
                "data-name": "Trazado 41193",
                d: "M42.9,51.5A1.05,1.05,0,0,1,42,51l-1.3-2.2a1.1,1.1,0,0,1,1.9-1.1l1.3,2.2a1.129,1.129,0,0,1-.4,1.5A1.486,1.486,0,0,1,42.9,51.5Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16827", "data-name": "Grupo 16827", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41194",
                "data-name": "Trazado 41194",
                d: "M53.2,33.6H50.6a1.1,1.1,0,0,1,0-2.2h2.6a1.1,1.1,0,0,1,0,2.2Z",
                fill: "#ee2b7b"
              }
            ) })
          ]
        }
      )
    ]
  }
), io = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_22_icono_manutencion_semestral",
    "data-name": "22_icono_manutencion_semestral",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_22_icono_manutencion_semestral-2",
          "data-name": "22_icono_manutencion_semestral",
          transform: "translate(0.2 1)",
          children: [
            /* @__PURE__ */ r("g", { id: "Grupo_16543", "data-name": "Grupo 16543", children: /* @__PURE__ */ r("g", { id: "Grupo_16542", "data-name": "Grupo 16542", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40789",
                "data-name": "Trazado 40789",
                d: "M20.3,31.3A9.3,9.3,0,1,1,29.6,22,9.347,9.347,0,0,1,20.3,31.3Zm0-17.2A7.9,7.9,0,1,0,28.2,22,7.917,7.917,0,0,0,20.3,14.1Z",
                fill: "#ee2b7b"
              }
            ) }) }),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40790",
                "data-name": "Trazado 40790",
                d: "M23.1,19.6a.637.637,0,0,1-.9.7.675.675,0,0,1-.4-.6,1.508,1.508,0,0,0-.9-1.4,1.358,1.358,0,0,0-1.6.2,1.423,1.423,0,0,0-.5,1.6A1.5,1.5,0,0,0,20,21.2a2.769,2.769,0,0,1,.9.1A2.653,2.653,0,0,1,23,23.8a2.912,2.912,0,0,1-1.9,2.9c-.3.1-.3.1-.3.4v.4a.6.6,0,1,1-1.2,0V27c0-.2-.1-.2-.2-.3a2.749,2.749,0,0,1-1.9-2,1.268,1.268,0,0,1-.1-.6.645.645,0,0,1,.6-.6.661.661,0,0,1,.7.6.6.6,0,0,0,.1.4,1.341,1.341,0,0,0,1.5,1.1,1.5,1.5,0,1,0,0-3,2.7,2.7,0,0,1-2.7-2.3,2.784,2.784,0,0,1,1.9-3.1c.2-.1.2-.1.2-.3v-.4a.6.6,0,0,1,1.2,0V17c0,.1,0,.2.2.3a2.954,2.954,0,0,1,2,2.3C23.1,19.4,23.1,19.5,23.1,19.6Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40791",
                "data-name": "Trazado 40791",
                d: "M56.9,11.2A3.222,3.222,0,0,0,53.7,8a3.137,3.137,0,0,0-3.2,3.1v.4L37.2,23l-2.7,2.7a3.371,3.371,0,0,0-1.7-.5,3.159,3.159,0,0,0-3.2,3.2,3.194,3.194,0,0,0,.3,1.4L18.8,38.9,10,42.4A3.127,3.127,0,0,0,6.9,40a3.2,3.2,0,0,0,0,6.4A3.33,3.33,0,0,0,10,44l9.5-3.9c.1,0,.1-.1.2-.1l11.1-9.1A3.2,3.2,0,0,0,36,28.4a3.371,3.371,0,0,0-.5-1.7L38.2,24,51.1,13a2.787,2.787,0,0,0,1.8,1.2V47.5a1.817,1.817,0,0,1-1.8,1.9H47V19.8a.7.7,0,0,0-1.4,0V49.4H40.5V25.9a.7.7,0,0,0-1.4,0V49.4H34v-16a.7.7,0,0,0-1.4,0v16H27.5V38.3a.7.7,0,1,0-1.4,0V49.4H21V42a.7.7,0,0,0-1.4,0v7.4H14.5V45a.7.7,0,1,0-1.4,0v4.4h-7a2.989,2.989,0,0,1-2.9-3,.684.684,0,0,0-.7-.7.684.684,0,0,0-.7.7,4.439,4.439,0,0,0,4.4,4.4h45a3.1,3.1,0,0,0,3.1-3.3V14.2A2.946,2.946,0,0,0,56.9,11.2ZM6.9,45a.6.6,0,0,1-.4-.1,1.77,1.77,0,0,1,.4-3.5A1.831,1.831,0,0,1,8.7,43v.2A1.793,1.793,0,0,1,6.9,45ZM32.8,30.3a1.613,1.613,0,0,1-.9-.3,1.548,1.548,0,0,1-.8-1.1c0-.1-.1-.3-.1-.4a1.793,1.793,0,0,1,1.8-1.8,1.268,1.268,0,0,1,.6.1,1.651,1.651,0,0,1,1,1,1.854,1.854,0,0,1,.2.7A1.793,1.793,0,0,1,32.8,30.3ZM53.7,13a1.8,1.8,0,1,1,1.8-1.8A1.793,1.793,0,0,1,53.7,13Z",
                fill: "#ee2b7b"
              }
            )
          ]
        }
      )
    ]
  }
), no = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_02_icono_meditar",
    "data-name": "02_icono_meditar",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h("g", { id: "_02_icono_meditar-2", "data-name": "02_icono_meditar", transform: "translate(-2.6 -2.5)", children: [
        /* @__PURE__ */ r("g", { id: "Grupo_16743", "data-name": "Grupo 16743", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41115",
            "data-name": "Trazado 41115",
            d: "M45.3,59.5h-.5L33,57.3h-.8L20.4,59.5a3.031,3.031,0,0,1-2.4-.6,2.836,2.836,0,0,1-1-2.2v-.9a5.835,5.835,0,0,1-3.9-5.5,5.727,5.727,0,0,1,3-5.1l8.7-4.8V34.9l-3.6,3a6.1,6.1,0,0,1-4.1,1.5H12.2a3.6,3.6,0,1,1,0-7.2h3.9l5.5-7.8A10.194,10.194,0,0,1,30,20.1h5.3a10.47,10.47,0,0,1,8.4,4.3l5.5,7.8h3.9a3.6,3.6,0,1,1,0,7.2H48a6.1,6.1,0,0,1-4.1-1.5l-3.6-3v5.5L49,45.2a5.928,5.928,0,0,1,3,5.1,5.835,5.835,0,0,1-3.9,5.5v.9a2.865,2.865,0,0,1-1,2.2A3,3,0,0,1,45.3,59.5ZM33.2,55.6l11.9,2.2a1.015,1.015,0,0,0,1-.3,1.086,1.086,0,0,0,.4-.9v-.9a1.5,1.5,0,0,1,1.1-1.5,4.125,4.125,0,0,0,.7-7.5l-9.2-5.1a.755.755,0,0,1-.4-.7V33a1.02,1.02,0,0,1,.5-.8.94.94,0,0,1,.9.1l5,4.2a4.617,4.617,0,0,0,3,1.1H53a1.9,1.9,0,1,0,0-3.8H48.7a.755.755,0,0,1-.7-.4l-5.8-8.1a8.714,8.714,0,0,0-7-3.6H29.9a8.448,8.448,0,0,0-7,3.6l-5.8,8.1a1.012,1.012,0,0,1-.7.4H12.1a1.9,1.9,0,0,0,0,3.8H17a4.617,4.617,0,0,0,3-1.1l5-4.2a.761.761,0,0,1,.9-.1.792.792,0,0,1,.5.8v7.8a.842.842,0,0,1-.4.7l-9.2,5.1a4.125,4.125,0,0,0,.7,7.5,1.5,1.5,0,0,1,1.1,1.5v.9a1.268,1.268,0,0,0,.4.9,1.689,1.689,0,0,0,1,.3l11.8-2.2A3.688,3.688,0,0,1,33.2,55.6Z",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16744", "data-name": "Grupo 16744", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41116",
            "data-name": "Trazado 41116",
            d: "M32.5,19.5a7,7,0,1,1,7-7A6.957,6.957,0,0,1,32.5,19.5Zm0-12.3a5.3,5.3,0,1,0,5.3,5.3A5.335,5.335,0,0,0,32.5,7.2Z",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16745", "data-name": "Grupo 16745", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41117",
            "data-name": "Trazado 41117",
            d: "M30,48.5l-2.4,1.4h9.9l-2.2-1.4A5.538,5.538,0,0,0,30,48.5Z",
            fill: "#ee2b7b"
          }
        ) })
      ] })
    ]
  }
), oo = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_34_mejora_de_casa",
    "data-name": "34_mejora_de_casa",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ r(
        "path",
        {
          id: "_34_mejora_de_casa-2",
          "data-name": "34_mejora_de_casa",
          d: "M46.107,32.232V26.7l1.164,1.067a2.016,2.016,0,0,0,1.164.485,1.217,1.217,0,0,0,1.067-.582l1.552-1.552a1.607,1.607,0,0,0,.485-1.164,1.79,1.79,0,0,0-.485-1.164l-7.762-7.471V4.676A.663.663,0,0,0,42.614,4H34.851a.663.663,0,0,0-.679.679V7.49L27.283.891a1.67,1.67,0,0,0-2.329,0L1.085,23.79A1.607,1.607,0,0,0,.6,24.955a1.79,1.79,0,0,0,.485,1.164l1.552,1.552a1.673,1.673,0,0,0,2.329.1l1.067-.97V45.816a.663.663,0,0,0,.679.679H30.194A11.76,11.76,0,1,0,46.107,32.232ZM6.131,24.955,4.093,26.8a.3.3,0,0,1-.388,0L2.053,25.146a.3.3,0,0,1-.1-.194c0-.1,0-.1.1-.194l23.772-22.9a.4.4,0,0,1,.585.1l8.053,7.762a.732.732,0,0,0,.776.1.817.817,0,0,0,.388-.679V5.355h6.307V16.707a.741.741,0,0,0,.194.485l8.053,7.665a.3.3,0,0,1,.1.194c0,.1,0,.1-.1.194L48.63,26.8a.3.3,0,0,1-.388,0L27.283,7.684A1.248,1.248,0,0,0,26.119,7.3a2.035,2.035,0,0,0-1.067.388ZM29.612,45.04H14.475V42.323H29.612ZM17.534,40.868V27.284h9.06V40.868Zm12.369.1H27.865V26.6a.663.663,0,0,0-.679-.679H16.8a.663.663,0,0,0-.679.679v14.36H13.8a.663.663,0,0,0-.679.679v3.4H7.489v-19.5L25.925,8.654a.3.3,0,0,1,.388,0L44.845,25.537h0v6.21a13.049,13.049,0,0,0-3.4-.485,15.925,15.925,0,0,0-2.232.194V26.6a.663.663,0,0,0-.679-.679h-6.21a.663.663,0,0,0-.679.679v7.277a.663.663,0,0,0,.679.679h.97A11.183,11.183,0,0,0,29.9,40.965Zm7.956-13.681v4.56a13.831,13.831,0,0,0-2.717,1.261H32.967V27.284Zm3.59,26a10.315,10.315,0,0,1-9.7-6.792,8.084,8.084,0,0,1-.388-1.455A14.476,14.476,0,0,1,31.164,43a10.173,10.173,0,0,1,4.463-8.442,9.861,9.861,0,0,1,3.59-1.552,8.271,8.271,0,0,1,2.232-.291,9.994,9.994,0,0,1,3.4.582,7.315,7.315,0,0,1,1.261.582,10.255,10.255,0,0,1-4.657,19.406Zm6.367-6.2a1.689,1.689,0,0,0-.511-.916l-2.217-2.216c-.214-.216-.4-.248-.611-.107a.424.424,0,0,0-.08-.584c-.078-.08-.157-.161-.242-.243l.319-.316c.151-.149.3-.3.458-.451a2.533,2.533,0,0,0,.732,0,2.568,2.568,0,0,0,1.719-1.039A2.6,2.6,0,0,0,47.8,39.2a.471.471,0,0,0-.307-.39.465.465,0,0,0-.479.155l-.388.388c-.22.219-.44.44-.662.665-.126-.045-.253-.087-.381-.131-.111-.037-.222-.075-.336-.114l-.032-.1c-.062-.2-.127-.4-.19-.618.234-.23.466-.464.7-.7l.238-.238c.055-.054.111-.111.164-.172a.446.446,0,0,0,.1-.415.436.436,0,0,0-.315-.286,1.966,1.966,0,0,0-.2-.047h-.8a2.556,2.556,0,0,0-2.123,2.887.11.11,0,0,0,0,.012l-.009.01-.827.823-.572.57a.374.374,0,0,0-.121-.223q-.336-.335-.671-.673c-.409-.413-.833-.841-1.268-1.251a1.506,1.506,0,0,1-.55-.974.575.575,0,0,0-.313-.426c-.3-.17-.6-.343-.9-.516l-.427-.246a.046.046,0,0,0-.024-.007h-.264a.047.047,0,0,0-.03.011l-.048.038a5.036,5.036,0,0,0-.472.449c-.067.07-.136.141-.2.207l-.052.049a.85.85,0,0,0-.245.313.029.029,0,0,0,0,.016l-.013.2a.046.046,0,0,0,.006.026l.79,1.391a.558.558,0,0,0,.379.28l.145.036.132.033c.082.02.163.042.246.06a.224.224,0,0,1,.113.066q.921.927,1.846,1.849l.37.37a.509.509,0,0,0,.3.194c-.173.171-.343.343-.514.512-.3.3-.6.6-.9.9A2.552,2.552,0,0,0,36.03,45.57a2.92,2.92,0,0,0-.268.965l0,.4.013.076c.013.078.025.162.045.247a2.577,2.577,0,0,0,2.463,2.007h.061a2.573,2.573,0,0,0,2.51-2.938c.276-.271.525-.52.76-.759.06.06.12.12.182.18l.053.054a.428.428,0,0,0,.586.088.429.429,0,0,0,.074.57l.348.348c.648.651,1.319,1.323,1.984,1.979a1.65,1.65,0,0,0,1.178.488,2.046,2.046,0,0,0,.344-.031A1.762,1.762,0,0,0,47.817,47.087ZM47,47.542a.911.911,0,0,1-.173.474.936.936,0,0,1-.67.389l-.022,0Zm-8.259.841a1.72,1.72,0,1,1-.628-3.373A1.652,1.652,0,0,1,38.324,45a1.317,1.317,0,0,1,.323.038.535.535,0,0,0,.545-.154c1.273-1.274,2.665-2.665,4.259-4.252a.586.586,0,0,0,.18-.575,1.67,1.67,0,0,1,.256-1.294,1.708,1.708,0,0,1,.89-.664c-.153.154-.313.313-.476.472a.538.538,0,0,0-.147.617c.116.318.222.645.329.981a.551.551,0,0,0,.368.374c.343.112.688.226,1.03.343a.5.5,0,0,0,.553-.136c.165-.17.334-.339.5-.506a1.557,1.557,0,0,1-.323.579,1.654,1.654,0,0,1-1.66.571.555.555,0,0,0-.532.165c-1.465,1.469-2.9,2.9-4.265,4.264a.578.578,0,0,0-.169.562A1.7,1.7,0,0,1,38.745,48.384Zm3.536-3.489.527-.525c.247-.247.5-.5.75-.752l.022.018a.284.284,0,0,1-.022.063.774.774,0,0,0,.063.742.845.845,0,0,0,.706.385.606.606,0,0,0,.356-.078c.649.652,1.3,1.3,1.956,1.959-.445.443-.892.889-1.341,1.341q-.977-.98-1.961-1.959a.832.832,0,0,0-1.108-1.106l-.019-.019C42.232,44.943,42.257,44.92,42.281,44.894ZM40.6,42.267a.434.434,0,0,0-.142-.225L39.8,41.4c-.477-.474-.971-.966-1.448-1.461a1.629,1.629,0,0,0-.985-.542.24.24,0,0,1-.046-.011l-.011,0-.07-.019-.018-.018c-.169-.3-.341-.6-.515-.9q.159-.156.319-.32l.221.129c.225.131.458.265.7.412.012.051.024.1.038.151l.016.065c.022.085.046.172.064.255a.729.729,0,0,0,.213.381L39.8,41.022l.755.754a.535.535,0,0,0,.333.2C40.787,42.077,40.692,42.173,40.6,42.267Zm-1.307,3.3a.491.491,0,0,0-.45-.253c-.347,0-.694,0-1.044,0a.491.491,0,0,0-.449.253c-.178.3-.355.6-.537.893a.46.46,0,0,0,0,.5q.272.451.542.905a.468.468,0,0,0,.425.236h.778c.092,0,.185,0,.288,0h.015a.491.491,0,0,0,.441-.26c.159-.273.329-.554.518-.861a.486.486,0,0,0,0-.538C39.657,46.181,39.489,45.9,39.289,45.563ZM38.995,46.7c-.045.071-.088.143-.134.217-.068.112-.139.226-.213.345-.219,0-.44,0-.67-.008-.1-.17-.216-.361-.335-.536.114-.185.225-.372.33-.552h.523c.055,0,.111,0,.165,0C38.765,46.342,38.878,46.528,38.995,46.7Z",
          transform: "translate(3.4 2.582)",
          fill: "#ee2b7b"
        }
      )
    ]
  }
), so = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_01_mujeres_lideres",
    "data-name": "01_mujeres_lideres",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ r(
        "path",
        {
          id: "_01_mujeres_lideres-2",
          "data-name": "01_mujeres_lideres",
          d: "M46.591,44.048a9.258,9.258,0,0,0,2.175-.783,1.816,1.816,0,0,0,1.044-1.827,1.779,1.779,0,0,0-1.218-1.653,6.03,6.03,0,0,1-3.916-5.656c0-1.392.087-2.872.087-4.438.261-9.311.609-19.927-9.659-24.278a15.838,15.838,0,0,0-15.837,2c-4.612,3.829-5.134,10.355-5.134,14.88V34.128a6.03,6.03,0,0,1-3.916,5.656A1.906,1.906,0,0,0,9,41.438a1.954,1.954,0,0,0,1.044,1.827,9.939,9.939,0,0,0,2.262.783C10.392,45.353,9,47.355,9,51.1v1.566a.783.783,0,1,0,1.566,0V51.1c0-5.482,3.394-6.526,7.135-7.57,1.218,1.392,5.656,5.482,11.747,5.482s10.529-4.177,11.66-5.569a21.384,21.384,0,0,1,2.523.783.085.085,0,0,1,.087.087c2.611.957,4.612,2.611,4.612,6.787v1.566a.783.783,0,0,0,1.566,0V51.1C49.9,47.355,48.506,45.353,46.591,44.048ZM29.449,34.041c-5.047,0-10.7-5.308-10.7-12.443a4.982,4.982,0,0,1,4.786-4.96c1.479.7,10.442,5.308,16.446,5.743C39.63,29.255,34.322,34.041,29.449,34.041ZM10.566,41.525a.466.466,0,0,1,.261-.348A7.56,7.56,0,0,0,15.7,34.128V22.294c0-4.264.435-10.268,4.612-13.662a13.6,13.6,0,0,1,8.7-2.872,13.571,13.571,0,0,1,5.569,1.131c9.311,4,8.963,14.01,8.7,22.885,0,1.479-.087,3.046-.087,4.438a7.522,7.522,0,0,0,4.873,7.048.325.325,0,0,1,.261.348.347.347,0,0,1-.174.348,8.965,8.965,0,0,1-4,.87,26.039,26.039,0,0,0-2.785-.87c-4-1.131-6.439-2-6.439-5.917V33.954A14.368,14.368,0,0,0,41.544,21.6a.78.78,0,0,0-.783-.783c-6,0-16.62-5.482-16.707-5.569a.523.523,0,0,0-.348-.087A6.425,6.425,0,0,0,17.267,21.6,14.772,14.772,0,0,0,23.88,33.954V36.13a4.72,4.72,0,0,1-1.827,4.09,14.884,14.884,0,0,1-4.525,1.74c-.87.261-1.827.522-2.7.87a8.062,8.062,0,0,1-4.09-.87A.562.562,0,0,1,10.566,41.525ZM19.355,43c.087,0,.174-.087.348-.087,2-.609,4-1.566,5.047-3.568a.085.085,0,0,1,.087-.087l.261-.522c0-.087.087-.087.087-.174.087-.174.087-.348.174-.522,0-.087.087-.174.087-.261,0-.174.087-.348.087-.522V35a9.035,9.035,0,0,0,7.919,0v1.044a6.187,6.187,0,0,0,1.914,4.873,11.966,11.966,0,0,0,4.177,2.175c-1.74,1.479-5.308,4.438-10.094,4.438S21.008,44.57,19.355,43Z",
          transform: "translate(1 0.844)",
          fill: "#ee2b7b"
        }
      )
    ]
  }
), lo = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_25_icono_notifica",
    "data-name": "25_icono_notifica",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ r(
        "path",
        {
          id: "_25_icono_notifica-2",
          "data-name": "25_icono_notifica",
          d: "M47.838,1.512a4.8,4.8,0,0,0-3.6-1.2,5.08,5.08,0,0,0-3.4,1.7c-.689.787-3.222,4.971-7.685,12.25-4.5-2.013-8.991.626-13.835,4.05a9.78,9.78,0,0,1-4.6,1.6,17.573,17.573,0,0,0-12.5,6s0,.006,0,.009-.023.02-.033.031c-3.816,4.418-.6,13.255,7.33,20.184A29.119,29.119,0,0,0,21.26,52.563a13.761,13.761,0,0,0,3.414.4,7.208,7.208,0,0,0,5.68-2.264c.022.005.043.005.064.012a17.51,17.51,0,0,0,4.3-13.2,9.057,9.057,0,0,1,1-4.8c2.922-5.667,4.97-10.7,1.655-15.048,9.978-7.973,10.669-8.856,10.965-9.152a4.8,4.8,0,0,0,1.2-3.6A5.08,5.08,0,0,0,47.838,1.512ZM21.6,50.529a26.27,26.27,0,0,1-10.836-5.945C3.9,38.54.622,30.614,3.6,27.245A5.647,5.647,0,0,1,7.978,25.66a19.554,19.554,0,0,1,9.06,2.861l-3.726,2.63a3.823,3.823,0,0,0-2.874-.981,3.676,3.676,0,0,0-2.7,1.3,3.833,3.833,0,0,0-1,2.9,3.676,3.676,0,0,0,1.3,2.7,3.541,3.541,0,0,0,2.6,1h.3a3.676,3.676,0,0,0,2.7-1.3,3.833,3.833,0,0,0,1-2.9,3.285,3.285,0,0,0-.255-1.2l4.384-3.095A31.935,31.935,0,0,1,21.9,31.9a25.772,25.772,0,0,1,7.357,9.908c1.035,2.752,1.094,5.128.182,6.745-.172.219-.333.446-.517.656a.914.914,0,0,0-.061.121C27.441,50.84,24.809,51.305,21.6,50.529Zm-8.86-16.558a1.741,1.741,0,0,1-.5,1.5,2.127,2.127,0,0,1-1.5.7,1.741,1.741,0,0,1-1.5-.5,2.127,2.127,0,0,1-.7-1.5,1.741,1.741,0,0,1,.5-1.5,2.127,2.127,0,0,1,1.5-.7h.1a1.872,1.872,0,0,1,1.4.5A2.127,2.127,0,0,1,12.738,33.971Zm21.28-2.359a11.049,11.049,0,0,0-1.2,5.8,16.511,16.511,0,0,1-.992,6.845A15.484,15.484,0,0,0,31,41.316a27.916,27.916,0,0,0-7.933-10.745c-5.1-4.513-10.792-6.922-15.2-6.871a15.752,15.752,0,0,1,6.95-1.988,10.56,10.56,0,0,0,5.5-2c6.4-4.5,10.1-6.1,14.2-2.5C38.518,20.712,37.518,24.712,34.018,31.612Zm13.02-24.1c-.393.393-2.251,2.054-10.76,8.943-.153-.148-.292-.3-.46-.444a11.972,11.972,0,0,0-1.115-.876C40.656,5.284,41.941,3.4,42.238,3.107a3.336,3.336,0,0,1,2.2-1.1,3.094,3.094,0,0,1,2.3.8,3.822,3.822,0,0,1,1.1,2.4A3.1,3.1,0,0,1,47.038,7.512Z",
          transform: "translate(5.422 3.703)",
          fill: "#ee2b7b"
        }
      )
    ]
  }
), co = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_01_nuestra_gente",
    "data-name": "01_nuestra_gente",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h("g", { id: "_01_nuestra_gente-2", "data-name": "01_nuestra_gente", transform: "translate(2.813 1.667)", children: [
        /* @__PURE__ */ h("g", { id: "Grupo_16714", "data-name": "Grupo 16714", children: [
          /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41025",
              "data-name": "Trazado 41025",
              d: "M50.628,29.59V39.735a2.93,2.93,0,0,1-2.547,2.307c-.3.036-.337.252-.337.5,0,.74,0,1.479,0,2.219,0,2.763.009,5.525-.005,8.287A2.991,2.991,0,0,1,46,55.94a2.885,2.885,0,0,1-3.292-.46c-.234-.194-.374-.141-.576.028a2.891,2.891,0,0,1-2.443.695,3.05,3.05,0,0,1-2.56-3.155c-.016-1.66,0-3.321-.005-4.982,0-1.811-.006-3.623,0-5.434,0-.376-.094-.568-.518-.619a2.449,2.449,0,0,1-1.939-1.337c-.314-.608-.736-.3-1.119-.266-.416.039-.274.41-.275.652q-.012,5.887-.006,11.775a3.17,3.17,0,0,1-1.944,3.106,3.105,3.105,0,0,1-3.6-.62c-.22-.2-.348-.2-.555.007a3.136,3.136,0,0,1-2.114.911,3.281,3.281,0,0,1-3.439-3.264c-.012-4,0-8-.008-12,0-.224.088-.557-.272-.563s-.761-.377-1.065.195a2.6,2.6,0,0,1-2.084,1.421c-.3.035-.428.172-.422.467.007.362,0,.725,0,1.087,0,3.14,0,6.28,0,9.42a3.014,3.014,0,0,1-1.745,2.939,2.885,2.885,0,0,1-3.292-.463c-.236-.2-.375-.134-.576.033A2.9,2.9,0,0,1,9.7,56.2,3.061,3.061,0,0,1,7.146,53c-.016-2.053-.005-4.106-.005-6.159,0-1.4-.007-2.808,0-4.212,0-.379-.1-.607-.525-.611a1.554,1.554,0,0,1-.523-.134A3.083,3.083,0,0,1,4.25,39.736V29.591c.045-.144.092-.287.133-.432a4.58,4.58,0,0,1,4.61-3.485c2.339,0,4.679,0,7.018,0a4.794,4.794,0,0,1,1.9.376c.512.217.512.217.694-.317A4.994,4.994,0,0,1,23.5,22.225q3.984,0,7.969,0a4.543,4.543,0,0,1,.766.044,4.972,4.972,0,0,1,4.08,3.6c.113.336.227.4.537.237a3.934,3.934,0,0,1,1.789-.429c2.521-.008,5.041-.014,7.562,0a4.218,4.218,0,0,1,2.636.945A5.075,5.075,0,0,1,50.628,29.59ZM23.121,40.958q0,5.91,0,11.819a1.789,1.789,0,1,0,3.56-.011c.007-1.253,0-2.506,0-3.758q0-3.737,0-7.472c0-.562.285-.9.732-.912s.76.342.773.918c0,.136,0,.272,0,.408V50.6c0,.8-.018,1.6.011,2.4a1.775,1.775,0,0,0,3.549-.038c.008-.287,0-.574,0-.86q0-11.547,0-23.094c0-.64.267-.977.752-.982s.753.331.755.97c0,1.208,0,2.415,0,3.623q0,2.875,0,5.751c0,.514.1.585.6.441a1.626,1.626,0,0,0,1.171-1.647c.011-3.321.034-6.642-.016-9.962A3.516,3.516,0,0,0,31.4,23.734q-3.962-.006-7.924,0a3.814,3.814,0,0,0-.676.041,3.637,3.637,0,0,0-2.969,3.781q-.01,4.619,0,9.237a4.458,4.458,0,0,0,.029.633,1.628,1.628,0,0,0,1.022,1.338c.581.248.727.142.727-.483q0-4.551,0-9.1a3.162,3.162,0,0,1,.014-.5.739.739,0,0,1,1.454-.082,2.638,2.638,0,0,1,.04.63Q23.122,35.093,23.121,40.958Zm-6.9,1.584q0-5.072,0-10.143c0-.226,0-.453.018-.679.047-.567.342-.888.782-.867s.715.368.741.923c.007.151,0,.3,0,.453v7.426c0,.136,0,.272,0,.408.016.455.194.563.6.364a1.4,1.4,0,0,0,.689-.75.428.428,0,0,0-.035-.469,4.166,4.166,0,0,1-.748-2.735c.012-2.611,0-5.222.012-7.834a1,1,0,0,0-.5-.936,3.011,3.011,0,0,0-1.664-.515c-2.445-.013-4.891-.029-7.335,0a3.072,3.072,0,0,0-3.049,2.994c-.041,2.988-.016,5.977-.013,8.965A1.413,1.413,0,0,0,6.3,40.286a.674.674,0,0,0,.662.206c.276-.109.18-.389.181-.6.006-2.581,0-5.162.007-7.743a3.377,3.377,0,0,1,.063-.718.68.68,0,0,1,.718-.569.678.678,0,0,1,.706.584,4.468,4.468,0,0,1,.059.81q0,10.166,0,20.331c0,.241,0,.483.011.724a1.479,1.479,0,0,0,2.956.009c.016-.271.018-.543.018-.815q0-4.506,0-9.011a3.833,3.833,0,0,1,.067-.809.658.658,0,0,1,.686-.543.688.688,0,0,1,.721.5,2.225,2.225,0,0,1,.073.762q0,4.529,0,9.056c0,.287,0,.574.015.86a1.459,1.459,0,0,0,1.254,1.4,1.515,1.515,0,0,0,1.609-.913,2.556,2.556,0,0,0,.109-.983Q16.219,47.68,16.219,42.542Zm22.452-.007q0,4.143,0,8.286c0,.845-.016,1.691.02,2.535a1.462,1.462,0,0,0,1.469,1.377,1.48,1.48,0,0,0,1.478-1.416c.014-.256.017-.513.017-.769q0-4.551,0-9.1a4.013,4.013,0,0,1,.043-.676.682.682,0,0,1,.71-.628.689.689,0,0,1,.753.632,4.226,4.226,0,0,1,.042.721c.007,3.26,0,6.52.02,9.78a1.448,1.448,0,0,0,1.429,1.46,1.479,1.479,0,0,0,1.525-1.416c.017-.24.013-.483.013-.724q0-10.074,0-20.149c0-.256,0-.514.022-.769.051-.532.352-.843.777-.824s.706.352.742.875c.009.135.006.272.006.407v4.256c0,1.223,0,2.445,0,3.668,0,.454.194.57.6.362a1.376,1.376,0,0,0,.8-1.275c.01-2.988.032-5.977-.009-8.965a3.085,3.085,0,0,0-3.089-3c-2.415-.01-4.83,0-7.244,0a3.153,3.153,0,0,0-1.593.445,1.122,1.122,0,0,0-.617,1.1c.026,2.686.011,5.373.012,8.059a3.864,3.864,0,0,1-.562,2.158.851.851,0,0,0,.239,1.334c.192.149.411.309.66.211.275-.109.174-.391.175-.6.007-2.6,0-5.192.007-7.788a2.969,2.969,0,0,1,.06-.673.687.687,0,0,1,.724-.564.68.68,0,0,1,.7.587,4.244,4.244,0,0,1,.058.765Q38.673,37.374,38.671,42.535Z",
              fill: "#ee2b7b"
            }
          ),
          /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41026",
              "data-name": "Trazado 41026",
              d: "M32.368,15.293a4.926,4.926,0,1,1-4.909-4.932A4.933,4.933,0,0,1,32.368,15.293Zm-4.91,3.418a3.367,3.367,0,0,0,3.4-3.419,3.417,3.417,0,1,0-6.833.022A3.388,3.388,0,0,0,27.458,18.711Z",
              fill: "#ee2b7b"
            }
          ),
          /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41027",
              "data-name": "Trazado 41027",
              d: "M42.416,24.084A4.5,4.5,0,1,1,46.934,19.6,4.557,4.557,0,0,1,42.416,24.084Zm3.01-4.526a2.994,2.994,0,1,0-3,3.014A3.043,3.043,0,0,0,45.426,19.558Z",
              fill: "#ee2b7b"
            }
          ),
          /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41028",
              "data-name": "Trazado 41028",
              d: "M12.47,24.084a4.5,4.5,0,1,1,4.487-4.519A4.557,4.557,0,0,1,12.47,24.084ZM15.447,19.6a2.99,2.99,0,1,0-2.989,2.972A3.042,3.042,0,0,0,15.447,19.6Z",
              fill: "#ee2b7b"
            }
          )
        ] }),
        /* @__PURE__ */ r("g", { id: "Grupo_16715", "data-name": "Grupo 16715", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41029",
            "data-name": "Trazado 41029",
            d: "M53.9,15.107a.366.366,0,0,1-.3-.1L27.381,1.9,1.26,15.007a.771.771,0,0,1-.993-.3.771.771,0,0,1,.3-.993L27.083.407a.85.85,0,0,1,.695,0L54.3,13.617a.688.688,0,0,1,.3.993C54.4,14.908,54.2,15.107,53.9,15.107Z",
            fill: "#ee2b7b"
          }
        ) })
      ] })
    ]
  }
), uo = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_04_Icono_nuevas_oportunidades",
    "data-name": "04_Icono_nuevas_oportunidades",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_04_Icono_nuevas_oportunidades-2",
          "data-name": "04_Icono_nuevas_oportunidades",
          transform: "translate(0.012 8.441)",
          children: [
            /* @__PURE__ */ h("g", { id: "Grupo_16723", "data-name": "Grupo 16723", children: [
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41059",
                  "data-name": "Trazado 41059",
                  d: "M23.188,34.659a.684.684,0,0,0-.7-.7H4.988v-17.6a.9.9,0,0,1,.9-.9h23a.773.773,0,0,0,.7-.8.684.684,0,0,0-.7-.7H5.988a2.433,2.433,0,0,0-2.4,2.4v17.6h-.6a2.006,2.006,0,0,0-2,2v.1l.4,2.3c.5,1.5,1.3,1.8,2,1.8h19.1c.4,0,.7-.5.7-.9a.684.684,0,0,0-.7-.7H3.388c-.1,0-.3,0-.5-.6l-.4-2.1a.458.458,0,0,1,.5-.4h19.5A.773.773,0,0,0,23.188,34.659Z",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41060",
                  "data-name": "Trazado 41060",
                  d: "M41.488,23.359c-9.929,0-16.6,4.982-16.6,12.4v6.7c0,.45.538.8,1,.8a.783.783,0,0,0,.8-.8v-6.6c0-7.392,7.483-10.7,14.9-10.7s14.9,3.31,14.9,10.7v6.7a.783.783,0,0,0,.8.8.868.868,0,0,0,.8-.9v-6.6C58.088,28.383,51.417,23.359,41.488,23.359Z",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41061",
                  "data-name": "Trazado 41061",
                  d: "M41.488,21.359a10.4,10.4,0,1,0-10.4-10.4A10.412,10.412,0,0,0,41.488,21.359Zm0-19.1a8.71,8.71,0,0,1,8.7,8.7,8.816,8.816,0,0,1-8.7,8.7,8.7,8.7,0,1,1,0-17.4Z",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41062",
                  "data-name": "Trazado 41062",
                  d: "M5.288,36.359a.7.7,0,0,0,0,1.4h.3a.7.7,0,0,0,0-1.4Z",
                  fill: "#ee2b7b"
                }
              )
            ] }),
            /* @__PURE__ */ r("g", { id: "Grupo_16724", "data-name": "Grupo 16724", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41063",
                "data-name": "Trazado 41063",
                d: "M14.833,27.814a3.356,3.356,0,0,0,2.4,2.769.254.254,0,0,1,.2.289c-.01.2-.007.406,0,.61a.767.767,0,0,0,1.532,0,3.512,3.512,0,0,0,0-.492c-.027-.249.06-.368.312-.45a3.36,3.36,0,0,0,2.3-3.66,3.4,3.4,0,0,0-3.323-2.961,1.85,1.85,0,0,1-.432-3.657,1.856,1.856,0,0,1,1.994.906,2.4,2.4,0,0,1,.252.99.756.756,0,0,0,.79.678.747.747,0,0,0,.737-.706,2.532,2.532,0,0,0-.024-.537,3.345,3.345,0,0,0-2.384-2.776.264.264,0,0,1-.215-.305c.011-.2.007-.406,0-.61a.767.767,0,0,0-1.532,0,4.6,4.6,0,0,0,0,.563c.02.219-.068.31-.279.376a3.411,3.411,0,0,0-2.353,3.5,3.453,3.453,0,0,0,2.616,3.045c.346.085.7.061,1.045.118a1.767,1.767,0,0,1,1.481,1.241,1.84,1.84,0,0,1-2.342,2.32,1.817,1.817,0,0,1-1.258-1.748.8.8,0,0,0-.219-.528.765.765,0,0,0-.842-.18.8.8,0,0,0-.486.831C14.809,27.566,14.811,27.692,14.833,27.814Z",
                fill: "#ee2b7b"
              }
            ) })
          ]
        }
      )
    ]
  }
), ho = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_39_odontologia",
    "data-name": "39_odontologia",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ r("g", { id: "_39_odontologia-2", "data-name": "39_odontologia", transform: "translate(-3.5 -3.6)", children: /* @__PURE__ */ r(
        "path",
        {
          id: "Trazado_40984",
          "data-name": "Trazado 40984",
          d: "M41.682,59.492a4.315,4.315,0,0,0,3.952-2.7l.728-1.768a48.526,48.526,0,0,0,3.328-17.679V35.47a13.625,13.625,0,0,1,1.144-5.408l.936-2.184a15.787,15.787,0,0,0,1.248-6.136,15.576,15.576,0,0,0-4.888-11.335l-.312-.312a9.275,9.275,0,0,0-6.24-2.5,8.784,8.784,0,0,0-4.784,1.352,6.672,6.672,0,0,1-7.071,0A9.468,9.468,0,0,0,24.939,7.6a8.806,8.806,0,0,0-6.24,2.5l-.312.312A15.576,15.576,0,0,0,13.5,21.743a15.053,15.053,0,0,0,1.248,6.136l.936,2.184a14.017,14.017,0,0,1,1.144,5.408v1.872a49.358,49.358,0,0,0,3.328,17.679l.728,1.768a4.265,4.265,0,0,0,3.952,2.7A4.217,4.217,0,0,0,29.1,55.229V46.389a4.061,4.061,0,0,1,4.056-4.056,4.13,4.13,0,0,1,4.056,4.056v8.839A4.465,4.465,0,0,0,41.682,59.492ZM33.259,40.254a6.258,6.258,0,0,0-6.24,6.24v8.839a2.132,2.132,0,0,1-2.184,2.184,2.275,2.275,0,0,1-2.08-1.352L22.027,54.4a46.947,46.947,0,0,1-3.12-16.847V35.678a14.351,14.351,0,0,0-1.352-6.24l-.936-2.184a13.514,13.514,0,0,1-1.144-5.3,13.292,13.292,0,0,1,4.264-9.775l.312-.312a6.941,6.941,0,0,1,4.784-1.872,6.691,6.691,0,0,1,3.64,1.04,8.738,8.738,0,0,0,9.255,0,7.716,7.716,0,0,1,3.64-1.04,6.761,6.761,0,0,1,4.784,1.872l.312.312a13.465,13.465,0,0,1,4.264,9.775,13.13,13.13,0,0,1-1.144,5.3l-.936,2.184a16.425,16.425,0,0,0-1.352,6.24V37.55A46.535,46.535,0,0,1,44.178,54.4l-.728,1.768a2.171,2.171,0,0,1-2.08,1.352,2.132,2.132,0,0,1-2.184-2.184V46.493A5.76,5.76,0,0,0,33.259,40.254Z",
          transform: "translate(0 0)",
          fill: "#ee2b7b"
        }
      ) })
    ]
  }
), mo = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_22_pago_menos",
    "data-name": "22_pago_menos",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h("g", { id: "_22_pago_menos-2", "data-name": "22_pago_menos", transform: "translate(3.012 10.441)", children: [
        /* @__PURE__ */ h("g", { id: "Grupo_16629", "data-name": "Grupo 16629", transform: "translate(0.988 0.559)", children: [
          /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_40903",
              "data-name": "Trazado 40903",
              d: "M21.092,32.7a.619.619,0,0,0-.634-.634H4.61V16.132a.812.812,0,0,1,.815-.815H26.254a.7.7,0,0,0,.634-.724.619.619,0,0,0-.634-.634H5.516a2.2,2.2,0,0,0-2.173,2.173V32.071H2.8A1.817,1.817,0,0,0,.988,33.882v.091l.362,2.083c.453,1.358,1.177,1.63,1.811,1.63h17.3c.362,0,.634-.453.634-.815a.619.619,0,0,0-.634-.634H3.161c-.091,0-.272,0-.453-.543l-.362-1.9a.414.414,0,0,1,.453-.362H20.458A.7.7,0,0,0,21.092,32.7Z",
              transform: "translate(-0.988 -1.824)",
              fill: "#ee2b7b"
            }
          ),
          /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_40904",
              "data-name": "Trazado 40904",
              d: "M39.921,23.359c-8.992,0-15.033,4.512-15.033,11.229v6.068c0,.408.487.724.906.724a.709.709,0,0,0,.724-.724V34.678c0-6.694,6.777-9.691,13.493-9.691s13.493,3,13.493,9.691v6.067a.709.709,0,0,0,.724.724.786.786,0,0,0,.724-.814V34.678C54.954,27.909,48.913,23.359,39.921,23.359Z",
              transform: "translate(-3.244 -2.711)",
              fill: "#ee2b7b"
            }
          ),
          /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_40905",
              "data-name": "Trazado 40905",
              d: "M40.506,19.4a9.418,9.418,0,1,0-9.417-9.418A9.429,9.429,0,0,0,40.506,19.4Zm0-17.3a7.888,7.888,0,0,1,7.879,7.879,7.984,7.984,0,0,1-7.879,7.879,7.879,7.879,0,1,1,0-15.757Z",
              transform: "translate(-3.83 -0.559)",
              fill: "#ee2b7b"
            }
          ),
          /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_40906",
              "data-name": "Trazado 40906",
              d: "M5.222,36.359a.634.634,0,0,0,0,1.268h.272a.634.634,0,0,0,0-1.268Z",
              transform: "translate(-1.328 -3.939)",
              fill: "#ee2b7b"
            }
          )
        ] }),
        /* @__PURE__ */ r("g", { id: "Grupo_16630", "data-name": "Grupo 16630", transform: "translate(13.494 15.61)", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40907",
            "data-name": "Trazado 40907",
            d: "M14.83,26.81A3.039,3.039,0,0,0,17,29.318a.23.23,0,0,1,.186.262c-.009.183-.006.368,0,.552a.694.694,0,0,0,1.387,0,3.18,3.18,0,0,0,0-.446c-.024-.225.054-.333.283-.408a3.043,3.043,0,0,0,2.079-3.314,3.08,3.08,0,0,0-3.009-2.681,1.675,1.675,0,0,1-.391-3.312,1.681,1.681,0,0,1,1.806.82,2.175,2.175,0,0,1,.228.9.685.685,0,0,0,.715.614.676.676,0,0,0,.667-.639,2.293,2.293,0,0,0-.022-.486,3.03,3.03,0,0,0-2.159-2.514.239.239,0,0,1-.195-.276c.01-.183.006-.368,0-.552a.695.695,0,0,0-1.387,0,4.164,4.164,0,0,0,0,.51c.018.2-.062.281-.253.341A3.089,3.089,0,0,0,14.8,21.854a3.127,3.127,0,0,0,2.369,2.758c.313.077.633.055.946.107a1.6,1.6,0,0,1,1.341,1.124,1.666,1.666,0,0,1-2.121,2.1A1.645,1.645,0,0,1,16.2,26.36a.729.729,0,0,0-.2-.478.693.693,0,0,0-.763-.163.72.72,0,0,0-.44.753C14.808,26.585,14.81,26.7,14.83,26.81Z",
            transform: "translate(-14.798 -17.179)",
            fill: "#ee2b7b"
          }
        ) })
      ] })
    ]
  }
), fo = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_05_icono_pedir_ayuda",
    "data-name": "05_icono_pedir_ayuda",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_05_icono_pedir_ayuda-2",
          "data-name": "05_icono_pedir_ayuda",
          transform: "translate(0.3 0.5)",
          children: [
            /* @__PURE__ */ r("g", { id: "Grupo_16760", "data-name": "Grupo 16760", transform: "translate(21.316 22.664)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41132",
                "data-name": "Trazado 41132",
                d: "M31.685,39.016a1.3,1.3,0,0,1-.547-.182c-1.825-1.095-7.938-5.109-7.938-9.306A4.906,4.906,0,0,1,28.127,24.6a4.763,4.763,0,0,1,3.558,1.551A4.763,4.763,0,0,1,35.243,24.6a4.906,4.906,0,0,1,4.927,4.927c0,4.2-6.113,8.211-7.938,9.306A1.3,1.3,0,0,1,31.685,39.016Zm.274-1.551Zm-.547,0ZM28.127,26.151a3.428,3.428,0,0,0-3.376,3.376c0,3.285,5.565,6.934,6.934,7.755,1.369-.821,6.934-4.562,6.934-7.755a3.428,3.428,0,0,0-3.376-3.376A3.091,3.091,0,0,0,32.6,27.52a1.219,1.219,0,0,1-1.825,0A3.465,3.465,0,0,0,28.127,26.151Z",
                transform: "translate(-23.2 -24.6)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16762", "data-name": "Grupo 16762", transform: "translate(11.086 10.985)", children: /* @__PURE__ */ r("g", { id: "Grupo_16761", "data-name": "Grupo 16761", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41133",
                "data-name": "Trazado 41133",
                d: "M25.867,49.025a.549.549,0,0,1-.365-.091,1.456,1.456,0,0,1-.821-.639,1.255,1.255,0,0,1-.091-1,1.345,1.345,0,0,1,1.642-.912,1.456,1.456,0,0,1,.821.639,1.255,1.255,0,0,1,.091,1A1.2,1.2,0,0,1,25.867,49.025ZM20.028,46.2a1.472,1.472,0,0,1-.821-.274,1.369,1.369,0,1,1,1.642-2.19,1.552,1.552,0,0,1,.547.912,1.03,1.03,0,0,1-.274,1A1.59,1.59,0,0,1,20.028,46.2Zm-4.379-4.836a1.56,1.56,0,0,1-1.186-.639l-.091-.182a1.33,1.33,0,0,1,2.372-1.186,1.267,1.267,0,0,1,.182,1,1.161,1.161,0,0,1-.639.821A1.063,1.063,0,0,1,15.648,41.361Zm-2.372-6.022A1.279,1.279,0,0,1,12,34.244a1.351,1.351,0,0,1,1.095-1.551h.182a1.479,1.479,0,0,1,1.46,1.095,1.267,1.267,0,0,1-.182,1,1.641,1.641,0,0,1-.821.547h-.456ZM48.4,32.055a1.4,1.4,0,0,1-1.369-1.369,1.367,1.367,0,0,1,1.369-1.46,1.4,1.4,0,0,1,1.369,1.369A1.424,1.424,0,0,1,48.4,32.055Zm-1.277-6.478a1.545,1.545,0,0,1-1.277-.821,1.866,1.866,0,0,1,0-1,1.868,1.868,0,0,1,.73-.73,1.374,1.374,0,0,1,1.734.639.319.319,0,0,1,.091.182,1.866,1.866,0,0,1,0,1,1.425,1.425,0,0,1-.73.73ZM43.75,20.1a1.465,1.465,0,0,1-1-.456,1.372,1.372,0,0,1-.365-1,1.123,1.123,0,0,1,.456-.912,1.407,1.407,0,0,1,1.916.091,1.326,1.326,0,0,1-.091,1.916A1.927,1.927,0,0,1,43.75,20.1Zm-5.2-3.923A1.3,1.3,0,0,1,38,16a1.61,1.61,0,0,1-.73-.821,1.255,1.255,0,0,1,.091-1,1.487,1.487,0,0,1,1.825-.639,1.623,1.623,0,0,1,.639.73,1.255,1.255,0,0,1-.091,1A1.229,1.229,0,0,1,38.549,16.179Zm-6.3-1.734H31.98a1.328,1.328,0,0,1-1.095-1.46A1.309,1.309,0,0,1,32.254,11.8a1.177,1.177,0,0,1,1,.456,1.03,1.03,0,0,1,.274,1A1.229,1.229,0,0,1,32.254,14.446Z",
                transform: "translate(-11.987 -11.8)",
                fill: "#ee2b7b"
              }
            ) }) }),
            /* @__PURE__ */ h("g", { id: "Grupo_16769", "data-name": "Grupo 16769", transform: "translate(1.7 2.5)", children: [
              /* @__PURE__ */ h("g", { id: "Grupo_16765", "data-name": "Grupo 16765", transform: "translate(19.799 28.831)", children: [
                /* @__PURE__ */ r("g", { id: "Grupo_16763", "data-name": "Grupo 16763", transform: "translate(0 1.642)", children: /* @__PURE__ */ r(
                  "path",
                  {
                    id: "Trazado_41134",
                    "data-name": "Trazado 41134",
                    d: "M37.177,60.169H26.958a3.558,3.558,0,1,1,0-7.117h6.3a4.272,4.272,0,0,1,.73-3.467c.912-1.277,6.934-8.576,8.485-10.127,1.095-1.095,4.2-3.558,9.945-3.558a.818.818,0,0,1,.821.821V47.3a.818.818,0,0,1-.821.821,2.683,2.683,0,0,0-2.007.821l-6.752,8.485A8.343,8.343,0,0,1,37.177,60.169ZM26.958,54.877a1.754,1.754,0,0,0-1.825,1.734,1.83,1.83,0,0,0,1.825,1.825H37.177a7.221,7.221,0,0,0,5.383-2.19l6.752-8.485a4.652,4.652,0,0,1,2.372-1.277v-8.85a11.575,11.575,0,0,0-7.938,3.1c-1.551,1.551-7.481,8.759-8.3,9.945a2.052,2.052,0,0,0-.091,2.646,1.763,1.763,0,0,0,2.555,0L42.834,48.4a.822.822,0,0,1,1.369.639.77.77,0,0,1-.182.639L39.093,54.6a3.617,3.617,0,0,1-4.744.274Z",
                    transform: "translate(-23.4 -35.9)",
                    fill: "#ee2b7b"
                  }
                ) }),
                /* @__PURE__ */ r("g", { id: "Grupo_16764", "data-name": "Grupo 16764", transform: "translate(28.375)", children: /* @__PURE__ */ r(
                  "path",
                  {
                    id: "Trazado_41135",
                    "data-name": "Trazado 41135",
                    d: "M61.708,49.7H57.055A2.55,2.55,0,0,1,54.5,47.147V36.655A2.55,2.55,0,0,1,57.055,34.1h4.653a.818.818,0,0,1,.821.821V48.972A.8.8,0,0,1,61.708,49.7ZM57.055,35.651a1.013,1.013,0,0,0-1,1V47.147a1.013,1.013,0,0,0,1,1h3.832v-12.5Z",
                    transform: "translate(-54.5 -34.1)",
                    fill: "#ee2b7b"
                  }
                ) })
              ] }),
              /* @__PURE__ */ h("g", { id: "Grupo_16768", "data-name": "Grupo 16768", children: [
                /* @__PURE__ */ r("g", { id: "Grupo_16766", "data-name": "Grupo 16766", transform: "translate(6.478)", children: /* @__PURE__ */ r(
                  "path",
                  {
                    id: "Trazado_41136",
                    "data-name": "Trazado 41136",
                    d: "M9.621,26.769h0a.818.818,0,0,1-.821-.821V15.364a.818.818,0,0,1,.821-.821,2.683,2.683,0,0,0,2.007-.821L18.38,5.237A8.817,8.817,0,0,1,25.04,2.5H35.259a3.558,3.558,0,1,1,0,7.117h-6.3a4.272,4.272,0,0,1-.73,3.467c-.912,1.277-6.934,8.576-8.485,10.127A15.174,15.174,0,0,1,9.621,26.769Zm.821-10.584v8.85a11.575,11.575,0,0,0,7.938-3.1c1.551-1.551,7.481-8.759,8.3-9.945a2.052,2.052,0,0,0,.091-2.646,1.763,1.763,0,0,0-2.555,0L19.292,14.27a.822.822,0,0,1-1.369-.639.869.869,0,0,1,.182-.639l4.927-4.927a3.617,3.617,0,0,1,4.744-.274h7.481a1.825,1.825,0,0,0,0-3.65H24.949a7.221,7.221,0,0,0-5.383,2.19l-6.752,8.485A4.894,4.894,0,0,1,10.442,16.186Z",
                    transform: "translate(-8.8 -2.5)",
                    fill: "#ee2b7b"
                  }
                ) }),
                /* @__PURE__ */ r("g", { id: "Grupo_16767", "data-name": "Grupo 16767", transform: "translate(0 10.31)", children: /* @__PURE__ */ r(
                  "path",
                  {
                    id: "Trazado_41137",
                    "data-name": "Trazado 41137",
                    d: "M7.174,29.4H2.521A.818.818,0,0,1,1.7,28.58V14.621a.818.818,0,0,1,.821-.821H7.174a2.55,2.55,0,0,1,2.555,2.555V26.847A2.5,2.5,0,0,1,7.174,29.4ZM3.342,27.851H7.174a1.013,1.013,0,0,0,1-1v-10.4a1.013,1.013,0,0,0-1-1H3.342Z",
                    transform: "translate(-1.7 -13.8)",
                    fill: "#ee2b7b"
                  }
                ) })
              ] })
            ] })
          ]
        }
      )
    ]
  }
), po = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_33_pedir_cita_medica",
    "data-name": "33_pedir_cita_medica",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_33_pedir_cita_medica-2",
          "data-name": "33_pedir_cita_medica",
          transform: "translate(-2.4 -2.5)",
          children: [
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41267",
                "data-name": "Trazado 41267",
                d: "M28.9,36.7c-4,0-7.2,2.7-7.2,6.1,0,3.3,3.3,6.1,7.2,6.1s7.2-2.7,7.2-6.1C36.1,39.5,32.9,36.7,28.9,36.7Zm0,10.4c-3,0-5.4-1.9-5.4-4.3s2.4-4.4,5.4-4.4,5.4,2,5.4,4.4C34.3,45.1,31.9,47.1,28.9,47.1Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41268",
                "data-name": "Trazado 41268",
                d: "M52.3,33.234V29.7a2.1,2.1,0,0,0-1.5-2,56.087,56.087,0,0,0-6.593-1.463.922.922,0,0,0-.4,1.8A53.106,53.106,0,0,1,50.2,29.5a.2.2,0,0,1,.2.2v5.8c0,.1-.2.2-.7.3a23.134,23.134,0,0,1-8.3,0,1.363,1.363,0,0,1-.6-.3V31.4a.875.875,0,0,0-.6-.9c-6.7-2.3-15.5-2.3-22.9,0a1.149,1.149,0,0,0-.6.9v4.1q0,.15-.6.3a29.548,29.548,0,0,1-8.4,0,1.363,1.363,0,0,1-.6-.3V29.7a.693.693,0,0,1,.4-.3,72.341,72.341,0,0,1,25.7-3.2.906.906,0,0,0,.2-1.8A73.465,73.465,0,0,0,7.1,27.7a2.207,2.207,0,0,0-1.7,2v5.8c0,1,.8,1.8,2.1,2a34.854,34.854,0,0,0,8.17.114L9.9,47.9a1.884,1.884,0,0,0-.2.8v7.4a2.433,2.433,0,0,0,2.4,2.4H45.7A2.326,2.326,0,0,0,48,56.2V54.3c6.155-.048,11.3-4.527,11.5-10.3A11.013,11.013,0,0,0,52.3,33.234ZM46.3,56.2a.645.645,0,0,1-.6.6H12.1a.645.645,0,0,1-.6-.6V48.7l6.8-12.2c.016-.022.016-.049.03-.072a1.743,1.743,0,0,0,.27-.928V32.1a37.92,37.92,0,0,1,20.6,0v3.4a1.743,1.743,0,0,0,.289.961c.005.012.005.027.011.039l6.8,12.1v7.6ZM57.8,43.9c-.286,4.854-4.56,8.523-9.8,8.607V48.8a1.978,1.978,0,0,0-.2-1L42.144,37.653A25.429,25.429,0,0,0,45.9,37.9a17.963,17.963,0,0,0,4.3-.4c1.9-.4,2.1-1.5,2.1-2v-.332A9.274,9.274,0,0,1,57.8,43.9Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41269",
                "data-name": "Trazado 41269",
                d: "M33,21.7c3.1.7,3.5,1.6,3.5,1.8.1.4-.4,1-.6,1.2a1.529,1.529,0,0,0-.3,1.8,1.371,1.371,0,0,0,1.3.8h.4c2.6-.6,15.5-3.9,15.6-11.6a7.349,7.349,0,0,0-2.3-5.4c-2.3-2.4-6.2-3.8-10.2-3.8-6.9,0-12.5,4.1-12.5,9.1A6.09,6.09,0,0,0,33,21.7ZM40.3,8.3a12.709,12.709,0,0,1,8.9,3.2A5.7,5.7,0,0,1,51,15.6c0,5-8,8.4-13.3,9.7a2.859,2.859,0,0,0,.5-2.3c-.4-1.4-2-2.4-4.9-3.1a4.2,4.2,0,0,1-3.7-4.3C29.6,11.6,34.4,8.3,40.3,8.3Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41270",
                "data-name": "Trazado 41270",
                d: "M34.3,14.3h12a.9.9,0,1,0,0-1.8h-12a.9.9,0,1,0,0,1.8Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41271",
                "data-name": "Trazado 41271",
                d: "M34.3,18.2h12a.9.9,0,1,0,0-1.8h-12a.9.9,0,1,0,0,1.8Z",
                fill: "#ee2b7b"
              }
            )
          ]
        }
      )
    ]
  }
), go = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_34_pedir_incapacidad",
    "data-name": "34_pedir_incapacidad",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_34_pedir_incapacidad-2",
          "data-name": "34_pedir_incapacidad",
          transform: "translate(-2.8 -2.5)",
          children: [
            /* @__PURE__ */ r("g", { id: "Grupo_16856", "data-name": "Grupo 16856", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41272",
                "data-name": "Trazado 41272",
                d: "M50.8,58.5H14.2a2.433,2.433,0,0,1-2.4-2.4V8.9a2.433,2.433,0,0,1,2.4-2.4H50.7a2.433,2.433,0,0,1,2.4,2.4V56.1A2.286,2.286,0,0,1,50.8,58.5ZM14.2,7.9a1,1,0,0,0-1,1V56.1a1,1,0,0,0,1,1H50.7a1,1,0,0,0,1-1V8.9a1,1,0,0,0-1-1H14.2Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16857", "data-name": "Grupo 16857", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41273",
                "data-name": "Trazado 41273",
                d: "M44.2,31.5H19.8a.7.7,0,0,1,0-1.4H44.2a.7.7,0,0,1,0,1.4Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16858", "data-name": "Grupo 16858", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41274",
                "data-name": "Trazado 41274",
                d: "M44.2,39.9H19.8a.7.7,0,1,1,0-1.4H44.1a.684.684,0,0,1,.7.7C44.8,39.6,44.6,39.9,44.2,39.9Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16859", "data-name": "Grupo 16859", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41275",
                "data-name": "Trazado 41275",
                d: "M44.2,48.3H19.8a.7.7,0,1,1,0-1.4H44.1a.684.684,0,0,1,.7.7C44.8,48,44.6,48.3,44.2,48.3Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16860", "data-name": "Grupo 16860", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41276",
                "data-name": "Trazado 41276",
                d: "M35.4,24.1H30.5a.684.684,0,0,1-.7-.7V20.2H26.6a.684.684,0,0,1-.7-.7V14.6a.684.684,0,0,1,.7-.7h3.2V10.7a.684.684,0,0,1,.7-.7h4.9a.684.684,0,0,1,.7.7v3.2h3.2a.684.684,0,0,1,.7.7v4.9a.684.684,0,0,1-.7.7H36.1v3.2C36.2,23.8,35.8,24.1,35.4,24.1Zm-4.2-1.4h3.5V19.5a.684.684,0,0,1,.7-.7h3.2V15.3H35.4a.684.684,0,0,1-.7-.7V11.4H31.2v3.2a.684.684,0,0,1-.7.7H27.3v3.5h3.2a.684.684,0,0,1,.7.7Z",
                fill: "#ee2b7b"
              }
            ) })
          ]
        }
      )
    ]
  }
), vo = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_20_plan_ahorro",
    "data-name": "20_plan_ahorro",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h("g", { id: "_20_plan_ahorro-2", "data-name": "20_plan_ahorro", transform: "translate(-0.22 -2.08)", children: [
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40899",
            "data-name": "Trazado 40899",
            d: "M57.534,36.634l-6.494-6.311V20.628a.527.527,0,0,0-.549-.549H44a.527.527,0,0,0-.549.549v2.378l-5.762-5.488a1.411,1.411,0,0,0-1.921,0l-3.2,3.11a6.422,6.422,0,0,0-1.738-4.3,6.352,6.352,0,0,0-4.39-2.012h-.274l-3.293-3.475a5.014,5.014,0,0,0-2.835-1.463L9.244,8.1a.537.537,0,0,0-.64.457.515.515,0,0,0,.549.64l10.518,1.28a4.182,4.182,0,0,1,2.2,1.1l2.744,2.835a6.027,6.027,0,0,0-2.2,1.006l-1.189-1.1a.693.693,0,0,0-.366-.183c-.64,0-3.75-.091-4.573,1.28A1.606,1.606,0,0,0,16.1,16.7a2.666,2.666,0,0,0,1.463,1.372l2.744.915c.091,0,.091.091.183.091s.183.091.274.091l3.384,1.1a2.137,2.137,0,0,1,.64.64,1.479,1.479,0,0,1-.091,1.372,1.347,1.347,0,0,1-1.555.549l-10.426-2.2a6.247,6.247,0,0,1-2.561-1.555l-3.567-3.75c-.183.091-.274,0-.366,0l-3.2-1.1a.576.576,0,0,0-.732.274.506.506,0,0,0,.274.732l3.11,1.1,3.475,3.658a6.022,6.022,0,0,0,3.11,1.829l8.231,1.738a10.352,10.352,0,0,0,.915,1.189,6.562,6.562,0,0,0,4.481,2.012L15.646,36.634a1.249,1.249,0,0,0-.366,1.006,1.918,1.918,0,0,0,.366,1.006l1.28,1.28a1.414,1.414,0,0,0,1.921.091l.915-.823V55.108a.527.527,0,0,0,.549.549H52.87c.366,0,.64-.366.457-.64V39.1l1.006.915a1.524,1.524,0,0,0,1.006.366,1.126,1.126,0,0,0,.915-.457l1.28-1.28A1.249,1.249,0,0,0,57.9,37.64,1.918,1.918,0,0,0,57.534,36.634ZM17.292,16.33a.336.336,0,0,1,.091-.274c.274-.457,1.829-.732,3.293-.732l.915.915a4.131,4.131,0,0,0-1.006,1.555l-2.378-.823C17.658,16.787,17.292,16.6,17.292,16.33ZM26.8,25.567a5.358,5.358,0,0,1-4.481-1.555l-.183-.183.732.183a2.014,2.014,0,0,0,.732.091,2.588,2.588,0,0,0,2.2-1.28,2.618,2.618,0,0,0,.091-2.469,2.324,2.324,0,0,0-1.189-1.1L21.682,18.25a5.58,5.58,0,0,1,1.1-1.463,5.352,5.352,0,0,1,3.658-1.372,5.133,5.133,0,0,1,3.567,1.555,5.475,5.475,0,0,1,1.28,4.573v.183L27.17,25.658A.691.691,0,0,0,26.8,25.567Zm0,28.9V52.182H39.517v2.286Zm2.652-3.475V39.56h7.5V50.993Zm22.865,3.475H40.706V51.633a.527.527,0,0,0-.549-.549H38.145V39.011a.527.527,0,0,0-.549-.549H28.908a.527.527,0,0,0-.549.549V50.993H26.438a.527.527,0,0,0-.549.549v2.835H21.134V38.1L36.59,23.921a.278.278,0,0,1,.366,0L52.5,38.1V54.468ZM56.8,37.822l-1.28,1.28a.278.278,0,0,1-.366,0L37.6,23.1a1.31,1.31,0,0,0-.915-.366,1.375,1.375,0,0,0-1.006.366L19.945,37.457a.319.319,0,0,0-.091.183l-1.646,1.555a.278.278,0,0,1-.366,0l-1.28-1.28a.283.283,0,0,1-.091-.183c0-.091,0-.091.091-.183L36.5,18.342c.091-.091.091-.091.183-.091a.336.336,0,0,1,.274.091l6.768,6.494a.542.542,0,0,0,.64.091.752.752,0,0,0,.366-.549v-3.2h5.3v9.512c0,.183.091.366.183.366l6.768,6.4a.283.283,0,0,1,.091.183A.7.7,0,0,0,56.8,37.822Z",
            fill: "#ee2b7b"
          }
        ),
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40900",
            "data-name": "Trazado 40900",
            d: "M45.449,48.525h5.213c.366,0,.64-.274.549-.549V41.849a.527.527,0,0,0-.549-.549H45.449a.527.527,0,0,0-.549.549v6.128A.527.527,0,0,0,45.449,48.525Zm.64-6.128h4.024v4.847H46.089Z",
            transform: "translate(-3.645 -2.837)",
            fill: "#ee2b7b"
          }
        )
      ] })
    ]
  }
), bo = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_02_Icono_planeacion_y_gestion",
    "data-name": "02_Icono_planeacion_y_gestion",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_02_Icono_planeacion_y_gestion-2",
          "data-name": "02_Icono_planeacion_y_gestion",
          transform: "translate(-1.3 -1.398)",
          children: [
            /* @__PURE__ */ h("g", { id: "Grupo_16720", "data-name": "Grupo 16720", transform: "translate(3.3 26.403)", children: [
              /* @__PURE__ */ r("g", { id: "Grupo_16717", "data-name": "Grupo 16717", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41042",
                  "data-name": "Trazado 41042",
                  d: "M10.4,56.5H4.1a.8.8,0,1,1,0-1.6h6.3a1.324,1.324,0,0,0,1.3-1.3V31.3A1.324,1.324,0,0,0,10.4,30H4.1a.8.8,0,1,1,0-1.6h6.3a2.9,2.9,0,0,1,2.9,2.9V53.6A2.9,2.9,0,0,1,10.4,56.5Z",
                  transform: "translate(-3.3 -28.4)",
                  fill: "#ee2b7b"
                }
              ) }),
              /* @__PURE__ */ r("g", { id: "Grupo_16718", "data-name": "Grupo 16718", transform: "translate(12.143 3.6)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41043",
                  "data-name": "Trazado 41043",
                  d: "M43.9,42a.86.86,0,0,1-.8-.8v-.6a1,1,0,0,0-1-1H34.2c-.2,0-.3-.1-.5-.1l-8.2-5.9H17.3a.8.8,0,1,1,0-1.6h8.4c.2,0,.3.1.5.1L34.4,38H42a2.647,2.647,0,0,1,2.6,2.6v.6A.666.666,0,0,1,43.9,42Z",
                  transform: "translate(-16.5 -32)",
                  fill: "#ee2b7b"
                }
              ) }),
              /* @__PURE__ */ r("g", { id: "Grupo_16719", "data-name": "Grupo 16719", transform: "translate(9.675 7.9)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41044",
                  "data-name": "Trazado 41044",
                  d: "M37.2,53.8a19.332,19.332,0,0,1-6.7-1.2A22.133,22.133,0,0,1,27,51c-1-.5-1.9-1-2.9-1.4A22.213,22.213,0,0,0,16.2,48a.8.8,0,1,1,0-1.6,25.633,25.633,0,0,1,8.5,1.7,29.173,29.173,0,0,1,3.1,1.4A24.084,24.084,0,0,0,31.1,51c7.6,2.6,14.2-.1,18.3-2.9,1.1-.7,2.1-1.5,3.1-2.2a59.1,59.1,0,0,1,5.2-3.5l.3-.2a6.447,6.447,0,0,0,1.6-1.1,1.494,1.494,0,0,0,.5-1.8A2.465,2.465,0,0,0,58,38h-.1a10.091,10.091,0,0,0-4.5,1.7l-7.9,4.4c-.1,0-.1.1-.2.1-4.9,1.2-16.7.1-17.2,0a.806.806,0,0,1,.2-1.6c.1,0,11.8,1.2,16.5,0l7.8-4.4c1.6-.9,3.4-1.9,5.3-1.9H58a3.69,3.69,0,0,1,3.5,2.2,3.176,3.176,0,0,1-.9,3.5,7.16,7.16,0,0,1-1.9,1.3l-.3.1c-1.7,1-3.4,2.3-5.1,3.5-1,.8-2.1,1.5-3.2,2.3A20.621,20.621,0,0,1,37.2,53.8Z",
                  transform: "translate(-15.4 -36.3)",
                  fill: "#ee2b7b"
                }
              ) })
            ] }),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41045",
                "data-name": "Trazado 41045",
                d: "M46.313,30.4a11,11,0,1,1,11-11A10.968,10.968,0,0,1,46.313,30.4Zm0-20.4a9.4,9.4,0,1,0,9.4,9.4A9.389,9.389,0,0,0,46.313,10Zm-3.2,12.358a3.19,3.19,0,0,0,2.276,2.631.241.241,0,0,1,.195.275c-.009.193-.006.386,0,.579a.729.729,0,0,0,1.457.006,3.322,3.322,0,0,0,0-.468c-.025-.237.057-.35.3-.427a3.193,3.193,0,0,0,2.181-3.479,3.232,3.232,0,0,0-3.158-2.813,1.758,1.758,0,0,1-.411-3.475,1.763,1.763,0,0,1,1.9.861,2.284,2.284,0,0,1,.24.941.718.718,0,0,0,.751.644.71.71,0,0,0,.7-.671,2.41,2.41,0,0,0-.023-.51,3.18,3.18,0,0,0-2.266-2.638.251.251,0,0,1-.205-.29c.01-.193.007-.386,0-.579a.715.715,0,0,0-.727-.692.707.707,0,0,0-.728.688,4.137,4.137,0,0,0,0,.534c.018.208-.065.3-.265.358a3.243,3.243,0,0,0-2.236,3.326,3.283,3.283,0,0,0,2.486,2.894c.329.081.664.058.994.112a1.678,1.678,0,0,1,1.408,1.179,1.748,1.748,0,0,1-2.225,2.2,1.729,1.729,0,0,1-1.2-1.661.766.766,0,0,0-.208-.5.73.73,0,0,0-.8-.172.756.756,0,0,0-.462.789A2.8,2.8,0,0,0,43.115,22.356Z",
                transform: "translate(-2.425)",
                fill: "#ee2b7b"
              }
            )
          ]
        }
      )
    ]
  }
), yo = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_02_plenarios",
    "data-name": "02_plenarios",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h("g", { id: "_02_plenarios-2", "data-name": "02_plenarios", transform: "translate(-1.947 -1.5)", children: [
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41030",
            "data-name": "Trazado 41030",
            d: "M49.036,16.232a8.819,8.819,0,0,0-5.4-2.508,4.177,4.177,0,0,1,.1-.482v-2.99a3.4,3.4,0,0,0-.289-1.35h1.447a.675.675,0,0,0,0-1.35H43.441c-.193-1.35-.868-4.051-2.6-4.051a2.365,2.365,0,0,0-1.447.386.965.965,0,0,1-1.157,0A2.365,2.365,0,0,0,36.786,3.5c-1.833,0-2.411,2.7-2.6,4.051H32.735a.675.675,0,0,0,0,1.35h1.543a5.693,5.693,0,0,0-.193,1.35v3.376H32.349a5.979,5.979,0,0,0-2.7-4.533,3.982,3.982,0,0,0-2.7-.482,5.634,5.634,0,0,0-3.279-1.061c-4.437,0-6.752,3.955-6.752,7.813V18.45l-2.7,1.254a3.694,3.694,0,0,0-2.122,3.955l.193,1.254a2.691,2.691,0,0,0,1.35,2.025,4.7,4.7,0,0,0,.675.289,1.223,1.223,0,0,0-.1.579L12,40.345a3,3,0,0,0,2.315,3.472,2.124,2.124,0,0,0,.772.1,2.67,2.67,0,0,0,.868-.1l-.965,7.909a.659.659,0,0,0,.675.675h3.376v6.655a.675.675,0,1,0,1.35,0V52.4h3.762v6.655a.659.659,0,0,0,.675.675.725.725,0,0,0,.675-.675V52.4h3.665v6.655a.675.675,0,1,0,1.35,0V52.4h2.7v6.655a.675.675,0,1,0,1.35,0V52.4h.289a4.177,4.177,0,0,0,.482-.1c.193-.1.193-.289.193-.482l-1.061-9.549h10.9V58.767a.675.675,0,0,0,1.35,0V42.274h.289a.7.7,0,0,0,.675-.579,2.693,2.693,0,0,0,1.736.579,2.347,2.347,0,0,0,2.315-2.315V22.4A9.3,9.3,0,0,0,49.036,16.232Zm-13.5-2.99v-2.99a3.081,3.081,0,0,1,.289-1.35H41.9a3.081,3.081,0,0,1,.289,1.35v2.99c0,.289-.1.579-.1.868h0a3.331,3.331,0,0,1-6.559-.868ZM36.786,4.85a1.124,1.124,0,0,1,.675.193,2.248,2.248,0,0,0,1.35.386,2.034,2.034,0,0,0,1.35-.386,1.124,1.124,0,0,1,.675-.193c.482,0,.965,1.35,1.254,2.7H35.532C35.822,6.2,36.3,4.85,36.786,4.85ZM23.669,8.9a3.526,3.526,0,0,1,2.6.868.6.6,0,0,0,.772.193,2.107,2.107,0,0,1,1.929.289c.675.386,1.929,1.447,2.122,4.147v7.234A6.525,6.525,0,0,0,28.588,19.9a5.983,5.983,0,0,0,.868-3.086V14.3a.659.659,0,0,0-.675-.675h-.193a3.348,3.348,0,0,1-2.411-.965.644.644,0,0,0-.965,0,.709.709,0,0,0-.193.579,5.353,5.353,0,0,1-4.34,2.411.659.659,0,0,0-.675.675v.482a6.5,6.5,0,0,0,.965,3.279,8.662,8.662,0,0,0-2.7,1.254v-5.98C18.267,12.277,20,8.9,23.669,8.9ZM21.354,17a6.5,6.5,0,0,0,4.533-2.7,4.239,4.239,0,0,0,2.122.675V16.81c0,1.929-1.061,3.858-3.376,3.858C22.608,20.668,21.45,18.836,21.354,17Zm-7.813,7.813-.193-1.254a2.464,2.464,0,0,1,1.35-2.508L16.917,19.9V22.79a5.644,5.644,0,0,1-.482,2.122c-.193.482-.579,1.061-1.157,1.061a1.66,1.66,0,0,1-1.157-.193A1.389,1.389,0,0,1,13.541,24.816ZM17.3,43.045h0l.965-8.2c.1.1.1.193.193.289A2.884,2.884,0,0,0,20.679,36.2a4.517,4.517,0,0,0,3.569-1.254.685.685,0,0,0-1.061-.868,3.136,3.136,0,0,1-2.508.772,1.555,1.555,0,0,1-1.254-.579,3.907,3.907,0,0,1-.675-2.7.618.618,0,0,0-.579-.772.656.656,0,0,0-.772.386c-.1.1-.1.193-.1.386l-1.35,10.706a1.9,1.9,0,0,1-1.447.289,1.639,1.639,0,0,1-1.254-1.929L15.47,28.1c.1-.289.1-.482.193-.772a2.27,2.27,0,0,0,.772-.193,2.736,2.736,0,0,0,.965-.868,6.324,6.324,0,0,0,.868-3.183,8.422,8.422,0,0,1,3.858-1.833,4.389,4.389,0,0,0,2.6.772,5.065,5.065,0,0,0,2.8-.868A4.252,4.252,0,0,1,31.1,25.395c0,.193.1.289.1.386.482,1.35,1.929,4.533,1.929,5.691a2.237,2.237,0,0,1-.675,1.929,2.58,2.58,0,0,1-1.64.386.675.675,0,0,0,0,1.35,7.445,7.445,0,0,0,1.447-.193l1.833,16.3H16.338ZM50.29,39.959a.967.967,0,0,1-.965.965,1.729,1.729,0,0,1-1.736-1.736V25.395a.675.675,0,1,0-1.35,0V40.923H34.279l-.772-6.848a3.436,3.436,0,0,0,.965-2.7c0-1.543-1.64-5.3-2.025-6.173V14.978h2.025a4.726,4.726,0,0,0,4.34,2.99,4.874,4.874,0,0,0,4.437-2.894A7.616,7.616,0,0,1,48.071,17.2,7.149,7.149,0,0,1,50.29,22.4V39.959Z",
            fill: "#ee2b7b"
          }
        ),
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41031",
            "data-name": "Trazado 41031",
            d: "M40.875,46.5a.659.659,0,0,0-.675.675V60.293a.675.675,0,0,0,1.35,0V47.175A.659.659,0,0,0,40.875,46.5Z",
            transform: "translate(-1.002 -1.526)",
            fill: "#ee2b7b"
          }
        )
      ] })
    ]
  }
), _o = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_35_plenarios_independientes",
    "data-name": "35_plenarios_independientes",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_35_plenarios_independientes-2",
          "data-name": "35_plenarios_independientes",
          transform: "translate(1 -0.799)",
          children: [
            /* @__PURE__ */ r("g", { id: "Grupo_16671", "data-name": "Grupo 16671", transform: "translate(6.953 16.719)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40956",
                "data-name": "Trazado 40956",
                d: "M15.118,32.136a7.518,7.518,0,1,1,7.518-7.518A7.512,7.512,0,0,1,15.118,32.136Zm0-13.621a6.1,6.1,0,1,0,6.1,6.1A6.115,6.115,0,0,0,15.118,18.515Z",
                transform: "translate(-7.6 -17.1)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16672", "data-name": "Grupo 16672", transform: "translate(2 33.17)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40957",
                "data-name": "Trazado 40957",
                d: "M26.146,49.409a.7.7,0,0,1-.708-.708V44.987c0-5.484-5.484-7.872-10.967-7.872S3.415,39.592,3.415,44.987V48.7a.7.7,0,0,1-.708.708A.761.761,0,0,1,2,48.7V44.987C2,39.5,7.13,35.7,14.471,35.7c7.43,0,12.471,3.715,12.471,9.375V48.79A.87.87,0,0,1,26.146,49.409Z",
                transform: "translate(-2 -35.7)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16673", "data-name": "Grupo 16673", transform: "translate(31.187 33.081)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40958",
                "data-name": "Trazado 40958",
                d: "M59.058,49.4a.7.7,0,0,1-.708-.708V44.975c0-5.484-5.484-7.872-10.967-7.872S36.415,39.58,36.415,44.975V48.69a.7.7,0,0,1-.708.708A.761.761,0,0,1,35,48.69V44.975C35,39.4,40.041,35.6,47.471,35.6s12.294,3.8,12.294,9.375V48.69A.761.761,0,0,1,59.058,49.4Z",
                transform: "translate(-35 -35.6)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16674", "data-name": "Grupo 16674", transform: "translate(37.379 18.93)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40959",
                "data-name": "Trazado 40959",
                d: "M48.191,32.779A6.044,6.044,0,0,1,42,26.853V22.961a5.405,5.405,0,0,1,.884-3.007.713.713,0,0,1,1.238.708,3.992,3.992,0,0,0-.619,2.211v3.892a4.578,4.578,0,0,0,4.776,4.422,4.635,4.635,0,0,0,4.776-4.422V22.873a3.992,3.992,0,0,0-.619-2.211.713.713,0,0,1,1.238-.708,5.963,5.963,0,0,1,.884,3.007v3.892A6.26,6.26,0,0,1,48.191,32.779Z",
                transform: "translate(-42 -19.6)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16675", "data-name": "Grupo 16675", transform: "translate(34.637 19.018)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40960",
                "data-name": "Trazado 40960",
                d: "M56.147,21.115H39.608a.708.708,0,0,1,0-1.415h16.54a.7.7,0,0,1,.708.708A.761.761,0,0,1,56.147,21.115Z",
                transform: "translate(-38.9 -19.7)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16676", "data-name": "Grupo 16676", transform: "translate(37.453 13.8)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40961",
                "data-name": "Trazado 40961",
                d: "M53.773,20.434a.684.684,0,0,1-.708-.619C52.8,17.869,52,15.3,51.031,15.3a1.537,1.537,0,0,0-1.061.265,3.414,3.414,0,0,1-3.361,0,1.537,1.537,0,0,0-1.061-.265c-.973,0-1.769,2.653-2.034,4.511-.088.354-.442.708-.8.619s-.708-.442-.619-.8c.088-.973.8-5.837,3.449-5.837a3.33,3.33,0,0,1,1.769.442,1.916,1.916,0,0,0,1.946,0,3.33,3.33,0,0,1,1.769-.442c2.653,0,3.361,4.865,3.449,5.837a.838.838,0,0,1-.708.8Z",
                transform: "translate(-42.084 -13.8)",
                fill: "#ee2b7b"
              }
            ) })
          ]
        }
      )
    ]
  }
), wo = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_26_icono_portafolio",
    "data-name": "26_icono_portafolio",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_26_icono_portafolio-2",
          "data-name": "26_icono_portafolio",
          transform: "translate(10.347 0.549)",
          children: [
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41238",
                "data-name": "Trazado 41238",
                d: "M38.516,7.741A.555.555,0,0,0,38.5,7.66a.815.815,0,0,0-.045-.1.829.829,0,0,0-.542-.462l-26.9-6.6a.821.821,0,0,0-.7.1.713.713,0,0,0-.3.6V7.139H1.456a.789.789,0,0,0-.8.8v.108c0,.009,0,.02,0,.029v42.3a.858.858,0,0,0,.6.7l25.7,7.6h.2c.2,0,.3-.1.5-.2a.713.713,0,0,0,.3-.6V50.938h9.9a.773.773,0,0,0,.7-.8V7.938A.774.774,0,0,0,38.516,7.741Zm-26.9-5.647L31.79,7.139H11.612ZM26.353,56.876l-24.1-7.2V9.078l24.1,7.2Zm10.7-7.537h-9.1V15.676a.858.858,0,0,0-.6-.7L5.921,8.639H37.056Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41239",
                "data-name": "Trazado 41239",
                d: "M6.612,20.394l14.8,4.4h.2a1.02,1.02,0,0,0,.8-.5.779.779,0,0,0-.5-1l-14.8-4.4a.791.791,0,0,0-.5,1.5Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41240",
                "data-name": "Trazado 41240",
                d: "M18.812,28.594l-10.3-3.1a.791.791,0,1,0-.5,1.5l10.3,3.1h.2a.792.792,0,0,0,.8-.5A.779.779,0,0,0,18.812,28.594Z",
                fill: "#ee2b7b"
              }
            )
          ]
        }
      )
    ]
  }
), To = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_16_icono_programas",
    "data-name": "16_icono_programas",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ r(
        "path",
        {
          id: "_16_icono_programas-2",
          "data-name": "16_icono_programas",
          d: "M27.294,25.566h-.187L13.1,21.457a.738.738,0,0,1,.467-1.4l14.005,4.108a.77.77,0,0,1,.467.934A.739.739,0,0,1,27.294,25.566Zm-2.8,4.948h-.187L14.5,27.62a.738.738,0,0,1,.467-1.4l9.71,2.894a.77.77,0,0,1,.467.934A.7.7,0,0,1,24.493,30.514Zm20.261,9.15c-.467,0-1.027.093-1.494.093V9.506a.792.792,0,0,0-.654-.747L17.3,2.6a.767.767,0,0,0-.654.093.665.665,0,0,0-.28.56V8.759H8.434c-.187-.093-.373,0-.467,0a.485.485,0,0,0-.373.187c0,.093-.093.093-.093.187V49.374c0,.187.093.28.187.467H7.78c.093.093.187.187.28.187l24.275,7.189h.187a1.327,1.327,0,0,0,.56-.187.665.665,0,0,0,.28-.56V50.028H35.51A9.41,9.41,0,0,0,54.277,49,9.526,9.526,0,0,0,44.753,39.664ZM17.864,4.184,36.911,8.759H17.864ZM31.682,55.536,8.9,48.814V10.44l22.782,6.722Zm1.027-39.588L13.2,10.16h28.57V40.131a9.358,9.358,0,0,0-6.442,8.5H33.269V16.6A.8.8,0,0,0,32.709,15.949ZM44.753,57.124a7.982,7.982,0,0,1-7.936-7c0-.373-.093-.654-.093-1.027v-.467a8.093,8.093,0,0,1,5.042-7,7,7,0,0,1,1.494-.467,8.172,8.172,0,0,1,1.494-.187,8.076,8.076,0,0,1,0,16.152Zm6.069-9.43q0-.14-.28-.28l-5.6-1.867h-.28l-5.6,1.867c-.187,0-.28.187-.28.373a.476.476,0,0,0,.373.467l1.494.467v2.8a.513.513,0,0,0,.28.467,11.161,11.161,0,0,0,3.921.654,9.99,9.99,0,0,0,3.828-.747c.187,0,.28-.187.28-.373v-2.8a8.337,8.337,0,0,0,1.214-.467V50.4a.373.373,0,0,0,.747,0V47.974A.343.343,0,0,0,50.822,47.693Zm-2.614,3.548a10.646,10.646,0,0,1-6.816,0V49l3.361,1.12h.093c.093,0,1.774-.654,3.361-1.12v2.241Zm-3.361-2.054-4.295-1.4,4.295-1.4,4.295,1.4Zm5.7,1.867c-.187,0-.373.28-.373.467a.373.373,0,1,0,.747,0v-.093A.4.4,0,0,0,50.542,51.055Z",
          transform: "translate(-0.5 -0.559)",
          fill: "#ee2b7b"
        }
      )
    ]
  }
), So = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_43_proyectos_agropecuarios",
    "data-name": "43_proyectos_agropecuarios",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_43_proyectos_agropecuarios-2",
          "data-name": "43_proyectos_agropecuarios",
          transform: "translate(-2.923 -2.5)",
          children: [
            /* @__PURE__ */ r("g", { id: "Grupo_16692", "data-name": "Grupo 16692", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40996",
                "data-name": "Trazado 40996",
                d: "M33.3,30.3V22.6a.758.758,0,0,1,.2-.4c1-1.1,3.6-4.5,3.6-8.3,0-4.8-3.7-8.6-3.9-8.9-.2-.2-.5-.5-.7-.5s-.6.5-.6.5c-.2.2-4,4-4,8.8a12.921,12.921,0,0,0,3.7,8.4c.1.1.1.2.1.4v1.6a3.126,3.126,0,0,0-.9-1.1,6.911,6.911,0,0,0-4.3-1.5c-.4,0-1.1-.1-1.1.3v.6a6.707,6.707,0,0,0,1.9,4.4,6.911,6.911,0,0,0,4.3,1.5h0v1.9H8.5a.589.589,0,0,0-.5.9L18.9,46.4a.764.764,0,0,0,.5.2h3.8a.55.55,0,0,1,.5.3L32,59.8a.666.666,0,0,0,1,0l8.4-12.9a.55.55,0,0,1,.5-.3h3.8a.764.764,0,0,0,.5-.2L57,31.2a.563.563,0,0,0-.5-.9H33.3Zm-4.9-4.6c-.8-.7-1.5-2.3-1.3-2.5s1.8.3,2.6,1,1.5,2.2,1.3,2.5S29.2,26.4,28.4,25.7Zm1.1-11.9a10.8,10.8,0,0,1,2.6-6.5.563.563,0,0,1,.9,0,11.068,11.068,0,0,1,2.6,6.5A9.329,9.329,0,0,1,34.5,18c-.1.3-.6,1-.8.9s-.3-.9-.3-1.2v-3a.8.8,0,1,0-1.6,0v3.1c0,.3,0,1.1-.2,1.2s-.7-.7-.9-.9A8.636,8.636,0,0,1,29.5,13.8ZM44.7,45H40.9a.55.55,0,0,0-.5.3L33,56.9a.666.666,0,0,1-1,0L24.5,45.3A.55.55,0,0,0,24,45H20.2a.764.764,0,0,1-.5-.2L11,32.8a.563.563,0,0,1,.5-.9H31.6V35a.52.52,0,0,1-.2.4L29,37.7a.758.758,0,0,0-.2.4v3.5a.8.8,0,0,0,1.6,0V38.8a.52.52,0,0,1,.2-.4l1.1-1v7.4a.8.8,0,0,0,1.6,0V41.6s1.1.6,1.2.7a.75.75,0,0,0,1-.3.678.678,0,0,0-.3-1c-.2-.1-1.7-1-1.7-1a.55.55,0,0,1-.3-.5V31.9H53.3a.589.589,0,0,1,.5.9l-8.7,12C45.1,44.9,44.9,45,44.7,45Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16693", "data-name": "Grupo 16693", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40997",
                "data-name": "Trazado 40997",
                d: "M25.6,35a.8.8,0,1,0,.8.8A.789.789,0,0,0,25.6,35Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16694", "data-name": "Grupo 16694", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40998",
                "data-name": "Trazado 40998",
                d: "M35.5,33.9a.8.8,0,1,0,.8.8A.86.86,0,0,0,35.5,33.9Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16695", "data-name": "Grupo 16695", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40999",
                "data-name": "Trazado 40999",
                d: "M18.4,34.3a.8.8,0,1,0-.8.8A.86.86,0,0,0,18.4,34.3Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16696", "data-name": "Grupo 16696", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41000",
                "data-name": "Trazado 41000",
                d: "M18.6,37.4a.8.8,0,1,0,.8.8A.86.86,0,0,0,18.6,37.4Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16697", "data-name": "Grupo 16697", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41001",
                "data-name": "Trazado 41001",
                d: "M47.6,37a.8.8,0,1,0,.8.8A.789.789,0,0,0,47.6,37Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16698", "data-name": "Grupo 16698", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41002",
                "data-name": "Trazado 41002",
                d: "M41.1,34.8a.8.8,0,1,0,.8.8A.86.86,0,0,0,41.1,34.8Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16699", "data-name": "Grupo 16699", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41003",
                "data-name": "Trazado 41003",
                d: "M28.1,45.6a.8.8,0,1,0,.8.8C28.8,45.9,28.5,45.6,28.1,45.6Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16700", "data-name": "Grupo 16700", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41004",
                "data-name": "Trazado 41004",
                d: "M31.3,51.1a.8.8,0,1,0,.8.8A.736.736,0,0,0,31.3,51.1Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16701", "data-name": "Grupo 16701", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41005",
                "data-name": "Trazado 41005",
                d: "M22.6,41.2a.8.8,0,1,0,.8.8A.86.86,0,0,0,22.6,41.2Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16702", "data-name": "Grupo 16702", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41006",
                "data-name": "Trazado 41006",
                d: "M41.4,41.1a.8.8,0,1,0,.8.8C42.1,41.5,41.8,41.1,41.4,41.1Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16703", "data-name": "Grupo 16703", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41007",
                "data-name": "Trazado 41007",
                d: "M35.9,46.6a.8.8,0,1,0,.8.8A.789.789,0,0,0,35.9,46.6Z",
                fill: "#ee2b7b"
              }
            ) })
          ]
        }
      )
    ]
  }
), Mo = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_38_prueba_laboratorio",
    "data-name": "38_prueba_laboratorio",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ r(
        "path",
        {
          id: "_38_prueba_laboratorio-2",
          "data-name": "38_prueba_laboratorio",
          d: "M42.559,46.065H36.913a11.676,11.676,0,0,0-.674-3.115,26.938,26.938,0,0,0,11.5-22.1,22.7,22.7,0,0,0-1.89-8.89,4.4,4.4,0,0,0,.92-4.448,4.363,4.363,0,0,0-6.213-6.1,4.387,4.387,0,0,0-4.4,1.061L22.346,16.373a2.4,2.4,0,0,0-2.987.391l-1.5,1.5a2.609,2.609,0,0,0-.7,1.7,2.342,2.342,0,0,0,.7,1.7l8.6,8.6a2.413,2.413,0,0,0,1.7.7,2.792,2.792,0,0,0,1.8-.6l1.5-1.5a2.4,2.4,0,0,0,.391-2.987l7.374-7.323a12.852,12.852,0,0,1,.215,2.29,14.3,14.3,0,0,1-14.3,14.3.911.911,0,0,0-.1.021H8.859a6.274,6.274,0,0,0-6.3,6.3.9.9,0,0,0,.9.9H14.3a11.7,11.7,0,0,0-.891,3.7H7.759a7.383,7.383,0,0,0-7.4,7.4.9.9,0,0,0,.9.9h47.8a.9.9,0,0,0,.9-.9A7.383,7.383,0,0,0,42.559,46.065Zm2.7-43.2a2.63,2.63,0,0,1,.5,2.9l-3.4-3.4A2.827,2.827,0,0,1,45.259,2.865Zm-15.1,24.8-1.5,1.5a.75.75,0,0,1-.9,0l-8.6-8.6c-.1-.2-.2-.3-.2-.5a.764.764,0,0,1,.2-.5l1.5-1.5c.2-.1.3-.2.5-.2a.373.373,0,0,1,.4.3l8.6,8.6A.561.561,0,0,1,30.159,27.665Zm8.88-11.621a.711.711,0,0,0-.1.138l-8.282,8.282-7-7,13.8-13.8a2.535,2.535,0,0,1,3.6,0l3.4,3.4a2.535,2.535,0,0,1,0,3.6l-.313.313a.944.944,0,0,0-.106.066Zm2.4,4.6a17.258,17.258,0,0,0-.481-3.811l3.716-3.691a19.8,19.8,0,0,1,1.465,7.5,25.073,25.073,0,0,1-10.5,20.5,11.786,11.786,0,0,0-5.5-5.1A16.212,16.212,0,0,0,41.439,20.644ZM19.517,38.773c.156-.109.311-.217.473-.316.195-.12.4-.231.6-.338.1-.053.2-.1.3-.151a10.053,10.053,0,0,1,2.233-.767c.125-.027.249-.054.374-.076q.315-.055.635-.092.387-.042.78-.053c.115,0,.228-.016.344-.016.172,0,.339.016.508.024.2.012.4.019.6.043.167.019.331.045.5.072A9.955,9.955,0,0,1,28,37.351c.017.005.034.008.051.012a9.885,9.885,0,0,1,1.2.451c.087.038.173.077.258.118a9.872,9.872,0,0,1,1.072.59c.081.052.156.111.235.165.258.175.5.365.746.564.115.1.231.189.341.289a9.793,9.793,0,0,1,.763.775c.1.115.2.237.293.357.2.251.393.51.57.782.049.074.1.144.149.219a10.057,10.057,0,0,1,.624,1.193,10.217,10.217,0,0,1,.859,3.2H30.365a5.282,5.282,0,0,0-10.416,0H15.257a9.6,9.6,0,0,1,1.291-4.09l.009-.01a10.066,10.066,0,0,1,1.507-1.971c.073-.075.147-.149.222-.221.207-.2.426-.386.648-.567C19.124,39.054,19.318,38.911,19.517,38.773Zm8.942,7.292h-6.6a3.232,3.232,0,0,1,3.3-2.5A3.335,3.335,0,0,1,28.459,46.065Zm-24-5.5a4.511,4.511,0,0,1,4.4-3.6H18.93q-.489.306-.945.657c-.064.047-.128.094-.19.142-.129.1-.253.212-.377.321a10.112,10.112,0,0,0-1.842,2.027c-.1.135-.194.269-.285.408-.01.016-.022.029-.032.045Zm-2.2,12a5.507,5.507,0,0,1,5.5-4.7h34.8a5.688,5.688,0,0,1,5.6,4.7Z",
          transform: "translate(4.642 2.703)",
          fill: "#ee2b7b"
        }
      )
    ]
  }
), Ao = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_05_publicaciones",
    "data-name": "05_publicaciones",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ r(
        "path",
        {
          id: "_06_misiones_empresariales",
          "data-name": "06_misiones_empresariales",
          d: "M51.238,38.943a19.3,19.3,0,0,0-2.411-7.232,11.765,11.765,0,0,0,1.543-5.978V22.84l8.678-8.678a.818.818,0,1,0-1.157-1.157l-8.967,8.967a.833.833,0,0,0-.289.579v3.182a10.969,10.969,0,0,1-.964,4.339c-.482-.675-1.061-1.253-1.639-1.928l-7.906-7.906h0L34.268,16.38a14.425,14.425,0,0,0-1.253-1.061,15.212,15.212,0,0,1,6.267-1.928.815.815,0,0,0,.579-.193L46.61,6.449a.88.88,0,0,0,0-1.157.88.88,0,0,0-1.157,0l-6.46,6.46a18.651,18.651,0,0,0-7.521,2.6,11.607,11.607,0,0,0-5.689-1.446H22.89L15.273,5.292a.88.88,0,0,0-1.157,0,.88.88,0,0,0,0,1.157l7.81,7.81a.833.833,0,0,0,.579.289h3.182a10.275,10.275,0,0,1,7.328,2.989l2.025,2.025a3.175,3.175,0,0,0-1.253.675l-.193.193a2.571,2.571,0,0,0-.675,1.35l-1.543-1.543a3.145,3.145,0,0,0-4.339,0l-.193.193a2.653,2.653,0,0,0-.771,1.446,3.091,3.091,0,0,0-3.375.579l-.193.193a3.251,3.251,0,0,0-.579,3.471,2.938,2.938,0,0,0-1.543.771l-.193.193a3.146,3.146,0,0,0,0,4.339L26.169,37.3a2.749,2.749,0,0,0-1.35.771l-.193.193a3.4,3.4,0,0,0-.771,1.253l-5.785-5.785a16.79,16.79,0,0,1-4.821-10.028.815.815,0,0,0-.193-.579l-7.81-7.81a.88.88,0,0,0-1.157,0,.88.88,0,0,0,0,1.157l7.617,7.617a18.569,18.569,0,0,0,2.507,7.328A12.739,12.739,0,0,0,12.67,37.3V40.2L3.992,48.874a.88.88,0,0,0,0,1.157.833.833,0,0,0,.579.289.53.53,0,0,0,.482-.289l8.967-8.967a.833.833,0,0,0,.289-.579V37.3a10.969,10.969,0,0,1,.964-4.339A14.022,14.022,0,0,0,16.912,34.8L24.819,42.7h0l3.857,3.857a14.425,14.425,0,0,0,1.253,1.061,15.212,15.212,0,0,1-6.267,1.928.815.815,0,0,0-.579.193l-6.749,6.749a.88.88,0,0,0,0,1.157.833.833,0,0,0,.579.289.583.583,0,0,0,.579-.289l6.557-6.46a17.945,17.945,0,0,0,7.424-2.6,11.607,11.607,0,0,0,5.689,1.446h2.893l7.617,7.617a.833.833,0,0,0,.579.289.53.53,0,0,0,.482-.289.88.88,0,0,0,0-1.157l-7.81-7.81a.833.833,0,0,0-.579-.289H37.161A10.275,10.275,0,0,1,29.833,45.4l-3.857-3.857-.193-.193a1.4,1.4,0,0,1,0-2.025l.193-.193a1.6,1.6,0,0,1,1.928-.193l4.146,4.146a.833.833,0,0,0,.579.289.708.708,0,0,0,.579-.193.88.88,0,0,0,0-1.157L21.348,30.265a1.4,1.4,0,0,1,0-2.025l.193-.193a1.4,1.4,0,0,1,2.025,0h0l8.485,8.485a.723.723,0,0,0,1.157,0,.88.88,0,0,0,0-1.157L23.662,25.83a1.4,1.4,0,0,1,0-2.025l.193-.193a1.4,1.4,0,0,1,2.025,0l1.061,1.061h0l8.485,8.485A.818.818,0,0,0,36.582,32L28.1,23.515a1.292,1.292,0,0,1-.1-1.928l.193-.193a1.4,1.4,0,0,1,2.025,0L38.7,29.783a.833.833,0,0,0,.579.289.708.708,0,0,0,.579-.193.88.88,0,0,0,0-1.157l-5.11-5.11a1.4,1.4,0,0,1,0-2.025l.193-.193a1.4,1.4,0,0,1,2.025,0l.193.193L44.874,29.3A16.79,16.79,0,0,1,49.7,39.328a.815.815,0,0,0,.193.579l7.81,7.81a.723.723,0,0,0,1.157,0,.88.88,0,0,0,0-1.157Z",
          transform: "translate(-1.775 -1.076)",
          fill: "#ee2b7b"
        }
      )
    ]
  }
), zo = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_09_icono_reflexion",
    "data-name": "09_icono_reflexion",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_09_icono_reflexion-2",
          "data-name": "09_icono_reflexion",
          transform: "translate(7.363 2.429)",
          children: [
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40728",
                "data-name": "Trazado 40728",
                d: "M11.213,14.52a12.966,12.966,0,0,0-6.05,6.44A14.572,14.572,0,0,0,3.8,27.693a4.558,4.558,0,0,0,.293,1.659A1.566,1.566,0,0,1,3.8,30.913c-.293.293-.39.585-.683.878l-.1.2c-.293.293-.488.683-.781.976A13.823,13.823,0,0,0,.87,35.206a3.567,3.567,0,0,0-.1,2.244,2.665,2.665,0,0,0,1.659,1.366.663.663,0,0,1,.39.293.587.587,0,0,1-.1.39,1.781,1.781,0,0,0,.39,2.049c.2.2.293.293.2.585a1.492,1.492,0,0,0,.39,1.756,1.77,1.77,0,0,1,.488,1.756,3.676,3.676,0,0,0,.781,2.635A3.754,3.754,0,0,0,7.505,49.55l4.684.293a1.843,1.843,0,0,1,1.268.683,3.83,3.83,0,0,1,.585,1.268c.293.976.585,2.147.781,3.122a.77.77,0,0,0,.828.659c.917-.113.664-.978.629-1.134-.064-.293-.14-.627-.286-1.28a12.553,12.553,0,0,0-.781-2.537A3.416,3.416,0,0,0,11.9,48.282c-1.171,0-2.342-.1-3.61-.2l-.781-.1a1.707,1.707,0,0,1-1.366-.683,2.1,2.1,0,0,1-.39-1.561,3.1,3.1,0,0,0-.781-2.732c-.2-.2-.2-.293-.1-.585a1.351,1.351,0,0,0-.293-1.659.9.9,0,0,1-.2-.976,1.663,1.663,0,0,0,0-1.366,1.792,1.792,0,0,0-1.171-.781c-.2,0-.293-.1-.488-.2-.585-.293-.683-.585-.488-1.268a5.969,5.969,0,0,1,.488-1.171c.1-.2,2.049-2.927,2.439-3.513a2.646,2.646,0,0,0,.293-2.244,3.831,3.831,0,0,1-.293-1.366,13.5,13.5,0,0,1,2.83-8.977,11.191,11.191,0,0,1,5.757-3.9,18.971,18.971,0,0,1,4.781-1.073c.606-.042.722-.341.705-.722s-.149-.746-.8-.742A18.608,18.608,0,0,0,11.213,14.52Z",
                transform: "translate(0 -0.288)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40729",
                "data-name": "Trazado 40729",
                d: "M34.406,36.383l-1.073,1.854a14.336,14.336,0,0,0-1.366,4.391,16.805,16.805,0,0,0-.39,3.805v3.805l.052,4.972a.852.852,0,0,0,.841.855.771.771,0,0,0,.767-.855c0-.781-.293-8.583,0-10.827a25.224,25.224,0,0,1,.878-3.9,18.81,18.81,0,0,1,1.854-3.708c.488-.878.976-1.952,1.464-3.025.193-.531-.4-1.017-.893-.912-.362.076-.533.058-.952,1.237A12.385,12.385,0,0,1,34.406,36.383Z",
                transform: "translate(-0.75 -0.782)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ h("g", { id: "Grupo_16523", "data-name": "Grupo 16523", transform: "translate(19.995 0.571)", children: [
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40730",
                  "data-name": "Trazado 40730",
                  d: "M30.657,4.669a.754.754,0,0,0,.781-.683V1.352a.718.718,0,0,0-.781-.781.77.77,0,0,0-.781.781V3.986A.808.808,0,0,0,30.657,4.669Z",
                  transform: "translate(-20.704 -0.571)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40731",
                  "data-name": "Trazado 40731",
                  d: "M23.794,7.506a.74.74,0,0,0-.2-.488L21.647,5.066a.683.683,0,0,0-1.171.488.745.745,0,0,0,.2.488l1.952,1.952a.822.822,0,0,0,.488.2A.618.618,0,0,0,23.794,7.506Z",
                  transform: "translate(-20.476 -0.675)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40732",
                  "data-name": "Trazado 40732",
                  d: "M44.889,13.971H42.157a.718.718,0,0,0-.781.781.77.77,0,0,0,.781.781h2.732a.77.77,0,0,0,.781-.781A.82.82,0,0,0,44.889,13.971Z",
                  transform: "translate(-20.983 -0.896)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40733",
                  "data-name": "Trazado 40733",
                  d: "M40.711,4.071a.745.745,0,0,0-.488.2L38.271,6.218a.707.707,0,0,0,0,.976.745.745,0,0,0,.488.2,1.387,1.387,0,0,0,.585-.2L41.3,5.242a.707.707,0,0,0,0-.976A.717.717,0,0,0,40.711,4.071Z",
                  transform: "translate(-20.903 -0.656)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40734",
                  "data-name": "Trazado 40734",
                  d: "M30.969,6.171h-.878a8.5,8.5,0,0,0-7.416,7.513,8.578,8.578,0,0,0,1.952,6.245A8.247,8.247,0,0,1,26.481,25.2a.77.77,0,0,0,.781.781h8.1a.745.745,0,0,0,.488-.2.547.547,0,0,0,.1-.585A9.006,9.006,0,0,1,37.8,19.734a8.288,8.288,0,0,0,1.756-5.172,8.513,8.513,0,0,0-2.83-6.245A8.28,8.28,0,0,0,30.969,6.171Zm1.854,18.442.39-2.244q.146-.585-.585-.878h-.2a.713.713,0,0,0-.683.585l-.293,2.537h-.2l-.39-2.342a.837.837,0,0,0-.683-.585h-.2c-.39.1-.683.488-.585.781l.39,2.147H27.847A8.822,8.822,0,0,0,25.7,19.149a7.168,7.168,0,0,1-1.561-5.269,7.056,7.056,0,0,1,6.245-6.245h.878a6.817,6.817,0,0,1,4.684,1.756,7.33,7.33,0,0,1,2.342,5.269,6.928,6.928,0,0,1-1.464,4.293,10.214,10.214,0,0,0-2.049,5.659Z",
                  transform: "translate(-20.529 -0.707)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40735",
                  "data-name": "Trazado 40735",
                  d: "M35.353,26.871h-8.2a.718.718,0,0,0-.781.781.77.77,0,0,0,.781.781h8.2a.781.781,0,1,0,0-1.561Z",
                  transform: "translate(-20.619 -1.208)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40736",
                  "data-name": "Trazado 40736",
                  d: "M34.689,28.771H27.957a.718.718,0,0,0-.781.781.77.77,0,0,0,.781.781h6.733a.781.781,0,1,0,0-1.561Z",
                  transform: "translate(-20.638 -1.255)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40737",
                  "data-name": "Trazado 40737",
                  d: "M33.931,30.669h-.293a.737.737,0,0,0-.683.39,1.708,1.708,0,0,1-1.464.976H31a1.61,1.61,0,0,1-1.464-.878l-.1-.2a.659.659,0,0,0-.585-.39.738.738,0,0,0-.39.1.676.676,0,0,0-.293.976l.1.2A3.126,3.126,0,0,0,31,33.5h.488a3.237,3.237,0,0,0,2.83-1.854C34.418,31.156,34.321,30.766,33.931,30.669Z",
                  transform: "translate(-20.66 -1.298)",
                  fill: "#ee2b7b"
                }
              )
            ] })
          ]
        }
      )
    ]
  }
), xo = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_04_relaciones_internacionales",
    "data-name": "04_relaciones_internacionales",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_04_relaciones_internacionales-2",
          "data-name": "04_relaciones_internacionales",
          transform: "translate(2.179 2.516)",
          children: [
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41097",
                "data-name": "Trazado 41097",
                d: "M50.283,18.109a5.063,5.063,0,1,0-5.063-5.063A5.069,5.069,0,0,0,50.283,18.109Zm-3.616-5.063a3.616,3.616,0,1,1,3.616,3.616A3.62,3.62,0,0,1,46.667,13.047Z",
                transform: "translate(-2.967 -0.501)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41098",
                "data-name": "Trazado 41098",
                d: "M29.883,10.609A5.063,5.063,0,1,0,24.82,5.547,5.069,5.069,0,0,0,29.883,10.609Zm0-8.585A3.616,3.616,0,1,1,26.266,5.64,3.711,3.711,0,0,1,29.883,2.024Z",
                transform: "translate(-1.603 0)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41099",
                "data-name": "Trazado 41099",
                d: "M22.2,20.976a.655.655,0,0,0,.677-.677V17.966c0-3.271,3.41-4.736,6.789-4.736s6.789,1.464,6.789,4.736V20.3a.655.655,0,0,0,.677.677A.723.723,0,0,0,37.8,20.3v-2.33a5.18,5.18,0,0,0-1.515-3.822,9.235,9.235,0,0,0-6.627-2.363c-4.794,0-8.142,2.542-8.142,6.182V20.3A.723.723,0,0,0,22.2,20.976Z",
                transform: "translate(-1.383 -0.755)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41100",
                "data-name": "Trazado 41100",
                d: "M9.183,18.109A5.063,5.063,0,1,0,4.12,13.047,5.068,5.068,0,0,0,9.183,18.109ZM5.566,13.047a3.616,3.616,0,1,1,3.616,3.616A3.62,3.62,0,0,1,5.566,13.047Z",
                transform: "translate(-0.22 -0.501)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41101",
                "data-name": "Trazado 41101",
                d: "M18.705,38.264,14.04,33.505l-.032-.022c-.048-.023-.09-.048-.128-.07a.731.731,0,0,0-.391-.129.829.829,0,0,0-.549.22l-.021.031c-.024.049-.048.09-.07.129a.717.717,0,0,0-.129.39.829.829,0,0,0,.219.549l4.573,4.666.032.022c.048.023.09.048.128.07a.731.731,0,0,0,.391.129,1.435,1.435,0,0,0,.624-.206.573.573,0,0,0,.259-.424A.753.753,0,0,0,18.705,38.264Z",
                transform: "translate(-0.795 -2.192)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41102",
                "data-name": "Trazado 41102",
                d: "M50.063,19.284c-4.795,0-8.143,2.542-8.143,6.182V27.8a.723.723,0,0,0,.677.677.655.655,0,0,0,.677-.677V25.466c0-3.271,3.41-4.736,6.789-4.736s6.788,1.464,6.788,4.736V27.8a.656.656,0,0,0,.677.677.723.723,0,0,0,.677-.677V25.466C58.2,21.769,54.932,19.284,50.063,19.284Z",
                transform: "translate(-2.746 -1.256)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41103",
                "data-name": "Trazado 41103",
                d: "M30.961,29.034V23.155a.753.753,0,0,0-.77-.77.811.811,0,0,0-.77.77v5.879a.811.811,0,0,0,.77.769A.7.7,0,0,0,30.961,29.034Z",
                transform: "translate(-1.911 -1.463)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41104",
                "data-name": "Trazado 41104",
                d: "M47.075,33.483c-.049-.023-.091-.048-.129-.07a.72.72,0,0,0-.39-.129.825.825,0,0,0-.55.221L41.34,38.264l-.021.03a1.471,1.471,0,0,0-.2.519.8.8,0,0,0,.221.456l.03.021c.049.023.091.048.129.07a.72.72,0,0,0,.39.129,1.47,1.47,0,0,0,.519-.2l4.679-4.767a.566.566,0,0,0,.258-.423.758.758,0,0,0-.241-.6Z",
                transform: "translate(-2.693 -2.192)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41105",
                "data-name": "Trazado 41105",
                d: "M15.752,25.466V27.8a.656.656,0,0,0,.677.677.722.722,0,0,0,.677-.677V25.466c0-3.7-3.272-6.182-8.142-6.182-4.794,0-8.142,2.542-8.142,6.182V27.8a.723.723,0,0,0,.677.677.655.655,0,0,0,.677-.677V25.466c0-3.271,3.41-4.736,6.789-4.736S15.752,22.2,15.752,25.466Z",
                transform: "translate(0 -1.256)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41106",
                "data-name": "Trazado 41106",
                d: "M29.505,46.734c-6.085,0-10.335,3.213-10.335,7.815v2.986a.861.861,0,0,0,.817.817.75.75,0,0,0,.817-.817V54.549c0-3.124,2.72-6.277,8.8-6.277,4.378,0,8.8,1.941,8.8,6.277v2.986a.8.8,0,0,0,.817.817.86.86,0,0,0,.816-.817v-2.99C39.932,49.874,35.7,46.734,29.505,46.734Z",
                transform: "translate(-1.226 -3.09)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41107",
                "data-name": "Trazado 41107",
                d: "M23.47,38.656a6.322,6.322,0,1,0,6.322-6.321A6.407,6.407,0,0,0,23.47,38.656Zm6.322-4.689A4.689,4.689,0,1,1,25.1,38.656,4.7,4.7,0,0,1,29.792,33.967Z",
                transform: "translate(-1.513 -2.128)",
                fill: "#ee2b7b"
              }
            )
          ]
        }
      )
    ]
  }
), Po = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_44_renta_hospitalizacion",
    "data-name": "44_renta_hospitalizacion",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_44_renta_hospitalizacion-2",
          "data-name": "44_renta_hospitalizacion",
          transform: "translate(-2.101 -2.5)",
          children: [
            /* @__PURE__ */ r("g", { id: "Grupo_16704", "data-name": "Grupo 16704", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41008",
                "data-name": "Trazado 41008",
                d: "M51.4,59.5H13.6A2.476,2.476,0,0,1,11.1,57V8a2.476,2.476,0,0,1,2.5-2.5H51.5A2.54,2.54,0,0,1,54,8V57A2.562,2.562,0,0,1,51.4,59.5ZM13.6,7.1a1,1,0,0,0-1,1v49a1,1,0,0,0,1,1H51.5a1,1,0,0,0,1-1V8a1,1,0,0,0-1-1H13.6Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16705", "data-name": "Grupo 16705", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41009",
                "data-name": "Trazado 41009",
                d: "M44.7,31.5H19.3a.8.8,0,1,1,0-1.6H44.6a.789.789,0,0,1,.8.8A.713.713,0,0,1,44.7,31.5Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16706", "data-name": "Grupo 16706", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41010",
                "data-name": "Trazado 41010",
                d: "M44.6,40.2H19.3a.8.8,0,1,1,0-1.6H44.6a.8.8,0,1,1,0,1.6Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16707", "data-name": "Grupo 16707", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41011",
                "data-name": "Trazado 41011",
                d: "M44.6,48.9H19.3a.8.8,0,1,1,0-1.6H44.6a.789.789,0,0,1,.8.8A.86.86,0,0,1,44.6,48.9Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16708", "data-name": "Grupo 16708", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41012",
                "data-name": "Trazado 41012",
                d: "M35.6,23.9H30.5a.789.789,0,0,1-.8-.8V19.8H26.4a.789.789,0,0,1-.8-.8V13.9a.789.789,0,0,1,.8-.8h3.3V9.9a.789.789,0,0,1,.8-.8h5.1a.789.789,0,0,1,.8.8v3.3h3.3a.789.789,0,0,1,.8.8v5.1a.789.789,0,0,1-.8.8H36.4v3.3A.969.969,0,0,1,35.6,23.9Zm-4.4-1.6h3.6V19a.789.789,0,0,1,.8-.8h3.3V14.6H35.6a.789.789,0,0,1-.8-.8V10.5H31.2v3.3a.789.789,0,0,1-.8.8H27.1v3.6h3.3a.789.789,0,0,1,.8.8v3.3Z",
                fill: "#ee2b7b"
              }
            ) })
          ]
        }
      )
    ]
  }
), Zo = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_10_icono_reportar_sintomas",
    "data-name": "10_icono_reportar_sintomas",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_10_icono_reportar_sintomas-2",
          "data-name": "10_icono_reportar_sintomas",
          transform: "translate(-2.987 -2.5)",
          children: [
            /* @__PURE__ */ r("g", { id: "Grupo_16799", "data-name": "Grupo 16799", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41167",
                "data-name": "Trazado 41167",
                d: "M37,28.3A10.9,10.9,0,1,1,47.9,17.4,10.926,10.926,0,0,1,37,28.3ZM37,8.4a9,9,0,1,0,9,9A8.963,8.963,0,0,0,37,8.4Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16800", "data-name": "Grupo 16800", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41168",
                "data-name": "Trazado 41168",
                d: "M22.7,25.9l-.2-.7a.949.949,0,0,1,1.8-.6l.2.7c.1.6-.1,1.1-.6,1.2A1.046,1.046,0,0,1,22.7,25.9Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16801", "data-name": "Grupo 16801", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41169",
                "data-name": "Trazado 41169",
                d: "M22.8,30.8a1.884,1.884,0,0,1-.8-.2,1.673,1.673,0,0,1-.9-1.1l-2.3-6.9a1.691,1.691,0,0,1,.1-1.4,1.673,1.673,0,0,1,1.1-.9l4.4-1.4a.949.949,0,0,1,.6,1.8l-4.4,1.4L23,28.9l6.3-2.1a.949.949,0,1,1,.6,1.8l-6.4,2.1A1.952,1.952,0,0,1,22.8,30.8Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16802", "data-name": "Grupo 16802", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41170",
                "data-name": "Trazado 41170",
                d: "M52,58.5a1,1,0,0,1-1-1V44.2c0-3.7-.5-8.3-4.1-10.4a16.7,16.7,0,0,0-15.1-.3h0l-9.7,4.7a.9.9,0,0,1-1-.1,1.015,1.015,0,0,1-.3-1L22.5,32a.949.949,0,0,1,1.8.6l-1,2.9L31,31.8c5.4-2.6,12.1-2.5,16.9.3,4.5,2.7,5.1,7.8,5.1,12.1V57.5A1.071,1.071,0,0,1,52,58.5Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16803", "data-name": "Grupo 16803", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41171",
                "data-name": "Trazado 41171",
                d: "M26.9,58.5a1,1,0,0,1-1-1V46.4l-8.1.8h0A5.689,5.689,0,0,1,13.2,45a5.569,5.569,0,0,1-1-5l3.5-13a.982.982,0,0,1,1.9.5l-3.5,13a3.545,3.545,0,0,0,.7,3.3,3.564,3.564,0,0,0,3,1.5l9-.9a1.445,1.445,0,0,1,.7.2.908.908,0,0,1,.3.7V57.5A.923.923,0,0,1,26.9,58.5Z",
                fill: "#ee2b7b"
              }
            ) })
          ]
        }
      )
    ]
  }
), Co = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_36_requisitos_minimos",
    "data-name": "36_requisitos_minimos",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_36_requisitos_minimos-2",
          "data-name": "36_requisitos_minimos",
          transform: "translate(-2 -2.5)",
          children: [
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40962",
                "data-name": "Trazado 40962",
                d: "M32.254,12.008A2.354,2.354,0,1,0,29.9,9.654,2.4,2.4,0,0,0,32.254,12.008Zm0-3.441a1.086,1.086,0,1,1,0,2.173,1.046,1.046,0,0,1-1.086-1.086A1.1,1.1,0,0,1,32.254,8.568Z",
                transform: "translate(0.117 -0.265)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40963",
                "data-name": "Trazado 40963",
                d: "M49.861,12.052H42.309v-.3a3.456,3.456,0,0,0-3.478-3.478H37.44A5.558,5.558,0,0,0,32.272,4.5,5.461,5.461,0,0,0,27.1,8.276H25.713a3.521,3.521,0,0,0-3.478,3.478v.2H14.882A2.884,2.884,0,0,0,12,14.835V57.267a2.884,2.884,0,0,0,2.882,2.882H49.861a2.85,2.85,0,0,0,2.882-2.683V14.934A2.884,2.884,0,0,0,49.861,12.052Zm-26.135-.3a2.038,2.038,0,0,1,2.087-2.087H27.8a.852.852,0,0,0,.7-.6,3.952,3.952,0,0,1,7.751,0,.726.726,0,0,0,.7.6H38.93a2.038,2.038,0,0,1,2.087,2.087v2.782a.214.214,0,0,1-.2.2H23.925a.214.214,0,0,1-.2-.2ZM51.252,57.267a1.359,1.359,0,0,1-1.391,1.391H14.882a1.358,1.358,0,0,1-1.391-1.391V14.735a1.359,1.359,0,0,1,1.391-1.391h7.354v1.192a1.675,1.675,0,0,0,1.689,1.689H40.818a1.516,1.516,0,0,0,1.491-1.689V13.444h7.552a1.359,1.359,0,0,1,1.391,1.391Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40964",
                "data-name": "Trazado 40964",
                d: "M38.419,18.334a.619.619,0,0,0-.634-.634H25.834a.634.634,0,0,0,0,1.268H37.785A.619.619,0,0,0,38.419,18.334Z",
                transform: "translate(0.562 -0.053)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40965",
                "data-name": "Trazado 40965",
                d: "M43.035,37.5h-15.3a.634.634,0,0,0,0,1.268h15.3a.634.634,0,0,0,0-1.268Z",
                transform: "translate(0.981 -0.132)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40966",
                "data-name": "Trazado 40966",
                d: "M43.035,25.2h-15.3a.634.634,0,1,0,0,1.268h15.3a.634.634,0,0,0,0-1.268Z",
                transform: "translate(0.981 -0.083)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40967",
                "data-name": "Trazado 40967",
                d: "M43.035,49.7h-15.3a.634.634,0,1,0,0,1.268h15.3a.634.634,0,1,0,0-1.268Z",
                transform: "translate(0.981 0.671)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40968",
                "data-name": "Trazado 40968",
                d: "M23.219,36.487l-2.807,2.082-.543-1a.668.668,0,0,0-1.177.634l.815,1.72a.6.6,0,0,0,.453.362h.181a.493.493,0,0,0,.453-.272l3.441-2.535a.643.643,0,0,0-.815-1Z",
                transform: "translate(0.063 0.037)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40969",
                "data-name": "Trazado 40969",
                d: "M23.219,48.787l-2.807,2.082-.543-1a.668.668,0,0,0-1.177.634l.815,1.72a.6.6,0,0,0,.453.362h.181a.827.827,0,0,0,.453-.272l3.441-2.535a.643.643,0,0,0-.815-1Z",
                transform: "translate(0.063 0.769)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40970",
                "data-name": "Trazado 40970",
                d: "M23.219,24.287l-2.807,2.082-.543-1a.668.668,0,0,0-1.177.634l.815,1.72a.6.6,0,0,0,.453.362h.181a.493.493,0,0,0,.453-.272l3.441-2.535a.643.643,0,1,0-.815-1Z",
                transform: "translate(0.063 0.023)",
                fill: "#ee2b7b"
              }
            )
          ]
        }
      )
    ]
  }
), Vo = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_48_seguimiento_ahorros_tiempo_real",
    "data-name": "48_seguimiento_ahorros_tiempo_real",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ r(
        "path",
        {
          id: "_48_seguimiento_ahorros_tiempo_real-2",
          "data-name": "48_seguimiento_ahorros_tiempo_real",
          d: "M35.359,14.393l-7.7,13.332a1.969,1.969,0,0,1,.376,1.033,2.017,2.017,0,0,1-1.878,1.878,1.855,1.855,0,0,1-1.69-1.127H15.454a.751.751,0,1,1,0-1.5h9.013a1.855,1.855,0,0,1,1.69-1.127h.188l7.7-13.238a.757.757,0,0,1,1.314.751Zm-9.2.188a.808.808,0,0,0,.751-.751V11.67a.751.751,0,1,0-1.5,0v2.159A.808.808,0,0,0,26.158,14.58Zm0,28.354a.808.808,0,0,0-.751.751v2.159a.808.808,0,0,0,.751.751.741.741,0,0,0,.751-.751V43.686A.808.808,0,0,0,26.158,42.935Zm-7.135-1.878a.755.755,0,0,0-1.033.282l-1.033,1.878a.755.755,0,0,0,.282,1.033.564.564,0,0,0,.376.094.814.814,0,0,0,.657-.376L19.3,42.09A.755.755,0,0,0,19.022,41.057Zm-6.2-5.445-1.878,1.033a.755.755,0,0,0-.282,1.033.629.629,0,0,0,.657.376.564.564,0,0,0,.376-.094l1.878-1.033a.757.757,0,0,0-.751-1.314Zm26.289-13.52c.094,0,.188-.094.376-.094l1.878-1.033a.757.757,0,0,0-.751-1.314l-1.878,1.033a.755.755,0,0,0-.282,1.033A.629.629,0,0,0,39.114,22.092ZM11.98,28.758a.808.808,0,0,0-.751-.751H9.07a.751.751,0,1,0,0,1.5h2.066A.767.767,0,0,0,11.98,28.758Zm1.6-8.074L11.7,19.65a.757.757,0,0,0-.751,1.314L12.825,22a.564.564,0,0,0,.376.094.95.95,0,0,0,.657-.376A.755.755,0,0,0,13.577,20.683Zm4.413-4.507a.629.629,0,0,0,.657.376.564.564,0,0,0,.376-.094.755.755,0,0,0,.282-1.033l-1.033-1.878a.757.757,0,1,0-1.314.751ZM57.516,41.151A14.024,14.024,0,0,1,43.527,55.14a14.253,14.253,0,0,1-10.891-5.164,21.211,21.211,0,0,1-6.478.939A22.158,22.158,0,1,1,48.315,28.006,14.064,14.064,0,0,1,57.516,41.151ZM31.7,48.568a14.276,14.276,0,0,1-2.159-7.417A14.024,14.024,0,0,1,43.527,27.161a11.9,11.9,0,0,1,3.192.376A20.579,20.579,0,1,0,26.158,49.319,21.89,21.89,0,0,0,31.7,48.568Zm24.317-7.323a12.566,12.566,0,0,0-7.7-11.548c-.469-.188-1.033-.376-1.6-.563a11.924,11.924,0,0,0-3.192-.469A12.542,12.542,0,0,0,31.04,41.151,12.283,12.283,0,0,0,33.105,48a7.09,7.09,0,0,0,1.033,1.314,12.449,12.449,0,0,0,21.876-8.074ZM48.033,37.3a4.21,4.21,0,0,0-3.1-3.568c-.188-.094-.282-.188-.282-.376v-.845a1.028,1.028,0,0,0-1.033-.939.887.887,0,0,0-.939.939v.751c0,.282-.094.376-.376.469a4.3,4.3,0,0,0-3,4.507,4.481,4.481,0,0,0,3.38,3.943c.469.094.845.094,1.314.188a2.3,2.3,0,0,1,1.972,1.69,2.389,2.389,0,0,1-3.474,2.723,2.3,2.3,0,0,1-1.221-2.159.965.965,0,0,0-1.033-.939.941.941,0,0,0-.939.939,2.894,2.894,0,0,0,.094.939,4.168,4.168,0,0,0,3,3.192c.188.094.376.188.282.469v.751a1.01,1.01,0,0,0,.939.939,1.024,1.024,0,0,0,1.033-.939v-.657c-.094-.376.094-.469.469-.657a4.343,4.343,0,0,0,2.911-4.507,4.279,4.279,0,0,0-3.38-3.849c-.469-.094-.939-.094-1.314-.188a2.32,2.32,0,0,1-1.972-1.69,2.233,2.233,0,0,1,.751-2.441,2.283,2.283,0,0,1,2.535-.376,2.478,2.478,0,0,1,1.408,2.159.822.822,0,0,0,.657.845c.657.282,1.408-.188,1.408-1.127C48.033,37.583,48.033,37.4,48.033,37.3Z",
          transform: "translate(-1 -0.6)",
          fill: "#ee2b7b"
        }
      )
    ]
  }
), Oo = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_29_icono_seguro",
    "data-name": "29_icono_seguro",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h("g", { id: "_29_icono_seguro-2", "data-name": "29_icono_seguro", transform: "translate(-2.7 -2.6)", children: [
        /* @__PURE__ */ r("g", { id: "Grupo_16846", "data-name": "Grupo 16846", children: /* @__PURE__ */ r("g", { id: "Grupo_16845", "data-name": "Grupo 16845", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41255",
            "data-name": "Trazado 41255",
            d: "M32.5,61.5a.367.367,0,0,1-.3-.1A49.3,49.3,0,0,1,20,54.8C11.9,48.9,7.7,41.9,7.7,34.6V11.7a.67.67,0,0,1,.4-.7c.4-.3,11.1-7.4,24.5-7.4s24,7.1,24.5,7.4a1.012,1.012,0,0,1,.4.7V34.6c0,7.3-4.3,14.3-12.3,20.2A54.113,54.113,0,0,1,33,61.5ZM9.4,12.1V34.6C9.4,50,29.8,58.7,32.5,59.7c2.7-1.1,23.1-9.7,23.1-25.1V12.1c-2-1.2-11.7-6.9-23.1-6.9S11.4,10.9,9.4,12.1Z",
            fill: "#ee2b7b"
          }
        ) }) }),
        /* @__PURE__ */ h("g", { id: "Grupo_16849", "data-name": "Grupo 16849", children: [
          /* @__PURE__ */ r("g", { id: "Grupo_16847", "data-name": "Grupo 16847", children: /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41256",
              "data-name": "Trazado 41256",
              d: "M35,39.2H30a.9.9,0,0,1-.9-.9V34.2H25a.9.9,0,0,1-.9-.9v-5a.9.9,0,0,1,.9-.9h4.1V23.3a.9.9,0,0,1,.9-.9h5a.9.9,0,0,1,.9.9v4.1H40a.9.9,0,0,1,.9.9v5a.9.9,0,0,1-.9.9H35.9v4.1A.9.9,0,0,1,35,39.2Zm-4.1-1.7h3.3V33.4a.9.9,0,0,1,.9-.9h4.1V29.2H35a.9.9,0,0,1-.9-.9V24.2H30.8v4.1a.9.9,0,0,1-.9.9H25.8v3.3H30a.9.9,0,0,1,.9.9Z",
              fill: "#ee2b7b"
            }
          ) }),
          /* @__PURE__ */ r("g", { id: "Grupo_16848", "data-name": "Grupo 16848", children: /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_41257",
              "data-name": "Trazado 41257",
              d: "M32.5,45.2a14.4,14.4,0,0,1,0-28.8h.1A14.319,14.319,0,0,1,46.9,30.8h0a14.132,14.132,0,0,1-4.1,10.1A14.371,14.371,0,0,1,32.5,45.2Zm.1-27h0a12.7,12.7,0,1,0,9,21.6,11.915,11.915,0,0,0,3.6-8.9h0A12.57,12.57,0,0,0,32.6,18.2Z",
              fill: "#ee2b7b"
            }
          ) })
        ] })
      ] })
    ]
  }
), Eo = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_18_seguro_accidentes",
    "data-name": "18_seguro_accidentes",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_18_seguro_accidentes-2",
          "data-name": "18_seguro_accidentes",
          transform: "translate(-2.05 -2.199)",
          children: [
            /* @__PURE__ */ r("g", { id: "Grupo_16623", "data-name": "Grupo 16623", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40897",
                "data-name": "Trazado 40897",
                d: "M32.5,51.8a3.783,3.783,0,0,1-3.9-3.9A3.842,3.842,0,0,1,32.5,44a3.9,3.9,0,1,1,0,7.8Zm0-5.9a2,2,0,1,0,2,2A1.794,1.794,0,0,0,32.5,45.9Zm.9-3.9H31.8a2.135,2.135,0,0,1-2.2-2.1h0l-.7-15.8a2.271,2.271,0,0,1,.6-1.6,2.36,2.36,0,0,1,1.6-.7h3.1a1.99,1.99,0,0,1,1.6.7,2.271,2.271,0,0,1,.6,1.6l-.7,15.8A2.364,2.364,0,0,1,33.4,42Zm-2-2.2a.265.265,0,0,0,.3.3h1.6a.265.265,0,0,0,.3-.3L34.4,24c0-.1,0-.2-.1-.2a.349.349,0,0,0-.2-.1H31a.354.354,0,0,0-.3.3Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16624", "data-name": "Grupo 16624", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40898",
                "data-name": "Trazado 40898",
                d: "M55.8,55.9H9.2a3.034,3.034,0,0,1-2.7-1.6,3.069,3.069,0,0,1,0-3.2L29.8,10.7a3.18,3.18,0,0,1,5.4,0L58.5,51.1a3.069,3.069,0,0,1,0,3.2A3.112,3.112,0,0,1,55.8,55.9ZM32.5,11.1a1.149,1.149,0,0,0-1.1.6L8.1,52.1a1.271,1.271,0,0,0,0,1.2,1.149,1.149,0,0,0,1.1.6H55.9a1.255,1.255,0,0,0,1.1-.6,1.271,1.271,0,0,0,0-1.2L33.6,11.6A1.29,1.29,0,0,0,32.5,11.1Z",
                fill: "#ee2b7b"
              }
            ) })
          ]
        }
      )
    ]
  }
), Ho = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_17_seguro_hospitalizacion",
    "data-name": "17_seguro_hospitalizacion",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_17_seguro_hospitalizacion-2",
          "data-name": "17_seguro_hospitalizacion",
          transform: "translate(-2 -2.1)",
          children: [
            /* @__PURE__ */ r("g", { id: "Grupo_16619", "data-name": "Grupo 16619", transform: "translate(9 5.1)", children: /* @__PURE__ */ r("g", { id: "Grupo_16618", "data-name": "Grupo 16618", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40894",
                "data-name": "Trazado 40894",
                d: "M31.94,58.594a.359.359,0,0,1-.293-.1,55.228,55.228,0,0,1-11.226-6.15C12.9,46.978,9,40.535,9,33.8V12.617a.737.737,0,0,1,.39-.683A44.039,44.039,0,0,1,31.94,5.1c12.3,0,22.159,6.638,22.55,6.833a.988.988,0,0,1,.39.683V33.8c0,6.833-3.9,13.276-11.421,18.645a55.228,55.228,0,0,1-11.226,6.15ZM10.562,13.007V33.8c0,14.252,18.84,22.257,21.378,23.233,2.538-.976,21.378-8.981,21.378-23.233V13.007C51.463,11.836,42.58,6.662,31.94,6.662S12.417,11.836,10.562,13.007Z",
                transform: "translate(-9 -5.1)",
                fill: "#ee2b7b"
              }
            ) }) }),
            /* @__PURE__ */ h("g", { id: "Grupo_16622", "data-name": "Grupo 16622", transform: "translate(18.34 16.723)", children: [
              /* @__PURE__ */ r("g", { id: "Grupo_16620", "data-name": "Grupo 16620", transform: "translate(5.8 5.8)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40895",
                  "data-name": "Trazado 40895",
                  d: "M34.9,38.8H30.2a.86.86,0,0,1-.8-.8V34.1H25.5a.86.86,0,0,1-.8-.8V28.6a.86.86,0,0,1,.8-.8h3.9V23.9a.86.86,0,0,1,.8-.8h4.7a.86.86,0,0,1,.8.8v3.9h3.9a.86.86,0,0,1,.8.8v4.7a.86.86,0,0,1-.8.8H35.7V38A.789.789,0,0,1,34.9,38.8Zm-4-1.6H34V33.3a.86.86,0,0,1,.8-.8h3.9V29.4H34.8a.86.86,0,0,1-.8-.8V24.7H30.9v3.9a.86.86,0,0,1-.8.8H26.2v3.1h3.9a.86.86,0,0,1,.8.8Z",
                  transform: "translate(-24.7 -23.1)",
                  fill: "#ee2b7b"
                }
              ) }),
              /* @__PURE__ */ r("g", { id: "Grupo_16621", "data-name": "Grupo 16621", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40896",
                  "data-name": "Trazado 40896",
                  d: "M32.5,44.5a13.6,13.6,0,0,1,0-27.2h.1A13.466,13.466,0,0,1,46.1,30.9h0a13.372,13.372,0,0,1-3.9,9.6A13.528,13.528,0,0,1,32.5,44.5Zm.1-25.6h0a12,12,0,1,0-.1,24,12.2,12.2,0,0,0,8.6-3.6,11.547,11.547,0,0,0,3.4-8.4h0A11.95,11.95,0,0,0,32.6,18.9Z",
                  transform: "translate(-18.9 -17.3)",
                  fill: "#ee2b7b"
                }
              ) })
            ] })
          ]
        }
      )
    ]
  }
), Lo = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_16_seguro_mascotas",
    "data-name": "16_seguro_mascotas",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h("g", { id: "_16_seguro_mascotas-2", "data-name": "16_seguro_mascotas", transform: "translate(-1.5 -1.5)", children: [
        /* @__PURE__ */ r("g", { id: "Grupo_16610", "data-name": "Grupo 16610", transform: "translate(8.5 4.5)", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40887",
            "data-name": "Trazado 40887",
            d: "M31.439,58.025a.351.351,0,0,1-.287-.1,52.61,52.61,0,0,1-11.279-6.117C12.419,46.365,8.5,39.961,8.5,33.174V12.051a.722.722,0,0,1,.382-.669A43.8,43.8,0,0,1,31.439,4.5,43.8,43.8,0,0,1,54,11.382a.967.967,0,0,1,.382.669V33.174c0,6.786-3.919,13.19-11.374,18.638A50.3,50.3,0,0,1,31.726,57.93.351.351,0,0,1,31.439,58.025ZM10.125,12.433V33.174c0,14.242,18.829,22.175,21.315,23.226,2.485-.956,21.315-8.985,21.315-23.226V12.433c-1.816-1.147-10.8-6.4-21.315-6.4C20.83,6.125,11.941,11.286,10.125,12.433Z",
            transform: "translate(-8.5 -4.5)",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16611", "data-name": "Grupo 16611", transform: "translate(18.249 16.161)", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40888",
            "data-name": "Trazado 40888",
            d: "M31.89,43.08a13.19,13.19,0,0,1,0-26.38h.1A13.075,13.075,0,0,1,45.08,29.89h0a13.416,13.416,0,0,1-3.728,9.271A13.635,13.635,0,0,1,31.89,43.08Zm.1-24.851h0A11.661,11.661,0,1,0,40.3,38.11a11.345,11.345,0,0,0,3.345-8.124h0A11.79,11.79,0,0,0,31.986,18.229Z",
            transform: "translate(-18.7 -16.7)",
            fill: "#ee2b7b"
          }
        ) }),
        /* @__PURE__ */ h("g", { id: "Grupo_16617", "data-name": "Grupo 16617", transform: "translate(23.984 22.66)", children: [
          /* @__PURE__ */ r("g", { id: "Grupo_16612", "data-name": "Grupo 16612", transform: "translate(2.485 5.114)", children: /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_40889",
              "data-name": "Trazado 40889",
              d: "M30.359,37.022a3.293,3.293,0,0,1-2.2-.956,3.489,3.489,0,0,1,0-4.588l1.72-1.625a3.346,3.346,0,0,1,4.779,0l1.625,1.625h0a3.489,3.489,0,0,1,0,4.588,2.924,2.924,0,0,1-3.441.669,1.418,1.418,0,0,0-1.243,0A2.646,2.646,0,0,1,30.359,37.022Zm1.912-6.691a1.541,1.541,0,0,0-1.243.573L29.4,32.53a1.874,1.874,0,0,0,0,2.39,1.357,1.357,0,0,0,1.529.382,3.266,3.266,0,0,1,2.676,0,1.2,1.2,0,0,0,1.529-.382,2.01,2.01,0,0,0,0-2.485L33.513,30.9A1.541,1.541,0,0,0,32.27,30.332Z",
              transform: "translate(-27.3 -28.85)",
              fill: "#ee2b7b"
            }
          ) }),
          /* @__PURE__ */ r("g", { id: "Grupo_16613", "data-name": "Grupo 16613", transform: "translate(11.661 3.25)", children: /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_40890",
              "data-name": "Trazado 40890",
              d: "M38.525,31.106a1.5,1.5,0,0,1-1.243-.669A2.3,2.3,0,0,1,36.9,29a2.3,2.3,0,0,1,.382-1.434,1.619,1.619,0,0,1,1.147-.669,1.789,1.789,0,0,1,1.625,2.007C40.054,30.436,39.29,31.106,38.525,31.106Zm0-1.529Z",
              transform: "translate(-36.9 -26.9)",
              fill: "#ee2b7b"
            }
          ) }),
          /* @__PURE__ */ r("g", { id: "Grupo_16614", "data-name": "Grupo 16614", transform: "translate(8.316)", children: /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_40891",
              "data-name": "Trazado 40891",
              d: "M35.025,27.706a1.5,1.5,0,0,1-1.243-.669A2.3,2.3,0,0,1,33.4,25.6a2.3,2.3,0,0,1,.382-1.434,1.619,1.619,0,0,1,1.147-.669,1.789,1.789,0,0,1,1.625,2.007C36.65,26.941,35.79,27.706,35.025,27.706Zm.1-1.625Z",
              transform: "translate(-33.4 -23.5)",
              fill: "#ee2b7b"
            }
          ) }),
          /* @__PURE__ */ r("g", { id: "Grupo_16615", "data-name": "Grupo 16615", transform: "translate(3.345)", children: /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_40892",
              "data-name": "Trazado 40892",
              d: "M29.825,27.706a1.5,1.5,0,0,1-1.243-.669A2.3,2.3,0,0,1,28.2,25.6a2.3,2.3,0,0,1,.382-1.434,1.619,1.619,0,0,1,1.147-.669,1.789,1.789,0,0,1,1.625,2.007C31.45,26.941,30.59,27.706,29.825,27.706Zm.1-1.625Z",
              transform: "translate(-28.2 -23.5)",
              fill: "#ee2b7b"
            }
          ) }),
          /* @__PURE__ */ r("g", { id: "Grupo_16616", "data-name": "Grupo 16616", transform: "translate(0 3.25)", children: /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_40893",
              "data-name": "Trazado 40893",
              d: "M26.325,31.106a1.5,1.5,0,0,1-1.243-.669A2.3,2.3,0,0,1,24.7,29a2.3,2.3,0,0,1,.382-1.434,1.619,1.619,0,0,1,1.147-.669,1.789,1.789,0,0,1,1.625,2.007C27.95,30.436,27.185,31.106,26.325,31.106Zm.1-1.529Z",
              transform: "translate(-24.7 -26.9)",
              fill: "#ee2b7b"
            }
          ) })
        ] })
      ] })
    ]
  }
), ko = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_15_seguro_vida",
    "data-name": "15_seguro_vida",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h("g", { id: "_15_seguro_vida-2", "data-name": "15_seguro_vida", transform: "translate(-1 -2.041)", children: [
        /* @__PURE__ */ h("g", { id: "Grupo_16609", "data-name": "Grupo 16609", transform: "translate(3 25.057)", children: [
          /* @__PURE__ */ r("g", { id: "Grupo_16606", "data-name": "Grupo 16606", children: /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_40883",
              "data-name": "Trazado 40883",
              d: "M10.2,55.9H3.8a.8.8,0,1,1,0-1.6h6.4A1.324,1.324,0,0,0,11.5,53V30.4a1.324,1.324,0,0,0-1.3-1.3H3.8a.8.8,0,1,1,0-1.6h6.4a2.9,2.9,0,0,1,2.9,2.9V53A2.9,2.9,0,0,1,10.2,55.9Z",
              transform: "translate(-3 -27.5)",
              fill: "#ee2b7b"
            }
          ) }),
          /* @__PURE__ */ r("g", { id: "Grupo_16607", "data-name": "Grupo 16607", transform: "translate(11.998 3.7)", children: /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_40884",
              "data-name": "Trazado 40884",
              d: "M44,41.3a.86.86,0,0,1-.8-.8v-.6a1,1,0,0,0-1-1H34.3c-.2,0-.3-.1-.5-.1l-8.3-6H17.2a.8.8,0,0,1,0-1.6h8.5c.2,0,.3.1.5.1l8.3,6h7.7a2.647,2.647,0,0,1,2.6,2.6v.6A.789.789,0,0,1,44,41.3Z",
              transform: "translate(-16.4 -31.2)",
              fill: "#ee2b7b"
            }
          ) }),
          /* @__PURE__ */ r("g", { id: "Grupo_16608", "data-name": "Grupo 16608", transform: "translate(9.075 8.3)", children: /* @__PURE__ */ r(
            "path",
            {
              id: "Trazado_40885",
              "data-name": "Trazado 40885",
              d: "M37.3,53.2A19.889,19.889,0,0,1,30.5,52,18.669,18.669,0,0,1,27,50.4c-1-.5-1.9-1-2.9-1.4a23.022,23.022,0,0,0-8-1.7.8.8,0,1,1,0-1.6,23.689,23.689,0,0,1,8.6,1.8A17.723,17.723,0,0,1,27.8,49a24.084,24.084,0,0,0,3.3,1.5c7.7,2.7,14.3-.1,18.5-3,1.1-.7,2.1-1.5,3.2-2.2,1.7-1.2,3.4-2.5,5.2-3.6l.3-.1a11.068,11.068,0,0,0,1.6-1.1,1.494,1.494,0,0,0,.5-1.8,2.282,2.282,0,0,0-2.1-1.3h-.1a10.091,10.091,0,0,0-4.5,1.7l-8,4.5c-.1,0-.1.1-.2.1-5,1.2-16.8.1-17.3,0a.806.806,0,0,1,.2-1.6c.1,0,11.9,1.2,16.7,0L53,37.7a11.008,11.008,0,0,1,5.3-1.9h.1A3.862,3.862,0,0,1,62,38.1a3.176,3.176,0,0,1-.9,3.5A11.545,11.545,0,0,1,59.2,43l-.2.1a45.914,45.914,0,0,0-5.1,3.5c-1.1.8-2.1,1.6-3.2,2.3C46.1,51.7,41.7,53.2,37.3,53.2Z",
              transform: "translate(-15.3 -35.8)",
              fill: "#ee2b7b"
            }
          ) })
        ] }),
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40886",
            "data-name": "Trazado 40886",
            d: "M61.424,20.477a.809.809,0,0,0-.779-.408s-.156,0-.23,0c0,0-.509,0-.587,0a6.413,6.413,0,0,0,.44-3.282,6.536,6.536,0,0,0-5.98-5.689c-.157-.01-.312-.014-.465-.014A6.444,6.444,0,0,0,49.2,12.994a1.868,1.868,0,0,0-.151.174c-.055.069-.146.185-.191.186s-.14-.116-.2-.193a1.876,1.876,0,0,0-.143-.168,6.259,6.259,0,0,0-4.078-1.932c-.2-.014-.4-.021-.6-.021a6.335,6.335,0,0,0-5.646,3.2,6.219,6.219,0,0,0-.907,3.745,6.572,6.572,0,0,0,.62,2.422l-.426,0c-.074,0-.148,0-.286-.007a.791.791,0,0,0-.725.408l-.027.047v.491l.025.045a.81.81,0,0,0,.779.413l.2,0,.536.006c.127,0,.254,0,.463-.016a.843.843,0,0,1,.646.319q3.707,3.753,7.451,7.465a3.19,3.19,0,0,0,2.255.942,3.034,3.034,0,0,0,2.048-.792c.867-.79,7.381-7.294,8.1-8.151a.255.255,0,0,1,.229-.115l1.5.007a.8.8,0,0,0,.744-.409l.027-.046v-.491ZM48.79,29.1a1.928,1.928,0,0,1-1.349-.632l-6.666-6.663h1.562a.748.748,0,0,0,.869-.585l.879-2.154,1.782,4.974s.441,1.239.542,1.509a.743.743,0,0,0,.714.521h.005a.73.73,0,0,0,.664-.57l1.289-4.389.092.229c.211.521.42,1.038.623,1.556a.769.769,0,0,0,.715.555.757.757,0,0,0,.687-.514l1.851-4.087.154.361c.243.567.486,1.135.72,1.706a.81.81,0,0,0,.825.555s.735-.007,1.1-.007l1.293,0c-.989.992-5.195,5.2-5.241,5.246,0,0-1.4,1.4-1.771,1.766A1.938,1.938,0,0,1,48.79,29.1Zm9.536-9.142a.172.172,0,0,1-.195.117s-.983-.006-1.475-.006-.957,0-1.441.007c-.1,0-.117-.009-.162-.117-.289-.7-.586-1.4-.882-2.091l-.418-.98a.714.714,0,0,0-1.358-.025l-1.853,4.084-.867-2.15a.747.747,0,0,0-.715-.543h0a.732.732,0,0,0-.69.613l-1.241,4.211-2.191-6.109a1.009,1.009,0,0,0-.161-.319.7.7,0,0,0-.546-.273.742.742,0,0,0-.673.493q-.417,1-.823,2.007l-.4.993c-.066.158-.133.315-.191.476-.024.066-.029.066-.091.066,0,0-.791,0-1.186,0s-.767,0-1.154.007c-.059,0-.081-.006-.156-.127a5.137,5.137,0,0,1,3.253-7.7,5.743,5.743,0,0,1,1.216-.136,5.036,5.036,0,0,1,3.521,1.471c.171.162.336.329.5.5l.364.364a.807.807,0,0,0,.56.266.823.823,0,0,0,.558-.258c.157-.148.309-.3.459-.456a7.8,7.8,0,0,1,.848-.787,5.1,5.1,0,0,1,7.595,6.415Z",
            transform: "translate(-3.225)",
            fill: "#ee2b7b"
          }
        )
      ] })
    ]
  }
), No = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_05_Icono_seguros",
    "data-name": "05_Icono_seguros",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h("g", { id: "_05_Icono_seguros-2", "data-name": "05_Icono_seguros", transform: "translate(-8.5 -9.675)", children: [
        /* @__PURE__ */ r("g", { id: "Grupo_16726", "data-name": "Grupo 16726", transform: "translate(15.5 10.675)", children: /* @__PURE__ */ r("g", { id: "Grupo_16725", "data-name": "Grupo 16725", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41064",
            "data-name": "Trazado 41064",
            d: "M38.487,69.4a1.278,1.278,0,0,1-.563-.2L29.667,63A36.349,36.349,0,0,1,15.5,34V22.2a1.156,1.156,0,0,1,.844-1.1h.281A48.206,48.206,0,0,0,35.86,12.5l2.158-1.6a.939.939,0,0,1,1.22,0L40.645,12a47.452,47.452,0,0,0,19.046,8.9l.844.2a1.156,1.156,0,0,1,.844,1.1V34.4A35.351,35.351,0,0,1,47.494,62.8l-8.538,6.4A.694.694,0,0,1,38.487,69.4ZM17.658,23.1V34A34.079,34.079,0,0,0,30.887,61.2l7.6,5.7L46.368,61A33.081,33.081,0,0,0,59.316,34.4V23.1a50.3,50.3,0,0,1-19.891-9.3l-.844-.6-1.6,1.2A51.759,51.759,0,0,1,17.658,23.1ZM47.025,61.9Z",
            transform: "translate(-15.5 -10.675)",
            fill: "#ee2b7b"
          }
        ) }) }),
        /* @__PURE__ */ r("g", { id: "Grupo_16728", "data-name": "Grupo 16728", transform: "translate(24.483 28.2)", children: /* @__PURE__ */ r("g", { id: "Grupo_16727", "data-name": "Grupo 16727", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41065",
            "data-name": "Trazado 41065",
            d: "M36.1,51.8a1.135,1.135,0,0,1-.8-.3l-9-9a1.217,1.217,0,0,1,0-1.6l4.6-4.6a1.215,1.215,0,0,1,1.6,0l3.6,3.6L47.5,28.5a1.215,1.215,0,0,1,1.6,0l4.6,4.6a1.215,1.215,0,0,1,0,1.6L36.9,51.5A1.135,1.135,0,0,1,36.1,51.8ZM28.6,41.7l7.5,7.5L51.3,34l-3.1-3.1L36.9,42.2a1.215,1.215,0,0,1-1.6,0l-3.6-3.6Z",
            transform: "translate(-26 -28.2)",
            fill: "#ee2b7b"
          }
        ) }) })
      ] })
    ]
  }
), Go = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_07_Icono_siete_acciones",
    "data-name": "07_Icono_siete_acciones",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_07_Icono_siete_acciones-2",
          "data-name": "07_Icono_siete_acciones",
          transform: "translate(7.363 1.429)",
          children: [
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41072",
                "data-name": "Trazado 41072",
                d: "M11.476,14.571a13.289,13.289,0,0,0-6.2,6.6,14.934,14.934,0,0,0-1.4,6.9,4.671,4.671,0,0,0,.3,1.7,1.605,1.605,0,0,1-.3,1.6c-.3.3-.4.6-.7.9l-.1.2c-.3.3-.5.7-.8,1a14.166,14.166,0,0,0-1.4,2.3,3.655,3.655,0,0,0-.1,2.3,2.731,2.731,0,0,0,1.7,1.4.68.68,0,0,1,.4.3.6.6,0,0,1-.1.4,1.826,1.826,0,0,0,.4,2.1c.2.2.3.3.2.6a1.529,1.529,0,0,0,.4,1.8,1.814,1.814,0,0,1,.5,1.8,3.768,3.768,0,0,0,.8,2.7,3.847,3.847,0,0,0,2.6,1.3l4.8.3a1.889,1.889,0,0,1,1.3.7,3.926,3.926,0,0,1,.6,1.3c.3,1,.6,2.2.8,3.2a.789.789,0,0,0,.849.675c.94-.116.68-1,.645-1.162-.066-.3-.143-.643-.293-1.312a12.865,12.865,0,0,0-.8-2.6,3.5,3.5,0,0,0-3.4-2.4c-1.2,0-2.4-.1-3.7-.2l-.8-.1a1.75,1.75,0,0,1-1.4-.7,2.155,2.155,0,0,1-.4-1.6,3.177,3.177,0,0,0-.8-2.8c-.2-.2-.2-.3-.1-.6a1.384,1.384,0,0,0-.3-1.7.919.919,0,0,1-.2-1,1.7,1.7,0,0,0,0-1.4,1.837,1.837,0,0,0-1.2-.8c-.2,0-.3-.1-.5-.2-.6-.3-.7-.6-.5-1.3a6.117,6.117,0,0,1,.5-1.2c.1-.2,2.1-3,2.5-3.6a2.712,2.712,0,0,0,.3-2.3,3.926,3.926,0,0,1-.3-1.4,13.831,13.831,0,0,1,2.9-9.2,11.469,11.469,0,0,1,5.9-4,19.442,19.442,0,0,1,4.9-1.1c.621-.043.74-.349.723-.74s-.153-.765-.823-.76A19.071,19.071,0,0,0,11.476,14.571Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41073",
                "data-name": "Trazado 41073",
                d: "M34.476,36.471l-1.1,1.9a14.692,14.692,0,0,0-1.4,4.5,17.223,17.223,0,0,0-.4,3.9v3.9l.053,5.1a.873.873,0,0,0,.862.876.79.79,0,0,0,.786-.876c0-.8-.3-8.8,0-11.1a25.851,25.851,0,0,1,.9-4,19.277,19.277,0,0,1,1.9-3.8c.5-.9,1-2,1.5-3.1.2-.544-.406-1.042-.915-.935-.371.078-.546.059-.976,1.268A12.693,12.693,0,0,1,34.476,36.471Z",
                transform: "translate(-0.862)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ h("g", { id: "Grupo_16739", "data-name": "Grupo 16739", transform: "translate(19.387 0.571)", children: [
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41074",
                  "data-name": "Trazado 41074",
                  d: "M30.676,4.771a.773.773,0,0,0,.8-.7v-2.7a.736.736,0,0,0-.8-.8.789.789,0,0,0-.8.8v2.7A.828.828,0,0,0,30.676,4.771Z",
                  transform: "translate(-20.476 -0.571)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41075",
                  "data-name": "Trazado 41075",
                  d: "M23.876,7.571a.759.759,0,0,0-.2-.5l-2-2a.7.7,0,0,0-1.2.5.764.764,0,0,0,.2.5l2,2a.843.843,0,0,0,.5.2A.633.633,0,0,0,23.876,7.571Z",
                  transform: "translate(-20.476 -0.571)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41076",
                  "data-name": "Trazado 41076",
                  d: "M44.976,13.971h-2.8a.736.736,0,0,0-.8.8.789.789,0,0,0,.8.8h2.8a.789.789,0,0,0,.8-.8A.841.841,0,0,0,44.976,13.971Z",
                  transform: "translate(-20.476 -0.571)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41077",
                  "data-name": "Trazado 41077",
                  d: "M40.776,4.071a.764.764,0,0,0-.5.2l-2,2a.725.725,0,0,0,0,1,.764.764,0,0,0,.5.2,1.421,1.421,0,0,0,.6-.2l2-2a.725.725,0,0,0,0-1A.735.735,0,0,0,40.776,4.071Z",
                  transform: "translate(-20.476 -0.571)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41078",
                  "data-name": "Trazado 41078",
                  d: "M31.176,6.171h-.9a8.712,8.712,0,0,0-7.6,7.7,8.791,8.791,0,0,0,2,6.4,8.452,8.452,0,0,1,1.9,5.4.789.789,0,0,0,.8.8h8.3a.764.764,0,0,0,.5-.2.56.56,0,0,0,.1-.6,9.229,9.229,0,0,1,1.9-5.6,8.493,8.493,0,0,0,1.8-5.3,8.724,8.724,0,0,0-2.9-6.4A8.486,8.486,0,0,0,31.176,6.171Zm1.9,18.9.4-2.3q.15-.6-.6-.9h-.2a.73.73,0,0,0-.7.6l-.3,2.6h-.2l-.4-2.4a.858.858,0,0,0-.7-.6h-.2c-.4.1-.7.5-.6.8l.4,2.2h-2a9.041,9.041,0,0,0-2.2-5.6,7.346,7.346,0,0,1-1.6-5.4,7.231,7.231,0,0,1,6.4-6.4h.9a6.986,6.986,0,0,1,4.8,1.8,7.512,7.512,0,0,1,2.4,5.4,7.1,7.1,0,0,1-1.5,4.4,10.467,10.467,0,0,0-2.1,5.8Z",
                  transform: "translate(-20.476 -0.571)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41079",
                  "data-name": "Trazado 41079",
                  d: "M35.576,26.871h-8.4a.736.736,0,0,0-.8.8.789.789,0,0,0,.8.8h8.4a.8.8,0,1,0,0-1.6Z",
                  transform: "translate(-20.476 -0.571)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41080",
                  "data-name": "Trazado 41080",
                  d: "M34.876,28.771h-6.9a.736.736,0,0,0-.8.8.789.789,0,0,0,.8.8h6.9a.8.8,0,1,0,0-1.6Z",
                  transform: "translate(-20.476 -0.571)",
                  fill: "#ee2b7b"
                }
              ),
              /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_41081",
                  "data-name": "Trazado 41081",
                  d: "M34.076,30.671h-.3a.755.755,0,0,0-.7.4,1.751,1.751,0,0,1-1.5,1h-.5a1.65,1.65,0,0,1-1.5-.9l-.1-.2a.675.675,0,0,0-.6-.4.756.756,0,0,0-.4.1.693.693,0,0,0-.3,1l.1.2a3.2,3.2,0,0,0,2.8,1.7h.5a3.318,3.318,0,0,0,2.9-1.9C34.576,31.171,34.476,30.771,34.076,30.671Z",
                  transform: "translate(-20.476 -0.571)",
                  fill: "#ee2b7b"
                }
              )
            ] })
          ]
        }
      )
    ]
  }
), Io = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_46_sin_cuota_manejo",
    "data-name": "46_sin_cuota_manejo",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_46_sin_cuota_manejo-2",
          "data-name": "46_sin_cuota_manejo",
          transform: "translate(-1.7 -2.419)",
          children: [
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41021",
                "data-name": "Trazado 41021",
                d: "M11.4,28.8h-6a.7.7,0,0,0,0,1.4h6a1.324,1.324,0,0,1,1.3,1.3V52.7A1.324,1.324,0,0,1,11.4,54h-6a.606.606,0,0,0-.6.8.684.684,0,0,0,.7.7h6a2.689,2.689,0,0,0,2.7-2.7V31.6A2.8,2.8,0,0,0,11.4,28.8Z",
                transform: "translate(0 0.597)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41022",
                "data-name": "Trazado 41022",
                d: "M18.2,33.7H26l7.8,5.6c.1.1.2.1.4.1h7.5a1,1,0,0,1,1,1V41a.7.7,0,0,0,1.4,0v-.5A2.476,2.476,0,0,0,41.6,38H34.4l-7.8-5.6c-.1-.1-.2-.1-.4-.1h-8a.7.7,0,1,0,0,1.4Z",
                transform: "translate(0.32 0.372)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41023",
                "data-name": "Trazado 41023",
                d: "M59.8,38.6a3.727,3.727,0,0,0-3.4-2.1,9.3,9.3,0,0,0-5.1,1.8l-7.4,4.2c-4.4,1.1-15.6,0-15.7,0a.752.752,0,1,0-.1,1.5c.4.1,11.6,1.2,16.3,0,.1,0,.1-.1.2-.1l7.5-4.2c1-.5,2.8-1.6,4.3-1.6h.1a2.161,2.161,0,0,1,2,1.2A1.625,1.625,0,0,1,58,41a4.177,4.177,0,0,1-1.5,1.1l-.2.1a53.612,53.612,0,0,0-4.9,3.4l-3,2.1C44.5,50.4,38.2,53,31,50.5a21.186,21.186,0,0,1-3.1-1.4A25.909,25.909,0,0,0,25,47.7,21.413,21.413,0,0,0,16.9,46a.7.7,0,0,0,0,1.4A20.344,20.344,0,0,1,24.5,49a23.94,23.94,0,0,1,2.8,1.3,25.213,25.213,0,0,0,3.3,1.5,19.852,19.852,0,0,0,18.6-3c1-.7,2-1.5,3-2.2A57.815,57.815,0,0,1,57,43.3l.2-.1A20.279,20.279,0,0,0,59,41.9,3.177,3.177,0,0,0,59.8,38.6Z",
                transform: "translate(0.716 0.597)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41024",
                "data-name": "Trazado 41024",
                d: "M37.1,14A10.825,10.825,0,0,0,35,20.3,10.478,10.478,0,0,0,45.5,30.7,10.666,10.666,0,0,0,53,27.6l3.3,2.8c.2.1.3.2.5.2a.864.864,0,0,0,.6-.3.784.784,0,0,0-.1-1.1L54,26.4A10.451,10.451,0,0,0,45.5,9.8a10.43,10.43,0,0,0-7.4,3.1L34.3,9.6a.781.781,0,0,0-1,1.2Zm8.4-2.7a8.963,8.963,0,0,1,9,9,8.829,8.829,0,0,1-1.6,5.1l-4.3-3.7a3.386,3.386,0,0,0-2.3-2.2H46l-2.2-1.8a1.76,1.76,0,0,1,.6-1.3,1.66,1.66,0,0,1,1.9-.2,1.781,1.781,0,0,1,1,1.6.675.675,0,0,0,.4.6.709.709,0,0,0,1-.8v-.3a3.127,3.127,0,0,0-2.2-2.6c-.2-.1-.2-.1-.2-.3v-.6a.7.7,0,0,0-1.4,0v.5c0,.2-.1.3-.3.4a2.936,2.936,0,0,0-2,1.9l-3.3-2.8A9.126,9.126,0,0,1,45.5,11.3ZM38.2,15l4.2,3.6a3.238,3.238,0,0,0,2.7,2.3l2.1,1.8v.2a1.736,1.736,0,0,1-3.4.2c0-.2-.1-.3-.1-.5a.773.773,0,0,0-.8-.7.684.684,0,0,0-.7.7,1.7,1.7,0,0,0,.1.7,3.072,3.072,0,0,0,2.1,2.3c.2.1.3.1.3.3v.5a.7.7,0,1,0,1.4,0V26c0-.4,0-.4.3-.5a3,3,0,0,0,1.9-1.9l3.4,2.9a9.155,9.155,0,0,1-6.4,2.7,8.963,8.963,0,0,1-9-9A10.581,10.581,0,0,1,38.2,15Z",
                transform: "translate(0.716)",
                fill: "#ee2b7b"
              }
            )
          ]
        }
      )
    ]
  }
), Fo = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_31_icono_sin_salir",
    "data-name": "31_icono_sin_salir",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_31_icono_sin_salir-2",
          "data-name": "31_icono_sin_salir",
          transform: "translate(-2.04 -2.275)",
          children: [
            /* @__PURE__ */ r("g", { id: "Grupo_16850", "data-name": "Grupo 16850", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41258",
                "data-name": "Trazado 41258",
                d: "M46.3,54.8H18.7a.9.9,0,0,1-.9-.9V36.4H12.5a.891.891,0,0,1-.8-.5.765.765,0,0,1,.2-.9L31.8,15.7a.913.913,0,0,1,1.2,0L53,34.9a.765.765,0,0,1,.2.9.792.792,0,0,1-.8.5H47.1V53.9A.765.765,0,0,1,46.3,54.8ZM19.6,53.1H45.5V35.5a.9.9,0,0,1,.9-.9h4L32.5,17.4,14.7,34.7h4a.9.9,0,0,1,.9.9Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16851", "data-name": "Grupo 16851", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41259",
                "data-name": "Trazado 41259",
                d: "M36.7,54.8a.9.9,0,0,1-.9-.9V43.1H29.2V53.9a.9.9,0,1,1-1.8,0V42.3a.9.9,0,0,1,.9-.9h8.3a.9.9,0,0,1,.9.9V54A.86.86,0,0,1,36.7,54.8Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16852", "data-name": "Grupo 16852", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41260",
                "data-name": "Trazado 41260",
                d: "M56.2,42.6H51.9a.9.9,0,0,1,0-1.8h3.5v-14a.9.9,0,0,1,.9-.9H59L44.9,12.3l-5.1,5a.849.849,0,0,1-1.2-1.2l5.7-5.6a.913.913,0,0,1,1.2,0L61.7,26.2a.765.765,0,0,1,.2.9.792.792,0,0,1-.8.5H57V41.7A.882.882,0,0,1,56.2,42.6Z",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16853", "data-name": "Grupo 16853", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41261",
                "data-name": "Trazado 41261",
                d: "M13.2,42.6H8.8a.9.9,0,0,1-.9-.9V27.6h-4a.891.891,0,0,1-.8-.5.765.765,0,0,1,.2-.9L19.5,10.5a.913.913,0,0,1,1.2,0l5.7,5.6a.849.849,0,0,1-1.2,1.2l-5.1-5L6,25.9H8.9a.9.9,0,0,1,.9.9V40.9h3.5a.9.9,0,0,1,.9.9A1.187,1.187,0,0,1,13.2,42.6Z",
                fill: "#ee2b7b"
              }
            ) })
          ]
        }
      )
    ]
  }
), Do = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_12_solicita_credito",
    "data-name": "12_solicita_credito",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_12_solicita_credito-2",
          "data-name": "12_solicita_credito",
          transform: "translate(-1.7 0.2)",
          children: [
            /* @__PURE__ */ r("g", { id: "Grupo_16574", "data-name": "Grupo 16574", transform: "translate(20.53 23.748)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40853",
                "data-name": "Trazado 40853",
                d: "M40.1,27.1H23.2a.789.789,0,0,1-.8-.8.736.736,0,0,1,.8-.8H40.1a.8.8,0,1,1,0,1.6Z",
                transform: "translate(-22.4 -25.5)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16575", "data-name": "Grupo 16575", transform: "translate(20.875 33.405)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40854",
                "data-name": "Trazado 40854",
                d: "M32.9,37.7H23.2a.789.789,0,0,1-.8-.8.736.736,0,0,1,.8-.8h9.7a.789.789,0,0,1,.8.8A.736.736,0,0,1,32.9,37.7Z",
                transform: "translate(-22.4 -36.1)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16576", "data-name": "Grupo 16576", transform: "translate(21.008 43.153)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40855",
                "data-name": "Trazado 40855",
                d: "M29.3,48.4H23.2a.789.789,0,0,1-.8-.8.736.736,0,0,1,.8-.8h6a.789.789,0,0,1,.8.8A.713.713,0,0,1,29.3,48.4Z",
                transform: "translate(-22.4 -46.8)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16577", "data-name": "Grupo 16577", transform: "translate(15 22.086)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40856",
                "data-name": "Trazado 40856",
                d: "M17.5,28.8A2.5,2.5,0,1,1,20,26.3,2.476,2.476,0,0,1,17.5,28.8Zm0-3.5a1,1,0,0,0-1,1,1,1,0,1,0,1-1Z",
                transform: "translate(-15 -23.8)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16578", "data-name": "Grupo 16578", transform: "translate(15 31.768)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40857",
                "data-name": "Trazado 40857",
                d: "M17.5,39.5A2.5,2.5,0,1,1,20,37,2.476,2.476,0,0,1,17.5,39.5Zm0-3.6a1,1,0,0,0-1,1,1,1,0,1,0,1-1Z",
                transform: "translate(-15 -34.5)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16579", "data-name": "Grupo 16579", transform: "translate(15 41.359)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40858",
                "data-name": "Trazado 40858",
                d: "M17.5,50.1A2.5,2.5,0,1,1,20,47.6,2.476,2.476,0,0,1,17.5,50.1Zm0-3.5a1,1,0,0,0-1,1,1,1,0,1,0,1-1Z",
                transform: "translate(-15 -45.1)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16580", "data-name": "Grupo 16580", transform: "translate(30.06 28.993)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40859",
                "data-name": "Trazado 40859",
                d: "M46.7,58.2A12.3,12.3,0,1,1,59,45.9,12.291,12.291,0,0,1,46.7,58.2Zm0-23.1A10.8,10.8,0,1,0,57.5,45.9,10.819,10.819,0,0,0,46.7,35.1Z",
                transform: "translate(-34.4 -33.6)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16581", "data-name": "Grupo 16581", transform: "translate(37.135 38.179)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40860",
                "data-name": "Trazado 40860",
                d: "M45.1,50.3h0a.764.764,0,0,1-.5-.2l-2.9-2.9A.849.849,0,0,1,42.9,46l2.2,2.2,6.1-6.1a.849.849,0,0,1,1.2,1.2L45.8,50A.908.908,0,0,1,45.1,50.3Z",
                transform: "translate(-41.475 -41.875)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40861",
                "data-name": "Trazado 40861",
                d: "M40.964,5.8H18.512a1.6,1.6,0,0,0-.619.183L8.877,15.394a1.354,1.354,0,0,0-.177.64V53.77a.87.87,0,0,0,.8.822h23.69a.823.823,0,0,0,0-1.645H10.2v-36h9.282a.806.806,0,0,0,.8-.822V7.353H40.169v20.01a.8.8,0,1,0,1.591,0V6.622A.869.869,0,0,0,40.964,5.8Zm-22.1,9.594H11.087l7.779-8.041Z",
                fill: "#ee2b7b"
              }
            )
          ]
        }
      )
    ]
  }
), Ro = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_09_icono_solicitar_cita",
    "data-name": "09_icono_solicitar_cita",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_09_icono_solicitar_cita-2",
          "data-name": "09_icono_solicitar_cita",
          transform: "translate(-2.399 -2.5)",
          children: [
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41162",
                "data-name": "Trazado 41162",
                d: "M28.9,36.7c-4,0-7.2,2.7-7.2,6.1,0,3.3,3.3,6.1,7.2,6.1s7.2-2.7,7.2-6.1C36.1,39.5,32.9,36.7,28.9,36.7Zm0,10.4c-3,0-5.4-1.9-5.4-4.3s2.4-4.4,5.4-4.4,5.4,2,5.4,4.4C34.3,45.1,31.9,47.1,28.9,47.1Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41163",
                "data-name": "Trazado 41163",
                d: "M52.3,33.2V29.7a2.1,2.1,0,0,0-1.5-2A60.475,60.475,0,0,0,44,26.1a.922.922,0,0,0-.4,1.8,57.394,57.394,0,0,1,6.6,1.6.2.2,0,0,1,.2.2v5.8c0,.1-.2.2-.7.3a23.134,23.134,0,0,1-8.3,0,1.363,1.363,0,0,1-.6-.3V31.4a.875.875,0,0,0-.6-.9c-6.7-2.3-15.5-2.3-22.9,0a1.149,1.149,0,0,0-.6.9v4.1q0,.15-.6.3a29.548,29.548,0,0,1-8.4,0,1.363,1.363,0,0,1-.6-.3V29.7a.693.693,0,0,1,.4-.3,72.341,72.341,0,0,1,25.7-3.2.906.906,0,0,0,.2-1.8A73.465,73.465,0,0,0,7.1,27.7a2.207,2.207,0,0,0-1.7,2v5.8c0,1,.8,1.8,2.1,2a31.9,31.9,0,0,0,8.2.1L9.9,47.9a1.884,1.884,0,0,0-.2.8v7.4a2.433,2.433,0,0,0,2.4,2.4H45.7A2.326,2.326,0,0,0,48,56.2V54.3c6.2,0,11.3-4.5,11.5-10.3C59.8,39.3,56.9,35.1,52.3,33.2Zm-6,23a.645.645,0,0,1-.6.6H12.1a.645.645,0,0,1-.6-.6V48.7l6.8-12.2v-.1a1.613,1.613,0,0,0,.3-.9V32.1a37.92,37.92,0,0,1,20.6,0v3.4a1.689,1.689,0,0,0,.3,1h0l6.8,12.1v7.6ZM57.8,43.9c-.3,4.9-4.6,8.5-9.8,8.6V48.8a1.978,1.978,0,0,0-.2-1L42.1,37.6a23.4,23.4,0,0,0,3.8.3,17.963,17.963,0,0,0,4.3-.4c1.9-.4,2.1-1.5,2.1-2v-.3A9.3,9.3,0,0,1,57.8,43.9Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41164",
                "data-name": "Trazado 41164",
                d: "M33,21.7c3.1.7,3.5,1.6,3.5,1.8.1.4-.4,1-.6,1.2a1.529,1.529,0,0,0-.3,1.8c.3.6.6.8,1.7.8,1.8-.1,15.5-3.9,15.6-11.6a7.349,7.349,0,0,0-2.3-5.4c-2.3-2.4-6.2-3.8-10.2-3.8-6.9,0-12.5,4.1-12.5,9.1A6.09,6.09,0,0,0,33,21.7ZM40.3,8.3a12.709,12.709,0,0,1,8.9,3.2A5.7,5.7,0,0,1,51,15.6c0,5-8,8.4-13.3,9.7a2.859,2.859,0,0,0,.5-2.3c-.4-1.4-2-2.4-4.9-3.1a4.2,4.2,0,0,1-3.7-4.3C29.6,11.6,34.4,8.3,40.3,8.3Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41165",
                "data-name": "Trazado 41165",
                d: "M34.3,14.3h12a.9.9,0,1,0,0-1.8h-12a.9.9,0,1,0,0,1.8Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41166",
                "data-name": "Trazado 41166",
                d: "M34.3,18.2h12a.9.9,0,1,0,0-1.8h-12a.9.9,0,1,0,0,1.8Z",
                fill: "#ee2b7b"
              }
            )
          ]
        }
      )
    ]
  }
), Bo = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_37_solicitud_antes_de_compra",
    "data-name": "37_solicitud_antes_de_compra",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_37_solicitud_antes_de_compra-2",
          "data-name": "37_solicitud_antes_de_compra",
          transform: "translate(1 1)",
          children: [
            /* @__PURE__ */ r("g", { id: "Grupo_16677", "data-name": "Grupo 16677", transform: "translate(6 3)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40971",
                "data-name": "Trazado 40971",
                d: "M44.875,54.892H8.391A2.381,2.381,0,0,1,6,52.5V5.391A2.381,2.381,0,0,1,8.391,3H44.875a2.381,2.381,0,0,1,2.391,2.391v14.7a.708.708,0,0,1-1.417,0V5.391a.983.983,0,0,0-.974-.974H8.391a.983.983,0,0,0-.974.974V52.5a.983.983,0,0,0,.974.974H44.875a.983.983,0,0,0,.974-.974V40.281a.708.708,0,0,1,1.417,0V52.589A2.424,2.424,0,0,1,44.875,54.892Z",
                transform: "translate(-6 -3)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16678", "data-name": "Grupo 16678", transform: "translate(14.147 27.883)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40972",
                "data-name": "Trazado 40972",
                d: "M36.453,32.517H15.908a.708.708,0,0,1,0-1.417H36.453a.708.708,0,1,1,0,1.417Z",
                transform: "translate(-15.2 -31.1)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16679", "data-name": "Grupo 16679", transform: "translate(14.147 20.091)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40973",
                "data-name": "Trazado 40973",
                d: "M40.26,23.717H15.908a.708.708,0,1,1,0-1.417H40.26a.708.708,0,1,1,0,1.417Z",
                transform: "translate(-15.2 -22.3)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16680", "data-name": "Grupo 16680", transform: "translate(14.147 12.387)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40974",
                "data-name": "Trazado 40974",
                d: "M40.26,15.017H15.908a.708.708,0,1,1,0-1.417H40.26a.708.708,0,1,1,0,1.417Z",
                transform: "translate(-15.2 -13.6)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16681", "data-name": "Grupo 16681", transform: "translate(14.147 35.676)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40975",
                "data-name": "Trazado 40975",
                d: "M31.051,41.317H15.908a.708.708,0,1,1,0-1.417H31.139a.762.762,0,0,1,.708.708A.775.775,0,0,1,31.051,41.317Z",
                transform: "translate(-15.2 -39.9)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16682", "data-name": "Grupo 16682", transform: "translate(14.147 43.468)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40976",
                "data-name": "Trazado 40976",
                d: "M23.347,50.117H15.908a.708.708,0,1,1,0-1.417h7.527a.762.762,0,0,1,.708.708A.781.781,0,0,1,23.347,50.117Z",
                transform: "translate(-15.2 -48.7)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40977",
                "data-name": "Trazado 40977",
                d: "M54.308,31.562l-3.985-3.985a1.259,1.259,0,0,0-.531-.177.749.749,0,0,0-.531.177L36.952,39.886l-.089.177L34.3,46.616c-.089.266,0,.443.177.8a.729.729,0,0,0,.8.177l6.376-2.479A.671.671,0,0,0,42,44.933h.089L54.4,32.536A.805.805,0,0,0,54.308,31.562ZM37.749,41.657l2.479,2.479-3.985,1.505Zm3.719,1.771-3.011-3.011L49.792,29.082,52.8,32.093Z",
                transform: "translate(-3.235 -2.793)",
                fill: "#ee2b7b"
              }
            )
          ]
        }
      )
    ]
  }
), $o = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_30_solicitud_via_web",
    "data-name": "30_solicitud_via_web",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_30_solicitud_via_web-2",
          "data-name": "30_solicitud_via_web",
          transform: "translate(-2.1 -2.5)",
          children: [
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40942",
                "data-name": "Trazado 40942",
                d: "M52.2,29.6a.86.86,0,0,0,.8-.8V19.5a.86.86,0,0,0-.8-.8H43.1a.86.86,0,0,0-.8.8v9.3a.86.86,0,0,0,.8.8h9.1Zm-8.3-9.3h7.5V28H43.9Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40943",
                "data-name": "Trazado 40943",
                d: "M22.8,20.4H38.9a.8.8,0,1,0,0-1.6H22.8a.8.8,0,1,0,0,1.6Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40944",
                "data-name": "Trazado 40944",
                d: "M22.8,24.9H38.9a.8.8,0,1,0,0-1.6H22.8a.8.8,0,1,0,0,1.6Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40945",
                "data-name": "Trazado 40945",
                d: "M38.9,27.9H24a.8.8,0,0,0,0,1.6H38.9a.789.789,0,0,0,.8-.8A.86.86,0,0,0,38.9,27.9Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40946",
                "data-name": "Trazado 40946",
                d: "M55.3,9.5H9.7a2.647,2.647,0,0,0-2.6,2.6V41.3a.86.86,0,0,0,.8.8.86.86,0,0,0,.8-.8V12.1a1,1,0,0,1,1-1H55.3a1,1,0,0,1,1,1V35H32a.789.789,0,0,0-.8.8.86.86,0,0,0,.8.8H56.3v4.7a1,1,0,0,1-1,1H32.5a.8.8,0,1,0,0,1.6h3.8v3.9H32a.8.8,0,1,0,0,1.6h8.7a.8.8,0,0,0,0-1.6H37.9V43.9H55.3a2.582,2.582,0,0,0,2.6-2.6V12.1A2.647,2.647,0,0,0,55.3,9.5Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40947",
                "data-name": "Trazado 40947",
                d: "M16.2,18.6A3.159,3.159,0,0,0,13,21.8v8.1a4.06,4.06,0,0,0-3.2,3.9v6.4a9.21,9.21,0,0,0,3.5,7,.764.764,0,0,0,.5.2.864.864,0,0,0,.6-.3.792.792,0,0,0-.1-1.1,7.808,7.808,0,0,1-2.9-5.8V33.8A2.378,2.378,0,0,1,13,31.6V37a.789.789,0,0,0,.8.8.86.86,0,0,0,.8-.8V21.9a1.6,1.6,0,0,1,3.2,0v8.6a.752.752,0,0,0,.5.7.744.744,0,0,0,.9-.1,1.6,1.6,0,0,1,1.1-.4,1.708,1.708,0,0,1,1.6,1.5.752.752,0,0,0,.5.7.778.778,0,0,0,.8-.2,2.1,2.1,0,0,1,1.1-.4,1.593,1.593,0,0,1,1.5,1.2.664.664,0,0,0,.4.5.638.638,0,0,0,.6,0A1.62,1.62,0,0,1,29,35.5v7.3a4.706,4.706,0,0,1-1.4,3.3.785.785,0,0,0,0,1.1,1.421,1.421,0,0,0,.6.2.6.6,0,0,0,.6-.3,6.465,6.465,0,0,0,1.8-4.4V35.4A3.206,3.206,0,0,0,27,32.2a3.192,3.192,0,0,0-2.8-1.6,4.253,4.253,0,0,0-1.1.2A3.116,3.116,0,0,0,20.2,29a2.2,2.2,0,0,0-.8.1V21.8A3.159,3.159,0,0,0,16.2,18.6Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40948",
                "data-name": "Trazado 40948",
                d: "M28.7,49.1h-17a2.247,2.247,0,0,0-2.4,2v3.6a.86.86,0,0,0,.8.8.86.86,0,0,0,.8-.8V51.1a.827.827,0,0,1,.8-.4h17a.827.827,0,0,1,.8.4v3.6a.8.8,0,0,0,1.6,0V51.1A2.247,2.247,0,0,0,28.7,49.1Z",
                fill: "#ee2b7b"
              }
            )
          ]
        }
      )
    ]
  }
), jo = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_13_subir_documentos",
    "data-name": "13_subir_documentos",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_13_subir_documentos-2",
          "data-name": "13_subir_documentos",
          transform: "translate(-0.598 0.9)",
          children: [
            /* @__PURE__ */ r("g", { id: "Grupo_16582", "data-name": "Grupo 16582", transform: "translate(31.496 25.536)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40862",
                "data-name": "Trazado 40862",
                d: "M43.288,44.634a.783.783,0,0,1-.539-.719V39.69a.809.809,0,0,1,1.618,0v1.977l4.134-5.3-4.134-5.3v1.977a.806.806,0,0,1-.809.809H35.109a.809.809,0,0,1,0-1.618h7.64V28.815a.683.683,0,0,1,.539-.719.912.912,0,0,1,.9.27l5.932,7.55a.97.97,0,0,1,0,.989l-5.932,7.55A.919.919,0,0,1,43.288,44.634Z",
                transform: "translate(-34.3 -28.063)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16583", "data-name": "Grupo 16583", transform: "translate(19.722 37.973)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40863",
                "data-name": "Trazado 40863",
                d: "M38.906,43.518h-16.9a.809.809,0,0,1,0-1.618H38.816a.806.806,0,0,1,.809.809A.792.792,0,0,1,38.906,43.518Z",
                transform: "translate(-21.2 -41.9)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16584", "data-name": "Grupo 16584", transform: "translate(13.071 33.748)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40864",
                "data-name": "Trazado 40864",
                d: "M29.708,38.818h-15.1a.809.809,0,0,1,0-1.618h15.1a.809.809,0,0,1,0,1.618Z",
                transform: "translate(-13.8 -37.2)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r("g", { id: "Grupo_16585", "data-name": "Grupo 16585", transform: "translate(17.205 29.524)", children: /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40865",
                "data-name": "Trazado 40865",
                d: "M25.95,34.118H19.209a.809.809,0,0,1,0-1.618H25.95a.809.809,0,0,1,0,1.618Z",
                transform: "translate(-18.4 -32.5)",
                fill: "#ee2b7b"
              }
            ) }),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40866",
                "data-name": "Trazado 40866",
                d: "M36.8,43.507a.648.648,0,0,0-.719.629V54.2H8.038V13.038h18.6v8a.709.709,0,0,0,.719.719H36.08v5.662a.719.719,0,1,0,1.438,0V20.857a1.277,1.277,0,0,0-.18-.539L28.8,11.78a.964.964,0,0,0-.539-.18H7.319a.773.773,0,0,0-.719.719V54.741s-.09.9.989.9h29.12a.773.773,0,0,0,.719-.719V44.136C37.518,44.136,37.428,43.507,36.8,43.507ZM27.991,13.038l7.28,7.28h-7.28Z",
                transform: "translate(0 -0.86)",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40867",
                "data-name": "Trazado 40867",
                d: "M23,3.909V7.864a.719.719,0,1,0,1.438,0V4.628H44.031v8.359a.709.709,0,0,0,.719.719h9.168V47.859H42.144a.719.719,0,1,0,0,1.438H54.727a.773.773,0,0,0,.719-.719V12.807a1.277,1.277,0,0,0-.18-.539L46.278,3.28a.964.964,0,0,0-.539-.18H23.719A.792.792,0,0,0,23,3.909Zm22.469.719,7.64,7.64h-7.64Z",
                transform: "translate(-1.66 0)",
                fill: "#ee2b7b"
              }
            )
          ]
        }
      )
    ]
  }
), Wo = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_04_subsidio_vivienda",
    "data-name": "04_subsidio_vivienda",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_04_subsidio_vivienda-2",
          "data-name": "04_subsidio_vivienda",
          transform: "translate(-2.831 -2.326)",
          children: [
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41330",
                "data-name": "Trazado 41330",
                d: "M60.738,32.468l-9.163-7.9V11.5a.72.72,0,0,0-.675-.675H42.2a.721.721,0,0,0-.676.675v3.429L33.749,7.791a1.911,1.911,0,0,0-2.5,0l-26.9,24.76a1.742,1.742,0,0,0-.522,1.253,1.921,1.921,0,0,0,.522,1.253l2.09,2.089a1.668,1.668,0,0,0,2.407.107L10.225,36V57.4a.72.72,0,0,0,.675.675H54.1c.418,0,.775-.316.775-.575V36.1l1.372,1.249a1.565,1.565,0,0,0,1.153.423,1.8,1.8,0,0,0,1.253-.624l2.089-2.174a1.764,1.764,0,0,0,0-2.509Zm-3.206,3.8a.192.192,0,0,1-.149.1.4.4,0,0,1-.332-.127l-2.392-2.188s-.005-.01-.008-.013L46.394,26.5,33.652,14.847a1.561,1.561,0,0,0-1.152-.422,1.668,1.668,0,0,0-1.15.52l-23.5,21.2-.017.022a.2.2,0,0,1-.15.1.389.389,0,0,1-.33-.124L5.259,34.053a.3.3,0,0,1-.078-.247.292.292,0,0,1,.076-.244L32.151,8.8l.016-.021a.2.2,0,0,1,.15-.1.4.4,0,0,1,.332.126l9,8.252.018.012a.966.966,0,0,0,.757.1.7.7,0,0,0,.451-.671V12.175h7.25l.033,12.791a.825.825,0,0,0,.226.457l9.286,8.121a.314.314,0,0,1,.091.231.409.409,0,0,1-.092.264l-2.123,2.209ZM32.925,52.125H22.775V36.775H32.924v15.35Zm-13.55,1.351h17.05v3.249H19.375ZM37.1,52.125H34.276V36.1a.721.721,0,0,0-.676-.675H22.1a.72.72,0,0,0-.675.675V52.125H18.7a.72.72,0,0,0-.675.675v3.925h-6.45V34.833l20.66-18.864.015-.014h0l.016-.021a.2.2,0,0,1,.15-.1.393.393,0,0,1,.333.127L53.524,34.874V56.725H37.775V52.8A.721.721,0,0,0,37.1,52.125Z",
                fill: "#ee2b7b"
              }
            ),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_41331",
                "data-name": "Trazado 41331",
                d: "M39.4,44.775h6.9a.6.6,0,0,0,.676-.676V36a.721.721,0,0,0-.676-.675H39.4a.721.721,0,0,0-.676.675v8.1A.724.724,0,0,0,39.4,44.775Zm6.225-8v6.649h-5.55V36.775Z",
                fill: "#ee2b7b"
              }
            )
          ]
        }
      )
    ]
  }
), Uo = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_14_icono_talentos",
    "data-name": "14_icono_talentos",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h("g", { id: "_14_icono_talentos-2", "data-name": "14_icono_talentos", transform: "translate(1.5 1.4)", children: [
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40775",
            "data-name": "Trazado 40775",
            d: "M31.321,28.042a8.221,8.221,0,1,1,8.221-8.221A8.268,8.268,0,0,1,31.321,28.042Zm0-14.868a6.647,6.647,0,1,0,6.647,6.647A6.644,6.644,0,0,0,31.321,13.174Z",
            transform: "translate(-2.834)",
            fill: "#ee2b7b"
          }
        ),
        /* @__PURE__ */ r(
          "circle",
          {
            id: "Elipse_76",
            "data-name": "Elipse 76",
            cx: "4.635",
            cy: "4.635",
            r: "4.635",
            transform: "translate(5.922 18.509)",
            fill: "none"
          }
        ),
        /* @__PURE__ */ r(
          "circle",
          {
            id: "Elipse_77",
            "data-name": "Elipse 77",
            cx: "4.635",
            cy: "4.635",
            r: "4.635",
            transform: "translate(41.781 18.509)",
            fill: "none"
          }
        ),
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40776",
            "data-name": "Trazado 40776",
            d: "M11.122,30.044a6.122,6.122,0,0,0,0-12.244,6.122,6.122,0,0,0,0,12.244Zm0-10.757a4.666,4.666,0,0,1,4.635,4.635,4.635,4.635,0,1,1-9.271,0A4.666,4.666,0,0,1,11.122,19.287Z",
            transform: "translate(-0.564 -0.778)",
            fill: "#ee2b7b"
          }
        ),
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40777",
            "data-name": "Trazado 40777",
            d: "M52.122,30.044a6.122,6.122,0,1,0,0-12.244A6.2,6.2,0,0,0,46,23.922,6.084,6.084,0,0,0,52.122,30.044Zm0-10.757a4.635,4.635,0,1,1-4.635,4.635A4.666,4.666,0,0,1,52.122,19.287Z",
            transform: "translate(-5.706 -0.778)",
            fill: "#ee2b7b"
          }
        ),
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40778",
            "data-name": "Trazado 40778",
            d: "M17.554,34.537A12.638,12.638,0,0,0,10.645,32.7C4.611,32.7.5,35.761.5,40.4v2.886a.787.787,0,1,0,1.574,0V40.4c0-4.2,4.285-6.122,8.571-6.122a11.293,11.293,0,0,1,5.772,1.4l.087-.087A3.989,3.989,0,0,1,17.554,34.537Z",
            transform: "translate(0 -2.646)",
            fill: "#ee2b7b"
          }
        ),
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40779",
            "data-name": "Trazado 40779",
            d: "M52.009,32.7A12.638,12.638,0,0,0,45.1,34.537a11.874,11.874,0,0,1,1.05,1.05l.087.087a11.293,11.293,0,0,1,5.772-1.4c4.285,0,8.571,1.924,8.571,6.122v2.886a.787.787,0,1,0,1.574,0V40.4C62.067,35.761,58.044,32.7,52.009,32.7Z",
            transform: "translate(-5.593 -2.646)",
            fill: "#ee2b7b"
          }
        ),
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_40780",
            "data-name": "Trazado 40780",
            d: "M41.826,36.223a13.451,13.451,0,0,0-1.137-1.05C38.327,33.25,34.829,32.2,30.544,32.2a16.376,16.376,0,0,0-10.058,2.974,13.451,13.451,0,0,0-1.137,1.05,8.8,8.8,0,0,0-2.449,6.21v4.023a.787.787,0,1,0,1.574,0V42.433a7.425,7.425,0,0,1,1.837-4.985,6.48,6.48,0,0,1,1.137-1.05,15.219,15.219,0,0,1,9.008-2.624A14.8,14.8,0,0,1,39.464,36.4a13.45,13.45,0,0,1,1.137,1.05,7.489,7.489,0,0,1,1.924,4.985v4.023a.787.787,0,1,0,1.574,0V42.433A7.976,7.976,0,0,0,41.826,36.223Z",
            transform: "translate(-2.057 -2.584)",
            fill: "#ee2b7b"
          }
        )
      ] })
    ]
  }
), qo = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_27_tasa_bajo_interes",
    "data-name": "27_tasa_bajo_interes",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ r(
        "path",
        {
          id: "_27_tasa_bajo_interes-2",
          "data-name": "27_tasa_bajo_interes",
          d: "M47.293,49.127a1.965,1.965,0,0,1-.4,2.182l-7.934,8.033a2.489,2.489,0,0,1-1.686.694,2.432,2.432,0,0,1-1.587-.6l-8.033-8.033a2.1,2.1,0,0,1-.3-2.182,1.673,1.673,0,0,1,1.488-1.091H32.02V42.979a.793.793,0,0,1,1.587,0V48.83a.757.757,0,0,1-.2.5.594.594,0,0,1-.6.3H28.847l-.1.1a.774.774,0,0,0,0,.5l8.033,7.934a.758.758,0,0,0,.5.2c.2,0,.3-.1.5-.2l7.934-8.033a.443.443,0,0,0,0-.5c0-.1-.1-.2-.3-.2H41.342a.678.678,0,0,1-.694-.694V41.987a.782.782,0,0,1,.793-.793.73.73,0,0,1,.793.793v6.049h3.372A1.737,1.737,0,0,1,47.293,49.127ZM17.839,21.161a.853.853,0,0,0,.793-.793V18.285a.73.73,0,0,0-.793-.793.782.782,0,0,0-.793.793v2.083A.782.782,0,0,0,17.839,21.161Zm11.4-4.364A.782.782,0,0,0,30.037,16V14.12a.793.793,0,1,0-1.587,0V16A.782.782,0,0,0,29.243,16.8Zm0,7.14a.782.782,0,0,0,.793-.793V19.673a.793.793,0,1,0-1.587,0v3.471A.782.782,0,0,0,29.243,23.938Zm-5.454,5.157c.4,0,.694-.4.793-.793v-9.52a.793.793,0,0,0-1.587,0V28.3A.782.782,0,0,0,23.789,29.095Zm0-13.19c.4,0,.694-.3.793-.793v-4.76a.793.793,0,1,0-1.587,0v4.76A.782.782,0,0,0,23.789,15.9Zm0-8.33c.4,0,.694-.4.793-.793V5.293a.793.793,0,1,0-1.587,0V6.781A.782.782,0,0,0,23.789,7.574ZM54.135,26.219A11.259,11.259,0,0,1,42.929,37.425h-.793v.992a.853.853,0,0,1-.793.793.782.782,0,0,1-.793-.793V37.127a10.6,10.6,0,0,1-4.165-1.884.346.346,0,0,0-.1.2L25.673,46.152a2.634,2.634,0,0,1-3.769,0L11.095,35.442a2.536,2.536,0,0,1-.4-2.678,1.906,1.906,0,0,1,1.785-1.289h4.562V23.838a.782.782,0,0,1,.793-.793.73.73,0,0,1,.793.793v8.33a.678.678,0,0,1-.694.694H12.583c-.1,0-.2,0-.4.3-.2.4-.1.893.1.992L22.9,45.061a1.207,1.207,0,0,0,1.587,0L35.194,34.351h0A17.267,17.267,0,0,1,34,32.962H29.144a.678.678,0,0,1-.694-.694V26.615a.793.793,0,1,1,1.587,0v4.859h2.975a10.586,10.586,0,0,1-1.289-5.256,11.206,11.206,0,1,1,22.413,0Zm-1.488,0a9.719,9.719,0,1,0-19.438,0A9.4,9.4,0,0,0,34.8,31.475a9.9,9.9,0,0,0,2.182,2.38,12.058,12.058,0,0,0,3.57,1.785c.5.1,1.091.2,1.587.3h.793A9.735,9.735,0,0,0,52.648,26.219ZM39.656,29.392a3.593,3.593,0,0,0,2.38,2.777c.2.1.2.1.2.3v.6a.707.707,0,0,0,.793.694.766.766,0,0,0,.793-.694v-.5a.458.458,0,0,1,.3-.5A3.339,3.339,0,0,0,46.4,28.4a3.3,3.3,0,0,0-3.273-2.975,1.874,1.874,0,0,1-1.884-2.083,1.922,1.922,0,0,1,1.388-1.587,1.8,1.8,0,0,1,1.983.893,3.778,3.778,0,0,1,.3.992.766.766,0,0,0,.793.694.678.678,0,0,0,.694-.694v-.5a3.281,3.281,0,0,0-2.38-2.777c-.2-.1-.2-.1-.2-.3v-.6a.8.8,0,0,0-1.587,0v.6c0,.2-.1.3-.3.4a3.411,3.411,0,0,0-2.38,3.471,3.607,3.607,0,0,0,2.578,3.074,3.718,3.718,0,0,0,1.091.1A1.679,1.679,0,0,1,44.714,28.4a1.7,1.7,0,0,1-.5,1.884,1.665,1.665,0,0,1-1.884.4A1.944,1.944,0,0,1,41.045,28.9a.758.758,0,0,0-.2-.5.824.824,0,0,0-.793-.2.785.785,0,0,0-.5.793C39.557,29.194,39.557,29.293,39.656,29.392Z",
          transform: "translate(-2.492 -2.5)",
          fill: "#ee2b7b"
        }
      )
    ]
  }
), Yo = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_40_telemedicina",
    "data-name": "40_telemedicina",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h("g", { id: "_40_telemedicina-2", "data-name": "40_telemedicina", transform: "translate(5.624 7.752)", children: [
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41304",
            "data-name": "Trazado 41304",
            d: "M43.777,6.248h-4.3l-4.9-4.7a5.069,5.069,0,0,0-3.3-1.3h-15.8a.645.645,0,0,0-.1.021H5.076A4.711,4.711,0,0,0,.376,5V37.849a5.484,5.484,0,0,0,5.5,5.5h38a5.339,5.339,0,0,0,5.4-5.5v-26.1A5.483,5.483,0,0,0,43.777,6.248Zm-10.4-3.5,3.7,3.5h-5.5l-4.583-4.4h4.188A3.1,3.1,0,0,1,33.376,2.748Zm-10-.9a3.1,3.1,0,0,1,2.2.9l3.6,3.5H23.507L20.752,3.584,18.976,1.848h4.4ZM1.876,5a3.17,3.17,0,0,1,3.2-3.222h10.3a3.092,3.092,0,0,1,2.2.906l3.6,3.524H5.076a4.526,4.526,0,0,0-3.2,1.208V5Zm45.9,32.846a4.012,4.012,0,0,1-4,4H5.877a4.012,4.012,0,0,1-4-4v-26.1a4.012,4.012,0,0,1,4-4h37.9a4.012,4.012,0,0,1,4,4v26.1Z",
            fill: "#ee2b7b"
          }
        ),
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41305",
            "data-name": "Trazado 41305",
            d: "M33.876,20.548h-4.7v-4.7a.789.789,0,0,0-.8-.8h-7a.789.789,0,0,0-.8.8v4.7h-4.7a.789.789,0,0,0-.8.8v6.8a.789.789,0,0,0,.8.8h4.7v4.7a.789.789,0,0,0,.8.8h7a.849.849,0,0,0,.8-.7v-4.7h4.7a.789.789,0,0,0,.8-.8v-6.9A.788.788,0,0,0,33.876,20.548Zm-.8,6.9h-4.7a.789.789,0,0,0-.8.8v4.7h-5.4v-4.6a.789.789,0,0,0-.8-.8h-4.7v-5.4h4.7a.789.789,0,0,0,.8-.8v-4.8h5.4v4.7a.789.789,0,0,0,.8.8h4.7Z",
            fill: "#ee2b7b"
          }
        )
      ] })
    ]
  }
), Ko = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_15_icono_trabajo",
    "data-name": "15_icono_trabajo",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ r(
        "path",
        {
          id: "_15_icono_trabajo-2",
          "data-name": "15_icono_trabajo",
          d: "M57.25,41.465h-7.21L56.8,25.783a.876.876,0,0,0-.09-.811,1.113,1.113,0,0,0-.721-.361H36.61a.9.9,0,0,0-.721.541l-4.777,11a3.593,3.593,0,0,0-2.163-.631H18.854V30.289A5.568,5.568,0,0,0,13.987,24.7a7.523,7.523,0,1,0-4.867-.09H7.678A5.655,5.655,0,0,0,2,30.289V49.667s0,.9.811.811a.729.729,0,0,0,.811-.811V30.379a4.039,4.039,0,0,1,4.056-4.056h5.408a4.039,4.039,0,0,1,4.056,4.056v6.039a.808.808,0,0,0,.811.811H28.859a2.078,2.078,0,0,1,1.8.991h0a1.023,1.023,0,0,1,.27.721v.451a2.193,2.193,0,0,1-2.163,2.163H12.726V33.985a.811.811,0,1,0-1.622,0v8.472a.808.808,0,0,0,.811.811h6.039a6.5,6.5,0,0,1,6.4,5.588l.09.811a.794.794,0,0,0,.811.811.849.849,0,0,0,.9-.9,7.6,7.6,0,0,0-3.245-6.309H40.486v6.4a.808.808,0,0,0,.811.811h.09a.958.958,0,0,0,.9-.811v-6.4H57.25a.917.917,0,0,0,.811-.991A.808.808,0,0,0,57.25,41.465ZM5.785,17.581a5.858,5.858,0,1,1,5.858,5.858A5.847,5.847,0,0,1,5.785,17.581Zm31.546,8.653H54.906l-6.58,15.232H32.194a4.011,4.011,0,0,0,.631-2.073,3.728,3.728,0,0,0-.451-1.712Z",
          transform: "translate(0 -0.1)",
          fill: "#ee2b7b"
        }
      )
    ]
  }
), Xo = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_13_icono_transformacion",
    "data-name": "13_icono_transformacion",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ r(
        "g",
        {
          id: "_13_icono_transformacion-2",
          "data-name": "13_icono_transformacion",
          transform: "translate(0.05 -1.2)",
          children: /* @__PURE__ */ h("g", { id: "Grupo_16537", "data-name": "Grupo 16537", transform: "translate(1.95 6.2)", children: [
            /* @__PURE__ */ h("g", { id: "Grupo_16531", "data-name": "Grupo 16531", children: [
              /* @__PURE__ */ r("g", { id: "Grupo_16527", "data-name": "Grupo 16527", transform: "translate(0 3.303)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40767",
                  "data-name": "Trazado 40767",
                  d: "M9.7,42.1h0a.614.614,0,0,1-.642-.367L2.088,31.087a.688.688,0,0,1,0-.826.817.817,0,0,1,.734-.459H5.85A24.064,24.064,0,0,1,17.5,9.892a.876.876,0,0,1,1.1.275.876.876,0,0,1-.275,1.1A22.358,22.358,0,0,0,7.409,30.628a.822.822,0,0,1-.826.826H4.29L9.7,39.8l5.413-8.35H12.639a.822.822,0,0,1-.826-.826,18.174,18.174,0,0,1,33.031-10.46.789.789,0,0,1-1.285.918,16.66,16.66,0,0,0-13.579-7.065A16.483,16.483,0,0,0,13.465,29.8h3.12a.936.936,0,0,1,.734.459.877.877,0,0,1,0,.826L10.437,41.73C10.162,41.914,9.978,42.1,9.7,42.1Z",
                  transform: "translate(-1.95 -9.8)",
                  fill: "#ee2b7b"
                }
              ) }),
              /* @__PURE__ */ r("g", { id: "Grupo_16528", "data-name": "Grupo 16528", transform: "translate(17.591)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40768",
                  "data-name": "Trazado 40768",
                  d: "M21.928,9.778a.936.936,0,0,1-.734-.459.742.742,0,0,1,.367-1.009A24.643,24.643,0,0,1,31.47,6.2a8.9,8.9,0,0,1,1.56.092.781.781,0,1,1-.092,1.56A22.8,22.8,0,0,0,22.2,9.778Z",
                  transform: "translate(-21.122 -6.2)",
                  fill: "#ee2b7b"
                }
              ) }),
              /* @__PURE__ */ r("g", { id: "Grupo_16529", "data-name": "Grupo 16529", transform: "translate(31.775 0.349)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40769",
                  "data-name": "Trazado 40769",
                  d: "M44.03,10.544a.552.552,0,0,1-.367-.092,22.361,22.361,0,0,0-6.423-2.294.756.756,0,0,1-.642-.918.8.8,0,0,1,.918-.642A23.826,23.826,0,0,1,44.4,9.076a.768.768,0,0,1,.275,1.1A.614.614,0,0,1,44.03,10.544Z",
                  transform: "translate(-36.581 -6.581)",
                  fill: "#ee2b7b"
                }
              ) }),
              /* @__PURE__ */ r("g", { id: "Grupo_16530", "data-name": "Grupo 16530", transform: "translate(40.716 4.152)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40770",
                  "data-name": "Trazado 40770",
                  d: "M50.982,15.84a.654.654,0,0,1-.551-.275,22.089,22.089,0,0,0-3.762-3.395.789.789,0,0,1,.918-1.285,21.3,21.3,0,0,1,4.037,3.578.749.749,0,0,1-.092,1.1A.793.793,0,0,1,50.982,15.84Z",
                  transform: "translate(-46.326 -10.726)",
                  fill: "#ee2b7b"
                }
              ) })
            ] }),
            /* @__PURE__ */ h("g", { id: "Grupo_16536", "data-name": "Grupo 16536", transform: "translate(9.943 12.662)", children: [
              /* @__PURE__ */ r("g", { id: "Grupo_16532", "data-name": "Grupo 16532", transform: "translate(3.156)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40771",
                  "data-name": "Trazado 40771",
                  d: "M43.269,52.3a.614.614,0,0,1-.642-.367.876.876,0,0,1,.275-1.1,22.358,22.358,0,0,0,10.919-19.36.822.822,0,0,1,.826-.826h2.294l-5.413-8.35-5.413,8.35h2.477a.822.822,0,0,1,.826.826,18.174,18.174,0,0,1-33.031,10.46.789.789,0,1,1,1.285-.918A16.66,16.66,0,0,0,31.25,48.076,16.483,16.483,0,0,0,47.765,32.295h-3.12a.936.936,0,0,1-.734-.459.877.877,0,0,1,0-.826l6.881-10.643A.929.929,0,0,1,51.435,20h0a.614.614,0,0,1,.642.367L59.051,31.01a.688.688,0,0,1,0,.826.817.817,0,0,1-.734.459H55.289a24.064,24.064,0,0,1-11.653,19.91A.552.552,0,0,1,43.269,52.3Z",
                  transform: "translate(-16.226 -20)",
                  fill: "#ee2b7b"
                }
              ) }),
              /* @__PURE__ */ r("g", { id: "Grupo_16533", "data-name": "Grupo 16533", transform: "translate(15.794 32.042)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40772",
                  "data-name": "Trazado 40772",
                  d: "M32.294,58.572a8.9,8.9,0,0,1-1.56-.092.781.781,0,0,1,.092-1.56,22.8,22.8,0,0,0,10.735-1.927.771.771,0,0,1,1.009.367A.742.742,0,0,1,42.2,56.37,22.99,22.99,0,0,1,32.294,58.572Z",
                  transform: "translate(-30 -54.922)",
                  fill: "#ee2b7b"
                }
              ) }),
              /* @__PURE__ */ r("g", { id: "Grupo_16534", "data-name": "Grupo 16534", transform: "translate(6.119 31.247)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40773",
                  "data-name": "Trazado 40773",
                  d: "M26.928,58.042h-.184a23.826,23.826,0,0,1-6.881-2.477.8.8,0,0,1,.826-1.376,22.361,22.361,0,0,0,6.423,2.294.756.756,0,0,1,.642.918A.98.98,0,0,1,26.928,58.042Z",
                  transform: "translate(-19.456 -54.056)",
                  fill: "#ee2b7b"
                }
              ) }),
              /* @__PURE__ */ r("g", { id: "Grupo_16535", "data-name": "Grupo 16535", transform: "translate(0 26.412)", children: /* @__PURE__ */ r(
                "path",
                {
                  id: "Trazado_40774",
                  "data-name": "Trazado 40774",
                  d: "M17.478,53.845c-.184,0-.275-.092-.459-.184a21.3,21.3,0,0,1-4.037-3.578.781.781,0,0,1,1.193-1.009,22.088,22.088,0,0,0,3.762,3.395.762.762,0,0,1,.184,1.1A1.943,1.943,0,0,1,17.478,53.845Z",
                  transform: "translate(-12.786 -48.786)",
                  fill: "#ee2b7b"
                }
              ) })
            ] })
          ] })
        }
      )
    ]
  }
), Qo = ({
  width: t = "60",
  height: e = "60"
}) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_26_traspaso_cuotas",
    "data-name": "26_traspaso_cuotas",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h(
        "g",
        {
          id: "_26_traspaso_cuotas-2",
          "data-name": "26_traspaso_cuotas",
          transform: "translate(-1.55 -1.532)",
          children: [
            /* @__PURE__ */ r("g", { id: "Grupo_16662", "data-name": "Grupo 16662", transform: "translate(3.55 7.532)", children: /* @__PURE__ */ r("g", { id: "Grupo_16661", "data-name": "Grupo 16661", children: /* @__PURE__ */ h("g", { id: "Grupo_16660", "data-name": "Grupo 16660", children: [
              /* @__PURE__ */ h("g", { id: "Grupo_16654", "data-name": "Grupo 16654", children: [
                /* @__PURE__ */ r("g", { id: "Grupo_16650", "data-name": "Grupo 16650", transform: "translate(0 3.307)", children: /* @__PURE__ */ r(
                  "path",
                  {
                    id: "Trazado_40929",
                    "data-name": "Trazado 40929",
                    d: "M11.228,42.762h0a.639.639,0,0,1-.668-.382l-6.868-10.4a.715.715,0,0,1,0-.858.85.85,0,0,1,.763-.477H7.413A23.442,23.442,0,0,1,18.954,11.1a.91.91,0,0,1,1.145.286.91.91,0,0,1-.286,1.145A22.123,22.123,0,0,0,9.13,31.507a.855.855,0,0,1-.858.858H5.982l5.246,8.107,5.246-8.107H14.09a.855.855,0,0,1-.858-.858,17.939,17.939,0,0,1,32.621-10.3.821.821,0,1,1-1.335.954,16.252,16.252,0,0,0-29.569,8.489H18a.973.973,0,0,1,.763.477.912.912,0,0,1,0,.858L11.991,42.476A1.522,1.522,0,0,1,11.228,42.762Z",
                    transform: "translate(-3.55 -11)",
                    fill: "#ee2b7b"
                  }
                ) }),
                /* @__PURE__ */ r("g", { id: "Grupo_16651", "data-name": "Grupo 16651", transform: "translate(17.332)", children: /* @__PURE__ */ r(
                  "path",
                  {
                    id: "Trazado_40930",
                    "data-name": "Trazado 40930",
                    d: "M22.559,11.126a.973.973,0,0,1-.763-.477A.8.8,0,0,1,22.178,9.6a23.519,23.519,0,0,1,11.35-2,.779.779,0,0,1,.763.858.835.835,0,0,1-.858.763H32a22.7,22.7,0,0,0-9.061,1.908Z",
                    transform: "translate(-21.722 -7.533)",
                    fill: "#ee2b7b"
                  }
                ) }),
                /* @__PURE__ */ r("g", { id: "Grupo_16652", "data-name": "Grupo 16652", transform: "translate(31.219 0.332)", children: /* @__PURE__ */ r(
                  "path",
                  {
                    id: "Trazado_40931",
                    "data-name": "Trazado 40931",
                    d: "M43.644,11.905a.573.573,0,0,1-.382-.1,24.916,24.916,0,0,0-6.3-2.289.786.786,0,0,1-.668-.954.831.831,0,0,1,.954-.668,23.842,23.842,0,0,1,6.772,2.385.8.8,0,0,1,.286,1.145A.61.61,0,0,1,43.644,11.905Z",
                    transform: "translate(-36.281 -7.881)",
                    fill: "#ee2b7b"
                  }
                ) }),
                /* @__PURE__ */ r("g", { id: "Grupo_16653", "data-name": "Grupo 16653", transform: "translate(40.037 4.095)", children: /* @__PURE__ */ r(
                  "path",
                  {
                    id: "Trazado_40932",
                    "data-name": "Trazado 40932",
                    d: "M50.175,16.952a.68.68,0,0,1-.572-.286,24.528,24.528,0,0,0-3.72-3.338.821.821,0,1,1,.954-1.335,27.94,27.94,0,0,1,4.006,3.529.779.779,0,0,1-.1,1.145A.824.824,0,0,1,50.175,16.952Z",
                    transform: "translate(-45.526 -11.826)",
                    fill: "#ee2b7b"
                  }
                ) })
              ] }),
              /* @__PURE__ */ h("g", { id: "Grupo_16659", "data-name": "Grupo 16659", transform: "translate(9.763 12.464)", children: [
                /* @__PURE__ */ r("g", { id: "Grupo_16655", "data-name": "Grupo 16655", transform: "translate(3.09)", children: /* @__PURE__ */ r(
                  "path",
                  {
                    id: "Trazado_40933",
                    "data-name": "Trazado 40933",
                    d: "M43.708,52.458a.639.639,0,0,1-.668-.382.91.91,0,0,1,.286-1.145A22.123,22.123,0,0,0,54.01,31.95a.855.855,0,0,1,.858-.858h2.194l-5.246-8.107L46.57,31.092h2.385a.855.855,0,0,1,.858.858,17.939,17.939,0,0,1-32.621,10.3.821.821,0,1,1,1.335-.954A16.252,16.252,0,0,0,48.1,32.809H45.044a.973.973,0,0,1-.763-.477.912.912,0,0,1,0-.858l6.772-10.492a.965.965,0,0,1,.668-.382h0a.639.639,0,0,1,.668.382L59.16,31.474a.715.715,0,0,1,0,.858.85.85,0,0,1-.763.477H55.44A23.442,23.442,0,0,1,43.9,52.362C43.994,52.458,43.8,52.458,43.708,52.458Z",
                    transform: "translate(-17.026 -20.6)",
                    fill: "#ee2b7b"
                  }
                ) }),
                /* @__PURE__ */ r("g", { id: "Grupo_16656", "data-name": "Grupo 16656", transform: "translate(15.561 31.497)", children: /* @__PURE__ */ r(
                  "path",
                  {
                    id: "Trazado_40934",
                    "data-name": "Trazado 40934",
                    d: "M32.389,57.321a8.205,8.205,0,0,1-1.526-.1.812.812,0,0,1,.1-1.622A21.9,21.9,0,0,0,41.45,53.7a.789.789,0,0,1,.668,1.431A21.377,21.377,0,0,1,32.389,57.321Z",
                    transform: "translate(-30.1 -53.622)",
                    fill: "#ee2b7b"
                  }
                ) }),
                /* @__PURE__ */ r("g", { id: "Grupo_16657", "data-name": "Grupo 16657", transform: "translate(5.98 30.766)", children: /* @__PURE__ */ r(
                  "path",
                  {
                    id: "Trazado_40935",
                    "data-name": "Trazado 40935",
                    d: "M27.442,56.809h-.191a23.842,23.842,0,0,1-6.772-2.385.779.779,0,0,1-.286-1.145.8.8,0,0,1,1.145-.286,24.916,24.916,0,0,0,6.3,2.289.786.786,0,0,1,.668.954A.834.834,0,0,1,27.442,56.809Z",
                    transform: "translate(-20.056 -52.856)",
                    fill: "#ee2b7b"
                  }
                ) }),
                /* @__PURE__ */ r("g", { id: "Grupo_16658", "data-name": "Grupo 16658", transform: "translate(0 25.931)", children: /* @__PURE__ */ r(
                  "path",
                  {
                    id: "Trazado_40936",
                    "data-name": "Trazado 40936",
                    d: "M18.473,52.855c-.191,0-.286-.1-.477-.191a27.94,27.94,0,0,1-4.006-3.529.812.812,0,0,1,1.24-1.049,24.528,24.528,0,0,0,3.72,3.338.792.792,0,0,1,.191,1.145A1.03,1.03,0,0,1,18.473,52.855Z",
                    transform: "translate(-13.786 -47.786)",
                    fill: "#ee2b7b"
                  }
                ) })
              ] })
            ] }) }) }),
            /* @__PURE__ */ r(
              "path",
              {
                id: "Trazado_40937",
                "data-name": "Trazado 40937",
                d: "M27.811,36.216A4.472,4.472,0,0,0,31,39.9a.339.339,0,0,1,.274.385c-.012.271-.009.541,0,.812a1.022,1.022,0,0,0,2.042.009,4.709,4.709,0,0,0,0-.656c-.035-.332.08-.49.415-.6a4.475,4.475,0,0,0,3.057-4.876,4.529,4.529,0,0,0-4.426-3.942,2.464,2.464,0,0,1-.576-4.871,2.474,2.474,0,0,1,2.656,1.207,3.208,3.208,0,0,1,.337,1.319,1,1,0,0,0,1.053.9.994.994,0,0,0,.982-.94,3.368,3.368,0,0,0-.032-.714,4.456,4.456,0,0,0-3.176-3.7.352.352,0,0,1-.287-.406c.014-.271.01-.541,0-.812a1,1,0,0,0-1.019-.97.991.991,0,0,0-1.021.964,5.942,5.942,0,0,0,0,.749c.025.292-.092.413-.371.5a4.544,4.544,0,0,0-3.134,4.661,4.6,4.6,0,0,0,3.484,4.056c.461.114.931.081,1.394.157A2.352,2.352,0,0,1,34.626,34.8a2.45,2.45,0,0,1-3.118,3.089,2.422,2.422,0,0,1-1.676-2.328,1.073,1.073,0,0,0-.292-.7,1.026,1.026,0,0,0-1.122-.241,1.059,1.059,0,0,0-.648,1.105A3.475,3.475,0,0,0,27.811,36.216Z",
                transform: "translate(-1.118 -0.671)",
                fill: "#ee2b7b"
              }
            )
          ]
        }
      )
    ]
  }
), Jo = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_01_icono_vacunacion",
    "data-name": "01_icono_vacunacion",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ r(
        "path",
        {
          id: "_01_icono_vacunacion-2",
          "data-name": "01_icono_vacunacion",
          d: "M59.435,3.793a.886.886,0,0,0-1.165,0l-9.711,9.614-1.36-1.36a1.993,1.993,0,0,0-2.816,0L42.83,13.6a2.032,2.032,0,0,0-.388.583,8.717,8.717,0,0,0-7.866,2.331L13.794,37.3l-1.845-1.845a.837.837,0,0,0-1.262.1.877.877,0,0,0,0,1.165l4.273,4.176L9.812,46.036,8.744,44.968a3.168,3.168,0,0,0-4.37,0A3.421,3.421,0,0,0,3.5,47.2a3.076,3.076,0,0,0,.874,2.234l9.517,9.517a3.421,3.421,0,0,0,2.234.874,3.013,3.013,0,0,0,2.136-.874,3.241,3.241,0,0,0,.874-2.234,3.076,3.076,0,0,0-.874-2.234l-.971-.971,5.05-5.05,4.176,4.273a.821.821,0,0,0,.583.194.93.93,0,0,0,.874-.874,1.049,1.049,0,0,0-.291-.68l-1.748-1.748L46.714,28.848a8.639,8.639,0,0,0,2.331-7.866,2.031,2.031,0,0,0,.583-.388l1.554-1.554a1.993,1.993,0,0,0,0-2.816l-1.36-1.554,9.711-9.711C59.824,4.765,59.727,4.085,59.435,3.793ZM17.1,57.69a1.3,1.3,0,0,1-1.942,0L5.636,48.173a1.408,1.408,0,0,1,0-1.942,1.477,1.477,0,0,1,1.942,0L17.1,55.747a1.408,1.408,0,0,1,0,1.942Zm-.971-5.341L10.977,47.2l5.05-5.05L21.174,47.3ZM14.959,38.462,29.525,23.9,39.431,33.8,36.712,36.52,34.09,33.8a1.028,1.028,0,0,0-1.262.1.692.692,0,0,0-.291.583.839.839,0,0,0,.291.583l2.719,2.719L32.827,40.5l-2.719-2.719a1.028,1.028,0,0,0-1.262.1.886.886,0,0,0,0,1.165l2.719,2.719-2.719,2.719-2.622-2.622a1.8,1.8,0,0,0-.68-.194.874.874,0,0,0-.68,1.457l2.719,2.719-2.719,2.719ZM45.646,27.585l-.971.971-2.622-2.622a1.8,1.8,0,0,0-.68-.194.874.874,0,0,0-.68,1.457l2.622,2.719L40.79,32.441l-10-9.808,4.953-4.953a7.036,7.036,0,0,1,6.409-1.845l5.341,5.341A7.036,7.036,0,0,1,45.646,27.585Zm4.467-9.808-1.554,1.554a.3.3,0,0,1-.388,0l-4.079-4.079a.3.3,0,0,1,0-.388l1.554-1.554c.1-.1.1-.1.194-.1a.3.3,0,0,1,.194.1l4.079,4.079A.3.3,0,0,1,50.113,17.777Z",
          transform: "translate(-1.5 -1.575)",
          fill: "#ee2b7b"
        }
      )
    ]
  }
), e6 = ({ width: t = "60", height: e = "60" }) => /* @__PURE__ */ h(
  "svg",
  {
    "aria-hidden": !0,
    focusable: "false",
    id: "_20_plan_ahorro",
    "data-name": "20_plan_ahorro",
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: e,
    viewBox: "0 0 60 60",
    children: [
      /* @__PURE__ */ r("path", { id: "Trazado_356", "data-name": "Trazado 356", d: "M0,0H60V60H0Z", fill: "rgba(0,0,0,0)" }),
      /* @__PURE__ */ h("g", { id: "_20_plan_ahorro-2", "data-name": "20_plan_ahorro", transform: "translate(1.534 5.605)", children: [
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41217",
            "data-name": "Trazado 41217",
            d: "M61.066,14.766l-.913.888c-.248.181-.3.238-.541.238a1.013,1.013,0,0,1-.668-.243l-.526-.607V25.672c0,.285-.127.425-.37.425h-5.36l-.812-.789h5.786V14.44L47.341,5.028a.184.184,0,0,0-.243,0l-6.862,6.227h-.673a3.186,3.186,0,0,0-.462.036l7.39-6.809a.914.914,0,0,1,.668-.243.87.87,0,0,1,.607.243l11.6,10.625a.184.184,0,0,0,.243,0l.907-.85c.061-.061.182-.182.121-.243l-4.493-4.25a.414.414,0,0,1-.121-.315V3.207H52.336V5.332c0,.121.044.3-.077.364a.359.359,0,0,1-.425-.061L47.341,1.324a.222.222,0,0,0-.182-.061c-.061,0-.061,0-.121.061L36.885,10.967l-.522-.5,8.065-7.628L46.553.778A.94.94,0,0,1,47.828.85l3.825,3.643V2.842a.35.35,0,0,1,.364-.364h4.311a.35.35,0,0,1,.364.364V9.278L61,13.467C61.659,14.125,61.248,14.584,61.066,14.766ZM50.143,19.114V15.046a.35.35,0,0,1,.364-.364h3.461a.35.35,0,0,1,.364.364v4.068a.327.327,0,0,1-.364.364H50.507A.349.349,0,0,1,50.143,19.114Zm.668-.349H53.69V15.41H50.811Z",
            transform: "translate(-4.178 -0.02)",
            fill: "#ee2b7b",
            stroke: "#ee2b7b",
            strokeMiterlimit: "10",
            strokeWidth: t
          }
        ),
        /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41218",
            "data-name": "Trazado 41218",
            d: "M11.011,32.315a1.12,1.12,0,0,0-.329.9,1.72,1.72,0,0,0,.329.9l1.15,1.15a1.27,1.27,0,0,0,1.724.082l.821-.739V48.9a.473.473,0,0,0,.492.492H44.613c.329,0,.5-.19.5-.574V34.442l.71.821a1.367,1.367,0,0,0,.9.329c.329,0,.395-.076.732-.321l1.234-1.2c.247-.247.8-.868-.085-1.755L42.78,26.652v-8.7a.473.473,0,0,0-.492-.492H36.46a.473.473,0,0,0-.492.492v2.232L30.8,15.257a1.272,1.272,0,0,0-1.724-.1L26.2,17.95ZM21.026,48.322V46.141h11.41v2.182Zm2.361-3.139V34.923h6.859V45.185Zm20.542,3.139H33.5V45.778a.549.549,0,0,0-.492-.574H31.2V34.45a.473.473,0,0,0-.492-.492h-7.8a.473.473,0,0,0-.492.492V45.2H20.7a.473.473,0,0,0-.492.492V48.24H15.787V33.629L29.81,20.9a.25.25,0,0,1,.329,0L44.094,33.629V48.322Zm4.022-14.94-1.226,1.15a.25.25,0,0,1-.329,0L30.712,20.166a1.175,1.175,0,0,0-.821-.329,1.234,1.234,0,0,0-.9.329L13.309,34.614a.25.25,0,0,1-.329,0l-1.272-1.272a.255.255,0,0,1-.082-.164c0-.082,0-.082.082-.164L29.726,15.9c.082-.082.082-.082.164-.082a.3.3,0,0,1,.247.082l6.075,5.828a.486.486,0,0,0,.574.082c.164-.082.1-.329.1-.492V18.442h4.985v8.44a.56.56,0,0,0,.164.425l6.075,5.746C48.2,33.136,48.033,33.3,47.951,33.382Zm-13.533,7.06H39.1a.442.442,0,0,0,.492-.492v-5.5a.473.473,0,0,0-.492-.492H34.418a.473.473,0,0,0-.492.492v5.5A.473.473,0,0,0,34.418,40.442Zm.411-5.5h3.892v4.536H34.828Z",
            transform: "translate(-1.189 -1.685)",
            fill: "#ee2b7b"
          }
        ),
        /* @__PURE__ */ r("g", { id: "Grupo_16831", "data-name": "Grupo 16831", transform: "translate(0.466 0.394)", children: /* @__PURE__ */ r(
          "path",
          {
            id: "Trazado_41219",
            "data-name": "Trazado 41219",
            d: "M8.133,26.23l.844-.8H8.206V23.8h2.5l.756-.716H9.974V15.4h5.133v4.23l.717-.679V15.048a.354.354,0,0,0-.368-.368H9.619a.354.354,0,0,0-.368.368V23.1H7.961a.354.354,0,0,0-.368.368v1.9H4.286V14.435L14.78,4.912a.186.186,0,0,1,.246,0l7.966,7.262.156-.148.33-.321L15.456,4.358a.879.879,0,0,0-.614-.246.927.927,0,0,0-.676.246L2.432,15.172a.186.186,0,0,1-.246,0l-.953-.953a.19.19,0,0,1-.062-.123c0-.062,0-.062.062-.123L14.719,1.165c.062-.062.062-.062.123-.062a.225.225,0,0,1,.185.062l4.546,4.361a.365.365,0,0,0,.43.062c.123-.062.078-.246.078-.368V3.07h3.731V9.387a.419.419,0,0,0,.123.318l.813.769.519-.5-.778-.756V2.7a.354.354,0,0,0-.368-.368H19.757a.354.354,0,0,0-.368.368V4.372L15.517.686a.951.951,0,0,0-1.29-.073L12.078,2.7.712,13.452a.838.838,0,0,0-.246.676,1.291,1.291,0,0,0,.246.676l.86.86a.951.951,0,0,0,1.29.062l.614-.553v10.69a.354.354,0,0,0,.368.368H8.133Z",
            transform: "translate(-0.466 -0.394)",
            fill: "#ee2b7b",
            stroke: "#ee2b7b",
            strokeMiterlimit: "10",
            strokeWidth: t
          }
        ) })
      ] })
    ]
  }
), w2 = {
  defaultProps: { disableRipple: !0 },
  styleOverrides: {
    root: ({ theme: t }) => ({
      textTransform: "none",
      borderRadius: 99,
      boxShadow: "none",
      fontWeight: "bold",
      borderWidth: t.spacing(0.25)
    }),
    outlined: ({ theme: t, ownerState: { color: e = "primary" } }) => ({
      borderColor: t.palette[e].main,
      color: t.palette[e].main,
      "&:hover": {
        backgroundColor: t.palette[e].light,
        borderColor: t.palette[e].light,
        borderWidth: t.spacing(0.25),
        color: t.palette.common.white,
        boxShadow: "none"
      },
      "&:disabled": {
        borderWidth: t.spacing(0.25),
        color: t.palette.secondary[700],
        borderColor: t.palette.secondary[400]
      }
    }),
    contained: ({ theme: t, ownerState: { color: e = "primary" } }) => ({
      "&:hover": {
        backgroundColor: t.palette[e].light,
        boxShadow: "none"
      },
      "&:disabled": {
        backgroundColor: t.palette.secondary[400],
        color: t.palette.secondary[700]
      }
    }),
    sizeSmall: ({ theme: t }) => ({
      padding: `${t.spacing(1.5)} ${t.spacing(6)}`,
      fontSize: t.typography.fontSize
    }),
    sizeMedium: ({ theme: t }) => ({
      padding: `${t.spacing(2)} ${t.spacing(6.5)}`,
      fontSize: t.typography.fontSize
    }),
    sizeLarge: ({ theme: t }) => ({
      padding: `${t.spacing(2.5)} ${t.spacing(10.5)}`,
      fontSize: t.typography.htmlFontSize
    })
  }
}, T2 = {
  styleOverrides: {
    root: ({ theme: t }) => ({
      "& .MuiInputBase-root": {
        color: t.palette.typography.light,
        "&:hover:not(.Mui-focused):not(.Mui-disabled)": {
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: `${t.palette.typography.light} !important`
          }
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: t.palette.typography.light
        }
      },
      "& .MuiInputBase-input": {
        padding: `${t.spacing(1.5)} ${t.spacing(1.75)}`
      },
      "& .MuiInputBase-multiline": {
        padding: 0
      },
      "& .Mui-disabled": {
        backgroundColor: t.palette.surfaces.main,
        borderRadius: t.spacing(0.5),
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: t.palette.surfaces.dark
        }
      }
    })
  }
}, S2 = {
  styleOverrides: {
    root: ({ theme: t }) => ({
      color: t.palette.typography.main,
      marginBottom: t.spacing(1)
    }),
    sizeSmall: ({ theme: t }) => ({
      fontSize: t.typography.fontSize,
      lineHeight: t.spacing(4),
      "&:focus": {
        fontSize: Math.round(t.typography.fontSize * 1.142),
        lineHeight: t.spacing(3)
      }
    }),
    // El shrink es el label que se pone arriba del input cuando este tiene contenido
    shrink: ({ theme: t }) => ({
      fontSize: Math.round(t.typography.fontSize * 1.142),
      lineHeight: t.spacing(3)
    })
  }
}, M2 = {
  styleOverrides: {
    root: ({ theme: t, ownerState: { color: e = "primary" } }) => ({
      color: t.palette.typography.light,
      "&:hover": {
        backgroundColor: "transparent",
        color: t.palette[e].light
      }
    })
  }
}, A2 = {
  styleOverrides: {
    label: ({ theme: t }) => ({
      fontSize: t.typography.fontSize,
      color: t.palette.typography.main
    })
  }
}, z2 = {
  styleOverrides: {
    root: ({ theme: t, ownerState: { color: e = "primary" } }) => ({
      color: t.palette.typography.light,
      "&:hover": {
        backgroundColor: "transparent",
        color: t.palette[e].light
      }
    })
  }
}, x2 = {
  styleOverrides: {
    sizeMedium: ({ theme: t, ownerState: { color: e = "primary" } }) => ({
      padding: t.spacing(0),
      marginRight: t.spacing(2),
      alignItems: "center",
      justifyContent: "center",
      "& .MuiSwitch-thumb": {
        width: t.spacing(3.5),
        height: t.spacing(3.5),
        backgroundColor: t.palette.mode === "light" ? t.palette.common.white : t.palette.secondary[200],
        boxShadow: "none"
      },
      "& .MuiSwitch-track": {
        width: t.spacing(6.5),
        height: t.spacing(4),
        borderRadius: t.spacing(20),
        border: `${t.spacing(0.125)} solid ${t.palette.secondary[500]}`,
        backgroundColor: t.palette.mode === "light" ? t.palette.secondary[400] : t.palette.secondary[900],
        opacity: 1
      },
      "& .MuiSwitch-switchBase": {
        padding: t.spacing(0),
        margin: t.spacing(0.625),
        marginLeft: t.spacing(0.65)
      },
      "& .Mui-checked": {
        "& + .MuiSwitch-track": {
          opacity: "1 !important",
          border: `${t.spacing(0.125)} solid ${t.palette[e].main}`
        }
      },
      "& :hover": {
        "& + .MuiSwitch-track": {
          backgroundColor: `${t.palette[e].light} !important`,
          border: `${t.spacing(0.125)} solid ${t.palette[e].light}`,
          opacity: 1
        }
      },
      "& .Mui-disabled": {
        "& + .MuiSwitch-track": {
          backgroundColor: `${t.palette.secondary[200]}`,
          border: `${t.spacing(0.125)} solid ${t.palette.secondary[400]}`,
          opacity: "1 !important"
        },
        "& .MuiSwitch-thumb": {
          backgroundColor: `${t.palette.secondary[400]}`
        }
      }
    })
  }
}, P2 = {
  defaultProps: { disableRipple: !0, disableFocusRipple: !1 },
  styleOverrides: {
    root: ({ theme: t }) => ({
      textTransform: "none",
      borderRadius: 99,
      boxShadow: "none",
      fontWeight: "bold",
      borderWidth: t.spacing(0.25)
    })
  }
}, $1 = (t, e) => ({
  small: {
    width: t.spacing(4),
    height: t.spacing(4),
    fontSize: t.typography.fontSize
  },
  medium: {
    width: t.spacing(8),
    height: t.spacing(8),
    fontSize: Math.round(t.typography.fontSize * 1.571)
  },
  large: {
    width: t.spacing(12),
    height: t.spacing(12),
    fontSize: Math.round(t.typography.fontSize * 2.285)
  },
  xlarge: {
    width: t.spacing(16),
    height: t.spacing(16),
    fontSize: Math.round(t.typography.fontSize * 3.214)
  }
})[e], Z2 = {
  styleOverrides: {
    root: ({ theme: t, ownerState: { size: e = "medium" } }) => ({
      backgroundColor: t.palette.primary.main,
      fontWeight: t.typography.fontWeightBold,
      width: $1(t, e).width,
      height: $1(t, e).height,
      fontSize: $1(t, e).fontSize,
      color: t.palette.common.white
    }),
    fallback: ({ theme: t }) => ({
      color: t.palette.common.white
    })
  }
}, C2 = {
  defaultProps: {
    inputProps: {
      sx: {
        borderColor: "typography.light",
        color: "typography.main"
      }
    },
    MenuProps: {
      sx: {
        "& .MuiListSubheader-root": {
          color: "typography.main"
        },
        "& .MuiMenu-paper": {
          backgroundColor: "surfaces.light",
          color: "typography.light"
        },
        "& .MuiMenuItem-root": {
          color: "typography.light"
        },
        "& .MuiMenuItem-root:hover": {
          backgroundColor: "surfaces.main",
          color: "typography.white"
        },
        "& .Mui-selected": {
          backgroundColor: "primary.main",
          color: "typography.light"
        }
      }
    }
  },
  styleOverrides: {
    root: ({ theme: t }) => ({
      color: t.palette.typography.main,
      borderColor: t.palette.surfaces.light,
      "& .MuiInputBase-root": {
        color: "typography.main"
      },
      "&:hover:not(.Mui-focused):not(.Mui-disabled)": {
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: `${t.palette.typography.light} !important`
        }
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: t.palette.typography.light
      },
      "& .MuiSelect-select": {
        padding: `${t.spacing(1.5)} ${t.spacing(1.75)}`
      },
      "& .Mui-selected": {
        backgroundColor: "primary.main",
        color: "typography.light"
      },
      "& .Mui-disabled": {
        backgroundColor: t.palette.surfaces.main,
        borderRadius: t.spacing(0.5),
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: t.palette.surfaces.dark
        }
      }
    }),
    [`.${Ut.multiple}`]: ({ theme: t }) => ({
      backgroundColor: t.palette.primary.main,
      color: t.palette.typography.light
    }),
    icon: ({ theme: t }) => ({
      color: t.palette.typography.light
    })
  }
};
var Va = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, Ne = d0.createContext && /* @__PURE__ */ d0.createContext(Va), V2 = ["attr", "size", "title"];
function O2(t, e) {
  if (t == null) return {};
  var a = E2(t, e), i, n;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (n = 0; n < o.length; n++)
      i = o[n], !(e.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(t, i) && (a[i] = t[i]);
  }
  return a;
}
function E2(t, e) {
  if (t == null) return {};
  var a = {};
  for (var i in t)
    if (Object.prototype.hasOwnProperty.call(t, i)) {
      if (e.indexOf(i) >= 0) continue;
      a[i] = t[i];
    }
  return a;
}
function b1() {
  return b1 = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var a = arguments[e];
      for (var i in a)
        Object.prototype.hasOwnProperty.call(a, i) && (t[i] = a[i]);
    }
    return t;
  }, b1.apply(this, arguments);
}
function Ge(t, e) {
  var a = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(t, n).enumerable;
    })), a.push.apply(a, i);
  }
  return a;
}
function y1(t) {
  for (var e = 1; e < arguments.length; e++) {
    var a = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Ge(Object(a), !0).forEach(function(i) {
      H2(t, i, a[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(a)) : Ge(Object(a)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(a, i));
    });
  }
  return t;
}
function H2(t, e, a) {
  return e = L2(e), e in t ? Object.defineProperty(t, e, { value: a, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = a, t;
}
function L2(t) {
  var e = k2(t, "string");
  return typeof e == "symbol" ? e : e + "";
}
function k2(t, e) {
  if (typeof t != "object" || !t) return t;
  var a = t[Symbol.toPrimitive];
  if (a !== void 0) {
    var i = a.call(t, e || "default");
    if (typeof i != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function Oa(t) {
  return t && t.map((e, a) => /* @__PURE__ */ d0.createElement(e.tag, y1({
    key: a
  }, e.attr), Oa(e.child)));
}
function b0(t) {
  return (e) => /* @__PURE__ */ d0.createElement(N2, b1({
    attr: y1({}, t.attr)
  }, e), Oa(t.child));
}
function N2(t) {
  var e = (a) => {
    var {
      attr: i,
      size: n,
      title: o
    } = t, d = O2(t, V2), s = n || a.size || "1em", c;
    return a.className && (c = a.className), t.className && (c = (c ? c + " " : "") + t.className), /* @__PURE__ */ d0.createElement("svg", b1({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, a.attr, i, d, {
      className: c,
      style: y1(y1({
        color: t.color || a.color
      }, a.style), t.style),
      height: s,
      width: s,
      xmlns: "http://www.w3.org/2000/svg"
    }), o && /* @__PURE__ */ d0.createElement("title", null, o), t.children);
  };
  return Ne !== void 0 ? /* @__PURE__ */ d0.createElement(Ne.Consumer, null, (a) => e(a)) : e(Va);
}
function G2(t) {
  return b0({ tag: "svg", attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 10.5858L14.8284 7.75736L16.2426 9.17157L13.4142 12L16.2426 14.8284L14.8284 16.2426L12 13.4142L9.17157 16.2426L7.75736 14.8284L10.5858 12L7.75736 9.17157L9.17157 7.75736L12 10.5858Z" }, child: [] }] })(t);
}
const I2 = {
  defaultProps: {
    deleteIcon: /* @__PURE__ */ r(G2, {})
  },
  styleOverrides: {
    root: ({ theme: t, ownerState: { color: e = "primary" } }) => ({
      backgroundColor: t.palette[e].main,
      borderRadius: t.spacing(1),
      height: "auto",
      padding: `${t.spacing(0.75)} ${t.spacing(1.125)}`
    }),
    label: ({ theme: t }) => ({
      fontSize: t.typography.fontSize,
      color: t.palette.common.white,
      padding: 0
    }),
    deleteIcon: ({ theme: t }) => ({
      color: t.palette.common.white,
      fontSize: Math.round(t.typography.fontSize * 1.285),
      marginLeft: t.spacing(1),
      marginRight: 0,
      "&:hover": {
        color: t.palette.common.white
      }
    }),
    icon: ({ theme: t }) => ({
      color: t.palette.common.white,
      fontSize: t.typography.htmlFontSize,
      marginRight: t.spacing(1),
      marginLeft: 0
    })
  }
}, F2 = {}, D2 = {
  defaultProps: {
    arrow: !0,
    color: "primary"
  },
  styleOverrides: {
    tooltip: ({ theme: t, ownerState: { color: e } }) => ({
      backgroundColor: t.palette[e].main,
      color: t.palette[e].contrastText,
      padding: `${t.spacing(1)} ${t.spacing(3)}`
    }),
    arrow: ({ theme: t, ownerState: { color: e } }) => ({
      color: t.palette[e].main
    })
  }
}, R2 = {
  styleOverrides: {
    ol: ({ theme: t }) => ({
      fontSize: t.typography.fontSize
    }),
    li: ({ theme: t }) => ({
      "& a": {
        color: t.palette.typography.main
      }
    }),
    separator: ({ theme: t }) => ({
      marginLeft: t.spacing(0.625),
      marginRight: t.spacing(0.625),
      color: t.palette.typography.main
    })
  }
}, B2 = {
  styleOverrides: {
    root: ({ theme: t }) => ({
      "& .MuiTableRow-root": {
        backgroundColor: t.palette.surfaces.light,
        color: t.palette.typography.main,
        border: "none"
      },
      "& .MuiTableRow-root:nth-child(even)": {
        backgroundColor: t.palette.surfaces.main
      },
      "& .MuiTableHead-root .MuiTableRow-root": {
        backgroundColor: t.palette.surfaces.pink,
        border: `1px solid ${t.palette.surfaces.light}`,
        color: t.palette.secondary[900]
      },
      "& .MuiTableHead-root .MuiTableCell-root": {
        fontWeight: "bold"
      },
      "& .MuiTableCell-root": {
        borderBottom: "none",
        color: t.palette.typography.main
      },
      "& .MuiAvatar-root": {
        width: t.spacing(4),
        height: t.spacing(4),
        fontSize: t.typography.fontSize
      },
      "& .MuiTableRow-root:last-child td, &  .MuiTableRow-root:last-child th": {
        border: 0
      }
    })
  }
}, $2 = {
  defaultProps: {
    color: "primary"
  },
  styleOverrides: {
    icon: ({ theme: t, ownerState: { color: e } }) => ({
      "& .MuiSvgIcon-root": {
        color: t.palette[e].main
      }
    })
  }
}, j2 = {
  styleOverrides: {
    root: ({ theme: t }) => ({
      boxShadow: "none",
      marginBottom: t.spacing(2),
      ":before": {
        opacity: 0
      }
    })
  }
}, W2 = {
  styleOverrides: {
    root: ({ theme: t }) => ({
      color: t.palette.typography.main,
      fontWeight: t.typography.fontWeightBold,
      backgroundColor: t.palette.mode === "light" ? t.palette.secondary[300] : t.palette.secondary[900],
      fontSize: Math.round(t.typography.fontSize * 1.285),
      minHeight: `${t.spacing(6)} !important`,
      transition: "none",
      "&.Mui-expanded": {
        backgroundColor: t.palette.mode === "light" ? t.palette.secondary[100] : t.palette.secondary[800]
      }
    }),
    content: ({ theme: t }) => ({
      margin: `${t.spacing(1.5, 0)} !important`
    })
  }
}, U2 = {
  styleOverrides: {
    root: ({ theme: t }) => ({
      color: t.palette.typography.main,
      fontSize: t.typography.htmlFontSize
    })
  }
}, q2 = {
  styleOverrides: {
    root: ({ theme: t, ownerState: { color: e } }) => e ? {
      borderColor: t.palette[e].main,
      "&:before, &:after": { borderColor: t.palette[e].main }
    } : { borderColor: t.palette.surfaces.dark }
  }
}, Y2 = {
  styleOverrides: {
    root: ({ theme: t }) => ({
      "&.cfmPopover .MuiPaper-root": {
        maxWidth: t.spacing(40),
        padding: t.spacing(3),
        borderRadius: t.spacing(1.5)
      }
    })
  }
}, K2 = {
  styleOverrides: {
    root: ({ theme: t }) => ({
      "&.cfm-header-main-menu": {
        width: "100%",
        maxWidth: "100vw"
      },
      "&.cfm-header-main-menu .MuiButtonBase-root": {
        textTransform: "math-auto",
        maxWidth: "100%",
        justifyContent: "flex-start",
        color: t.palette.typography.main,
        flexDirection: "row",
        gap: t.spacing(1),
        textAlign: "left"
      },
      "&.cfm-header-main-menu .MuiButtonBase-root:after": {
        display: "block",
        content: '"+"',
        fontWeight: "700",
        fontSize: Math.round(t.typography.fontSize * 1.285),
        lineHeight: t.spacing(2.4),
        color: t.palette.primary.main
      },
      "&.cfm-header-main-menu .MuiButtonBase-root.Mui-selected": {
        color: `${t.palette.primary.main} !important`
      },
      "&.cfm-header-main-menu .MuiButtonBase-root.Mui-selected .MuiTypography-root": {
        color: `${t.palette.primary.main} !important`
      },
      "&.cfm-header-main-menu .MuiButtonBase-root.Mui-selected:after": {
        content: '"-"'
      },
      "&.cfm-header-main-menu .MuiButtonBase-root.Mui-expanded": {
        color: `${t.palette.primary.main} !important`
      },
      "&.cfm-header-main-menu .MuiButtonBase-root.Mui-expanded:after": {
        content: '"-"'
      },
      "&.cfm-header-main-menu .MuiButtonBase-root:hover": {
        opacity: "0.6"
      },
      "&.cfm-header-main-menu .MuiButtonBase-root:focus": {
        outline: "none"
      }
    })
  }
}, X2 = {
  defaultProps: {
    color: "typography.main",
    sx: { textWrap: "pretty" }
  },
  styleOverrides: {
    h1: ({ theme: t }) => ({
      fontSize: Math.round(t.typography.fontSize * 2.57),
      lineHeight: `${Math.round(t.typography.fontSize * 3.214)}px`,
      fontWeight: "bold",
      [t.breakpoints.up("md")]: {
        fontSize: Math.round(t.typography.fontSize * 4.07),
        lineHeight: `${Math.round(t.typography.fontSize * 5.357)}px`,
        fontWeight: "bold"
      }
    }),
    h2: ({ theme: t }) => ({
      fontSize: Math.round(t.typography.fontSize * 2),
      lineHeight: `${Math.round(t.typography.fontSize * 2.5)}px`,
      fontWeight: "bold",
      [t.breakpoints.up("md")]: {
        fontSize: Math.round(t.typography.fontSize * 3.357),
        lineHeight: `${Math.round(t.typography.fontSize * 4.428)}px`,
        fontWeight: "bold"
      }
    }),
    h3: ({ theme: t }) => ({
      fontSize: Math.round(t.typography.fontSize * 1.785),
      lineHeight: `${Math.round(t.typography.fontSize * 2.285)}px`,
      fontWeight: "bold",
      [t.breakpoints.up("md")]: {
        fontSize: Math.round(t.typography.fontSize * 2.785),
        lineHeight: `${Math.round(t.typography.fontSize * 3.642)}px`,
        fontWeight: "bold"
      }
    }),
    h4: ({ theme: t }) => ({
      fontSize: Math.round(t.typography.fontSize * 1.571),
      lineHeight: `${Math.round(t.typography.fontSize * 1.928)}px`,
      [t.breakpoints.up("md")]: {
        fontSize: Math.round(t.typography.fontSize * 2.357),
        lineHeight: `${Math.round(t.typography.fontSize * 3.071)}px`
      }
    }),
    h5: ({ theme: t }) => ({
      fontSize: Math.round(t.typography.fontSize * 1.428),
      lineHeight: `${Math.round(t.typography.fontSize * 1.785)}px`,
      [t.breakpoints.up("md")]: {
        fontSize: Math.round(t.typography.fontSize * 1.928),
        lineHeight: `${Math.round(t.typography.fontSize * 2.5)}px`
      }
    }),
    h6: ({ theme: t }) => ({
      fontSize: Math.round(t.typography.fontSize * 1.642),
      lineHeight: `${Math.round(t.typography.fontSize * 2.142)}px`,
      [t.breakpoints.up("md")]: {
        fontSize: Math.round(t.typography.fontSize * 1.642),
        lineHeight: `${Math.round(t.typography.fontSize * 2.142)}px`
      }
    }),
    subtitle1: ({ theme: t }) => ({
      fontSize: Math.round(t.typography.fontSize * 1.285),
      lineHeight: `${Math.round(t.typography.fontSize * 1.714)}px`,
      [t.breakpoints.up("md")]: {
        fontSize: Math.round(t.typography.fontSize * 1.285),
        lineHeight: `${Math.round(t.typography.fontSize * 1.642)}px`
      }
    }),
    subtitle2: ({ theme: t }) => ({
      fontSize: t.typography.fontSize,
      lineHeight: `${Math.round(t.typography.fontSize * 1.428)}px`,
      [t.breakpoints.up("md")]: {
        fontSize: t.typography.fontSize,
        lineHeight: `${Math.round(t.typography.fontSize * 1.357)}px`
      }
    }),
    body1: ({ theme: t }) => ({
      fontSize: Math.round(t.typography.fontSize * 1.142),
      lineHeight: `${Math.round(t.typography.fontSize * 1.428)}px`,
      [t.breakpoints.up("md")]: {
        fontSize: Math.round(t.typography.fontSize * 1.142),
        lineHeight: `${Math.round(t.typography.fontSize * 1.428)}px`
      }
    }),
    body2: ({ theme: t }) => ({
      fontSize: t.typography.fontSize,
      lineHeight: `${Math.round(t.typography.fontSize * 1.142)}px`,
      [t.breakpoints.up("md")]: {
        fontSize: t.typography.fontSize,
        lineHeight: `${Math.round(t.typography.fontSize * 1.142)}px`
      }
    })
  }
}, Q2 = {
  styleOverrides: {
    root: ({ theme: t }) => ({
      textTransform: "none",
      fontWeight: t.typography.fontWeightBold,
      fontSize: Math.round(t.typography.fontSize * 1.285),
      color: t.palette.typography.light,
      paddingBottom: t.spacing(0.5),
      paddingLeft: t.spacing(0.75),
      paddingRight: t.spacing(0.75),
      "& .Mui-selected": {
        color: t.palette.typography.main
      }
    })
  }
}, J2 = {
  styleOverrides: {
    root: ({ theme: t }) => ({
      "& .Mui-selected": {
        color: `${t.palette.typography.main} !important`
      }
    }),
    scrollButtons: ({ theme: t }) => ({
      color: t.palette.typography.main,
      paddingTop: t.spacing(1)
    }),
    vertical: ({ theme: t }) => ({
      "& .MuiTabs-indicator": {
        height: `${t.spacing(0.25)} !important`
      },
      "& .MuiButtonBase-root": {
        alignSelf: "flex-start",
        alignItems: "flex-start"
      }
    })
  }
}, er = ({ theme: t }) => ({
  color: t.palette.typography.main,
  "&.Mui-active, &.Mui-completed": {
    color: t.palette.typography.main
  },
  "&.Mui-active": {
    fontWeight: "bold"
  }
}), ar = ({ theme: t }) => ({
  "& .MuiSvgIcon-root": {
    color: t.palette.surfaces.main
  },
  "& .MuiSvgIcon-root.Mui-active, & .MuiSvgIcon-root.Mui-completed": {
    color: t.palette.primary.main,
    "& .MuiStepIcon-text": {
      fill: "white"
    }
  },
  "& .MuiStepIcon-text": {
    fill: t.palette.typography.main
  }
}), tr = {
  styleOverrides: {
    label: er,
    iconContainer: ar
  }
}, rr = {
  styleOverrides: {
    root: ({ theme: t }) => ({
      ".MuiPickersDay-root, .MuiDayCalendar-weekDayLabel, .MuiPickersCalendarHeader-label, .MuiPickersYear-yearButton, .MuiPickersCalendarHeader-switchViewButton, .MuiPickersArrowSwitcher-button, .MuiMultiSectionDigitalClockSection-item": {
        color: t.palette.typography.main
      },
      ".MuiPickersDay-root.Mui-disabled, .MuiPickersArrowSwitcher-button.Mui-disabled, .MuiMultiSectionDigitalClockSection-item.Mui-disabled": {
        color: t.palette.typography.main + " !important",
        opacity: 0.5
      },
      ".MuiPickersDay-root.Mui-selected": {
        color: "white"
      }
    })
  }
}, ir = {
  styleOverrides: {
    root: ({ theme: t }) => ({
      ".MuiMultiSectionDigitalClockSection-item": {
        color: t.palette.typography.main
      },
      ".MuiMultiSectionDigitalClockSection-item.Mui-disabled": {
        color: t.palette.typography.main + " !important",
        opacity: 0.5
      }
    })
  }
}, nr = {
  styleOverrides: {
    root: ({ theme: t }) => ({
      color: t.palette.typography.light
    })
  }
}, or = {
  styleOverrides: {
    colorDisabled: ({ theme: t }) => ({
      color: `${t.palette.surfaces.dark}`
    })
  }
}, sr = {
  MuiButtonGroup: P2,
  MuiButton: w2,
  MuiTextField: T2,
  MuiInputLabel: S2,
  MuiCheckbox: M2,
  MuiFormControlLabel: A2,
  MuiRadio: z2,
  MuiSelect: C2,
  MuiSwitch: x2,
  MuiMenuItem: F2,
  MuiAvatar: Z2,
  MuiChip: I2,
  MuiTooltip: D2,
  MuiBreadcrumbs: R2,
  MuiTable: B2,
  MuiRating: $2,
  MuiAccordion: j2,
  MuiAccordionSummary: W2,
  MuiAccordionDetails: U2,
  MuiDivider: q2,
  MuiPopover: Y2,
  MuiPopper: K2,
  MuiTypography: X2,
  MuiTab: Q2,
  MuiTabs: J2,
  MuiStepLabel: tr,
  MuiDateCalendar: rr,
  MuiMultiSectionDigitalClock: ir,
  MuiIconButton: nr,
  MuiSvgIcon: or
}, O0 = {
  50: "#fce3ed",
  100: "#f8b8d1",
  200: "#f48ab3",
  300: "#f15894",
  400: "#ee2b7b",
  500: "#ec0064",
  600: "#db0061",
  700: "#c5005c",
  800: "#b00059",
  900: "#8a0051"
}, z0 = {
  50: "#fdfdfd",
  100: "#f8f8f8",
  200: "#f3f3f3",
  300: "#eeeeee",
  400: "#cfcfcf",
  500: "#b2b2b2",
  600: "#888888",
  700: "#737373",
  800: "#535353",
  900: "#303030"
}, n1 = {
  50: "#f6f8ff",
  100: "#f0f3ff",
  200: "#e9ebff",
  300: "#daddf5",
  400: "#b7bad1",
  500: "#989bb1",
  600: "#6f7287",
  700: "#5b5e72",
  800: "#3c3f52",
  900: "#1b1f30"
}, o1 = {
  50: "#fefee6",
  100: "#fcfac1",
  200: "#faf798",
  300: "#f7f36c",
  400: "#f4ef46",
  500: "#f0ea14",
  600: "#f7dd16",
  700: "#f7c401",
  800: "#f8ab00",
  900: "#f78100"
}, s1 = {
  50: "#e0f2f2",
  100: "#b1e0de",
  200: "#7eccc9",
  300: "#48b7b3",
  400: "#18a8a2",
  500: "#009890",
  600: "#008b82",
  700: "#007b72",
  800: "#006b62",
  900: "#004f45"
}, l1 = {
  50: "#f7e8e4",
  100: "#f4c9b5",
  200: "#eca785",
  300: "#e58753",
  400: "#e16f2a",
  500: "#dc5900",
  600: "#d25300",
  700: "#c54c00",
  800: "#b84500",
  900: "#a13800"
}, d1 = {
  100: "#ffcad6",
  200: "#f493a0",
  300: "#ed667b",
  400: "#fa375b",
  500: "#ff0042"
}, c1 = {
  100: "#ffecb4",
  200: "#ffe084",
  300: "#ffd653",
  400: "#ffcb2f",
  500: "#ffc218"
}, u1 = {
  100: "#bcdcff",
  200: "#90c7ff",
  300: "#61b1ff",
  400: "#40a0ff",
  500: "#298fff"
}, h1 = {
  100: "#ddecbd",
  200: "#c5df93",
  300: "#add365",
  400: "#99c93e",
  500: "#86c000"
}, j1 = {
  pink: "#FDF3F7",
  yellow: "#fff4e7",
  purple: "#F0F3FF"
}, lr = {
  white: "#ffffff",
  black: "#000000"
}, l0 = {
  typography: {
    light: z0[800],
    dark: z0[900],
    main: z0[900]
  },
  surfaces: {
    pink: j1.pink,
    purple: j1.purple,
    yellow: j1.yellow,
    light: z0[50],
    dark: z0[400],
    main: z0[200]
  },
  default: {
    ...O0,
    light: O0[300],
    dark: O0[900],
    main: O0[400]
  },
  primary: {
    ...O0,
    light: O0[300],
    dark: O0[900],
    main: O0[400]
  },
  secondary: {
    ...z0,
    light: z0[300],
    dark: z0[900],
    main: z0[900]
  },
  tertiary: {
    ...n1,
    light: n1[300],
    dark: n1[900],
    main: n1[600]
  },
  background: {
    default: "#fff",
    paper: "#fff"
  },
  yellow: {
    ...o1,
    light: o1[300],
    dark: o1[900],
    main: o1[600]
  },
  turquoise: {
    ...s1,
    light: s1[300],
    dark: s1[900],
    main: s1[200]
  },
  orange: {
    ...l1,
    light: l1[300],
    dark: l1[900],
    main: l1[200]
  },
  success: {
    ...h1,
    light: h1[300],
    dark: h1[500],
    main: h1[500]
  },
  error: {
    ...d1,
    light: d1[300],
    dark: d1[500],
    main: d1[500]
  },
  warning: {
    ...c1,
    light: c1[300],
    dark: c1[500],
    main: c1[500]
  },
  info: {
    ...u1,
    light: u1[300],
    dark: u1[500],
    main: u1[500]
  },
  common: { ...lr },
  mode: "light"
}, x0 = r1(), Ea = (t = 14) => ({
  fontFamily: "Roboto, sans-serif",
  fontSize: t,
  htmlFontSize: Math.round(t * 1.142),
  h1: {
    fontSize: Math.round(t * 2.57),
    lineHeight: `${Math.round(t * 3.214)}px`,
    fontWeight: "bold",
    [x0.breakpoints.up("md")]: {
      fontSize: Math.round(t * 4.07),
      lineHeight: `${Math.round(t * 5.357)}px`,
      fontWeight: "bold"
    }
  },
  h2: {
    fontSize: Math.round(t * 2),
    lineHeight: `${Math.round(t * 2.5)}px`,
    fontWeight: "bold",
    [x0.breakpoints.up("md")]: {
      fontSize: Math.round(t * 3.357),
      lineHeight: `${Math.round(t * 4.428)}px`,
      fontWeight: "bold"
    }
  },
  h3: {
    fontSize: Math.round(t * 1.785),
    lineHeight: `${Math.round(t * 2.285)}px`,
    fontWeight: "bold",
    [x0.breakpoints.up("md")]: {
      fontSize: Math.round(t * 2.785),
      lineHeight: `${Math.round(t * 3.642)}px`,
      fontWeight: "bold"
    }
  },
  h4: {
    fontSize: Math.round(t * 1.571),
    lineHeight: `${Math.round(t * 1.928)}px`,
    [x0.breakpoints.up("md")]: {
      fontSize: Math.round(t * 2.357),
      lineHeight: `${Math.round(t * 3.071)}px`
    }
  },
  h5: {
    fontSize: Math.round(t * 1.428),
    lineHeight: `${Math.round(t * 1.785)}px`,
    [x0.breakpoints.up("md")]: {
      fontSize: Math.round(t * 1.928),
      lineHeight: `${Math.round(t * 2.5)}px`
    }
  },
  h6: {
    fontSize: Math.round(t * 1.642),
    lineHeight: `${Math.round(t * 2.142)}px`,
    [x0.breakpoints.up("md")]: {
      fontSize: Math.round(t * 1.642),
      lineHeight: `${Math.round(t * 2.142)}px`
    }
  },
  subtitle1: {
    fontSize: Math.round(t * 1.285),
    lineHeight: `${Math.round(t * 1.714)}px`,
    [x0.breakpoints.up("md")]: {
      fontSize: Math.round(t * 1.285),
      lineHeight: `${Math.round(t * 1.642)}px`
    }
  },
  subtitle2: {
    fontSize: t,
    lineHeight: `${Math.round(t * 1.428)}px`,
    [x0.breakpoints.up("md")]: {
      fontSize: t,
      lineHeight: `${Math.round(t * 1.357)}px`
    }
  },
  body1: {
    fontSize: Math.round(t * 1.142),
    lineHeight: `${Math.round(t * 1.428)}px`,
    [x0.breakpoints.up("md")]: {
      fontSize: Math.round(t * 1.142),
      lineHeight: `${Math.round(t * 1.428)}px`
    }
  },
  body2: {
    fontSize: t,
    lineHeight: `${Math.round(t * 1.142)}px`,
    [x0.breakpoints.up("md")]: {
      fontSize: t,
      lineHeight: `${Math.round(t * 1.142)}px`
    }
  }
}), Ha = {
  ...sr,
  MuiButtonBase: {
    defaultProps: { disableRipple: !0 }
  },
  MuiCssBaseline: {
    styleOverrides: `
      .Mui-focusVisible {
        background-color: #7eccc9 !important;
        outline: 3px solid #000 !important;
        color: #000 !important;
        box-shadow: 0 0 0 6px #fff !important;
      }
    `
  }
}, La = r1({
  typography: Ea()
}), dr = r1(La, {
  palette: l0,
  components: Ha
}), cr = r1(La, {
  components: Ha,
  palette: {
    ...l0,
    mode: "dark",
    background: { default: "#000000", paper: "#222425" },
    typography: {
      light: l0.secondary[200],
      dark: l0.secondary[50],
      main: l0.secondary[50]
    },
    surfaces: {
      ...l0.surfaces,
      light: l0.secondary[900],
      dark: l0.secondary[700],
      main: l0.secondary[700]
    }
  }
}), Me = i2({
  theme: "light",
  fontSize: 14,
  setTheme: () => {
  },
  setFontSize: () => {
  }
}), a6 = ({
  children: t,
  customDarkTheme: e,
  customTheme: a
}) => {
  const [i, n] = Z0("light"), [o, d] = Z0(14);
  F0(() => {
    const m = localStorage.getItem("theme");
    if (m === null) {
      const p = window.matchMedia("(prefers-color-scheme: dark)") ? "dark" : "light";
      localStorage.setItem("theme", p), n(p);
    } else
      n(m);
  }, []);
  const s = Ee(() => r1(i === "dark" ? e || cr : a || dr, {
    typography: Ea(o)
  }), [e, a, o, i]), c = Ee(
    () => ({
      theme: i,
      setTheme: (m) => {
        localStorage.setItem("theme", m), n(m);
      },
      fontSize: o,
      setFontSize: (m) => {
        d(m);
      }
    }),
    [o, i]
  );
  return /* @__PURE__ */ r(qt, { theme: s, children: /* @__PURE__ */ r(Me.Provider, { value: c, children: t }) });
}, t6 = () => {
  const t = Sa(Me);
  if (!t)
    throw new Error("useToggleTheme must be used within a ThemeProvider");
  const { theme: e, setTheme: a } = t;
  return { theme: e, setTheme: a };
}, k0 = () => ya(), r6 = () => {
  const t = Sa(Me);
  if (!t)
    throw new Error("useChangeFontSize must be used within a ThemeProvider");
  const { fontSize: e, setFontSize: a } = t;
  return { fontSize: e, setFontSize: a };
}, i6 = (t) => Ma(/* @__PURE__ */ r(Yt, {}), { ...t }), e1 = (t) => /* @__PURE__ */ r(_a, { ...t }), n6 = (t) => Ma(/* @__PURE__ */ r(Kt, {}), { ...t }), H = {};
H.allowedTagList = [
  "b",
  "caption",
  "cite",
  "code",
  "const",
  "dd",
  "del",
  "div",
  "dfn",
  "dt",
  "em",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "input",
  "ins",
  "kdb",
  "label",
  "li",
  "option",
  "output",
  "p",
  "q",
  "s",
  "sample",
  "span",
  "strong",
  "td",
  "th",
  "u"
];
Object.freeze(H.allowedTagList);
Object.defineProperty(H, "allowedTagList", { configurable: !1, writable: !1 });
H.fromCharCodeKeyCode = {
  0: "LaunchCalculator",
  8: "Backspace",
  9: "Tab",
  13: "Enter",
  16: "Shift",
  17: "Ctrl",
  18: "Alt",
  19: "Pause",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  45: "Insert",
  46: "Delete",
  48: "0",
  49: "1",
  50: "2",
  51: "3",
  52: "4",
  53: "5",
  54: "6",
  55: "7",
  56: "8",
  57: "9",
  // 65: 'a',
  // 66: 'b',
  // 67: 'c',
  // 68: 'd',
  // 69: 'e',
  // 70: 'f',
  // 71: 'g',
  // 72: 'h',
  // 73: 'i',
  // 74: 'j',
  // 75: 'k',
  // 76: 'l',
  // 77: 'm',
  // 78: 'n',
  // 79: 'o',
  // 80: 'p',
  // 81: 'q',
  // 82: 'r',
  // 83: 's',
  // 84: 't',
  // 85: 'u',
  // 86: 'v',
  // 87: 'w',
  // 88: 'x',
  // 89: 'y',
  // 90: 'z',
  91: "OS",
  // Note: Firefox and Chrome reports 'OS' instead of 'OSLeft'
  92: "OSRight",
  93: "ContextMenu",
  96: "0",
  97: "1",
  98: "2",
  99: "3",
  100: "4",
  101: "5",
  102: "6",
  103: "7",
  104: "8",
  105: "9",
  106: "*",
  107: "+",
  109: "-",
  // The 'NumpadSubtract' code
  110: ".",
  111: "/",
  112: "F1",
  113: "F2",
  114: "F3",
  115: "F4",
  116: "F5",
  117: "F6",
  118: "F7",
  119: "F8",
  120: "F9",
  121: "F10",
  122: "F11",
  123: "F12",
  144: "NumLock",
  145: "ScrollLock",
  173: "-",
  // The 'Minus' sign on Firefox. This is only needed when using the Selenium bot though.
  182: "MyComputer",
  183: "MyCalculator",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  // The 'Minus' sign on all other browsers
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'",
  224: "Meta",
  225: "AltGraph"
};
Object.freeze(H.fromCharCodeKeyCode);
Object.defineProperty(H, "fromCharCodeKeyCode", { configurable: !1, writable: !1 });
H.keyName = {
  // Special values
  Unidentified: "Unidentified",
  AndroidDefault: "AndroidDefault",
  // Modifier keys
  Alt: "Alt",
  AltGr: "AltGraph",
  CapsLock: "CapsLock",
  // Under Chrome, e.key is empty for CapsLock
  Ctrl: "Control",
  Fn: "Fn",
  FnLock: "FnLock",
  Hyper: "Hyper",
  // 'OS' under Firefox
  Meta: "Meta",
  OSLeft: "OS",
  OSRight: "OS",
  Command: "OS",
  NumLock: "NumLock",
  ScrollLock: "ScrollLock",
  Shift: "Shift",
  Super: "Super",
  // 'OS' under Firefox
  Symbol: "Symbol",
  SymbolLock: "SymbolLock",
  // Whitespace keys
  Enter: "Enter",
  Tab: "Tab",
  Space: " ",
  // 'Spacebar' for Firefox <37, and IE9
  // Navigation keys
  LeftArrow: "ArrowLeft",
  // 'Left' for Firefox <=36, and IE9
  UpArrow: "ArrowUp",
  // 'Up' for Firefox <=36, and IE9
  RightArrow: "ArrowRight",
  // 'Right' for Firefox <=36, and IE9
  DownArrow: "ArrowDown",
  // 'Down' for Firefox <=36, and IE9
  End: "End",
  Home: "Home",
  PageUp: "PageUp",
  PageDown: "PageDown",
  // Editing keys
  Backspace: "Backspace",
  Clear: "Clear",
  Copy: "Copy",
  CrSel: "CrSel",
  // 'Crsel' for Firefox <=36, and IE9
  Cut: "Cut",
  Delete: "Delete",
  // 'Del' for Firefox <=36, and IE9
  EraseEof: "EraseEof",
  ExSel: "ExSel",
  // 'Exsel' for Firefox <=36, and IE9
  Insert: "Insert",
  Paste: "Paste",
  Redo: "Redo",
  Undo: "Undo",
  // UI keys
  Accept: "Accept",
  Again: "Again",
  Attn: "Attn",
  // 'Unidentified' for Firefox, Chrome, and IE9 ('KanaMode' when using the Japanese keyboard layout)
  Cancel: "Cancel",
  ContextMenu: "ContextMenu",
  // 'Apps' for Firefox <=36, and IE9
  Esc: "Escape",
  // 'Esc' for Firefox <=36, and IE9
  Execute: "Execute",
  Find: "Find",
  Finish: "Finish",
  // 'Unidentified' for Firefox, Chrome, and IE9 ('Katakana' when using the Japanese keyboard layout)
  Help: "Help",
  Pause: "Pause",
  Play: "Play",
  Props: "Props",
  Select: "Select",
  ZoomIn: "ZoomIn",
  ZoomOut: "ZoomOut",
  // Device keys
  BrightnessDown: "BrightnessDown",
  BrightnessUp: "BrightnessUp",
  Eject: "Eject",
  LogOff: "LogOff",
  Power: "Power",
  PowerOff: "PowerOff",
  PrintScreen: "PrintScreen",
  Hibernate: "Hibernate",
  // 'Unidentified' for Firefox <=37
  Standby: "Standby",
  // 'Unidentified' for Firefox <=36, and IE9
  WakeUp: "WakeUp",
  // IME and composition keys
  Compose: "Compose",
  Dead: "Dead",
  // Function keys
  F1: "F1",
  F2: "F2",
  F3: "F3",
  F4: "F4",
  F5: "F5",
  F6: "F6",
  F7: "F7",
  F8: "F8",
  F9: "F9",
  F10: "F10",
  F11: "F11",
  F12: "F12",
  // Document keys
  Print: "Print",
  // 'Normal' keys
  num0: "0",
  num1: "1",
  num2: "2",
  num3: "3",
  num4: "4",
  num5: "5",
  num6: "6",
  num7: "7",
  num8: "8",
  num9: "9",
  a: "a",
  b: "b",
  c: "c",
  d: "d",
  e: "e",
  f: "f",
  g: "g",
  h: "h",
  i: "i",
  j: "j",
  k: "k",
  l: "l",
  m: "m",
  n: "n",
  o: "o",
  p: "p",
  q: "q",
  r: "r",
  s: "s",
  t: "t",
  u: "u",
  v: "v",
  w: "w",
  x: "x",
  y: "y",
  z: "z",
  A: "A",
  B: "B",
  C: "C",
  D: "D",
  E: "E",
  F: "F",
  G: "G",
  H: "H",
  I: "I",
  J: "J",
  K: "K",
  L: "L",
  M: "M",
  N: "N",
  O: "O",
  P: "P",
  Q: "Q",
  R: "R",
  S: "S",
  T: "T",
  U: "U",
  V: "V",
  W: "W",
  X: "X",
  Y: "Y",
  Z: "Z",
  Semicolon: ";",
  Equal: "=",
  Comma: ",",
  Hyphen: "-",
  Minus: "-",
  Plus: "+",
  Dot: ".",
  Slash: "/",
  Backquote: "`",
  LeftParenthesis: "(",
  RightParenthesis: ")",
  LeftBracket: "[",
  RightBracket: "]",
  Backslash: "\\",
  Quote: "'",
  // Numeric keypad keys
  numpad0: "0",
  numpad1: "1",
  numpad2: "2",
  numpad3: "3",
  numpad4: "4",
  numpad5: "5",
  numpad6: "6",
  numpad7: "7",
  numpad8: "8",
  numpad9: "9",
  NumpadDot: ".",
  NumpadDotAlt: ",",
  // Modern browsers automatically adapt the character sent by this key to the decimal character of the current language
  NumpadMultiply: "*",
  NumpadPlus: "+",
  NumpadMinus: "-",
  NumpadSubtract: "-",
  NumpadSlash: "/",
  NumpadDotObsoleteBrowsers: "Decimal",
  NumpadMultiplyObsoleteBrowsers: "Multiply",
  NumpadPlusObsoleteBrowsers: "Add",
  NumpadMinusObsoleteBrowsers: "Subtract",
  NumpadSlashObsoleteBrowsers: "Divide",
  // Special arrays for quicker tests
  _allFnKeys: ["F1", "F2", "F3", "F4", "F5", "F6", "F7", "F8", "F9", "F10", "F11", "F12"],
  _someNonPrintableKeys: ["Tab", "Enter", "Shift", "ShiftLeft", "ShiftRight", "Control", "ControlLeft", "ControlRight", "Alt", "AltLeft", "AltRight", "Pause", "CapsLock", "Escape"],
  _directionKeys: ["PageUp", "PageDown", "End", "Home", "ArrowDown", "ArrowLeft", "ArrowRight", "ArrowUp"]
};
Object.freeze(H.keyName._allFnKeys);
Object.freeze(H.keyName._someNonPrintableKeys);
Object.freeze(H.keyName._directionKeys);
Object.freeze(H.keyName);
Object.defineProperty(H, "keyName", { configurable: !1, writable: !1 });
Object.freeze(H);
class l {
  /**
   * Return `true` if the `value` is null
   *
   * @static
   * @param {*} value The value to test
   * @returns {boolean} Return `true` if the `value` is null, FALSE otherwise
   */
  static isNull(e) {
    return e === null;
  }
  /**
   * Return `true` if the `value` is undefined
   *
   * @static
   * @param {*} value The value to test
   * @returns {boolean} Return `true` if the `value` is undefined, FALSE otherwise
   */
  static isUndefined(e) {
    return e === void 0;
  }
  /**
   * Return `true` if the `value` is undefined, null or empty
   *
   * @param {*} value
   * @returns {boolean}
   */
  static isUndefinedOrNullOrEmpty(e) {
    return e == null || e === "";
  }
  /**
   * Return `true` if the given parameter is a String
   *
   * @param {*} str
   * @returns {boolean}
   */
  static isString(e) {
    return typeof e == "string" || e instanceof String;
  }
  /**
   * Return `true` if the `value` is an empty string ''
   *
   * @static
   * @param {*} value The value to test
   * @returns {boolean} Return `true` if the `value` is an empty string '', FALSE otherwise
   */
  static isEmptyString(e) {
    return e === "";
  }
  /**
   * Return `true` if the parameter is a boolean
   *
   * @static
   * @param {*} value
   * @returns {boolean}
   */
  static isBoolean(e) {
    return typeof e == "boolean";
  }
  /**
   * Return `true` if the parameter is a string 'true' or 'false'
   *
   * This function accepts any cases for those strings.
   * @param {string} value
   * @returns {boolean}
   */
  static isTrueOrFalseString(e) {
    const a = String(e).toLowerCase();
    return a === "true" || a === "false";
  }
  /**
   * Return `true` if the parameter is an object
   *
   * @param {*} reference
   * @returns {boolean}
   */
  static isObject(e) {
    return typeof e == "object" && e !== null && !Array.isArray(e);
  }
  /**
   * Return `true` if the given object is empty
   * cf. http://stackoverflow.com/questions/679915/how-do-i-test-for-an-empty-javascript-object and http://jsperf.com/empty-object-test
   *
   * @param {object} obj
   * @returns {boolean}
   */
  static isEmptyObj(e) {
    for (const a in e)
      if (Object.prototype.hasOwnProperty.call(e, a))
        return !1;
    return !0;
  }
  /**
   * Return `true` if the parameter is a real number (and not a numeric string).
   *
   * @param {*} n
   * @returns {boolean}
   */
  static isNumberStrict(e) {
    return typeof e == "number";
  }
  /**
   * Return `true` if the parameter is a number (or a number written as a string).
   *
   * @param {*} n
   * @returns {boolean}
   */
  static isNumber(e) {
    return !this.isArray(e) && !isNaN(parseFloat(e)) && isFinite(e);
  }
  /**
   * Return `true` if the given character is a number (0 to 9)
   *
   * @param {char} char
   * @returns {boolean}
   */
  static isDigit(e) {
    return /\d/.test(e);
  }
  /**
   * Return `true` if the parameter is a number (or a number written as a string).
   * This version also accepts Arabic and Persian numbers.
   *
   * @param {*} n
   * @returns {boolean}
   */
  static isNumberOrArabic(e) {
    const a = this.arabicToLatinNumbers(e, !1, !0, !0);
    return this.isNumber(a);
  }
  /**
   * Return `true` if the parameter is an integer (and not a float).
   *
   * @param {*} n
   * @returns {boolean}
   */
  static isInt(e) {
    return typeof e == "number" && parseFloat(e) === parseInt(e, 10) && !isNaN(e);
  }
  /**
   * Return `true` if the parameter is a function.
   *
   * @param {function} func
   * @returns {boolean}
   */
  static isFunction(e) {
    return typeof e == "function";
  }
  /**
   * Return `true` is the string `str` contains the string `needle`
   * Note: this function does not coerce the parameters types
   *
   * @param {string} str
   * @param {string} needle
   * @returns {boolean}
   */
  static contains(e, a) {
    return !this.isString(e) || !this.isString(a) || e === "" || a === "" ? !1 : e.indexOf(a) !== -1;
  }
  /**
   * Return `true` if the `needle` is in the array
   *
   * @param {*} needle
   * @param {Array} array
   * @returns {boolean}
   */
  static isInArray(e, a) {
    return !this.isArray(a) || a === [] || this.isUndefined(e) ? !1 : a.indexOf(e) !== -1;
  }
  /**
   * Return `true` if the parameter is an Array
   * //TODO Replace this by the default `Array.isArray()` function?
   *
   * @param {*} arr
   * @throws Error
   * @returns {*|boolean}
   */
  static isArray(e) {
    if (Object.prototype.toString.call([]) === "[object Array]")
      return Array.isArray(e) || typeof e == "object" && Object.prototype.toString.call(e) === "[object Array]";
    throw new Error("toString message changed for Object Array");
  }
  /**
   * Return `true` if the parameter is a DOM element
   * cf. http://stackoverflow.com/a/4754104/2834898
   *
   * @param {*} obj
   * @returns {boolean}
   */
  static isElement(e) {
    return typeof Element > "u" ? !1 : e instanceof Element;
  }
  /**
   * Return `true` in the given DOM element is an <input>.
   *
   * @param {HTMLElement|HTMLInputElement} domElement
   * @returns {boolean}
   * @private
   */
  static isInputElement(e) {
    return this.isElement(e) && e.tagName.toLowerCase() === "input";
  }
  /**
   * Return `true` if the parameter is a string that represents a float number, and that number has a decimal part
   *
   * @param {string} str
   * @returns {boolean}
   */
  // static hasDecimals(str) {
  //     const [, decimalPart] = str.split('.');
  //     return !isUndefined(decimalPart);
  // }
  /**
   * Return the number of decimal places if the parameter is a string that represents a float number, and that number has a decimal part.
   *
   * @param {string} str
   * @returns {int}
   */
  static decimalPlaces(e) {
    const [, a] = e.split(".");
    return this.isUndefined(a) ? 0 : a.length;
  }
  /**
   * Return the index of the first non-zero decimal place in the given value.
   * The index starts after the decimal point, if any, and begins at '1'.
   * If no decimal places are found in the value, this function returns `0`.
   *
   * @example
   * indexFirstNonZeroDecimalPlace('0.00') -> 0
   * indexFirstNonZeroDecimalPlace('1.00') -> 0
   * indexFirstNonZeroDecimalPlace('0.12') -> 1
   * indexFirstNonZeroDecimalPlace('0.1234') -> 1
   * indexFirstNonZeroDecimalPlace('0.01234') -> 2
   * indexFirstNonZeroDecimalPlace('0.001234') -> 3
   * indexFirstNonZeroDecimalPlace('0.0001234') -> 4
   *
   * @param {number} value
   * @returns {Number|number}
   */
  static indexFirstNonZeroDecimalPlace(e) {
    const [, a] = String(Math.abs(e)).split(".");
    if (this.isUndefined(a))
      return 0;
    let i = a.lastIndexOf("0");
    return i === -1 ? i = 0 : i += 2, i;
  }
  /**
   * Return the code for the key used to generate the given event.
   *
   * @param {Event} event
   * @returns {string|Number}
   */
  static keyCodeNumber(e) {
    return typeof e.which > "u" ? e.keyCode : e.which;
  }
  /**
   * Return the character from the event key code.
   * If the KeyboardEvent does not represent a printable character, then the key name is used (ie. 'Meta', 'Shift', 'F1', etc.)
   * @example character(50) => '2'
   *
   * @param {KeyboardEvent} event
   * @returns {string}
   */
  static character(e) {
    let a;
    if (e.key === "Unidentified" || e.key === void 0 || this.isSeleniumBot()) {
      const i = this.keyCodeNumber(e);
      if (i === 229)
        return H.keyName.AndroidDefault;
      const n = H.fromCharCodeKeyCode[i];
      l.isUndefinedOrNullOrEmpty(n) ? a = String.fromCharCode(i) : a = n;
    } else
      switch (e.key) {
        case "Add":
          a = H.keyName.NumpadPlus;
          break;
        case "Apps":
          a = H.keyName.ContextMenu;
          break;
        case "Crsel":
          a = H.keyName.CrSel;
          break;
        case "Decimal":
          e.char ? a = e.char : a = H.keyName.NumpadDot;
          break;
        case "Del":
          a = H.keyName.Delete;
          break;
        case "Divide":
          a = H.keyName.NumpadSlash;
          break;
        case "Down":
          a = H.keyName.DownArrow;
          break;
        case "Esc":
          a = H.keyName.Esc;
          break;
        case "Exsel":
          a = H.keyName.ExSel;
          break;
        case "Left":
          a = H.keyName.LeftArrow;
          break;
        case "Meta":
        case "Super":
          a = H.keyName.OSLeft;
          break;
        case "Multiply":
          a = H.keyName.NumpadMultiply;
          break;
        case "Right":
          a = H.keyName.RightArrow;
          break;
        case "Spacebar":
          a = H.keyName.Space;
          break;
        case "Subtract":
          a = H.keyName.NumpadMinus;
          break;
        case "Up":
          a = H.keyName.UpArrow;
          break;
        default:
          a = e.key;
      }
    return a;
  }
  /**
   * Return an object containing the name and version of the current browser.
   * @example `browserVersion()` => { name: 'Firefox', version: '42' }
   * Based on http://stackoverflow.com/a/38080051/2834898
   *
   * @returns {{ name: string, version: string }}
   */
  static browser() {
    const e = navigator.userAgent;
    let a, i = e.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    return /trident/i.test(i[1]) ? (a = /\brv[ :]+(\d+)/g.exec(e) || [], { name: "ie", version: a[1] || "" }) : i[1] === "Chrome" && (a = e.match(/\b(OPR|Edge)\/(\d+)/), a !== null) ? { name: a[1].replace("OPR", "opera"), version: a[2] } : (i = i[2] ? [i[1], i[2]] : [navigator.appName, navigator.appVersion, "-?"], (a = e.match(/version\/(\d+)/i)) !== null && i.splice(1, 1, a[1]), { name: i[0].toLowerCase(), version: i[1] });
  }
  /**
   * Check if the browser is controlled by Selenium.
   * Note: This only works within the geckodriver.
   * cf. http://stackoverflow.com/questions/33225947/can-a-website-detect-when-you-are-using-selenium-with-chromedriver
   *
   * @returns {boolean}
   */
  static isSeleniumBot() {
    return window.navigator.webdriver === !0;
  }
  /**
   * Return `true` if the given number is negative, or if the given string contains a negative sign :
   * - everywhere in the string (by default), or
   * - on the first character only if the `checkEverywhere` parameter is set to `false`.
   *
   * Note: `-0` is not a negative number since it's equal to `0`.
   *
   * @param {number|string} numberOrNumericString A Number, or a number represented by a string
   * @param {string} negativeSignCharacter The single character that represent the negative sign
   * @param {boolean} checkEverywhere If TRUE, then the negative sign is search everywhere in the numeric string (this is needed for instance if the string is '1234.56-')
   * @returns {boolean}
   */
  static isNegative(e, a = "-", i = !0) {
    return e === a ? !0 : e === "" ? !1 : l.isNumber(e) ? e < 0 : i ? this.contains(e, a) : this.isNegativeStrict(e, a);
  }
  /**
   * Return `true` if the given string contains a negative sign on the first character (on the far left).
   *
   * @example isNegativeStrict('1234.56')     => false
   * @example isNegativeStrict('1234.56-')    => false
   * @example isNegativeStrict('-1234.56')    => true
   * @example isNegativeStrict('-1,234.56 €') => true
   *
   * @param {string} numericString
   * @param {string} negativeSignCharacter The single character that represent the negative sign
   * @returns {boolean}
   */
  static isNegativeStrict(e, a = "-") {
    return e.charAt(0) === a;
  }
  /**
   * Return `true` if the very first character is the opening bracket, and if the rest of the `valueString` also has the closing bracket.
   *
   * @param {string} valueString
   * @param {string} leftBracket
   * @param {string} rightBracket
   * @returns {boolean}
   */
  static isNegativeWithBrackets(e, a, i) {
    return e.charAt(0) === a && this.contains(e, i);
  }
  /**
   * Return `true` if the formatted or unformatted numeric string represent the value 0 (ie. '0,00 €'), or is empty (' €').
   * This works since we test if there are any numbers from 1 to 9 in the string. If there is none, then the number is zero (or the string is empty).
   *
   * @param {string} numericString
   * @returns {boolean}
   */
  static isZeroOrHasNoValue(e) {
    return !/[1-9]/g.test(e);
  }
  /**
   * Return the negative version of the value (represented as a string) given as a parameter.
   * The numeric string is a valid Javascript number when typecast to a `Number`.
   *
   * @param {string} value
   * @returns {*}
   */
  static setRawNegativeSign(e) {
    return this.isNegativeStrict(e, "-") ? e : `-${e}`;
  }
  /**
   * Replace the character at the position `index` in the string `string` by the character(s) `newCharacter`.
   *
   * @param {string} string
   * @param {int} index
   * @param {string} newCharacter
   * @returns {string}
   */
  static replaceCharAt(e, a, i) {
    return `${e.substr(0, a)}${i}${e.substr(a + i.length)}`;
  }
  /**
   * Return the value clamped to the nearest minimum/maximum value, as defined in the settings.
   *
   * @param {string|number} value
   * @param {object} settings
   * @returns {number}
   */
  static clampToRangeLimits(e, a) {
    return Math.max(a.minimumValue, Math.min(a.maximumValue, e));
  }
  /**
   * Return the number of number or dot characters on the left side of the caret, in a formatted number.
   *
   * @param {string} formattedNumberString
   * @param {int} caretPosition This must be a positive integer
   * @param {string} decimalCharacter
   * @returns {number}
   */
  static countNumberCharactersOnTheCaretLeftSide(e, a, i) {
    const n = new RegExp(`[0-9${i}-]`);
    let o = 0;
    for (let d = 0; d < a; d++)
      n.test(e[d]) && o++;
    return o;
  }
  /**
   * Walk the `formattedNumberString` from left to right, one char by one, counting the `formattedNumberStringIndex`.
   * If the char is in the `rawNumberString` (starting at index 0), then `rawNumberStringIndex++`, and continue until
   * there is no more characters in `rawNumberString`) or that `rawNumberStringIndex === caretPositionInRawValue`.
   * When you stop, the `formattedNumberStringIndex` is the position where the caret should be set.
   *
   * @example
   * 1234567|89.01   : position 7 (rawNumberString)
   * 123.456.7|89,01 : position 9 (formattedNumberString)
   *
   * @param {string} rawNumberString
   * @param {int} caretPositionInRawValue
   * @param {string} formattedNumberString
   * @param {string} decimalCharacter
   * @returns {*}
   */
  static findCaretPositionInFormattedNumber(e, a, i, n) {
    const o = i.length, d = e.length;
    let s, c = 0;
    for (s = 0; s < o && c < d && c < a; s++)
      (e[c] === i[s] || e[c] === "." && i[s] === n) && c++;
    return s;
  }
  /**
   * Count the number of occurrence of the given character, in the given text.
   *
   * @param {string} character
   * @param {string} text
   * @returns {number}
   */
  static countCharInText(e, a) {
    let i = 0;
    for (let n = 0; n < a.length; n++)
      a[n] === e && i++;
    return i;
  }
  /**
   * Return the index that can be used to set the caret position.
   * This takes into account that the position is starting at '0', not 1.
   *
   * @param {int} characterCount
   * @returns {number}
   */
  static convertCharacterCountToIndexPosition(e) {
    return Math.max(e, e - 1);
  }
  /**
   * Cross browser routine for getting selected range/cursor position.
   * Note: this also works with edge cases like contenteditable-enabled elements, and hidden inputs.
   *
   * @param {HTMLInputElement|EventTarget} element
   * @returns {{}}
   */
  static getElementSelection(e) {
    const a = {};
    let i;
    try {
      i = this.isUndefined(e.selectionStart);
    } catch {
      i = !1;
    }
    try {
      if (i) {
        const o = window.getSelection().getRangeAt(0);
        a.start = o.startOffset, a.end = o.endOffset, a.length = a.end - a.start;
      } else
        a.start = e.selectionStart, a.end = e.selectionEnd, a.length = a.end - a.start;
    } catch {
      a.start = 0, a.end = 0, a.length = 0;
    }
    return a;
  }
  /**
   * Cross browser routine for setting selected range/cursor position
   *
   * @param {HTMLInputElement|EventTarget} element
   * @param {int} start
   * @param {int|null} end
   */
  static setElementSelection(e, a, i = null) {
    if (this.isUndefinedOrNullOrEmpty(i) && (i = a), this.isInputElement(e))
      e.setSelectionRange(a, i);
    else if (!l.isNull(e.firstChild)) {
      const n = document.createRange();
      n.setStart(e.firstChild, a), n.setEnd(e.firstChild, i);
      const o = window.getSelection();
      o.removeAllRanges(), o.addRange(n);
    }
  }
  /**
   * Function that throw error messages
   *
   * @param {string} message
   * @throws
   */
  static throwError(e) {
    throw new Error(e);
  }
  /**
   * Function that display a warning messages, according to the debug level.
   *
   * @param {string} message
   * @param {boolean} showWarning If FALSE, then the warning message is not displayed
   */
  static warning(e, a = !0) {
    a && console.warn(`Warning: ${e}`);
  }
  /**
   * Return `true` if the given event is an instance of WheelEvent
   *
   * @static
   * @param {event} event The event to test
   * @returns {boolean} Return `true` if the event is an instance of WheelEvent, FALSE otherwise
  */
  static isWheelEvent(e) {
    return e instanceof WheelEvent;
  }
  /**
   * Return `true` if the given event is a wheelup event
   *
   * @param {WheelEvent} wheelEvent
   * @returns {boolean}
   */
  static isWheelUpEvent(e) {
    return (!this.isWheelEvent(e) || this.isUndefinedOrNullOrEmpty(e.deltaY)) && this.throwError(`The event passed as a parameter is not a valid wheel event, '${e.type}' given.`), e.deltaY < 0;
  }
  /**
   * Return `true` if the given event is a wheeldown event
   *
   * @param {WheelEvent} wheelEvent
   * @returns {boolean}
   */
  static isWheelDownEvent(e) {
    return (!this.isWheelEvent(e) || this.isUndefinedOrNullOrEmpty(e.deltaY)) && this.throwError(`The event passed as a parameter is not a valid wheel event, '${e.type}' given.`), e.deltaY > 0;
  }
  /**
   * Return `true` if the given event is an instance of WheelEvent and the deltaY value is equal to zero
   *
   * @param {WheelEvent} wheelEvent The event to test
   * @returns {boolean} Return `true` if the event is an instance of WheelEvent and the deltaY value is equal to zero, FALSE otherwise
   */
  static isWheelEventWithZeroDeltaY(e) {
    return this.isWheelEvent(e) && !this.isUndefinedOrNullOrEmpty(e.deltaY) && e.deltaY === 0;
  }
  /**
   * Return the given raw value truncated at the given number of decimal places `decimalPlaces`.
   * This function does not round the value.
   *
   * @example
   * forceDecimalPlaces(123.45678, 0) -> '123.45678'
   * forceDecimalPlaces(123.45678, 1) -> '123.4'
   * forceDecimalPlaces(123.45678, 2) -> '123.45'
   * forceDecimalPlaces(123.45678, 3) -> '123.456'
   *
   * @param {number} value
   * @param {int} decimalPlaces
   * @returns {number|string}
   */
  static forceDecimalPlaces(e, a) {
    const [i, n] = String(e).split(".");
    return n ? `${i}.${n.substr(0, a)}` : e;
  }
  /**
   * Return the 'nearest rounded' value, according to the given step size.
   * @example roundToNearest(264789, 10000)) => 260000
   *
   * @param {number} value
   * @param {number} stepPlace
   * @returns {*}
   */
  static roundToNearest(e, a = 1e3) {
    return e === 0 ? 0 : (a === 0 && this.throwError("The `stepPlace` used to round is equal to `0`. This value must not be equal to zero."), Math.round(e / a) * a);
  }
  /**
   * Return the 'nearest rounded' value by automatically adding or subtracting the calculated offset to the initial value.
   * This is done without having to pass a step to this function, and based on the size of the given `value`.
   *
   * @example                    Calculated offset
   *           1 ->           1 (1)
   *          14 ->          10 (10)
   *         143 ->         140 (10)
   *       1.278 ->       1.300 (100)
   *      28.456 ->      28.500 (100)
   *     276.345 ->     276.000 (1.000)
   *   4.534.061 ->   4.530.000 (10.000)
   *  66.723.844 ->  66.700.000 (100.000)
   * 257.833.411 -> 258.000.000 (1.000.000)
   *
   *                           Initial   Added   Offset
   * 2 decimalPlacesRawValue : 1.12   -> 2.00   (1)
   * 3 decimalPlacesRawValue : 1.123  -> 2.000  (1)
   *
   * Special case when the `value` to round is between -1 and 1, excluded :
   * @example
   *     Number of             Initial   Result  Calculated
   *     decimal places        value     (add)   offset
   * 2 decimalPlacesRawValue : 0.12   -> 0.13    (0.01) : Math.pow(10, -2)
   * 2 decimalPlacesRawValue : 0.01   -> 0.02    (0.01)
   * 2 decimalPlacesRawValue : 0.00   -> 0.01    (0.01)
   *
   * 3 decimalPlacesRawValue : 0.123  -> 0.133   (0.01)  : Math.pow(10, -2)
   * 3 decimalPlacesRawValue : 0.012  -> 0.013   (0.001) : Math.pow(10, -3)
   * 3 decimalPlacesRawValue : 0.001  -> 0.001   (0.001)
   * 3 decimalPlacesRawValue : 0.000  -> 0.001   (0.001)
   *
   * 4 decimalPlacesRawValue : 0.4123 -> 0.4200  (0.01)   : Math.pow(10, -2)
   * 4 decimalPlacesRawValue : 0.0412 -> 0.0420  (0.001)  : Math.pow(10, -3)
   * 4 decimalPlacesRawValue : 0.0041 -> 0.0042  (0.0001) : Math.pow(10, -4)
   * 4 decimalPlacesRawValue : 0.0004 -> 0.0005  (0.0001)
   * 4 decimalPlacesRawValue : 0.0000 -> 0.0001  (0.0001)
   *
   * @param {number} value
   * @param {boolean} isAddition
   * @param {int} decimalPlacesRawValue The precision needed by the `rawValue`
   * @returns {*}
   */
  static modifyAndRoundToNearestAuto(e, a, i) {
    e = Number(this.forceDecimalPlaces(e, i));
    const n = Math.abs(e);
    if (n >= 0 && n < 1) {
      const o = Math.pow(10, -i);
      if (e === 0)
        return a ? o : -o;
      let d;
      const s = i, c = this.indexFirstNonZeroDecimalPlace(e);
      c >= s - 1 ? d = o : d = Math.pow(10, -(c + 1));
      let m;
      return a ? m = e + d : m = e - d, this.roundToNearest(m, d);
    } else {
      e = parseInt(e, 10);
      const o = Math.abs(e).toString().length;
      let d;
      switch (o) {
        case 1:
          d = 0;
          break;
        case 2:
        case 3:
          d = 1;
          break;
        case 4:
        case 5:
          d = 2;
          break;
        default:
          d = o - 3;
      }
      const s = Math.pow(10, d);
      let c;
      return a ? c = e + s : c = e - s, c <= 10 && c >= -10 ? c : this.roundToNearest(c, s);
    }
  }
  /**
   * Return the 'nearest rounded' value automatically by adding the calculated offset to the initial value.
   * This will limit the result to the given number of decimal places `decimalPlacesLimit`.
   *
   * @param {number} value
   * @param {int} decimalPlacesLimit
   * @returns {*}
   */
  static addAndRoundToNearestAuto(e, a) {
    return this.modifyAndRoundToNearestAuto(e, !0, a);
  }
  /**
   * Return the 'nearest rounded' value automatically by subtracting the calculated offset to the initial value.
   * This will limit the result to the given number of decimal places `decimalPlacesLimit`.
   *
   * @param {number} value
   * @param {int} decimalPlacesLimit
   * @returns {*}
   */
  static subtractAndRoundToNearestAuto(e, a) {
    return this.modifyAndRoundToNearestAuto(e, !1, a);
  }
  /**
   * Take an arabic number as a string and return a javascript number.
   * By default, this function does not try to convert the arabic decimal and thousand separator characters.
   * This returns `NaN` is the conversion is not possible.
   * Based on http://stackoverflow.com/a/17025392/2834898
   *
   * @param {string} arabicNumbers
   * @param {boolean} returnANumber If `true`, return a Number, otherwise return a String
   * @param {boolean} parseDecimalCharacter
   * @param {boolean} parseThousandSeparator
   * @returns {string|number|NaN}
   */
  static arabicToLatinNumbers(e, a = !0, i = !1, n = !1) {
    if (this.isNull(e))
      return e;
    let o = e.toString();
    if (o === "")
      return e;
    if (o.match(/[٠١٢٣٤٥٦٧٨٩۴۵۶]/g) === null)
      return a && (o = Number(o)), o;
    i && (o = o.replace(/٫/, ".")), n && (o = o.replace(/٬/g, "")), o = o.replace(/[٠١٢٣٤٥٦٧٨٩]/g, (s) => s.charCodeAt(0) - 1632).replace(/[۰۱۲۳۴۵۶۷۸۹]/g, (s) => s.charCodeAt(0) - 1776);
    const d = Number(o);
    return isNaN(d) ? d : (a && (o = d), o);
  }
  /**
   * Create a custom event and immediately sent it from the given element.
   * By default, if no element is given, the event is thrown from `document`.
   *
   * @param {string} eventName
   * @param {HTMLElement|HTMLDocument|EventTarget} element
   * @param {object} detail
   * @param {boolean} bubbles Set to `true` if the event must bubble up
   * @param {boolean} cancelable Set to `true` if the event must be cancelable
   */
  static triggerEvent(e, a = document, i = null, n = !0, o = !0) {
    let d;
    window.CustomEvent ? d = new CustomEvent(e, { detail: i, bubbles: n, cancelable: o }) : (d = document.createEvent("CustomEvent"), d.initCustomEvent(e, n, o, { detail: i })), a.dispatchEvent(d);
  }
  /**
   * Function to parse minimumValue, maximumValue & the input value to prepare for testing to determine if the value falls within the min / max range.
   * Return an object example: minimumValue: "999999999999999.99" returns the following "{s: -1, e: 12, c: Array[15]}".
   *
   * This function is adapted from Big.js https://github.com/MikeMcl/big.js/. Many thanks to Mike.
   *
   * @param {number|string} n A numeric value.
   * @returns {{}}
   */
  static parseStr(e) {
    const a = {};
    let i, n, o, d;
    if (e === 0 && 1 / e < 0 && (e = "-0"), e = e.toString(), this.isNegativeStrict(e, "-") ? (e = e.slice(1), a.s = -1) : a.s = 1, i = e.indexOf("."), i > -1 && (e = e.replace(".", "")), i < 0 && (i = e.length), n = e.search(/[1-9]/i) === -1 ? e.length : e.search(/[1-9]/i), o = e.length, n === o)
      a.e = 0, a.c = [0];
    else {
      for (d = o - 1; e.charAt(d) === "0"; d -= 1)
        o -= 1;
      for (o -= 1, a.e = i - n - 1, a.c = [], i = 0; n <= o; n += 1)
        a.c[i] = +e.charAt(n), i += 1;
    }
    return a;
  }
  /**
   * Function to test if the input value falls with the Min / Max settings.
   * This uses the parsed strings for the above parseStr function.
   *
   * This function is adapted from Big.js https://github.com/MikeMcl/big.js/. Many thanks to Mike.
   *
   * @param {object} y Big number instance
   * @param {object} x Big number instance
   * @returns {*}
   */
  static testMinMax(e, a) {
    const i = a.c, n = e.c;
    let o = a.s, d = e.s, s = a.e, c = e.e;
    if (!i[0] || !n[0]) {
      let p;
      return i[0] ? p = o : p = n[0] ? -d : 0, p;
    }
    if (o !== d)
      return o;
    const m = o < 0;
    if (s !== c)
      return s > c ^ m ? 1 : -1;
    for (o = -1, s = i.length, c = n.length, d = s < c ? s : c, o += 1; o < d; o += 1)
      if (i[o] !== n[o])
        return i[o] > n[o] ^ m ? 1 : -1;
    let f;
    return s === c ? f = 0 : f = s > c ^ m ? 1 : -1, f;
  }
  /**
   * Generate a random string.
   * cf. http://stackoverflow.com/a/8084248/2834898
   *
   * @param {Number} strLength Length of the generated string (in character count)
   * @returns {string}
   */
  static randomString(e = 5) {
    return Math.random().toString(36).substr(2, e);
  }
  /**
   * Return the DOM element when passed either a DOM element or a selector string.
   *
   * @param {HTMLElement|string} domElementOrSelector
   * @returns {HTMLElement}
   */
  static domElement(e) {
    let a;
    return l.isString(e) ? a = document.querySelector(e) : a = e, a;
  }
  /**
   * Retrieve the current element value.
   *
   * @param {HTMLElement|HTMLInputElement|EventTarget} element
   * @returns {number|string|null}
   */
  static getElementValue(e) {
    return e.tagName.toLowerCase() === "input" ? e.value : this.text(e);
  }
  /**
   * Modify the element value directly.
   *
   * @param {HTMLElement|HTMLInputElement} element
   * @param {number|string|null} value
   */
  static setElementValue(e, a = null) {
    e.tagName.toLowerCase() === "input" ? e.value = a : e.textContent = a;
  }
  /**
   * Set the invalid state for the given element.
   * A custom message can be passed as the second argument.
   * Note: This does not work with contenteditable elements
   *
   * @param {HTMLElement|HTMLInputElement} element
   * @param {string|null} message
   * @throws Error
   */
  static setInvalidState(e, a = "Invalid") {
    (a === "" || this.isNull(a)) && this.throwError("Cannot set the invalid state with an empty message."), e.setCustomValidity(a);
  }
  /**
   * Set the valid state for the given element.
   * Note: This does not work with contenteditable elements
   *
   * @param {HTMLElement|HTMLInputElement} element
   */
  static setValidState(e) {
    e.setCustomValidity("");
  }
  /**
   * This clone the given object, and return it.
   * WARNING: This does not do a deep cloning.
   * cf. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Examples
   * //TODO Add a `deep` option to clone object with more than one depth
   *
   * @param {object} obj
   * @returns {object}
   */
  static cloneObject(e) {
    return Object.assign({}, e);
  }
  /**
   * Return a 'camelized' version of the given string.
   * By default, this assume that :
   * - the separators are hyphens '-',
   * - the 'data-' string should be removed, and
   * - that the very first word should not be capitalized.
   *
   * @example camelize('data-currency-symbol') => 'currencySymbol'
   *
   * @param {string} str Text to camelize
   * @param {string} separator Character that separate each word
   * @param {boolean} removeData If set to `true`, remove the `data-` part that you can find on some html attributes
   * @param {boolean} skipFirstWord If set to `true`, do not capitalize the very first word
   * @returns {string|null}
   */
  static camelize(e, a = "-", i = !0, n = !0) {
    if (this.isNull(e))
      return null;
    i && (e = e.replace(/^data-/, ""));
    let d = e.split(a).map((s) => `${s.charAt(0).toUpperCase()}${s.slice(1)}`);
    return d = d.join(""), n && (d = `${d.charAt(0).toLowerCase()}${d.slice(1)}`), d;
  }
  /**
   * Return the text component of the given DOM element.
   *
   * @param {Element} domElement
   * @returns {string}
   */
  static text(e) {
    const a = e.nodeType;
    let i;
    return a === Node.ELEMENT_NODE || a === Node.DOCUMENT_NODE || a === Node.DOCUMENT_FRAGMENT_NODE ? i = e.textContent : a === Node.TEXT_NODE ? i = e.nodeValue : i = "", i;
  }
  /**
   * Set the text content of the given DOM element.
   * @param {Element} domElement
   * @param {string} text
   */
  static setText(e, a) {
    const i = e.nodeType;
    (i === Node.ELEMENT_NODE || i === Node.DOCUMENT_NODE || i === Node.DOCUMENT_FRAGMENT_NODE) && (e.textContent = a);
  }
  /**
   * Filter out the given `arr` array with the elements found in `excludedElements`.
   * This returns a new array and does not modify the source.
   * cf. verification here : http://codepen.io/AnotherLinuxUser/pen/XpvrMg?editors=0012
   *
   * @param {Array} arr
   * @param {Array} excludedElements
   * @returns {*|Array.<T>}
   */
  static filterOut(e, a) {
    return e.filter((i) => !this.isInArray(i, a));
  }
  /**
   * Remove the trailing zeros in the decimal part of a number.
   *
   * @param {string} numericString
   * @returns {*}
   */
  static trimPaddedZerosFromDecimalPlaces(e) {
    if (e = String(e), e === "")
      return "";
    const [a, i] = e.split(".");
    if (this.isUndefinedOrNullOrEmpty(i))
      return a;
    const n = i.replace(/0+$/g, "");
    let o;
    return n === "" ? o = a : o = `${a}.${n}`, o;
  }
  /**
   * Return the top-most hovered item by the mouse cursor.
   *
   * @returns {*}
   */
  static getHoveredElement() {
    const e = [...document.querySelectorAll(":hover")];
    return e[e.length - 1];
  }
  /**
   * Return the given array trimmed to the given length.
   * @example arrayTrim([1, 2, 3, 4], 2) -> [1, 2]
   *
   * @param {Array} array
   * @param {Number} length
   * @returns {*}
   */
  static arrayTrim(e, a) {
    const i = e.length;
    return i === 0 || a > i ? e : a < 0 ? [] : (e.length = parseInt(a, 10), e);
  }
  /**
   * Merge all the given arrays by keeping only unique elements, and return an array with de-duplicated values.
   * cf. http://stackoverflow.com/a/27664971/2834898
   *
   * @param {...array} arrays
   * @returns {[*]}
   */
  static arrayUnique(...e) {
    return [...new Set([].concat(...e))];
  }
  /**
   * Merge all the given Maps by keeping only unique elements, and return a new Map with de-duplicated keys.
   *
   * @param {...Map} mapObjects
   * @returns {Map}
   */
  static mergeMaps(...e) {
    return new Map(e.reduce((a, i) => a.concat([...i]), []));
  }
  /**
   * Search the given `value` in the object `obj`, and return the very first key it finds
   *
   * @param {object} obj
   * @param {string|number} value
   * @returns {*|null}
   */
  static objectKeyLookup(e, a) {
    const i = Object.entries(e).find((o) => o[1] === a);
    let n = null;
    return i !== void 0 && (n = i[0]), n;
  }
  /**
   * Insert the single character `char` in the string `str` at the given position `index`
   *
   * @param {string} str
   * @param {string} char
   * @param {int} index
   * @returns {string}
   */
  static insertAt(e, a, i) {
    if (e = String(e), i > e.length)
      throw new Error("The given index is out of the string range.");
    if (a.length !== 1)
      throw new Error("The given string `char` should be only one character long.");
    return e === "" && i === 0 ? a : `${e.slice(0, i)}${a}${e.slice(i)}`;
  }
  /**
   * Convert the given scientific notation to the 'expanded' decimal notation
   *
   * @example scientificToDecimal('-123.4567e-6') returns '-0.0001234567'
   *
   * @param {number|string} val
   * @returns {number|string}
   */
  static scientificToDecimal(e) {
    const a = Number(e);
    if (isNaN(a))
      return NaN;
    if (e = String(e), !(this.contains(e, "e") || this.contains(e, "E")))
      return e;
    let [n, o] = e.split(/e/i);
    const d = n < 0;
    d && (n = n.replace("-", ""));
    const s = +o < 0;
    s && (o = o.replace("-", ""));
    const [c, m] = n.split(/\./);
    let f;
    return s ? (c.length > o ? f = this.insertAt(c, ".", c.length - o) : f = `0.${"0".repeat(o - c.length)}${c}`, f = `${f}${m || ""}`) : m ? (n = `${c}${m}`, o < m.length ? f = this.insertAt(n, ".", +o + c.length) : f = `${n}${"0".repeat(o - m.length)}`) : (n = n.replace(".", ""), f = `${n}${"0".repeat(Number(o))}`), d && (f = `-${f}`), f;
  }
}
class ur {
  constructor(e) {
    if (e === null)
      throw new Error("Invalid AST");
  }
  evaluate(e) {
    if (e == null)
      throw new Error("Invalid AST sub-tree");
    if (e.type === "number")
      return e.value;
    if (e.type === "unaryMinus")
      return -this.evaluate(e.left);
    {
      const a = this.evaluate(e.left), i = this.evaluate(e.right);
      switch (e.type) {
        case "op_+":
          return Number(a) + Number(i);
        case "op_-":
          return a - i;
        case "op_*":
          return a * i;
        case "op_/":
          return a / i;
        default:
          throw new Error(`Invalid operator '${e.type}'`);
      }
    }
  }
}
class S0 {
  /*
  constructor() {
      // this.type = void(0);
      // this.value = 0;
      // this.left = null;
      // this.right = null;
  }
  */
  static createNode(e, a, i) {
    const n = new S0();
    return n.type = e, n.left = a, n.right = i, n;
  }
  static createUnaryNode(e) {
    const a = new S0();
    return a.type = "unaryMinus", a.left = e, a.right = null, a;
  }
  static createLeaf(e) {
    const a = new S0();
    return a.type = "number", a.value = e, a;
  }
}
class hr {
  constructor(e, a, i) {
    this.type = e, this.value = a, this.symbol = i;
  }
}
class mr {
  constructor(e) {
    this.text = e, this.textLength = e.length, this.index = 0, this.token = new hr("Error", 0, 0);
  }
  /**
   * Ignore white spaces and increment the index count until a non-space character is found
   * @private
   */
  _skipSpaces() {
    for (; this.text[this.index] === " " && this.index <= this.textLength; )
      this.index++;
  }
  /**
   * Return the current index
   *
   * @returns {number}
   */
  getIndex() {
    return this.index;
  }
  /**
   * Return the next token object
   *
   * @param {string} decimalCharacter The decimal character to use in the float numbers
   * @returns {Token}
   */
  getNextToken(e = ".") {
    if (this._skipSpaces(), this.textLength === this.index)
      return this.token.type = "EOT", this.token;
    if (l.isDigit(this.text[this.index]))
      return this.token.type = "num", this.token.value = this._getNumber(e), this.token;
    switch (this.token.type = "Error", this.text[this.index]) {
      case "+":
        this.token.type = "+";
        break;
      case "-":
        this.token.type = "-";
        break;
      case "*":
        this.token.type = "*";
        break;
      case "/":
        this.token.type = "/";
        break;
      case "(":
        this.token.type = "(";
        break;
      case ")":
        this.token.type = ")";
        break;
    }
    if (this.token.type !== "Error")
      this.token.symbol = this.text[this.index], this.index++;
    else
      throw new Error(`Unexpected token '${this.token.symbol}' at position '${this.token.index}' in the token function`);
    return this.token;
  }
  /**
   * Return the integer or float number starting from the `this.index` string index
   *
   * @param {string} decimalCharacter The decimal character to use in the float numbers
   *
   * @returns {string}
   * @private
   */
  _getNumber(e) {
    this._skipSpaces();
    const a = this.index;
    for (; this.index <= this.textLength && l.isDigit(this.text[this.index]); )
      this.index++;
    for (this.text[this.index] === e && this.index++; this.index <= this.textLength && l.isDigit(this.text[this.index]); )
      this.index++;
    if (this.index === a)
      throw new Error("No number has been found while it was expected");
    return this.text.substring(a, this.index).replace(e, ".");
  }
}
class fr {
  /**
   * Parse the given string, and generate an abstract syntax tree (AST) from the math expression
   *
   * @param {string} text
   * @param {string} customDecimalCharacter The custom decimal character to use in floats
   * @returns {ASTNode}
   */
  constructor(e, a = ".") {
    return this.text = e, this.decimalCharacter = a, this.lexer = new mr(e), this.token = this.lexer.getNextToken(this.decimalCharacter), this._exp();
  }
  _exp() {
    const e = this._term(), a = this._moreExp();
    return S0.createNode("op_+", e, a);
  }
  _moreExp() {
    let e, a;
    switch (this.token.type) {
      case "+":
        return this.token = this.lexer.getNextToken(this.decimalCharacter), e = this._term(), a = this._moreExp(), S0.createNode("op_+", a, e);
      case "-":
        return this.token = this.lexer.getNextToken(this.decimalCharacter), e = this._term(), a = this._moreExp(), S0.createNode("op_-", a, e);
    }
    return S0.createLeaf(0);
  }
  _term() {
    const e = this._factor(), a = this._moreTerms();
    return S0.createNode("op_*", e, a);
  }
  _moreTerms() {
    let e, a;
    switch (this.token.type) {
      case "*":
        return this.token = this.lexer.getNextToken(this.decimalCharacter), e = this._factor(), a = this._moreTerms(), S0.createNode("op_*", a, e);
      case "/":
        return this.token = this.lexer.getNextToken(this.decimalCharacter), e = this._factor(), a = this._moreTerms(), S0.createNode("op_/", a, e);
    }
    return S0.createLeaf(1);
  }
  _factor() {
    let e, a, i;
    switch (this.token.type) {
      case "num":
        return i = this.token.value, this.token = this.lexer.getNextToken(this.decimalCharacter), S0.createLeaf(i);
      case "-":
        return this.token = this.lexer.getNextToken(this.decimalCharacter), a = this._factor(), S0.createUnaryNode(a);
      case "(":
        return this.token = this.lexer.getNextToken(this.decimalCharacter), e = this._exp(), this._match(")"), e;
      default:
        throw new Error(`Unexpected token '${this.token.symbol}' with type '${this.token.type}' at position '${this.token.index}' in the factor function`);
    }
  }
  _match(e) {
    const a = this.lexer.getIndex() - 1;
    if (this.text[a] === e)
      this.token = this.lexer.getNextToken(this.decimalCharacter);
    else
      throw new Error(`Unexpected token '${this.token.symbol}' at position '${a}' in the match function`);
  }
}
/**
 *               AutoNumeric.js
 *
 * @version      4.10.5
 * @date         2024-02-06 UTC 20:14
 *
 * @authors      2016-2024 Alexandre Bonneau <alexandre.bonneau@linuxfr.eu>
 *               2009-2016 Bob Knothe <bob.knothe@gmail.com>
 * @contributors Sokolov Yura and others, cf. AUTHORS
 * @copyright    Alexandre Bonneau & Robert J. Knothe
 * @since        2009-08-09
 *
 * @summary      AutoNumeric is a standalone Javascript library
 *               that provides live *as-you-type* formatting for
 *               international numbers and currencies.
 *
 * @link         http://autonumeric.org
 * @docs         https://docs.autonumeric.org
 *
 *               Note : Some functions are borrowed from big.js
 * @see          https://github.com/MikeMcl/big.js/
 *
 * Please report any bugs to https://github.com/autoNumeric/autoNumeric
 *
 * @license      Released under the MIT License
 * @link         http://www.opensource.org/licenses/mit-license.php
 *
 * Permission is hereby granted, free of charge, to any person
 * obtaining a copy of this software and associated documentation
 * files (the "Software"), to deal in the Software without
 * restriction, including without limitation the rights to use,
 * copy, modify, merge, publish, distribute, sub license, and/or sell
 * copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following
 * conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
 * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 * OTHER DEALINGS IN THE SOFTWARE.
 */
const u = class u {
  /**
   * Return the autoNumeric version number (for debugging purpose)
   *
   * @returns {string}
   */
  static version() {
    return "4.10.5";
  }
  /**
   * Initialize the AutoNumeric object onto the given DOM element, and attach the settings and related event listeners to it.
   * The options passed as a parameter is an object that contains the settings (i.e. {digitGroupSeparator: ".", decimalCharacter: ",", currencySymbol: '€ '})
   *
   * @example
   * anElement = new AutoNumeric(domElement); // With the default options
   * anElement = new AutoNumeric(domElement, { options }); // With one option object
   * anElement = new AutoNumeric(domElement, 'euroPos'); // With a named pre-defined string
   * anElement = new AutoNumeric(domElement, [{ options1 }, 'euroPos', { options2 }]); // With multiple option objects (the latest option overwriting the previous ones)
   * anElement = new AutoNumeric(domElement, null, { options }); // With one option object, and a failed initial value
   * anElement = new AutoNumeric(domElement).french(); // With one pre-defined language object
   * anElement = new AutoNumeric(domElement).french({ options });// With one pre-defined language object and additional options that will override the defaults
   *
   * // ...or init and set the value in one call :
   * anElement = new AutoNumeric(domElement, 12345.789); // With the default options, and an initial value
   * anElement = new AutoNumeric(domElement, 12345.789, { options });
   * anElement = new AutoNumeric(domElement, '12345.789', { options });
   * anElement = new AutoNumeric(domElement, 12345.789, 'euroPos');
   * anElement = new AutoNumeric(domElement, 12345.789, [{ options1 }, 'euroPos', { options2 }]);
   * anElement = new AutoNumeric(domElement, 12345.789).french({ options });
   * anElement = new AutoNumeric(domElement, 12345.789, { options }).french({ options }); // Not really helpful, but possible
   *
   * // The AutoNumeric constructor class can also accept a string as a css selector. Under the hood this use `QuerySelector` and limit itself to only the first element it finds.
   * anElement = new AutoNumeric('.myCssClass > input');
   * anElement = new AutoNumeric('.myCssClass > input', { options });
   * anElement = new AutoNumeric('.myCssClass > input', 'euroPos');
   * anElement = new AutoNumeric('.myCssClass > input', [{ options1 }, 'euroPos', { options2 }]);
   * anElement = new AutoNumeric('.myCssClass > input', 12345.789);
   * anElement = new AutoNumeric('.myCssClass > input', 12345.789, { options });
   * anElement = new AutoNumeric('.myCssClass > input', 12345.789, 'euroPos');
   * anElement = new AutoNumeric('.myCssClass > input', 12345.789, [{ options1 }, 'euroPos', { options2 }]);
   * anElement = new AutoNumeric('.myCssClass > input', null, { options }); // With a failed initial value
   * anElement = new AutoNumeric('.myCssClass > input', 12345.789).french({ options });
   *
   * @param {object|Array|number|string} arg1
   * @param {object|Array|number|string|null} arg2
   * @param {object|Array|number|string|null} arg3
   * @throws
   */
  constructor(e = null, a = null, i = null) {
    const { domElement: n, initialValue: o, userOptions: d } = u._setArgumentsValues(e, a, i);
    if (this.domElement = n, this.defaultRawValue = "", this._setSettings(d, !1), this._checkElement(), this.savedCancellableValue = null, this.historyTable = [], this.historyTableIndex = -1, this.onGoingRedo = !1, this.parentForm = this._getParentForm(), !this.runOnce && this.settings.formatOnPageLoad)
      this._formatDefaultValueOnPageLoad(o);
    else {
      let s;
      if (l.isNull(o))
        switch (this.settings.emptyInputBehavior) {
          case u.options.emptyInputBehavior.min:
            s = this.settings.minimumValue;
            break;
          case u.options.emptyInputBehavior.max:
            s = this.settings.maximumValue;
            break;
          case u.options.emptyInputBehavior.zero:
            s = "0";
            break;
          case u.options.emptyInputBehavior.focus:
          case u.options.emptyInputBehavior.press:
          case u.options.emptyInputBehavior.always:
            s = "";
            break;
          case u.options.emptyInputBehavior.null:
            s = null;
            break;
          default:
            s = this.settings.emptyInputBehavior;
        }
      else
        s = o;
      this._setElementAndRawValue(s);
    }
    this.runOnce = !0, this.hasEventListeners = !1, (this.isInputElement || this.isContentEditable) && (this.settings.noEventListeners || this._createEventListeners(), this._setWritePermissions(!0)), this._saveInitialValues(o), this.storageNamePrefix = "AUTO_", this._setPersistentStorageName(), this.validState = !0, this.isFocused = !1, this.isWheelEvent = !1, this.isDropEvent = !1, this.isEditing = !1, this.rawValueOnFocus = void 0, this.internalModification = !1, this.attributeToWatch = this._getAttributeToWatch(), this.getterSetter = Object.getOwnPropertyDescriptor(this.domElement.__proto__, this.attributeToWatch), this._addWatcher(), this.settings.createLocalList && this._createLocalList(), this.constructor._addToGlobalList(this), this.global = {
      /**
       * Set the same given element value for each element in the local AutoNumeric element list, and format those elements immediately
       *
       * @param {number|string} newValue The value must be a number or a numeric string
       * @param {object} options A settings object that will override the current settings. Note: the update is done only if the `newValue` is defined.
       */
      set: (s, c = null) => {
        this.autoNumericLocalList.forEach((m) => {
          m.set(s, c);
        });
      },
      /**
       * Set the value given value directly as the DOM element value, without formatting it beforehand.
       * This sets the same unformatted value for each element in the local AutoNumeric element list.
       *
       * @param {number|string} value
       * @param {object} options
       */
      setUnformatted: (s, c = null) => {
        this.autoNumericLocalList.forEach((m) => {
          m.setUnformatted(s, c);
        });
      },
      /**
       * This is an alias of the `getNumericString()` function, and should not be used anymore.
       *
       * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
       * @returns {Array<string>}
       * @deprecated
       */
      get: (s = null) => {
        const c = [];
        return this.autoNumericLocalList.forEach((m) => {
          c.push(m.get());
        }), this._executeCallback(c, s), c;
      },
      /**
       * Return an array of the unformatted values (as a string) of each AutoNumeric element of the local AutoNumeric element list
       *
       * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
       * @returns {Array<string>}
       */
      getNumericString: (s = null) => {
        const c = [];
        return this.autoNumericLocalList.forEach((m) => {
          c.push(m.getNumericString());
        }), this._executeCallback(c, s), c;
      },
      /**
       * Return an array of the current formatted values (as a string) of each AutoNumeric element of the local AutoNumeric element list
       *
       * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
       * @returns {Array<string>}
       */
      getFormatted: (s = null) => {
        const c = [];
        return this.autoNumericLocalList.forEach((m) => {
          c.push(m.getFormatted());
        }), this._executeCallback(c, s), c;
      },
      /**
       * Return an array of the element unformatted values (as a real Javascript number), for each element of the local AutoNumeric element list
       *
       * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
       * @returns {Array<number>}
       */
      getNumber: (s = null) => {
        const c = [];
        return this.autoNumericLocalList.forEach((m) => {
          c.push(m.getNumber());
        }), this._executeCallback(c, s), c;
      },
      /**
       * Returns the unformatted values (following the `outputFormat` setting) of each element of the local AutoNumeric element list into an array
       *
       * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
       * @returns {Array<string>}
       */
      getLocalized: (s = null) => {
        const c = [];
        return this.autoNumericLocalList.forEach((m) => {
          c.push(m.getLocalized());
        }), this._executeCallback(c, s), c;
      },
      /**
       * Force each element of the local AutoNumeric element list to reformat its value
       */
      reformat: () => {
        this.autoNumericLocalList.forEach((s) => {
          s.reformat();
        });
      },
      /**
       * Remove the formatting and keep only the raw unformatted value (as a numericString) in each element of the local AutoNumeric element list
       */
      unformat: () => {
        this.autoNumericLocalList.forEach((s) => {
          s.unformat();
        });
      },
      /**
       * Remove the formatting and keep only the localized unformatted value in the element, with the option to override the default outputFormat if needed
       *
       * @param {null|string} forcedOutputFormat If set to something different from `null`, then this is used as an overriding outputFormat option
       */
      unformatLocalized: (s = null) => {
        this.autoNumericLocalList.forEach((c) => {
          c.unformatLocalized(s);
        });
      },
      /**
       * Updates the AutoNumeric settings, and immediately format the elements accordingly, for each element of the local AutoNumeric element list
       *
       * @param {object} newOptions This can be either one or more option objects
       */
      update: (...s) => {
        this.autoNumericLocalList.forEach((c) => {
          c.update(...s);
        });
      },
      /**
       * Return `true` if *all* the autoNumeric-managed elements are pristine, if their raw value hasn't changed.
       * By default, this returns `true` if the raw unformatted value is still the same even if the formatted one has changed (due to a configuration update for instance).
       *
       * @param {boolean} checkOnlyRawValue If set to `true`, the pristine value is done on the raw unformatted value, not the formatted one. If set to `false`, this also checks that the formatted value hasn't changed.
       * @returns {boolean}
       */
      isPristine: (s = !0) => {
        let c = !0;
        return this.autoNumericLocalList.forEach((m) => {
          c && !m.isPristine(s) && (c = !1);
        }), c;
      },
      /**
       * Execute the `clear()` method on each AutoNumeric object in the local AutoNumeric element list
       *
       * @param {boolean} forceClearAll
       */
      clear: (s = !1) => {
        this.autoNumericLocalList.forEach((c) => {
          c.clear(s);
        });
      },
      /**
       * Execute the `remove()` method on each AutoNumeric object in the local AutoNumeric element list
       */
      remove: () => {
        this.autoNumericLocalList.forEach((s) => {
          s.remove();
        });
      },
      /**
       * Execute the `wipe()` method on each AutoNumeric object in the local AutoNumeric element list
       */
      wipe: () => {
        this.autoNumericLocalList.forEach((s) => {
          s.wipe();
        });
      },
      /**
       * Execute the `nuke()` method on each AutoNumeric object in the local AutoNumeric element list
       */
      nuke: () => {
        this.autoNumericLocalList.forEach((s) => {
          s.nuke();
        });
      },
      /**
       * Return `true` if the given AutoNumeric object (or DOM element) is in the local AutoNumeric element list
       *
       * @param {HTMLElement|HTMLInputElement|AutoNumeric} domElementOrAutoNumericObject
       * @returns {*}
       */
      has: (s) => {
        let c;
        return s instanceof u ? c = this.autoNumericLocalList.has(s.node()) : c = this.autoNumericLocalList.has(s), c;
      },
      /**
       * Add an existing AutoNumeric object (or DOM element) to the local AutoNumeric element list, using the DOM element as the key.
       * This manages the case where `addObject` is used on an AutoNumeric object that already has multiple elements in its local list.
       *
       * @param {HTMLElement|HTMLInputElement|AutoNumeric} domElementOrAutoNumericObject
       */
      addObject: (s) => {
        let c, m;
        s instanceof u ? (c = s.node(), m = s) : (c = s, m = u.getAutoNumericElement(c)), this._hasLocalList() || this._createLocalList();
        let f = m._getLocalList();
        f.size === 0 && (m._createLocalList(), f = m._getLocalList());
        let p;
        f instanceof Map ? p = l.mergeMaps(this._getLocalList(), f) : (this._addToLocalList(c, m), p = this._getLocalList()), p.forEach((b) => {
          b._setLocalList(p);
        });
      },
      /**
       * Remove the given AutoNumeric object (or DOM element) from the local AutoNumeric element list, using the DOM element as the key.
       * If this function attempts to remove the current AutoNumeric object from the local list, a warning is shown, but the deletion is still done.
       *
       * Special cases :
       * - If the current object removes itself, then it's removed from the shared local list, then a new empty local list is used/created
       * - If another object remove this object, then a local list with only this object is used/created
       *
       * @param {HTMLElement|HTMLInputElement|AutoNumeric} domElementOrAutoNumericObject
       * @param {boolean} keepCurrentANObject If set to `false`, then the function will also remove the current AutoNumeric object if asked, otherwise it will ignore it and print a warning message
       */
      removeObject: (s, c = !1) => {
        let m, f;
        s instanceof u ? (m = s.node(), f = s) : (m = s, f = u.getAutoNumericElement(m));
        const p = this.autoNumericLocalList;
        this.autoNumericLocalList.delete(m), p.forEach((b) => {
          b._setLocalList(this.autoNumericLocalList);
        }), !c && m === this.node() ? f._setLocalList(/* @__PURE__ */ new Map()) : f._createLocalList();
      },
      /**
       * Remove all elements from the shared list, effectively emptying it.
       * This is the equivalent of calling `detach()` on each of its elements.
       *
       * @param {boolean} keepEachANObjectInItsOwnList If set to `true`, then instead of completely emptying the local list of each AutoNumeric objects, each one of those keeps itself in its own local list
       */
      empty: (s = !1) => {
        this.autoNumericLocalList.forEach((m) => {
          s ? m._createLocalList() : m._setLocalList(/* @__PURE__ */ new Map());
        });
      },
      /**
       * Return an array containing all the AutoNumeric DOM elements that have been initialized by each other
       *
       * @returns {Array<HTMLElement>}
       */
      elements: () => {
        const s = [];
        return this.autoNumericLocalList.forEach((c) => {
          s.push(c.node());
        }), s;
      },
      /**
       * Return the `Map` object directly
       * @returns {Map}
       */
      getList: () => this.autoNumericLocalList,
      /**
       * Return the number of element in the local AutoNumeric element list
       * @returns {number}
       */
      size: () => this.autoNumericLocalList.size
    }, this.options = {
      /**
       * Reset any options set previously, by overwriting them with the default settings
       *
       * @returns {AutoNumeric}
       */
      reset: () => (this.settings = { rawValue: this.defaultRawValue }, this.update(u.defaultSettings), this),
      allowDecimalPadding: (s) => (this.update({ allowDecimalPadding: s }), this),
      alwaysAllowDecimalCharacter: (s) => (this.update({ alwaysAllowDecimalCharacter: s }), this),
      caretPositionOnFocus: (s) => (this.settings.caretPositionOnFocus = s, this),
      createLocalList: (s) => (this.settings.createLocalList = s, this.settings.createLocalList ? this._hasLocalList() || this._createLocalList() : this._deleteLocalList(), this),
      currencySymbol: (s) => (this.update({ currencySymbol: s }), this),
      currencySymbolPlacement: (s) => (this.update({ currencySymbolPlacement: s }), this),
      decimalCharacter: (s) => (this.update({ decimalCharacter: s }), this),
      decimalCharacterAlternative: (s) => (this.settings.decimalCharacterAlternative = s, this),
      /**
       * Update the decimal places globally, which means this override any previously set number of decimal shown on focus, on blur, or in the raw value.
       *
       * @param {int} decimalPlaces
       * @returns {AutoNumeric}
       */
      decimalPlaces: (s) => (l.warning("Using `options.decimalPlaces()` instead of calling the specific `options.decimalPlacesRawValue()`, `options.decimalPlacesShownOnFocus()` and `options.decimalPlacesShownOnBlur()` methods will reset those options.\nPlease call the specific methods if you do not want to reset those.", this.settings.showWarnings), this.update({ decimalPlaces: s }), this),
      decimalPlacesRawValue: (s) => (this.update({ decimalPlacesRawValue: s }), this),
      decimalPlacesShownOnBlur: (s) => (this.update({ decimalPlacesShownOnBlur: s }), this),
      decimalPlacesShownOnFocus: (s) => (this.update({ decimalPlacesShownOnFocus: s }), this),
      defaultValueOverride: (s) => (this.update({ defaultValueOverride: s }), this),
      digitalGroupSpacing: (s) => (this.update({ digitalGroupSpacing: s }), this),
      digitGroupSeparator: (s) => (this.update({ digitGroupSeparator: s }), this),
      divisorWhenUnfocused: (s) => (this.update({ divisorWhenUnfocused: s }), this),
      emptyInputBehavior: (s) => (this.rawValue === null && s !== u.options.emptyInputBehavior.null && (l.warning(`You are trying to modify the \`emptyInputBehavior\` option to something different than \`'null'\` (${s}), but the element raw value is currently set to \`null\`. This would result in an invalid \`rawValue\`. In order to fix that, the element value has been changed to the empty string \`''\`.`, this.settings.showWarnings), this.rawValue = ""), this.update({ emptyInputBehavior: s }), this),
      eventBubbles: (s) => (this.settings.eventBubbles = s, this),
      eventIsCancelable: (s) => (this.settings.eventIsCancelable = s, this),
      failOnUnknownOption: (s) => (this.settings.failOnUnknownOption = s, this),
      formatOnPageLoad: (s) => (this.settings.formatOnPageLoad = s, this),
      formulaMode: (s) => (this.settings.formulaMode = s, this),
      historySize: (s) => (this.settings.historySize = s, this),
      invalidClass: (s) => (this.settings.invalidClass = s, this),
      isCancellable: (s) => (this.settings.isCancellable = s, this),
      leadingZero: (s) => (this.update({ leadingZero: s }), this),
      maximumValue: (s) => (this.update({ maximumValue: s }), this),
      minimumValue: (s) => (this.update({ minimumValue: s }), this),
      modifyValueOnUpDownArrow: (s) => (this.settings.modifyValueOnUpDownArrow = s, this),
      modifyValueOnWheel: (s) => (this.settings.modifyValueOnWheel = s, this),
      negativeBracketsTypeOnBlur: (s) => (this.update({ negativeBracketsTypeOnBlur: s }), this),
      negativePositiveSignPlacement: (s) => (this.update({ negativePositiveSignPlacement: s }), this),
      negativeSignCharacter: (s) => (this.update({ negativeSignCharacter: s }), this),
      negativePositiveSignBehavior: (s) => (this.settings.negativePositiveSignBehavior = s, this),
      noEventListeners: (s) => (s === u.options.noEventListeners.noEvents && this.settings.noEventListeners === u.options.noEventListeners.addEvents && this._removeEventListeners(), this.update({ noEventListeners: s }), this),
      onInvalidPaste: (s) => (this.settings.onInvalidPaste = s, this),
      outputFormat: (s) => (this.settings.outputFormat = s, this),
      overrideMinMaxLimits: (s) => (this.update({ overrideMinMaxLimits: s }), this),
      positiveSignCharacter: (s) => (this.update({ positiveSignCharacter: s }), this),
      rawValueDivisor: (s) => (this.update({ rawValueDivisor: s }), this),
      readOnly: (s) => (this.settings.readOnly = s, this._setWritePermissions(), this),
      roundingMethod: (s) => (this.update({ roundingMethod: s }), this),
      saveValueToSessionStorage: (s) => (this.update({ saveValueToSessionStorage: s }), this),
      symbolWhenUnfocused: (s) => (this.update({ symbolWhenUnfocused: s }), this),
      selectNumberOnly: (s) => (this.settings.selectNumberOnly = s, this),
      selectOnFocus: (s) => (this.settings.selectOnFocus = s, this),
      serializeSpaces: (s) => (this.settings.serializeSpaces = s, this),
      showOnlyNumbersOnFocus: (s) => (this.update({ showOnlyNumbersOnFocus: s }), this),
      showPositiveSign: (s) => (this.update({ showPositiveSign: s }), this),
      showWarnings: (s) => (this.settings.showWarnings = s, this),
      styleRules: (s) => (this.update({ styleRules: s }), this),
      suffixText: (s) => (this.update({ suffixText: s }), this),
      unformatOnHover: (s) => (this.settings.unformatOnHover = s, this),
      unformatOnSubmit: (s) => (this.settings.unformatOnSubmit = s, this),
      upDownStep: (s) => (this.settings.upDownStep = s, this),
      valuesToStrings: (s) => (this.update({ valuesToStrings: s }), this),
      watchExternalChanges: (s) => (this.update({ watchExternalChanges: s }), this),
      wheelOn: (s) => (this.settings.wheelOn = s, this),
      wheelStep: (s) => (this.settings.wheelStep = s, this)
    }, this._triggerEvent(u.events.initialized, this.domElement, {
      newValue: l.getElementValue(this.domElement),
      newRawValue: this.rawValue,
      error: null,
      aNElement: this
    });
  }
  /**
   * Take the parameters given to the AutoNumeric object, and output the three variables that are needed to finish initializing it :
   * - domElement : The target DOM element
   * - initialValue : The initial value, or `null` if none is given
   * - userOptions : The option object
   *
   * @param {object|Array|number|string} arg1
   * @param {object|Array|number|string|null} arg2
   * @param {object|Array|number|string|null} arg3
   * @returns {{domElement: *, initialValue: *, userOptions: *}}
   * @throws
   * @private
   */
  static _setArgumentsValues(e, a, i) {
    l.isNull(e) && l.throwError("At least one valid parameter is needed in order to initialize an AutoNumeric object");
    const n = l.isElement(e), o = l.isString(e), d = l.isObject(a), s = Array.isArray(a) && a.length > 0, c = l.isNumberOrArabic(a) || a === "", m = this._isPreDefinedOptionValid(a), f = l.isNull(a), p = l.isEmptyString(a), b = l.isObject(i), y = Array.isArray(i) && i.length > 0, v = l.isNull(i), g = this._isPreDefinedOptionValid(i);
    let _, M, S;
    return n && f && v ? (_ = e, S = null, M = null) : n && c && v ? (_ = e, S = a, M = null) : n && d && v ? (_ = e, S = null, M = a) : n && m && v ? (_ = e, S = null, M = this._getOptionObject(a)) : n && s && v ? (_ = e, S = null, M = this.mergeOptions(a)) : n && (f || p) && b ? (_ = e, S = null, M = i) : n && (f || p) && y ? (_ = e, S = null, M = this.mergeOptions(i)) : o && f && v ? (_ = document.querySelector(e), S = null, M = null) : o && d && v ? (_ = document.querySelector(e), S = null, M = a) : o && m && v ? (_ = document.querySelector(e), S = null, M = this._getOptionObject(a)) : o && s && v ? (_ = document.querySelector(e), S = null, M = this.mergeOptions(a)) : o && (f || p) && b ? (_ = document.querySelector(e), S = null, M = i) : o && (f || p) && y ? (_ = document.querySelector(e), S = null, M = this.mergeOptions(i)) : o && c && v ? (_ = document.querySelector(e), S = a, M = null) : o && c && b ? (_ = document.querySelector(e), S = a, M = i) : o && c && g ? (_ = document.querySelector(e), S = a, M = this._getOptionObject(i)) : o && c && y ? (_ = document.querySelector(e), S = a, M = this.mergeOptions(i)) : n && c && b ? (_ = e, S = a, M = i) : n && c && g ? (_ = e, S = a, M = this._getOptionObject(i)) : n && c && y ? (_ = e, S = a, M = this.mergeOptions(i)) : l.throwError(`The parameters given to the AutoNumeric object are not valid, '${e}', '${a}' and '${i}' given.`), l.isNull(_) && l.throwError(`The selector '${e}' did not select any valid DOM element. Please check on which element you called AutoNumeric.`), { domElement: _, initialValue: S, userOptions: M };
  }
  /**
   * Merge the option objects found in the given array `optionsArray`.
   * If a `string` is found, then we try to get the related pre-defined option using that string as its name.
   * When merging the options, the latest option overwrite any previously set. This allows to fine tune a pre-defined option for instance.
   *
   * @param {Array<object|string>} optionsArray
   * @returns {{}}
   */
  static mergeOptions(e) {
    const a = {};
    return e.forEach((i) => {
      Object.assign(a, this._getOptionObject(i));
    }), a;
  }
  /**
   * Return `true` if the given pre-defined option name is an attribute of the `AutoNumeric.predefinedOptions` object
   *
   * @param {string} preDefinedOptionName
   * @returns {boolean}
   * @private
   */
  static _isPreDefinedOptionValid(e) {
    return Object.prototype.hasOwnProperty.call(u.predefinedOptions, e);
  }
  /**
   * Return an option object based on the given parameter.
   * If `optionObjectOrPredefinedName` is as string, then we retrieve the pre-defined option object, if it's an object, we use it as is.
   *
   * @param {object|string} optionObjectOrPredefinedName
   * @returns {object}
   */
  static _getOptionObject(e) {
    let a;
    return l.isString(e) ? (a = u.getPredefinedOptions()[e], a == null && l.warning(`The given pre-defined option [${e}] is not recognized by autoNumeric. Please check that pre-defined option name.`, !0)) : a = e, a;
  }
  /**
   * Save the initial element values for later use in the pristine test.
   * Those values are :
   * - the html attribute (i.e. <input value='42'>), and
   * - the script `value` (i.e. `let domElement.value`)
   *
   * @param {null|number|string} initialValue
   * @private
   */
  _saveInitialValues(e) {
    this.initialValueHtmlAttribute = l.scientificToDecimal(this.domElement.getAttribute("value")), l.isNull(this.initialValueHtmlAttribute) && (this.initialValueHtmlAttribute = ""), this.initialValue = e, l.isNull(this.initialValue) && (this.initialValue = "");
  }
  /**
   * Generate all the event listeners for the given DOM element
   * @private
   */
  _createEventListeners() {
    this.formulaMode = !1, this._onFocusInFunc = (e) => {
      this._onFocusIn(e);
    }, this._onFocusInAndMouseEnterFunc = (e) => {
      this._onFocusInAndMouseEnter(e);
    }, this._onFocusFunc = () => {
      this._onFocus();
    }, this._onKeydownFunc = (e) => {
      this._onKeydown(e);
    }, this._onKeypressFunc = (e) => {
      this._onKeypress(e);
    }, this._onKeyupFunc = (e) => {
      this._onKeyup(e);
    }, this._onFocusOutAndMouseLeaveFunc = (e) => {
      this._onFocusOutAndMouseLeave(e);
    }, this._onPasteFunc = (e) => {
      this._onPaste(e);
    }, this._onWheelFunc = (e) => {
      this._onWheel(e);
    }, this._onDropFunc = (e) => {
      this._onDrop(e);
    }, this._onKeydownGlobalFunc = (e) => {
      this._onKeydownGlobal(e);
    }, this._onKeyupGlobalFunc = (e) => {
      this._onKeyupGlobal(e);
    }, this.domElement.addEventListener("focusin", this._onFocusInFunc, !1), this.domElement.addEventListener("focus", this._onFocusInAndMouseEnterFunc, !1), this.domElement.addEventListener("focus", this._onFocusFunc, !1), this.domElement.addEventListener("mouseenter", this._onFocusInAndMouseEnterFunc, !1), this.domElement.addEventListener("keydown", this._onKeydownFunc, !1), this.domElement.addEventListener("keypress", this._onKeypressFunc, !1), this.domElement.addEventListener("keyup", this._onKeyupFunc, !1), this.domElement.addEventListener("blur", this._onFocusOutAndMouseLeaveFunc, !1), this.domElement.addEventListener("mouseleave", this._onFocusOutAndMouseLeaveFunc, !1), this.domElement.addEventListener("paste", this._onPasteFunc, !1), this.domElement.addEventListener("wheel", this._onWheelFunc, !1), this.domElement.addEventListener("drop", this._onDropFunc, !1), this._setupFormListener(), this.hasEventListeners = !0, u._doesGlobalListExists() || (document.addEventListener("keydown", this._onKeydownGlobalFunc, !1), document.addEventListener("keyup", this._onKeyupGlobalFunc, !1));
  }
  /**
   * Remove all the autoNumeric-related event listeners for the given DOM element
   * @private
   */
  _removeEventListeners() {
    this.domElement.removeEventListener("focusin", this._onFocusInFunc, !1), this.domElement.removeEventListener("focus", this._onFocusInAndMouseEnterFunc, !1), this.domElement.removeEventListener("focus", this._onFocusFunc, !1), this.domElement.removeEventListener("mouseenter", this._onFocusInAndMouseEnterFunc, !1), this.domElement.removeEventListener("blur", this._onFocusOutAndMouseLeaveFunc, !1), this.domElement.removeEventListener("mouseleave", this._onFocusOutAndMouseLeaveFunc, !1), this.domElement.removeEventListener("keydown", this._onKeydownFunc, !1), this.domElement.removeEventListener("keypress", this._onKeypressFunc, !1), this.domElement.removeEventListener("keyup", this._onKeyupFunc, !1), this.domElement.removeEventListener("paste", this._onPasteFunc, !1), this.domElement.removeEventListener("wheel", this._onWheelFunc, !1), this.domElement.removeEventListener("drop", this._onDropFunc, !1), this._removeFormListener(), this.hasEventListeners = !1, document.removeEventListener("keydown", this._onKeydownGlobalFunc, !1), document.removeEventListener("keyup", this._onKeyupGlobalFunc, !1);
  }
  /**
   * Toggle the event listeners according to the `noEventListeners` option, if those were not activated/deactivated before
   * @private
   */
  _updateEventListeners() {
    !this.settings.noEventListeners && !this.hasEventListeners && this._createEventListeners(), this.settings.noEventListeners && this.hasEventListeners && this._removeEventListeners();
  }
  /**
   * Mark the parent <form> so that other AutoNumeric object will not add more listeners.
   * Add a counter so that when removing the AutoNumeric object, we only remove the submit listener if that count is equal to 0.
   * Also keep a reference to the 'submit' event handler function to be able to remove that handler later if the `_removeFormListener()` function is called from another AutoNumeric object.
   *
   * @private
   */
  _setupFormListener() {
    l.isNull(this.parentForm) || (this._onFormSubmitFunc = () => {
      this._onFormSubmit();
    }, this._onFormResetFunc = () => {
      this._onFormReset();
    }, this._hasParentFormCounter() ? this._incrementParentFormCounter() : (this._initializeFormCounterToOne(), this.parentForm.addEventListener("submit", this._onFormSubmitFunc, !1), this.parentForm.addEventListener("reset", this._onFormResetFunc, !1), this._storeFormHandlerFunction()));
  }
  /**
   * Remove the form 'submit' event listener, as well as the `dataset` info (`anCount` and `anFormHandler`) from the parent form, only when there are only one AutoNumeric child element left in that <form>.
   * Otherwise, decrement the `anCount`.
   *
   * @private
   */
  _removeFormListener() {
    if (!l.isNull(this.parentForm)) {
      const e = this._getParentFormCounter();
      e === 1 ? (this.parentForm.removeEventListener("submit", this._getFormHandlerFunction().submitFn, !1), this.parentForm.removeEventListener("reset", this._getFormHandlerFunction().resetFn, !1), this._removeFormDataSetInfo()) : e > 1 ? this._decrementParentFormCounter() : l.throwError("The AutoNumeric object count on the form is incoherent.");
    }
  }
  /**
   * Return `true` if the parent form has the form counter attribute
   *
   * @returns {boolean}
   * @private
   */
  _hasParentFormCounter() {
    return "anCount" in this.parentForm.dataset;
  }
  /**
   * Return the count of AutoNumeric form children
   *
   * @returns {number}
   * @private
   */
  _getParentFormCounter() {
    return Number(this.parentForm.dataset.anCount);
  }
  /**
   * Set the count of AutoNumeric form children to 1 for the given form element, or if none are passed, the current `this.parentForm` one.
   *
   * @param {HTMLFormElement|null} formElement
   * @private
   */
  _initializeFormCounterToOne(e = null) {
    this._getFormElement(e).dataset.anCount = 1;
  }
  /**
   * Increment the AutoNumeric form children count for the given form element, or if none are passed, the current `this.parentForm` one.
   *
   * @param {HTMLFormElement|null} formElement
   * @private
   */
  _incrementParentFormCounter(e = null) {
    this._getFormElement(e).dataset.anCount++;
  }
  /**
   * Decrement the AutoNumeric form children count for the current `this.parentForm` form element.
   *
   * @private
   */
  _decrementParentFormCounter() {
    this.parentForm.dataset.anCount--;
  }
  /**
   * Return `true` if the global form handler list exists on the `window` object.
   *
   * @returns {boolean}
   * @private
   */
  static _doesFormHandlerListExists() {
    const e = typeof window.aNFormHandlerMap;
    return e !== "undefined" && e === "object";
  }
  /**
   * Create the global form handler list on the `window` object.
   *
   * @private
   */
  static _createFormHandlerList() {
    window.aNFormHandlerMap = /* @__PURE__ */ new Map();
  }
  /**
   * Return `true` if the given form element, or if none are passed, the current `this.parentForm` one has a form handler name.
   *
   * @param {HTMLFormElement|null} formElement
   * @returns {boolean}
   * @private
   */
  _hasFormHandlerFunction(e = null) {
    return "anFormHandler" in this._getFormElement(e).dataset;
  }
  /**
   * Return the given form element, or defaults to `this.parentForm` if no argument is passed.
   *
   * @param {HTMLFormElement|null} formElement
   * @returns {*}
   * @private
   */
  _getFormElement(e = null) {
    let a;
    return l.isNull(e) ? a = this.parentForm : a = e, a;
  }
  /**
   * Generate a form handler unique name and store it in the global form handler list.
   * This also save that name in the dataset of the given form element.
   *
   * @param {HTMLFormElement|null} formElement
   * @private
   */
  _storeFormHandlerFunction(e = null) {
    this.constructor._doesFormHandlerListExists() || this.constructor._createFormHandlerList();
    const a = l.randomString();
    this._getFormElement(e).dataset.anFormHandler = a, window.aNFormHandlerMap.set(a, { submitFn: this._onFormSubmitFunc, resetFn: this._onFormResetFunc });
  }
  /**
   * Return the form handler key name from the parent form element, for the global form handler list.
   *
   * @returns {string|*}
   * @private
   */
  _getFormHandlerKey() {
    this._hasFormHandlerFunction() || l.throwError("Unable to retrieve the form handler name");
    const e = this.parentForm.dataset.anFormHandler;
    return e === "" && l.throwError("The form handler name is invalid"), e;
  }
  /**
   * Return the 'submit' event handler function used for the parent form.
   *
   * @returns {function}
   * @private
   */
  _getFormHandlerFunction() {
    const e = this._getFormHandlerKey();
    return window.aNFormHandlerMap.get(e);
  }
  /**
   * Remove the dataset attributes `data-an-count` and `data-an-form-handler` from the parent form element.
   *
   * @private
   */
  _removeFormDataSetInfo() {
    this._decrementParentFormCounter(), window.aNFormHandlerMap.delete(this._getFormHandlerKey()), this.parentForm.removeAttribute("data-an-count"), this.parentForm.removeAttribute("data-an-form-handler");
  }
  /**
   * Set the DOM element write permissions according to the current settings, by setting the `readonly` or `contenteditable` attributes depending on its tag type.
   * If the `useHtmlAttribute` parameter is set to `true`, then the `readonly` html attribute is used and has precedence over the `readOnly` option to set the element as read-only.
   *
   * @param {boolean} useHtmlAttribute If set to `true`, then the write permissions are set by taking into account the html 'readonly' attribute, even if the `readOnly` option is set to false
   * @private
   */
  _setWritePermissions(e = !1) {
    e && this.domElement.readOnly || this.settings.readOnly ? this._setReadOnly() : this._setReadWrite();
  }
  /**
   * Set the element to be read-only.
   * If the DOM element tag is not an `input`, then it `contenteditable` attribute is set to `false`.
   *
   * @private
   */
  _setReadOnly() {
    this.isInputElement ? this.domElement.readOnly = !0 : this.domElement.setAttribute("contenteditable", !1);
  }
  /**
   * Set the element to be read-write.
   *
   * @private
   */
  _setReadWrite() {
    this.isInputElement ? this.domElement.readOnly = !1 : this.domElement.setAttribute("contenteditable", !0);
  }
  /**
   * Add a watcher so that any external change to the AutoNumeric-managed element would be detected.
   * As soon as such change is detected, AutoNumeric then tries to `set()` the value so that it gets formatted and stored in the history.
   * //XXX For now, this only works when watching the `value` attribute, not the `textContent` one
   * @private
   */
  _addWatcher() {
    if (!l.isUndefined(this.getterSetter)) {
      const { set: e, get: a } = this.getterSetter;
      Object.defineProperty(this.domElement, this.attributeToWatch, {
        configurable: !0,
        // This is needed in some rare cases
        get: () => a.call(this.domElement),
        set: (i) => {
          e.call(this.domElement, i), this.settings.watchExternalChanges && !this.internalModification && this.set(i);
        }
      });
    }
  }
  /**
   * Remove the watcher on the AutoNumeric-managed element
   * Note: This needs to be called when the AutoNumeric element is 'removed', otherwise the getter/setter stays on the DOM element and that can lead to problem if the user initialize another AutoNumeric object on it.
   * @private
   */
  _removeWatcher() {
    if (!l.isUndefined(this.getterSetter)) {
      const { set: e, get: a } = this.getterSetter;
      Object.defineProperty(this.domElement, this.attributeToWatch, {
        configurable: !0,
        // This is needed in some rare cases
        get: () => a.call(this.domElement),
        set: (i) => {
          e.call(this.domElement, i);
        }
      });
    }
  }
  /**
   * Return the name of the object attribute that store the current formatted data in the DOM element.
   *
   * @returns {string}
   * @private
   */
  _getAttributeToWatch() {
    let e;
    if (this.isInputElement)
      e = "value";
    else {
      const a = this.domElement.nodeType;
      a === Node.ELEMENT_NODE || a === Node.DOCUMENT_NODE || a === Node.DOCUMENT_FRAGMENT_NODE ? e = "textContent" : a === Node.TEXT_NODE && (e = "nodeValue");
    }
    return e;
  }
  /**
   * Save the current raw value into the history table, along with the selection information.
   *
   * If the user has done some undos and tries to enter:
   * - a new and different number than the 'next' state, this drops the rest of the history table
   * - the very same number that result in the same rawValue as the 'next' state, we only move the history table pointer to the next state
   *
   * @private
   */
  _historyTableAdd() {
    const e = this.historyTable.length === 0;
    if (e || this.rawValue !== this._historyTableCurrentValueUsed()) {
      let a = !0;
      if (!e) {
        const i = this.historyTableIndex + 1;
        i < this.historyTable.length && this.rawValue === this.historyTable[i].value ? a = !1 : l.arrayTrim(this.historyTable, this.historyTableIndex + 1);
      }
      if (this.historyTableIndex++, a) {
        const i = l.getElementSelection(this.domElement);
        this.selectionStart = i.start, this.selectionEnd = i.end, this.historyTable.push({
          // Save the rawValue and selection start/end
          value: this.rawValue,
          // The selection for this element is temporary, and will be updated when the next history state will be recorded.
          // That way, we are always sure we save the last caret or selection positions just before the value is changed. Otherwise, we would only save those positions when the value is first changed, and would not take into account that the user could move the caret around afterward.
          // For instance, this is needed if the user change the element value, and immediately undo it ; if he then does a redo, he'll see the value and the right selection
          // To sum up; The selection position are not always +1 character, since it could also be '2' if a group separator is added when entering one character. That's why the current history state caret/selection position is updated on each `keyup` event.
          start: this.selectionStart + 1,
          // Here we add one since the user added one character too
          end: this.selectionEnd + 1
        }), this.historyTable.length > 1 && (this.historyTable[this.historyTableIndex - 1].start = this.selectionStart, this.historyTable[this.historyTableIndex - 1].end = this.selectionEnd);
      }
      this.historyTable.length > this.settings.historySize && this._historyTableForget();
    }
  }
  /**
   * Debug function for the history table
   * @private
   */
  /*
  _debugHistoryTable() {
      let i = 0;
      let mark;
      this.historyTable.forEach(history => {
          if (this.historyTableIndex === i) {
              mark = '> ';
          } else {
              mark = '';
          }
          console.log(`${mark}${i++}: ${history.value} ${history.start}|${history.end} [onGoingRedo: ${this.onGoingRedo}]`); //DEBUG
      });
  }
  */
  /**
   * 'Undo' or 'Redo' the last/next user entry in the history table.
   * This does not modify the history table, only the pointer to the current state.
   *
   * @param {boolean} undo If set to `true`, then this function does an 'Undo', otherwise it does a 'Redo'
   * @private
   */
  _historyTableUndoOrRedo(e = !0) {
    let a;
    if (e ? (a = this.historyTableIndex > 0, a && this.historyTableIndex--) : (a = this.historyTableIndex + 1 < this.historyTable.length, a && this.historyTableIndex++), a) {
      const i = this.historyTable[this.historyTableIndex];
      this.set(i.value, null, !1), l.setElementSelection(this.domElement, i.start, i.end);
    }
  }
  /**
   * 'Undo' the last user entry by going back one entry in the history table.
   * This keeps the following entries in order to allow for a 'redo'.
   * This does not modify the history table, only the pointer to the current state.
   * @private
   */
  _historyTableUndo() {
    this._historyTableUndoOrRedo(!0);
  }
  /**
   * 'Redo' the next user entry in the history table.
   * This does not modify the history table, only the pointer to the current state.
   * @private
   */
  _historyTableRedo() {
    this._historyTableUndoOrRedo(!1);
  }
  /**
   * Reset the history table to its initial state, and select the value.
   * @private
   */
  /*
  resetHistoryTable() { //FIXME Test this
      this.set(this.rawValue, null, false);
      this.select();
      const selection = AutoNumericHelper.getElementSelection(this.domElement);
      this.historyTableIndex = 0;
      this.historyTable = [{
          // Save the rawValue and selection start/end
          value: this.rawValue,
          start: selection.start,
          end  : selection.end,
      }];
  }
  */
  /**
   * Make the history table forget its first N elements, shifting its indexes in the process.
   * `N` being given as the `numberOfEntriesToForget` parameter.
   *
   * @param {Number} numberOfEntriesToForget
   * @returns {object|Array<object>} The discarded objects, in an Array.
   * @private
   */
  _historyTableForget(e = 1) {
    const a = [];
    for (let i = 0; i < e; i++)
      a.push(this.historyTable.shift()), this.historyTableIndex--, this.historyTableIndex < 0 && (this.historyTableIndex = 0);
    return a.length === 1 ? a[0] : a;
  }
  /**
   * Return the currently used value from the history table.
   *
   * @returns {string|number}
   * @private
   */
  _historyTableCurrentValueUsed() {
    let e = this.historyTableIndex;
    e < 0 && (e = 0);
    let a;
    return l.isUndefinedOrNullOrEmpty(this.historyTable[e]) ? a = "" : a = this.historyTable[e].value, a;
  }
  /**
   * Parse the `styleRules` option and run the test for each given rules, either pre-defined ones like `positive`, `negative` and `ranges`, or user defined callbacks within the `userDefined` attribute.
   * @private
   */
  _parseStyleRules() {
    l.isUndefinedOrNullOrEmpty(this.settings.styleRules) || this.rawValue === "" || (l.isUndefinedOrNullOrEmpty(this.settings.styleRules.positive) || (this.rawValue >= 0 ? this._addCSSClass(this.settings.styleRules.positive) : this._removeCSSClass(this.settings.styleRules.positive)), l.isUndefinedOrNullOrEmpty(this.settings.styleRules.negative) || (this.rawValue < 0 ? this._addCSSClass(this.settings.styleRules.negative) : this._removeCSSClass(this.settings.styleRules.negative)), !l.isUndefinedOrNullOrEmpty(this.settings.styleRules.ranges) && this.settings.styleRules.ranges.length !== 0 && this.settings.styleRules.ranges.forEach((e) => {
      this.rawValue >= e.min && this.rawValue < e.max ? this._addCSSClass(e.class) : this._removeCSSClass(e.class);
    }), !l.isUndefinedOrNullOrEmpty(this.settings.styleRules.userDefined) && this.settings.styleRules.userDefined.length !== 0 && this.settings.styleRules.userDefined.forEach((e) => {
      if (l.isFunction(e.callback))
        if (l.isString(e.classes))
          e.callback(this.rawValue) ? this._addCSSClass(e.classes) : this._removeCSSClass(e.classes);
        else if (l.isArray(e.classes))
          if (e.classes.length === 2)
            e.callback(this.rawValue) ? (this._addCSSClass(e.classes[0]), this._removeCSSClass(e.classes[1])) : (this._removeCSSClass(e.classes[0]), this._addCSSClass(e.classes[1]));
          else if (e.classes.length > 2) {
            const a = e.callback(this.rawValue);
            l.isArray(a) ? e.classes.forEach((i, n) => {
              l.isInArray(n, a) ? this._addCSSClass(i) : this._removeCSSClass(i);
            }) : l.isInt(a) ? e.classes.forEach((i, n) => {
              n === a ? this._addCSSClass(i) : this._removeCSSClass(i);
            }) : l.isNull(a) ? e.classes.forEach((i) => {
              this._removeCSSClass(i);
            }) : l.throwError(`The callback result is not an array nor a valid array index, ${typeof a} given.`);
          } else
            l.throwError("The classes attribute is not valid for the `styleRules` option.");
        else l.isUndefinedOrNullOrEmpty(e.classes) ? e.callback(this) : l.throwError("The callback/classes structure is not valid for the `styleRules` option.");
      else
        l.warning(`The given \`styleRules\` callback is not a function, ${typeof e.callback} given.`, this.settings.showWarnings);
    }));
  }
  /**
   * Add the given CSS class to the DOM element.
   *
   * @param {string} cssClassName
   * @private
   */
  _addCSSClass(e) {
    this.domElement.classList.add(e);
  }
  /**
   * Remove the given CSS class from the DOM element.
   *
   * @param {string} cssClassName
   * @private
   */
  _removeCSSClass(e) {
    this.domElement.classList.remove(e);
  }
  // Those are the public function available on each autoNumeric-managed element
  /**
   * Method that updates the AutoNumeric settings, and immediately format the element accordingly.
   * The options passed as parameter(s) is either one or many objects that each contains some settings, i.e. :
   * {
   *     digitGroupSeparator: ".",
   *     decimalCharacter: ",",
   *     currencySymbol: '€ ',
   * }
   * If multiple options are passed, the latter overwrite the previous ones.
   *
   * Note: If the new settings are not validated, or the call to `set()` fails, then the previous valid settings are reverted back to.
   *
   * @example anElement.update({ options }) // Updates the settings
   * @example anElement.update({ options1 }, { options2 }) // Updates the settings with multiple option objects
   * @example anElement.update([{ options1 }, { options2 }]) // Updates the settings with multiple option objects in a single array
   *
   * @param {object|string|array} newOptions
   * @returns {AutoNumeric}
   */
  update(...e) {
    Array.isArray(e) && Array.isArray(e[0]) && (e = e[0]);
    const a = l.cloneObject(this.settings), i = this.rawValue;
    let n = {};
    l.isUndefinedOrNullOrEmpty(e) || e.length === 0 ? n = null : e.length >= 1 && e.forEach((o) => {
      this.constructor._isPreDefinedOptionValid(o) && (o = this.constructor._getOptionObject(o)), Object.assign(n, o);
    });
    try {
      this._setSettings(n, !0), this._setWritePermissions(), this._updateEventListeners(), this.set(i);
    } catch (o) {
      return this._setSettings(a, !0), l.throwError(`Unable to update the settings, those are invalid: [${o}]`), this;
    }
    return this;
  }
  /**
   * Return the options object containing all the current autoNumeric settings in effect.
   * You can then directly access each option by using its name : `anElement.getSettings().optionNameAutoCompleted`.
   *
   * @example
   * anElement.getSettings()
   * anElement.getSettings().decimalCharacter // Return the decimalCharacter setting as a string - any valid option name can be used
   *
   * @returns {object}
   */
  getSettings() {
    return this.settings;
  }
  /**
   * Set the given element value, and format it immediately.
   * Additionally, this `set()` method can accept options that will be merged into the current AutoNumeric element, taking precedence over any previous settings.
   *
   * @example anElement.set('12345.67') // Formats the value
   * @example anElement.set(12345.67) // Formats the value
   * @example anElement.set(12345.67, { decimalCharacter : ',' }) // Update the settings and formats the value in one go
   * @example anElement.northAmerican().set('$12,345.67') // Set an already formatted value (this does not _exactly_ respect the currency symbol/negative placements, but only remove all non-numbers characters, according to the ones given in the settings)
   * @example anElement.set(null) // Set the rawValue and element value to `null`
   *
   * @param {number|string|null} newValue The value must be a Number, a numeric string or `null` (if `emptyInputBehavior` is set to `'null'`)
   * @param {object} options A settings object that will override the current settings. Note: the update is done only if the `newValue` is defined.
   * @param {boolean} saveChangeToHistory If set to `true`, then the change is recorded in the history table
   * @returns {AutoNumeric}
   * @throws
   */
  set(e, a = null, i = !0) {
    if (l.isUndefined(e))
      return l.warning("You are trying to set an 'undefined' value ; an error could have occurred.", this.settings.showWarnings), this;
    if (l.isNull(a) || this._setSettings(a, !0), e === null && this.settings.emptyInputBehavior !== u.options.emptyInputBehavior.null)
      return l.warning(`You are trying to set the \`null\` value while the \`emptyInputBehavior\` option is set to ${this.settings.emptyInputBehavior}. If you want to be able to set the \`null\` value, you need to change the 'emptyInputBehavior' option to \`'null'\`.`, this.settings.showWarnings), this;
    let n;
    if (e === null)
      return this._setElementAndRawValue(null, null, i), this._saveValueToPersistentStorage(), this;
    if (n = this.constructor._toNumericValue(e, this.settings), isNaN(Number(n)))
      return l.warning("The value you are trying to set results in `NaN`. The element value is set to the empty string instead.", this.settings.showWarnings), this.setValue("", i), this;
    if (n === "")
      switch (this.settings.emptyInputBehavior) {
        case u.options.emptyInputBehavior.zero:
          n = 0;
          break;
        case u.options.emptyInputBehavior.min:
          n = this.settings.minimumValue;
          break;
        case u.options.emptyInputBehavior.max:
          n = this.settings.maximumValue;
          break;
        default:
          l.isNumber(this.settings.emptyInputBehavior) && (n = Number(this.settings.emptyInputBehavior));
      }
    if (n !== "") {
      const [o, d] = this.constructor._checkIfInRangeWithOverrideOption(n, this.settings);
      if (o && d && this.settings.valuesToStrings && this._checkValuesToStrings(n))
        return this._setElementAndRawValue(this.settings.valuesToStrings[n], n, i), this._saveValueToPersistentStorage(), this;
      if (l.isZeroOrHasNoValue(n) && (n = "0"), o && d) {
        let c = this.constructor._roundRawValue(n, this.settings);
        return c = this._trimLeadingAndTrailingZeros(c.replace(this.settings.decimalCharacter, ".")), n = this._getRawValueToFormat(n), this.isFocused ? n = this.constructor._roundFormattedValueShownOnFocus(n, this.settings) : (this.settings.divisorWhenUnfocused && (n = n / this.settings.divisorWhenUnfocused, n = n.toString()), n = this.constructor._roundFormattedValueShownOnBlur(n, this.settings)), n = this.constructor._modifyNegativeSignAndDecimalCharacterForFormattedValue(n, this.settings), n = this.constructor._addGroupSeparators(n, this.settings, this.isFocused, this.rawValue, c), !this.isFocused && this.settings.symbolWhenUnfocused && (n = `${n}${this.settings.symbolWhenUnfocused}`), (this.settings.decimalPlacesShownOnFocus || this.settings.divisorWhenUnfocused) && this._saveValueToPersistentStorage(), this._setElementAndRawValue(n, c, i), this._setValidOrInvalidState(c), this;
      } else
        return this._triggerRangeEvents(o, d), l.throwError(`The value [${n}] being set falls outside of the minimumValue [${this.settings.minimumValue}] and maximumValue [${this.settings.maximumValue}] range set for this element`), this._removeValueFromPersistentStorage(), this.setValue("", i), this;
    } else {
      let o;
      return this.settings.emptyInputBehavior === u.options.emptyInputBehavior.always ? o = this.settings.currencySymbol : o = "", this._setElementAndRawValue(o, "", i), this;
    }
  }
  /**
   * Set the given value directly as the DOM element value, without formatting it beforehand.
   * You can also set the value and update the setting in one go (the value will again not be formatted immediately).
   *
   * @param {number|string} value
   * @param {object} options
   * @returns {AutoNumeric}
   * @throws
   */
  setUnformatted(e, a = null) {
    if (e === null || l.isUndefined(e))
      return this;
    l.isNull(a) || this._setSettings(a, !0);
    const i = this.constructor._removeBrackets(e, this.settings), n = this.constructor._stripAllNonNumberCharacters(i, this.settings, !0, this.isFocused);
    return l.isNumber(n) || l.throwError("The value is not a valid one, it's not a numeric string nor a recognized currency."), this.constructor._isWithinRangeWithOverrideOption(n, this.settings) ? this.setValue(e) : l.throwError(`The value is out of the range limits [${this.settings.minimumValue}, ${this.settings.maximumValue}].`), this;
  }
  /**
   * Set the given value directly as the DOM element value, without formatting it beforehand, and without checking its validity.
   * This also updates the `rawValue` with the given `newValue`, without checking it too ; if it's not formatted like a number recognized by Javascript, this *will* likely make other AutoNumeric methods fail.
   *
   * @param {string|number|null} newValue The new value to set on the element
   * @param {boolean} saveChangeToHistory If set to `true`, then the change is recorded in the history array, otherwise it is not
   * @returns {AutoNumeric}
   */
  setValue(e, a = !0) {
    return this._setElementAndRawValue(e, a), this;
  }
  /**
   * Save the raw value inside the AutoNumeric object.
   *
   * @param {number|string|null} rawValue The numeric value as understood by Javascript like a `Number`
   * @param {boolean} saveChangeToHistory If set to `true`, then the change is recorded in the history array, otherwise it is not
   * @private
   */
  _setRawValue(e, a = !0) {
    if (this.rawValue !== e) {
      const i = this.rawValue;
      this.rawValue = e, !l.isNull(this.settings.rawValueDivisor) && this.settings.rawValueDivisor !== 0 && // Only divide if the `rawValueDivisor` option is set
      e !== "" && e !== null && // Do not modify the `rawValue` if it's an empty string or null
      this._isUserManuallyEditingTheValue() && (this.rawValue /= this.settings.rawValueDivisor), this._triggerEvent(u.events.rawValueModified, this.domElement, {
        oldRawValue: i,
        newRawValue: this.rawValue,
        isPristine: this.isPristine(!0),
        error: null,
        aNElement: this
      }), this._parseStyleRules(), a && window.requestAnimationFrame(() => this._historyTableAdd());
    }
  }
  /**
   * Set the given value on the DOM element, without affecting the `rawValue`.
   * This sends an 'autoNumeric:formatted' event if the new value is different from the old one.
   *
   * @param {number|string} newElementValue
   * @param {boolean} sendFormattedEvent If set to `true`, then the `AutoNumeric.events.formatted` event is sent if the value has changed
   * @returns {AutoNumeric}
   * @private
   */
  _setElementValue(e, a = !0) {
    const i = l.getElementValue(this.domElement);
    return e !== i && (this.internalModification = !0, l.setElementValue(this.domElement, e), this.internalModification = !1, a && this._triggerEvent(u.events.formatted, this.domElement, {
      oldValue: i,
      newValue: e,
      oldRawValue: this.rawValue,
      newRawValue: this.rawValue,
      isPristine: this.isPristine(!1),
      error: null,
      aNElement: this
    })), this;
  }
  /**
   * Set the given value on the DOM element, and the raw value on `this.rawValue`, if both are given.
   * If only one value is given, then both the DOM element value and the raw value are set with that value.
   * The third argument `saveChangeToHistory` defines if the change should be recorded in the history array.
   * Note: if the second argument `rawValue` is a boolean, we consider that is really is the `saveChangeToHistory` argument.
   *
   * @param {number|string|null} newElementValue
   * @param {number|string|null|boolean} rawValue
   * @param {boolean} saveChangeToHistory
   * @returns {AutoNumeric}
   * @private
   */
  _setElementAndRawValue(e, a = null, i = !0) {
    return l.isNull(a) ? a = e : l.isBoolean(a) && (i = a, a = e), this._setElementValue(e), this._setRawValue(a, i), this;
  }
  /**
   * Return the multiplied raw value with the `rawValueDivisor`.
   * This is used to display different values between the raw and formatted values.
   *
   * @param {number|string|null} rawValue The numeric value as understood by Javascript like a `Number`
   * @returns {number|string|null}
   * @private
   */
  _getRawValueToFormat(e) {
    let a;
    return !l.isNull(this.settings.rawValueDivisor) && this.settings.rawValueDivisor !== 0 && // Only multiply if the `rawValueDivisor` option is set
    e !== "" && e !== null ? a = e * this.settings.rawValueDivisor : a = e, a;
  }
  /**
   * Check if the given value has a corresponding key in the `valuesToStrings` option object.
   *
   * @param {number|string} value
   * @returns {boolean} Returns `true` if such a key is found.
   * @private
   */
  _checkValuesToStrings(e) {
    return this.constructor._checkValuesToStringsArray(e, this.valuesToStringsKeys);
  }
  /**
   * Check if the given value has a corresponding key in the `stringsArray` array.
   *
   * @param {number|string} key
   * @param {array} stringsArray Array where the `key` is checked against its keys
   * @returns {boolean} Returns `true` if such a key is found.
   * @private
   */
  static _checkValuesToStringsArray(e, a) {
    return l.isInArray(String(e), a);
  }
  /**
   * Static helper for checking if the given `key` is found in the settings' `valuesToStrings` option object.
   *
   * @param {number|string} key
   * @param {object} settings
   * @returns {boolean}
   * @private
   */
  static _checkValuesToStringsSettings(e, a) {
    return this._checkValuesToStringsArray(e, Object.keys(a.valuesToStrings));
  }
  /**
   * Static helper for checking if the given `value` is found in the settings' `valuesToStrings` option object.
   *
   * @param {number|string} value
   * @param {object} settings
   * @returns {boolean}
   * @private
   */
  static _checkStringsToValuesSettings(e, a) {
    return this._checkValuesToStringsArray(e, Object.values(a.valuesToStrings));
  }
  /**
   * Return `true` if the user is currently modifying the element value manually.
   *
   * @returns {boolean}
   * @private
   */
  _isUserManuallyEditingTheValue() {
    return this.isFocused && this.isEditing || this.isDropEvent;
  }
  /**
   * Execute the given callback function using the given result as its first parameter, and the AutoNumeric object as its second.
   *
   * @param {number|string|Array|null} result
   * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
   * @private
   */
  _executeCallback(e, a) {
    !l.isNull(a) && l.isFunction(a) && a(e, this);
  }
  /**
   * Trigger the given event on the given element with the given detail.
   * This takes into account the `eventBubbles` and `eventIsCancelable` options.
   *
   * @param {string} eventName
   * @param {HTMLElement|HTMLDocument|EventTarget} element
   * @param {object} detail
   * @private
   */
  _triggerEvent(e, a = document, i = null) {
    l.triggerEvent(e, a, i, this.settings.eventBubbles, this.settings.eventIsCancelable);
  }
  /**
   * Alias of the `getNumericString()` function.
   * Developers should use one of the more explicit function names to get what they want :
   * - a numeric string : `getNumericString()`
   * - a formatted string : `getFormatted()`
   * - a number : `getNumber()`, or
   * - a localized numeric string : `getLocalized()`
   *
   * @usage anElement.get();
   *
   * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
   *
   * @deprecated
   * @returns {string|null}
   */
  get(e = null) {
    return this.getNumericString(e);
  }
  /**
   * Return the unformatted value as a string.
   * This can also return `null` if `rawValue` is null.
   *
   * @usage anElement.getNumericString();
   *
   * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
   *
   * @returns {string|null}
   */
  getNumericString(e = null) {
    let a;
    return l.isNull(this.rawValue) ? a = null : a = l.trimPaddedZerosFromDecimalPlaces(this.rawValue), this._executeCallback(a, e), a;
  }
  /**
   * Return the current formatted value of the AutoNumeric element as a string
   *
   * @usage anElement.getFormatted()
   *
   * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
   *
   * @returns {string}
   */
  getFormatted(e = null) {
    "value" in this.domElement || "textContent" in this.domElement || l.throwError("Unable to get the formatted string from the element.");
    const a = l.getElementValue(this.domElement);
    return this._executeCallback(a, e), a;
  }
  /**
   * Return the element unformatted value as a real Javascript number.
   * Warning: This can lead to precision problems with big numbers that should be stored as strings.
   *
   * @usage anElement.getNumber()
   *
   * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
   *
   * @returns {number|null}
   */
  getNumber(e = null) {
    let a;
    return this.rawValue === null ? a = null : a = this.constructor._toLocale(this.getNumericString(), "number", this.settings), this._executeCallback(a, e), a;
  }
  /**
   * Returns the unformatted value, but following the `outputFormat` setting, which means the output can either be :
   * - a string (that could or could not represent a number (i.e. "12345,67-")), or
   * - a plain number (if the setting 'number' is used).
   *
   * By default, the returned values are an ISO numeric string "1234.56" or "-1234.56" where the decimal character is a period.
   * Check the "outputFormat" option definition for more details.
   *
   * @usage anElement.getLocalized();
   *
   * @param {null|string|function} forcedOutputFormat If set to something different from `null`, then this is used as an overriding outputFormat option
   * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
   *
   * @returns {*}
   */
  getLocalized(e = null, a = null) {
    l.isFunction(e) && l.isNull(a) && (a = e, e = null);
    let i;
    l.isEmptyString(this.rawValue) ? i = "" : i = "" + Number(this.rawValue), i !== "" && Number(i) === 0 && this.settings.leadingZero !== u.options.leadingZero.keep && (i = "0");
    let n;
    l.isNull(e) ? n = this.settings.outputFormat : n = e;
    const o = this.constructor._toLocale(i, n, this.settings);
    return this._executeCallback(o, a), o;
  }
  /**
   * Force the element to reformat its value again (just in case the formatting has been lost).
   * This can be used right after a form submission for instance (after a previous call to `unformat`).
   *
   * @example anElement.reformat()
   *
   * @returns {AutoNumeric}
   */
  reformat() {
    return this.set(this.rawValue), this;
  }
  /**
   * Remove the formatting and keep only the raw unformatted value in the element (as a numericString)
   * Note: this is loosely based on the previous 'unSet()' function
   *
   * By default, values are returned as ISO numeric strings (i.e. "1234.56" or "-1234.56"), where the decimal character is a period.
   * @example anElement.unformat()
   *
   * @returns {AutoNumeric}
   */
  unformat() {
    return this._setElementValue(this.getNumericString()), this;
  }
  /**
   * Remove the formatting and keep only the localized unformatted value in the element, with the option to override the default outputFormat if needed
   *
   * Locale formats are supported "1234.56-" or "1234,56" or "-1234,56 or "1234,56-", or even plain numbers.
   * Take a look at the `outputFormat` option definition in the default settings for more details.
   *
   * @param {null|string} forcedOutputFormat If set to something different from `null`, then this is used as an overriding outputFormat option
   * @returns {AutoNumeric}
   */
  unformatLocalized(e = null) {
    return this._setElementValue(this.getLocalized(e)), this;
  }
  /**
   * Return `true` if the current value is the same as when the element got initialized.
   * Note: By default, this returns `true` if the raw unformatted value is still the same even if the formatted one has changed (due to a configuration update for instance).
   * In order to test if the formatted value is the same (which means neither the raw value nor the settings have been changed), then you must pass `false` as its argument.
   *
   * @param {boolean} checkOnlyRawValue If set to `true`, the pristine value is done on the raw unformatted value, not the formatted one.  If set to `false`, this also checks that the formatted value hasn't changed.
   * @returns {boolean}
   */
  isPristine(e = !0) {
    let a;
    return e ? a = this.initialValue === this.getNumericString() : a = this.initialValueHtmlAttribute === this.getFormatted(), a;
  }
  /**
   * Select the formatted element content, based on the `selectNumberOnly` option
   *
   * @returns {AutoNumeric}
   */
  select() {
    return this.settings.selectNumberOnly ? this.selectNumber() : this._defaultSelectAll(), this;
  }
  /**
   * Select the whole element content (including the currency symbol).
   * @private
   */
  _defaultSelectAll() {
    l.setElementSelection(this.domElement, 0, l.getElementValue(this.domElement).length);
  }
  /**
   * Select only the numbers in the formatted element content, leaving out the currency symbol, whatever the value of the `selectNumberOnly` option
   *
   * @returns {AutoNumeric}
   */
  selectNumber() {
    const e = l.getElementValue(this.domElement), a = e.length, i = this.settings.currencySymbol.length, n = this.settings.currencySymbolPlacement, o = l.isNegative(e, this.settings.negativeSignCharacter) ? 1 : 0, d = this.settings.suffixText.length;
    let s;
    n === u.options.currencySymbolPlacement.suffix ? s = 0 : this.settings.negativePositiveSignPlacement === u.options.negativePositiveSignPlacement.left && o === 1 && i > 0 ? s = i + 1 : s = i;
    let c;
    if (n === u.options.currencySymbolPlacement.prefix)
      c = a - d;
    else
      switch (this.settings.negativePositiveSignPlacement) {
        case u.options.negativePositiveSignPlacement.left:
          c = a - (d + i);
          break;
        case u.options.negativePositiveSignPlacement.right:
          i > 0 ? c = a - (i + o + d) : c = a - (i + d);
          break;
        default:
          c = a - (i + d);
      }
    return l.setElementSelection(this.domElement, s, c), this;
  }
  /**
   * Select only the integer part in the formatted element content, whatever the value of `selectNumberOnly`
   *
   * @returns {AutoNumeric}
   */
  selectInteger() {
    let e = 0;
    const a = this.rawValue >= 0;
    (this.settings.currencySymbolPlacement === u.options.currencySymbolPlacement.prefix || this.settings.currencySymbolPlacement === u.options.currencySymbolPlacement.suffix && (this.settings.negativePositiveSignPlacement === u.options.negativePositiveSignPlacement.prefix || this.settings.negativePositiveSignPlacement === u.options.negativePositiveSignPlacement.none)) && (this.settings.showPositiveSign && a || // This only exclude the positive sign from being selected
    !a && this.settings.currencySymbolPlacement === u.options.currencySymbolPlacement.prefix && this.settings.negativePositiveSignPlacement === u.options.negativePositiveSignPlacement.left) && (e = e + 1), this.settings.currencySymbolPlacement === u.options.currencySymbolPlacement.prefix && (e = e + this.settings.currencySymbol.length);
    const i = l.getElementValue(this.domElement);
    let n = i.indexOf(this.settings.decimalCharacter);
    return n === -1 && (this.settings.currencySymbolPlacement === u.options.currencySymbolPlacement.suffix ? n = i.length - this.settings.currencySymbol.length : n = i.length, !a && (this.settings.negativePositiveSignPlacement === u.options.negativePositiveSignPlacement.suffix || this.settings.currencySymbolPlacement === u.options.currencySymbolPlacement.suffix) && (n = n - 1), n = n - this.settings.suffixText.length), l.setElementSelection(this.domElement, e, n), this;
  }
  /**
   * Select only the decimal part in the formatted element content, whatever the value of `selectNumberOnly`
   * Multiple cases are possible :
   * +1.234,57suffixText
   *
   * € +1.234,57suffixText
   * +€ 1.234,57suffixText
   * € 1.234,57+suffixText
   *
   * 1.234,57+ €suffixText
   * 1.234,57 €+suffixText
   * +1.234,57 €suffixText
   *
   * @returns {AutoNumeric}
   */
  selectDecimal() {
    let e = l.getElementValue(this.domElement).indexOf(this.settings.decimalCharacter), a;
    if (e === -1)
      e = 0, a = 0;
    else {
      e = e + 1;
      let i;
      this.isFocused ? i = this.settings.decimalPlacesShownOnFocus : i = this.settings.decimalPlacesShownOnBlur, a = e + Number(i);
    }
    return l.setElementSelection(this.domElement, e, a), this;
  }
  /**
   * Return the DOM element reference of the autoNumeric-managed element
   *
   * @returns {HTMLElement|HTMLInputElement}
   */
  node() {
    return this.domElement;
  }
  /**
   * Return the DOM element reference of the parent node of the autoNumeric-managed element
   *
   * @returns {HTMLElement|HTMLInputElement|Node}
   */
  parent() {
    return this.domElement.parentNode;
  }
  /**
   * Detach the current AutoNumeric element from the shared local 'init' list.
   * This means any changes made on that local shared list will not be transmitted to that element anymore.
   * Note : The user can provide another AutoNumeric element, and detach this one instead of the current one.
   *
   * @param {AutoNumeric} otherAnElement
   * @returns {AutoNumeric}
   */
  detach(e = null) {
    let a;
    return l.isNull(e) ? a = this.domElement : a = e.node(), this._removeFromLocalList(a), this;
  }
  /**
   * Attach the given AutoNumeric element to the shared local 'init' list.
   * When doing that, by default the DOM content is left untouched.
   * The user can force a reformat with the new shared list options by passing a second argument to `true`.
   *
   * @param {AutoNumeric} otherAnElement
   * @param {boolean} reFormat
   * @returns {AutoNumeric}
   */
  attach(e, a = !0) {
    return this._addToLocalList(e.node()), a && e.update(this.settings), this;
  }
  /**
   * Format and return the given value, or set the formatted value into the given DOM element if one is passed as an argument.
   * By default, this use the current element settings.
   * The user can override any option of its choosing by passing an option object.
   *
   * @param {number|HTMLElement|HTMLInputElement} valueOrElement
   * @param {null|object} optionOverride
   * @returns {string|null}
   */
  formatOther(e, a = null) {
    return this._formatOrUnformatOther(!0, e, a);
  }
  /**
       * Unformat and return the raw numeric string corresponding to the given value, or directly set the unformatted value into the given DOM element if one is passed as an argument.
       * By default, this use the current element settings.
       * The user can override any option of its choosing by passing an option object.
  
       * @param {string|HTMLElement|HTMLInputElement} stringOrElement
       * @param {null|object} optionOverride
       * @returns {string|null}
       */
  unformatOther(e, a = null) {
    return this._formatOrUnformatOther(!1, e, a);
  }
  /**
   * Method that either format or unformat the value of another element.
   *
   * - Format and return the given value, or set the formatted value into the given DOM element if one is passed as an argument.
   * - Unformat and return the raw numeric string corresponding to the given value, or directly set the unformatted value into the given DOM element if one is passed as an argument.
   *
   * By default, this use the current element settings.
   * The user can override any option of its choosing by passing an option object.
   *
   * @param {boolean} isFormatting If set to `true`, then the method formats, otherwise if set to `false`, it unformats
   * @param {number|string|HTMLElement|HTMLInputElement} valueOrStringOrElement
   * @param {null|object} optionOverride
   * @returns {string|null}
   * @private
   */
  _formatOrUnformatOther(e, a, i = null) {
    let n;
    l.isNull(i) ? n = this.settings : n = this._cloneAndMergeSettings(i);
    let o;
    if (l.isElement(a)) {
      const d = l.getElementValue(a);
      return e ? o = u.format(d, n) : o = u.unformat(d, n), l.setElementValue(a, o), null;
    }
    return e ? o = u.format(a, n) : o = u.unformat(a, n), o;
  }
  /**
   * Use the current AutoNumeric element settings to initialize the DOM element(s) given as a parameter.
   * Doing so will *link* the AutoNumeric elements together since they will share the same local AutoNumeric element list.
   * (cf. prototype pattern : https://en.wikipedia.org/wiki/Prototype_pattern)
   *
   * You can `init` either a single DOM element (in that case an AutoNumeric object will be returned), or an array of DOM elements or a string that will be used as a CSS selector. In the latter cases, an array of AutoNumeric objects will then be returned (or an empty array if nothing gets selected by the CSS selector).
   *
   * Use case : Once you have an AutoNumeric element already setup correctly with the right options, you can use it as many times you want to initialize as many other DOM elements as needed.
   * Note : this works only on elements that can be managed by autoNumeric.
   *
   * @param {HTMLElement|HTMLInputElement|Array<HTMLElement|HTMLInputElement>|string} domElementOrArrayOrString
   * @param {boolean} attached If set to `false`, then the newly generated AutoNumeric element will not share the same local element list
   * @returns {AutoNumeric|[AutoNumeric]}
   */
  init(e, a = !0) {
    let i = !1, n = [];
    if (l.isString(e) ? n = [...document.querySelectorAll(e)] : l.isElement(e) ? (n.push(e), i = !0) : l.isArray(e) ? n = e : l.throwError("The given parameters to the 'init' function are invalid."), n.length === 0)
      return l.warning("No valid DOM elements were given hence no AutoNumeric object were instantiated.", !0), [];
    const o = this._getLocalList(), d = [];
    return n.forEach((s) => {
      const c = this.settings.createLocalList;
      a && (this.settings.createLocalList = !1);
      const m = new u(s, l.getElementValue(s), this.settings);
      a && (m._setLocalList(o), this._addToLocalList(s, m), this.settings.createLocalList = c), d.push(m);
    }), i ? d[0] : d;
  }
  /**
   * Reset the element value either to the empty string '', or the currency sign, depending on the `emptyInputBehavior` option value.
   * If you set the `forceClearAll` argument to `true`, then the `emptyInputBehavior` option is overridden and the whole input is clear, including any currency sign.
   *
   * @param {boolean} forceClearAll
   * @returns {AutoNumeric}
   */
  clear(e = !1) {
    if (e) {
      const a = {
        emptyInputBehavior: u.options.emptyInputBehavior.focus
      };
      this.set("", a);
    } else
      this.set("");
    return this;
  }
  /**
   * Remove the autoNumeric data and event listeners from the element, but keep the element content intact.
   * This also clears the value from sessionStorage (or cookie, depending on browser supports).
   * Note: this does not remove the formatting.
   *
   * @example anElement.remove()
   */
  remove() {
    this._removeValueFromPersistentStorage(), this._removeEventListeners(), this._removeWatcher(), this._removeFromLocalList(this.domElement), this.constructor._removeFromGlobalList(this);
  }
  /**
   * Remove the autoNumeric data and event listeners from the element, and reset its value to the empty string ''.
   * This also clears the value from sessionStorage (or cookie, depending on browser supports).
   *
   * @example anElement.wipe()
   */
  wipe() {
    this._setElementValue("", !1), this.remove();
  }
  /**
   * Remove the autoNumeric data and event listeners from the element, and delete the DOM element altogether
   */
  nuke() {
    this.remove(), this.domElement.parentNode.removeChild(this.domElement);
  }
  // Special functions that really work on the parent <form> element, instead of the <input> element itself
  /**
   * Return a reference to the parent <form> element if it exists, otherwise return `null`.
   * If the parent form element as already been found, this directly return a reference to it.
   * However, you can force AutoNumeric to search again for its reference by passing `true` as a parameter to this method.
   * This method updates the `this.parentForm` attribute.
   *
   * In either case, whenever a new parent form is set for the current AutoNumeric element, we make sure to update the anCount and anFormHandler attributes on both the old form and the new one (for instance in case the user moved the input elements with `appendChild()` since AutoNumeric cannot not detect that).
   *
   * @param {boolean} forceSearch If set to `true`, the parent form is searched again, even if `this.parentForm` is already set.
   *
   * @returns {HTMLFormElement|null}
   */
  form(e = !1) {
    if (e || l.isUndefinedOrNullOrEmpty(this.parentForm)) {
      const a = this._getParentForm();
      if (!l.isNull(a) && a !== this.parentForm) {
        const i = this._getFormAutoNumericChildren(this.parentForm);
        this.parentForm.dataset.anCount = i.length, this._hasFormHandlerFunction(a) ? this._incrementParentFormCounter(a) : (this._storeFormHandlerFunction(a), this._initializeFormCounterToOne(a));
      }
      this.parentForm = a;
    }
    return this.parentForm;
  }
  /**
   * Returns an array of the AutoNumeric-managed elements for the given form element is passed, otherwise for the current `this.parentForm` element.
   * This search for <input> elements, as well as contenteditable non-input tag ones. This also search for elements outside the `form` elements.
   *
   * @param {HTMLFormElement|null} formElement
   *
   * @returns {Array.<HTMLInputElement>}
   * @private
   */
  _getFormAutoNumericChildren(e) {
    const a = [...e.elements], i = this._getContenteditableElements(e);
    return l.arrayUnique(a, i).filter((o) => this.constructor.isManagedByAutoNumeric(o));
  }
  /**
   * Returns an array of the non-input contenteditable elements linked to the given form element.
   * Two types of elements are possible, either located inside the form element, or outside.
   * For the outside elements, this only works if the form element has a defined id and that id is referenced on the non-input element as the `form` attribute.
   * If no elements can be found, then an empty array is returned.
   *
   * @param {HTMLFormElement|null} formElement
   *
   * @returns {Array.<HTMLInputElement>}
   * @private
   */
  _getContenteditableElements(e) {
    if (l.isUndefinedOrNullOrEmpty(e) || !e.hasAttribute("id"))
      return [];
    const a = [...e.querySelectorAll("[contenteditable=true]")], i = [...document.querySelectorAll(`*:not(input)[form=${e.id}][contenteditable=true]`)];
    return l.arrayUnique(a, i);
  }
  /**
   * Returns a reference to the parent <form> element if it exists, otherwise return `null`.
   *
   * @returns {HTMLFormElement|null}
   * @private
   */
  _getParentForm() {
    if (!l.isUndefined(this.domElement.form)) return this.domElement.form;
    if (this.domElement.tagName.toLowerCase() === "body")
      return null;
    let e = this.domElement, a;
    do {
      if (e = e.parentNode, l.isNull(e))
        return null;
      if (e.tagName ? a = e.tagName.toLowerCase() : a = "", a === "body")
        break;
    } while (a !== "form");
    return a === "form" ? e : null;
  }
  /**
   * Return a string in standard URL-encoded notation with the form input values being unformatted.
   * This string can be used as a query for instance.
   *
   * @returns {string}
   */
  formNumericString() {
    return this.constructor._serializeNumericString(this.form(), this.settings.serializeSpaces);
  }
  /**
   * Return a string in standard URL-encoded notation with the form input values being formatted.
   *
   * @returns {string}
   */
  formFormatted() {
    return this.constructor._serializeFormatted(this.form(), this.settings.serializeSpaces);
  }
  /**
   * Return a string in standard URL-encoded notation with the form input values, with localized values.
   * The default output format can be overridden by passing the option as a parameter.
   *
   * @param {null|string} forcedOutputFormat If set to something different from `null`, then this is used as an overriding outputFormat option
   * @returns {string}
   */
  formLocalized(e = null) {
    let a;
    return l.isNull(e) ? a = this.settings.outputFormat : a = e, this.constructor._serializeLocalized(this.form(), this.settings.serializeSpaces, a);
  }
  /**
   * Return an array containing an object for each form <input> element.
   * Those objects are of the following structure `{ name: foo, value: '42' }`, where the `name` is the DOM element name, and the `value` is an unformatted numeric string.
   *
   * @returns {Array}
   */
  formArrayNumericString() {
    return this.constructor._serializeNumericStringArray(this.form(), this.settings.serializeSpaces);
  }
  /**
   * Return an array containing an object for each form <input> element.
   * Those objects are of the following structure `{ name: foo, value: '42' }`, where the `name` is the DOM element name, and the `value` is the formatted string.
   *
   * @returns {Array}
   */
  formArrayFormatted() {
    return this.constructor._serializeFormattedArray(this.form(), this.settings.serializeSpaces);
  }
  /**
   * Return an array containing an object for each form <input> element.
   * Those objects are of the following structure `{ name: foo, value: '42' }`, where the `name` is the DOM element name, and the `value` is the localized numeric string.
   *
   * @param {null|string} forcedOutputFormat If set to something different from `null`, then this is used as an overriding outputFormat option
   * @returns {Array}
   */
  formArrayLocalized(e = null) {
    let a;
    return l.isNull(e) ? a = this.settings.outputFormat : a = e, this.constructor._serializeLocalizedArray(this.form(), this.settings.serializeSpaces, a);
  }
  /**
   * Return a JSON string containing an object representing the form input values.
   * This is based on the result of the `formArrayNumericString()` function.
   *
   * @returns {string}
   */
  formJsonNumericString() {
    return JSON.stringify(this.formArrayNumericString());
  }
  /**
   * Return a JSON string containing an object representing the form input values.
   * This is based on the result of the `formArrayFormatted()` function.
   *
   * @returns {string}
   */
  formJsonFormatted() {
    return JSON.stringify(this.formArrayFormatted());
  }
  /**
   * Return a JSON string containing an object representing the form input values.
   * This is based on the result of the `formArrayLocalized()` function.
   *
   * @param {null|string} forcedOutputFormat If set to something different from `null`, then this is used as an overriding outputFormat option
   * @returns {string}
   */
  formJsonLocalized(e = null) {
    return JSON.stringify(this.formArrayLocalized(e));
  }
  /**
   * Unformat all the autoNumeric-managed elements that are a child of the parent <form> element of this DOM element, to numeric strings
   *
   * @returns {AutoNumeric}
   */
  formUnformat() {
    return this.constructor._getChildANInputElement(this.form()).forEach((a) => {
      u.getAutoNumericElement(a).unformat();
    }), this;
  }
  /**
   * Unformat all the autoNumeric-managed elements that are a child of the parent <form> element of this DOM element, to localized strings
   *
   * @returns {AutoNumeric}
   */
  formUnformatLocalized() {
    return this.constructor._getChildANInputElement(this.form()).forEach((a) => {
      u.getAutoNumericElement(a).unformatLocalized();
    }), this;
  }
  /**
   * Reformat all the autoNumeric-managed elements that are a child of the parent <form> element of this DOM element
   *
   * @returns {AutoNumeric}
   */
  formReformat() {
    return this.constructor._getChildANInputElement(this.form()).forEach((a) => {
      u.getAutoNumericElement(a).reformat();
    }), this;
  }
  /**
   * Convert the input values to numeric strings, submit the form, then reformat those back.
   * The function can either take a callback, or not. If it doesn't, the default `form.submit()` function will be called.
   * Otherwise, it runs `callback(value)` with `value` being equal to the result of `formNumericString()`.
   *
   * @param {function|null} callback
   * @returns {AutoNumeric}
   */
  formSubmitNumericString(e = null) {
    return l.isNull(e) ? (this.formUnformat(), this.form().submit(), this.formReformat()) : l.isFunction(e) ? e(this.formNumericString()) : l.throwError("The given callback is not a function."), this;
  }
  /**
   * Submit the form with the current formatted values.
   * The function can either take a callback, or not. If it doesn't, the default `form.submit()` function will be called.
   * Otherwise, it runs `callback(value)` with `value` being equal to the result of `formFormatted()`.
   *
   * @param {function|null} callback
   * @returns {AutoNumeric}
   */
  formSubmitFormatted(e = null) {
    return l.isNull(e) ? this.form().submit() : l.isFunction(e) ? e(this.formFormatted()) : l.throwError("The given callback is not a function."), this;
  }
  /**
   * Convert the input values to localized strings, submit the form, then reformat those back.
   * The function can either take a callback, or not. If it doesn't, the default `form.submit()` function will be called.
   * Otherwise, it runs `callback(value)` with `value` being equal to the result of `formLocalized()`.
   *
   * @param {null|string} forcedOutputFormat If set to something different from `null`, then this is used as an overriding outputFormat option
   * @param {function|null} callback
   * @returns {AutoNumeric}
   */
  formSubmitLocalized(e = null, a = null) {
    return l.isNull(a) ? (this.formUnformatLocalized(), this.form().submit(), this.formReformat()) : l.isFunction(a) ? a(this.formLocalized(e)) : l.throwError("The given callback is not a function."), this;
  }
  /**
   * Generate an array of numeric strings from the `<input>` elements, and pass it to the given callback.
   * Under the hood, the array is generated via a call to `formArrayNumericString()`.
   *
   * @param {function} callback
   * @returns {AutoNumeric}
   */
  formSubmitArrayNumericString(e) {
    return l.isFunction(e) ? e(this.formArrayNumericString()) : l.throwError("The given callback is not a function."), this;
  }
  /**
   * Generate an array of the current formatted values from the `<input>` elements, and pass it to the given callback.
   * Under the hood, the array is generated via a call to `formArrayFormatted()`.
   *
   * @param {function} callback
   * @returns {AutoNumeric}
   */
  formSubmitArrayFormatted(e) {
    return l.isFunction(e) ? e(this.formArrayFormatted()) : l.throwError("The given callback is not a function."), this;
  }
  /**
   * Generate an array of localized strings from the `<input>` elements, and pass it to the given callback.
   * Under the hood, the array is generated via a call to `formArrayLocalized()`.
   *
   * @param {function} callback
   * @param {null|string} forcedOutputFormat If set to something different from `null`, then this is used as an overriding outputFormat option
   * @returns {AutoNumeric}
   */
  formSubmitArrayLocalized(e, a = null) {
    return l.isFunction(e) ? e(this.formArrayLocalized(a)) : l.throwError("The given callback is not a function."), this;
  }
  /**
   * Generate a JSON string with the numeric strings values from the `<input>` elements, and pass it to the given callback.
   * Under the hood, the array is generated via a call to `formJsonNumericString()`.
   *
   * @param {function} callback
   * @returns {AutoNumeric}
   */
  formSubmitJsonNumericString(e) {
    return l.isFunction(e) ? e(this.formJsonNumericString()) : l.throwError("The given callback is not a function."), this;
  }
  /**
   * Generate a JSON string with the current formatted values from the `<input>` elements, and pass it to the given callback.
   * Under the hood, the array is generated via a call to `formJsonFormatted()`.
   *
   * @param {function} callback
   * @returns {AutoNumeric}
   */
  formSubmitJsonFormatted(e) {
    return l.isFunction(e) ? e(this.formJsonFormatted()) : l.throwError("The given callback is not a function."), this;
  }
  /**
   * Generate a JSON string with the localized strings values from the `<input>` elements, and pass it to the given callback.
   * Under the hood, the array is generated via a call to `formJsonLocalized()`.
   *
   * @param {function} callback
   * @param {null|string} forcedOutputFormat If set to something different from `null`, then this is used as an overriding outputFormat option
   * @returns {AutoNumeric}
   */
  formSubmitJsonLocalized(e, a = null) {
    return l.isFunction(e) ? e(this.formJsonLocalized(a)) : l.throwError("The given callback is not a function."), this;
  }
  /**
   * Unformat the given AutoNumeric element, and update the `hoveredWithAlt` variable.
   *
   * @param {AutoNumeric} anElement
   * @private
   */
  static _unformatAltHovered(e) {
    e.hoveredWithAlt = !0, e.unformat();
  }
  /**
   * Reformat the given AutoNumeric element, and update the `hoveredWithAlt` variable.
   *
   * @param {AutoNumeric} anElement
   * @private
   */
  static _reformatAltHovered(e) {
    e.hoveredWithAlt = !1, e.reformat();
  }
  /**
   * Return an array of autoNumeric elements, child of the <form> element passed as a parameter.
   *
   * @param {HTMLElement} formNode
   * @returns {Array}
   * @private
   */
  static _getChildANInputElement(e) {
    const a = e.getElementsByTagName("input"), i = [];
    return Array.prototype.slice.call(a, 0).forEach((o) => {
      this.test(o) && i.push(o);
    }), i;
  }
  // Static methods
  /**
   * Test if the given DOM element, or the element selected by the given selector string is already managed by AutoNumeric (if it has been initialized on the current page).
   *
   * @param {HTMLElement|string} domElementOrSelector Accepts either directly a DOM element to test, or a string selector (that will return one and only one element, if any)
   * @returns {boolean}
   */
  static test(e) {
    return this._isInGlobalList(l.domElement(e));
  }
  /**
   * Create a WeakMap with the given name.
   *
   * @param {string} weakMapName
   * @private
   */
  static _createWeakMap(e) {
    window[e] = /* @__PURE__ */ new WeakMap();
  }
  /**
   * Create a list of all the AutoNumeric elements that are initialized on the current page.
   * This is needed in order to determine if a given dom element is already managed by autoNumeric.
   * This uses a WeakMap in order to limit potential garbage collection problems.
   * (cf. my tests on http://codepen.io/AnotherLinuxUser/pen/pRQGaM?editors=1011)
   * @private
   */
  static _createGlobalList() {
    this.autoNumericGlobalListName = "autoNumericGlobalList", this._createWeakMap(this.autoNumericGlobalListName);
  }
  /**
   * Return `true` if the global AutoNumeric element list exists.
   *
   * @returns {boolean}
   * @private
   */
  static _doesGlobalListExists() {
    const e = typeof window[this.autoNumericGlobalListName];
    return e !== "undefined" && e === "object";
  }
  /**
   * Add the given object to the global AutoNumeric element list.
   *
   * @param {AutoNumeric} autoNumericObject
   * @private
   */
  static _addToGlobalList(e) {
    this._doesGlobalListExists() || this._createGlobalList();
    const a = e.node();
    if (this._isInGlobalList(a)) {
      if (this._getFromGlobalList(a) === this)
        return;
      l.warning("A reference to the DOM element you just initialized already exists in the global AutoNumeric element list. Please make sure to not initialize the same DOM element multiple times.", e.getSettings().showWarnings);
    }
    window[this.autoNumericGlobalListName].set(a, e);
  }
  /**
   * Remove the given object from the global AutoNumeric element list.
   *
   * @param {AutoNumeric} autoNumericObject
   * @private
   */
  static _removeFromGlobalList(e) {
    this._doesGlobalListExists() && window[this.autoNumericGlobalListName].delete(e.node());
  }
  /**
   * Return the value associated to the key `domElement` passed as a parameter.
   * The value is the AutoNumeric object that manages the DOM element `domElement`.
   *
   * @param {HTMLElement|HTMLInputElement} domElement
   * @returns {null|AutoNumeric}
   * @private
   */
  static _getFromGlobalList(e) {
    return this._doesGlobalListExists() ? window[this.autoNumericGlobalListName].get(e) : null;
  }
  /**
   * Check if the given DOM element is in the global AutoNumeric element list.
   *
   * @param {HTMLElement|HTMLInputElement} domElement
   * @returns {boolean}
   * @private
   */
  static _isInGlobalList(e) {
    return this._doesGlobalListExists() ? window[this.autoNumericGlobalListName].has(e) : !1;
  }
  /**
   * Create a `Map` that will store all the autoNumeric elements that are initialized from this current element.
   * @private
   */
  _createLocalList() {
    this.autoNumericLocalList = /* @__PURE__ */ new Map(), this._addToLocalList(this.domElement);
  }
  /**
   * In some rare cases, you could want to delete the local list generated during the element initialization (in order to use another one instead for instance).
   * @private
   */
  _deleteLocalList() {
    delete this.autoNumericLocalList;
  }
  /**
   * Set the local list with the given Map object.
   *
   * @param {Map} localList
   * @private
   */
  _setLocalList(e) {
    this.autoNumericLocalList = e;
  }
  /**
   * Return the local list Map object.
   *
   * @returns {*|Map}
   * @private
   */
  _getLocalList() {
    return this.autoNumericLocalList;
  }
  /**
   * Return `true` if the AutoNumeric object has a local list defined already and has at least one element in it (itself usually).
   *
   * @returns {boolean}
   * @private
   */
  _hasLocalList() {
    return this.autoNumericLocalList instanceof Map && this.autoNumericLocalList.size !== 0;
  }
  /**
   * Add the given object to the local autoNumeric element list.
   * Note: in order to keep a coherent list, we only add DOM elements in it, not the autoNumeric object.
   *
   * @param {HTMLElement|HTMLInputElement} domElement
   * @param {AutoNumeric} autoNumericObject A reference to the AutoNumeric object that manage the given DOM element
   * @throws
   * @private
   */
  _addToLocalList(e, a = null) {
    l.isNull(a) && (a = this), l.isUndefined(this.autoNumericLocalList) ? l.throwError(`The local list provided does not exists when trying to add an element. [${this.autoNumericLocalList}] given.`) : this.autoNumericLocalList.set(e, a);
  }
  /**
   * Remove the given object from the local autoNumeric element list.
   *
   * @param {HTMLElement|HTMLInputElement} domElement
   * @private
   */
  _removeFromLocalList(e) {
    l.isUndefined(this.autoNumericLocalList) ? this.settings.createLocalList && l.throwError(`The local list provided does not exists when trying to remove an element. [${this.autoNumericLocalList}] given.`) : this.autoNumericLocalList.delete(e);
  }
  /**
   * Merge the `newSettings` given as parameters into the current element settings.
   *
   * WARNING: Using `Object.assign()` here means the merge is not recursive and only one depth is merged.
   * cf. http://stackoverflow.com/a/39188108/2834898
   * cf. tests on http://codepen.io/AnotherLinuxUser/pen/KaJORq?editors=0011
   *
   * @param {object} newSettings
   * @private
   */
  _mergeSettings(...e) {
    Object.assign(this.settings, ...e);
  }
  /**
   * Return a new object with the current element settings merged with the new settings.
   *
   * @param {object} newSettings
   * @returns {object}
   * @private
   */
  _cloneAndMergeSettings(...e) {
    const a = {};
    return Object.assign(a, this.settings, ...e), a;
  }
  /**
   * Validate the given option object.
   * If the options are valid, this function returns nothing, otherwise if the options are invalid, this function throws an error.
   *
   * This tests if the options are not conflicting and are well formatted.
   * This function is lenient since it only tests the settings properties ; it ignores any other properties the options object could have.
   *
   * @param {*} userOptions
   * @param {Boolean} shouldExtendDefaultOptions If `true`, then this function will extend the `userOptions` passed by the user, with the default options.
   * @param {object|null} originalOptions The user can pass the original options (and not the one that are generated from the default settings and the various usability corrections), in order to add compatibility and conflicts checks.
   * @throws Error This throws if the `userOptions` are not valid
   */
  static validate(e, a = !0, i = null) {
    (l.isUndefinedOrNullOrEmpty(e) || !l.isObject(e)) && l.throwError(`The userOptions are invalid ; it should be a valid object, [${e}] given.`);
    const n = l.isObject(i);
    !n && !l.isNull(i) && l.throwError(`The 'originalOptions' parameter is invalid ; it should either be a valid option object or \`null\`, [${e}] given.`), l.isNull(e) || this._convertOldOptionsToNewOnes(e);
    let o;
    a ? o = Object.assign({}, this.getDefaultConfig(), e) : o = e, !l.isTrueOrFalseString(o.showWarnings) && !l.isBoolean(o.showWarnings) && l.throwError(`The debug option 'showWarnings' is invalid ; it should be either 'true' or 'false', [${o.showWarnings}] given.`);
    const d = /^[0-9]+$/, s = /[0-9]+/, c = /^-?[0-9]+(\.?[0-9]+)?$/, m = /^[0-9]+(\.?[0-9]+)?$/;
    !l.isTrueOrFalseString(o.allowDecimalPadding) && !l.isBoolean(o.allowDecimalPadding) && o.allowDecimalPadding !== u.options.allowDecimalPadding.floats && !(l.isNumber(o.allowDecimalPadding) && o.allowDecimalPadding > 0) && l.throwError(`The decimal padding option 'allowDecimalPadding' is invalid ; it should either be \`false\`, \`true\`, \`'floats'\` or a positive integer superior to 0, [${o.allowDecimalPadding}] given.`), l.isNumber(o.allowDecimalPadding) && o.allowDecimalPadding > o.decimalPlaces && l.warning(`Setting 'allowDecimalPadding' to a number [${o.allowDecimalPadding}] superior to the current 'decimalPlaces' settings [${o.decimalPlaces}] is useless, since the padding will not be shown.`, o.showWarnings), (o.allowDecimalPadding === u.options.allowDecimalPadding.never || o.allowDecimalPadding === "false") && (o.decimalPlaces !== u.options.decimalPlaces.none || o.decimalPlacesShownOnBlur !== u.options.decimalPlacesShownOnBlur.none || o.decimalPlacesShownOnFocus !== u.options.decimalPlacesShownOnFocus.none) && l.warning(`Setting 'allowDecimalPadding' to [${o.allowDecimalPadding}] will override the current 'decimalPlaces*' settings [${o.decimalPlaces}, ${o.decimalPlacesShownOnBlur} and ${o.decimalPlacesShownOnFocus}].`, o.showWarnings), !l.isTrueOrFalseString(o.alwaysAllowDecimalCharacter) && !l.isBoolean(o.alwaysAllowDecimalCharacter) && l.throwError(`The option 'alwaysAllowDecimalCharacter' is invalid ; it should either be \`true\` or \`false\`, [${o.alwaysAllowDecimalCharacter}] given.`), !l.isNull(o.caretPositionOnFocus) && !l.isInArray(o.caretPositionOnFocus, [
      u.options.caretPositionOnFocus.start,
      u.options.caretPositionOnFocus.end,
      u.options.caretPositionOnFocus.decimalLeft,
      u.options.caretPositionOnFocus.decimalRight
    ]) && l.throwError(`The display on empty string option 'caretPositionOnFocus' is invalid ; it should either be \`null\`, 'focus', 'press', 'always' or 'zero', [${o.caretPositionOnFocus}] given.`);
    let f;
    n ? f = i : f = this._correctCaretPositionOnFocusAndSelectOnFocusOptions(e), !l.isNull(f) && f.caretPositionOnFocus !== u.options.caretPositionOnFocus.doNoForceCaretPosition && f.selectOnFocus === u.options.selectOnFocus.select && l.warning(`The 'selectOnFocus' option is set to 'select', which is in conflict with the 'caretPositionOnFocus' which is set to '${f.caretPositionOnFocus}'. As a result, if this has been called when instantiating an AutoNumeric object, the 'selectOnFocus' option is forced to 'doNotSelect'.`, o.showWarnings), l.isInArray(o.digitGroupSeparator, [
      u.options.digitGroupSeparator.comma,
      u.options.digitGroupSeparator.dot,
      u.options.digitGroupSeparator.normalSpace,
      u.options.digitGroupSeparator.thinSpace,
      u.options.digitGroupSeparator.narrowNoBreakSpace,
      u.options.digitGroupSeparator.noBreakSpace,
      u.options.digitGroupSeparator.noSeparator,
      u.options.digitGroupSeparator.apostrophe,
      u.options.digitGroupSeparator.arabicThousandsSeparator,
      u.options.digitGroupSeparator.dotAbove,
      u.options.digitGroupSeparator.privateUseTwo
    ]) || l.throwError(`The thousand separator character option 'digitGroupSeparator' is invalid ; it should be ',', '.', '٬', '˙', "'", '', ' ', ' ', ' ', ' ' or empty (''), [${o.digitGroupSeparator}] given.`), !l.isTrueOrFalseString(o.showOnlyNumbersOnFocus) && !l.isBoolean(o.showOnlyNumbersOnFocus) && l.throwError(`The 'showOnlyNumbersOnFocus' option is invalid ; it should be either 'true' or 'false', [${o.showOnlyNumbersOnFocus}] given.`), !l.isInArray(o.digitalGroupSpacing, [
      u.options.digitalGroupSpacing.two,
      u.options.digitalGroupSpacing.twoThree,
      u.options.digitalGroupSpacing.twoScaled,
      u.options.digitalGroupSpacing.three,
      u.options.digitalGroupSpacing.four
    ]) && !(o.digitalGroupSpacing >= 2 && o.digitalGroupSpacing <= 4) && l.throwError(`The grouping separator option for thousands 'digitalGroupSpacing' is invalid ; it should be '2', '2t', '2s', '3', or '4', [${o.digitalGroupSpacing}] given.`), l.isInArray(o.decimalCharacter, [
      u.options.decimalCharacter.comma,
      u.options.decimalCharacter.dot,
      u.options.decimalCharacter.middleDot,
      u.options.decimalCharacter.arabicDecimalSeparator,
      u.options.decimalCharacter.decimalSeparatorKeySymbol
    ]) || l.throwError(`The decimal separator character option 'decimalCharacter' is invalid ; it should be '.', ',', '·', '⎖' or '٫', [${o.decimalCharacter}] given.`), o.decimalCharacter === o.digitGroupSeparator && l.throwError(`autoNumeric will not function properly when the decimal character 'decimalCharacter' [${o.decimalCharacter}] and the thousand separator 'digitGroupSeparator' [${o.digitGroupSeparator}] are the same character.`), !l.isNull(o.decimalCharacterAlternative) && !l.isString(o.decimalCharacterAlternative) && l.throwError(`The alternate decimal separator character option 'decimalCharacterAlternative' is invalid ; it should be a string, [${o.decimalCharacterAlternative}] given.`), o.currencySymbol !== "" && !l.isString(o.currencySymbol) && l.throwError(`The currency symbol option 'currencySymbol' is invalid ; it should be a string, [${o.currencySymbol}] given.`), l.isInArray(o.currencySymbolPlacement, [
      u.options.currencySymbolPlacement.prefix,
      u.options.currencySymbolPlacement.suffix
    ]) || l.throwError(`The placement of the currency sign option 'currencySymbolPlacement' is invalid ; it should either be 'p' (prefix) or 's' (suffix), [${o.currencySymbolPlacement}] given.`), l.isInArray(o.negativePositiveSignPlacement, [
      u.options.negativePositiveSignPlacement.prefix,
      u.options.negativePositiveSignPlacement.suffix,
      u.options.negativePositiveSignPlacement.left,
      u.options.negativePositiveSignPlacement.right,
      u.options.negativePositiveSignPlacement.none
    ]) || l.throwError(`The placement of the negative sign option 'negativePositiveSignPlacement' is invalid ; it should either be 'p' (prefix), 's' (suffix), 'l' (left), 'r' (right) or 'null', [${o.negativePositiveSignPlacement}] given.`), !l.isTrueOrFalseString(o.showPositiveSign) && !l.isBoolean(o.showPositiveSign) && l.throwError(`The show positive sign option 'showPositiveSign' is invalid ; it should be either 'true' or 'false', [${o.showPositiveSign}] given.`), (!l.isString(o.suffixText) || o.suffixText !== "" && (l.isNegative(o.suffixText, o.negativeSignCharacter) || s.test(o.suffixText))) && l.throwError(`The additional suffix option 'suffixText' is invalid ; it should not contains the negative sign '${o.negativeSignCharacter}' nor any numerical characters, [${o.suffixText}] given.`), (!l.isString(o.negativeSignCharacter) || o.negativeSignCharacter.length !== 1 || l.isUndefinedOrNullOrEmpty(o.negativeSignCharacter) || s.test(o.negativeSignCharacter)) && l.throwError(`The negative sign character option 'negativeSignCharacter' is invalid ; it should be a single character, and cannot be any numerical characters, [${o.negativeSignCharacter}] given.`), (!l.isString(o.positiveSignCharacter) || o.positiveSignCharacter.length !== 1 || l.isUndefinedOrNullOrEmpty(o.positiveSignCharacter) || s.test(o.positiveSignCharacter)) && l.throwError(`The positive sign character option 'positiveSignCharacter' is invalid ; it should be a single character, and cannot be any numerical characters, [${o.positiveSignCharacter}] given.
If you want to show the positive sign character, you need to set the \`showPositiveSign\` option to \`true\`.`), o.negativeSignCharacter === o.positiveSignCharacter && l.throwError(`The positive 'positiveSignCharacter' and negative 'negativeSignCharacter' sign characters cannot be identical ; [${o.negativeSignCharacter}] given.`), !l.isTrueOrFalseString(o.negativePositiveSignBehavior) && !l.isBoolean(o.negativePositiveSignBehavior) && l.throwError(`The option 'negativePositiveSignBehavior' is invalid ; it should be either 'true' or 'false', [${o.negativePositiveSignBehavior}] given.`);
    const [p, b] = l.isNull(o.negativeBracketsTypeOnBlur) ? ["", ""] : o.negativeBracketsTypeOnBlur.split(",");
    (l.contains(o.digitGroupSeparator, o.negativeSignCharacter) || l.contains(o.decimalCharacter, o.negativeSignCharacter) || l.contains(o.decimalCharacterAlternative, o.negativeSignCharacter) || l.contains(p, o.negativeSignCharacter) || l.contains(b, o.negativeSignCharacter) || l.contains(o.suffixText, o.negativeSignCharacter)) && l.throwError(`The negative sign character option 'negativeSignCharacter' is invalid ; it should not be equal or a part of the digit separator, the decimal character, the decimal character alternative, the negative brackets or the suffix text, [${o.negativeSignCharacter}] given.`), (l.contains(o.digitGroupSeparator, o.positiveSignCharacter) || l.contains(o.decimalCharacter, o.positiveSignCharacter) || l.contains(o.decimalCharacterAlternative, o.positiveSignCharacter) || l.contains(p, o.positiveSignCharacter) || l.contains(b, o.positiveSignCharacter) || l.contains(o.suffixText, o.positiveSignCharacter)) && l.throwError(`The positive sign character option 'positiveSignCharacter' is invalid ; it should not be equal or a part of the digit separator, the decimal character, the decimal character alternative, the negative brackets or the suffix text, [${o.positiveSignCharacter}] given.`), !l.isNull(o.overrideMinMaxLimits) && !l.isInArray(o.overrideMinMaxLimits, [
      u.options.overrideMinMaxLimits.ceiling,
      u.options.overrideMinMaxLimits.floor,
      u.options.overrideMinMaxLimits.ignore,
      u.options.overrideMinMaxLimits.invalid
    ]) && l.throwError(`The override min & max limits option 'overrideMinMaxLimits' is invalid ; it should either be 'ceiling', 'floor', 'ignore' or 'invalid', [${o.overrideMinMaxLimits}] given.`), o.overrideMinMaxLimits !== u.options.overrideMinMaxLimits.invalid && o.overrideMinMaxLimits !== u.options.overrideMinMaxLimits.ignore && (o.minimumValue > 0 || o.maximumValue < 0) && l.warning("You've set a `minimumValue` or a `maximumValue` excluding the value `0`. AutoNumeric will force the users to always have a valid value in the input, hence preventing them to clear the field. If you want to allow for temporary invalid values (i.e. out-of-range), you should use the 'invalid' option for the 'overrideMinMaxLimits' setting."), (!l.isString(o.maximumValue) || !c.test(o.maximumValue)) && l.throwError(`The maximum possible value option 'maximumValue' is invalid ; it should be a string that represents a positive or negative number, [${o.maximumValue}] given.`), (!l.isString(o.minimumValue) || !c.test(o.minimumValue)) && l.throwError(`The minimum possible value option 'minimumValue' is invalid ; it should be a string that represents a positive or negative number, [${o.minimumValue}] given.`), parseFloat(o.minimumValue) > parseFloat(o.maximumValue) && l.throwError(`The minimum possible value option is greater than the maximum possible value option ; 'minimumValue' [${o.minimumValue}] should be smaller than 'maximumValue' [${o.maximumValue}].`), l.isInt(o.decimalPlaces) && o.decimalPlaces >= 0 || // If integer option
    l.isString(o.decimalPlaces) && d.test(o.decimalPlaces) || l.throwError(`The number of decimal places option 'decimalPlaces' is invalid ; it should be a positive integer, [${o.decimalPlaces}] given.`), l.isNull(o.decimalPlacesRawValue) || l.isInt(o.decimalPlacesRawValue) && o.decimalPlacesRawValue >= 0 || // If integer option
    l.isString(o.decimalPlacesRawValue) && d.test(o.decimalPlacesRawValue) || l.throwError(`The number of decimal places for the raw value option 'decimalPlacesRawValue' is invalid ; it should be a positive integer or \`null\`, [${o.decimalPlacesRawValue}] given.`), this._validateDecimalPlacesRawValue(o), !l.isNull(o.decimalPlacesShownOnFocus) && !d.test(String(o.decimalPlacesShownOnFocus)) && l.throwError(`The number of expanded decimal places option 'decimalPlacesShownOnFocus' is invalid ; it should be a positive integer or \`null\`, [${o.decimalPlacesShownOnFocus}] given.`), !l.isNull(o.decimalPlacesShownOnFocus) && Number(o.decimalPlaces) > Number(o.decimalPlacesShownOnFocus) && l.warning(`The extended decimal places 'decimalPlacesShownOnFocus' [${o.decimalPlacesShownOnFocus}] should be greater than the 'decimalPlaces' [${o.decimalPlaces}] value. Currently, this will limit the ability of your user to manually change some of the decimal places. Do you really want to do that?`, o.showWarnings), (!l.isNull(o.divisorWhenUnfocused) && !m.test(o.divisorWhenUnfocused) || o.divisorWhenUnfocused === 0 || o.divisorWhenUnfocused === "0" || o.divisorWhenUnfocused === 1 || o.divisorWhenUnfocused === "1") && l.throwError(`The divisor option 'divisorWhenUnfocused' is invalid ; it should be a positive number higher than one, preferably an integer, [${o.divisorWhenUnfocused}] given.`), !l.isNull(o.decimalPlacesShownOnBlur) && !d.test(o.decimalPlacesShownOnBlur) && l.throwError(`The number of decimals shown when unfocused option 'decimalPlacesShownOnBlur' is invalid ; it should be a positive integer or \`null\`, [${o.decimalPlacesShownOnBlur}] given.`), !l.isNull(o.symbolWhenUnfocused) && !l.isString(o.symbolWhenUnfocused) && l.throwError(`The symbol to show when unfocused option 'symbolWhenUnfocused' is invalid ; it should be a string, [${o.symbolWhenUnfocused}] given.`), !l.isTrueOrFalseString(o.saveValueToSessionStorage) && !l.isBoolean(o.saveValueToSessionStorage) && l.throwError(`The save to session storage option 'saveValueToSessionStorage' is invalid ; it should be either 'true' or 'false', [${o.saveValueToSessionStorage}] given.`), l.isInArray(o.onInvalidPaste, [
      u.options.onInvalidPaste.error,
      u.options.onInvalidPaste.ignore,
      u.options.onInvalidPaste.clamp,
      u.options.onInvalidPaste.truncate,
      u.options.onInvalidPaste.replace
    ]) || l.throwError(`The paste behavior option 'onInvalidPaste' is invalid ; it should either be 'error', 'ignore', 'clamp', 'truncate' or 'replace' (cf. documentation), [${o.onInvalidPaste}] given.`), l.isInArray(o.roundingMethod, [
      u.options.roundingMethod.halfUpSymmetric,
      u.options.roundingMethod.halfUpAsymmetric,
      u.options.roundingMethod.halfDownSymmetric,
      u.options.roundingMethod.halfDownAsymmetric,
      u.options.roundingMethod.halfEvenBankersRounding,
      u.options.roundingMethod.upRoundAwayFromZero,
      u.options.roundingMethod.downRoundTowardZero,
      u.options.roundingMethod.toCeilingTowardPositiveInfinity,
      u.options.roundingMethod.toFloorTowardNegativeInfinity,
      u.options.roundingMethod.toNearest05,
      u.options.roundingMethod.toNearest05Alt,
      u.options.roundingMethod.upToNext05,
      u.options.roundingMethod.downToNext05
    ]) || l.throwError(`The rounding method option 'roundingMethod' is invalid ; it should either be 'S', 'A', 's', 'a', 'B', 'U', 'D', 'C', 'F', 'N05', 'CHF', 'U05' or 'D05' (cf. documentation), [${o.roundingMethod}] given.`), !l.isNull(o.negativeBracketsTypeOnBlur) && !l.isInArray(o.negativeBracketsTypeOnBlur, [
      u.options.negativeBracketsTypeOnBlur.parentheses,
      u.options.negativeBracketsTypeOnBlur.brackets,
      u.options.negativeBracketsTypeOnBlur.chevrons,
      u.options.negativeBracketsTypeOnBlur.curlyBraces,
      u.options.negativeBracketsTypeOnBlur.angleBrackets,
      u.options.negativeBracketsTypeOnBlur.japaneseQuotationMarks,
      u.options.negativeBracketsTypeOnBlur.halfBrackets,
      u.options.negativeBracketsTypeOnBlur.whiteSquareBrackets,
      u.options.negativeBracketsTypeOnBlur.quotationMarks,
      u.options.negativeBracketsTypeOnBlur.guillemets
    ]) && l.throwError(`The brackets for negative values option 'negativeBracketsTypeOnBlur' is invalid ; it should either be '(,)', '[,]', '<,>', '{,}', '〈,〉', '｢,｣', '⸤,⸥', '⟦,⟧', '‹,›' or '«,»', [${o.negativeBracketsTypeOnBlur}] given.`), (!(l.isString(o.emptyInputBehavior) || l.isNumber(o.emptyInputBehavior)) || !(l.isInArray(o.emptyInputBehavior, [
      u.options.emptyInputBehavior.focus,
      u.options.emptyInputBehavior.press,
      u.options.emptyInputBehavior.always,
      u.options.emptyInputBehavior.min,
      u.options.emptyInputBehavior.max,
      u.options.emptyInputBehavior.zero,
      u.options.emptyInputBehavior.null
    ]) || c.test(o.emptyInputBehavior))) && l.throwError(`The display on empty string option 'emptyInputBehavior' is invalid ; it should either be 'focus', 'press', 'always', 'min', 'max', 'zero', 'null', a number, or a string that represents a number, [${o.emptyInputBehavior}] given.`), o.emptyInputBehavior === u.options.emptyInputBehavior.zero && (o.minimumValue > 0 || o.maximumValue < 0) && l.throwError(`The 'emptyInputBehavior' option is set to 'zero', but this value is outside of the range defined by 'minimumValue' and 'maximumValue' [${o.minimumValue}, ${o.maximumValue}].`), c.test(String(o.emptyInputBehavior)) && (this._isWithinRangeWithOverrideOption(o.emptyInputBehavior, o) || l.throwError(`The 'emptyInputBehavior' option is set to a number or a string that represents a number, but its value [${o.emptyInputBehavior}] is outside of the range defined by the 'minimumValue' and 'maximumValue' options [${o.minimumValue}, ${o.maximumValue}].`)), !l.isTrueOrFalseString(o.eventBubbles) && !l.isBoolean(o.eventBubbles) && l.throwError(`The event bubbles option 'eventBubbles' is invalid ; it should be either 'true' or 'false', [${o.eventBubbles}] given.`), !l.isTrueOrFalseString(o.eventIsCancelable) && !l.isBoolean(o.eventIsCancelable) && l.throwError(`The event is cancelable option 'eventIsCancelable' is invalid ; it should be either 'true' or 'false', [${o.eventIsCancelable}] given.`), (l.isBoolean(o.invalidClass) || !/^-?[_a-zA-Z]+[_a-zA-Z0-9-]*$/.test(o.invalidClass)) && l.throwError(`The name of the 'invalidClass' option is not a valid CSS class name ; it should not be empty, and should follow the '^-?[_a-zA-Z]+[_a-zA-Z0-9-]*$' regex, [${o.invalidClass}] given.`), l.isInArray(o.leadingZero, [
      u.options.leadingZero.allow,
      u.options.leadingZero.deny,
      u.options.leadingZero.keep
    ]) || l.throwError(`The leading zero behavior option 'leadingZero' is invalid ; it should either be 'allow', 'deny' or 'keep', [${o.leadingZero}] given.`), !l.isTrueOrFalseString(o.formatOnPageLoad) && !l.isBoolean(o.formatOnPageLoad) && l.throwError(`The format on initialization option 'formatOnPageLoad' is invalid ; it should be either 'true' or 'false', [${o.formatOnPageLoad}] given.`), !l.isTrueOrFalseString(o.formulaMode) && !l.isBoolean(o.formulaMode) && l.throwError(`The formula mode option 'formulaMode' is invalid ; it should be either 'true' or 'false', [${o.formulaMode}] given.`), (!d.test(o.historySize) || o.historySize === 0) && l.throwError(`The history size option 'historySize' is invalid ; it should be a positive integer, [${o.historySize}] given.`), !l.isTrueOrFalseString(o.selectNumberOnly) && !l.isBoolean(o.selectNumberOnly) && l.throwError(`The select number only option 'selectNumberOnly' is invalid ; it should be either 'true' or 'false', [${o.selectNumberOnly}] given.`), !l.isTrueOrFalseString(o.selectOnFocus) && !l.isBoolean(o.selectOnFocus) && l.throwError(`The select on focus option 'selectOnFocus' is invalid ; it should be either 'true' or 'false', [${o.selectOnFocus}] given.`), !l.isNull(o.defaultValueOverride) && o.defaultValueOverride !== "" && !c.test(o.defaultValueOverride) && l.throwError(`The unformatted default value option 'defaultValueOverride' is invalid ; it should be a string that represents a positive or negative number, [${o.defaultValueOverride}] given.`), !l.isTrueOrFalseString(o.unformatOnSubmit) && !l.isBoolean(o.unformatOnSubmit) && l.throwError(`The remove formatting on submit option 'unformatOnSubmit' is invalid ; it should be either 'true' or 'false', [${o.unformatOnSubmit}] given.`), !l.isNull(o.valuesToStrings) && !l.isObject(o.valuesToStrings) && l.throwError(`The option 'valuesToStrings' is invalid ; it should be an object, ideally with 'key -> value' entries, [${o.valuesToStrings}] given.`), !l.isNull(o.outputFormat) && !l.isInArray(o.outputFormat, [
      u.options.outputFormat.string,
      u.options.outputFormat.number,
      u.options.outputFormat.dot,
      u.options.outputFormat.negativeDot,
      u.options.outputFormat.comma,
      u.options.outputFormat.negativeComma,
      u.options.outputFormat.dotNegative,
      u.options.outputFormat.commaNegative
    ]) && l.throwError(`The custom locale format option 'outputFormat' is invalid ; it should either be null, 'string', 'number', '.', '-.', ',', '-,', '.-' or ',-', [${o.outputFormat}] given.`), !l.isTrueOrFalseString(o.isCancellable) && !l.isBoolean(o.isCancellable) && l.throwError(`The cancellable behavior option 'isCancellable' is invalid ; it should be either 'true' or 'false', [${o.isCancellable}] given.`), !l.isTrueOrFalseString(o.modifyValueOnUpDownArrow) && !l.isBoolean(o.modifyValueOnUpDownArrow) && l.throwError(`The increment/decrement on up and down arrow keys 'modifyValueOnUpDownArrow' is invalid ; it should be either 'true' or 'false', [${o.modifyValueOnUpDownArrow}] given.`), !l.isTrueOrFalseString(o.modifyValueOnWheel) && !l.isBoolean(o.modifyValueOnWheel) && l.throwError(`The increment/decrement on mouse wheel option 'modifyValueOnWheel' is invalid ; it should be either 'true' or 'false', [${o.modifyValueOnWheel}] given.`), !l.isTrueOrFalseString(o.watchExternalChanges) && !l.isBoolean(o.watchExternalChanges) && l.throwError(`The option 'watchExternalChanges' is invalid ; it should be either 'true' or 'false', [${o.watchExternalChanges}] given.`), l.isInArray(o.wheelOn, [
      u.options.wheelOn.focus,
      u.options.wheelOn.hover
    ]) || l.throwError(`The wheel behavior option 'wheelOn' is invalid ; it should either be 'focus' or 'hover', [${o.wheelOn}] given.`), (!(l.isString(o.upDownStep) || l.isNumber(o.upDownStep)) || o.upDownStep !== "progressive" && !m.test(o.upDownStep) || Number(o.upDownStep) === 0) && l.throwError(`The up/down arrow step value option 'upDownStep' is invalid ; it should either be the string 'progressive', or a number or a string that represents a positive number (excluding zero), [${o.upDownStep}] given.`), (!(l.isString(o.wheelStep) || l.isNumber(o.wheelStep)) || o.wheelStep !== "progressive" && !m.test(o.wheelStep) || Number(o.wheelStep) === 0) && l.throwError(`The wheel step value option 'wheelStep' is invalid ; it should either be the string 'progressive', or a number or a string that represents a positive number (excluding zero), [${o.wheelStep}] given.`), l.isInArray(o.serializeSpaces, [
      u.options.serializeSpaces.plus,
      u.options.serializeSpaces.percent
    ]) || l.throwError(`The space replacement character option 'serializeSpaces' is invalid ; it should either be '+' or '%20', [${o.serializeSpaces}] given.`), !l.isTrueOrFalseString(o.noEventListeners) && !l.isBoolean(o.noEventListeners) && l.throwError(`The option 'noEventListeners' that prevent the creation of event listeners is invalid ; it should be either 'true' or 'false', [${o.noEventListeners}] given.`), !l.isNull(o.styleRules) && !(l.isObject(o.styleRules) && (Object.prototype.hasOwnProperty.call(o.styleRules, "positive") || Object.prototype.hasOwnProperty.call(o.styleRules, "negative") || Object.prototype.hasOwnProperty.call(o.styleRules, "ranges") || Object.prototype.hasOwnProperty.call(o.styleRules, "userDefined"))) && l.throwError(`The option 'styleRules' is invalid ; it should be a correctly structured object, with one or more 'positive', 'negative', 'ranges' or 'userDefined' attributes, [${o.styleRules}] given.`), !l.isNull(o.styleRules) && Object.prototype.hasOwnProperty.call(o.styleRules, "userDefined") && !l.isNull(o.styleRules.userDefined) && o.styleRules.userDefined.forEach((y) => {
      Object.prototype.hasOwnProperty.call(y, "callback") && !l.isFunction(y.callback) && l.throwError(`The callback defined in the \`userDefined\` attribute is not a function, ${typeof y.callback} given.`);
    }), (!l.isNull(o.rawValueDivisor) && !m.test(o.rawValueDivisor) || o.rawValueDivisor === 0 || o.rawValueDivisor === "0" || o.rawValueDivisor === 1 || o.rawValueDivisor === "1") && l.throwError(`The raw value divisor option 'rawValueDivisor' is invalid ; it should be a positive number higher than one, preferably an integer, [${o.rawValueDivisor}] given.`), !l.isTrueOrFalseString(o.readOnly) && !l.isBoolean(o.readOnly) && l.throwError(`The option 'readOnly' is invalid ; it should be either 'true' or 'false', [${o.readOnly}] given.`), !l.isTrueOrFalseString(o.unformatOnHover) && !l.isBoolean(o.unformatOnHover) && l.throwError(`The option 'unformatOnHover' is invalid ; it should be either 'true' or 'false', [${o.unformatOnHover}] given.`), !l.isTrueOrFalseString(o.failOnUnknownOption) && !l.isBoolean(o.failOnUnknownOption) && l.throwError(`The debug option 'failOnUnknownOption' is invalid ; it should be either 'true' or 'false', [${o.failOnUnknownOption}] given.`), !l.isTrueOrFalseString(o.createLocalList) && !l.isBoolean(o.createLocalList) && l.throwError(`The debug option 'createLocalList' is invalid ; it should be either 'true' or 'false', [${o.createLocalList}] given.`);
  }
  /**
   * Check the `decimalPlaces*` options and output the relevant warnings if some of those will get overwritten during the initialization or settings update.
   *
   * @param {object} options
   * @private
   */
  static _validateDecimalPlacesRawValue(e) {
    l.isNull(e.decimalPlacesRawValue) || (e.decimalPlacesRawValue < e.decimalPlaces && l.warning(`The number of decimal places to store in the raw value [${e.decimalPlacesRawValue}] is lower than the ones to display [${e.decimalPlaces}]. This will likely confuse your users.
To solve that, you'd need to either set \`decimalPlacesRawValue\` to \`null\`, or set a number of decimal places for the raw value equal of bigger than \`decimalPlaces\`.`, e.showWarnings), e.decimalPlacesRawValue < e.decimalPlacesShownOnFocus && l.warning(`The number of decimal places to store in the raw value [${e.decimalPlacesRawValue}] is lower than the ones shown on focus [${e.decimalPlacesShownOnFocus}]. This will likely confuse your users.
To solve that, you'd need to either set \`decimalPlacesRawValue\` to \`null\`, or set a number of decimal places for the raw value equal of bigger than \`decimalPlacesShownOnFocus\`.`, e.showWarnings), e.decimalPlacesRawValue < e.decimalPlacesShownOnBlur && l.warning(`The number of decimal places to store in the raw value [${e.decimalPlacesRawValue}] is lower than the ones shown when unfocused [${e.decimalPlacesShownOnBlur}]. This will likely confuse your users.
To solve that, you'd need to either set \`decimalPlacesRawValue\` to \`null\`, or set a number of decimal places for the raw value equal of bigger than \`decimalPlacesShownOnBlur\`.`, e.showWarnings));
  }
  /**
   * Return `true` if the settings/options are valid, `false` otherwise.
   *
   * @param {object} options
   * @returns {boolean}
   */
  static areSettingsValid(e) {
    let a = !0;
    try {
      this.validate(e, !0);
    } catch {
      a = !1;
    }
    return a;
  }
  /**
   * Return the default autoNumeric settings.
   *
   * @returns {object}
   */
  static getDefaultConfig() {
    return u.defaultSettings;
  }
  /**
   * Return all the predefined language options in one object.
   * You can also access a specific language object directly by using `AutoNumeric.getPredefinedOptions().French` for instance.
   *
   * @returns {object}
   */
  static getPredefinedOptions() {
    return u.predefinedOptions;
  }
  /**
   * Analyse the given array `options` and return a single 'merged' option objet.
   * `options` can be `null`, or an array of an option objects, or an array containing another array of option objects / strings (pre-defined option names)
   *
   * @param {null|Array<object|string|Array<string|object>>} options
   * @returns {null|object}
   * @private
   */
  static _generateOptionsObjectFromOptionsArray(e) {
    let a;
    return l.isUndefinedOrNullOrEmpty(e) || e.length === 0 ? a = null : (a = {}, e.length === 1 && Array.isArray(e[0]) ? e[0].forEach((i) => {
      Object.assign(a, this._getOptionObject(i));
    }) : e.length >= 1 && e.forEach((i) => {
      Object.assign(a, this._getOptionObject(i));
    })), a;
  }
  /**
   * Format the given number (or numeric string) with the given options. This returns the formatted value as a string.
   * This can also format the given DOM element value with the given options and returns the formatted value as a string.
   * Note : This function does *not* update that element value with the newly formatted value.
   * This basically allows to get the formatted value without first having to initialize an AutoNumeric object.
   *
   * @param {number|string|HTMLElement|HTMLInputElement} numericStringOrDomElement A number, or a string that represent a javascript number, or a DOM element
   * @param {object|null} options Multiple objects can be passed, the latter overwriting the settings from the former ones
   * @returns {string|null}
   */
  static format(e, ...a) {
    if (l.isUndefined(e) || e === null)
      return null;
    let i;
    l.isElement(e) ? i = l.getElementValue(e) : i = e, !l.isString(i) && !l.isNumber(i) && l.throwError(`The value "${i}" being "set" is not numeric and therefore cannot be used appropriately.`);
    const n = this._generateOptionsObjectFromOptionsArray(a), o = Object.assign({}, this.getDefaultConfig(), n);
    o.isNegativeSignAllowed = i < 0, o.isPositiveSignAllowed = i >= 0, this._setBrackets(o);
    const d = {};
    this._cachesUsualRegularExpressions(o, d);
    let s = this._toNumericValue(i, o);
    return isNaN(Number(s)) && l.throwError(`The value [${s}] that you are trying to format is not a recognized number.`), this._isWithinRangeWithOverrideOption(s, o) || (l.triggerEvent(u.events.formatted, document, {
      oldValue: null,
      newValue: null,
      oldRawValue: null,
      newRawValue: null,
      isPristine: null,
      error: "Range test failed",
      aNElement: null
    }, !0, !0), l.throwError(`The value [${s}] being set falls outside of the minimumValue [${o.minimumValue}] and maximumValue [${o.maximumValue}] range set for this element`)), o.valuesToStrings && this._checkValuesToStringsSettings(i, o) ? o.valuesToStrings[i] : (this._correctNegativePositiveSignPlacementOption(o), this._calculateDecimalPlacesOnInit(o), !l.isUndefinedOrNullOrEmpty(o.rawValueDivisor) && o.rawValueDivisor !== 0 && // Only divide if the `rawValueDivisor` option is set
    s !== "" && s !== null && (s *= o.rawValueDivisor), s = this._roundFormattedValueShownOnFocus(s, o), s = this._modifyNegativeSignAndDecimalCharacterForFormattedValue(s, o), s = this._addGroupSeparators(s, o, !1, s), s);
  }
  /**
   * Format the given DOM element value, and set the resulting value back as the element value.
   *
   * @param {HTMLElement|HTMLInputElement} domElement
   * @param {object} options
   * @returns {string|null}
   */
  static formatAndSet(e, a = null) {
    const i = this.format(e, a);
    return l.setElementValue(e, i), i;
  }
  /**
   * Unformat the given formatted string with the given options. This returns a numeric string.
   * It can also unformat the given DOM element value with the given options and returns the unformatted numeric string.
   * Note: This does *not* update that element value.
   * This basically allows to get the unformatted value without first having to initialize an AutoNumeric object.
   *
   * @param {string|number|HTMLElement|HTMLInputElement} numericStringOrDomElement A number, or a string that represent a javascript number, or a DOM element
   * @param {object|null} options Multiple objects can be passed, the latter overwriting the settings from the former ones
   * @returns {string|number|NaN}
   */
  static unformat(e, ...a) {
    if (l.isNumberStrict(e))
      return e;
    let i;
    if (l.isElement(e) ? i = l.getElementValue(e) : i = e, i === "")
      return "";
    if (l.isUndefined(i) || i === null)
      return null;
    (l.isArray(i) || l.isObject(i)) && l.throwError(`A number or a string representing a number is needed to be able to unformat it, [${i}] given.`);
    const n = this._generateOptionsObjectFromOptionsArray(a), o = Object.assign({}, this.getDefaultConfig(), n);
    return o.isNegativeSignAllowed = !1, o.isPositiveSignAllowed = !0, i = i.toString(), o.valuesToStrings && this._checkStringsToValuesSettings(i, o) ? l.objectKeyLookup(o.valuesToStrings, i) : (l.isNegative(i, o.negativeSignCharacter) ? (o.isNegativeSignAllowed = !0, o.isPositiveSignAllowed = !1) : l.isNull(o.negativeBracketsTypeOnBlur) || ([o.firstBracket, o.lastBracket] = o.negativeBracketsTypeOnBlur.split(","), i.charAt(0) === o.firstBracket && i.charAt(i.length - 1) === o.lastBracket && (o.isNegativeSignAllowed = !0, o.isPositiveSignAllowed = !1, i = this._removeBrackets(i, o, !1))), i = this._convertToNumericString(i, o), l.isNumber(Number(i)) && (i = l.scientificToDecimal(i)), new RegExp("[^+-0123456789.]", "gi").test(i) ? NaN : (this._correctNegativePositiveSignPlacementOption(o), o.decimalPlacesRawValue ? o.originalDecimalPlacesRawValue = o.decimalPlacesRawValue : o.originalDecimalPlacesRawValue = o.decimalPlaces, this._calculateDecimalPlacesOnInit(o), !l.isUndefinedOrNullOrEmpty(o.rawValueDivisor) && o.rawValueDivisor !== 0 && // Only divide if the `rawValueDivisor` option is set
    i !== "" && i !== null && (i /= o.rawValueDivisor), i = this._roundRawValue(i, o), i = i.replace(o.decimalCharacter, "."), i = this._toLocale(i, o.outputFormat, o), i));
  }
  /**
   * Unformat the given DOM element value, and set the resulting value back as the element value.
   *
   * @param {HTMLElement|HTMLInputElement} domElement
   * @param {object} options
   * @returns {*}
   */
  static unformatAndSet(e, a = null) {
    const i = this.unformat(e, a);
    return l.setElementValue(e, i), i;
  }
  /**
   * Unformat and localize the given formatted string with the given options. This returns a numeric string.
   * It can also unformat and localize the given DOM element value with the given options and returns the unformatted numeric string.
   * Note: This does *not* update that element value.
   * This basically allows to get the localized value without first having to initialize an AutoNumeric object.
   *
   * @param {string|number|HTMLElement|HTMLInputElement} numericStringOrDomElement
   * @param {object} settings
   * @returns {*}
   */
  static localize(e, a = null) {
    let i;
    if (l.isElement(e) ? i = l.getElementValue(e) : i = e, i === "")
      return "";
    l.isNull(a) && (a = u.defaultSettings), i = this.unformat(i, a), Number(i) === 0 && a.leadingZero !== u.options.leadingZero.keep && (i = "0");
    let n;
    return l.isNull(a) ? n = a.outputFormat : n = u.defaultSettings.outputFormat, this._toLocale(i, n, a);
  }
  static localizeAndSet(e, a = null) {
    const i = this.localize(e, a);
    return l.setElementValue(e, i), i;
  }
  /**
   * Return `true` if the given DOM element has an AutoNumeric object that manages it.
   * This function also accepts a selector string.
   *
   * @param {HTMLElement|string} domElementOrSelector Accepts either directly a DOM element to test, or a string selector (that will return one and only one element, if any)
   * @returns {boolean}
   */
  static isManagedByAutoNumeric(e) {
    return this._isInGlobalList(l.domElement(e));
  }
  /**
   * Return the AutoNumeric object that manages the given DOM element.
   * This function also accepts a selector string.
   *
   * @param {HTMLElement|string} domElementOrSelector Accepts either directly a DOM element to test, or a string selector (that will return one and only one element, if any)
   * @returns {null|AutoNumeric}
   */
  static getAutoNumericElement(e) {
    const a = l.domElement(e);
    return this.isManagedByAutoNumeric(a) ? this._getFromGlobalList(a) : null;
  }
  /**
   * Set the given element value, and format it immediately.
   * Return `null` if no AutoNumeric object is found, else, return the AutoNumeric object.
   *
   * @param {HTMLElement|string} domElementOrSelector Either a DOM element reference, or a selector string can be used
   * @param {number|string|null} newValue The value must be a Number, a numeric string or `null` (if `emptyInputBehavior` is set to `'null'`)
   * @param {object} options A settings object that will override the current settings. Note: the update is done only if the `newValue` is defined.
   * @param {boolean} saveChangeToHistory If set to `true`, then the change is recorded in the history table
   * @returns {AutoNumeric|null}
   */
  static set(e, a, i = null, n = !0) {
    const o = l.domElement(e);
    if (!this.isManagedByAutoNumeric(o)) {
      let d;
      return !l.isNull(i) && Object.prototype.hasOwnProperty.call(i, "showWarnings") ? d = i.showWarnings : d = !0, l.warning("Impossible to find an AutoNumeric object for the given DOM element or selector.", d), null;
    }
    return this.getAutoNumericElement(o).set(a, i, n);
  }
  /**
   * Return the unformatted value as a string from the given DOM element or query selector.
   * This can also return `null` if `rawValue` is null.
   *
   * @param {HTMLElement|string} domElementOrSelector
   * @param {function|null} callback
   * @returns {string|null}
   */
  static getNumericString(e, a = null) {
    return this._get(e, "getNumericString", a);
  }
  /**
   * Return the current formatted value of the AutoNumeric element as a string, from the given DOM element or query selector.
   *
   * @param {HTMLElement|string} domElementOrSelector
   * @param {function|null} callback
   * @returns {string}
   */
  static getFormatted(e, a = null) {
    return this._get(e, "getFormatted", a);
  }
  /**
   * Return the element unformatted value as a real Javascript number, from the given DOM element or query selector.
   * Warning: This can lead to precision problems with big numbers that should be stored as strings.
   *
   * @param {HTMLElement|string} domElementOrSelector
   * @param {function|null} callback
   * @returns {number|null}
   */
  static getNumber(e, a = null) {
    return this._get(e, "getNumber", a);
  }
  /**
   * DRY the code between the static `get*` functions
   *
   * @param {HTMLElement|string} domElementOrSelector
   * @param {string} getFunction The name of the non-static `get*` function as a string
   * @param {function|null} callback
   * @returns {*}
   * @private
   */
  static _get(e, a, i = null) {
    const n = l.domElement(e);
    return this.isManagedByAutoNumeric(n) || l.throwError("Impossible to find an AutoNumeric object for the given DOM element or selector."), this.getAutoNumericElement(n)[a](i);
  }
  /**
   * Returns the unformatted value following the `outputFormat` setting, from the given DOM element or query selector.
   * See the non-static `getLocalized()` method documentation for more details.
   *
   * @param {HTMLElement|string} domElementOrSelector
   * @param {null|string|function} forcedOutputFormat
   * @param {function|null} callback
   * @returns {*}
   */
  static getLocalized(e, a = null, i = null) {
    const n = l.domElement(e);
    return this.isManagedByAutoNumeric(n) || l.throwError("Impossible to find an AutoNumeric object for the given DOM element or selector."), this.getAutoNumericElement(n).getLocalized(a, i);
  }
  // Pre-defined options can be called to update the current default options with their specificities
  //XXX A better way would be to not initialize first, but that's not possible since `new` is called first and we do not pass the language options (i.e. `French`) to the constructor
  /**
   * Update the AutoNumeric object with the predefined options, and possibly some option overrides.
   *
   * @param {object} predefinedOption
   * @param {object} optionOverride
   * @private
   * @returns {AutoNumeric}
   */
  _updatePredefinedOptions(e, a = null) {
    return l.isNull(a) ? this.update(e) : (this._mergeSettings(e, a), this.update(this.settings)), this;
  }
  /**
   * Update the settings to use the French pre-defined language options.
   * Those pre-defined options can be overridden by passing an option object as a parameter.
   *
   * @param {object} optionOverride
   * @returns {AutoNumeric}
   */
  french(e = null) {
    return this._updatePredefinedOptions(u.getPredefinedOptions().French, e), this;
  }
  /**
   * Update the settings to use the North American pre-defined language options.
   * Those pre-defined options can be overridden by passing an option object as a parameter.
   *
   * @param {object} optionOverride
   * @returns {AutoNumeric}
   */
  northAmerican(e = null) {
    return this._updatePredefinedOptions(u.getPredefinedOptions().NorthAmerican, e), this;
  }
  /**
   * Update the settings to use the British pre-defined language options.
   * Those pre-defined options can be overridden by passing an option object as a parameter.
   *
   * @param {object} optionOverride
   * @returns {AutoNumeric}
   */
  british(e = null) {
    return this._updatePredefinedOptions(u.getPredefinedOptions().British, e), this;
  }
  /**
   * Update the settings to use the Swiss pre-defined language options.
   * Those pre-defined options can be overridden by passing an option object as a parameter.
   *
   * @param {object} optionOverride
   * @returns {AutoNumeric}
   */
  swiss(e = null) {
    return this._updatePredefinedOptions(u.getPredefinedOptions().Swiss, e), this;
  }
  /**
   * Update the settings to use the Japanese pre-defined language options.
   * Those pre-defined options can be overridden by passing an option object as a parameter.
   *
   * @param {object} optionOverride
   * @returns {AutoNumeric}
   */
  japanese(e = null) {
    return this._updatePredefinedOptions(u.getPredefinedOptions().Japanese, e), this;
  }
  /**
   * Update the settings to use the Spanish pre-defined language options.
   * Those pre-defined options can be overridden by passing an option object as a parameter.
   *
   * @param {object} optionOverride
   * @returns {AutoNumeric}
   */
  spanish(e = null) {
    return this._updatePredefinedOptions(u.getPredefinedOptions().Spanish, e), this;
  }
  /**
   * Update the settings to use the Chinese pre-defined language options.
   * Those pre-defined options can be overridden by passing an option object as a parameter.
   *
   * @param {object} optionOverride
   * @returns {AutoNumeric}
   */
  chinese(e = null) {
    return this._updatePredefinedOptions(u.getPredefinedOptions().Chinese, e), this;
  }
  /**
   * Update the settings to use the Brazilian pre-defined language options.
   * Those pre-defined options can be overridden by passing an option object as a parameter.
   *
   * @param {object} optionOverride
   * @returns {AutoNumeric}
   */
  brazilian(e = null) {
    return this._updatePredefinedOptions(u.getPredefinedOptions().Brazilian, e), this;
  }
  // Internal private functions
  /**
   * Run any callbacks found in the settings object in order to set the settings value back.
   * Any parameter can have a callback defined.
   * The callback takes the current AutoNumeric element as the first argument, and the key name as the second.
   * @example callback(this, 'currencySymbol')
   */
  _runCallbacksFoundInTheSettingsObject() {
    for (const e in this.settings)
      if (Object.prototype.hasOwnProperty.call(this.settings, e)) {
        const a = this.settings[e];
        if (typeof a == "function")
          this.settings[e] = a(this, e);
        else {
          let i = "";
          e in this.domElement.dataset && (i = this.domElement.dataset[e]), i = l.camelize(i), typeof this.settings[i] == "function" && (this.settings[e] = i(this, e));
        }
      }
  }
  /**
   * Keep track if the settings configuration leads to a trailing negative sign (only when the raw value is negative), so we do not have to test the settings values every time we need to know that.
   * `isTrailingNegative` is set to `true` if the settings result in a trailing negative character, `false` otherwise.
   * Note: This returns `true` even if the raw value is positive.
   * @private
   */
  _setTrailingNegativeSignInfo() {
    this.isTrailingNegative = this.settings.currencySymbolPlacement === u.options.currencySymbolPlacement.prefix && this.settings.negativePositiveSignPlacement === u.options.negativePositiveSignPlacement.suffix || this.settings.currencySymbolPlacement === u.options.currencySymbolPlacement.suffix && (this.settings.negativePositiveSignPlacement === u.options.negativePositiveSignPlacement.left || this.settings.negativePositiveSignPlacement === u.options.negativePositiveSignPlacement.right);
  }
  /**
   * Strip all the unwanted non-number characters.
   * However, it does not reorder the localized negative sign.
   *
   * @param {string} s
   * @param {object} settings
   * @param {boolean} stripZeros If set to `false`, then the leading zero(s) are not stripped, otherwise if set to `true`, the `leadingZero` option is followed
   * @param {boolean} isFocused If the element is focused, then this is `true`
   * @returns {string}
   * @private
   */
  static _stripAllNonNumberCharacters(e, a, i, n) {
    return this._stripAllNonNumberCharactersExceptCustomDecimalChar(e, a, i, n).replace(a.decimalCharacter, ".");
  }
  /**
   * Strip all unwanted non-number characters except the custom decimal character.
   *
   * It converts the custom negative sign and removes the positive sign (custom or not).
   * This keeps :
   * - the numbers,
   * - the normal negative sign '-' if any,
   * - and the *custom* decimal character.
   *
   * @param {string} s
   * @param {object} settings
   * @param {boolean} stripZeros If set to `false`, then the leading zero(s) are not stripped, otherwise if set to `true`, the `leadingZero` option is followed
   * @param {boolean} isFocused If the element is focused, then this is `true`
   * @returns {string|*}
   */
  static _stripAllNonNumberCharactersExceptCustomDecimalChar(e, a, i, n) {
    e = this._normalizeCurrencySuffixAndNegativeSignCharacters(e, a), e = e.replace(a.allowedAutoStrip, "");
    const o = e.match(a.numRegAutoStrip);
    if (e = o ? [o[1], o[2], o[3]].join("") : "", a.leadingZero === u.options.leadingZero.allow || a.leadingZero === u.options.leadingZero.keep) {
      let d = "";
      const [s, c] = e.split(a.decimalCharacter);
      let m = s;
      l.contains(m, a.negativeSignCharacter) && (d = a.negativeSignCharacter, m = m.replace(a.negativeSignCharacter, "")), d === "" && m.length > a.mIntPos && m.charAt(0) === "0" && (m = m.slice(1)), d !== "" && m.length > a.mIntNeg && m.charAt(0) === "0" && (m = m.slice(1)), e = `${d}${m}${l.isUndefined(c) ? "" : a.decimalCharacter + c}`;
    }
    return (i && a.leadingZero === u.options.leadingZero.deny || !n && a.leadingZero === u.options.leadingZero.allow) && (e = e.replace(a.stripReg, "$1$2")), e;
  }
  /**
   * Sets or removes brackets on negative values, depending on the focus state, which is passed as `isFocused`.
   * The focus state is 'stored' in that object property.
   *
   * @param {string} value
   * @param {object} settings
   * @param {boolean} isFocused
   * @returns {*}
   */
  static _toggleNegativeBracket(e, a, i) {
    let n;
    return i ? n = this._removeBrackets(e, a) : n = this._addBrackets(e, a), n;
  }
  /**
   * Add the bracket types specified in the `settings` object, to the given string `value`.
   *
   * @param {string} value
   * @param {object} settings
   * @returns {string}
   * @private
   */
  static _addBrackets(e, a) {
    return l.isNull(a.negativeBracketsTypeOnBlur) ? e : `${a.firstBracket}${e.replace(a.negativeSignCharacter, "")}${a.lastBracket}`;
  }
  /**
   * Remove the bracket types specified in the `settings` object, from the given string `value`.
   *
   * @param {string} value
   * @param {object} settings
   * @param {boolean} rearrangeSignsAndValueOrder If set to `true`, then only the brackets are remove and a negative sign is added, without reordering the negative sign, currency symbol and value according to the settings.
   * @returns {string}
   * @private
   */
  static _removeBrackets(e, a, i = !0) {
    let n;
    return !l.isNull(a.negativeBracketsTypeOnBlur) && e.charAt(0) === a.firstBracket ? (n = e.replace(a.firstBracket, ""), n = n.replace(a.lastBracket, ""), i ? (n = n.replace(a.currencySymbol, ""), n = this._mergeCurrencySignNegativePositiveSignAndValue(n, a, !0, !1)) : n = `${a.negativeSignCharacter}${n}`) : n = e, n;
  }
  /**
   * Analyze the `negativeBracketsTypeOnBlur` options and keep track of the first and last bracket characters to use.
   *
   * @param {object} settings
   * @private
   */
  static _setBrackets(e) {
    if (l.isNull(e.negativeBracketsTypeOnBlur))
      e.firstBracket = "", e.lastBracket = "";
    else {
      const [a, i] = e.negativeBracketsTypeOnBlur.split(",");
      e.firstBracket = a, e.lastBracket = i;
    }
  }
  /**
   * Return a number as a numeric string that can be typecast to a Number that Javascript will understand.
   *
   * This function returns the given string by stripping:
   * - the currency sign (currencySymbol),
   * - the grouping separators (digitalGroupSpacing),
   * - the suffix text (suffixText),
   * - the positive sign (positiveSignCharacter),
   * - the brackets if any,
   * - by replacing the negative sign character with a hyphen,
   * - and by replacing the decimal character (decimalCharacter) by a dot.
   *
   * Lastly, it also put the negative sign back to its normal position if needed.
   * Bonus; it converts any arabic numbers found to the latin ones.
   *
   * @param {string} s
   * @param {object} settings
   * @returns {string|void|*}
   */
  static _convertToNumericString(e, a) {
    e = this._removeBrackets(e, a, !1), e = this._normalizeCurrencySuffixAndNegativeSignCharacters(e, a), e = e.replace(new RegExp(`[${a.digitGroupSeparator}]`, "g"), ""), a.decimalCharacter !== "." && (e = e.replace(a.decimalCharacter, ".")), l.isNegative(e) && e.lastIndexOf("-") === e.length - 1 && (e = e.replace("-", ""), e = `-${e}`), a.showPositiveSign && (e = e.replace(a.positiveSignCharacter, ""));
    const i = a.leadingZero !== u.options.leadingZero.keep, n = l.arabicToLatinNumbers(e, i, !1, !1);
    return isNaN(n) || (e = n.toString()), e;
  }
  /**
   * Removes the currency symbol and the suffix text from the given string, and replace the custom negative sign with a hyphen.
   *
   * @param {string} s
   * @param {object} settings
   * @returns {string | *}
   * @private
   */
  static _normalizeCurrencySuffixAndNegativeSignCharacters(e, a) {
    return e = String(e), a.currencySymbol !== u.options.currencySymbol.none && (e = e.replace(a.currencySymbol, "")), a.suffixText !== u.options.suffixText.none && (e = e.replace(a.suffixText, "")), a.negativeSignCharacter !== u.options.negativeSignCharacter.hyphen && (e = e.replace(a.negativeSignCharacter, "-")), e;
  }
  /**
   * Converts the ISO numeric string to the locale decimal and minus sign placement.
   * See the "outputFormat" option definition for more details.
   * Note: If the `outputFormat` is set to a number, the custom `negativeSignCharacter` is ignored.
   *
   * @param {string|null} value The unformatted value
   * @param {string|null} locale
   * @param {object} settings
   * @returns {*}
   */
  static _toLocale(e, a, i) {
    if (l.isNull(a) || a === u.options.outputFormat.string)
      return e;
    let n;
    switch (a) {
      case u.options.outputFormat.number:
        n = Number(e);
        break;
      case u.options.outputFormat.dotNegative:
        n = l.isNegative(e) ? e.replace("-", "") + "-" : e;
        break;
      case u.options.outputFormat.comma:
      case u.options.outputFormat.negativeComma:
        n = e.replace(".", ",");
        break;
      case u.options.outputFormat.commaNegative:
        n = e.replace(".", ","), n = l.isNegative(n) ? n.replace("-", "") + "-" : n;
        break;
      case u.options.outputFormat.dot:
      case u.options.outputFormat.negativeDot:
        n = e;
        break;
      default:
        l.throwError(`The given outputFormat [${a}] option is not recognized.`);
    }
    return a !== u.options.outputFormat.number && i.negativeSignCharacter !== "-" && (n = n.replace("-", i.negativeSignCharacter)), n;
  }
  /**
   * Modify the negative sign and the decimal character of the given string value to a hyphen (-) and a dot (.) in order to make that value 'typecastable' to a real number.
   *
   * @param {string} s The formatted value
   * @returns {string} The value with the 'normal' minus sign and decimal character
   */
  _modifyNegativeSignAndDecimalCharacterForRawValue(e) {
    return this.settings.decimalCharacter !== "." && (e = e.replace(this.settings.decimalCharacter, ".")), this.settings.negativeSignCharacter !== "-" && this.settings.isNegativeSignAllowed && (e = e.replace(this.settings.negativeSignCharacter, "-")), e.match(/\d/) || (e += "0"), e;
  }
  /**
   * Modify the negative sign and the decimal character to use those defined in the settings.
   *
   * @param {string} s
   * @param {object} settings
   * @returns {string}
   */
  static _modifyNegativeSignAndDecimalCharacterForFormattedValue(e, a) {
    return a.negativeSignCharacter !== "-" && (e = e.replace("-", a.negativeSignCharacter)), a.decimalCharacter !== "." && (e = e.replace(".", a.decimalCharacter)), e;
  }
  /**
   * Return `true` if the given value is empty or is equal to the negative sign character defined in the given settings.
   *
   * @param {string} value
   * @param {object} settings
   * @returns {boolean}
   * @private
   */
  static _isElementValueEmptyOrOnlyTheNegativeSign(e, a) {
    return e === "" || e === a.negativeSignCharacter;
  }
  /**
   * Return the value with the currency symbol and the suffix text ordered according to the given settings.
   *
   * @param {string} value
   * @param {object} settings
   * @param {boolean} signOnEmpty
   * @returns {*}
   * @private
   */
  static _orderValueCurrencySymbolAndSuffixText(e, a, i) {
    let n;
    if (a.emptyInputBehavior === u.options.emptyInputBehavior.always || i)
      switch (a.negativePositiveSignPlacement) {
        case u.options.negativePositiveSignPlacement.left:
        case u.options.negativePositiveSignPlacement.prefix:
        case u.options.negativePositiveSignPlacement.none:
          n = e + a.currencySymbol + a.suffixText;
          break;
        default:
          n = a.currencySymbol + e + a.suffixText;
      }
    else
      n = e;
    return n;
  }
  /**
   * Modify the input value by adding the group separators, as defined in the settings, and the negative brackets if needed.
   *
   * @param {string} inputValue The formatted value (i.e. with the `decimalCharacter` defined in the settings, not the raw value)
   * @param {object} settings
   * @param {boolean} isFocused
   * @param {number|string|null} currentRawValue The object current raw value (`this.rawValue`)
   * @param {number|string|null} forcedRawValue If this is set, then this rawValue is used instead of the one passed through the `settings` object. This is useful is some very specific cases where we need to set the raw value *after* settings the formatted value, using the `_addGroupSeparators()` method.
   * @returns {*}
   */
  static _addGroupSeparators(e, a, i, n, o = null) {
    let d;
    if (l.isNull(o) ? d = l.isNegative(e, a.negativeSignCharacter) || l.isNegativeWithBrackets(e, a.firstBracket, a.lastBracket) : d = o < 0, e = this._stripAllNonNumberCharactersExceptCustomDecimalChar(e, a, !1, i), this._isElementValueEmptyOrOnlyTheNegativeSign(e, a))
      return this._orderValueCurrencySymbolAndSuffixText(e, a, !0);
    const s = l.isZeroOrHasNoValue(e);
    d && (e = e.replace("-", ""));
    let [c, m] = e.split(a.decimalCharacter);
    if (a.decimalCharacterAlternative && l.isUndefined(m) && ([c, m] = e.split(a.decimalCharacterAlternative)), a.digitGroupSeparator !== "") {
      a.digitalGroupSpacing = a.digitalGroupSpacing.toString();
      let b;
      switch (a.digitalGroupSpacing) {
        case u.options.digitalGroupSpacing.twoThree:
          b = /(\d)((\d)(\d{2}?)+)$/;
          break;
        case u.options.digitalGroupSpacing.twoScaled:
          b = /(\d)((?:\d{2}){0,2}\d{3}(?:(?:\d{2}){2}\d{3})*?)$/;
          break;
        case u.options.digitalGroupSpacing.two:
        case u.options.digitalGroupSpacing.three:
        case u.options.digitalGroupSpacing.four:
        default:
          b = new RegExp(`(\\d)((\\d{${a.digitalGroupSpacing}}?)+)$`);
      }
      for (; b.test(c); )
        c = c.replace(b, `$1${a.digitGroupSeparator}$2`);
    }
    let f;
    i ? f = a.decimalPlacesShownOnFocus : f = a.decimalPlacesShownOnBlur, f !== 0 && !l.isUndefined(m) ? (m.length > f && (m = m.substring(0, f)), e = `${c}${a.decimalCharacter}${m}`) : e = c, e = u._mergeCurrencySignNegativePositiveSignAndValue(e, a, d, s), l.isNull(o) && (o = n), a.negativeBracketsTypeOnBlur !== null && (o < 0 || l.isNegativeStrict(e, a.negativeSignCharacter)) && (e = this._toggleNegativeBracket(e, a, i));
    let p;
    return a.suffixText ? p = `${e}${a.suffixText}` : p = e, p;
  }
  /**
   * Return a semi-formatted string where the input value, the negative or positive sign, and the currency symbol are stitched together at the right positions, using the options set in the `settings` object.
   * Note : the `inputValue` is usually not a numeric string since the grouping symbols are already added to it at this point.
   *
   * @param {string} inputValue
   * @param {object} settings
   * @param {boolean} isValueNegative
   * @param {boolean} isZeroOrHasNoValue
   * @returns {*}
   * @throws
   * @private
   */
  static _mergeCurrencySignNegativePositiveSignAndValue(e, a, i, n) {
    let o = "";
    i ? o = a.negativeSignCharacter : a.showPositiveSign && !n && (o = a.positiveSignCharacter);
    let d;
    if (a.currencySymbolPlacement === u.options.currencySymbolPlacement.prefix)
      if (a.negativePositiveSignPlacement !== u.options.negativePositiveSignPlacement.none && (i || !i && a.showPositiveSign && !n))
        switch (a.negativePositiveSignPlacement) {
          case u.options.negativePositiveSignPlacement.prefix:
          case u.options.negativePositiveSignPlacement.left:
            d = `${o}${a.currencySymbol}${e}`;
            break;
          case u.options.negativePositiveSignPlacement.right:
            d = `${a.currencySymbol}${o}${e}`;
            break;
          case u.options.negativePositiveSignPlacement.suffix:
            d = `${a.currencySymbol}${e}${o}`;
            break;
        }
      else
        d = a.currencySymbol + e;
    else if (a.currencySymbolPlacement === u.options.currencySymbolPlacement.suffix)
      if (a.negativePositiveSignPlacement !== u.options.negativePositiveSignPlacement.none && (i || !i && a.showPositiveSign && !n))
        switch (a.negativePositiveSignPlacement) {
          case u.options.negativePositiveSignPlacement.suffix:
          case u.options.negativePositiveSignPlacement.right:
            d = `${e}${a.currencySymbol}${o}`;
            break;
          case u.options.negativePositiveSignPlacement.left:
            d = `${e}${o}${a.currencySymbol}`;
            break;
          case u.options.negativePositiveSignPlacement.prefix:
            d = `${o}${e}${a.currencySymbol}`;
            break;
        }
      else
        d = e + a.currencySymbol;
    return d;
  }
  /**
   * Calculate where to put the caret position on focus if the element content is not selected.
   * This calculation is affected by the `caretPositionOnFocus` option which can be either `null`, `'start'`, `'end'`, `'decimalLeft'` or 'decimalRight'`, and will decide where to put the caret (on the left or right of the value or the decimal character, respectively) :
   * - `null` : the caret position is not forced
   * - `'start'` : the caret is positioned on the left hand side of the value
   * - `'end'` : the caret is positioned on the right hand side of the value
   * - `'decimalLeft'` : the caret is positioned on the left side of the decimal character
   * - `'decimalRight'` : the caret is positioned on the right side of the decimal character
   *
   * @param {string} value The formatted string stripped of the currency symbol and negative/positive sign
   * @returns {number}
   * @throws
   * @private
   */
  _initialCaretPosition(e) {
    l.isNull(this.settings.caretPositionOnFocus) && this.settings.selectOnFocus === u.options.selectOnFocus.doNotSelect && l.throwError("`_initialCaretPosition()` should never be called when the `caretPositionOnFocus` option is `null`.");
    const a = this.rawValue < 0, i = l.isZeroOrHasNoValue(e), n = e.length;
    let o = 0, d = 0, s = !1, c = 0;
    this.settings.caretPositionOnFocus !== u.options.caretPositionOnFocus.start && (e = e.replace(this.settings.negativeSignCharacter, ""), e = e.replace(this.settings.positiveSignCharacter, ""), e = e.replace(this.settings.currencySymbol, ""), o = e.length, s = l.contains(e, this.settings.decimalCharacter), (this.settings.caretPositionOnFocus === u.options.caretPositionOnFocus.decimalLeft || this.settings.caretPositionOnFocus === u.options.caretPositionOnFocus.decimalRight) && (s ? (d = e.indexOf(this.settings.decimalCharacter), c = this.settings.decimalCharacter.length) : (d = o, c = 0)));
    let m = "";
    a ? m = this.settings.negativeSignCharacter : this.settings.showPositiveSign && !i && (m = this.settings.positiveSignCharacter);
    const f = m.length, p = this.settings.currencySymbol.length;
    let b;
    if (this.settings.currencySymbolPlacement === u.options.currencySymbolPlacement.prefix) {
      if (this.settings.caretPositionOnFocus === u.options.caretPositionOnFocus.start)
        if (this.settings.negativePositiveSignPlacement !== u.options.negativePositiveSignPlacement.none && (a || !a && this.settings.showPositiveSign && !i))
          switch (this.settings.negativePositiveSignPlacement) {
            case u.options.negativePositiveSignPlacement.prefix:
            case u.options.negativePositiveSignPlacement.left:
            case u.options.negativePositiveSignPlacement.right:
              b = f + p;
              break;
            case u.options.negativePositiveSignPlacement.suffix:
              b = p;
              break;
          }
        else
          b = p;
      else if (this.settings.caretPositionOnFocus === u.options.caretPositionOnFocus.end)
        if (this.settings.negativePositiveSignPlacement !== u.options.negativePositiveSignPlacement.none && (a || !a && this.settings.showPositiveSign && !i))
          switch (this.settings.negativePositiveSignPlacement) {
            case u.options.negativePositiveSignPlacement.prefix:
            case u.options.negativePositiveSignPlacement.left:
            case u.options.negativePositiveSignPlacement.right:
              b = n;
              break;
            case u.options.negativePositiveSignPlacement.suffix:
              b = p + o;
              break;
          }
        else
          b = n;
      else if (this.settings.caretPositionOnFocus === u.options.caretPositionOnFocus.decimalLeft)
        if (this.settings.negativePositiveSignPlacement !== u.options.negativePositiveSignPlacement.none && (a || !a && this.settings.showPositiveSign && !i))
          switch (this.settings.negativePositiveSignPlacement) {
            case u.options.negativePositiveSignPlacement.prefix:
            case u.options.negativePositiveSignPlacement.left:
            case u.options.negativePositiveSignPlacement.right:
              b = f + p + d;
              break;
            case u.options.negativePositiveSignPlacement.suffix:
              b = p + d;
              break;
          }
        else
          b = p + d;
      else if (this.settings.caretPositionOnFocus === u.options.caretPositionOnFocus.decimalRight)
        if (this.settings.negativePositiveSignPlacement !== u.options.negativePositiveSignPlacement.none && (a || !a && this.settings.showPositiveSign && !i))
          switch (this.settings.negativePositiveSignPlacement) {
            case u.options.negativePositiveSignPlacement.prefix:
            case u.options.negativePositiveSignPlacement.left:
            case u.options.negativePositiveSignPlacement.right:
              b = f + p + d + c;
              break;
            case u.options.negativePositiveSignPlacement.suffix:
              b = p + d + c;
              break;
          }
        else
          b = p + d + c;
    } else if (this.settings.currencySymbolPlacement === u.options.currencySymbolPlacement.suffix) {
      if (this.settings.caretPositionOnFocus === u.options.caretPositionOnFocus.start)
        if (this.settings.negativePositiveSignPlacement !== u.options.negativePositiveSignPlacement.none && (a || !a && this.settings.showPositiveSign && !i))
          switch (this.settings.negativePositiveSignPlacement) {
            case u.options.negativePositiveSignPlacement.suffix:
            case u.options.negativePositiveSignPlacement.right:
            case u.options.negativePositiveSignPlacement.left:
              b = 0;
              break;
            case u.options.negativePositiveSignPlacement.prefix:
              b = f;
              break;
          }
        else
          b = 0;
      else if (this.settings.caretPositionOnFocus === u.options.caretPositionOnFocus.end)
        if (this.settings.negativePositiveSignPlacement !== u.options.negativePositiveSignPlacement.none && (a || !a && this.settings.showPositiveSign && !i))
          switch (this.settings.negativePositiveSignPlacement) {
            case u.options.negativePositiveSignPlacement.suffix:
            case u.options.negativePositiveSignPlacement.right:
            case u.options.negativePositiveSignPlacement.left:
              b = o;
              break;
            case u.options.negativePositiveSignPlacement.prefix:
              b = f + o;
              break;
          }
        else
          b = o;
      else if (this.settings.caretPositionOnFocus === u.options.caretPositionOnFocus.decimalLeft)
        if (this.settings.negativePositiveSignPlacement !== u.options.negativePositiveSignPlacement.none && (a || !a && this.settings.showPositiveSign && !i))
          switch (this.settings.negativePositiveSignPlacement) {
            case u.options.negativePositiveSignPlacement.suffix:
            case u.options.negativePositiveSignPlacement.right:
            case u.options.negativePositiveSignPlacement.left:
              b = d;
              break;
            case u.options.negativePositiveSignPlacement.prefix:
              b = f + d;
              break;
          }
        else
          b = d;
      else if (this.settings.caretPositionOnFocus === u.options.caretPositionOnFocus.decimalRight)
        if (this.settings.negativePositiveSignPlacement !== u.options.negativePositiveSignPlacement.none && (a || !a && this.settings.showPositiveSign && !i))
          switch (this.settings.negativePositiveSignPlacement) {
            case u.options.negativePositiveSignPlacement.suffix:
            case u.options.negativePositiveSignPlacement.right:
            case u.options.negativePositiveSignPlacement.left:
              b = d + c;
              break;
            case u.options.negativePositiveSignPlacement.prefix:
              b = f + d + c;
              break;
          }
        else
          b = d + c;
    }
    return b;
  }
  /**
   * Truncate the trailing zeroes to the given number of decimal places
   *
   * @param {string} roundedInputValue
   * @param {int} decimalPlacesNeeded The number of decimal places to keep
   * @returns {string}
   */
  static _truncateZeros(e, a) {
    let i;
    switch (a) {
      case 0:
        i = /(\.(?:\d*[1-9])?)0*$/;
        break;
      case 1:
        i = /(\.\d(?:\d*[1-9])?)0*$/;
        break;
      default:
        i = new RegExp(`(\\.\\d{${a}}(?:\\d*[1-9])?)0*`);
    }
    return e = e.replace(i, "$1"), a === 0 && (e = e.replace(/\.$/, "")), e;
  }
  /**
   * Round the given `value` with the number of decimal places to keep for the raw value.
   *
   * @param {string|null} value An unformatted numeric value
   * @param {object} settings
   * @returns {*}
   * @private
   */
  static _roundRawValue(e, a) {
    return this._roundValue(e, a, a.decimalPlacesRawValue);
  }
  /**
   * Round the given `value` with the number of decimal places to show for the element if focused.
   *
   * @param {string|null} value An unformatted numeric value
   * @param {object} settings
   * @returns {*}
   * @private
   */
  static _roundFormattedValueShownOnFocus(e, a) {
    return this._roundValue(e, a, Number(a.decimalPlacesShownOnFocus));
  }
  /**
   * Round the given `value` with the number of decimal places to show for the element if unfocused.
   *
   * @param {string|null} value An unformatted numeric value
   * @param {object} settings
   * @returns {*}
   * @private
   */
  static _roundFormattedValueShownOnBlur(e, a) {
    return this._roundValue(e, a, Number(a.decimalPlacesShownOnBlur));
  }
  /**
   * Round the given `value` with the number of decimal places to show for the element based on the value of isFocused.
   *
   * @param {string|null} value An unformatted numeric value
   * @param {object} settings
   * @param {boolean} isFocused
   * @returns {*}
   * @private
   */
  static _roundFormattedValueShownOnFocusOrBlur(e, a, i) {
    return i ? this._roundFormattedValueShownOnFocus(e, a) : this._roundFormattedValueShownOnBlur(e, a);
  }
  /**
   * Round the input value using the rounding method defined in the settings.
   * This function accepts multiple rounding methods. See the documentation for more details about those.
   *
   * Note : This is handled as text since JavaScript math functions can return inaccurate values.
   *
   * @param {string|null} inputValue An unformatted numeric value
   * @param {object} settings
   * @param {int} decimalPlacesToRoundTo
   * @returns {*}
   */
  static _roundValue(e, a, i) {
    if (l.isNull(e))
      return e;
    if (e = e === "" ? "0" : e.toString(), a.roundingMethod === u.options.roundingMethod.toNearest05 || a.roundingMethod === u.options.roundingMethod.toNearest05Alt || a.roundingMethod === u.options.roundingMethod.upToNext05 || a.roundingMethod === u.options.roundingMethod.downToNext05)
      return this._roundCloseTo05(e, a);
    const [n, o] = u._prepareValueForRounding(e, a);
    e = o;
    const d = e.lastIndexOf("."), s = d === -1, [c, m] = e.split(".");
    if (!(m > 0) && (a.allowDecimalPadding === u.options.allowDecimalPadding.never || a.allowDecimalPadding === u.options.allowDecimalPadding.floats))
      return Number(e) === 0 ? c : `${n}${c}`;
    let p;
    a.allowDecimalPadding === u.options.allowDecimalPadding.always || a.allowDecimalPadding === u.options.allowDecimalPadding.floats ? p = i : a.allowDecimalPadding > 0 ? p = a.allowDecimalPadding : p = 0;
    const b = s ? e.length - 1 : d;
    let y = e.length - 1 - b, v = "";
    if (y <= i) {
      if (v = e, y < p) {
        s && (v = `${v}${a.decimalCharacter}`);
        let O = "000000";
        for (; y < p; )
          O = O.substring(0, p - y), v += O, y += O.length;
      } else y > p ? v = this._truncateZeros(v, p) : y === 0 && p === 0 && (v = v.replace(/\.$/, ""));
      return Number(v) === 0 ? v : `${n}${v}`;
    }
    let g;
    s ? g = i - 1 : g = Number(i) + Number(d);
    const _ = Number(e.charAt(g + 1));
    let M = e.substring(0, g + 1).split(""), S;
    if (e.charAt(g) === "." ? S = e.charAt(g - 1) % 2 : S = e.charAt(g) % 2, this._shouldRoundUp(_, a, n, S)) {
      for (let O = M.length - 1; O >= 0; O -= 1)
        if (M[O] !== ".") {
          if (M[O] = +M[O] + 1, M[O] < 10)
            break;
          O > 0 && (M[O] = "0");
        }
    }
    return M = M.slice(0, g + 1), v = this._truncateZeros(M.join(""), p), Number(v) === 0 ? v : `${n}${v}`;
  }
  /**
   * Round the `value` when the rounding method deals with '.05'
   *
   * @param {string} value
   * @param {object} settings
   * @returns {string}
   * @private
   */
  static _roundCloseTo05(e, a) {
    switch (a.roundingMethod) {
      case u.options.roundingMethod.toNearest05:
      case u.options.roundingMethod.toNearest05Alt:
        e = (Math.round(e * 20) / 20).toString();
        break;
      case u.options.roundingMethod.upToNext05:
        e = (Math.ceil(e * 20) / 20).toString();
        break;
      default:
        e = (Math.floor(e * 20) / 20).toString();
    }
    let i;
    return l.contains(e, ".") ? e.length - e.indexOf(".") < 3 ? i = e + "0" : i = e : i = e + ".00", i;
  }
  /**
   * Modify the given `value` in order to make it usable for the rest of the rounding function.
   * This convert the `value` to a positive one, trim any leading zeros and make sure it does not start with a leading dot.
   *
   * @param {string} value The unformatted value
   * @param {object} settings
   * @returns {[string, string]}
   * @private
   */
  static _prepareValueForRounding(e, a) {
    let i = "";
    return l.isNegativeStrict(e, "-") && (i = "-", e = e.replace("-", "")), e.match(/^\d/) || (e = `0${e}`), Number(e) === 0 && (i = ""), (Number(e) > 0 && a.leadingZero !== u.options.leadingZero.keep || e.length > 0 && a.leadingZero === u.options.leadingZero.allow) && (e = e.replace(/^0*(\d)/, "$1")), [i, e];
  }
  /**
   * Return `true` if a round up should be done given the last digit, the settings and other information about the value.
   *
   * @param {number} lastDigit
   * @param {object} settings
   * @param {string} negativeSign This variable comes from `_prepareValueForRounding()`, which return `'-'` if the initial value was negative
   * @param {number} odd
   * @returns {boolean}
   * @private
   */
  static _shouldRoundUp(e, a, i, n) {
    return e > 4 && a.roundingMethod === u.options.roundingMethod.halfUpSymmetric || // Round half up symmetric
    e > 4 && a.roundingMethod === u.options.roundingMethod.halfUpAsymmetric && i === "" || // Round half up asymmetric positive values
    e > 5 && a.roundingMethod === u.options.roundingMethod.halfUpAsymmetric && i === "-" || // Round half up asymmetric negative values
    e > 5 && a.roundingMethod === u.options.roundingMethod.halfDownSymmetric || // Round half down symmetric
    e > 5 && a.roundingMethod === u.options.roundingMethod.halfDownAsymmetric && i === "" || // Round half down asymmetric positive values
    e > 4 && a.roundingMethod === u.options.roundingMethod.halfDownAsymmetric && i === "-" || // Round half down asymmetric negative values
    e > 5 && a.roundingMethod === u.options.roundingMethod.halfEvenBankersRounding || e === 5 && a.roundingMethod === u.options.roundingMethod.halfEvenBankersRounding && n === 1 || e > 0 && a.roundingMethod === u.options.roundingMethod.toCeilingTowardPositiveInfinity && i === "" || e > 0 && a.roundingMethod === u.options.roundingMethod.toFloorTowardNegativeInfinity && i === "-" || e > 0 && a.roundingMethod === u.options.roundingMethod.upRoundAwayFromZero;
  }
  /**
   * Truncates the decimal part of a number to the given number of decimal places `decimalPlacesToRoundTo`.
   *
   * @param {string} value
   * @param {object} settings
   * @param {boolean} isPaste
   * @param {int} decimalPlacesToRoundTo
   * @returns {*}
   */
  static _truncateDecimalPlaces(e, a, i, n) {
    i && (e = this._roundFormattedValueShownOnFocus(e, a));
    const [o, d] = e.split(a.decimalCharacter);
    if (d && d.length > n)
      if (n > 0) {
        const s = d.substring(0, n);
        e = `${o}${a.decimalCharacter}${s}`;
      } else
        e = o;
    return e;
  }
  /**
   * Check if the given value is within the `minimumValue` and `maximumValue` range, while using the override options set with `overrideMinMaxLimits`.
   * The minimum and maximum limit test results are returned in an array like `[isMinimumLimitRespected, isMaximumLimitRespected]`.
   *
   * @param {string} value
   * @param {object} settings
   * @returns {[boolean, boolean]}
   */
  static _checkIfInRangeWithOverrideOption(e, a) {
    if (l.isNull(e) && a.emptyInputBehavior === u.options.emptyInputBehavior.null || // When the `null` value is accepted as the `rawValue`, the limits are ignored
    a.overrideMinMaxLimits === u.options.overrideMinMaxLimits.ignore || a.overrideMinMaxLimits === u.options.overrideMinMaxLimits.invalid)
      return [!0, !0];
    e = e.toString(), e = e.replace(",", ".");
    const i = l.parseStr(a.minimumValue), n = l.parseStr(a.maximumValue), o = l.parseStr(e);
    let d;
    switch (a.overrideMinMaxLimits) {
      case u.options.overrideMinMaxLimits.floor:
        d = [l.testMinMax(i, o) > -1, !0];
        break;
      case u.options.overrideMinMaxLimits.ceiling:
        d = [!0, l.testMinMax(n, o) < 1];
        break;
      default:
        d = [l.testMinMax(i, o) > -1, l.testMinMax(n, o) < 1];
    }
    return d;
  }
  /**
   * Returns `true` if the given value is within the `minimumValue` and `maximumValue` limits, while using the override options set with `overrideMinMaxLimits`, `false` otherwise
   *
   * @param {string} value
   * @param {object} settings
   * @returns {boolean}
   * @private
   */
  static _isWithinRangeWithOverrideOption(e, a) {
    const [i, n] = this._checkIfInRangeWithOverrideOption(e, a);
    return i && n;
  }
  /**
   * Helper function that prepares the value string for the min/max test
   *
   * @param {string} value
   * @returns {{}}
   * @private
   */
  static _cleanValueForRangeParse(e) {
    return e = e.toString().replace(",", "."), l.parseStr(e);
  }
  /**
   * Returns `true` is the value is superior or equal to the `minimumValue` limit, discarding any override options
   *
   * @param {string} value
   * @param {object} settings
   * @returns {boolean}
   * @private
   */
  static _isMinimumRangeRespected(e, a) {
    return l.testMinMax(l.parseStr(a.minimumValue), this._cleanValueForRangeParse(e)) > -1;
  }
  /**
   * Returns `true` is the value is inferior or equal to the `maximumValue` limit, discarding any override options
   *
   * @param {string} value
   * @param {object} settings
   * @returns {boolean}
   * @private
   */
  static _isMaximumRangeRespected(e, a) {
    return l.testMinMax(l.parseStr(a.maximumValue), this._cleanValueForRangeParse(e)) < 1;
  }
  /**
   * Helper function that triggers the range events if they are needed
   *
   * @param {boolean} minTest
   * @param {boolean} maxTest
   * @private
   */
  _triggerRangeEvents(e, a) {
    e || this._triggerEvent(u.events.minRangeExceeded, this.domElement), a || this._triggerEvent(u.events.maxRangeExceeded, this.domElement);
  }
  /**
   * Set the invalid state on the AutoNumeric element.
   * If the element is not an input, and therefore a contenteditable-enabled element, its validity state cannot be changed.
   * In that case, the invalid css class defined with the `settings.invalidClass` option is added to the element.
   * The 'autoNumeric:invalidValue' event is always sent when this function is called.
   *
   * @private
   */
  _setInvalidState() {
    this.isInputElement ? l.setInvalidState(this.domElement) : this._addCSSClass(this.settings.invalidClass), this._triggerEvent(u.events.invalidValue, this.domElement), this.validState = !1;
  }
  /**
   * Set the valid state on the AutoNumeric element.
   * If the element is not an input, and therefore a contenteditable-enabled element, its validity state cannot be changed.
   * In that case, the invalid css class defined with the `settings.invalidClass` option is removed.
   * The 'autoNumeric:correctedValue' event is sent if the element state is invalid when this is called.
   *
   * @private
   */
  _setValidState() {
    this.isInputElement ? l.setValidState(this.domElement) : this._removeCSSClass(this.settings.invalidClass), this.validState || this._triggerEvent(u.events.correctedValue, this.domElement), this.validState = !0;
  }
  /**
   * Sets the valid or invalid state on the DOM element, if the value is within the range set by the minimum and maximum value
   *
   * @param {string} value
   * @private
   */
  _setValidOrInvalidState(e) {
    if (this.settings.overrideMinMaxLimits === u.options.overrideMinMaxLimits.invalid) {
      const a = this.constructor._isMinimumRangeRespected(e, this.settings), i = this.constructor._isMaximumRangeRespected(e, this.settings);
      a && i ? this._setValidState() : this._setInvalidState(), this._triggerRangeEvents(a, i);
    }
  }
  /**
   * Original settings saved for use when the `decimalPlacesShownOnFocus` and `showOnlyNumbersOnFocus` options are used.
   * Those original settings are used exclusively in the `focusin` and `focusout` event handlers.
   */
  _keepAnOriginalSettingsCopy() {
    this.originalDigitGroupSeparator = this.settings.digitGroupSeparator, this.originalCurrencySymbol = this.settings.currencySymbol, this.originalSuffixText = this.settings.suffixText;
  }
  /**
   * Removes any zeros in excess in the front and back of the given `value`, according to the `settings`.
   * This also manages the cases where the decimal point is on the far left or far right of the `value`.
   *
   * @param {string} value
   * @returns {string|null}
   */
  _trimLeadingAndTrailingZeros(e) {
    if (e === "" || e === null)
      return e;
    if (this.settings.leadingZero !== u.options.leadingZero.keep) {
      if (Number(e) === 0)
        return "0";
      e = e.replace(/^(-)?0+(?=\d)/g, "$1");
    }
    return l.contains(e, ".") && (e = e.replace(/(\.[0-9]*?)0+$/, "$1")), e = e.replace(/\.$/, ""), e;
  }
  /**
   * Generate the name for the persistent stored data variable
   * @private
   */
  _setPersistentStorageName() {
    this.settings.saveValueToSessionStorage && (this.domElement.name !== "" && !l.isUndefined(this.domElement.name) ? this.rawValueStorageName = `${this.storageNamePrefix}${decodeURIComponent(this.domElement.name)}` : this.rawValueStorageName = `${this.storageNamePrefix}${this.domElement.id}`);
  }
  /**
   * Save the raw Value into sessionStorage or a cookie depending on what the browser is supporting.
   * @private
   */
  _saveValueToPersistentStorage() {
    this.settings.saveValueToSessionStorage && sessionStorage.setItem(this.rawValueStorageName, this.rawValue);
  }
  /**
   * Retrieve the raw value from sessionStorage or the cookie depending on what the browser is supporting.
   *
   * @returns {*}
   * @private
   */
  _getValueFromPersistentStorage() {
    return this.settings.saveValueToSessionStorage ? sessionStorage.getItem(this.rawValueStorageName) : (l.warning("`_getValueFromPersistentStorage()` is called but `settings.saveValueToSessionStorage` is false. There must be an error that needs fixing.", this.settings.showWarnings), null);
  }
  /**
   * Remove the raw value data from sessionStorage or the cookie depending on what the browser is supporting.
   * @private
   */
  _removeValueFromPersistentStorage() {
    this.settings.saveValueToSessionStorage && sessionStorage.removeItem(this.rawValueStorageName);
  }
  /**
   * Get the default value from the html `value` attribute.
   * Return the empty string if such attribute is not found.
   *
   * @param {HTMLElement} domElement
   *
   * @returns {string}
   * @private
   */
  _getDefaultValue(e) {
    const a = e.getAttribute("value");
    return l.isNull(a) ? "" : a;
  }
  /**
   * Handler for 'focusin' and 'mouseenter' events
   * On focusin, multiple things happens :
   * - If `Alt` is pressed, unformat
   * - Remove the separators if `showOnlyNumbersOnFocus` is set
   * - Depending on `emptyInputBehavior`, reformat the empty formatted value
   * - Display the correct number of decimal places (on focus/blur)
   * - Place the caret correctly if the element is empty
   *
   * Note: On focusin, the `rawValue` is never changed. Only the formatted value can be modified.
   *
   * @param {KeyboardEvent|MouseEvent} e
   * @private
   */
  _onFocusInAndMouseEnter(e) {
    if (this.isEditing = !1, !this.formulaMode && this.settings.unformatOnHover && e.type === "mouseenter" && e.altKey) {
      this.constructor._unformatAltHovered(this);
      return;
    }
    if (e.type === "focus" && (this.isFocused = !0, this.rawValueOnFocus = this.rawValue), e.type === "focus" && this.settings.unformatOnHover && this.hoveredWithAlt && this.constructor._reformatAltHovered(this), e.type === "focus" || e.type === "mouseenter" && !this.isFocused) {
      let a = null;
      this.settings.emptyInputBehavior === u.options.emptyInputBehavior.focus && this.rawValue < 0 && this.settings.negativeBracketsTypeOnBlur !== null && this.settings.isNegativeSignAllowed && (a = this.constructor._removeBrackets(l.getElementValue(this.domElement), this.settings));
      const i = this._getRawValueToFormat(this.rawValue);
      if (i !== "") {
        const s = this.constructor._roundFormattedValueShownOnFocusOrBlur(i, this.settings, this.isFocused);
        if (this.settings.showOnlyNumbersOnFocus === u.options.showOnlyNumbersOnFocus.onlyNumbers)
          this.settings.digitGroupSeparator = "", this.settings.currencySymbol = "", this.settings.suffixText = "", a = s.replace(".", this.settings.decimalCharacter);
        else {
          let c;
          l.isNull(s) ? c = "" : c = this.constructor._addGroupSeparators(s.replace(".", this.settings.decimalCharacter), this.settings, this.isFocused, i), a = c;
        }
      }
      l.isNull(a) ? this.valueOnFocus = "" : this.valueOnFocus = a, this.lastVal = this.valueOnFocus;
      const n = this.constructor._isElementValueEmptyOrOnlyTheNegativeSign(this.valueOnFocus, this.settings), o = this.constructor._orderValueCurrencySymbolAndSuffixText(this.valueOnFocus, this.settings, !0), d = n && o !== "" && this.settings.emptyInputBehavior === u.options.emptyInputBehavior.focus;
      d && (a = o), l.isNull(a) || this._setElementValue(a), d && o === this.settings.currencySymbol && this.settings.currencySymbolPlacement === u.options.currencySymbolPlacement.suffix && l.setElementSelection(e.target, 0);
    }
  }
  /**
   * Handler for the 'focus' event.
   * We update the info of the focused state in the `this.isFocused` variable when the element gets focused.
   * @private
   */
  _onFocus() {
    this.settings.isCancellable && this._saveCancellableValue();
  }
  /**
   * Handler for the 'focusin' event.
   * This is called before the 'focus' event, and is necessary to change the selection on focus under Firefox for instance.
   *
   * @param {Event} e
   * @private
   */
  _onFocusIn(e) {
    this.settings.selectOnFocus ? this.select() : l.isNull(this.settings.caretPositionOnFocus) || l.setElementSelection(e.target, this._initialCaretPosition(l.getElementValue(this.domElement)));
  }
  /**
   * Enter the special 'formula mode' where users can enter a math expression that will be evaluated on blur and `enter`
   * @private
   */
  _enterFormulaMode() {
    this.settings.formulaMode && (this.formulaMode = !0, l.setElementValue(this.domElement, "="), l.setElementSelection(this.domElement, 1));
  }
  /**
   * Exit the formula mode
   * Tries to parse and evaluate the math expression, then `set()` the result if it's correct, otherwise reformat with the previous `rawValue`
   * @private
   */
  _exitFormulaMode() {
    let e = l.getElementValue(this.domElement);
    e = e.replace(/^\s*=/, "");
    let a;
    try {
      const i = new fr(e, this.settings.decimalCharacter);
      a = new ur().evaluate(i);
    } catch {
      this._triggerEvent(u.events.invalidFormula, this.domElement, {
        formula: e,
        aNElement: this
      }), this.reformat(), this.formulaMode = !1;
      return;
    }
    this._triggerEvent(u.events.validFormula, this.domElement, {
      formula: e,
      result: a,
      aNElement: this
    }), this.set(a), this.formulaMode = !1;
  }
  /**
   * Returns `true` if the non-printable key is accepted in formula mode
   *
   * @returns {boolean}
   * @private
   */
  _acceptNonPrintableKeysInFormulaMode() {
    return this.eventKey === H.keyName.Backspace || this.eventKey === H.keyName.Delete || this.eventKey === H.keyName.LeftArrow || this.eventKey === H.keyName.RightArrow || this.eventKey === H.keyName.Home || this.eventKey === H.keyName.End;
  }
  /**
   * Handler for 'keydown' events.
   * The user just started pushing any key, hence one event is sent.
   *
   * Note :
   * By default a 'normal' input output those events in the right order when inputting a character key (i.e. 'a') :
   * - keydown
   * - keypress
   * - input
   * - keyup
   *
   * ...when inputting a modifier key (i.e. 'ctrl') :
   * - keydown
   * - keyup
   *
   * If 'delete' or 'backspace' are entered 'normally', the following events are sent :
   * - keydown
   * - input
   * - keyup
   *
   * If 'delete' or 'backspace' are entered continuously (with the key still pressed), the following events are sent :
   * - keydown
   * - input
   * [- keydown
   * - input] x times
   * - keyup
   *
   * If 'enter' is entered and the value has not changed, the following events are sent :
   * - keydown
   * - keypress
   * - keyup
   *
   * If 'enter' is entered and the value has been changed, the following events are sent :
   * - keydown
   * - keypress
   * - change
   * - keyup
   *
   * When a paste is done, the following events are sent :
   * - input (if paste is done with the mouse)
   *
   * - keydown (if paste is done with ctrl+v)
   * - keydown
   * - input
   * - keyup
   * - keyup
   *
   * @param {KeyboardEvent} e
   */
  _onKeydown(e) {
    if (this.formatted = !1, this.isEditing = !0, !this.formulaMode && !this.isFocused && this.settings.unformatOnHover && e.altKey && this.domElement === l.getHoveredElement()) {
      this.constructor._unformatAltHovered(this);
      return;
    }
    if (this._updateEventKeyInfo(e), this.keydownEventCounter += 1, this.keydownEventCounter === 1 && (this.initialValueOnFirstKeydown = l.getElementValue(e.target), this.initialRawValueOnFirstKeydown = this.rawValue), this.formulaMode) {
      if (this.eventKey === H.keyName.Esc) {
        this.formulaMode = !1, this.reformat();
        return;
      }
      if (this.eventKey === H.keyName.Enter) {
        this._exitFormulaMode();
        return;
      }
      if (this._acceptNonPrintableKeysInFormulaMode())
        return;
    } else {
      if (this.eventKey === H.keyName.Equal) {
        this._enterFormulaMode();
        return;
      }
      if (this.settings.modifyValueOnUpDownArrow && (this.eventKey === H.keyName.UpArrow || this.eventKey === H.keyName.DownArrow)) {
        this.upDownArrowAction(e);
        return;
      }
    }
    if (this.domElement.readOnly || this.settings.readOnly || this.domElement.disabled) {
      this.processed = !0;
      return;
    }
    this.eventKey === H.keyName.Esc && (e.preventDefault(), this.settings.isCancellable && this.rawValue !== this.savedCancellableValue && (this.set(this.savedCancellableValue), this._triggerEvent(u.events.native.input, e.target)), this.select());
    let a = l.getElementValue(e.target);
    if (this.eventKey === H.keyName.Enter && this.rawValue !== this.rawValueOnFocus && (this._triggerEvent(u.events.native.change, e.target), this.valueOnFocus = a, this.rawValueOnFocus = this.rawValue, this.settings.isCancellable && this._saveCancellableValue()), this._updateInternalProperties(e), this._processNonPrintableKeysAndShortcuts(e)) {
      this.processed = !0;
      return;
    }
    if (this.eventKey === H.keyName.Backspace || this.eventKey === H.keyName.Delete) {
      const i = this._processCharacterDeletion(e);
      if (this.processed = !0, !i) {
        e.preventDefault();
        return;
      }
      this._formatValue(e), a = l.getElementValue(e.target), a !== this.lastVal && this.throwInput && (this._triggerEvent(u.events.native.input, e.target), e.preventDefault()), this.lastVal = a, this.throwInput = !0;
    }
  }
  /**
   * Handler for 'keypress' events.
   * The user is still pressing the key, which will output a character (i.e. '2') continuously until he releases the key.
   * Note: 'keypress' events are not sent for delete keys like Backspace/Delete.
   *
   * @param {KeyboardEvent} e
   */
  _onKeypress(e) {
    if (this.formulaMode) {
      if (this._acceptNonPrintableKeysInFormulaMode() || this.settings.formulaChars.test(this.eventKey))
        return;
      e.preventDefault();
      return;
    }
    if (this.eventKey === H.keyName.Insert)
      return;
    const a = this.processed;
    if (this._updateInternalProperties(e), this._processNonPrintableKeysAndShortcuts(e))
      return;
    if (a) {
      e.preventDefault();
      return;
    }
    if (this._processCharacterInsertion()) {
      this._formatValue(e);
      const n = l.getElementValue(e.target);
      if (n !== this.lastVal && this.throwInput)
        this._triggerEvent(u.events.native.input, e.target), e.preventDefault();
      else {
        if ((this.eventKey === this.settings.decimalCharacter || this.eventKey === this.settings.decimalCharacterAlternative) && l.getElementSelection(e.target).start === l.getElementSelection(e.target).end && l.getElementSelection(e.target).start === n.indexOf(this.settings.decimalCharacter)) {
          const o = l.getElementSelection(e.target).start + 1;
          l.setElementSelection(e.target, o);
        }
        e.preventDefault();
      }
      this.lastVal = l.getElementValue(e.target), this.throwInput = !0, this._setValidOrInvalidState(this.rawValue);
      return;
    }
    e.preventDefault();
  }
  /**
   * Handler for 'keyup' events.
   * The user just released any key, hence one event is sent.
   *
   * @param {KeyboardEvent} e
   */
  _onKeyup(e) {
    if (this.isEditing = !1, this.keydownEventCounter = 0, this.formulaMode)
      return;
    if (this.settings.isCancellable && this.eventKey === H.keyName.Esc) {
      e.preventDefault();
      return;
    }
    if (this._updateEventKeyInfo(e), this.eventKey === H.keyName.Z || this.eventKey === H.keyName.z) {
      if (e.ctrlKey && e.shiftKey) {
        e.preventDefault(), this._historyTableRedo(), this._triggerEvent(u.events.native.input, e.target), this.onGoingRedo = !0;
        return;
      } else if (e.ctrlKey && !e.shiftKey)
        if (this.onGoingRedo)
          this.onGoingRedo = !1;
        else {
          e.preventDefault(), this._historyTableUndo(), this._triggerEvent(u.events.native.input, e.target);
          return;
        }
    } else if ((this.eventKey === H.keyName.Y || this.eventKey === H.keyName.y) && e.ctrlKey) {
      e.preventDefault(), this._historyTableRedo(), this._triggerEvent(u.events.native.input, e.target), this.onGoingRedo = !0;
      return;
    }
    if (this.onGoingRedo && (e.ctrlKey || e.shiftKey) && (this.onGoingRedo = !1), (e.ctrlKey || e.metaKey) && (this.eventKey === H.keyName.X || this.eventKey === H.keyName.x)) {
      const n = l.getElementSelection(this.domElement).start, o = this.constructor._toNumericValue(l.getElementValue(e.target), this.settings);
      this.set(o), this._setCaretPosition(n);
    }
    if (this.eventKey === H.keyName.Alt && this.settings.unformatOnHover && this.hoveredWithAlt) {
      this.constructor._reformatAltHovered(this);
      return;
    }
    if ((e.ctrlKey || e.metaKey) && (this.eventKey === H.keyName.Backspace || this.eventKey === H.keyName.Delete)) {
      const n = l.getElementValue(e.target);
      this._setRawValue(this._formatOrUnformatOther(!1, n));
      return;
    }
    this._updateInternalProperties(e);
    const a = this._processNonPrintableKeysAndShortcuts(e);
    delete this.valuePartsBeforePaste;
    const i = l.getElementValue(e.target);
    if (!(a || i === "" && this.initialValueOnFirstKeydown === "") && (i === this.settings.currencySymbol ? this.settings.currencySymbolPlacement === u.options.currencySymbolPlacement.suffix ? l.setElementSelection(e.target, 0) : l.setElementSelection(e.target, this.settings.currencySymbol.length) : this.eventKey === H.keyName.Tab && l.setElementSelection(e.target, 0, i.length), (i === this.settings.suffixText || this.rawValue === "" && this.settings.currencySymbol !== "" && this.settings.suffixText !== "") && l.setElementSelection(e.target, 0), this.settings.decimalPlacesShownOnFocus !== null && this._saveValueToPersistentStorage(), this.formatted || this._formatValue(e), this._setValidOrInvalidState(this.rawValue), this._saveRawValueForAndroid(), i !== this.initialValueOnFirstKeydown && this._triggerEvent(u.events.formatted, e.target, {
      oldValue: this.initialValueOnFirstKeydown,
      newValue: i,
      oldRawValue: this.initialRawValueOnFirstKeydown,
      newRawValue: this.rawValue,
      isPristine: this.isPristine(!1),
      error: null,
      aNElement: this
    }), this.historyTable.length > 1)) {
      const n = l.getElementSelection(this.domElement);
      this.selectionStart = n.start, this.selectionEnd = n.end, this.historyTable[this.historyTableIndex].start = this.selectionStart, this.historyTable[this.historyTableIndex].end = this.selectionEnd;
    }
  }
  /**
   * On Android Chrome, the `rawValue` is not updated when the user changes the input value.
   * This function updates the `rawValue` accordingly.
   * @private
   */
  _saveRawValueForAndroid() {
    if (this.eventKey === H.keyName.AndroidDefault) {
      let e = this.constructor._stripAllNonNumberCharactersExceptCustomDecimalChar(this.getFormatted(), this.settings, !0, this.isFocused);
      e = this.constructor._convertToNumericString(e, this.settings), this._setRawValue(e);
    }
  }
  /**
   * Handler for 'focusout' events
   * On focusout, multiple things happens :
   * - The element value is formatted back if the `Alt` key was pressed,
   * - The element value is formatted back if `showOnlyNumbersOnFocus` was set to only show numbers,
   * - The element value is multiplied by `rawValueDivisor` on `blur`
   *
   * Note: On focusout, the `rawValue` is never changed. Only the formatted value can be modified.
   *
   * @param {Event} e
   */
  _onFocusOutAndMouseLeave(e) {
    if (this.isEditing = !1, !(e.type === "mouseleave" && this.formulaMode)) {
      if (this.settings.unformatOnHover && e.type === "mouseleave" && this.hoveredWithAlt) {
        this.constructor._reformatAltHovered(this);
        return;
      }
      if (e.type === "mouseleave" && !this.isFocused || e.type === "blur") {
        e.type === "blur" && this.formulaMode && this._exitFormulaMode(), this._saveValueToPersistentStorage(), this.settings.showOnlyNumbersOnFocus === u.options.showOnlyNumbersOnFocus.onlyNumbers && (this.settings.digitGroupSeparator = this.originalDigitGroupSeparator, this.settings.currencySymbol = this.originalCurrencySymbol, this.settings.suffixText = this.originalSuffixText);
        const a = this._getRawValueToFormat(this.rawValue), i = l.isNull(a), [n, o] = this.constructor._checkIfInRangeWithOverrideOption(a, this.settings);
        let d = !1;
        if (a !== "" && !i && (this._triggerRangeEvents(n, o), this.settings.valuesToStrings && this._checkValuesToStrings(a) && (this._setElementValue(this.settings.valuesToStrings[a]), d = !0)), !d) {
          let s;
          if (i || a === "" ? s = a : s = String(a), a !== "" && !i)
            n && o && !this.constructor._isElementValueEmptyOrOnlyTheNegativeSign(a, this.settings) ? (s = this._modifyNegativeSignAndDecimalCharacterForRawValue(s), this.settings.divisorWhenUnfocused && !l.isNull(s) && (s = s / this.settings.divisorWhenUnfocused, s = s.toString()), s = this.constructor._roundFormattedValueShownOnBlur(s, this.settings), s = this.constructor._modifyNegativeSignAndDecimalCharacterForFormattedValue(s, this.settings)) : this._triggerRangeEvents(n, o);
          else if (a === "")
            switch (this.settings.emptyInputBehavior) {
              case u.options.emptyInputBehavior.zero:
                this._setRawValue("0"), s = this.constructor._roundValue("0", this.settings, 0);
                break;
              case u.options.emptyInputBehavior.min:
                this._setRawValue(this.settings.minimumValue), s = this.constructor._roundFormattedValueShownOnFocusOrBlur(this.settings.minimumValue, this.settings, this.isFocused);
                break;
              case u.options.emptyInputBehavior.max:
                this._setRawValue(this.settings.maximumValue), s = this.constructor._roundFormattedValueShownOnFocusOrBlur(this.settings.maximumValue, this.settings, this.isFocused);
                break;
              default:
                l.isNumber(this.settings.emptyInputBehavior) && (this._setRawValue(this.settings.emptyInputBehavior), s = this.constructor._roundFormattedValueShownOnFocusOrBlur(this.settings.emptyInputBehavior, this.settings, this.isFocused));
            }
          let c = this.constructor._orderValueCurrencySymbolAndSuffixText(s, this.settings, !1);
          this.constructor._isElementValueEmptyOrOnlyTheNegativeSign(s, this.settings) || i && this.settings.emptyInputBehavior === u.options.emptyInputBehavior.null || (c = this.constructor._addGroupSeparators(s, this.settings, !1, a)), (c !== a || a === "" || // This make sure we get rid on any currency symbol or suffix that might have been added on focus
          this.settings.allowDecimalPadding === u.options.allowDecimalPadding.never || this.settings.allowDecimalPadding === u.options.allowDecimalPadding.floats) && (this.settings.symbolWhenUnfocused && a !== "" && a !== null && (c = `${c}${this.settings.symbolWhenUnfocused}`), this._setElementValue(c));
        }
        this._setValidOrInvalidState(this.rawValue), e.type === "blur" && this._onBlur(e);
      }
    }
  }
  /**
   * Handler for 'paste' event
   *
   * @param {Event|ClipboardEvent} e
   */
  _onPaste(e) {
    if (e.preventDefault(), this.settings.readOnly || this.domElement.readOnly || this.domElement.disabled)
      return;
    let a;
    e.clipboardData && e.clipboardData.getData ? a = e.clipboardData.getData("text/plain") : l.throwError("Unable to retrieve the pasted value. Please use a modern browser (i.e. Firefox or Chromium).");
    let i;
    e.target.tagName ? i = e.target : i = e.explicitOriginalTarget;
    const n = l.getElementValue(i), o = i.selectionStart || 0, d = i.selectionEnd || 0, s = d - o;
    if (s === n.length) {
      const N = this._preparePastedText(a), Z = l.arabicToLatinNumbers(N, !1, !1, !1);
      if (Z === "." || Z === "" || Z !== "." && !l.isNumber(Z)) {
        this.formatted = !0, this.settings.onInvalidPaste === u.options.onInvalidPaste.error && l.throwError(`The pasted value '${a}' is not a valid paste content.`);
        return;
      }
      this.set(Z), this.formatted = !0, this._triggerEvent(u.events.native.input, i);
      return;
    }
    const c = l.isNegativeStrict(a, this.settings.negativeSignCharacter);
    c && (a = a.slice(1, a.length));
    const m = this._preparePastedText(a);
    let f;
    if (m === "." ? f = "." : f = l.arabicToLatinNumbers(m, !1, !1, !1), f !== "." && (!l.isNumber(f) || f === "")) {
      this.formatted = !0, this.settings.onInvalidPaste === u.options.onInvalidPaste.error && l.throwError(`The pasted value '${a}' is not a valid paste content.`);
      return;
    }
    let p, b = l.isNegativeStrict(this.getNumericString(), this.settings.negativeSignCharacter), y, v;
    c && !b ? (b = !0, y = !0) : y = !1;
    const g = n.slice(0, o), _ = n.slice(d, n.length);
    o !== d ? v = this._preparePastedText(g + _) : v = this._preparePastedText(n), b && (v = l.setRawNegativeSign(v)), p = l.convertCharacterCountToIndexPosition(l.countNumberCharactersOnTheCaretLeftSide(n, o, this.settings.decimalCharacter)), y && p++;
    let M = v.slice(0, p), S = v.slice(p, v.length), O = !1;
    f === "." && (l.contains(M, ".") && (O = !0, M = M.replace(".", "")), S = S.replace(".", ""));
    let I = !1;
    switch (M === "" && S === "-" && (M = "-", S = "", I = !0), this.settings.onInvalidPaste) {
      case u.options.onInvalidPaste.truncate:
      case u.options.onInvalidPaste.replace:
        const N = l.parseStr(this.settings.minimumValue), Z = l.parseStr(this.settings.maximumValue);
        let k = v, F = 0, U = M;
        for (; F < f.length && (U += f[F], v = U + S, !!this.constructor._checkIfInRange(v, N, Z)); )
          k = v, F++;
        if (p += F, I && p++, this.settings.onInvalidPaste === u.options.onInvalidPaste.truncate) {
          v = k, O && p--;
          break;
        }
        let C = p;
        const P = k.length;
        for (; F < f.length && C < P; ) {
          if (k[C] === ".") {
            C++;
            continue;
          }
          if (v = l.replaceCharAt(k, C, f[F]), !this.constructor._checkIfInRange(v, N, Z))
            break;
          k = v, F++, C++;
        }
        p = C, O && p--, v = k;
        break;
      case u.options.onInvalidPaste.error:
      case u.options.onInvalidPaste.ignore:
      case u.options.onInvalidPaste.clamp:
      default:
        if (v = `${M}${f}${S}`, o === d)
          p = l.convertCharacterCountToIndexPosition(l.countNumberCharactersOnTheCaretLeftSide(n, o, this.settings.decimalCharacter)) + f.length;
        else if (S === "")
          p = l.convertCharacterCountToIndexPosition(l.countNumberCharactersOnTheCaretLeftSide(n, o, this.settings.decimalCharacter)) + f.length, I && p++;
        else {
          const x = l.convertCharacterCountToIndexPosition(l.countNumberCharactersOnTheCaretLeftSide(n, d, this.settings.decimalCharacter)), w = l.getElementValue(i).slice(o, d);
          p = x - s + l.countCharInText(this.settings.digitGroupSeparator, w) + f.length;
        }
        y && p++, O && p--;
    }
    if (!l.isNumber(v) || v === "") {
      this.settings.onInvalidPaste === u.options.onInvalidPaste.error && l.throwError(`The pasted value '${a}' would result into an invalid content '${v}'.`);
      return;
    }
    let z = !1, $ = !1;
    try {
      this.set(v), z = !0;
    } catch {
      let Z;
      switch (this.settings.onInvalidPaste) {
        case u.options.onInvalidPaste.clamp:
          Z = l.clampToRangeLimits(v, this.settings);
          try {
            this.set(Z);
          } catch {
            l.throwError(`Fatal error: Unable to set the clamped value '${Z}'.`);
          }
          $ = !0, z = !0, v = Z;
          break;
        case u.options.onInvalidPaste.error:
        case u.options.onInvalidPaste.truncate:
        case u.options.onInvalidPaste.replace:
          l.throwError(`The pasted value '${a}' results in a value '${v}' that is outside of the minimum [${this.settings.minimumValue}] and maximum [${this.settings.maximumValue}] value range.`);
        case u.options.onInvalidPaste.ignore:
        default:
          return;
      }
    }
    const Q = l.getElementValue(i);
    let i0;
    if (z)
      switch (this.settings.onInvalidPaste) {
        case u.options.onInvalidPaste.clamp:
          if ($) {
            this.settings.currencySymbolPlacement === u.options.currencySymbolPlacement.suffix ? l.setElementSelection(i, Q.length - this.settings.currencySymbol.length) : l.setElementSelection(i, Q.length);
            break;
          }
        case u.options.onInvalidPaste.error:
        case u.options.onInvalidPaste.ignore:
        case u.options.onInvalidPaste.truncate:
        case u.options.onInvalidPaste.replace:
        default:
          i0 = l.findCaretPositionInFormattedNumber(v, p, Q, this.settings.decimalCharacter), l.setElementSelection(i, i0);
      }
    z && n !== Q && this._triggerEvent(u.events.native.input, i);
  }
  /**
   * When focusing out of the input, we check if the value has changed, and if it has, then we send a `change` event (since the native one would have been prevented by `e.preventDefault()` called in the other event listeners).
   * We also update the info of the focused state in the `this.isFocused` variable.
   *
   * @param {Event} e
   */
  _onBlur(e) {
    this.isFocused = !1, this.isEditing = !1, l.trimPaddedZerosFromDecimalPlaces(this.rawValue) !== l.trimPaddedZerosFromDecimalPlaces(this.rawValueOnFocus) && this._triggerEvent(u.events.native.change, e.target), this.rawValueOnFocus = void 0;
  }
  /**
   * Helper function that DRY the similar behaviors of the mousewheel and up/down arrow keys, which increment/decrement the element value, either by a fixed value, or using the 'progressive' heuristic
   *
   * @param {WheelEvent|KeyboardEvent} e The `wheel` or keyboard event
   * @param {boolean} isUp Defines if the event should increment the value
   * @param {boolean} isDown Defines if the event should decrement the value
   * @param {string|number} step The step to be applied to the increment/decrement action
   * @private
   */
  _wheelAndUpDownActions(e, a, i, n) {
    const o = e.target.selectionStart || 0, d = e.target.selectionEnd || 0, s = this.rawValue;
    let c;
    if (l.isUndefinedOrNullOrEmpty(s) ? this.settings.minimumValue > 0 || this.settings.maximumValue < 0 ? a ? c = this.settings.minimumValue : c = this.settings.maximumValue : c = 0 : c = s, c = +c, l.isNumber(n)) {
      const m = +n;
      a ? c += m : i && (c -= m);
    } else
      a ? c = l.addAndRoundToNearestAuto(c, this.settings.decimalPlacesRawValue) : i && (c = l.subtractAndRoundToNearestAuto(c, this.settings.decimalPlacesRawValue));
    c = l.clampToRangeLimits(c, this.settings), c !== +s && (this.set(c), this._triggerEvent(u.events.native.input, e.target)), e.preventDefault(), this._setSelection(o, d);
  }
  /**
   * Handler for up and down arrow keys
   * Increment or decrement the element value according to the `upDownStep` option chosen
   *
   * @param {KeyboardEvent} e
   */
  upDownArrowAction(e) {
    if (this.formulaMode || this.settings.readOnly || this.domElement.readOnly || this.domElement.disabled)
      return;
    let a = !1, i = !1;
    this.eventKey === H.keyName.UpArrow ? a = !0 : this.eventKey === H.keyName.DownArrow ? i = !0 : l.throwError("Something has gone wrong since neither an Up or Down arrow key is detected, but the function was still called!"), this._wheelAndUpDownActions(e, a, i, this.settings.upDownStep);
  }
  /**
   * Handler for 'wheel' event
   *
   * @param {WheelEvent} e
   */
  _onWheel(e) {
    this.formulaMode || this.settings.readOnly || this.domElement.readOnly || this.domElement.disabled || this.settings.modifyValueOnWheel && (this.settings.wheelOn === u.options.wheelOn.focus ? this.isFocused ? e.shiftKey || this.wheelAction(e) : e.shiftKey && this.wheelAction(e) : this.settings.wheelOn === u.options.wheelOn.hover ? e.shiftKey ? (e.preventDefault(), window.scrollBy(0, l.isNegativeStrict(String(e.deltaY)) ? -50 : 50)) : this.wheelAction(e) : l.throwError("Unknown `wheelOn` option."));
  }
  /**
   * Increment or decrement the element value according to the `wheelStep` option chosen
   *
   * @param {WheelEvent} e The `wheel` event
   */
  wheelAction(e) {
    this.isWheelEvent = !0;
    let a = !1, i = !1, n = !1;
    l.isWheelUpEvent(e) ? a = !0 : l.isWheelDownEvent(e) ? i = !0 : l.isWheelEventWithZeroDeltaY(e) ? n = !0 : l.throwError("The event is not a 'wheel' event."), n || this._wheelAndUpDownActions(e, a, i, this.settings.wheelStep), this.isWheelEvent = !1;
  }
  /**
   * Handler for 'drop' event
   *
   * @param {DragEvent} e
   */
  _onDrop(e) {
    if (this.formulaMode)
      return;
    this.isDropEvent = !0, e.preventDefault();
    const a = e.dataTransfer.getData("text/plain"), i = this.unformatOther(a), n = this.rawValue;
    this.set(i), this.isDropEvent = !1;
    const o = this.constructor._toNumericValue(i, this.settings);
    isNaN(Number(o)) || l.trimPaddedZerosFromDecimalPlaces(n) !== l.trimPaddedZerosFromDecimalPlaces(o) && this._triggerEvent(u.events.native.change, this.domElement);
  }
  /**
   * Handler for 'submit' events happening on the parent <form> element.
   * If `unformatOnSubmit` is set to `true`, the element value is first unformatted before the form is submitted.
   *
   * @returns {boolean}
   */
  _onFormSubmit() {
    return this._getFormAutoNumericChildren(this.parentForm).map((i) => this.constructor.getAutoNumericElement(i)).forEach((i) => i._unformatOnSubmit()), !0;
  }
  /**
   * Handler for 'reset' events caught on the parent <form> element.
   * When such event is detected, then every child AutoNumeric elements must format their default value that the browser is forcing upon them.
   *
   * @private
   */
  _onFormReset() {
    this._getFormAutoNumericChildren(this.parentForm).map((i) => this.constructor.getAutoNumericElement(i)).forEach((i) => {
      const n = this._getDefaultValue(i.node());
      setTimeout(() => i.set(n), 0);
    });
  }
  /**
   * Unformat the element value according to the `unformatOnSubmit` option
   *
   * @private
   */
  _unformatOnSubmit() {
    this.settings.unformatOnSubmit && this._setElementValue(this.rawValue);
  }
  /**
   * Listen for the `alt` key keydown event globally, and if the event is caught, unformat the AutoNumeric element that is hovered by the mouse.
   *
   * @param {KeyboardEvent} e
   * @private
   */
  _onKeydownGlobal(e) {
    if (l.character(e) === H.keyName.Alt) {
      const a = l.getHoveredElement();
      if (u.isManagedByAutoNumeric(a)) {
        const i = u.getAutoNumericElement(a);
        !i.formulaMode && i.settings.unformatOnHover && this.constructor._unformatAltHovered(i);
      }
    }
  }
  /**
   * Listen for the `alt` key keyup event globally, and if the event is caught, reformat the AutoNumeric element that is hovered by the mouse.
   *
   * @param {KeyboardEvent} e
   * @private
   */
  _onKeyupGlobal(e) {
    if (l.character(e) === H.keyName.Alt) {
      const a = l.getHoveredElement();
      if (u.isManagedByAutoNumeric(a)) {
        const i = u.getAutoNumericElement(a);
        if (i.formulaMode || !i.settings.unformatOnHover)
          return;
        this.constructor._reformatAltHovered(i);
      }
    }
  }
  /**
   * Return `true` if the DOM element is supported by autoNumeric.
   * A supported element is an element whitelisted in the `allowedTagList`.
   *
   * @returns {boolean}
   * @private
   */
  _isElementTagSupported() {
    return l.isElement(this.domElement) || l.throwError(`The DOM element is not valid, ${this.domElement} given.`), l.isInArray(this.domElement.tagName.toLowerCase(), this.allowedTagList);
  }
  /**
   * Return `true` in the DOM element is an <input>.
   *
   * @returns {boolean}
   * @private
   */
  _isInputElement() {
    return this.domElement.tagName.toLowerCase() === "input";
  }
  /**
   * Return `true` if the input type is supported by AutoNumeric
   *
   * @returns {boolean}
   * @throws
   */
  _isInputTypeSupported() {
    return this.domElement.type === "text" || this.domElement.type === "hidden" || this.domElement.type === "tel" || l.isUndefinedOrNullOrEmpty(this.domElement.type);
  }
  /**
   * Check if the DOM element is supported by autoNumeric.
   * A supported element is either an <input> element with the correct 'type' attribute, or a tag whitelisted in the `allowedTagList` array.
   * If the check fails, this method throws.
   * This function also sets the info `this.isInputElement` which keep tracks if the DOM element is an <input> or not, and the `this.isContentEditable` if the element has the `contenteditable` attribute set to `true` initially.
   *
   * @throws
   * @private
   */
  _checkElement() {
    const e = this.domElement.tagName.toLowerCase();
    this._isElementTagSupported() || l.throwError(`The <${e}> tag is not supported by autoNumeric`), this._isInputElement() ? (this._isInputTypeSupported() || l.throwError(`The input type "${this.domElement.type}" is not supported by autoNumeric`), this.isInputElement = !0) : (this.isInputElement = !1, this.isContentEditable = this._isContentEditable(this.domElement));
  }
  /**
   * Returns `true` if the given DOM element is a contenteditable one (set to `true`)
   *
   * @param {HTMLElement} domElement
   * @returns {boolean}
   */
  _isContentEditable(e) {
    return e.hasAttribute("contenteditable") && e.getAttribute("contenteditable") === "true";
  }
  /**
   * Formats the default value on page load.
   * This is called only if the `formatOnPageLoad` option is set to `true`.
   *
   * @param {number|string|null} forcedInitialValue The value that should be used for initialization, in place on the eventual html one
   */
  _formatDefaultValueOnPageLoad(e = null) {
    let a = !0, i;
    if (l.isNull(e) ? (i = l.getElementValue(this.domElement).trim(), this.domElement.setAttribute("value", i)) : i = e, this.isInputElement || this.isContentEditable) {
      const n = this.constructor._toNumericValue(i, this.settings);
      if (!this.domElement.hasAttribute("value") || this.domElement.getAttribute("value") === "")
        !isNaN(Number(n)) && n !== 1 / 0 ? (this.set(n), a = !1) : l.throwError(`The value [${i}] used in the input is not a valid value autoNumeric can work with.`);
      else if (this.settings.defaultValueOverride !== null && this.settings.defaultValueOverride.toString() !== i || this.settings.defaultValueOverride === null && i !== "" && i !== this.domElement.getAttribute("value") || i !== "" && this.domElement.getAttribute("type") === "hidden" && !l.isNumber(n)) {
        if (this.settings.saveValueToSessionStorage && (this.settings.decimalPlacesShownOnFocus !== null || this.settings.divisorWhenUnfocused) && this._setRawValue(this._getValueFromPersistentStorage()), !this.settings.saveValueToSessionStorage) {
          const o = this.constructor._removeBrackets(i, this.settings);
          (this.settings.negativePositiveSignPlacement === u.options.negativePositiveSignPlacement.suffix || this.settings.negativePositiveSignPlacement !== u.options.negativePositiveSignPlacement.prefix && this.settings.currencySymbolPlacement === u.options.currencySymbolPlacement.suffix) && this.settings.negativeSignCharacter !== "" && l.isNegative(i, this.settings.negativeSignCharacter) ? this._setRawValue(`-${this.constructor._stripAllNonNumberCharacters(o, this.settings, !0, this.isFocused)}`) : this._setRawValue(this.constructor._stripAllNonNumberCharacters(o, this.settings, !0, this.isFocused));
        }
        a = !1;
      }
      if (i === "")
        switch (this.settings.emptyInputBehavior) {
          case u.options.emptyInputBehavior.focus:
          case u.options.emptyInputBehavior.press:
            break;
          case u.options.emptyInputBehavior.always:
            this._setElementValue(this.settings.currencySymbol);
            break;
          case u.options.emptyInputBehavior.min:
            this.set(this.settings.minimumValue);
            break;
          case u.options.emptyInputBehavior.max:
            this.set(this.settings.maximumValue);
            break;
          case u.options.emptyInputBehavior.zero:
            this.set("0");
            break;
          case u.options.emptyInputBehavior.null:
            this.set(null);
            break;
          default:
            this.set(this.settings.emptyInputBehavior);
        }
      else a && i === this.domElement.getAttribute("value") && this.set(i);
    } else (this.settings.defaultValueOverride === null || this.settings.defaultValueOverride === i) && this.set(i);
  }
  /**
   * Enhance the user experience by modifying the default `negativePositiveSignPlacement` option depending on `currencySymbol` and `currencySymbolPlacement`.
   *
   * If the user has not set the placement of the negative sign (`negativePositiveSignPlacement`), but has set a currency symbol (`currencySymbol`),
   * then we modify the default value of `negativePositiveSignPlacement` in order to keep the resulting output logical by default :
   * - "$-1,234.56" instead of "-$1,234.56" ({currencySymbol: "$", negativePositiveSignPlacement: "r"})
   * - "-1,234.56$" instead of "1,234.56-$" ({currencySymbol: "$", currencySymbolPlacement: "s", negativePositiveSignPlacement: "p"})
   *
   * @param {object} settings
   */
  static _correctNegativePositiveSignPlacementOption(e) {
    if (l.isNull(e.negativePositiveSignPlacement))
      if (!l.isUndefined(e) && l.isUndefinedOrNullOrEmpty(e.negativePositiveSignPlacement) && !l.isUndefinedOrNullOrEmpty(e.currencySymbol))
        switch (e.currencySymbolPlacement) {
          case u.options.currencySymbolPlacement.suffix:
            e.negativePositiveSignPlacement = u.options.negativePositiveSignPlacement.prefix;
            break;
          case u.options.currencySymbolPlacement.prefix:
            e.negativePositiveSignPlacement = u.options.negativePositiveSignPlacement.left;
            break;
        }
      else
        e.negativePositiveSignPlacement = u.options.negativePositiveSignPlacement.left;
  }
  /**
   * Correct the `caretPositionOnFocus` and `selectOnFocus` options, since setting both leads to a conflict.
   * This method directly modifies the `options` object passed as a parameter, then returns it.
   * It returns `null` if the given option is `null`.
   *
   * @param {object} options The options passed as an argument by the user
   * @returns {object|null}
   * @private
   */
  static _correctCaretPositionOnFocusAndSelectOnFocusOptions(e) {
    return l.isNull(e) ? null : (!l.isUndefinedOrNullOrEmpty(e.caretPositionOnFocus) && l.isUndefinedOrNullOrEmpty(e.selectOnFocus) && (e.selectOnFocus = u.options.selectOnFocus.doNotSelect), l.isUndefinedOrNullOrEmpty(e.caretPositionOnFocus) && !l.isUndefinedOrNullOrEmpty(e.selectOnFocus) && e.selectOnFocus === u.options.selectOnFocus.select && (e.caretPositionOnFocus = u.options.caretPositionOnFocus.doNoForceCaretPosition), e);
  }
  /**
   * Calculate the number de decimal places to be used by the AutoNumeric object, for each of its state, and for its formatted and raw value.
   * By default, the `rawValue` precision is the same as the formatted value one.
   *
   * This method is called during the AutoNumeric object initialization. This assumes some internal variable state.
   *
   * This method set the following options accordingly to their own value and the mandatory `decimalPlaces` option:
   * - decimalPlacesRawValue     (nullable)
   * - decimalPlacesShownOnBlur  (nullable)
   * - decimalPlacesShownOnFocus (nullable)
   *
   * Note: the `decimalPlaces` option is only used here and only serve to define those three previous options value.
   * AutoNumeric will then *only* use `decimalPlacesRawValue`, `decimalPlacesShownOnBlur` and `decimalPlacesShownOnFocus` from there.
   *
   * This method directly modifies the `settings` object passed as a parameter.
   *
   * @param {object} settings This is an object with the new settings to use.
   * @private
   */
  static _calculateDecimalPlacesOnInit(e) {
    this._validateDecimalPlacesRawValue(e), e.decimalPlacesShownOnFocus === u.options.decimalPlacesShownOnFocus.useDefault && (e.decimalPlacesShownOnFocus = e.decimalPlaces), e.decimalPlacesShownOnBlur === u.options.decimalPlacesShownOnBlur.useDefault && (e.decimalPlacesShownOnBlur = e.decimalPlaces), e.decimalPlacesRawValue === u.options.decimalPlacesRawValue.useDefault && (e.decimalPlacesRawValue = e.decimalPlaces);
    let a = 0;
    e.rawValueDivisor && e.rawValueDivisor !== u.options.rawValueDivisor.none && (a = String(e.rawValueDivisor).length - 1, a < 0 && (a = 0)), e.decimalPlacesRawValue = Math.max(
      Math.max(e.decimalPlacesShownOnBlur, e.decimalPlacesShownOnFocus) + a,
      Number(e.originalDecimalPlacesRawValue) + a
    );
  }
  /**
   * Recalculate the number de decimal places to be used by the AutoNumeric object, for each of its state, and for its formatted and raw value.
   * By default, the `rawValue` precision is the same as the formatted value one.
   *
   * This method is close to the one called during initialization, `_calculateDecimalPlacesOnInit()`, but with slight difference so that the `decimalPlaces*` options are correctly updated as needed.
   *
   * This methods set the following options accordingly to their own value and the mandatory `decimalPlaces` option:
   * - decimalPlacesRawValue     (nullable)
   * - decimalPlacesShownOnBlur  (nullable)
   * - decimalPlacesShownOnFocus (nullable)
   *
   * Note: the `decimalPlaces` option is only used here and only serve to define those three previous options value.
   * AutoNumeric will then *only* use `decimalPlacesRawValue`, `decimalPlacesShownOnBlur` and `decimalPlacesShownOnFocus` from there.
   *
   * This methods directly modifies the `settings` object passed as a parameter.
   *
   * @param {object} settings This is an object with the new settings to use.
   * @param {object} currentSettings This is the current settings (`this.settings`) used by the element.
   * @private
   */
  static _calculateDecimalPlacesOnUpdate(e, a = null) {
    this._validateDecimalPlacesRawValue(e), l.isNull(a) && l.throwError("When updating the settings, the previous ones should be passed as an argument.");
    const i = "decimalPlaces" in e;
    if (!(i || "decimalPlacesRawValue" in e || "decimalPlacesShownOnFocus" in e || "decimalPlacesShownOnBlur" in e || "rawValueDivisor" in e))
      return;
    i ? ((!("decimalPlacesShownOnFocus" in e) || e.decimalPlacesShownOnFocus === u.options.decimalPlacesShownOnFocus.useDefault) && (e.decimalPlacesShownOnFocus = e.decimalPlaces), (!("decimalPlacesShownOnBlur" in e) || e.decimalPlacesShownOnBlur === u.options.decimalPlacesShownOnBlur.useDefault) && (e.decimalPlacesShownOnBlur = e.decimalPlaces), (!("decimalPlacesRawValue" in e) || e.decimalPlacesRawValue === u.options.decimalPlacesRawValue.useDefault) && (e.decimalPlacesRawValue = e.decimalPlaces)) : (l.isUndefined(e.decimalPlacesShownOnFocus) && (e.decimalPlacesShownOnFocus = a.decimalPlacesShownOnFocus), l.isUndefined(e.decimalPlacesShownOnBlur) && (e.decimalPlacesShownOnBlur = a.decimalPlacesShownOnBlur));
    let n = 0;
    e.rawValueDivisor && e.rawValueDivisor !== u.options.rawValueDivisor.none && (n = String(e.rawValueDivisor).length - 1, n < 0 && (n = 0)), !e.decimalPlaces && !e.decimalPlacesRawValue ? e.decimalPlacesRawValue = Math.max(
      Math.max(e.decimalPlacesShownOnBlur, e.decimalPlacesShownOnFocus) + n,
      Number(a.originalDecimalPlacesRawValue) + n
    ) : e.decimalPlacesRawValue = Math.max(
      Math.max(e.decimalPlacesShownOnBlur, e.decimalPlacesShownOnFocus) + n,
      Number(e.decimalPlacesRawValue) + n
    );
  }
  /**
   * Analyze and save the minimumValue and maximumValue integer size for later uses
   * @private
   */
  _calculateVMinAndVMaxIntegerSizes() {
    let [e] = this.settings.maximumValue.toString().split("."), [a] = !this.settings.minimumValue && this.settings.minimumValue !== 0 ? [] : this.settings.minimumValue.toString().split(".");
    e = e.replace(this.settings.negativeSignCharacter, ""), a = a.replace(this.settings.negativeSignCharacter, ""), this.settings.mIntPos = Math.max(e.length, 1), this.settings.mIntNeg = Math.max(a.length, 1);
  }
  /**
   * Calculate once what are the `valuesToStrings` option keys.
   * @private
   */
  _calculateValuesToStringsKeys() {
    this.settings.valuesToStrings ? this.valuesToStringsKeys = Object.keys(this.settings.valuesToStrings) : this.valuesToStringsKeys = [];
  }
  /**
   * Caches regular expressions for _stripAllNonNumberCharactersExceptCustomDecimalChar
   *
   * @param {object} settings
   * @param {object} regex
   */
  static _cachesUsualRegularExpressions(e, a) {
    let i;
    e.negativeSignCharacter !== u.options.negativeSignCharacter.hyphen ? i = `([-\\${e.negativeSignCharacter}]?)` : i = "(-?)", a.aNegRegAutoStrip = i, e.allowedAutoStrip = new RegExp(`[^-0123456789\\${e.decimalCharacter}]`, "g"), e.numRegAutoStrip = new RegExp(`${i}(?:\\${e.decimalCharacter}?([0-9]+\\${e.decimalCharacter}[0-9]+)|([0-9]*(?:\\${e.decimalCharacter}[0-9]*)?))`), e.stripReg = new RegExp(`^${a.aNegRegAutoStrip}0*([0-9])`), e.formulaChars = new RegExp(`[0-9${e.decimalCharacter}+\\-*/() ]`);
  }
  /**
   * Modify the user settings to make them 'exploitable' later.
   */
  _transformOptionsValuesToDefaultTypes() {
    for (const e in this.settings)
      if (Object.prototype.hasOwnProperty.call(this.settings, e)) {
        const a = this.settings[e];
        (a === "true" || a === "false") && (this.settings[e] = a === "true"), typeof a == "number" && (this.settings[e] = a.toString());
      }
  }
  /**
   * Convert the old settings options name to new ones.
   *
   * @param {object} options
   */
  static _convertOldOptionsToNewOnes(e) {
    const a = {
      // Old option names, with their corresponding new names
      aSep: "digitGroupSeparator",
      nSep: "showOnlyNumbersOnFocus",
      dGroup: "digitalGroupSpacing",
      aDec: "decimalCharacter",
      altDec: "decimalCharacterAlternative",
      aSign: "currencySymbol",
      pSign: "currencySymbolPlacement",
      pNeg: "negativePositiveSignPlacement",
      aSuffix: "suffixText",
      oLimits: "overrideMinMaxLimits",
      vMax: "maximumValue",
      vMin: "minimumValue",
      mDec: "decimalPlacesOverride",
      eDec: "decimalPlacesShownOnFocus",
      scaleDecimal: "decimalPlacesShownOnBlur",
      aStor: "saveValueToSessionStorage",
      mRound: "roundingMethod",
      aPad: "allowDecimalPadding",
      nBracket: "negativeBracketsTypeOnBlur",
      wEmpty: "emptyInputBehavior",
      lZero: "leadingZero",
      aForm: "formatOnPageLoad",
      sNumber: "selectNumberOnly",
      anDefault: "defaultValueOverride",
      unSetOnSubmit: "unformatOnSubmit",
      outputType: "outputFormat",
      debug: "showWarnings",
      // Current options :
      allowDecimalPadding: !0,
      alwaysAllowDecimalCharacter: !0,
      caretPositionOnFocus: !0,
      createLocalList: !0,
      currencySymbol: !0,
      currencySymbolPlacement: !0,
      decimalCharacter: !0,
      decimalCharacterAlternative: !0,
      decimalPlaces: !0,
      decimalPlacesRawValue: !0,
      decimalPlacesShownOnBlur: !0,
      decimalPlacesShownOnFocus: !0,
      defaultValueOverride: !0,
      digitalGroupSpacing: !0,
      digitGroupSeparator: !0,
      divisorWhenUnfocused: !0,
      emptyInputBehavior: !0,
      eventBubbles: !0,
      eventIsCancelable: !0,
      failOnUnknownOption: !0,
      formatOnPageLoad: !0,
      formulaMode: !0,
      historySize: !0,
      isCancellable: !0,
      leadingZero: !0,
      maximumValue: !0,
      minimumValue: !0,
      modifyValueOnUpDownArrow: !0,
      modifyValueOnWheel: !0,
      negativeBracketsTypeOnBlur: !0,
      negativePositiveSignPlacement: !0,
      negativeSignCharacter: !0,
      negativePositiveSignBehavior: !0,
      noEventListeners: !0,
      onInvalidPaste: !0,
      outputFormat: !0,
      overrideMinMaxLimits: !0,
      positiveSignCharacter: !0,
      rawValueDivisor: !0,
      readOnly: !0,
      roundingMethod: !0,
      saveValueToSessionStorage: !0,
      selectNumberOnly: !0,
      selectOnFocus: !0,
      serializeSpaces: !0,
      showOnlyNumbersOnFocus: !0,
      showPositiveSign: !0,
      showWarnings: !0,
      styleRules: !0,
      suffixText: !0,
      symbolWhenUnfocused: !0,
      upDownStep: !0,
      unformatOnHover: !0,
      unformatOnSubmit: !0,
      valuesToStrings: !0,
      watchExternalChanges: !0,
      wheelOn: !0,
      wheelStep: !0,
      // Additional information that are added to the `settings` object :
      //TODO Find a way to exclude those internal data from the settings object (ideally by using another object, or better yet, class attributes) -->
      allowedAutoStrip: !0,
      formulaChars: !0,
      isNegativeSignAllowed: !0,
      isPositiveSignAllowed: !0,
      mIntNeg: !0,
      mIntPos: !0,
      numRegAutoStrip: !0,
      originalDecimalPlaces: !0,
      originalDecimalPlacesRawValue: !0,
      stripReg: !0
    };
    for (const i in e)
      if (Object.prototype.hasOwnProperty.call(e, i)) {
        if (a[i] === !0)
          continue;
        Object.prototype.hasOwnProperty.call(a, i) ? (l.warning(`You are using the deprecated option name '${i}'. Please use '${a[i]}' instead from now on. The old option name will be dropped very soon™.`, !0), e[a[i]] = e[i], delete e[i]) : e.failOnUnknownOption && l.throwError(`Option name '${i}' is unknown. Please fix the options passed to autoNumeric`);
      }
    "mDec" in e && l.warning("The old `mDec` option has been deprecated in favor of more accurate options ; `decimalPlaces`, `decimalPlacesRawValue`, `decimalPlacesShownOnFocus` and `decimalPlacesShownOnBlur`.", !0);
  }
  /**
   * Analyse the settings/options passed by the user, validate and clean them, then set them into `this.settings`.
   * Note: This sets the settings to `null` if somehow the settings objet is undefined or empty
   *       If only `decimalPlaces` is defined in the option, overwrite the other decimalPlaces* options, otherwise, use those options
   *
   * @param {object} options
   * @param {boolean} update - If set to `true`, then the settings already exists and this function only updates them instead of recreating them from scratch
   * @throws
   */
  _setSettings(e, a = !1) {
    (a || !l.isNull(e)) && this.constructor._convertOldOptionsToNewOnes(e), a ? ("decimalPlacesRawValue" in e && (this.settings.originalDecimalPlacesRawValue = e.decimalPlacesRawValue), "decimalPlaces" in e && (this.settings.originalDecimalPlaces = e.decimalPlaces), this.constructor._calculateDecimalPlacesOnUpdate(e, this.settings), this._mergeSettings(e)) : (this.settings = {}, this._mergeSettings(this.constructor.getDefaultConfig(), this.domElement.dataset, e, { rawValue: this.defaultRawValue }), this.caretFix = !1, this.throwInput = !0, this.allowedTagList = H.allowedTagList, this.runOnce = !1, this.hoveredWithAlt = !1), this._transformOptionsValuesToDefaultTypes(), this._runCallbacksFoundInTheSettingsObject(), this.constructor._correctNegativePositiveSignPlacementOption(this.settings), this.constructor._correctCaretPositionOnFocusAndSelectOnFocusOptions(this.settings), this.constructor._setNegativePositiveSignPermissions(this.settings), a || (l.isNull(e) || !e.decimalPlaces ? this.settings.originalDecimalPlaces = null : this.settings.originalDecimalPlaces = e.decimalPlaces, this.settings.originalDecimalPlacesRawValue = this.settings.decimalPlacesRawValue, this.constructor._calculateDecimalPlacesOnInit(this.settings)), this._calculateVMinAndVMaxIntegerSizes(), this._setTrailingNegativeSignInfo(), this.regex = {}, this.constructor._cachesUsualRegularExpressions(this.settings, this.regex), this.constructor._setBrackets(this.settings), this._calculateValuesToStringsKeys(), l.isEmptyObj(this.settings) && l.throwError("Unable to set the settings, those are invalid ; an empty object was given."), this.constructor.validate(this.settings, !1, e), this._keepAnOriginalSettingsCopy();
  }
  /**
   * Define if the negative or positive signs are allowed, and update the given settings object directly.
   *
   * @param {object} settings
   * @private
   */
  static _setNegativePositiveSignPermissions(e) {
    e.isNegativeSignAllowed = e.minimumValue < 0, e.isPositiveSignAllowed = e.maximumValue >= 0;
  }
  /**
   * Convert the `value` parameter that can either be :
   * - a real number,
   * - a number represented in the scientific notation (i.e. -123.4567e-6)
   * - a string representing a real number, or
   * - a string representing a localized number (with specific group separators and decimal character),
   * ...to a string representing a real 'javascript' number (i.e. '1234' or '1234.567').
   *
   * This function returns `NaN` if such conversion fails.
   *
   * @param {int|float|string} value
   * @param {object} settings
   * @returns {string|NaN}
   */
  static _toNumericValue(e, a) {
    let i;
    return l.isNumber(Number(e)) ? (l.isNumberStrict(e) || (e = String(e).trim()), i = l.scientificToDecimal(e)) : (i = this._convertToNumericString(e.toString(), a), l.isNumber(Number(i)) || (l.warning(`The given value "${e}" cannot be converted to a numeric one and therefore cannot be used appropriately.`, a.showWarnings), i = NaN)), i;
  }
  /**
   * Return the pasted text that will be used, by stripping most non-numeric characters
   *
   * @param {string} text
   * @returns {string}
   */
  _preparePastedText(e) {
    return this.constructor._stripAllNonNumberCharacters(e, this.settings, !0, this.isFocused);
  }
  /**
   * Return TRUE if the given value (a number as a string) is within the range set in the settings `minimumValue` and `maximumValue`, FALSE otherwise.
   *
   * @param {string} value
   * @param {object} parsedMinValue Parsed via the `parseStr()` function
   * @param {object} parsedMaxValue Parsed via the `parseStr()` function
   * @returns {boolean}
   */
  static _checkIfInRange(e, a, i) {
    const n = l.parseStr(e);
    return l.testMinMax(a, n) > -1 && l.testMinMax(i, n) < 1;
  }
  /**
   * Update the selection values as well as resets the internal state of the current AutoNumeric object.
   * This keeps tracks of the current selection and resets the 'processed' state.
   *
   * Note : This state can change between the keydown, keypress and keyup events, that's why
   *        this function is called on each event handler.
   *
   * @private
   */
  _updateInternalProperties() {
    this.selection = l.getElementSelection(this.domElement), this.processed = !1;
  }
  /**
   * Update the `event.key` attribute that triggered the given event.
   *
   * `event.key` describes:
   * - the key name (if a non-printable character),
   * - or directly the character that result from the key press used to trigger the event.
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key
   * The key list is described here:
   * @link https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values
   *
   * @param {Event|KeyboardEvent} e
   * @private
   */
  _updateEventKeyInfo(e) {
    this.eventKey = l.character(e);
  }
  /**
   * Save the unformatted element value.
   * This is used in the 'cancellable' feature where the element value is saved on focus and input validation, to be used if the user wants to cancel his modifications by hitting the 'Escape' key.
   *
   * @private
   */
  _saveCancellableValue() {
    this.savedCancellableValue = this.rawValue;
  }
  /**
   * Set the text selection inside the input with the given start and end position.
   *
   * @param {int} start
   * @param {int} end
   * @private
   */
  _setSelection(e, a) {
    e = Math.max(e, 0), a = Math.min(a, l.getElementValue(this.domElement).length), this.selection = {
      start: e,
      end: a,
      length: a - e
    }, l.setElementSelection(this.domElement, e, a);
  }
  /**
   * Set the caret position inside the input at the given position.
   *
   * @param {int} position
   * @private
   */
  _setCaretPosition(e) {
    this._setSelection(e, e);
  }
  /**
   * Return an array containing the string parts located on the left and right side of the caret or selection.
   * Those parts are left 'untouched', i.e. formatted by autoNumeric.
   *
   * @returns {[string, string]} The parts on the left and right of the caret or selection
   * @private
   */
  _getLeftAndRightPartAroundTheSelection() {
    const e = l.getElementValue(this.domElement), a = e.substring(0, this.selection.start), i = e.substring(this.selection.end, e.length);
    return [a, i];
  }
  /**
   * Return an array containing the string parts located on the left and right side of the caret or selection.
   * Those parts are unformatted (stripped) of any non-numbers characters, and any trailing negative character is put back on the left hand side of the number.
   *
   * @returns {[string, string]} The parts on the left and right of the caret or selection, unformatted.
   * @private
   */
  _getUnformattedLeftAndRightPartAroundTheSelection() {
    let [e, a] = this._getLeftAndRightPartAroundTheSelection();
    if (e === "" && a === "")
      return ["", ""];
    let i = !0;
    return (this.eventKey === H.keyName.Hyphen || this.eventKey === H.keyName.Minus) && Number(e) === 0 && (i = !1), this.isTrailingNegative && (l.isNegative(a, this.settings.negativeSignCharacter) && // The caret is placed on the left of the negative sign
    !l.isNegative(e, this.settings.negativeSignCharacter) || a === "" && // ...or the caret is placed on the far right of the input (Fix issue #481)
    l.isNegative(e, this.settings.negativeSignCharacter, !0)) && (e = e.replace(this.settings.negativeSignCharacter, ""), a = a.replace(this.settings.negativeSignCharacter, ""), e = e.replace("-", ""), a = a.replace("-", ""), e = `-${e}`), e = u._stripAllNonNumberCharactersExceptCustomDecimalChar(e, this.settings, i, this.isFocused), a = u._stripAllNonNumberCharactersExceptCustomDecimalChar(a, this.settings, !1, this.isFocused), [e, a];
  }
  /**
   * Strip parts from excess characters and leading zeros.
   *
   * @param {string} left
   * @param {string} right
   * @returns {[*,*,*]}
   * @private
   */
  _normalizeParts(e, a) {
    let i = !0;
    (this.eventKey === H.keyName.Hyphen || this.eventKey === H.keyName.Minus) && Number(e) === 0 && (i = !1), this.isTrailingNegative && l.isNegative(a, this.settings.negativeSignCharacter) && !l.isNegative(e, this.settings.negativeSignCharacter) && (e = `-${e}`, a = a.replace(this.settings.negativeSignCharacter, "")), e = u._stripAllNonNumberCharactersExceptCustomDecimalChar(e, this.settings, i, this.isFocused), a = u._stripAllNonNumberCharactersExceptCustomDecimalChar(a, this.settings, !1, this.isFocused), this.settings.leadingZero === u.options.leadingZero.deny && (this.eventKey === H.keyName.num0 || this.eventKey === H.keyName.numpad0) && Number(e) === 0 && // If `right` is not empty and the first character is not `decimalCharacter`
    !l.contains(e, this.settings.decimalCharacter) && a !== "" && (e = e.substring(0, e.length - 1));
    let n = e + a;
    if (this.settings.decimalCharacter) {
      const o = n.match(new RegExp(`^${this.regex.aNegRegAutoStrip}\\${this.settings.decimalCharacter}`));
      o && (e = e.replace(o[1], o[1] + "0"), n = e + a);
    }
    return [e, a, n];
  }
  /**
   * Set the formatted element value as well as the `rawValue`.
   * This returns `true` if the element and raw value have been modified, `false` otherwise.
   * This method also adjust the caret position according to the `leadingZero` option and the normalized value. //TODO What about the cursor *selection*?
   *
   * @param {string} left
   * @param {string} right
   * @param {boolean} isPaste
   * @returns {boolean}
   * @private
   */
  _setValueParts(e, a, i = !1) {
    const [n, o, d] = this._normalizeParts(e, a), [s, c] = u._checkIfInRangeWithOverrideOption(d, this.settings);
    if (s && c) {
      const f = u._truncateDecimalPlaces(d, this.settings, i, this.settings.decimalPlacesRawValue).replace(this.settings.decimalCharacter, ".");
      if (f === "" || f === this.settings.negativeSignCharacter) {
        let y;
        switch (this.settings.emptyInputBehavior) {
          case u.options.emptyInputBehavior.focus:
          case u.options.emptyInputBehavior.press:
          case u.options.emptyInputBehavior.always:
            y = "";
            break;
          case u.options.emptyInputBehavior.min:
            y = this.settings.minimumValue;
            break;
          case u.options.emptyInputBehavior.max:
            y = this.settings.maximumValue;
            break;
          case u.options.emptyInputBehavior.zero:
            y = "0";
            break;
          case u.options.emptyInputBehavior.null:
            y = null;
            break;
          default:
            y = this.settings.emptyInputBehavior;
        }
        this._setRawValue(y);
      } else
        this._setRawValue(this._trimLeadingAndTrailingZeros(f));
      const p = u._truncateDecimalPlaces(d, this.settings, i, this.settings.decimalPlacesShownOnFocus);
      let b = n.length;
      return b > p.length && (b = p.length), b === 1 && n === "0" && this.settings.leadingZero === u.options.leadingZero.deny && (o === "" || n === "0" && o !== "" ? b = 1 : b = 0), this._setElementValue(p, !1), this._setCaretPosition(b), !0;
    }
    return this._triggerRangeEvents(s, c), !1;
  }
  /**
   * Helper function for `_expandSelectionOnSign()`.
   *
   * @returns {Array} Array containing [signPosition, currencySymbolPosition] of a formatted value
   * @private
   */
  _getSignPosition() {
    let e;
    if (this.settings.currencySymbol) {
      const a = this.settings.currencySymbol.length, i = l.getElementValue(this.domElement);
      if (this.settings.currencySymbolPlacement === u.options.currencySymbolPlacement.prefix)
        this.settings.negativeSignCharacter && i && i.charAt(0) === this.settings.negativeSignCharacter ? e = [1, a + 1] : e = [0, a];
      else {
        const n = i.length;
        e = [n - a, n];
      }
    } else
      e = [1e3, -1];
    return e;
  }
  /**
   * Expands selection to cover whole sign
   * Prevents partial deletion/copying/overwriting of a sign
   * @private
   */
  _expandSelectionOnSign() {
    const [e, a] = this._getSignPosition(), i = this.selection;
    i.start < a && i.end > e && ((i.start < e || i.end > a) && l.getElementValue(this.domElement).substring(Math.max(i.start, e), Math.min(i.end, a)).match(/^\s*$/) ? i.start < e ? this._setSelection(i.start, e) : this._setSelection(a, i.end) : this._setSelection(Math.min(i.start, e), Math.max(i.end, a)));
  }
  /**
   * Try to strip pasted value to digits
   */
  _checkPaste() {
    if (!this.formatted && !l.isUndefined(this.valuePartsBeforePaste)) {
      const e = this.valuePartsBeforePaste, [a, i] = this._getLeftAndRightPartAroundTheSelection();
      delete this.valuePartsBeforePaste;
      const n = a.substr(0, e[0].length) + u._stripAllNonNumberCharactersExceptCustomDecimalChar(a.substr(e[0].length), this.settings, !0, this.isFocused);
      this._setValueParts(n, i, !0) || (this._setElementValue(e.join(""), !1), this._setCaretPosition(e[0].length));
    }
  }
  /**
   * Return `true` if the given key should be ignored or not.
   *
   * @param {string} eventKeyName
   * @returns {boolean}
   * @private
   */
  static _shouldSkipEventKey(e) {
    const a = l.isInArray(e, H.keyName._allFnKeys), i = e === H.keyName.OSLeft || e === H.keyName.OSRight, n = e === H.keyName.ContextMenu, o = l.isInArray(e, H.keyName._someNonPrintableKeys), d = e === H.keyName.NumLock || e === H.keyName.ScrollLock || e === H.keyName.Insert || e === H.keyName.Command, s = e === H.keyName.Unidentified;
    return a || i || n || o || s || d;
  }
  /**
   * Process copying, cutting and pasting, as well as undo/redoing and cursor moving.
   * Return `true` if further processing should not be performed.
   *
   * @param {KeyboardEvent} e
   * @returns {boolean}
   * @private
   */
  _processNonPrintableKeysAndShortcuts(e) {
    if ((e.ctrlKey || e.metaKey) && e.type === "keyup" && !l.isUndefined(this.valuePartsBeforePaste) || e.shiftKey && this.eventKey === H.keyName.Insert)
      return this._checkPaste(), !1;
    if (this.constructor._shouldSkipEventKey(this.eventKey))
      return !0;
    if ((e.ctrlKey || e.metaKey) && this.eventKey === H.keyName.a)
      return this.settings.selectNumberOnly && (e.preventDefault(), this.selectNumber()), !0;
    if ((e.ctrlKey || e.metaKey) && (this.eventKey === H.keyName.c || this.eventKey === H.keyName.v || this.eventKey === H.keyName.x))
      return e.type === "keydown" && this._expandSelectionOnSign(), (this.eventKey === H.keyName.v || this.eventKey === H.keyName.Insert) && (e.type === "keydown" || e.type === "keypress" ? l.isUndefined(this.valuePartsBeforePaste) && (this.valuePartsBeforePaste = this._getLeftAndRightPartAroundTheSelection()) : this._checkPaste()), e.type === "keydown" || e.type === "keypress" || this.eventKey === H.keyName.c;
    if (e.ctrlKey || e.metaKey)
      return !(this.eventKey === H.keyName.Z || this.eventKey === H.keyName.z);
    if (this.eventKey === H.keyName.LeftArrow || this.eventKey === H.keyName.RightArrow) {
      if (e.type === "keydown" && !e.shiftKey) {
        const a = l.getElementValue(this.domElement);
        this.eventKey === H.keyName.LeftArrow && (a.charAt(this.selection.start - 2) === this.settings.digitGroupSeparator || a.charAt(this.selection.start - 2) === this.settings.decimalCharacter) ? this._setCaretPosition(this.selection.start - 1) : this.eventKey === H.keyName.RightArrow && (a.charAt(this.selection.start + 1) === this.settings.digitGroupSeparator || a.charAt(this.selection.start + 1) === this.settings.decimalCharacter) && this._setCaretPosition(this.selection.start + 1);
      }
      return !0;
    }
    return l.isInArray(this.eventKey, H.keyName._directionKeys);
  }
  /**
   * Process deletion of characters when the minus sign is to the right of the numeric characters.
   *
   * @param {string[]} leftAndRight The parts on the left and on the right of the caret or selection as an array with [left, right]
   * @returns {string[]} Processed left and right as an array with [left, right]
   * @private
   */
  _processCharacterDeletionIfTrailingNegativeSign([e, a]) {
    const i = l.getElementValue(this.domElement), n = l.isNegative(i, this.settings.negativeSignCharacter);
    if (this.settings.currencySymbolPlacement === u.options.currencySymbolPlacement.prefix && this.settings.negativePositiveSignPlacement === u.options.negativePositiveSignPlacement.suffix && (this.eventKey === H.keyName.Backspace ? (this.caretFix = this.selection.start >= i.indexOf(this.settings.suffixText) && this.settings.suffixText !== "", i.charAt(this.selection.start - 1) === "-" ? e = e.substring(1) : this.selection.start <= i.length - this.settings.suffixText.length && (e = e.substring(0, e.length - 1))) : (this.caretFix = this.selection.start >= i.indexOf(this.settings.suffixText) && this.settings.suffixText !== "", this.selection.start >= i.indexOf(this.settings.currencySymbol) + this.settings.currencySymbol.length && (a = a.substring(1, a.length)), l.isNegative(e, this.settings.negativeSignCharacter) && i.charAt(this.selection.start) === "-" && (e = e.substring(1)))), this.settings.currencySymbolPlacement === u.options.currencySymbolPlacement.suffix)
      switch (this.settings.negativePositiveSignPlacement) {
        case u.options.negativePositiveSignPlacement.left:
          this.caretFix = this.selection.start >= i.indexOf(this.settings.negativeSignCharacter) + this.settings.negativeSignCharacter.length, this.eventKey === H.keyName.Backspace ? this.selection.start === i.indexOf(this.settings.negativeSignCharacter) + this.settings.negativeSignCharacter.length && n ? e = e.substring(1) : e !== "-" && (this.selection.start <= i.indexOf(this.settings.negativeSignCharacter) || !n) && (e = e.substring(0, e.length - 1)) : (e[0] === "-" && (a = a.substring(1)), this.selection.start === i.indexOf(this.settings.negativeSignCharacter) && n && (e = e.substring(1)));
          break;
        case u.options.negativePositiveSignPlacement.right:
          this.caretFix = this.selection.start >= i.indexOf(this.settings.negativeSignCharacter) + this.settings.negativeSignCharacter.length, this.eventKey === H.keyName.Backspace ? this.selection.start === i.indexOf(this.settings.negativeSignCharacter) + this.settings.negativeSignCharacter.length ? e = e.substring(1) : (e !== "-" && this.selection.start <= i.indexOf(this.settings.negativeSignCharacter) - this.settings.currencySymbol.length || e !== "" && !n) && (e = e.substring(0, e.length - 1)) : (this.caretFix = this.selection.start >= i.indexOf(this.settings.currencySymbol) && this.settings.currencySymbol !== "", this.selection.start === i.indexOf(this.settings.negativeSignCharacter) && (e = e.substring(1)), a = a.substring(1));
          break;
      }
    return [e, a];
  }
  /**
   * Process the deletion of characters.
   * Returns `true` if the deletion is allowed (within the min and max range, according to the `overrideMinMaxLimits` option), `false` otherwise.
   *
   * @param {Event} e
   * @returns {boolean}
   */
  _processCharacterDeletion(e) {
    let a, i;
    return this.selection.length ? (this._expandSelectionOnSign(), [a, i] = this._getUnformattedLeftAndRightPartAroundTheSelection()) : ([a, i] = this._getUnformattedLeftAndRightPartAroundTheSelection(), a === "" && i === "" && (this.throwInput = !1), this.isTrailingNegative && l.isNegative(l.getElementValue(this.domElement), this.settings.negativeSignCharacter) ? [a, i] = this._processCharacterDeletionIfTrailingNegativeSign([a, i]) : this.eventKey === H.keyName.Backspace ? a = a.substring(0, a.length - 1) : i = i.substring(1, i.length)), !this.constructor._isWithinRangeWithOverrideOption(`${a}${i}`, this.settings) || l.getElementValue(e.target) === this.settings.currencySymbol ? !1 : (this._setValueParts(a, i), !0);
  }
  /**
   * Return `true` if a decimal character is allowed to be typed.
   * If the number of decimal places shown on focus is zero, then the decimal character is not allowed.
   *
   * @returns {boolean}
   * @private
   */
  _isDecimalCharacterInsertionAllowed() {
    return String(this.settings.decimalPlacesShownOnFocus) !== String(u.options.decimalPlacesShownOnFocus.none) && String(this.settings.decimalPlaces) !== String(u.options.decimalPlaces.none);
  }
  /**
   * Return `true` if the key is allowed.
   * This function decides if the key pressed should be dropped or accepted, and modify the value 'on-the-fly' accordingly.
   * //TODO This should use another function in order to separate the test and the modification
   *
   * @returns {boolean}
   */
  _processCharacterInsertion() {
    let [e, a] = this._getUnformattedLeftAndRightPartAroundTheSelection();
    if (this.eventKey !== H.keyName.AndroidDefault && (this.throwInput = !0), this.eventKey === this.settings.decimalCharacter || this.settings.decimalCharacterAlternative && this.eventKey === this.settings.decimalCharacterAlternative) {
      if (!this._isDecimalCharacterInsertionAllowed() || !this.settings.decimalCharacter)
        return !1;
      if (this.settings.alwaysAllowDecimalCharacter)
        e = e.replace(this.settings.decimalCharacter, ""), a = a.replace(this.settings.decimalCharacter, "");
      else {
        if (l.contains(e, this.settings.decimalCharacter) || a.indexOf(this.settings.decimalCharacter) > 0)
          return !0;
        a.indexOf(this.settings.decimalCharacter) === 0 && (a = a.substr(1));
      }
      return this.settings.negativeSignCharacter && l.contains(a, this.settings.negativeSignCharacter) && (e = `${this.settings.negativeSignCharacter}${e}`, a = a.replace(this.settings.negativeSignCharacter, "")), this._setValueParts(e + this.settings.decimalCharacter, a), !0;
    }
    if ((this.eventKey === "-" || this.eventKey === "+") && this.settings.isNegativeSignAllowed)
      return e === "" && l.contains(a, "-") ? (this.settings.negativePositiveSignBehavior || !this.settings.negativePositiveSignBehavior && this.eventKey === "+") && (a = a.replace("-", "")) : l.isNegativeStrict(e, "-") ? (this.settings.negativePositiveSignBehavior || !this.settings.negativePositiveSignBehavior && this.eventKey === "+") && (e = e.replace("-", "")) : (this.settings.negativePositiveSignBehavior || !this.settings.negativePositiveSignBehavior && this.eventKey === "-") && (e = `${this.settings.negativeSignCharacter}${e}`), this._setValueParts(e, a), !0;
    const i = Number(this.eventKey);
    return i >= 0 && i <= 9 ? (this.settings.isNegativeSignAllowed && e === "" && l.contains(a, "-") && (e = "-", a = a.substring(1, a.length)), this.settings.maximumValue <= 0 && this.settings.minimumValue < this.settings.maximumValue && !l.contains(l.getElementValue(this.domElement), this.settings.negativeSignCharacter) && this.eventKey !== "0" && (e = `-${e}`), this._setValueParts(`${e}${this.eventKey}`, a), !0) : (this.throwInput = !1, !1);
  }
  /**
   * Formatting of just processed value while keeping the cursor position
   *
   * @param {Event} e
   * @private
   */
  _formatValue(e) {
    const a = l.getElementValue(this.domElement);
    let [i] = this._getUnformattedLeftAndRightPartAroundTheSelection();
    if ((this.settings.digitGroupSeparator === "" || this.settings.digitGroupSeparator !== "" && !l.contains(a, this.settings.digitGroupSeparator)) && (this.settings.currencySymbol === "" || this.settings.currencySymbol !== "" && !l.contains(a, this.settings.currencySymbol))) {
      let [d] = a.split(this.settings.decimalCharacter), s = "";
      l.isNegative(d, this.settings.negativeSignCharacter) && (s = this.settings.negativeSignCharacter, d = d.replace(this.settings.negativeSignCharacter, ""), i = i.replace("-", "")), s === "" && d.length > this.settings.mIntPos && i.charAt(0) === "0" && (i = i.slice(1)), s === this.settings.negativeSignCharacter && d.length > this.settings.mIntNeg && i.charAt(0) === "0" && (i = i.slice(1)), this.isTrailingNegative || (i = `${s}${i}`);
    }
    const n = this.constructor._addGroupSeparators(a, this.settings, this.isFocused, this.rawValue);
    let o = n.length;
    if (n) {
      const d = i.split("");
      if ((this.settings.negativePositiveSignPlacement === u.options.negativePositiveSignPlacement.suffix || this.settings.negativePositiveSignPlacement !== u.options.negativePositiveSignPlacement.prefix && this.settings.currencySymbolPlacement === u.options.currencySymbolPlacement.suffix) && d[0] === this.settings.negativeSignCharacter && !this.settings.isNegativeSignAllowed && (d.shift(), (this.eventKey === H.keyName.Backspace || this.eventKey === H.keyName.Delete) && this.caretFix && ((this.settings.currencySymbolPlacement === u.options.currencySymbolPlacement.suffix && this.settings.negativePositiveSignPlacement === u.options.negativePositiveSignPlacement.left || this.settings.currencySymbolPlacement === u.options.currencySymbolPlacement.prefix && this.settings.negativePositiveSignPlacement === u.options.negativePositiveSignPlacement.suffix) && (d.push(this.settings.negativeSignCharacter), this.caretFix = e.type === "keydown"), this.settings.currencySymbolPlacement === u.options.currencySymbolPlacement.suffix && this.settings.negativePositiveSignPlacement === u.options.negativePositiveSignPlacement.right))) {
        const m = this.settings.currencySymbol.split(""), f = ["\\", "^", "$", ".", "|", "?", "*", "+", "(", ")", "["], p = [];
        m.forEach((b, y) => {
          y = m[b], l.isInArray(y, f) ? p.push("\\" + y) : p.push(y);
        }), this.eventKey === H.keyName.Backspace && this.settings.negativeSignCharacter === "-" && p.push("-"), d.push(p.join("")), this.caretFix = e.type === "keydown";
      }
      for (let m = 0; m < d.length; m++)
        d[m].match("\\d") || (d[m] = "\\" + d[m]);
      let s;
      this.settings.currencySymbolPlacement === u.options.currencySymbolPlacement.suffix ? s = new RegExp(`^.*?${d.join(".*?")}`) : s = new RegExp(`^.*?[${this.settings.currencySymbol}]*${d.join(".*?")}`);
      const c = n.match(s);
      c ? (o = c[0].length, this.settings.showPositiveSign && (o === 0 && c.input.charAt(0) === this.settings.positiveSignCharacter && (o = c.input.indexOf(this.settings.currencySymbol) === 1 ? this.settings.currencySymbol.length + 1 : 1), o === 0 && c.input.charAt(this.settings.currencySymbol.length) === this.settings.positiveSignCharacter && (o = this.settings.currencySymbol.length + 1)), (o === 0 && n.charAt(0) !== this.settings.negativeSignCharacter || o === 1 && n.charAt(0) === this.settings.negativeSignCharacter) && this.settings.currencySymbol && this.settings.currencySymbolPlacement === u.options.currencySymbolPlacement.prefix && (o = this.settings.currencySymbol.length + (l.isNegativeStrict(n, this.settings.negativeSignCharacter) ? 1 : 0))) : (this.settings.currencySymbol && this.settings.currencySymbolPlacement === u.options.currencySymbolPlacement.suffix && (o -= this.settings.currencySymbol.length), this.settings.suffixText && (o -= this.settings.suffixText.length));
    }
    n !== a && (this._setElementValue(n, !1), this._setCaretPosition(o)), this.formatted = !0;
  }
  /**
   * Serialize the form child <input> element values to a string, or an Array.
   * The output format is defined with the `formatType` argument.
   * This is loosely based upon http://stackoverflow.com/a/40705993/2834898.
   *
   * @param {HTMLFormElement} form
   * @param {boolean} intoAnArray If `true`, instead of generating a string, it generates an Array.
   * @param {string} formatType If `'unformatted'`, then the AutoNumeric elements values are unformatted, if `'localized'`, then the AutoNumeric elements values are localized, and if `'formatted'`, then the AutoNumeric elements values are kept formatted. In either way, this function does not modify the value of each DOM element, but only affect the value that is returned by that serialize function.
   * @param {string} serializedSpaceCharacter Can either be the '+' character, or the '%20' string.
   * @param {string|null} forcedOutputFormat If set, then this is the format that is used for the localization, instead of the default `outputFormat` option.
   * @returns {string|Array}
   * @private
   */
  static _serialize(e, a = !1, i = "unformatted", n = "+", o = null) {
    const d = [];
    typeof e == "object" && e.nodeName.toLowerCase() === "form" && Array.prototype.slice.call(e.elements).forEach((c) => {
      if (c.name && !c.disabled && ["file", "reset", "submit", "button"].indexOf(c.type) === -1) {
        if (c.type === "select-multiple")
          Array.prototype.slice.call(c.options).forEach((m) => {
            m.selected && (a ? d.push({ name: c.name, value: m.value }) : d.push(`${encodeURIComponent(c.name)}=${encodeURIComponent(m.value)}`));
          });
        else if (["checkbox", "radio"].indexOf(c.type) === -1 || c.checked) {
          let m;
          if (this.isManagedByAutoNumeric(c)) {
            let f;
            switch (i) {
              case "unformatted":
                f = this.getAutoNumericElement(c), l.isNull(f) || (m = this.unformat(c, f.getSettings()));
                break;
              case "localized":
                if (f = this.getAutoNumericElement(c), !l.isNull(f)) {
                  const p = l.cloneObject(f.getSettings());
                  l.isNull(o) || (p.outputFormat = o), m = this.localize(c, p);
                }
                break;
              case "formatted":
              default:
                m = c.value;
            }
          } else
            m = c.value;
          l.isUndefined(m) && l.throwError("This error should never be hit. If it has, something really wrong happened!"), a ? d.push({ name: c.name, value: m }) : d.push(`${encodeURIComponent(c.name)}=${encodeURIComponent(m)}`);
        }
      }
    });
    let s;
    return a ? s = d : (s = d.join("&"), n === "+" && (s = s.replace(/%20/g, "+"))), s;
  }
  /**
   * Serialize the form values to a string, outputting numeric strings for each AutoNumeric-managed element values.
   *
   * @param {HTMLFormElement} form
   * @param {string} serializedSpaceCharacter
   * @returns {string}
   */
  static _serializeNumericString(e, a = "+") {
    return this._serialize(e, !1, "unformatted", a);
  }
  /**
   * Serialize the form values to a string, outputting the formatted value as strings for each AutoNumeric-managed elements.
   *
   * @param {HTMLFormElement} form
   * @param {string} serializedSpaceCharacter
   * @returns {string}
   */
  static _serializeFormatted(e, a = "+") {
    return this._serialize(e, !1, "formatted", a);
  }
  /**
   * Serialize the form values to a string, outputting localized strings for each AutoNumeric-managed element values.
   *
   * @param {HTMLFormElement} form
   * @param {string} serializedSpaceCharacter
   * @param {string|null} forcedOutputFormat If set, then this is the format that is used for the localization, instead of the default `outputFormat` option.
   * @returns {string}
   */
  static _serializeLocalized(e, a = "+", i = null) {
    return this._serialize(e, !1, "localized", a, i);
  }
  /**
   * Generate an Array with the form values, outputting numeric strings for each AutoNumeric-managed element values.
   *
   * @param {HTMLFormElement} form
   * @param {string} serializedSpaceCharacter
   * @returns {Array}
   */
  static _serializeNumericStringArray(e, a = "+") {
    return this._serialize(e, !0, "unformatted", a);
  }
  /**
   * Generate an Array with the form values, outputting the formatted value as strings for each AutoNumeric-managed elements.
   *
   * @param {HTMLFormElement} form
   * @param {string} serializedSpaceCharacter
   * @returns {Array}
   */
  static _serializeFormattedArray(e, a = "+") {
    return this._serialize(e, !0, "formatted", a);
  }
  /**
   * Generate an Array with the form values, outputting localized strings for each AutoNumeric-managed element values.
   *
   * @param {HTMLFormElement} form
   * @param {string} serializedSpaceCharacter
   * @param {string|null} forcedOutputFormat If set, then this is the format that is used for the localization, instead of the default `outputFormat` option.
   * @returns {Array}
   */
  static _serializeLocalizedArray(e, a = "+", i = null) {
    return this._serialize(e, !0, "localized", a, i);
  }
};
J0(u, "options"), // Those static declarations are only used by the IDE, to prevent error messages not finding those fields declarations
J0(u, "events"), J0(u, "defaultSettings"), J0(u, "predefinedOptions");
let T = u;
T.multiple = (t, e = null, a = null) => {
  const i = [];
  if (l.isObject(e) && (a = e, e = null), l.isString(t))
    t = [...document.querySelectorAll(t)];
  else if (l.isObject(t)) {
    Object.prototype.hasOwnProperty.call(t, "rootElement") || l.throwError("The object passed to the 'multiple' function is invalid ; no 'rootElement' attribute found.");
    const y = [...t.rootElement.querySelectorAll("input")];
    Object.prototype.hasOwnProperty.call(t, "exclude") ? (Array.isArray(t.exclude) || l.throwError("The 'exclude' array passed to the 'multiple' function is invalid."), t = l.filterOut(y, t.exclude)) : t = y;
  } else l.isArray(t) || l.throwError("The given parameters to the 'multiple' function are invalid.");
  if (t.length === 0) {
    let y = !0;
    return !l.isNull(a) && l.isBoolean(a.showWarnings) && (y = a.showWarnings), l.warning("No valid DOM elements were given hence no AutoNumeric objects were instantiated.", y), [];
  }
  const o = l.isArray(e) && e.length >= 1;
  let d = !1, s = !1;
  if (o) {
    const y = typeof Number(e[0]);
    d = y === "number" && !isNaN(Number(e[0])), d || (y === "string" || isNaN(y) || y === "object") && (s = !0);
  }
  const c = l.isArray(a) && a.length >= 1;
  let m = !1;
  if (c) {
    const y = typeof a[0];
    (y === "string" || y === "object") && (m = !0);
  }
  let f;
  s ? f = T.mergeOptions(e) : m ? f = T.mergeOptions(a) : f = a;
  const p = l.isNumber(e);
  let b;
  return d && (b = e.length), t.forEach((y, v) => {
    p ? i.push(new T(y, e, f)) : d && v <= b ? i.push(new T(y, e[v], f)) : i.push(new T(y, null, f));
  }), i;
};
T.events = {
  correctedValue: "autoNumeric:correctedValue",
  initialized: "autoNumeric:initialized",
  invalidFormula: "autoNumeric:invalidFormula",
  invalidValue: "autoNumeric:invalidValue",
  formatted: "autoNumeric:formatted",
  rawValueModified: "autoNumeric:rawValueModified",
  minRangeExceeded: "autoNumeric:minExceeded",
  maxRangeExceeded: "autoNumeric:maxExceeded",
  native: {
    input: "input",
    change: "change"
  },
  validFormula: "autoNumeric:validFormula"
};
Object.freeze(T.events.native);
Object.freeze(T.events);
Object.defineProperty(T, "events", { configurable: !1, writable: !1 });
T.options = {
  /* Defines if the decimal places should be padded with zeroes
   * `true`     : always pad decimals with zeros (ie. '12.3400')
   * `false`    : never pad with zeros (ie. '12.34')
   * `'floats'` : pad with zeroes only when there are decimals (ie. '12' and '12.3400')
   * Note: setting allowDecimalPadding to 'false' will override the 'decimalPlaces' setting.
   */
  allowDecimalPadding: {
    always: !0,
    never: !1,
    floats: "floats"
  },
  /* Defines if the decimal character or decimal character alternative should be accepted when there is already a decimal character shown in the element.
   * If set to `true`, any decimal character input will be accepted and will subsequently modify the decimal character position, as well as the `rawValue`.
   * If set to `false`, the decimal character and its alternative key will be dropped as before. This is the default setting.
   */
  alwaysAllowDecimalCharacter: {
    alwaysAllow: !0,
    doNotAllow: !1
  },
  /* Defines where should be positioned the caret on focus
   * null : Do not enforce any caret positioning on focus (this is needed when using `selectOnFocus`)
   * `'start'` : put the caret of the far left side of the value (excluding the positive/negative sign and currency symbol, if any)
   * `'end'` : put the caret of the far right side of the value (excluding the positive/negative sign and currency symbol, if any)
   * `'decimalLeft'` : put the caret of the left of the decimal character if any
   * `'decimalRight'` : put the caret of the right of the decimal character if any
   */
  caretPositionOnFocus: {
    start: "start",
    end: "end",
    decimalLeft: "decimalLeft",
    decimalRight: "decimalRight",
    doNoForceCaretPosition: null
  },
  /* Defines if a local list of AutoNumeric objects should be kept when initializing this object.
   * This list is used by the `global.*` functions.
   */
  createLocalList: {
    createList: !0,
    doNotCreateList: !1
  },
  /* Defines the currency symbol string.
   * It can be a string of more than one character (allowing for instance to use a space on either side of it, example: '$ ' or ' $')
   * cf. https://en.wikipedia.org/wiki/Currency_symbol
   */
  currencySymbol: {
    none: "",
    currencySign: "¤",
    austral: "₳",
    // ARA
    australCentavo: "¢",
    baht: "฿",
    // THB
    cedi: "₵",
    // GHS
    cent: "¢",
    colon: "₡",
    // CRC
    cruzeiro: "₢",
    // BRB - Not used anymore since 1993
    dollar: "$",
    dong: "₫",
    // VND
    drachma: "₯",
    // GRD (or 'Δρχ.' or 'Δρ.')
    dram: "​֏",
    // AMD
    european: "₠",
    // XEU (old currency before the Euro)
    euro: "€",
    // EUR
    florin: "ƒ",
    franc: "₣",
    // FRF
    guarani: "₲",
    // PYG
    hryvnia: "₴",
    // грн
    kip: "₭",
    // LAK
    att: "ອັດ",
    // cents of the Kip
    lepton: "Λ.",
    // cents of the Drachma
    lira: "₺",
    // TRY
    liraOld: "₤",
    lari: "₾",
    // GEL
    mark: "ℳ",
    mill: "₥",
    naira: "₦",
    // NGN
    peseta: "₧",
    peso: "₱",
    // PHP
    pfennig: "₰",
    // cents of the Mark
    pound: "£",
    real: "R$ ",
    // Brazilian real
    riel: "៛",
    // KHR
    ruble: "₽",
    // RUB
    rupee: "₹",
    // INR
    rupeeOld: "₨",
    shekel: "₪",
    shekelAlt: "ש״ח‎‎",
    taka: "৳",
    // BDT
    tenge: "₸",
    // KZT
    togrog: "₮",
    // MNT
    won: "₩",
    yen: "¥"
  },
  /* Defines where the currency symbol should be placed (before of after the numbers)
   * for prefix currencySymbolPlacement: "p" (default)
   * for suffix currencySymbolPlacement: "s"
   */
  currencySymbolPlacement: {
    prefix: "p",
    suffix: "s"
  },
  /* Defines what decimal separator character is used
   */
  decimalCharacter: {
    comma: ",",
    dot: ".",
    middleDot: "·",
    arabicDecimalSeparator: "٫",
    decimalSeparatorKeySymbol: "⎖"
  },
  /* Allow to declare an alternative decimal separator which is automatically replaced by `decimalCharacter` when typed.
   * This is used by countries that use a comma ',' as the decimal character and have keyboards with a numeric pads that have
   * a period 'full stop' as the decimal character (France or Spain for instance).
   */
  decimalCharacterAlternative: {
    none: null,
    comma: ",",
    dot: "."
  },
  /* Defines the default number of decimal places to show on the formatted value, and keep for the precision.
   * Incidentally, since we need to be able to show that many decimal places, this also defines the raw value precision by default.
   */
  decimalPlaces: {
    none: 0,
    one: 1,
    two: 2,
    three: 3,
    four: 4,
    five: 5,
    six: 6
  },
  /* Defines how many decimal places should be kept for the raw value (ie. This is the precision for float values).
   *
   * If this option is set to `null` (which is the default), then the value of `decimalPlaces` is used for `decimalPlacesRawValue` as well.
   * Note: Setting this to a lower number of decimal places than the one to be shown will lead to confusion for the users.
   */
  decimalPlacesRawValue: {
    useDefault: null,
    none: 0,
    one: 1,
    two: 2,
    three: 3,
    four: 4,
    five: 5,
    six: 6
  },
  /* Defines how many decimal places should be visible when the element is unfocused.
   * If this is set to `null`, then this option is ignored, and the `decimalPlaces` option value will be used instead.
   * This means this is optional ; if omitted the decimal places will be the same when the input has the focus.
   *
   * This option can be used in conjonction with the two other `scale*` options, which allows to display a different formatted value when the element is unfocused, while another formatted value is shown when focused.
   * For those `scale*` options to have any effect, `divisorWhenUnfocused` must not be `null`.
   */
  decimalPlacesShownOnBlur: {
    useDefault: null,
    none: 0,
    one: 1,
    two: 2,
    three: 3,
    four: 4,
    five: 5,
    six: 6
  },
  /* Defines how many decimal places should be visible when the element has the focus.
   * If this is set to `null`, then this option is ignored, and the `decimalPlaces` option value will be used instead.
   *
   * Example:
   * For instance if `decimalPlacesShownOnFocus` is set to `5` and the default number of decimal places is `2`, then on focus `1,000.12345` will be shown, while without focus `1,000.12` will be set back.
   * Note 1: the results depends on the rounding method used.
   * Note 2: the `getNumericString()` method returns the extended decimal places
   */
  decimalPlacesShownOnFocus: {
    useDefault: null,
    none: 0,
    one: 1,
    two: 2,
    three: 3,
    four: 4,
    five: 5,
    six: 6
  },
  /* Helper option for ASP.NET postback
   * This should be set as the value of the unformatted default value
   * examples:
   * no default value="" {defaultValueOverride: ""}
   * value=1234.56 {defaultValueOverride: '1234.56'}
   */
  defaultValueOverride: {
    doNotOverride: null
  },
  /* Defines how many numbers should be grouped together (usually for the thousand separator)
   * - "2",  results in 99,99,99,99 Group by two
   * - "2t", results in 99,99,99,999 India's lakhs
   * - "2s", results in 99,999,99,99,999 India's lakhs scaled
   * - "3",  results in 999,999,999 (default)
   * - "4",  results in 9999,9999,9999 used in some Asian countries
   * Note: This option does not accept other grouping choice.
   */
  digitalGroupSpacing: {
    two: "2",
    twoThree: "2t",
    twoScaled: "2s",
    three: "3",
    four: "4"
  },
  /* Defines the thousand grouping separator character
   * Example : If `'.'` is set, then you'll get `'1.234.567'`
   */
  digitGroupSeparator: {
    comma: ",",
    dot: ".",
    normalSpace: " ",
    thinSpace: " ",
    narrowNoBreakSpace: " ",
    noBreakSpace: " ",
    noSeparator: "",
    apostrophe: "'",
    arabicThousandsSeparator: "٬",
    dotAbove: "˙",
    privateUseTwo: "’"
    // \u0092
  },
  /* The `divisorWhenUnfocused` divide the element value on focus.
   * On blur, the element value is multiplied back.
   *
   * Example : Display percentages using { divisorWhenUnfocused: 100 } (or directly in the Html with `<input data-divisor-when-unfocused="100">`)
   * The divisor value does not need to be an integer, but please understand that Javascript has limited accuracy in math ; use with caution.
   * Note: The `getNumericString` method returns the full value, including the 'hidden' decimals.
   */
  divisorWhenUnfocused: {
    none: null,
    percentage: 100,
    permille: 1e3,
    basisPoint: 1e4
  },
  /* Defines what should be displayed in the element if the raw value is an empty string ('').
   * - 'focus'  : The currency sign is displayed when the input receives focus (default)
   * - 'press'  : The currency sign is displayed whenever a key is being pressed
   * - 'always' : The currency sign is always displayed
   * - 'zero'   : A zero is displayed ('rounded' with or without a currency sign) if the input has no value on focus out
   * - 'min'    : The minimum value is displayed if the input has no value on focus out
   * - 'max'    : The maximum value is displayed if the input has no value on focus out
   * - 'null'   : When the element is empty, the `rawValue` and the element value/text is set to `null`. This also allows to set the value to `null` using `anElement.set(null)`.
   */
  emptyInputBehavior: {
    focus: "focus",
    press: "press",
    always: "always",
    zero: "zero",
    min: "min",
    max: "max",
    null: "null"
  },
  /* Defines if the custom and native events triggered by AutoNumeric should bubble up or not.
   */
  eventBubbles: {
    bubbles: !0,
    doesNotBubble: !1
  },
  /* Defines if the custom and native events triggered by AutoNumeric should be cancelable.
   */
  eventIsCancelable: {
    isCancelable: !0,
    isNotCancelable: !1
  },
  /* This option is the 'strict mode' (aka 'debug' mode), which allows autoNumeric to strictly analyse the options passed, and fails if an unknown options is used in the settings object.
   * You should set that to `true` if you want to make sure you are only using 'pure' autoNumeric settings objects in your code.
   * If you see uncaught errors in the console and your code starts to fail, this means somehow those options gets polluted by another program (which usually happens when using frameworks).
   */
  failOnUnknownOption: {
    fail: !0,
    ignore: !1
  },
  /* Determine if the default value will be formatted on initialization.
   */
  formatOnPageLoad: {
    format: !0,
    // automatically formats the default value on initialization
    doNotFormat: !1
    // will not format the default value on initialization
  },
  /* Defines if the 'formula mode' can be activated by the user.
   * If set to `true`, then the user can enter the formula mode by entering the '=' character.
   * He will then be allowed to enter any simple math formula using numeric characters as well as the following operators +, -, *, /, ( and ).
   * The formula mode is closed when the user either validate their math expression using the `Enter` key, or when the element is blurred.
   * If the formula is invalid, the previous valid `rawValue` is set back, and the `autoNumeric:invalidFormula` event is sent.
   * When a valid formula is accepted, then its result is `set()`, and the `autoNumeric:validFormula` event is sent.
   *
   * By default, this mode is disabled.
   */
  formulaMode: {
    enabled: !0,
    disabled: !1
  },
  /* Set the undo/redo history table size.
   * Each record keeps the raw value as well and the last known caret/selection positions.
   */
  historySize: {
    verySmall: 5,
    small: 10,
    medium: 20,
    large: 50,
    veryLarge: 100,
    insane: Number.MAX_SAFE_INTEGER
  },
  /* Defines the name of the CSS class to use on contenteditable-enabled elements when the value is invalid
   * This is not used when the HTML element used is an input.
   */
  invalidClass: "an-invalid",
  /* Allow the user to 'cancel' and undo the changes he made to the given autonumeric-managed element, by pressing the 'Escape' key.
   * Whenever the user 'validate' the input (either by hitting 'Enter', or blurring the element), the new value is saved for subsequent 'cancellation'.
   *
   * The process :
   *   - save the input value on focus
   *   - if the user change the input value, and hit `Escape`, then the initial value saved on focus is set back
   *   - on the other hand if the user either have used `Enter` to validate (`Enter` throws a change event) his entries, or if the input value has been changed by another script in the mean time, then we save the new input value
   *   - on a successful 'cancel', select the whole value (while respecting the `selectNumberOnly` option)
   *   - bonus; if the value has not changed, hitting 'Esc' just select all the input value (while respecting the `selectNumberOnly` option)
   */
  isCancellable: {
    cancellable: !0,
    notCancellable: !1
  },
  /* Controls the leading zero behavior
   * - 'allow' : allows leading zeros to be entered. Zeros will be truncated when entering additional digits. On focusout zeros will be deleted
   * - 'deny'  : allows only one leading zero on values that are between 1 and -1
   * - 'keep'  : allows leading zeros to be entered. on focusout zeros will be retained
   */
  leadingZero: {
    allow: "allow",
    deny: "deny",
    keep: "keep"
  },
  /* Defines the maximum possible value a user can enter.
   * Notes:
   * - this value must be a string and use the period for the decimal point
   * - this value needs to be larger than `minimumValue`
   */
  maximumValue: {
    tenTrillions: "10000000000000",
    // 10000 billions
    oneBillion: "1000000000",
    zero: "0"
  },
  /* Defines the minimum possible value a user can enter.
   * Notes:
   * - this value must be a string and use the period for the decimal point
   * - this value needs to be smaller than `maximumValue`
   * - if this is superior to 0, then you'll effectively prevent your user to entirely delete the content of your element
   */
  minimumValue: {
    tenTrillions: "-10000000000000",
    // 10000 billions
    oneBillion: "-1000000000",
    zero: "0"
  },
  /* Allows the user to increment or decrement the element value with the up and down arrow keys.
   * The behavior is similar to the mouse wheel one.
   * The up and down arrow keys behavior can be modified by the `upDownStep` option.
   * This `upDownStep` option can be used in two ways, either by setting:
   * - a 'fixed' step value (`upDownStep : 1000`), or
   * - the 'progressive' string (`upDownStep : 'progressive'`), which will then activate a special mode where the step is automatically calculated based on the element value size.
   */
  modifyValueOnUpDownArrow: {
    modifyValue: !0,
    doNothing: !1
  },
  /* Allows the user to increment or decrement the element value with the mouse wheel.
   * The behavior is similar to the up/down arrow one.
   * The wheel behavior can be modified by the `wheelStep` option.
   * This `wheelStep` option can be used in two ways, either by setting:
   * - a 'fixed' step value (`wheelStep : 1000`), or
   * - the 'progressive' string (`wheelStep : 'progressive'`), which will then activate a special mode where the step is automatically calculated based on the element value size.
   *
   * Note :
   * You can activate/deactivate the wheel event for each `wheelOn` option value by using the 'Shift' modifier key while using the mouse wheel.
   */
  modifyValueOnWheel: {
    modifyValue: !0,
    doNothing: !1
  },
  /* Adds brackets on negative values (ie. transforms '-$ 999.99' to '($999.99)')
   * Those brackets are visible only when the field does NOT have the focus.
   * The left and right symbols should be enclosed in quotes and separated by a comma.
   */
  negativeBracketsTypeOnBlur: {
    parentheses: "(,)",
    brackets: "[,]",
    chevrons: "<,>",
    curlyBraces: "{,}",
    angleBrackets: "〈,〉",
    japaneseQuotationMarks: "｢,｣",
    halfBrackets: "⸤,⸥",
    whiteSquareBrackets: "⟦,⟧",
    quotationMarks: "‹,›",
    guillemets: "«,»",
    none: null
    // This is the default value, which deactivate this feature
  },
  /* Placement of the negative/positive sign relative to the `currencySymbol` option.
   *
   * Example:
   * // Default values
   * -1,234.56  => default no options required
   * $-1,234.56 => {currencySymbol: "$", negativePositiveSignPlacement: "r"} // Default if negativePositiveSignPlacement is 'null' and currencySymbol is not empty
   *
   * // Sign on the left hand side of the whole number
   * -$1,234.56 => {currencySymbol: "$"} or {currencySymbol: "$", negativePositiveSignPlacement: "l"}
   * -1,234.56$ => {currencySymbol: "$", currencySymbolPlacement: "s", negativePositiveSignPlacement: "p"} // Default if negativePositiveSignPlacement is 'null' and currencySymbol is not empty
   *
   * // Sign on the right hand side of the whole number
   * 1,234.56-  => {negativePositiveSignPlacement: "s"}
   * $1,234.56- => {currencySymbol: "$", negativePositiveSignPlacement: "s"}
   * 1,234.56-$ => {currencySymbol: "$", currencySymbolPlacement: "s"}
   * 1,234.56$- => {currencySymbol: "$", currencySymbolPlacement: "s", negativePositiveSignPlacement: "r"}
   */
  negativePositiveSignPlacement: {
    prefix: "p",
    suffix: "s",
    left: "l",
    right: "r",
    none: null
  },
  /* Defines the negative sign symbol.
   * It can be a string of only one character.
   */
  negativeSignCharacter: {
    hyphen: "-",
    minus: "−",
    heavyMinus: "➖",
    fullWidthHyphen: "－",
    circledMinus: "⊖",
    squaredMinus: "⊟",
    triangleMinus: "⨺",
    plusMinus: "±",
    minusPlus: "∓",
    dotMinus: "∸",
    minusTilde: "≂",
    not: "¬"
  },
  /*
   * Defines if the negative sign should be toggled when hitting the negative or positive key multiple times.
   * When `toggle` is used, using the same '-' on '+' key will toggle between a positive and negative value.
   * When `doNotToggle` is used, using '-' will always set the value negative, and '+' will always set the value positive.
   */
  negativePositiveSignBehavior: {
    toggle: !0,
    doNotToggle: !1
  },
  /* Defines if the element should have event listeners activated on it.
   * By default, those event listeners are only added to <input> elements and html element with the `contenteditable` attribute set to `true`, but not on the other html tags.
   * This allows to initialize elements without any event listeners.
   * Warning: Since AutoNumeric will not check the input content after its initialization, using some autoNumeric methods afterwards *will* probably leads to formatting problems.
   */
  noEventListeners: {
    noEvents: !0,
    addEvents: !1
  },
  /* Manage how autoNumeric react when the user tries to paste an invalid number.
   * - 'error'    : (This is the default behavior) The input value is not changed and an error is output in the console.
   * - 'ignore'   : idem than 'error', but fail silently without outputting any error/warning in the console.
   * - 'clamp'    : if the pasted value is either too small or too big regarding the minimumValue and maximumValue range, then the result is clamped to those limits.
   * - 'truncate' : autoNumeric will insert as many pasted numbers it can at the initial caret/selection, until everything is pasted, or the range limit is hit.
   *                The non-pasted numbers are dropped and therefore not used at all.
   * - 'replace'  : autoNumeric will first insert as many pasted numbers it can at the initial caret/selection, then if the range limit is hit, it will try
   *                to replace one by one the remaining initial numbers (on the right side of the caret) with the rest of the pasted numbers.
   *
   * Note 1 : A paste content starting with a negative sign '-' will be accepted anywhere in the input, and will set the resulting value as a negative number
   * Note 2 : A paste content starting with a number will be accepted, even if the rest is gibberish (ie. '123foobar456').
   *          Only the first number will be used (here '123').
   * Note 3 : The paste event works with the `decimalPlacesShownOnFocus` option too.
   */
  onInvalidPaste: {
    error: "error",
    ignore: "ignore",
    clamp: "clamp",
    truncate: "truncate",
    replace: "replace"
  },
  /* Defines how the value should be formatted when wanting a 'localized' version of it.
   * - null or 'string' => 'nnnn.nn' or '-nnnn.nn' as text type. This is the default behavior.
   * - 'number'         => nnnn.nn or -nnnn.nn as a Number (Warning: this works only for integers inferior to Number.MAX_SAFE_INTEGER)
   * - ',' or '-,'      => 'nnnn,nn' or '-nnnn,nn'
   * - '.-'             => 'nnnn.nn' or 'nnnn.nn-'
   * - ',-'             => 'nnnn,nn' or 'nnnn,nn-'
   *
   * Note: The hyphen '-' is translated to the custom negative sign defined in `negativeSignCharacter`
   */
  outputFormat: {
    string: "string",
    number: "number",
    dot: ".",
    negativeDot: "-.",
    comma: ",",
    negativeComma: "-,",
    dotNegative: ".-",
    commaNegative: ",-",
    none: null
  },
  /* Defines if AutoNumeric should let the user override the minimum and/or maximum limits when he types numbers in the element.
   * - 'ceiling' Strictly adheres to `maximumValue` and ignores the `minimumValue` settings
   *             It allows the user to enter anything between -∞ `and maximumValue`
   *             If `maximumValue` is less than 0, then it will prevent the user emptying the field or typing value above `maximumValue`, making sure the value entered is always valid
   * - 'floor'   Strictly adheres to `minimumValue` and ignores the `maximumValue` settings
   *             It allows the user to enter anything between `minimumValue` and +∞
   *             If `minimumValue` is higher than 0, then it will prevent the user emptying the field or typing value below `minimumValue`, making sure the value entered is always valid
   * - 'ignore'  Ignores both the `minimumValue` and `maximumValue` settings
   *             When using this option, the field will always be valid range-wise
   * - 'invalid' The user can temporarily type out-of-bound values. In doing so, the invalid state is set on the field.
   *             Whenever an invalid value is typed, an 'autoNumeric:invalidValue' event is sent
   *             When the value is correctly set back within the limit boundaries, the invalid state is removed, and the 'autoNumeric:correctedValue' event is sent
   * - 'doNotOverride' Strictly adheres to the `maximumValue` and `minimumValue` settings
   *                   This is the default behavior
   *                   If `0` is out of the min/max range, this will prevent the user clearing the input field, making sure the value entered is always valid
   */
  overrideMinMaxLimits: {
    ceiling: "ceiling",
    floor: "floor",
    ignore: "ignore",
    invalid: "invalid",
    doNotOverride: null
  },
  /* Defines the positive sign symbol.
   * It can be a string of only one character.
   * This is shown only if `showPositiveSign` is set to `true`.
   */
  positiveSignCharacter: {
    plus: "+",
    fullWidthPlus: "＋",
    heavyPlus: "➕",
    doublePlus: "⧺",
    triplePlus: "⧻",
    circledPlus: "⊕",
    squaredPlus: "⊞",
    trianglePlus: "⨹",
    plusMinus: "±",
    minusPlus: "∓",
    dotPlus: "∔",
    altHebrewPlus: "﬩",
    normalSpace: " ",
    thinSpace: " ",
    narrowNoBreakSpace: " ",
    noBreakSpace: " "
  },
  /* The `rawValueDivisor` divides the formatted value shown in the AutoNumeric element and store the result in `rawValue`.
   * @example { rawValueDivisor: '100' } or <input data-raw-value-divisor="100">
   * Given the `0.01234` raw value, the formatted value will be displayed as `'1.234'`.
   * This is useful when displaying percentage for instance, and avoid the need to divide/multiply by 100 between the number shown and the raw value.
   */
  rawValueDivisor: {
    none: null,
    percentage: 100,
    permille: 1e3,
    basisPoint: 1e4
  },
  /* Defines if the element (`<input>` or another allowed html tag) should be set as read-only on initialization.
   * When set to `true`, then:
   * - the `readonly` html property is added to the <input> element on initialization, or
   * - the `contenteditable` attribute is set to `false` on non-input elements.
   */
  readOnly: {
    readOnly: !0,
    readWrite: !1
  },
  /* Defines the rounding method to use.
   * roundingMethod: "S", Round-Half-Up Symmetric (default)
   * roundingMethod: "A", Round-Half-Up Asymmetric
   * roundingMethod: "s", Round-Half-Down Symmetric (lower case s)
   * roundingMethod: "a", Round-Half-Down Asymmetric (lower case a)
   * roundingMethod: "B", Round-Half-Even "Bankers Rounding"
   * roundingMethod: "U", Round Up "Round-Away-From-Zero"
   * roundingMethod: "D", Round Down "Round-Toward-Zero" - same as truncate
   * roundingMethod: "C", Round to Ceiling "Toward Positive Infinity"
   * roundingMethod: "F", Round to Floor "Toward Negative Infinity"
   * roundingMethod: "N05" Rounds to the nearest .05 => same as "CHF" used in 1.9X and still valid
   * roundingMethod: "U05" Rounds up to next .05
   * roundingMethod: "D05" Rounds down to next .05
   */
  roundingMethod: {
    halfUpSymmetric: "S",
    halfUpAsymmetric: "A",
    halfDownSymmetric: "s",
    halfDownAsymmetric: "a",
    halfEvenBankersRounding: "B",
    upRoundAwayFromZero: "U",
    downRoundTowardZero: "D",
    toCeilingTowardPositiveInfinity: "C",
    toFloorTowardNegativeInfinity: "F",
    toNearest05: "N05",
    toNearest05Alt: "CHF",
    upToNext05: "U05",
    downToNext05: "D05"
  },
  /* Set to `true` to allow the `decimalPlacesShownOnFocus` value to be saved with sessionStorage
   * If IE 6 or 7 is detected, the value will be saved as a session cookie.
   */
  saveValueToSessionStorage: {
    save: !0,
    doNotSave: !1
  },
  /* Determine if the select all keyboard command will select the complete input text, or only the input numeric value
   * Note : If the currency symbol is between the numeric value and the negative sign, only the numeric value will be selected
   */
  selectNumberOnly: {
    selectNumbersOnly: !0,
    selectAll: !1
  },
  /* Defines if the element value should be selected on focus.
   * Note: The selection is done using the `selectNumberOnly` option.
   */
  selectOnFocus: {
    select: !0,
    doNotSelect: !1
  },
  /* Defines how the serialize functions should treat the spaces.
   * Those spaces ' ' can either be converted to the plus sign '+', which is the default, or to '%20'.
   * Both values being valid per the spec (http://www.w3.org/Addressing/URL/uri-spec.html).
   * Also see the summed up answer on http://stackoverflow.com/a/33939287.
   *
   * tl;dr : Spaces should be converted to '%20' before the '?' sign, then converted to '+' after.
   * In our case since we serialize the query, we use '+' as the default (but allow the user to get back the old *wrong* behavior).
   */
  serializeSpaces: {
    plus: "+",
    percent: "%20"
  },
  /* Defines if the element value should be converted to the raw value on focus (and back to the formatted on blur).
   * If set to `true`, then autoNumeric remove the thousand separator, currency symbol and suffix on focus.
   * Example:
   * If the input value is '$ 1,999.88 suffix', on focus it becomes '1999.88' and back to '$ 1,999.88 suffix' on blur.
   */
  showOnlyNumbersOnFocus: {
    onlyNumbers: !0,
    showAll: !1
  },
  /* Allow the positive sign symbol `+` to be displayed for positive numbers.
   * By default, this positive sign is not shown.
   * The sign placement is controlled by the 'negativePositiveSignPlacement' option, mimicking the negative sign placement rules.
   */
  showPositiveSign: {
    show: !0,
    hide: !1
  },
  /* Defines if warnings should be shown in the console.
   * Those warnings can be ignored, but are usually printed when something could be improved by the user (ie. option conflicts).
   */
  showWarnings: {
    show: !0,
    // All warning are shown
    hide: !1
    // No warnings are shown, only the thrown errors
  },
  /* Defines the rules that calculate the CSS class(es) to apply on the element, based on the raw unformatted value.
   * This can also be used to call callbacks whenever the `rawValue` is updated.
   * Important: all callbacks must return `null` if no ranges/userDefined classes are selected
   * @example
   * {
   *     positive   : 'autoNumeric-positive', // Or `null` to not use it
   *     negative   : 'autoNumeric-negative',
   *     ranges     : [
   *         { min: 0, max: 25, class: 'autoNumeric-red' },
   *         { min: 25, max: 50, class: 'autoNumeric-orange' },
   *         { min: 50, max: 75, class: 'autoNumeric-yellow' },
   *         { min: 75, max: Number.MAX_SAFE_INTEGER, class: 'autoNumeric-green' },
   *     ],
   *     userDefined: [
   *         // If 'classes' is a string, set it if `true`, remove it if `false`
   *         { callback: rawValue => { return true; }, classes: 'thisIsTrue' },
   *         // If 'classes' is an array with only 2 elements, set the first class if `true`, the second if `false`
   *         { callback: rawValue => rawValue % 2 === 0, classes: ['autoNumeric-even', 'autoNumeric-odd'] },
   *         // Return only one index to use on the `classes` array (here, 'class3')
   *         { callback: rawValue => { return 2; }, classes: ['class1', 'class2', 'class3'] },
   *         // Return an array of indexes to use on the `classes` array (here, 'class1' and 'class3')
   *         { callback: rawValue => { return [0, 2]; }, classes: ['class1', 'class2', 'class3'] },
   *         // If 'classes' is `undefined` or `null`, then the callback is called with the AutoNumeric object passed as a parameter
   *         { callback: anElement => { return anElement.getFormatted(); } },
   *     ],
   * }
   */
  styleRules: {
    none: null,
    positiveNegative: {
      positive: "autoNumeric-positive",
      negative: "autoNumeric-negative"
    },
    range0To100With4Steps: {
      ranges: [
        { min: 0, max: 25, class: "autoNumeric-red" },
        { min: 25, max: 50, class: "autoNumeric-orange" },
        { min: 50, max: 75, class: "autoNumeric-yellow" },
        { min: 75, max: 100, class: "autoNumeric-green" }
      ]
    },
    evenOdd: {
      userDefined: [
        { callback: (t) => t % 2 === 0, classes: ["autoNumeric-even", "autoNumeric-odd"] }
      ]
    },
    rangeSmallAndZero: {
      userDefined: [
        {
          callback: (t) => t >= -1 && t < 0 ? 0 : Number(t) === 0 ? 1 : t > 0 && t <= 1 ? 2 : null,
          classes: [
            "autoNumeric-small-negative",
            "autoNumeric-zero",
            "autoNumeric-small-positive"
          ]
        }
      ]
    }
  },
  /* Add a text on the right hand side of the element value.
   * This suffix text can have any characters in its string, except numeric characters and the negative/positive sign.
   * Example: ' dollars'
   */
  suffixText: {
    none: "",
    percentage: "%",
    permille: "‰",
    basisPoint: "‱"
  },
  /* The three options (divisorWhenUnfocused, decimalPlacesShownOnBlur & symbolWhenUnfocused) handle scaling of the input when the input does not have focus
   * Please note that the non-scaled value is held in data and it is advised that you use the `saveValueToSessionStorage` option to ensure retaining the value
   * ["divisor", "decimal places", "symbol"]
   * Example: with the following options set {divisorWhenUnfocused: '1000', decimalPlacesShownOnBlur: '1', symbolWhenUnfocused: ' K'}
   * Example: focusin value "1,111.11" focusout value "1.1 K"
   */
  /* The `symbolWhenUnfocused` option is a symbol placed as a suffix when not in focus.
   * This is optional too.
   */
  symbolWhenUnfocused: {
    none: null,
    percentage: "%",
    permille: "‰",
    basisPoint: "‱"
  },
  /* Defines if the element value should be unformatted when the user hover his mouse over it while holding the `Alt` key.
   * Unformatting there means that this removes any non-number characters and displays the *raw* value, as understood by Javascript (ie. `12.34` is a valid number, while `12,34` is not).
   *
   * We reformat back before anything else if :
   * - the user focus on the element by tabbing or clicking into it,
   * - the user releases the `Alt` key, and
   * - if we detect a mouseleave event.
   *
   * We unformat again if :
   * - while the mouse is over the element, the user hit `Alt` again
   */
  unformatOnHover: {
    unformat: !0,
    doNotUnformat: !1
    //TODO Rename to `keepFormat`
  },
  /* Removes the formatting and use the raw value in each autoNumeric elements of the parent form element, on the form `submit` event.
   * The output format is a numeric string (nnnn.nn or -nnnn.nn).
   */
  unformatOnSubmit: {
    unformat: !0,
    keepCurrentValue: !1
  },
  /* That option is linked to the `modifyValueOnUpDownArrow` one and will only be used if the latter is set to `true`.
   * This option will modify the up/down arrow behavior and can be used in two ways, either by setting :
   * - a 'fixed' step value (a positive float or integer number (ex: `1000`)), or
   * - the `'progressive'` string.
   *
   * The 'fixed' mode always increment/decrement the element value by that amount, while respecting the `minimumValue` and `maximumValue` settings.
   * The 'progressive' mode will increment/decrement the element value based on its current value. The bigger the number, the bigger the step, and vice versa.
   */
  upDownStep: {
    progressive: "progressive"
  },
  /* Provides a way for automatically replacing the formatted value with a pre-defined string, when the raw value is equal to a specific value
   * Here you can specify as many 'conversion' as needed.
   */
  valuesToStrings: {
    none: null,
    zeroDash: {
      0: "-"
    },
    oneAroundZero: {
      "-1": "Min",
      1: "Max"
    }
  },
  /* Defines if the AutoNumeric element should watch external changes made without using `.set()`, but by using the basic `aNElement.node().value = 42` notation.
   * If set to `watch`, then AutoNumeric will format the new value using `.set()` internally.
   * Otherwise it will neither format it, nor save it in the history.
   */
  watchExternalChanges: {
    watch: !0,
    doNotWatch: !1
  },
  /* Defines when the wheel event will increment or decrement the element value.
   * When set to `'focus'`, the AutoNumeric-managed element needs to be focused for the wheel event to change the value.
   * When set to `'hover'`, using the wheel event while the mouse is hovering the element is sufficient (no focus needed).
   *
   * Note :
   * When `wheelOn` is set to `'focus'`, you can use the 'Shift' modifier key while using the mouse wheel in order to temporarily activate the increment/decrement feature even if the element is not focused.
   * When `wheelOn` is set to `'hover'`, you can use the 'Shift' modifier key while using the mouse wheel in order to temporarily disable the increment/decrement feature even if the element is not hovered.
   */
  wheelOn: {
    focus: "focus",
    hover: "hover"
  },
  /* That option is linked to the `modifyValueOnWheel` one and will only be used if the latter is set to `true`.
   * This option will modify the wheel behavior and can be used in two ways, either by setting :
   * - a 'fixed' step value (a positive float or integer (ex: number `1000`)), or
   * - the `'progressive'` string.
   *
   * The 'fixed' mode always increment/decrement the element value by that amount, while respecting the `minimumValue` and `maximumValue` settings.
   * The 'progressive' mode will increment/decrement the element value based on its current value. The bigger the number, the bigger the step, and vice versa.
   */
  wheelStep: {
    progressive: "progressive"
  }
};
function pr(t) {
  return Object.getOwnPropertyNames(t).forEach((e) => {
    e === "valuesToStrings" ? Object.getOwnPropertyNames(t.valuesToStrings).forEach((i) => {
      t.valuesToStrings[i] !== null && Object.freeze(t.valuesToStrings[i]);
    }) : e !== "styleRules" && t[e] !== null && Object.freeze(t[e]);
  }), Object.freeze(t);
}
pr(T.options);
Object.defineProperty(T, "options", { configurable: !1, writable: !1 });
T.defaultSettings = {
  allowDecimalPadding: T.options.allowDecimalPadding.always,
  alwaysAllowDecimalCharacter: T.options.alwaysAllowDecimalCharacter.doNotAllow,
  caretPositionOnFocus: T.options.caretPositionOnFocus.doNoForceCaretPosition,
  createLocalList: T.options.createLocalList.createList,
  currencySymbol: T.options.currencySymbol.none,
  currencySymbolPlacement: T.options.currencySymbolPlacement.prefix,
  decimalCharacter: T.options.decimalCharacter.dot,
  decimalCharacterAlternative: T.options.decimalCharacterAlternative.none,
  decimalPlaces: T.options.decimalPlaces.two,
  decimalPlacesRawValue: T.options.decimalPlacesRawValue.useDefault,
  decimalPlacesShownOnBlur: T.options.decimalPlacesShownOnBlur.useDefault,
  decimalPlacesShownOnFocus: T.options.decimalPlacesShownOnFocus.useDefault,
  defaultValueOverride: T.options.defaultValueOverride.doNotOverride,
  digitalGroupSpacing: T.options.digitalGroupSpacing.three,
  digitGroupSeparator: T.options.digitGroupSeparator.comma,
  divisorWhenUnfocused: T.options.divisorWhenUnfocused.none,
  emptyInputBehavior: T.options.emptyInputBehavior.focus,
  eventBubbles: T.options.eventBubbles.bubbles,
  eventIsCancelable: T.options.eventIsCancelable.isCancelable,
  failOnUnknownOption: T.options.failOnUnknownOption.ignore,
  formatOnPageLoad: T.options.formatOnPageLoad.format,
  formulaMode: T.options.formulaMode.disabled,
  historySize: T.options.historySize.medium,
  invalidClass: T.options.invalidClass,
  isCancellable: T.options.isCancellable.cancellable,
  leadingZero: T.options.leadingZero.deny,
  maximumValue: T.options.maximumValue.tenTrillions,
  minimumValue: T.options.minimumValue.tenTrillions,
  modifyValueOnUpDownArrow: T.options.modifyValueOnUpDownArrow.modifyValue,
  modifyValueOnWheel: T.options.modifyValueOnWheel.modifyValue,
  negativeBracketsTypeOnBlur: T.options.negativeBracketsTypeOnBlur.none,
  negativePositiveSignPlacement: T.options.negativePositiveSignPlacement.none,
  negativeSignCharacter: T.options.negativeSignCharacter.hyphen,
  negativePositiveSignBehavior: T.options.negativePositiveSignBehavior.doNotToggle,
  noEventListeners: T.options.noEventListeners.addEvents,
  //TODO Shouldn't we use `truncate` as the default value?
  onInvalidPaste: T.options.onInvalidPaste.error,
  outputFormat: T.options.outputFormat.none,
  overrideMinMaxLimits: T.options.overrideMinMaxLimits.doNotOverride,
  positiveSignCharacter: T.options.positiveSignCharacter.plus,
  rawValueDivisor: T.options.rawValueDivisor.none,
  readOnly: T.options.readOnly.readWrite,
  roundingMethod: T.options.roundingMethod.halfUpSymmetric,
  saveValueToSessionStorage: T.options.saveValueToSessionStorage.doNotSave,
  selectNumberOnly: T.options.selectNumberOnly.selectNumbersOnly,
  selectOnFocus: T.options.selectOnFocus.select,
  serializeSpaces: T.options.serializeSpaces.plus,
  showOnlyNumbersOnFocus: T.options.showOnlyNumbersOnFocus.showAll,
  showPositiveSign: T.options.showPositiveSign.hide,
  showWarnings: T.options.showWarnings.show,
  styleRules: T.options.styleRules.none,
  suffixText: T.options.suffixText.none,
  symbolWhenUnfocused: T.options.symbolWhenUnfocused.none,
  unformatOnHover: T.options.unformatOnHover.unformat,
  unformatOnSubmit: T.options.unformatOnSubmit.keepCurrentValue,
  upDownStep: "1",
  // To mimic the behavior of 'numeric'-typed input
  valuesToStrings: T.options.valuesToStrings.none,
  watchExternalChanges: T.options.watchExternalChanges.doNotWatch,
  wheelOn: T.options.wheelOn.focus,
  wheelStep: T.options.wheelStep.progressive
};
Object.freeze(T.defaultSettings);
Object.defineProperty(T, "defaultSettings", { configurable: !1, writable: !1 });
const C0 = {
  // Français
  digitGroupSeparator: T.options.digitGroupSeparator.dot,
  // or '\u202f'
  decimalCharacter: T.options.decimalCharacter.comma,
  decimalCharacterAlternative: T.options.decimalCharacterAlternative.dot,
  currencySymbol: " €",
  currencySymbolPlacement: T.options.currencySymbolPlacement.suffix,
  negativePositiveSignPlacement: T.options.negativePositiveSignPlacement.prefix
}, U0 = {
  digitGroupSeparator: T.options.digitGroupSeparator.comma,
  decimalCharacter: T.options.decimalCharacter.dot,
  currencySymbol: T.options.currencySymbol.dollar,
  currencySymbolPlacement: T.options.currencySymbolPlacement.prefix,
  negativePositiveSignPlacement: T.options.negativePositiveSignPlacement.right
}, Ie = {
  // 日本語
  digitGroupSeparator: T.options.digitGroupSeparator.comma,
  decimalCharacter: T.options.decimalCharacter.dot,
  currencySymbol: T.options.currencySymbol.yen,
  currencySymbolPlacement: T.options.currencySymbolPlacement.prefix,
  negativePositiveSignPlacement: T.options.negativePositiveSignPlacement.right
}, gr = l.cloneObject(C0);
gr.formulaMode = T.options.formulaMode.enabled;
const ka = l.cloneObject(C0);
ka.minimumValue = 0;
const Ae = l.cloneObject(C0);
Ae.maximumValue = 0;
Ae.negativePositiveSignPlacement = T.options.negativePositiveSignPlacement.prefix;
const H1 = l.cloneObject(C0);
H1.digitGroupSeparator = T.options.digitGroupSeparator.normalSpace;
const Na = l.cloneObject(H1);
Na.minimumValue = 0;
const ze = l.cloneObject(H1);
ze.maximumValue = 0;
ze.negativePositiveSignPlacement = T.options.negativePositiveSignPlacement.prefix;
const N0 = l.cloneObject(C0);
N0.currencySymbol = T.options.currencySymbol.none;
N0.suffixText = ` ${T.options.suffixText.percentage}`;
N0.wheelStep = 1e-4;
N0.rawValueDivisor = T.options.rawValueDivisor.percentage;
const xe = l.cloneObject(N0);
xe.minimumValue = 0;
const L1 = l.cloneObject(N0);
L1.maximumValue = 0;
L1.negativePositiveSignPlacement = T.options.negativePositiveSignPlacement.prefix;
const Ga = l.cloneObject(N0);
Ga.decimalPlaces = 3;
const Ia = l.cloneObject(xe);
Ia.decimalPlaces = 3;
const Fa = l.cloneObject(L1);
Fa.decimalPlaces = 3;
const vr = l.cloneObject(U0);
vr.formulaMode = T.options.formulaMode.enabled;
const Da = l.cloneObject(U0);
Da.minimumValue = 0;
const k1 = l.cloneObject(U0);
k1.maximumValue = 0;
k1.negativePositiveSignPlacement = T.options.negativePositiveSignPlacement.prefix;
const Ra = l.cloneObject(k1);
Ra.negativeBracketsTypeOnBlur = T.options.negativeBracketsTypeOnBlur.parentheses;
const G0 = l.cloneObject(U0);
G0.currencySymbol = T.options.currencySymbol.none;
G0.suffixText = T.options.suffixText.percentage;
G0.wheelStep = 1e-4;
G0.rawValueDivisor = T.options.rawValueDivisor.percentage;
const Pe = l.cloneObject(G0);
Pe.minimumValue = 0;
const N1 = l.cloneObject(G0);
N1.maximumValue = 0;
N1.negativePositiveSignPlacement = T.options.negativePositiveSignPlacement.prefix;
const Ba = l.cloneObject(G0);
Ba.decimalPlaces = 3;
const $a = l.cloneObject(Pe);
$a.decimalPlaces = 3;
const ja = l.cloneObject(N1);
ja.decimalPlaces = 3;
const Wa = l.cloneObject(C0);
Wa.currencySymbol = T.options.currencySymbol.lira;
T.predefinedOptions = {
  euro: C0,
  euroPos: ka,
  euroNeg: Ae,
  euroSpace: H1,
  euroSpacePos: Na,
  euroSpaceNeg: ze,
  percentageEU2dec: N0,
  percentageEU2decPos: xe,
  percentageEU2decNeg: L1,
  percentageEU3dec: Ga,
  percentageEU3decPos: Ia,
  percentageEU3decNeg: Fa,
  dollar: U0,
  dollarPos: Da,
  dollarNeg: k1,
  dollarNegBrackets: Ra,
  percentageUS2dec: G0,
  percentageUS2decPos: Pe,
  percentageUS2decNeg: N1,
  percentageUS3dec: Ba,
  percentageUS3decPos: $a,
  percentageUS3decNeg: ja,
  French: C0,
  // Français
  Spanish: C0,
  // Español
  NorthAmerican: U0,
  British: {
    digitGroupSeparator: T.options.digitGroupSeparator.comma,
    decimalCharacter: T.options.decimalCharacter.dot,
    currencySymbol: T.options.currencySymbol.pound,
    currencySymbolPlacement: T.options.currencySymbolPlacement.prefix,
    negativePositiveSignPlacement: T.options.negativePositiveSignPlacement.right
  },
  Swiss: {
    // Suisse
    digitGroupSeparator: T.options.digitGroupSeparator.apostrophe,
    decimalCharacter: T.options.decimalCharacter.dot,
    currencySymbol: " CHF",
    currencySymbolPlacement: T.options.currencySymbolPlacement.suffix,
    negativePositiveSignPlacement: T.options.negativePositiveSignPlacement.prefix
  },
  Japanese: Ie,
  // 日本語
  Chinese: Ie,
  // 中国語 (Chinese)
  Brazilian: {
    digitGroupSeparator: T.options.digitGroupSeparator.dot,
    decimalCharacter: T.options.decimalCharacter.comma,
    currencySymbol: T.options.currencySymbol.real,
    currencySymbolPlacement: T.options.currencySymbolPlacement.prefix,
    negativePositiveSignPlacement: T.options.negativePositiveSignPlacement.right
  },
  Turkish: Wa,
  dotDecimalCharCommaSeparator: {
    digitGroupSeparator: T.options.digitGroupSeparator.comma,
    decimalCharacter: T.options.decimalCharacter.dot
  },
  commaDecimalCharDotSeparator: {
    digitGroupSeparator: T.options.digitGroupSeparator.dot,
    decimalCharacter: T.options.decimalCharacter.comma,
    decimalCharacterAlternative: T.options.decimalCharacterAlternative.dot
  },
  integer: {
    decimalPlaces: 0
  },
  integerPos: {
    minimumValue: T.options.minimumValue.zero,
    decimalPlaces: 0
  },
  integerNeg: {
    maximumValue: T.options.maximumValue.zero,
    decimalPlaces: 0
  },
  float: {
    allowDecimalPadding: T.options.allowDecimalPadding.never
  },
  floatPos: {
    allowDecimalPadding: T.options.allowDecimalPadding.never,
    minimumValue: T.options.minimumValue.zero,
    maximumValue: T.options.maximumValue.tenTrillions
  },
  floatNeg: {
    allowDecimalPadding: T.options.allowDecimalPadding.never,
    minimumValue: T.options.minimumValue.tenTrillions,
    maximumValue: T.options.maximumValue.zero
  },
  numeric: {
    digitGroupSeparator: T.options.digitGroupSeparator.noSeparator,
    decimalCharacter: T.options.decimalCharacter.dot,
    currencySymbol: T.options.currencySymbol.none
  },
  numericPos: {
    digitGroupSeparator: T.options.digitGroupSeparator.noSeparator,
    decimalCharacter: T.options.decimalCharacter.dot,
    currencySymbol: T.options.currencySymbol.none,
    minimumValue: T.options.minimumValue.zero,
    maximumValue: T.options.maximumValue.tenTrillions
  },
  numericNeg: {
    digitGroupSeparator: T.options.digitGroupSeparator.noSeparator,
    decimalCharacter: T.options.decimalCharacter.dot,
    currencySymbol: T.options.currencySymbol.none,
    minimumValue: T.options.minimumValue.tenTrillions,
    maximumValue: T.options.maximumValue.zero
  }
};
Object.getOwnPropertyNames(T.predefinedOptions).forEach((t) => {
  Object.freeze(T.predefinedOptions[t]);
});
Object.freeze(T.predefinedOptions);
Object.defineProperty(T, "predefinedOptions", { configurable: !1, writable: !1 });
const o6 = ({
  currencySymbol: t = "$",
  textAlign: e = "right",
  value: a,
  outputFormat: i = "number",
  preDefined: n,
  InputProps: o,
  ...d
}) => {
  const s = W0(null), c = W0();
  F0(() => (s.current && (c.current = new T(s.current, a, {
    ...n,
    ...d,
    watchExternalChanges: !1
  })), () => {
    var p;
    (p = c.current) == null || p.remove();
  }), [a, n, d]), F0(() => {
    c.current && c.current.set(a);
  }, [a]);
  const m = He(() => c.current ? {
    string: (b) => b.getNumericString(),
    number: (b) => b.getNumber()
  }[i](c.current) : void 0, [i]), f = He(
    (p, b) => {
      const y = d[b];
      y && y(p, m());
    },
    [m, d]
  );
  return /* @__PURE__ */ r(
    wa,
    {
      sx: { textAlign: e || "right" },
      inputRef: s,
      onChange: (p) => f(p, "onChange"),
      onKeyUp: (p) => f(p, "onKeyUp"),
      onKeyDown: (p) => f(p, "onKeyDown"),
      InputProps: {
        startAdornment: /* @__PURE__ */ r(
          de,
          {
            sx: {
              ".MuiTypography-root": {
                color: "typography.main"
              }
            },
            position: "start",
            children: t
          }
        ),
        ...o
      },
      ...d
    }
  );
};
function Ua(t, e) {
  if (t == null) return {};
  var a = {};
  for (var i in t) if ({}.hasOwnProperty.call(t, i)) {
    if (e.includes(i)) continue;
    a[i] = t[i];
  }
  return a;
}
var ce = { exports: {} }, m1 = { exports: {} }, c0 = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Fe;
function br() {
  if (Fe) return c0;
  Fe = 1;
  var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, a = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, n = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, d = t ? Symbol.for("react.provider") : 60109, s = t ? Symbol.for("react.context") : 60110, c = t ? Symbol.for("react.async_mode") : 60111, m = t ? Symbol.for("react.concurrent_mode") : 60111, f = t ? Symbol.for("react.forward_ref") : 60112, p = t ? Symbol.for("react.suspense") : 60113, b = t ? Symbol.for("react.suspense_list") : 60120, y = t ? Symbol.for("react.memo") : 60115, v = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, _ = t ? Symbol.for("react.fundamental") : 60117, M = t ? Symbol.for("react.responder") : 60118, S = t ? Symbol.for("react.scope") : 60119;
  function O(z) {
    if (typeof z == "object" && z !== null) {
      var $ = z.$$typeof;
      switch ($) {
        case e:
          switch (z = z.type, z) {
            case c:
            case m:
            case i:
            case o:
            case n:
            case p:
              return z;
            default:
              switch (z = z && z.$$typeof, z) {
                case s:
                case f:
                case v:
                case y:
                case d:
                  return z;
                default:
                  return $;
              }
          }
        case a:
          return $;
      }
    }
  }
  function I(z) {
    return O(z) === m;
  }
  return c0.AsyncMode = c, c0.ConcurrentMode = m, c0.ContextConsumer = s, c0.ContextProvider = d, c0.Element = e, c0.ForwardRef = f, c0.Fragment = i, c0.Lazy = v, c0.Memo = y, c0.Portal = a, c0.Profiler = o, c0.StrictMode = n, c0.Suspense = p, c0.isAsyncMode = function(z) {
    return I(z) || O(z) === c;
  }, c0.isConcurrentMode = I, c0.isContextConsumer = function(z) {
    return O(z) === s;
  }, c0.isContextProvider = function(z) {
    return O(z) === d;
  }, c0.isElement = function(z) {
    return typeof z == "object" && z !== null && z.$$typeof === e;
  }, c0.isForwardRef = function(z) {
    return O(z) === f;
  }, c0.isFragment = function(z) {
    return O(z) === i;
  }, c0.isLazy = function(z) {
    return O(z) === v;
  }, c0.isMemo = function(z) {
    return O(z) === y;
  }, c0.isPortal = function(z) {
    return O(z) === a;
  }, c0.isProfiler = function(z) {
    return O(z) === o;
  }, c0.isStrictMode = function(z) {
    return O(z) === n;
  }, c0.isSuspense = function(z) {
    return O(z) === p;
  }, c0.isValidElementType = function(z) {
    return typeof z == "string" || typeof z == "function" || z === i || z === m || z === o || z === n || z === p || z === b || typeof z == "object" && z !== null && (z.$$typeof === v || z.$$typeof === y || z.$$typeof === d || z.$$typeof === s || z.$$typeof === f || z.$$typeof === _ || z.$$typeof === M || z.$$typeof === S || z.$$typeof === g);
  }, c0.typeOf = O, c0;
}
var u0 = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var De;
function yr() {
  return De || (De = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, a = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, n = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, d = t ? Symbol.for("react.provider") : 60109, s = t ? Symbol.for("react.context") : 60110, c = t ? Symbol.for("react.async_mode") : 60111, m = t ? Symbol.for("react.concurrent_mode") : 60111, f = t ? Symbol.for("react.forward_ref") : 60112, p = t ? Symbol.for("react.suspense") : 60113, b = t ? Symbol.for("react.suspense_list") : 60120, y = t ? Symbol.for("react.memo") : 60115, v = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, _ = t ? Symbol.for("react.fundamental") : 60117, M = t ? Symbol.for("react.responder") : 60118, S = t ? Symbol.for("react.scope") : 60119;
    function O(G) {
      return typeof G == "string" || typeof G == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      G === i || G === m || G === o || G === n || G === p || G === b || typeof G == "object" && G !== null && (G.$$typeof === v || G.$$typeof === y || G.$$typeof === d || G.$$typeof === s || G.$$typeof === f || G.$$typeof === _ || G.$$typeof === M || G.$$typeof === S || G.$$typeof === g);
    }
    function I(G) {
      if (typeof G == "object" && G !== null) {
        var m0 = G.$$typeof;
        switch (m0) {
          case e:
            var A0 = G.type;
            switch (A0) {
              case c:
              case m:
              case i:
              case o:
              case n:
              case p:
                return A0;
              default:
                var V0 = A0 && A0.$$typeof;
                switch (V0) {
                  case s:
                  case f:
                  case v:
                  case y:
                  case d:
                    return V0;
                  default:
                    return m0;
                }
            }
          case a:
            return m0;
        }
      }
    }
    var z = c, $ = m, Q = s, i0 = d, N = e, Z = f, k = i, F = v, U = y, C = a, P = o, x = n, w = p, L = !1;
    function j(G) {
      return L || (L = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), A(G) || I(G) === c;
    }
    function A(G) {
      return I(G) === m;
    }
    function E(G) {
      return I(G) === s;
    }
    function q(G) {
      return I(G) === d;
    }
    function W(G) {
      return typeof G == "object" && G !== null && G.$$typeof === e;
    }
    function Y(G) {
      return I(G) === f;
    }
    function X(G) {
      return I(G) === i;
    }
    function e0(G) {
      return I(G) === v;
    }
    function J(G) {
      return I(G) === y;
    }
    function t0(G) {
      return I(G) === a;
    }
    function D(G) {
      return I(G) === o;
    }
    function K(G) {
      return I(G) === n;
    }
    function n0(G) {
      return I(G) === p;
    }
    u0.AsyncMode = z, u0.ConcurrentMode = $, u0.ContextConsumer = Q, u0.ContextProvider = i0, u0.Element = N, u0.ForwardRef = Z, u0.Fragment = k, u0.Lazy = F, u0.Memo = U, u0.Portal = C, u0.Profiler = P, u0.StrictMode = x, u0.Suspense = w, u0.isAsyncMode = j, u0.isConcurrentMode = A, u0.isContextConsumer = E, u0.isContextProvider = q, u0.isElement = W, u0.isForwardRef = Y, u0.isFragment = X, u0.isLazy = e0, u0.isMemo = J, u0.isPortal = t0, u0.isProfiler = D, u0.isStrictMode = K, u0.isSuspense = n0, u0.isValidElementType = O, u0.typeOf = I;
  }()), u0;
}
var Re;
function qa() {
  return Re || (Re = 1, process.env.NODE_ENV === "production" ? m1.exports = br() : m1.exports = yr()), m1.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var W1, Be;
function _r() {
  if (Be) return W1;
  Be = 1;
  var t = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, a = Object.prototype.propertyIsEnumerable;
  function i(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function n() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var d = {}, s = 0; s < 10; s++)
        d["_" + String.fromCharCode(s)] = s;
      var c = Object.getOwnPropertyNames(d).map(function(f) {
        return d[f];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var m = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(f) {
        m[f] = f;
      }), Object.keys(Object.assign({}, m)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return W1 = n() ? Object.assign : function(o, d) {
    for (var s, c = i(o), m, f = 1; f < arguments.length; f++) {
      s = Object(arguments[f]);
      for (var p in s)
        e.call(s, p) && (c[p] = s[p]);
      if (t) {
        m = t(s);
        for (var b = 0; b < m.length; b++)
          a.call(s, m[b]) && (c[m[b]] = s[m[b]]);
      }
    }
    return c;
  }, W1;
}
var U1, $e;
function Ze() {
  if ($e) return U1;
  $e = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return U1 = t, U1;
}
var q1, je;
function Ya() {
  return je || (je = 1, q1 = Function.call.bind(Object.prototype.hasOwnProperty)), q1;
}
var Y1, We;
function wr() {
  if (We) return Y1;
  We = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = Ze(), a = {}, i = Ya();
    t = function(o) {
      var d = "Warning: " + o;
      typeof console < "u" && console.error(d);
      try {
        throw new Error(d);
      } catch {
      }
    };
  }
  function n(o, d, s, c, m) {
    if (process.env.NODE_ENV !== "production") {
      for (var f in o)
        if (i(o, f)) {
          var p;
          try {
            if (typeof o[f] != "function") {
              var b = Error(
                (c || "React class") + ": " + s + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw b.name = "Invariant Violation", b;
            }
            p = o[f](d, f, c, s, null, e);
          } catch (v) {
            p = v;
          }
          if (p && !(p instanceof Error) && t(
            (c || "React class") + ": type specification of " + s + " `" + f + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof p + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), p instanceof Error && !(p.message in a)) {
            a[p.message] = !0;
            var y = m ? m() : "";
            t(
              "Failed " + s + " type: " + p.message + (y ?? "")
            );
          }
        }
    }
  }
  return n.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (a = {});
  }, Y1 = n, Y1;
}
var K1, Ue;
function Tr() {
  if (Ue) return K1;
  Ue = 1;
  var t = qa(), e = _r(), a = Ze(), i = Ya(), n = wr(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(s) {
    var c = "Warning: " + s;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function d() {
    return null;
  }
  return K1 = function(s, c) {
    var m = typeof Symbol == "function" && Symbol.iterator, f = "@@iterator";
    function p(A) {
      var E = A && (m && A[m] || A[f]);
      if (typeof E == "function")
        return E;
    }
    var b = "<<anonymous>>", y = {
      array: M("array"),
      bigint: M("bigint"),
      bool: M("boolean"),
      func: M("function"),
      number: M("number"),
      object: M("object"),
      string: M("string"),
      symbol: M("symbol"),
      any: S(),
      arrayOf: O,
      element: I(),
      elementType: z(),
      instanceOf: $,
      node: Z(),
      objectOf: i0,
      oneOf: Q,
      oneOfType: N,
      shape: F,
      exact: U
    };
    function v(A, E) {
      return A === E ? A !== 0 || 1 / A === 1 / E : A !== A && E !== E;
    }
    function g(A, E) {
      this.message = A, this.data = E && typeof E == "object" ? E : {}, this.stack = "";
    }
    g.prototype = Error.prototype;
    function _(A) {
      if (process.env.NODE_ENV !== "production")
        var E = {}, q = 0;
      function W(X, e0, J, t0, D, K, n0) {
        if (t0 = t0 || b, K = K || J, n0 !== a) {
          if (c) {
            var G = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw G.name = "Invariant Violation", G;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var m0 = t0 + ":" + J;
            !E[m0] && // Avoid spamming the console because they are often not actionable except for lib authors
            q < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + K + "` prop on `" + t0 + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), E[m0] = !0, q++);
          }
        }
        return e0[J] == null ? X ? e0[J] === null ? new g("The " + D + " `" + K + "` is marked as required " + ("in `" + t0 + "`, but its value is `null`.")) : new g("The " + D + " `" + K + "` is marked as required in " + ("`" + t0 + "`, but its value is `undefined`.")) : null : A(e0, J, t0, D, K);
      }
      var Y = W.bind(null, !1);
      return Y.isRequired = W.bind(null, !0), Y;
    }
    function M(A) {
      function E(q, W, Y, X, e0, J) {
        var t0 = q[W], D = x(t0);
        if (D !== A) {
          var K = w(t0);
          return new g(
            "Invalid " + X + " `" + e0 + "` of type " + ("`" + K + "` supplied to `" + Y + "`, expected ") + ("`" + A + "`."),
            { expectedType: A }
          );
        }
        return null;
      }
      return _(E);
    }
    function S() {
      return _(d);
    }
    function O(A) {
      function E(q, W, Y, X, e0) {
        if (typeof A != "function")
          return new g("Property `" + e0 + "` of component `" + Y + "` has invalid PropType notation inside arrayOf.");
        var J = q[W];
        if (!Array.isArray(J)) {
          var t0 = x(J);
          return new g("Invalid " + X + " `" + e0 + "` of type " + ("`" + t0 + "` supplied to `" + Y + "`, expected an array."));
        }
        for (var D = 0; D < J.length; D++) {
          var K = A(J, D, Y, X, e0 + "[" + D + "]", a);
          if (K instanceof Error)
            return K;
        }
        return null;
      }
      return _(E);
    }
    function I() {
      function A(E, q, W, Y, X) {
        var e0 = E[q];
        if (!s(e0)) {
          var J = x(e0);
          return new g("Invalid " + Y + " `" + X + "` of type " + ("`" + J + "` supplied to `" + W + "`, expected a single ReactElement."));
        }
        return null;
      }
      return _(A);
    }
    function z() {
      function A(E, q, W, Y, X) {
        var e0 = E[q];
        if (!t.isValidElementType(e0)) {
          var J = x(e0);
          return new g("Invalid " + Y + " `" + X + "` of type " + ("`" + J + "` supplied to `" + W + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return _(A);
    }
    function $(A) {
      function E(q, W, Y, X, e0) {
        if (!(q[W] instanceof A)) {
          var J = A.name || b, t0 = j(q[W]);
          return new g("Invalid " + X + " `" + e0 + "` of type " + ("`" + t0 + "` supplied to `" + Y + "`, expected ") + ("instance of `" + J + "`."));
        }
        return null;
      }
      return _(E);
    }
    function Q(A) {
      if (!Array.isArray(A))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), d;
      function E(q, W, Y, X, e0) {
        for (var J = q[W], t0 = 0; t0 < A.length; t0++)
          if (v(J, A[t0]))
            return null;
        var D = JSON.stringify(A, function(n0, G) {
          var m0 = w(G);
          return m0 === "symbol" ? String(G) : G;
        });
        return new g("Invalid " + X + " `" + e0 + "` of value `" + String(J) + "` " + ("supplied to `" + Y + "`, expected one of " + D + "."));
      }
      return _(E);
    }
    function i0(A) {
      function E(q, W, Y, X, e0) {
        if (typeof A != "function")
          return new g("Property `" + e0 + "` of component `" + Y + "` has invalid PropType notation inside objectOf.");
        var J = q[W], t0 = x(J);
        if (t0 !== "object")
          return new g("Invalid " + X + " `" + e0 + "` of type " + ("`" + t0 + "` supplied to `" + Y + "`, expected an object."));
        for (var D in J)
          if (i(J, D)) {
            var K = A(J, D, Y, X, e0 + "." + D, a);
            if (K instanceof Error)
              return K;
          }
        return null;
      }
      return _(E);
    }
    function N(A) {
      if (!Array.isArray(A))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), d;
      for (var E = 0; E < A.length; E++) {
        var q = A[E];
        if (typeof q != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + L(q) + " at index " + E + "."
          ), d;
      }
      function W(Y, X, e0, J, t0) {
        for (var D = [], K = 0; K < A.length; K++) {
          var n0 = A[K], G = n0(Y, X, e0, J, t0, a);
          if (G == null)
            return null;
          G.data && i(G.data, "expectedType") && D.push(G.data.expectedType);
        }
        var m0 = D.length > 0 ? ", expected one of type [" + D.join(", ") + "]" : "";
        return new g("Invalid " + J + " `" + t0 + "` supplied to " + ("`" + e0 + "`" + m0 + "."));
      }
      return _(W);
    }
    function Z() {
      function A(E, q, W, Y, X) {
        return C(E[q]) ? null : new g("Invalid " + Y + " `" + X + "` supplied to " + ("`" + W + "`, expected a ReactNode."));
      }
      return _(A);
    }
    function k(A, E, q, W, Y) {
      return new g(
        (A || "React class") + ": " + E + " type `" + q + "." + W + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + Y + "`."
      );
    }
    function F(A) {
      function E(q, W, Y, X, e0) {
        var J = q[W], t0 = x(J);
        if (t0 !== "object")
          return new g("Invalid " + X + " `" + e0 + "` of type `" + t0 + "` " + ("supplied to `" + Y + "`, expected `object`."));
        for (var D in A) {
          var K = A[D];
          if (typeof K != "function")
            return k(Y, X, e0, D, w(K));
          var n0 = K(J, D, Y, X, e0 + "." + D, a);
          if (n0)
            return n0;
        }
        return null;
      }
      return _(E);
    }
    function U(A) {
      function E(q, W, Y, X, e0) {
        var J = q[W], t0 = x(J);
        if (t0 !== "object")
          return new g("Invalid " + X + " `" + e0 + "` of type `" + t0 + "` " + ("supplied to `" + Y + "`, expected `object`."));
        var D = e({}, q[W], A);
        for (var K in D) {
          var n0 = A[K];
          if (i(A, K) && typeof n0 != "function")
            return k(Y, X, e0, K, w(n0));
          if (!n0)
            return new g(
              "Invalid " + X + " `" + e0 + "` key `" + K + "` supplied to `" + Y + "`.\nBad object: " + JSON.stringify(q[W], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(A), null, "  ")
            );
          var G = n0(J, K, Y, X, e0 + "." + K, a);
          if (G)
            return G;
        }
        return null;
      }
      return _(E);
    }
    function C(A) {
      switch (typeof A) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !A;
        case "object":
          if (Array.isArray(A))
            return A.every(C);
          if (A === null || s(A))
            return !0;
          var E = p(A);
          if (E) {
            var q = E.call(A), W;
            if (E !== A.entries) {
              for (; !(W = q.next()).done; )
                if (!C(W.value))
                  return !1;
            } else
              for (; !(W = q.next()).done; ) {
                var Y = W.value;
                if (Y && !C(Y[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function P(A, E) {
      return A === "symbol" ? !0 : E ? E["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && E instanceof Symbol : !1;
    }
    function x(A) {
      var E = typeof A;
      return Array.isArray(A) ? "array" : A instanceof RegExp ? "object" : P(E, A) ? "symbol" : E;
    }
    function w(A) {
      if (typeof A > "u" || A === null)
        return "" + A;
      var E = x(A);
      if (E === "object") {
        if (A instanceof Date)
          return "date";
        if (A instanceof RegExp)
          return "regexp";
      }
      return E;
    }
    function L(A) {
      var E = w(A);
      switch (E) {
        case "array":
        case "object":
          return "an " + E;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + E;
        default:
          return E;
      }
    }
    function j(A) {
      return !A.constructor || !A.constructor.name ? b : A.constructor.name;
    }
    return y.checkPropTypes = n, y.resetWarningCache = n.resetWarningCache, y.PropTypes = y, y;
  }, K1;
}
var X1, qe;
function Sr() {
  if (qe) return X1;
  qe = 1;
  var t = Ze();
  function e() {
  }
  function a() {
  }
  return a.resetWarningCache = e, X1 = function() {
    function i(d, s, c, m, f, p) {
      if (p !== t) {
        var b = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw b.name = "Invariant Violation", b;
      }
    }
    i.isRequired = i;
    function n() {
      return i;
    }
    var o = {
      array: i,
      bigint: i,
      bool: i,
      func: i,
      number: i,
      object: i,
      string: i,
      symbol: i,
      any: i,
      arrayOf: n,
      element: i,
      elementType: i,
      instanceOf: n,
      node: i,
      objectOf: n,
      oneOf: n,
      oneOfType: n,
      shape: n,
      exact: n,
      checkPropTypes: a,
      resetWarningCache: e
    };
    return o.PropTypes = o, o;
  }, X1;
}
if (process.env.NODE_ENV !== "production") {
  var Mr = qa(), Ar = !0;
  ce.exports = Tr()(Mr.isElement, Ar);
} else
  ce.exports = Sr()();
var zr = ce.exports;
const r0 = /* @__PURE__ */ L0(zr);
function Ka(t) {
  return typeof t == "string";
}
const xr = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
}, Xa = "base";
function Pr(t) {
  return `${Xa}--${t}`;
}
function Zr(t, e) {
  return `${Xa}-${t}-${e}`;
}
function Qa(t, e) {
  const a = xr[e];
  return a ? Pr(a) : Zr(t, e);
}
function Cr(t, e) {
  const a = {};
  return e.forEach((i) => {
    a[i] = Qa(t, i);
  }), a;
}
const Ja = "Input";
function Vr(t) {
  return Qa(Ja, t);
}
Cr(Ja, ["root", "formControl", "focused", "disabled", "error", "multiline", "input", "inputMultiline", "inputTypeSearch", "adornedStart", "adornedEnd"]);
function Or(t) {
  let e = "https://mui.com/production-error/?code=" + t;
  for (let a = 1; a < arguments.length; a += 1)
    e += "&args[]=" + encodeURIComponent(arguments[a]);
  return "Minified MUI error #" + t + "; visit " + e + " for the full message.";
}
function Er(t, e) {
  typeof t == "function" ? t(e) : t && (t.current = e);
}
function et(...t) {
  return M0.useMemo(() => t.every((e) => e == null) ? null : (e) => {
    t.forEach((a) => {
      Er(a, e);
    });
  }, t);
}
function Hr(t, e, a = void 0) {
  const i = {};
  return Object.keys(t).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (n) => {
      i[n] = t[n].reduce((o, d) => {
        if (d) {
          const s = e(d);
          s !== "" && o.push(s), a && a[d] && o.push(a[d]);
        }
        return o;
      }, []).join(" ");
    }
  ), i;
}
function at(t) {
  var e, a, i = "";
  if (typeof t == "string" || typeof t == "number") i += t;
  else if (typeof t == "object") if (Array.isArray(t)) {
    var n = t.length;
    for (e = 0; e < n; e++) t[e] && (a = at(t[e])) && (i && (i += " "), i += a);
  } else for (a in t) t[a] && (i && (i += " "), i += a);
  return i;
}
function Ye() {
  for (var t, e, a = 0, i = "", n = arguments.length; a < n; a++) (t = arguments[a]) && (e = at(t)) && (i && (i += " "), i += e);
  return i;
}
const tt = /* @__PURE__ */ M0.createContext(void 0);
process.env.NODE_ENV !== "production" && (tt.displayName = "FormControlContext");
function Lr(t, e, a) {
  return t === void 0 || Ka(t) ? e : g0({}, e, {
    ownerState: g0({}, e.ownerState, a)
  });
}
const kr = {
  disableDefaultClasses: !1
}, rt = /* @__PURE__ */ M0.createContext(kr);
process.env.NODE_ENV !== "production" && (rt.displayName = "ClassNameConfiguratorContext");
function Nr(t) {
  const {
    disableDefaultClasses: e
  } = M0.useContext(rt);
  return (a) => e ? "" : t(a);
}
function p1(t, e = []) {
  if (t === void 0)
    return {};
  const a = {};
  return Object.keys(t).filter((i) => i.match(/^on[A-Z]/) && typeof t[i] == "function" && !e.includes(i)).forEach((i) => {
    a[i] = t[i];
  }), a;
}
function Gr(t, e, a) {
  return typeof t == "function" ? t(e, a) : t;
}
function Ke(t) {
  if (t === void 0)
    return {};
  const e = {};
  return Object.keys(t).filter((a) => !(a.match(/^on[A-Z]/) && typeof t[a] == "function")).forEach((a) => {
    e[a] = t[a];
  }), e;
}
function Ir(t) {
  const {
    getSlotProps: e,
    additionalProps: a,
    externalSlotProps: i,
    externalForwardedProps: n,
    className: o
  } = t;
  if (!e) {
    const y = Ye(a == null ? void 0 : a.className, o, n == null ? void 0 : n.className, i == null ? void 0 : i.className), v = g0({}, a == null ? void 0 : a.style, n == null ? void 0 : n.style, i == null ? void 0 : i.style), g = g0({}, a, n, i);
    return y.length > 0 && (g.className = y), Object.keys(v).length > 0 && (g.style = v), {
      props: g,
      internalRef: void 0
    };
  }
  const d = p1(g0({}, n, i)), s = Ke(i), c = Ke(n), m = e(d), f = Ye(m == null ? void 0 : m.className, a == null ? void 0 : a.className, o, n == null ? void 0 : n.className, i == null ? void 0 : i.className), p = g0({}, m == null ? void 0 : m.style, a == null ? void 0 : a.style, n == null ? void 0 : n.style, i == null ? void 0 : i.style), b = g0({}, m, a, c, s);
  return f.length > 0 && (b.className = f), Object.keys(p).length > 0 && (b.style = p), {
    props: b,
    internalRef: m.ref
  };
}
const Fr = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
function Xe(t) {
  var e;
  const {
    elementType: a,
    externalSlotProps: i,
    ownerState: n,
    skipResolvingSlotProps: o = !1
  } = t, d = Ua(t, Fr), s = o ? {} : Gr(i, n), {
    props: c,
    internalRef: m
  } = Ir(g0({}, d, {
    externalSlotProps: s
  })), f = et(m, s == null ? void 0 : s.ref, (e = t.additionalProps) == null ? void 0 : e.ref);
  return Lr(a, g0({}, c, {
    ref: f
  }), n);
}
function Dr() {
  return M0.useContext(tt);
}
function Rr(t = {}) {
  const {
    defaultValue: e,
    disabled: a = !1,
    error: i = !1,
    onBlur: n,
    onChange: o,
    onFocus: d,
    required: s = !1,
    value: c,
    inputRef: m
  } = t, f = Dr();
  let p, b, y, v, g;
  if (f) {
    var _, M, S;
    if (p = void 0, b = (_ = f.disabled) != null ? _ : !1, y = (M = f.error) != null ? M : !1, v = (S = f.required) != null ? S : !1, g = f.value, process.env.NODE_ENV !== "production") {
      const P = ["defaultValue", "disabled", "error", "required", "value"].filter((x) => t[x] !== void 0);
      P.length > 0 && console.warn(["MUI: You have set props on an input that is inside a FormControl.", "Set these props on a FormControl instead. Otherwise they will be ignored.", `Ignored props: ${P.join(", ")}`].join(`
`));
    }
  } else
    p = e, b = a, y = i, v = s, g = c;
  const {
    current: O
  } = M0.useRef(g != null), I = M0.useCallback((P) => {
    process.env.NODE_ENV !== "production" && P && P.nodeName !== "INPUT" && !P.focus && console.error(["MUI: You have provided a `slots.input` to the input component", "that does not correctly handle the `ref` prop.", "Make sure the `ref` prop is called with a HTMLInputElement."].join(`
`));
  }, []), z = M0.useRef(null), $ = et(z, m, I), [Q, i0] = M0.useState(!1);
  M0.useEffect(() => {
    !f && b && Q && (i0(!1), n == null || n());
  }, [f, b, Q, n]);
  const N = (P) => (x) => {
    var w;
    if (f != null && f.disabled) {
      x.stopPropagation();
      return;
    }
    if ((w = P.onFocus) == null || w.call(P, x), f && f.onFocus) {
      var L;
      f == null || (L = f.onFocus) == null || L.call(f);
    } else
      i0(!0);
  }, Z = (P) => (x) => {
    var w;
    (w = P.onBlur) == null || w.call(P, x), f && f.onBlur ? f.onBlur() : i0(!1);
  }, k = (P) => (x, ...w) => {
    var L, j;
    if (!O && (x.target || z.current) == null)
      throw new Error(process.env.NODE_ENV !== "production" ? "MUI: Expected valid input target. Did you use a custom `slots.input` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : Or(17));
    f == null || (L = f.onChange) == null || L.call(f, x), (j = P.onChange) == null || j.call(P, x, ...w);
  }, F = (P) => (x) => {
    var w;
    z.current && x.currentTarget === x.target && z.current.focus(), (w = P.onClick) == null || w.call(P, x);
  };
  return {
    disabled: b,
    error: y,
    focused: Q,
    formControlContext: f,
    getInputProps: (P = {}) => {
      const w = g0({}, {
        onBlur: n,
        onChange: o,
        onFocus: d
      }, p1(P)), L = g0({}, w, {
        onBlur: Z(w),
        onChange: k(w),
        onFocus: N(w)
      });
      return g0({}, L, {
        "aria-invalid": y || void 0,
        defaultValue: p,
        value: g,
        required: v,
        disabled: b
      }, P, {
        ref: $
      }, L);
    },
    getRootProps: (P = {}) => {
      const x = p1(t, ["onBlur", "onChange", "onFocus"]), w = g0({}, x, p1(P));
      return g0({}, P, w, {
        onClick: F(w)
      });
    },
    inputRef: $,
    required: v,
    value: g
  };
}
const Br = ["aria-describedby", "aria-label", "aria-labelledby", "autoComplete", "autoFocus", "className", "defaultValue", "disabled", "endAdornment", "error", "id", "multiline", "name", "onClick", "onChange", "onKeyDown", "onKeyUp", "onFocus", "onBlur", "placeholder", "readOnly", "required", "startAdornment", "value", "type", "rows", "slotProps", "slots", "minRows", "maxRows"], $r = (t) => {
  const {
    disabled: e,
    error: a,
    focused: i,
    formControlContext: n,
    multiline: o,
    startAdornment: d,
    endAdornment: s
  } = t;
  return Hr({
    root: ["root", e && "disabled", a && "error", i && "focused", !!n && "formControl", o && "multiline", !!d && "adornedStart", !!s && "adornedEnd"],
    input: ["input", e && "disabled", o && "multiline"]
  }, Nr(Vr));
}, it = /* @__PURE__ */ M0.forwardRef(function(e, a) {
  var i, n, o;
  const {
    "aria-describedby": d,
    "aria-label": s,
    "aria-labelledby": c,
    autoComplete: m,
    autoFocus: f,
    className: p,
    defaultValue: b,
    disabled: y,
    endAdornment: v,
    error: g,
    id: _,
    multiline: M = !1,
    name: S,
    onClick: O,
    onChange: I,
    onKeyDown: z,
    onKeyUp: $,
    onFocus: Q,
    onBlur: i0,
    placeholder: N,
    readOnly: Z,
    required: k,
    startAdornment: F,
    value: U,
    type: C,
    rows: P,
    slotProps: x = {},
    slots: w = {},
    minRows: L,
    maxRows: j
  } = e, A = Ua(e, Br), {
    getRootProps: E,
    getInputProps: q,
    focused: W,
    formControlContext: Y,
    error: X,
    disabled: e0
  } = Rr({
    disabled: y,
    defaultValue: b,
    error: g,
    onBlur: i0,
    onClick: O,
    onChange: I,
    onFocus: Q,
    required: k,
    value: U
  }), J = M ? void 0 : C ?? "text", t0 = g0({}, e, {
    disabled: e0,
    error: X,
    focused: W,
    formControlContext: Y,
    multiline: M,
    type: J
  }), D = $r(t0), K = {
    "aria-describedby": d,
    "aria-label": s,
    "aria-labelledby": c,
    autoComplete: m,
    autoFocus: f,
    id: _,
    onKeyDown: z,
    onKeyUp: $,
    name: S,
    placeholder: N,
    readOnly: Z,
    type: J
  }, n0 = (i = w.root) != null ? i : "div", G = Xe({
    elementType: n0,
    getSlotProps: E,
    externalSlotProps: x.root,
    externalForwardedProps: A,
    additionalProps: {
      ref: a
    },
    ownerState: t0,
    className: [D.root, p]
  }), m0 = M ? (n = w.textarea) != null ? n : "textarea" : (o = w.input) != null ? o : "input", A0 = Xe({
    elementType: m0,
    getSlotProps: (V0) => q(g0({}, K, V0)),
    externalSlotProps: x.input,
    additionalProps: g0({
      rows: M ? P : void 0
    }, M && !Ka(m0) && {
      minRows: P || L,
      maxRows: P || j
    }),
    ownerState: t0,
    className: D.input
  });
  return process.env.NODE_ENV !== "production" && M && P && (L || j) && console.warn("MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set."), /* @__PURE__ */ h(n0, g0({}, G, {
    children: [F, /* @__PURE__ */ r(m0, g0({}, A0)), v]
  }));
});
process.env.NODE_ENV !== "production" && (it.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  "aria-describedby": r0.string,
  /**
   * @ignore
   */
  "aria-label": r0.string,
  /**
   * @ignore
   */
  "aria-labelledby": r0.string,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: r0.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: r0.bool,
  /**
   * Class name applied to the root element.
   */
  className: r0.string,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: r0.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: r0.bool,
  /**
   * Trailing adornment for this input.
   */
  endAdornment: r0.node,
  /**
   * If `true`, the `input` will indicate an error by setting the `aria-invalid` attribute on the input and the `baseui--error` class on the root element.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: r0.bool,
  /**
   * The id of the `input` element.
   */
  id: r0.string,
  /**
   * @ignore
   */
  inputRef: r0.oneOfType([r0.func, r0.shape({
    current: r0.object
  })]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: r0.number,
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: r0.number,
  /**
   * If `true`, a `textarea` element is rendered.
   * @default false
   */
  multiline: r0.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: r0.string,
  /**
   * @ignore
   */
  onBlur: r0.func,
  /**
   * @ignore
   */
  onChange: r0.func,
  /**
   * @ignore
   */
  onClick: r0.func,
  /**
   * @ignore
   */
  onFocus: r0.func,
  /**
   * @ignore
   */
  onKeyDown: r0.func,
  /**
   * @ignore
   */
  onKeyUp: r0.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: r0.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: r0.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: r0.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: r0.number,
  /**
   * The props used for each slot inside the Input.
   * @default {}
   */
  slotProps: r0.shape({
    input: r0.oneOfType([r0.func, r0.object]),
    root: r0.oneOfType([r0.func, r0.object])
  }),
  /**
   * The components used for each slot inside the InputBase.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: r0.shape({
    input: r0.elementType,
    root: r0.elementType,
    textarea: r0.elementType
  }),
  /**
   * Leading adornment for this input.
   */
  startAdornment: r0.node,
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: r0.oneOf(["button", "checkbox", "color", "date", "datetime-local", "email", "file", "hidden", "image", "month", "number", "password", "radio", "range", "reset", "search", "submit", "tel", "text", "time", "url", "week"]),
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: r0.any
});
const s6 = ({
  separator: t,
  length: e,
  value: a,
  onChange: i
}) => {
  const { palette: n, spacing: o } = k0(), d = M0.useRef(new Array(e).fill(null)), s = (v) => {
    d.current[v].focus();
  }, c = (v) => {
    d.current[v].select();
  }, m = (v, g) => {
    switch (v.key) {
      case "ArrowUp":
      case "ArrowDown":
      case " ":
        v.preventDefault();
        break;
      case "ArrowLeft":
        v.preventDefault(), g > 0 && (s(g - 1), c(g - 1));
        break;
      case "ArrowRight":
        v.preventDefault(), g < e - 1 && (s(g + 1), c(g + 1));
        break;
      case "Delete":
        v.preventDefault(), i((_) => _.slice(0, g) + _.slice(g + 1));
        break;
      case "Backspace":
        v.preventDefault(), g > 0 && (s(g - 1), c(g - 1)), i((_) => _.slice(0, g) + _.slice(g + 1));
        break;
    }
  }, f = (v, g) => {
    const _ = v.target.value;
    let M = 0;
    for (; M <= g && (d.current[M].value && M < g); )
      M += 1;
    i((S) => {
      const O = S.split(""), I = _[_.length - 1];
      return O[M] = I, O.join("");
    }), _ !== "" && g < e - 1 && s(g + 1);
  }, p = (v, g) => {
    c(g);
  }, b = (v, g) => {
    v.preventDefault();
    const _ = v.clipboardData;
    if (_.types.includes("text/plain")) {
      let M = _.getData("text/plain");
      M = M.substring(0, e).trim();
      let S = 0;
      for (; S <= g && (d.current[S].value && S < g); )
        S += 1;
      const O = a.split("");
      for (let I = S; I < e; I += 1) {
        const z = M[I - S] ?? " ";
        O[I] = z;
      }
      i(O.join(""));
    }
  }, y = M0.useMemo(() => Ta("input")(
    () => `
			width: ${o(5)};
			font-family: 'IBM Plex Sans', sans-serif;
			font-size: ${o(1.75)};
			font-weight: 400;
			line-height: 1.5;
			padding: ${o(1)} 0;
			border-radius: ${o(1)};
			text-align: center;
			color: ${n.typography.main};
			background: ${n.surfaces.light};
			border: ${o(0.125)} solid ${n.surfaces.dark};

			&:hover {
				border-color: ${n.primary.main};
			}

			&:focus {
				border-color: ${n.primary.main};
			}

			// firefox
			&:focus-visible {
				outline: 0;
			}
		`
  ), [n]);
  return /* @__PURE__ */ r(V, { display: "flex", gap: 1, alignItems: "center", children: new Array(e).fill(null).map((v, g) => /* @__PURE__ */ h(M0.Fragment, { children: [
    /* @__PURE__ */ r(
      it,
      {
        slots: {
          input: y
        },
        "aria-label": `Digit ${g + 1} of OTP`,
        slotProps: {
          input: {
            ref: (_) => {
              d.current[g] = _;
            },
            onKeyDown: (_) => m(_, g),
            onChange: (_) => f(_, g),
            onClick: (_) => p(_, g),
            onPaste: (_) => b(_, g),
            value: a[g] ?? ""
          }
        }
      }
    ),
    g === e - 1 ? null : t
  ] }, "otp-" + g)) });
}, l6 = (t) => /* @__PURE__ */ r(Xt, { ...t, children: t.children }), jr = (t) => {
  switch (t) {
    case "top":
      return {
        anchorOrigin: {
          vertical: "top",
          horizontal: "center"
        },
        transformOrigin: {
          vertical: "bottom",
          horizontal: "center"
        }
      };
    case "left":
      return {
        anchorOrigin: {
          vertical: "center",
          horizontal: "left"
        },
        transformOrigin: {
          vertical: "center",
          horizontal: "right"
        }
      };
    case "right":
      return {
        anchorOrigin: {
          vertical: "center",
          horizontal: "right"
        },
        transformOrigin: {
          vertical: "center",
          horizontal: "left"
        }
      };
    default:
      return {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "center"
        }
      };
  }
}, d6 = (t) => {
  const { position: e = "bottom" } = t, a = jr(e);
  return /* @__PURE__ */ r(Qt, { ...t, className: `${t.className} cfmPopover`, ...a });
};
function Wr(t) {
  return b0({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z" }, child: [] }] })(t);
}
function Ur(t) {
  return b0({ tag: "svg", attr: { viewBox: "0 0 448 512" }, child: [{ tag: "path", attr: { d: "M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" }, child: [] }] })(t);
}
function qr(t) {
  return b0({ tag: "svg", attr: { viewBox: "0 0 448 512" }, child: [{ tag: "path", attr: { d: "M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z" }, child: [] }] })(t);
}
function Yr(t) {
  return b0({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z" }, child: [] }] })(t);
}
function Kr(t) {
  return b0({ tag: "svg", attr: { viewBox: "0 0 256 512" }, child: [{ tag: "path", attr: { d: "M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z" }, child: [] }] })(t);
}
function nt(t) {
  return b0({ tag: "svg", attr: { viewBox: "0 0 256 512" }, child: [{ tag: "path", attr: { d: "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z" }, child: [] }] })(t);
}
function Xr(t) {
  return b0({ tag: "svg", attr: { viewBox: "0 0 448 512" }, child: [{ tag: "path", attr: { d: "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z" }, child: [] }] })(t);
}
function Qr(t) {
  return b0({ tag: "svg", attr: { viewBox: "0 0 448 512" }, child: [{ tag: "path", attr: { d: "M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z" }, child: [] }] })(t);
}
function Jr(t) {
  return b0({ tag: "svg", attr: { viewBox: "0 0 448 512" }, child: [{ tag: "path", attr: { d: "M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z" }, child: [] }] })(t);
}
function ei(t) {
  return b0({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z" }, child: [] }] })(t);
}
function ai(t) {
  return b0({ tag: "svg", attr: { viewBox: "0 0 384 512" }, child: [{ tag: "path", attr: { d: "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z" }, child: [] }] })(t);
}
function ti(t) {
  return b0({ tag: "svg", attr: { viewBox: "0 0 448 512" }, child: [{ tag: "path", attr: { d: "M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z" }, child: [] }] })(t);
}
function ri(t) {
  return b0({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z" }, child: [] }] })(t);
}
function ii(t) {
  return b0({ tag: "svg", attr: { viewBox: "0 0 448 512" }, child: [{ tag: "path", attr: { d: "M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z" }, child: [] }] })(t);
}
function ni(t) {
  return b0({ tag: "svg", attr: { viewBox: "0 0 384 512" }, child: [{ tag: "path", attr: { d: "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48z" }, child: [] }] })(t);
}
const c6 = ({ name: t, url: e, size: a }) => /* @__PURE__ */ h(
  V,
  {
    boxShadow: 3,
    borderRadius: 1,
    px: 4,
    py: 3,
    display: "flex",
    alignItems: "center",
    gap: 3,
    sx: { backgroundColor: "surfaces.light" },
    children: [
      /* @__PURE__ */ r(V, { color: "typography.main", children: /* @__PURE__ */ r(ni, {}) }),
      /* @__PURE__ */ h(V, { children: [
        /* @__PURE__ */ r(R, { variant: "body1", fontWeight: "bold", children: /* @__PURE__ */ r(w0, { href: e, target: "_blank", title: `Descargar: ${t}`, children: t }) }),
        a && /* @__PURE__ */ r(R, { color: "typography.light", variant: "body2", mt: 1, children: a })
      ] }),
      /* @__PURE__ */ r(V, { ml: "auto", children: /* @__PURE__ */ r(w0, { href: e, target: "_blank", title: `Descargar: ${t}`, children: /* @__PURE__ */ r(ei, {}) }) })
    ]
  }
), u6 = ({ name: t, url: e, adress: a, phone: i }) => /* @__PURE__ */ h(
  V,
  {
    mb: 2,
    px: 4,
    py: 3,
    borderBottom: 1,
    borderColor: "secondary.400",
    display: "flex",
    alignItems: "center",
    gap: 3,
    children: [
      /* @__PURE__ */ h(V, { children: [
        /* @__PURE__ */ r(R, { variant: "body1", fontWeight: "bold", children: t }),
        /* @__PURE__ */ h(R, { color: "typography.light", variant: "body2", mt: 0.5, children: [
          "Dirección: ",
          a
        ] }),
        i && /* @__PURE__ */ h(R, { color: "typography.light", variant: "body2", mt: 0.5, children: [
          "Teléfono: ",
          i
        ] })
      ] }),
      /* @__PURE__ */ r(V, { ml: "auto", sx: { textAlign: "right" }, children: /* @__PURE__ */ h(w0, { href: e, target: "_blank", title: `Descargar: ${t}`, children: [
        /* @__PURE__ */ r(ai, {}),
        /* @__PURE__ */ r("br", {}),
        /* @__PURE__ */ r(R, { variant: "caption", fontWeight: "bold", children: "Ver mapa" })
      ] }) })
    ]
  }
), h6 = ({
  title: t,
  subtitle: e,
  description: a,
  date: i,
  mediaUrl: n,
  cta: o,
  mediaUrlTitle: d
}) => /* @__PURE__ */ h(
  V,
  {
    mb: 5,
    flex: "1 1 auto",
    display: "flex",
    alignItems: "stretch",
    position: "relative",
    sx: {
      backgroundColor: "surfaces.light",
      padding: { xs: 1, sm: 2, md: 0 },
      gap: { xs: 2, md: 3 }
    },
    children: [
      /* @__PURE__ */ r(V, { minWidth: "30%", flex: "1 1 auto", display: "flex", children: /* @__PURE__ */ r(
        "img",
        {
          loading: "lazy",
          src: n,
          alt: d ?? "Card media resource",
          style: {
            backgroundColor: "gray",
            aspectRatio: "3/2",
            height: "100%",
            width: "100%",
            objectFit: "cover",
            flex: "1 1 auto"
          }
        }
      ) }),
      /* @__PURE__ */ h(
        V,
        {
          display: "flex",
          flexDirection: "column",
          sx: {
            justifyContent: { xs: "flex-start", md: "center" }
          },
          children: [
            typeof e == "string" ? /* @__PURE__ */ r(R, { variant: "body2", color: "primary", fontWeight: "bold", children: e }) : e,
            typeof t == "string" ? /* @__PURE__ */ r(
              R,
              {
                style: { textWrap: "pretty" },
                variant: "h5",
                fontWeight: "bold",
                sx: { fontSize: { xs: "1rem", md: "1.375rem", lg: "1.688rem" } },
                mb: 1.2,
                children: t
              }
            ) : t,
            typeof a == "string" ? /* @__PURE__ */ r(
              R,
              {
                variant: "body2",
                pb: 1,
                sx: {
                  position: "relative",
                  flex: 1,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: { xs: "none", md: "-webkit-box" },
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: "3",
                  maxHeight: "62px"
                },
                children: a
              }
            ) : a,
            i && /* @__PURE__ */ r(
              R,
              {
                sx: {
                  position: { md: "absolute" },
                  right: { md: 24 },
                  top: { md: 8 }
                },
                variant: "body2",
                color: "secondary.500",
                fontWeight: "bold",
                children: i
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ r(
        V,
        {
          ml: "auto",
          display: "flex",
          justifyContent: "center",
          sx: {
            alignItems: { xs: "center", md: "flex-end" },
            padding: { xs: 0, md: 2 }
          },
          children: typeof o.action == "string" ? /* @__PURE__ */ r(
            D0,
            {
              sx: {
                paddingX: 1,
                minWidth: { md: "110px" },
                ".MuiButton-icon": {
                  display: { xs: "block", md: "none" },
                  mr: 0,
                  ml: 0
                },
                height: 32,
                fontSize: { xs: 0, md: 14 },
                borderWidth: { xs: 0, md: 2 }
              },
              href: o.action,
              variant: "outlined",
              size: "small",
              startIcon: /* @__PURE__ */ r(nt, {}),
              children: o.label
            }
          ) : /* @__PURE__ */ r(D0, { sx: { height: 32 }, onClick: o.action, variant: "outlined", size: "small", children: o.label })
        }
      )
    ]
  }
), oi = Ta("img")(() => ({
  backgroundColor: "gray",
  height: "100%",
  aspectRatio: "3/2",
  objectFit: "cover",
  width: "100%"
})), m6 = ({
  title: { variant: t = "subtitle1", align: e = "left", marginBottom: a = 2, fontWeight: i = "bold", content: n },
  subtitle: o,
  description: d,
  mediaUrl: s
}) => /* @__PURE__ */ h(
  V,
  {
    mb: 5,
    display: { xs: "block", sm: "flex" },
    alignItems: "stretch",
    position: "relative",
    sx: {
      backgroundColor: "surfaces.light",
      padding: { xs: 0, sm: 2, md: 0 },
      gap: { xs: 2, md: 3 }
    },
    children: [
      /* @__PURE__ */ r(V, { flex: 1, children: /* @__PURE__ */ r(oi, { src: s, alt: n }) }),
      /* @__PURE__ */ h(
        V,
        {
          flex: 2,
          display: "flex",
          flexDirection: "column",
          sx: {
            justifyContent: { xs: "flex-start", sm: "center" },
            padding: { xs: 1, sm: 0 }
          },
          children: [
            typeof o == "string" ? /* @__PURE__ */ r(R, { variant: "body2", color: "primary", fontWeight: "bold", children: o }) : o,
            /* @__PURE__ */ r(
              R,
              {
                variant: t,
                pr: 1,
                align: e,
                mb: a,
                fontWeight: i,
                children: n
              }
            ),
            typeof d == "string" ? /* @__PURE__ */ r(
              R,
              {
                variant: "body2",
                pb: 1,
                pr: 1,
                sx: (c) => ({
                  flex: 1,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: "vertical",
                  maxHeight: c.spacing(7.25)
                }),
                children: d
              }
            ) : d
          ]
        }
      )
    ]
  }
), f6 = ({
  title: t,
  subtitle: e,
  mediaUrl: a,
  mediaUrlTitle: i,
  link: n,
  linkTarget: o = "_self"
}) => /* @__PURE__ */ r(V, { children: /* @__PURE__ */ h(w0, { href: n, target: o, sx: { textDecoration: "none", color: "inherit" }, children: [
  /* @__PURE__ */ r(V, { mb: 1, children: /* @__PURE__ */ r(
    "img",
    {
      loading: "lazy",
      src: a,
      alt: i ?? "Card media resource",
      style: {
        width: "100%",
        backgroundColor: "gray",
        aspectRatio: "3/2"
      }
    }
  ) }),
  typeof e == "string" ? /* @__PURE__ */ r(
    R,
    {
      variant: "body2",
      color: "primary",
      align: "left",
      fontWeight: "bold",
      marginBottom: 0,
      children: e
    }
  ) : e,
  typeof t == "string" ? /* @__PURE__ */ r(R, { align: "left", variant: "h5", fontWeight: "bold", mb: 2, children: t }) : t
] }) }), p6 = ({ title: t, subtitle: e, mediaUrl: a, link: i }) => /* @__PURE__ */ h(w0, { href: i, sx: { textDecoration: "none", color: "inherit" }, children: [
  /* @__PURE__ */ r(
    V,
    {
      display: "flex",
      flexWrap: "wrap",
      alignContent: "end",
      sx: () => ({
        cursor: "pointer",
        backgroundImage: `linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0.8) 20%, rgba(0,0,0,0) 100%), url(${a})`,
        backgroundColor: "gray",
        aspectRatio: "3/2",
        width: "100%",
        backgroundSize: "cover",
        backgroundPosition: "center"
      }),
      children: typeof e == "string" ? /* @__PURE__ */ r(R, { color: "white", variant: "subtitle1", fontWeight: "bold", mb: 3, ml: 2.5, children: e }) : e
    }
  ),
  typeof t == "string" ? /* @__PURE__ */ r(R, { variant: "h6", fontWeight: "bold", mb: 2, children: t }) : t
] }), g6 = ({ title: t, subtitle: e, mediaUrl: a, link: i, mediaUrlTitle: n }) => /* @__PURE__ */ r(V, { children: /* @__PURE__ */ r(w0, { href: i, sx: { textDecoration: "none", color: "inherit" }, children: /* @__PURE__ */ h(V, { mb: 1, position: "relative", children: [
  /* @__PURE__ */ r(
    "img",
    {
      loading: "lazy",
      src: a,
      alt: n ?? "Card media resource",
      style: {
        width: "100%",
        backgroundColor: "gray",
        aspectRatio: "3/2"
      }
    }
  ),
  /* @__PURE__ */ h(
    V,
    {
      padding: 1.5,
      sx: {
        position: "absolute",
        width: "80%",
        backgroundColor: "surfaces.light",
        right: 0,
        bottom: 0
      },
      children: [
        typeof e == "string" ? /* @__PURE__ */ r(R, { variant: "caption", color: "primary", fontWeight: "bold", children: e }) : e,
        typeof t == "string" ? /* @__PURE__ */ r(R, { variant: "h6", fontWeight: "bold", lineHeight: 1.3, children: t }) : t
      ]
    }
  )
] }) }) }), v6 = ({ title: t, subtitle: e }) => /* @__PURE__ */ h(V, { children: [
  typeof t == "string" ? /* @__PURE__ */ r(R, { variant: "h5", fontWeight: "bold", marginBottom: 2, children: t }) : t,
  typeof e == "string" ? /* @__PURE__ */ r(R, { variant: "body1", children: e }) : e
] }), I0 = (t) => {
  const { cta: e, ...a } = t;
  return e != null && e.label ? /* @__PURE__ */ r(
    D0,
    {
      variant: (e == null ? void 0 : e.variant) || "contained",
      startIcon: e == null ? void 0 : e.icon,
      ...typeof e.action == "string" ? { target: "_blank", href: e.action } : { onClick: e.action },
      ...a,
      children: e.label
    }
  ) : null;
}, si = ({ cta: t, paddingTop: e = 5 }) => /* @__PURE__ */ r(V, { mt: e, textAlign: "center", children: /* @__PURE__ */ r(I0, { cta: t }) }), R0 = ({ title: t = {} }) => {
  const { variant: e = "h2", align: a = "left", marginBottom: i = 6, fontWeight: n = "bold", content: o } = t;
  return o ? /* @__PURE__ */ r(R, { variant: e, align: a, marginBottom: i, fontWeight: n, children: o }) : null;
}, v0 = () => Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15), ot = ({ mediaUrl: t }) => /* @__PURE__ */ r(
  "iframe",
  {
    src: t,
    style: { borderWidth: "0", aspectRatio: "16/9", width: "100%" },
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
    referrerPolicy: "strict-origin-when-cross-origin",
    allowFullScreen: !0,
    title: `video-iframe-${v0()}`
  }
), b6 = ({ title: t, mediaUrl: e }) => /* @__PURE__ */ h(V, { component: "article", children: [
  /* @__PURE__ */ r(ot, { mediaUrl: e }),
  typeof t == "string" ? /* @__PURE__ */ r(R, { variant: "h6", fontWeight: "bold", marginBottom: 2, children: t }) : t
] }), y6 = ({ title: t, description: e, mediaUrl: a, cta: i, mediaUrlTitle: n }) => /* @__PURE__ */ h(
  V,
  {
    boxShadow: 3,
    borderRadius: 2,
    overflow: "hidden",
    sx: { backgroundColor: "surfaces.light" },
    children: [
      /* @__PURE__ */ r(V, { mb: 1, children: /* @__PURE__ */ r(
        "img",
        {
          loading: "lazy",
          src: a,
          alt: n ?? "Card media resource",
          style: {
            width: "100%",
            backgroundColor: "gray",
            aspectRatio: "3/2"
          }
        }
      ) }),
      /* @__PURE__ */ h(V, { px: 2, py: 3, pt: 1, children: [
        typeof t == "string" ? /* @__PURE__ */ r(R, { variant: "h6", fontWeight: "bold", mb: 2, color: "typography.light", children: t }) : t,
        typeof e == "string" ? /* @__PURE__ */ r(R, { variant: "body2", color: "typography.main", children: e }) : e,
        /* @__PURE__ */ r(V, { textAlign: "center", mt: 2, children: typeof i.action == "string" ? /* @__PURE__ */ r(D0, { href: i.action, variant: "contained", size: "small", children: i.label }) : /* @__PURE__ */ r(D0, { onClick: i.action, variant: "contained", size: "small", children: i.label }) })
      ] })
    ]
  }
), li = ({ label: t, action: e }) => /* @__PURE__ */ r(H0, { children: typeof e == "string" ? /* @__PURE__ */ r(w0, { href: e, variant: "body2", children: t }) : /* @__PURE__ */ r(w0, { onClick: e, variant: "body2", children: t }) }), _6 = ({ icon: t, title: e, link: a }) => /* @__PURE__ */ r(Jt, { children: /* @__PURE__ */ h(h0, { container: !0, paddingX: 3, paddingY: 4, children: [
  /* @__PURE__ */ r(h0, { item: !0, xs: 2, children: t }),
  /* @__PURE__ */ r(h0, { item: !0, xs: !0, children: typeof e == "string" ? /* @__PURE__ */ r(R, { variant: "body1", sx: { textDecoration: "underline" }, children: e }) : e }),
  /* @__PURE__ */ r(h0, { item: !0, xs: 2, textAlign: "end", alignContent: "end", children: /* @__PURE__ */ r(li, { ...a }) })
] }) }), w6 = ({ icon: t, title: e, description: a }) => /* @__PURE__ */ h(h0, { container: !0, paddingX: 3, paddingY: 4, gap: 2, children: [
  /* @__PURE__ */ r(h0, { item: !0, xs: 2, children: t }),
  /* @__PURE__ */ h(h0, { item: !0, xs: !0, children: [
    typeof e == "string" ? /* @__PURE__ */ r(R, { variant: "subtitle1", fontWeight: "bold", children: e }) : e,
    typeof a == "string" ? /* @__PURE__ */ r(R, { variant: "body1", children: a }) : a
  ] })
] }), T6 = ({
  title: t,
  mediaUrl: e,
  onClick: a,
  bottomInformation: i,
  actions: n,
  tagLine: o
}) => /* @__PURE__ */ h(
  V,
  {
    p: 1.25,
    onClick: a,
    component: "div",
    borderRadius: 2,
    display: "flex",
    flexWrap: "wrap",
    alignContent: o ? "space-between" : "flex-end",
    sx: () => ({
      cursor: a && "pointer",
      backgroundImage: `linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0.25) 100%), url(${e})`,
      backgroundColor: "gray",
      aspectRatio: "5/6",
      backgroundSize: "cover",
      backgroundPosition: "center"
    }),
    children: [
      o,
      /* @__PURE__ */ h(V, { pl: 2, children: [
        n,
        typeof t == "string" ? /* @__PURE__ */ r(R, { color: "white", variant: "h6", fontWeight: "bold", mb: 2.75, children: t }) : t,
        i
      ] })
    ]
  }
), S6 = ({
  mediaUrl: t,
  title: e,
  description: a,
  rrss: i,
  mediaUrlTitle: n
}) => {
  const { spacing: o } = k0();
  return /* @__PURE__ */ h(V, { textAlign: "center", component: "article", children: [
    /* @__PURE__ */ r(V, { p: 2, children: /* @__PURE__ */ r(
      "img",
      {
        loading: "lazy",
        src: t,
        alt: n ?? "Card media resource",
        style: {
          width: "100%",
          borderRadius: "50%",
          objectFit: "cover",
          aspectRatio: "1/1",
          backgroundColor: "gray",
          maxWidth: o(31)
        }
      }
    ) }),
    /* @__PURE__ */ h(V, { display: "flex", flexDirection: "column", gap: 2, children: [
      typeof e == "string" ? /* @__PURE__ */ r(R, { variant: "h5", fontWeight: "bold", color: "typography.main", children: e }) : e,
      typeof a == "string" ? /* @__PURE__ */ r(R, { variant: "body2", color: "typography.main", children: a }) : a,
      /* @__PURE__ */ r(V, { display: "flex", gap: 2, justifyContent: "center", children: i.map(({ url: d, icon: s }) => /* @__PURE__ */ h(w0, { href: d, target: "_blank", fontSize: 24, children: [
        s === "Facebook" && /* @__PURE__ */ r(Wr, {}),
        s === "Instagram" && /* @__PURE__ */ r(Ur, {}),
        s === "Twitter" && /* @__PURE__ */ r(Yr, {}),
        s === "Linkedin" && /* @__PURE__ */ r(qr, {})
      ] }, d)) })
    ] })
  ] });
}, di = {
  vertical: "column",
  horizontal: "row"
}, M6 = ({
  label: t,
  icon: e,
  action: a,
  orientation: i = "horizontal",
  isHoverable: n = !1
}) => /* @__PURE__ */ h(
  w0,
  {
    ...typeof a == "string" ? { href: a, target: "_blank" } : { onClick: a },
    p: 3,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: di[i],
    gap: 2,
    className: n ? "is-hoverable" : "",
    title: t,
    sx: {
      backgroundColor: "surfaces.light",
      textDecoration: "none",
      textAlign: i === "vertical" ? "center" : "left",
      "&.is-hoverable:hover": {
        backgroundColor: "primary.main",
        color: "common.white",
        ".IconCard__icon": {
          color: "common.white"
        },
        ".IconCard__label": {
          color: "common.white"
        }
      }
    },
    children: [
      /* @__PURE__ */ r(V, { className: "IconCard__icon", color: "primary.main", children: e }),
      /* @__PURE__ */ r(V, { children: /* @__PURE__ */ r(R, { className: "IconCard__label", variant: "body1", fontWeight: "bold", children: t }) })
    ]
  }
), ci = "data:image/png;base64,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", ui = (t) => {
  const { children: e, value: a, index: i, ...n } = t;
  return /* @__PURE__ */ r(
    "div",
    {
      role: "tabpanel",
      hidden: a !== i,
      id: `vertical-tabpanel-${i}`,
      "aria-labelledby": `vertical-tab-${i}`,
      ...n,
      children: a === i && /* @__PURE__ */ h(V, { sx: { pl: 3 }, children: [
        /* @__PURE__ */ r(R, { variant: "h6", fontWeight: "bold", marginBottom: 1, color: "typography.ligth", children: "Encontrarás" }),
        e
      ] })
    }
  );
}, Q1 = ({ text: t, href: e, target: a = "_self" }) => /* @__PURE__ */ r(
  w0,
  {
    href: e,
    target: a,
    underline: "none",
    sx: { display: "block", width: "fit-content", marginBottom: "1.71429rem" },
    children: /* @__PURE__ */ r(R, { variant: "subtitle2", marginBottom: "0.725rem", children: t })
  }
), hi = ({ icon: t, label: e, action: a }) => /* @__PURE__ */ r(
  v1,
  {
    ...typeof a == "string" ? { href: a, target: "_blank" } : { onClick: a },
    size: "large",
    edge: "start",
    color: "inherit",
    "aria-label": e,
    sx: {
      mr: 2
    },
    children: t
  }
), A6 = ({ data: t }) => {
  var y;
  const { mainMenu: e, topMenu: a } = t, [i, n] = Z0(!1), [o, d] = d0.useState(!1), s = W0(), c = () => {
    n(!i);
  }, m = V1("(min-width:900px)"), [f, p] = d0.useState(0), b = (v, g) => {
    p(g);
  };
  return /* @__PURE__ */ h(H0, { children: [
    /* @__PURE__ */ r(e2, { ref: s, position: "static", color: "transparent", children: /* @__PURE__ */ h(
      a2,
      {
        sx: {
          display: "flex",
          alignItems: "center",
          color: "typography.main",
          backgroundColor: "surfaces.light"
        },
        children: [
          /* @__PURE__ */ r(V, { display: "flex", children: e && /* @__PURE__ */ r(
            v1,
            {
              size: "large",
              edge: "start",
              color: "inherit",
              "aria-label": "menu",
              style: { padding: "12px 12px 12px 12px" },
              onClick: c,
              children: /* @__PURE__ */ r(Jr, {})
            }
          ) }),
          /* @__PURE__ */ r(V, { sx: { flexGrow: 1, ml: 2 }, children: /* @__PURE__ */ r("img", { loading: "lazy", src: ci, alt: "Logo comfama", style: { height: "24px" } }) }),
          a == null ? void 0 : a.map((v) => /* @__PURE__ */ r(hi, { icon: v.icon, label: v.text, action: v.action }, v0()))
        ]
      }
    ) }),
    e && /* @__PURE__ */ r(
      t2,
      {
        className: "cfm-header-main-menu",
        id: "cfm-header-main-menu",
        open: i,
        anchorEl: s.current,
        placement: "bottom-end",
        sx: { display: "block" },
        disablePortal: !0,
        children: /* @__PURE__ */ r(
          V,
          {
            sx: {
              display: "flex",
              border: "none",
              width: ((y = s.current) == null ? void 0 : y.clientWidth) || "100vw",
              minHeight: "calc(100vh - 96px)",
              backgroundColor: "surfaces.main"
            },
            children: /* @__PURE__ */ h(
              V,
              {
                sx: {
                  width: "100%",
                  p: 3,
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" }
                },
                children: [
                  /* @__PURE__ */ r(
                    V,
                    {
                      sx: {
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        height: "100%",
                        width: { sm: "100%", md: "70%" }
                      },
                      children: m ? /* @__PURE__ */ h(H0, { children: [
                        /* @__PURE__ */ r(
                          O1,
                          {
                            orientation: "vertical",
                            variant: "scrollable",
                            value: f,
                            onChange: b,
                            "aria-label": "Vertical tabs example",
                            sx: { width: "55%", textAlign: "left" },
                            TabIndicatorProps: { hidden: !0 },
                            children: e.tabs.map((v, g) => /* @__PURE__ */ r(
                              E1,
                              {
                                "aria-label": v.title,
                                label: /* @__PURE__ */ r(R, { variant: "h3", children: v.title })
                              },
                              `${v.title}-${g}`
                            ))
                          }
                        ),
                        e.tabs.map((v, g) => /* @__PURE__ */ r(ui, { value: f, index: g, children: v.data.map((_) => /* @__PURE__ */ r(
                          Q1,
                          {
                            text: _.text,
                            href: _.href,
                            target: _.target
                          },
                          v0()
                        )) }, `${v.title}-${g}`))
                      ] }) : /* @__PURE__ */ r(H0, { children: e.tabs.map((v, g) => /* @__PURE__ */ h(
                        we,
                        {
                          expanded: o === g,
                          onChange: () => d(o === g ? !1 : g),
                          children: [
                            /* @__PURE__ */ r(Te, { expandIcon: null, children: v.title }),
                            /* @__PURE__ */ r(Se, { children: v.data.map((_) => /* @__PURE__ */ r(
                              Q1,
                              {
                                text: _.text,
                                href: _.href,
                                target: _.target
                              },
                              v0()
                            )) })
                          ]
                        },
                        `${v.title}-${g}`
                      )) })
                    }
                  ),
                  /* @__PURE__ */ r(
                    V,
                    {
                      sx: {
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                        width: { sx: "100%", md: "30%" }
                      },
                      children: e.others.map((v) => /* @__PURE__ */ r(
                        Q1,
                        {
                          text: v.text,
                          href: v.href,
                          target: v.target
                        },
                        v0()
                      ))
                    }
                  )
                ]
              }
            )
          }
        )
      }
    )
  ] });
}, z6 = ({
  title: t,
  description: e,
  fr: { mobile: a = 12, tablet: i = 6, desktop: n = 4 } = {},
  content: o,
  paddingTop: d = 4,
  paddingBottom: s = 4,
  cta: c,
  gap: m = 3,
  maxWidth: f = "xl"
}) => /* @__PURE__ */ h(V, { component: "section", pt: d, pb: s, maxWidth: f, mx: "auto", children: [
  /* @__PURE__ */ r(R0, { title: t }),
  /* @__PURE__ */ r(R0, { title: e }),
  /* @__PURE__ */ r(h0, { container: !0, spacing: m, children: o.map((p) => /* @__PURE__ */ r(h0, { item: !0, xs: a, sm: i, md: n, children: p }, v0())) }),
  /* @__PURE__ */ r(si, { cta: c })
] }), x6 = ({
  title: { variant: t = "h2", align: e = "center", marginBottom: a = 4, fontWeight: i = "bold", content: n },
  description: o,
  paddingBottom: d = 4,
  paddingTop: s = 4
}) => /* @__PURE__ */ h(V, { textAlign: "center", pt: s, pb: d, children: [
  /* @__PURE__ */ r(a1, { maxWidth: "xl", children: /* @__PURE__ */ r(
    R,
    {
      variant: t,
      align: e,
      marginBottom: a,
      fontWeight: i,
      children: n
    }
  ) }),
  /* @__PURE__ */ r(a1, { maxWidth: "md", children: typeof o == "string" ? /* @__PURE__ */ r(R, { variant: "body1", marginBottom: 4, children: o }) : o })
] }), P6 = ({
  imgUrl: t,
  imgTitle: e,
  title: a,
  description: i,
  cta: n,
  paddingTop: o = 4,
  paddingBottom: d = 4,
  rtl: s
}) => /* @__PURE__ */ r(V, { component: "section", pt: o, pb: d, children: /* @__PURE__ */ h(
  h0,
  {
    container: !0,
    sx: {
      alignItems: {
        xs: "center",
        lg: "flex-end"
      },
      flexDirection: {
        xs: "column-reverse",
        lg: "row"
      }
    },
    children: [
      /* @__PURE__ */ r(
        h0,
        {
          item: !0,
          md: 6,
          lg: 5,
          position: "relative",
          order: {
            md: s ? 2 : null
          },
          children: /* @__PURE__ */ h(
            V,
            {
              component: "article",
              sx: {
                backgroundColor: "surfaces.main",
                px: {
                  xs: 4,
                  md: 8
                },
                py: {
                  xs: 4,
                  md: 5
                },
                mr: {
                  md: s ? 0 : -10
                },
                ml: {
                  md: s ? -10 : 0
                }
              },
              children: [
                typeof a == "string" ? /* @__PURE__ */ r(R, { variant: "h4", color: "typography.main", sx: { fontWeight: "bold", mb: 3 }, children: a }) : a,
                typeof i == "string" ? /* @__PURE__ */ r(R, { color: "typography.main", children: i }) : i,
                /* @__PURE__ */ r(I0, { cta: n, sx: { mt: 3 } })
              ]
            }
          )
        }
      ),
      /* @__PURE__ */ r(h0, { item: !0, md: 6, lg: 7, children: /* @__PURE__ */ r(
        "img",
        {
          loading: "lazy",
          src: t,
          alt: e,
          style: {
            width: "100%",
            aspectRatio: "16/12",
            backgroundColor: "grey",
            objectFit: "cover"
          }
        }
      ) })
    ]
  }
) }), mi = {
  left: "flex-start",
  center: "center",
  right: "flex-end"
}, fi = ({
  title: { variant: t = "h3", marginBottom: e = 4, fontWeight: a = "bold", content: i },
  description: n,
  mediaUrl: o,
  paddingTop: d = 12,
  paddingBottom: s = 12,
  cta: c,
  contentAlign: m = "center",
  contentWidth: f = "lg",
  fullHeight: p = !1
}) => /* @__PURE__ */ h(
  V,
  {
    component: "section",
    pt: d,
    pb: s,
    color: "white",
    position: "relative",
    minHeight: p ? "calc(100vh - 70px)" : "initial",
    display: "flex",
    alignItems: "center",
    sx: {
      backgroundColor: "gray",
      backgroundImage: `url(${o})`,
      backgroundSize: "cover",
      backgroundPosition: "center"
    },
    children: [
      /* @__PURE__ */ r(
        "div",
        {
          style: {
            height: "100%",
            width: "100%",
            position: "absolute",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            left: 0,
            top: 0
          }
        }
      ),
      /* @__PURE__ */ r(a1, { sx: { display: "flex", justifyContent: mi[m] }, children: /* @__PURE__ */ h(V, { maxWidth: f, sx: { position: "relative" }, textAlign: m, children: [
        /* @__PURE__ */ r(
          R,
          {
            variant: t,
            marginBottom: e,
            fontWeight: a,
            color: "white",
            children: i
          }
        ),
        n && /* @__PURE__ */ r(R, { variant: "body1", align: m, color: "white", children: n }),
        /* @__PURE__ */ r(I0, { size: "small", sx: { marginTop: 5, width: "fit-content" }, cta: c })
      ] }) })
    ]
  }
), pi = {
  left: "flex-start",
  center: "center",
  right: "flex-end"
}, Z6 = ({
  fullWidth: t = !1,
  mediaUrl: e,
  paddingTop: a = 12,
  paddingBottom: i = 12,
  minHeight: n = "initial",
  content: o,
  contentAlign: d = "center",
  sxOverlay: s = {}
}) => /* @__PURE__ */ h(
  V,
  {
    component: "section",
    pt: a,
    pb: i,
    color: "white",
    position: "relative",
    minHeight: n,
    display: "flex",
    alignItems: "center",
    justifyContent: pi[d],
    sx: {
      backgroundColor: "gray",
      backgroundImage: `url(${e})`,
      backgroundSize: "cover",
      backgroundPosition: "center"
    },
    children: [
      /* @__PURE__ */ r(
        V,
        {
          sx: {
            height: "100%",
            width: "100%",
            position: "absolute",
            background: "rgba(0, 0, 0, 0.6)",
            left: 0,
            top: 0,
            ...s
          }
        }
      ),
      /* @__PURE__ */ r(V, { width: "100%", maxWidth: t ? "100%" : "xl", mx: "auto", children: /* @__PURE__ */ r(V, { position: "relative", children: o }) })
    ]
  }
), C6 = ({
  title: {
    variant: t = "h3",
    align: e = "center",
    marginBottom: a = 4,
    fontWeight: i = "bold",
    content: n
  },
  content: o,
  button: d,
  paddingBottom: s = 4,
  paddingTop: c = 4
}) => {
  const [m, f] = d0.useState(!1), p = (b) => (y, v) => {
    f(v ? b : !1);
  };
  return /* @__PURE__ */ h(V, { component: "section", paddingTop: c, paddingBottom: s, children: [
    /* @__PURE__ */ r(
      R,
      {
        variant: t,
        align: e,
        marginBottom: a,
        fontWeight: i,
        children: n
      }
    ),
    o.map((b, y) => /* @__PURE__ */ h(
      we,
      {
        expanded: m === `panel${y}`,
        onChange: p(`panel${y}`),
        children: [
          /* @__PURE__ */ r(Te, { expandIcon: m == `panel${y}` ? /* @__PURE__ */ r(ti, {}) : /* @__PURE__ */ r(ii, {}), children: b.title }),
          /* @__PURE__ */ r(Se, { children: b.description })
        ]
      },
      v0()
    )),
    d && /* @__PURE__ */ r(V, { textAlign: "center", marginTop: 4, children: /* @__PURE__ */ r(I0, { cta: d.cta, ...d }) })
  ] });
}, V6 = ({
  title: t,
  items: e,
  buttons: a,
  paddingBottom: i = 4,
  paddingTop: n = 4
}) => /* @__PURE__ */ h(
  V,
  {
    component: "section",
    paddingTop: n,
    paddingBottom: i,
    textAlign: "center",
    children: [
      /* @__PURE__ */ r(R0, { title: t }),
      /* @__PURE__ */ r(a1, { maxWidth: "xl", children: /* @__PURE__ */ r(V, { display: { xs: "block", sm: "flex" }, children: e.map((o, d) => /* @__PURE__ */ h(d0.Fragment, { children: [
        d !== 0 && /* @__PURE__ */ r(
          e1,
          {
            orientation: "vertical",
            sx: {
              display: { xs: "none", sm: "block" },
              height: "auto",
              borderColor: "typography.light"
            }
          }
        ),
        /* @__PURE__ */ h(V, { flex: 1, display: "block", alignContent: "center", marginY: 3, children: [
          o.icon,
          /* @__PURE__ */ r(R, { variant: "h6", fontWeight: "bold", marginTop: 3.625, children: o.title })
        ] })
      ] }, v0())) }) }),
      /* @__PURE__ */ r(
        V,
        {
          display: "flex",
          flexWrap: "wrap",
          marginTop: { xs: 4, sm: 9 },
          gap: 3,
          justifyContent: "center",
          children: a.map((o) => /* @__PURE__ */ r(I0, { cta: o.cta, ...o }, v0()))
        }
      )
    ]
  }
), O6 = ({
  title: t,
  subTitle: e,
  description: a,
  caption: i,
  extra: n,
  cta: o,
  paddingTop: d = 4,
  paddingBottom: s = 4,
  iframeUrl: c,
  mediaUrl: m,
  mediaTitle: f
}) => /* @__PURE__ */ r(V, { component: "section", pt: d, pb: s, children: /* @__PURE__ */ h(h0, { container: !0, alignItems: "flex-start", spacing: 4, children: [
  /* @__PURE__ */ h(h0, { item: !0, md: 6, component: "article", children: [
    e && (typeof e == "string" ? /* @__PURE__ */ r(R, { variant: "h6", color: "primary.main", sx: { fontWeight: "bold", mb: 2 }, children: e }) : e),
    typeof t == "string" ? /* @__PURE__ */ r(R, { variant: "h2", color: "typography.main", sx: { fontWeight: "bold", mb: 3 }, children: t }) : t,
    typeof a == "string" ? /* @__PURE__ */ r(R, { color: "typography.main", children: a }) : a,
    typeof i == "string" ? /* @__PURE__ */ r(R, { color: "secondary.500", sx: { mt: 1 }, children: i }) : i,
    n ?? "",
    /* @__PURE__ */ r(
      I0,
      {
        cta: o,
        sx: {
          mt: 3,
          paddingX: (o == null ? void 0 : o.variant) === "text" && (o != null && o.icon) ? 1 : 2
        }
      }
    )
  ] }),
  /* @__PURE__ */ r(h0, { item: !0, md: 6, flex: 1, children: c ? /* @__PURE__ */ r(ot, { mediaUrl: c }) : /* @__PURE__ */ r(
    "img",
    {
      loading: "lazy",
      src: m,
      alt: f,
      style: {
        width: "100%",
        aspectRatio: "16/12",
        backgroundColor: "grey",
        objectFit: "cover"
      }
    }
  ) })
] }) }), gi = ({ label: t, amount: e, save: a }) => /* @__PURE__ */ h(V, { display: "flex", justifyContent: "space-between", border: 1, borderColor: "typography.light", children: [
  /* @__PURE__ */ r(V, { py: 2, px: 3, children: /* @__PURE__ */ h(R, { variant: "body1", fontWeight: "bold", children: [
    t,
    " ",
    e
  ] }) }),
  a && /* @__PURE__ */ r(V, { py: 2, px: 3, sx: { backgroundColor: "secondary.900" }, children: /* @__PURE__ */ h(R, { variant: "body1", fontWeight: "bold", color: "common.white", children: [
    "Ahorras: ",
    a
  ] }) })
] }), E6 = ({
  title: t,
  prices: e,
  paddingTop: a = 4,
  paddingBottom: i = 4,
  cta: n
}) => /* @__PURE__ */ h(V, { component: "section", pt: a, pb: i, children: [
  /* @__PURE__ */ r(R0, { title: t }),
  /* @__PURE__ */ h(h0, { container: !0, spacing: 4, children: [
    /* @__PURE__ */ r(
      h0,
      {
        item: !0,
        flex: 1,
        md: 6,
        component: "article",
        display: "flex",
        flexDirection: "column",
        gap: 3,
        children: e.map((o) => /* @__PURE__ */ r(gi, { ...o }, o.label))
      }
    ),
    /* @__PURE__ */ h(h0, { item: !0, flex: 1, md: 6, component: "article", children: [
      /* @__PURE__ */ r(R, { variant: "body1", fontWeight: "bold", mb: 3, children: "¿No sabes cuál es tu tarifa?" }),
      /* @__PURE__ */ h(V, { display: "flex", alignItems: "center", gap: 2, children: [
        /* @__PURE__ */ r(R, { variant: "h4", component: "span", fontWeight: "bold", children: "TA" }),
        /* @__PURE__ */ r(V, { children: /* @__PURE__ */ r(R, { variant: "body2", children: "Afiliados que devengan hasta 2 salarios mínimos legales" }) })
      ] }),
      /* @__PURE__ */ r(e1, { sx: { mb: 2, mt: 2 }, variant: "middle" }),
      /* @__PURE__ */ h(V, { display: "flex", alignItems: "center", gap: 2, children: [
        /* @__PURE__ */ r(R, { variant: "h4", component: "span", fontWeight: "bold", children: "TB" }),
        /* @__PURE__ */ r(V, { children: /* @__PURE__ */ r(R, { variant: "body2", children: "Afiliados que devengan entre 2 y 4 salarios mínimos legales" }) })
      ] }),
      /* @__PURE__ */ r(e1, { sx: { mb: 2, mt: 2 }, variant: "middle" }),
      /* @__PURE__ */ h(V, { display: "flex", alignItems: "center", gap: 2, children: [
        /* @__PURE__ */ r(R, { variant: "h4", component: "span", fontWeight: "bold", children: "TC" }),
        /* @__PURE__ */ r(V, { children: /* @__PURE__ */ r(R, { variant: "body2", children: "Afiliados que devengan más de 4 salarios mínimos legales" }) })
      ] }),
      /* @__PURE__ */ r(e1, { sx: { mb: 2, mt: 2 }, variant: "middle" }),
      /* @__PURE__ */ h(V, { display: "flex", alignItems: "center", gap: 2, children: [
        /* @__PURE__ */ r(R, { variant: "h4", component: "span", fontWeight: "bold", children: "TD" }),
        /* @__PURE__ */ h(V, { children: [
          /* @__PURE__ */ r(R, { variant: "body2", fontWeight: "bold", children: "¿No estás afiliado?" }),
          /* @__PURE__ */ r(R, { variant: "body2", children: "Conoce todos los beneficios que Comfama tiene para ti" })
        ] })
      ] }),
      /* @__PURE__ */ r(
        V,
        {
          sx: {
            textAlign: {
              xs: "center",
              md: "left"
            }
          },
          children: /* @__PURE__ */ r(I0, { cta: n, sx: { mt: 3 } })
        }
      )
    ] })
  ] })
] }), vi = ({
  sx: t,
  onChangePage: e,
  value: a,
  text: i,
  disabledEvent: n = !0,
  currentPage: o
}) => {
  const { palette: d, spacing: s } = k0();
  return /* @__PURE__ */ r(
    V,
    {
      component: "button",
      bgcolor: "transparent",
      border: "none",
      padding: 0,
      sx: t,
      onClick: () => {
        n && e(a);
      },
      children: /* @__PURE__ */ r(
        R,
        {
          variant: "body1",
          fontSize: {
            md: s(2.25)
          },
          fontWeight: a === o ? "bold" : "regular",
          color: a === o ? "typography.main" : d.secondary[500],
          sx: t,
          children: i ?? a
        }
      )
    }
  );
}, bi = ({
  pageAmount: t,
  currentPage: e
}) => {
  if (!(e > 0 && e <= t))
    throw new Error(
      `Insert correct currentPage value. currentPage: ${e}. pageAmount: ${t}`
    );
  const i = [];
  if (t <= 6 && i.push(
    ...Array.from({ length: t }, (n, o) => ({
      value: o + 1,
      isClickeable: o + 1 !== e
    }))
  ), t > 6)
    if (e < t - 3) {
      const n = e === 1 ? e : e - 1;
      i.push(
        ...Array.from({ length: 3 }, (o, d) => ({
          value: n + d,
          isClickeable: n + d !== e
        })),
        { value: -1, label: "...", isClickeable: !1 },
        ...Array.from({ length: 3 }, (o, d) => ({
          value: t - 2 + d,
          isClickeable: !0
        }))
      );
    } else
      i.push(
        ...Array.from({
          length: 6
          /* SIX_VALUE */
        }, (n, o) => ({
          value: t - 5 + o,
          isClickeable: t - 5 + o !== e
        }))
      );
  return i;
}, H6 = ({
  currentPage: t = 1,
  pageAmount: e = 1,
  onChangePage: a,
  variant: i = "full",
  returnBtnLabel: n = "Atrás",
  nextBtnLabel: o = "Siguiente",
  outOfPagesLabel: d = "de"
}) => {
  const { palette: s, spacing: c } = k0(), m = i === "full" ? bi({ pageAmount: e, currentPage: t }) : [];
  return /* @__PURE__ */ h(
    V,
    {
      display: "flex",
      justifyContent: "center",
      gap: { xs: c(2), sm: c(4.25), md: c(4.5) },
      children: [
        /* @__PURE__ */ r(
          V,
          {
            component: "button",
            bgcolor: "transparent",
            paddingBlock: 1.25,
            paddingInline: 2,
            borderColor: t === 1 ? s.secondary[500] : "typography.main",
            borderRadius: { xs: 0.75 },
            onClick: () => t > 1 && a(
              t - 1
              /* ONE_VALUE */
            ),
            sx: {
              bgcolor: "surfaces.light",
              borderWidth: {
                xs: 0.125,
                md: 0
              },
              borderStyle: "solid",
              cursor: t === 1 ? "not-allowed" : "pointer"
            },
            children: /* @__PURE__ */ r(
              R,
              {
                variant: "body1",
                fontSize: {
                  xs: c(2),
                  md: c(2.25)
                },
                color: t === 1 ? s.secondary[500] : "typography.main",
                children: n
              }
            )
          }
        ),
        m.map((f) => /* @__PURE__ */ r(
          vi,
          {
            value: f.value,
            text: f.label,
            currentPage: t,
            pageAmount: e,
            disabledEvent: f.isClickeable,
            onChangePage: a,
            sx: {
              cursor: f.isClickeable ? "pointer" : "default"
            }
          },
          v0()
        )),
        i === "min" && /* @__PURE__ */ h(V, { display: "flex", gap: 0.8, children: [
          /* @__PURE__ */ r(
            R,
            {
              variant: "body1",
              fontSize: {
                xs: c(2),
                md: c(2.25)
              },
              marginBlock: "auto",
              marginInline: 0,
              fontWeight: "bold",
              children: t
            }
          ),
          /* @__PURE__ */ h(
            R,
            {
              variant: "body1",
              fontSize: {
                xs: c(2),
                md: c(2.25)
              },
              marginBlock: "auto",
              marginInline: 0,
              fontWeight: "regular",
              color: s.secondary[500],
              children: [
                d,
                " ",
                e
              ]
            }
          )
        ] }, e + 1),
        /* @__PURE__ */ r(
          V,
          {
            component: "button",
            bgcolor: "transparent",
            paddingBlock: 1.25,
            paddingInline: 2,
            borderColor: t === e ? s.secondary[500] : "typography.main",
            borderRadius: { xs: 0.75 },
            sx: {
              bgcolor: "surfaces.light",
              borderWidth: {
                xs: 0.125,
                md: 0
              },
              borderStyle: "solid",
              cursor: t === e ? "not-allowed" : "pointer"
            },
            onClick: () => t < e && a(
              t + 1
              /* ONE_VALUE */
            ),
            children: /* @__PURE__ */ r(
              R,
              {
                variant: "body1",
                fontSize: {
                  xs: c(2),
                  md: c(2.25)
                },
                color: t === e ? s.secondary[500] : "typography.main",
                children: o
              }
            )
          }
        )
      ]
    }
  );
};
var st = {}, lt = {}, G1 = {}, dt = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var e = {
    animating: !1,
    autoplaying: null,
    currentDirection: 0,
    currentLeft: null,
    currentSlide: 0,
    direction: 1,
    dragging: !1,
    edgeDragged: !1,
    initialized: !1,
    lazyLoadedList: [],
    listHeight: null,
    listWidth: null,
    scrolling: !1,
    slideCount: null,
    slideHeight: null,
    slideWidth: null,
    swipeLeft: null,
    swiped: !1,
    // used by swipeEvent. differentites between touch and swipe.
    swiping: !1,
    touchObject: {
      startX: 0,
      startY: 0,
      curX: 0,
      curY: 0
    },
    trackStyle: {},
    trackWidth: 0,
    targetSlide: 0
  };
  t.default = e;
})(dt);
var yi = "Expected a function", Qe = NaN, _i = "[object Symbol]", wi = /^\s+|\s+$/g, Ti = /^[-+]0x[0-9a-f]+$/i, Si = /^0b[01]+$/i, Mi = /^0o[0-7]+$/i, Ai = parseInt, zi = typeof P0 == "object" && P0 && P0.Object === Object && P0, xi = typeof self == "object" && self && self.Object === Object && self, Pi = zi || xi || Function("return this")(), Zi = Object.prototype, Ci = Zi.toString, Vi = Math.max, Oi = Math.min, J1 = function() {
  return Pi.Date.now();
};
function Ei(t, e, a) {
  var i, n, o, d, s, c, m = 0, f = !1, p = !1, b = !0;
  if (typeof t != "function")
    throw new TypeError(yi);
  e = Je(e) || 0, ue(a) && (f = !!a.leading, p = "maxWait" in a, o = p ? Vi(Je(a.maxWait) || 0, e) : o, b = "trailing" in a ? !!a.trailing : b);
  function y($) {
    var Q = i, i0 = n;
    return i = n = void 0, m = $, d = t.apply(i0, Q), d;
  }
  function v($) {
    return m = $, s = setTimeout(M, e), f ? y($) : d;
  }
  function g($) {
    var Q = $ - c, i0 = $ - m, N = e - Q;
    return p ? Oi(N, o - i0) : N;
  }
  function _($) {
    var Q = $ - c, i0 = $ - m;
    return c === void 0 || Q >= e || Q < 0 || p && i0 >= o;
  }
  function M() {
    var $ = J1();
    if (_($))
      return S($);
    s = setTimeout(M, g($));
  }
  function S($) {
    return s = void 0, b && i ? y($) : (i = n = void 0, d);
  }
  function O() {
    s !== void 0 && clearTimeout(s), m = 0, i = c = n = s = void 0;
  }
  function I() {
    return s === void 0 ? d : S(J1());
  }
  function z() {
    var $ = J1(), Q = _($);
    if (i = arguments, n = this, c = $, Q) {
      if (s === void 0)
        return v(c);
      if (p)
        return s = setTimeout(M, e), y(c);
    }
    return s === void 0 && (s = setTimeout(M, e)), d;
  }
  return z.cancel = O, z.flush = I, z;
}
function ue(t) {
  var e = typeof t;
  return !!t && (e == "object" || e == "function");
}
function Hi(t) {
  return !!t && typeof t == "object";
}
function Li(t) {
  return typeof t == "symbol" || Hi(t) && Ci.call(t) == _i;
}
function Je(t) {
  if (typeof t == "number")
    return t;
  if (Li(t))
    return Qe;
  if (ue(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = ue(e) ? e + "" : e;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = t.replace(wi, "");
  var a = Si.test(t);
  return a || Mi.test(t) ? Ai(t.slice(2), a ? 2 : 8) : Ti.test(t) ? Qe : +t;
}
var ki = Ei, ct = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(t) {
  (function() {
    var e = {}.hasOwnProperty;
    function a() {
      for (var o = "", d = 0; d < arguments.length; d++) {
        var s = arguments[d];
        s && (o = n(o, i(s)));
      }
      return o;
    }
    function i(o) {
      if (typeof o == "string" || typeof o == "number")
        return o;
      if (typeof o != "object")
        return "";
      if (Array.isArray(o))
        return a.apply(null, o);
      if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]"))
        return o.toString();
      var d = "";
      for (var s in o)
        e.call(o, s) && o[s] && (d = n(d, s));
      return d;
    }
    function n(o, d) {
      return d ? o ? o + " " + d : o + d : o;
    }
    t.exports ? (a.default = a, t.exports = a) : window.classNames = a;
  })();
})(ct);
var I1 = ct.exports, B = {}, Ce = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var e = a(d0);
  function a(n) {
    return n && n.__esModule ? n : { default: n };
  }
  var i = {
    accessibility: !0,
    adaptiveHeight: !1,
    afterChange: null,
    appendDots: function(o) {
      return /* @__PURE__ */ e.default.createElement("ul", {
        style: {
          display: "block"
        }
      }, o);
    },
    arrows: !0,
    autoplay: !1,
    autoplaySpeed: 3e3,
    beforeChange: null,
    centerMode: !1,
    centerPadding: "50px",
    className: "",
    cssEase: "ease",
    customPaging: function(o) {
      return /* @__PURE__ */ e.default.createElement("button", null, o + 1);
    },
    dots: !1,
    dotsClass: "slick-dots",
    draggable: !0,
    easing: "linear",
    edgeFriction: 0.35,
    fade: !1,
    focusOnSelect: !1,
    infinite: !0,
    initialSlide: 0,
    lazyLoad: null,
    nextArrow: null,
    onEdge: null,
    onInit: null,
    onLazyLoadError: null,
    onReInit: null,
    pauseOnDotsHover: !1,
    pauseOnFocus: !1,
    pauseOnHover: !0,
    prevArrow: null,
    responsive: null,
    rows: 1,
    rtl: !1,
    slide: "div",
    slidesPerRow: 1,
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 500,
    swipe: !0,
    swipeEvent: null,
    swipeToSlide: !1,
    touchMove: !0,
    touchThreshold: 5,
    useCSS: !0,
    useTransform: !0,
    variableWidth: !1,
    vertical: !1,
    waitForAnimate: !0,
    asNavFor: null
  };
  t.default = i;
})(Ce);
Object.defineProperty(B, "__esModule", {
  value: !0
});
B.checkSpecKeys = B.checkNavigable = B.changeSlide = B.canUseDOM = B.canGoNext = void 0;
B.clamp = ht;
B.extractObject = void 0;
B.filterSettings = Xi;
B.validSettings = B.swipeStart = B.swipeMove = B.swipeEnd = B.slidesOnRight = B.slidesOnLeft = B.slideHandler = B.siblingDirection = B.safePreventDefault = B.lazyStartIndex = B.lazySlidesOnRight = B.lazySlidesOnLeft = B.lazyEndIndex = B.keyHandler = B.initializedState = B.getWidth = B.getTrackLeft = B.getTrackCSS = B.getTrackAnimateCSS = B.getTotalSlides = B.getSwipeDirection = B.getSlideCount = B.getRequiredLazySlides = B.getPreClones = B.getPostClones = B.getOnDemandLazySlides = B.getNavigableIndexes = B.getHeight = void 0;
var Ni = ut(d0), Gi = ut(Ce);
function ut(t) {
  return t && t.__esModule ? t : { default: t };
}
function t1(t) {
  "@babel/helpers - typeof";
  return t1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, t1(t);
}
function ea(t, e) {
  var a = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(t, n).enumerable;
    })), a.push.apply(a, i);
  }
  return a;
}
function f0(t) {
  for (var e = 1; e < arguments.length; e++) {
    var a = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ea(Object(a), !0).forEach(function(i) {
      Ii(t, i, a[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(a)) : ea(Object(a)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(a, i));
    });
  }
  return t;
}
function Ii(t, e, a) {
  return e = Fi(e), e in t ? Object.defineProperty(t, e, { value: a, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = a, t;
}
function Fi(t) {
  var e = Di(t, "string");
  return t1(e) == "symbol" ? e : String(e);
}
function Di(t, e) {
  if (t1(t) != "object" || !t) return t;
  var a = t[Symbol.toPrimitive];
  if (a !== void 0) {
    var i = a.call(t, e || "default");
    if (t1(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function ht(t, e, a) {
  return Math.max(e, Math.min(t, a));
}
var $0 = B.safePreventDefault = function(e) {
  var a = ["onTouchStart", "onTouchMove", "onWheel"];
  a.includes(e._reactName) || e.preventDefault();
}, mt = B.getOnDemandLazySlides = function(e) {
  for (var a = [], i = ft(e), n = pt(e), o = i; o < n; o++)
    e.lazyLoadedList.indexOf(o) < 0 && a.push(o);
  return a;
};
B.getRequiredLazySlides = function(e) {
  for (var a = [], i = ft(e), n = pt(e), o = i; o < n; o++)
    a.push(o);
  return a;
};
var ft = B.lazyStartIndex = function(e) {
  return e.currentSlide - Ri(e);
}, pt = B.lazyEndIndex = function(e) {
  return e.currentSlide + Bi(e);
}, Ri = B.lazySlidesOnLeft = function(e) {
  return e.centerMode ? Math.floor(e.slidesToShow / 2) + (parseInt(e.centerPadding) > 0 ? 1 : 0) : 0;
}, Bi = B.lazySlidesOnRight = function(e) {
  return e.centerMode ? Math.floor((e.slidesToShow - 1) / 2) + 1 + (parseInt(e.centerPadding) > 0 ? 1 : 0) : e.slidesToShow;
}, he = B.getWidth = function(e) {
  return e && e.offsetWidth || 0;
}, gt = B.getHeight = function(e) {
  return e && e.offsetHeight || 0;
}, vt = B.getSwipeDirection = function(e) {
  var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, i, n, o, d;
  return i = e.startX - e.curX, n = e.startY - e.curY, o = Math.atan2(n, i), d = Math.round(o * 180 / Math.PI), d < 0 && (d = 360 - Math.abs(d)), d <= 45 && d >= 0 || d <= 360 && d >= 315 ? "left" : d >= 135 && d <= 225 ? "right" : a === !0 ? d >= 35 && d <= 135 ? "up" : "down" : "vertical";
}, bt = B.canGoNext = function(e) {
  var a = !0;
  return e.infinite || (e.centerMode && e.currentSlide >= e.slideCount - 1 || e.slideCount <= e.slidesToShow || e.currentSlide >= e.slideCount - e.slidesToShow) && (a = !1), a;
};
B.extractObject = function(e, a) {
  var i = {};
  return a.forEach(function(n) {
    return i[n] = e[n];
  }), i;
};
B.initializedState = function(e) {
  var a = Ni.default.Children.count(e.children), i = e.listRef, n = Math.ceil(he(i)), o = e.trackRef && e.trackRef.node, d = Math.ceil(he(o)), s;
  if (e.vertical)
    s = n;
  else {
    var c = e.centerMode && parseInt(e.centerPadding) * 2;
    typeof e.centerPadding == "string" && e.centerPadding.slice(-1) === "%" && (c *= n / 100), s = Math.ceil((n - c) / e.slidesToShow);
  }
  var m = i && gt(i.querySelector('[data-index="0"]')), f = m * e.slidesToShow, p = e.currentSlide === void 0 ? e.initialSlide : e.currentSlide;
  e.rtl && e.currentSlide === void 0 && (p = a - 1 - e.initialSlide);
  var b = e.lazyLoadedList || [], y = mt(f0(f0({}, e), {}, {
    currentSlide: p,
    lazyLoadedList: b
  }));
  b = b.concat(y);
  var v = {
    slideCount: a,
    slideWidth: s,
    listWidth: n,
    trackWidth: d,
    currentSlide: p,
    slideHeight: m,
    listHeight: f,
    lazyLoadedList: b
  };
  return e.autoplaying === null && e.autoplay && (v.autoplaying = "playing"), v;
};
B.slideHandler = function(e) {
  var a = e.waitForAnimate, i = e.animating, n = e.fade, o = e.infinite, d = e.index, s = e.slideCount, c = e.lazyLoad, m = e.currentSlide, f = e.centerMode, p = e.slidesToScroll, b = e.slidesToShow, y = e.useCSS, v = e.lazyLoadedList;
  if (a && i) return {};
  var g = d, _, M, S, O = {}, I = {}, z = o ? d : ht(d, 0, s - 1);
  if (n) {
    if (!o && (d < 0 || d >= s)) return {};
    d < 0 ? g = d + s : d >= s && (g = d - s), c && v.indexOf(g) < 0 && (v = v.concat(g)), O = {
      animating: !0,
      currentSlide: g,
      lazyLoadedList: v,
      targetSlide: g
    }, I = {
      animating: !1,
      targetSlide: g
    };
  } else
    _ = g, g < 0 ? (_ = g + s, o ? s % p !== 0 && (_ = s - s % p) : _ = 0) : !bt(e) && g > m ? g = _ = m : f && g >= s ? (g = o ? s : s - 1, _ = o ? 0 : s - 1) : g >= s && (_ = g - s, o ? s % p !== 0 && (_ = 0) : _ = s - b), !o && g + b >= s && (_ = s - b), M = w1(f0(f0({}, e), {}, {
      slideIndex: g
    })), S = w1(f0(f0({}, e), {}, {
      slideIndex: _
    })), o || (M === S && (g = _), M = S), c && (v = v.concat(mt(f0(f0({}, e), {}, {
      currentSlide: g
    })))), y ? (O = {
      animating: !0,
      currentSlide: _,
      trackStyle: yt(f0(f0({}, e), {}, {
        left: M
      })),
      lazyLoadedList: v,
      targetSlide: z
    }, I = {
      animating: !1,
      currentSlide: _,
      trackStyle: _1(f0(f0({}, e), {}, {
        left: S
      })),
      swipeLeft: null,
      targetSlide: z
    }) : O = {
      currentSlide: _,
      trackStyle: _1(f0(f0({}, e), {}, {
        left: S
      })),
      lazyLoadedList: v,
      targetSlide: z
    };
  return {
    state: O,
    nextState: I
  };
};
B.changeSlide = function(e, a) {
  var i, n, o, d, s, c = e.slidesToScroll, m = e.slidesToShow, f = e.slideCount, p = e.currentSlide, b = e.targetSlide, y = e.lazyLoad, v = e.infinite;
  if (d = f % c !== 0, i = d ? 0 : (f - p) % c, a.message === "previous")
    o = i === 0 ? c : m - i, s = p - o, y && !v && (n = p - o, s = n === -1 ? f - 1 : n), v || (s = b - c);
  else if (a.message === "next")
    o = i === 0 ? c : i, s = p + o, y && !v && (s = (p + c) % f + i), v || (s = b + c);
  else if (a.message === "dots")
    s = a.index * a.slidesToScroll;
  else if (a.message === "children") {
    if (s = a.index, v) {
      var g = Ui(f0(f0({}, e), {}, {
        targetSlide: s
      }));
      s > a.currentSlide && g === "left" ? s = s - f : s < a.currentSlide && g === "right" && (s = s + f);
    }
  } else a.message === "index" && (s = Number(a.index));
  return s;
};
B.keyHandler = function(e, a, i) {
  return e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !a ? "" : e.keyCode === 37 ? i ? "next" : "previous" : e.keyCode === 39 ? i ? "previous" : "next" : "";
};
B.swipeStart = function(e, a, i) {
  return e.target.tagName === "IMG" && $0(e), !a || !i && e.type.indexOf("mouse") !== -1 ? "" : {
    dragging: !0,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};
B.swipeMove = function(e, a) {
  var i = a.scrolling, n = a.animating, o = a.vertical, d = a.swipeToSlide, s = a.verticalSwiping, c = a.rtl, m = a.currentSlide, f = a.edgeFriction, p = a.edgeDragged, b = a.onEdge, y = a.swiped, v = a.swiping, g = a.slideCount, _ = a.slidesToScroll, M = a.infinite, S = a.touchObject, O = a.swipeEvent, I = a.listHeight, z = a.listWidth;
  if (!i) {
    if (n) return $0(e);
    o && d && s && $0(e);
    var $, Q = {}, i0 = w1(a);
    S.curX = e.touches ? e.touches[0].pageX : e.clientX, S.curY = e.touches ? e.touches[0].pageY : e.clientY, S.swipeLength = Math.round(Math.sqrt(Math.pow(S.curX - S.startX, 2)));
    var N = Math.round(Math.sqrt(Math.pow(S.curY - S.startY, 2)));
    if (!s && !v && N > 10)
      return {
        scrolling: !0
      };
    s && (S.swipeLength = N);
    var Z = (c ? -1 : 1) * (S.curX > S.startX ? 1 : -1);
    s && (Z = S.curY > S.startY ? 1 : -1);
    var k = Math.ceil(g / _), F = vt(a.touchObject, s), U = S.swipeLength;
    return M || (m === 0 && (F === "right" || F === "down") || m + 1 >= k && (F === "left" || F === "up") || !bt(a) && (F === "left" || F === "up")) && (U = S.swipeLength * f, p === !1 && b && (b(F), Q.edgeDragged = !0)), !y && O && (O(F), Q.swiped = !0), o ? $ = i0 + U * (I / z) * Z : c ? $ = i0 - U * Z : $ = i0 + U * Z, s && ($ = i0 + U * Z), Q = f0(f0({}, Q), {}, {
      touchObject: S,
      swipeLeft: $,
      trackStyle: _1(f0(f0({}, a), {}, {
        left: $
      }))
    }), Math.abs(S.curX - S.startX) < Math.abs(S.curY - S.startY) * 0.8 || S.swipeLength > 10 && (Q.swiping = !0, $0(e)), Q;
  }
};
B.swipeEnd = function(e, a) {
  var i = a.dragging, n = a.swipe, o = a.touchObject, d = a.listWidth, s = a.touchThreshold, c = a.verticalSwiping, m = a.listHeight, f = a.swipeToSlide, p = a.scrolling, b = a.onSwipe, y = a.targetSlide, v = a.currentSlide, g = a.infinite;
  if (!i)
    return n && $0(e), {};
  var _ = c ? m / s : d / s, M = vt(o, c), S = {
    dragging: !1,
    edgeDragged: !1,
    scrolling: !1,
    swiping: !1,
    swiped: !1,
    swipeLeft: null,
    touchObject: {}
  };
  if (p || !o.swipeLength)
    return S;
  if (o.swipeLength > _) {
    $0(e), b && b(M);
    var O, I, z = g ? v : y;
    switch (M) {
      case "left":
      case "up":
        I = z + ta(a), O = f ? aa(a, I) : I, S.currentDirection = 0;
        break;
      case "right":
      case "down":
        I = z - ta(a), O = f ? aa(a, I) : I, S.currentDirection = 1;
        break;
      default:
        O = z;
    }
    S.triggerSlideHandler = O;
  } else {
    var $ = w1(a);
    S.trackStyle = yt(f0(f0({}, a), {}, {
      left: $
    }));
  }
  return S;
};
var $i = B.getNavigableIndexes = function(e) {
  for (var a = e.infinite ? e.slideCount * 2 : e.slideCount, i = e.infinite ? e.slidesToShow * -1 : 0, n = e.infinite ? e.slidesToShow * -1 : 0, o = []; i < a; )
    o.push(i), i = n + e.slidesToScroll, n += Math.min(e.slidesToScroll, e.slidesToShow);
  return o;
}, aa = B.checkNavigable = function(e, a) {
  var i = $i(e), n = 0;
  if (a > i[i.length - 1])
    a = i[i.length - 1];
  else
    for (var o in i) {
      if (a < i[o]) {
        a = n;
        break;
      }
      n = i[o];
    }
  return a;
}, ta = B.getSlideCount = function(e) {
  var a = e.centerMode ? e.slideWidth * Math.floor(e.slidesToShow / 2) : 0;
  if (e.swipeToSlide) {
    var i, n = e.listRef, o = n.querySelectorAll && n.querySelectorAll(".slick-slide") || [];
    if (Array.from(o).every(function(c) {
      if (e.vertical) {
        if (c.offsetTop + gt(c) / 2 > e.swipeLeft * -1)
          return i = c, !1;
      } else if (c.offsetLeft - a + he(c) / 2 > e.swipeLeft * -1)
        return i = c, !1;
      return !0;
    }), !i)
      return 0;
    var d = e.rtl === !0 ? e.slideCount - e.currentSlide : e.currentSlide, s = Math.abs(i.dataset.index - d) || 1;
    return s;
  } else
    return e.slidesToScroll;
}, Ve = B.checkSpecKeys = function(e, a) {
  return a.reduce(function(i, n) {
    return i && e.hasOwnProperty(n);
  }, !0) ? null : console.error("Keys Missing:", e);
}, _1 = B.getTrackCSS = function(e) {
  Ve(e, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var a, i, n = e.slideCount + 2 * e.slidesToShow;
  e.vertical ? i = n * e.slideHeight : a = Wi(e) * e.slideWidth;
  var o = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };
  if (e.useTransform) {
    var d = e.vertical ? "translate3d(0px, " + e.left + "px, 0px)" : "translate3d(" + e.left + "px, 0px, 0px)", s = e.vertical ? "translate3d(0px, " + e.left + "px, 0px)" : "translate3d(" + e.left + "px, 0px, 0px)", c = e.vertical ? "translateY(" + e.left + "px)" : "translateX(" + e.left + "px)";
    o = f0(f0({}, o), {}, {
      WebkitTransform: d,
      transform: s,
      msTransform: c
    });
  } else
    e.vertical ? o.top = e.left : o.left = e.left;
  return e.fade && (o = {
    opacity: 1
  }), a && (o.width = a), i && (o.height = i), window && !window.addEventListener && window.attachEvent && (e.vertical ? o.marginTop = e.left + "px" : o.marginLeft = e.left + "px"), o;
}, yt = B.getTrackAnimateCSS = function(e) {
  Ve(e, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var a = _1(e);
  return e.useTransform ? (a.WebkitTransition = "-webkit-transform " + e.speed + "ms " + e.cssEase, a.transition = "transform " + e.speed + "ms " + e.cssEase) : e.vertical ? a.transition = "top " + e.speed + "ms " + e.cssEase : a.transition = "left " + e.speed + "ms " + e.cssEase, a;
}, w1 = B.getTrackLeft = function(e) {
  if (e.unslick)
    return 0;
  Ve(e, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
  var a = e.slideIndex, i = e.trackRef, n = e.infinite, o = e.centerMode, d = e.slideCount, s = e.slidesToShow, c = e.slidesToScroll, m = e.slideWidth, f = e.listWidth, p = e.variableWidth, b = e.slideHeight, y = e.fade, v = e.vertical, g = 0, _, M, S = 0;
  if (y || e.slideCount === 1)
    return 0;
  var O = 0;
  if (n ? (O = -g1(e), d % c !== 0 && a + c > d && (O = -(a > d ? s - (a - d) : d % c)), o && (O += parseInt(s / 2))) : (d % c !== 0 && a + c > d && (O = s - d % c), o && (O = parseInt(s / 2))), g = O * m, S = O * b, v ? _ = a * b * -1 + S : _ = a * m * -1 + g, p === !0) {
    var I, z = i && i.node;
    if (I = a + g1(e), M = z && z.childNodes[I], _ = M ? M.offsetLeft * -1 : 0, o === !0) {
      I = n ? a + g1(e) : a, M = z && z.children[I], _ = 0;
      for (var $ = 0; $ < I; $++)
        _ -= z && z.children[$] && z.children[$].offsetWidth;
      _ -= parseInt(e.centerPadding), _ += M && (f - M.offsetWidth) / 2;
    }
  }
  return _;
}, g1 = B.getPreClones = function(e) {
  return e.unslick || !e.infinite ? 0 : e.variableWidth ? e.slideCount : e.slidesToShow + (e.centerMode ? 1 : 0);
}, ji = B.getPostClones = function(e) {
  return e.unslick || !e.infinite ? 0 : e.slideCount;
}, Wi = B.getTotalSlides = function(e) {
  return e.slideCount === 1 ? 1 : g1(e) + e.slideCount + ji(e);
}, Ui = B.siblingDirection = function(e) {
  return e.targetSlide > e.currentSlide ? e.targetSlide > e.currentSlide + qi(e) ? "left" : "right" : e.targetSlide < e.currentSlide - Yi(e) ? "right" : "left";
}, qi = B.slidesOnRight = function(e) {
  var a = e.slidesToShow, i = e.centerMode, n = e.rtl, o = e.centerPadding;
  if (i) {
    var d = (a - 1) / 2 + 1;
    return parseInt(o) > 0 && (d += 1), n && a % 2 === 0 && (d += 1), d;
  }
  return n ? 0 : a - 1;
}, Yi = B.slidesOnLeft = function(e) {
  var a = e.slidesToShow, i = e.centerMode, n = e.rtl, o = e.centerPadding;
  if (i) {
    var d = (a - 1) / 2 + 1;
    return parseInt(o) > 0 && (d += 1), !n && a % 2 === 0 && (d += 1), d;
  }
  return n ? a - 1 : 0;
};
B.canUseDOM = function() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
};
var Ki = B.validSettings = Object.keys(Gi.default);
function Xi(t) {
  return Ki.reduce(function(e, a) {
    return t.hasOwnProperty(a) && (e[a] = t[a]), e;
  }, {});
}
var F1 = {};
Object.defineProperty(F1, "__esModule", {
  value: !0
});
F1.Track = void 0;
var E0 = _t(d0), ee = _t(I1), ae = B;
function _t(t) {
  return t && t.__esModule ? t : { default: t };
}
function q0(t) {
  "@babel/helpers - typeof";
  return q0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, q0(t);
}
function me() {
  return me = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var a = arguments[e];
      for (var i in a)
        Object.prototype.hasOwnProperty.call(a, i) && (t[i] = a[i]);
    }
    return t;
  }, me.apply(this, arguments);
}
function Qi(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Ji(t, e) {
  for (var a = 0; a < e.length; a++) {
    var i = e[a];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, Tt(i.key), i);
  }
}
function en(t, e, a) {
  return e && Ji(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function an(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && fe(t, e);
}
function fe(t, e) {
  return fe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, n) {
    return i.__proto__ = n, i;
  }, fe(t, e);
}
function tn(t) {
  var e = wt();
  return function() {
    var i = T1(t), n;
    if (e) {
      var o = T1(this).constructor;
      n = Reflect.construct(i, arguments, o);
    } else
      n = i.apply(this, arguments);
    return rn(this, n);
  };
}
function rn(t, e) {
  if (e && (q0(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return pe(t);
}
function pe(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function wt() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (wt = function() {
    return !!t;
  })();
}
function T1(t) {
  return T1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(a) {
    return a.__proto__ || Object.getPrototypeOf(a);
  }, T1(t);
}
function ra(t, e) {
  var a = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(t, n).enumerable;
    })), a.push.apply(a, i);
  }
  return a;
}
function T0(t) {
  for (var e = 1; e < arguments.length; e++) {
    var a = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ra(Object(a), !0).forEach(function(i) {
      ge(t, i, a[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(a)) : ra(Object(a)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(a, i));
    });
  }
  return t;
}
function ge(t, e, a) {
  return e = Tt(e), e in t ? Object.defineProperty(t, e, { value: a, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = a, t;
}
function Tt(t) {
  var e = nn(t, "string");
  return q0(e) == "symbol" ? e : String(e);
}
function nn(t, e) {
  if (q0(t) != "object" || !t) return t;
  var a = t[Symbol.toPrimitive];
  if (a !== void 0) {
    var i = a.call(t, e || "default");
    if (q0(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var te = function(e) {
  var a, i, n, o, d;
  e.rtl ? d = e.slideCount - 1 - e.index : d = e.index, n = d < 0 || d >= e.slideCount, e.centerMode ? (o = Math.floor(e.slidesToShow / 2), i = (d - e.currentSlide) % e.slideCount === 0, d > e.currentSlide - o - 1 && d <= e.currentSlide + o && (a = !0)) : a = e.currentSlide <= d && d < e.currentSlide + e.slidesToShow;
  var s;
  e.targetSlide < 0 ? s = e.targetSlide + e.slideCount : e.targetSlide >= e.slideCount ? s = e.targetSlide - e.slideCount : s = e.targetSlide;
  var c = d === s;
  return {
    "slick-slide": !0,
    "slick-active": a,
    "slick-center": i,
    "slick-cloned": n,
    "slick-current": c
    // dubious in case of RTL
  };
}, on = function(e) {
  var a = {};
  return (e.variableWidth === void 0 || e.variableWidth === !1) && (a.width = e.slideWidth), e.fade && (a.position = "relative", e.vertical ? a.top = -e.index * parseInt(e.slideHeight) : a.left = -e.index * parseInt(e.slideWidth), a.opacity = e.currentSlide === e.index ? 1 : 0, a.zIndex = e.currentSlide === e.index ? 999 : 998, e.useCSS && (a.transition = "opacity " + e.speed + "ms " + e.cssEase + ", visibility " + e.speed + "ms " + e.cssEase)), a;
}, re = function(e, a) {
  return e.key || a;
}, sn = function(e) {
  var a, i = [], n = [], o = [], d = E0.default.Children.count(e.children), s = (0, ae.lazyStartIndex)(e), c = (0, ae.lazyEndIndex)(e);
  return E0.default.Children.forEach(e.children, function(m, f) {
    var p, b = {
      message: "children",
      index: f,
      slidesToScroll: e.slidesToScroll,
      currentSlide: e.currentSlide
    };
    !e.lazyLoad || e.lazyLoad && e.lazyLoadedList.indexOf(f) >= 0 ? p = m : p = /* @__PURE__ */ E0.default.createElement("div", null);
    var y = on(T0(T0({}, e), {}, {
      index: f
    })), v = p.props.className || "", g = te(T0(T0({}, e), {}, {
      index: f
    }));
    if (i.push(/* @__PURE__ */ E0.default.cloneElement(p, {
      key: "original" + re(p, f),
      "data-index": f,
      className: (0, ee.default)(g, v),
      tabIndex: "-1",
      "aria-hidden": !g["slick-active"],
      style: T0(T0({
        outline: "none"
      }, p.props.style || {}), y),
      onClick: function(S) {
        p.props && p.props.onClick && p.props.onClick(S), e.focusOnSelect && e.focusOnSelect(b);
      }
    })), e.infinite && e.fade === !1) {
      var _ = d - f;
      _ <= (0, ae.getPreClones)(e) && (a = -_, a >= s && (p = m), g = te(T0(T0({}, e), {}, {
        index: a
      })), n.push(/* @__PURE__ */ E0.default.cloneElement(p, {
        key: "precloned" + re(p, a),
        "data-index": a,
        tabIndex: "-1",
        className: (0, ee.default)(g, v),
        "aria-hidden": !g["slick-active"],
        style: T0(T0({}, p.props.style || {}), y),
        onClick: function(S) {
          p.props && p.props.onClick && p.props.onClick(S), e.focusOnSelect && e.focusOnSelect(b);
        }
      }))), a = d + f, a < c && (p = m), g = te(T0(T0({}, e), {}, {
        index: a
      })), o.push(/* @__PURE__ */ E0.default.cloneElement(p, {
        key: "postcloned" + re(p, a),
        "data-index": a,
        tabIndex: "-1",
        className: (0, ee.default)(g, v),
        "aria-hidden": !g["slick-active"],
        style: T0(T0({}, p.props.style || {}), y),
        onClick: function(S) {
          p.props && p.props.onClick && p.props.onClick(S), e.focusOnSelect && e.focusOnSelect(b);
        }
      }));
    }
  }), e.rtl ? n.concat(i, o).reverse() : n.concat(i, o);
};
F1.Track = /* @__PURE__ */ function(t) {
  an(a, t);
  var e = tn(a);
  function a() {
    var i;
    Qi(this, a);
    for (var n = arguments.length, o = new Array(n), d = 0; d < n; d++)
      o[d] = arguments[d];
    return i = e.call.apply(e, [this].concat(o)), ge(pe(i), "node", null), ge(pe(i), "handleRef", function(s) {
      i.node = s;
    }), i;
  }
  return en(a, [{
    key: "render",
    value: function() {
      var n = sn(this.props), o = this.props, d = o.onMouseEnter, s = o.onMouseOver, c = o.onMouseLeave, m = {
        onMouseEnter: d,
        onMouseOver: s,
        onMouseLeave: c
      };
      return /* @__PURE__ */ E0.default.createElement("div", me({
        ref: this.handleRef,
        className: "slick-track",
        style: this.props.trackStyle
      }, m), n);
    }
  }]), a;
}(E0.default.PureComponent);
var D1 = {};
function Y0(t) {
  "@babel/helpers - typeof";
  return Y0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Y0(t);
}
Object.defineProperty(D1, "__esModule", {
  value: !0
});
D1.Dots = void 0;
var f1 = St(d0), ln = St(I1), ia = B;
function St(t) {
  return t && t.__esModule ? t : { default: t };
}
function na(t, e) {
  var a = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(t, n).enumerable;
    })), a.push.apply(a, i);
  }
  return a;
}
function dn(t) {
  for (var e = 1; e < arguments.length; e++) {
    var a = arguments[e] != null ? arguments[e] : {};
    e % 2 ? na(Object(a), !0).forEach(function(i) {
      cn(t, i, a[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(a)) : na(Object(a)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(a, i));
    });
  }
  return t;
}
function cn(t, e, a) {
  return e = Mt(e), e in t ? Object.defineProperty(t, e, { value: a, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = a, t;
}
function un(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function hn(t, e) {
  for (var a = 0; a < e.length; a++) {
    var i = e[a];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, Mt(i.key), i);
  }
}
function mn(t, e, a) {
  return e && hn(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function Mt(t) {
  var e = fn(t, "string");
  return Y0(e) == "symbol" ? e : String(e);
}
function fn(t, e) {
  if (Y0(t) != "object" || !t) return t;
  var a = t[Symbol.toPrimitive];
  if (a !== void 0) {
    var i = a.call(t, e || "default");
    if (Y0(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function pn(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && ve(t, e);
}
function ve(t, e) {
  return ve = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, n) {
    return i.__proto__ = n, i;
  }, ve(t, e);
}
function gn(t) {
  var e = At();
  return function() {
    var i = S1(t), n;
    if (e) {
      var o = S1(this).constructor;
      n = Reflect.construct(i, arguments, o);
    } else
      n = i.apply(this, arguments);
    return vn(this, n);
  };
}
function vn(t, e) {
  if (e && (Y0(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return bn(t);
}
function bn(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function At() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (At = function() {
    return !!t;
  })();
}
function S1(t) {
  return S1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(a) {
    return a.__proto__ || Object.getPrototypeOf(a);
  }, S1(t);
}
var yn = function(e) {
  var a;
  return e.infinite ? a = Math.ceil(e.slideCount / e.slidesToScroll) : a = Math.ceil((e.slideCount - e.slidesToShow) / e.slidesToScroll) + 1, a;
};
D1.Dots = /* @__PURE__ */ function(t) {
  pn(a, t);
  var e = gn(a);
  function a() {
    return un(this, a), e.apply(this, arguments);
  }
  return mn(a, [{
    key: "clickHandler",
    value: function(n, o) {
      o.preventDefault(), this.props.clickHandler(n);
    }
  }, {
    key: "render",
    value: function() {
      for (var n = this.props, o = n.onMouseEnter, d = n.onMouseOver, s = n.onMouseLeave, c = n.infinite, m = n.slidesToScroll, f = n.slidesToShow, p = n.slideCount, b = n.currentSlide, y = yn({
        slideCount: p,
        slidesToScroll: m,
        slidesToShow: f,
        infinite: c
      }), v = {
        onMouseEnter: o,
        onMouseOver: d,
        onMouseLeave: s
      }, g = [], _ = 0; _ < y; _++) {
        var M = (_ + 1) * m - 1, S = c ? M : (0, ia.clamp)(M, 0, p - 1), O = S - (m - 1), I = c ? O : (0, ia.clamp)(O, 0, p - 1), z = (0, ln.default)({
          "slick-active": c ? b >= I && b <= S : b === I
        }), $ = {
          message: "dots",
          index: _,
          slidesToScroll: m,
          currentSlide: b
        }, Q = this.clickHandler.bind(this, $);
        g = g.concat(/* @__PURE__ */ f1.default.createElement("li", {
          key: _,
          className: z
        }, /* @__PURE__ */ f1.default.cloneElement(this.props.customPaging(_), {
          onClick: Q
        })));
      }
      return /* @__PURE__ */ f1.default.cloneElement(this.props.appendDots(g), dn({
        className: this.props.dotsClass
      }, v));
    }
  }]), a;
}(f1.default.PureComponent);
var K0 = {};
function X0(t) {
  "@babel/helpers - typeof";
  return X0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, X0(t);
}
Object.defineProperty(K0, "__esModule", {
  value: !0
});
K0.PrevArrow = K0.NextArrow = void 0;
var j0 = xt(d0), zt = xt(I1), _n = B;
function xt(t) {
  return t && t.__esModule ? t : { default: t };
}
function M1() {
  return M1 = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var a = arguments[e];
      for (var i in a)
        Object.prototype.hasOwnProperty.call(a, i) && (t[i] = a[i]);
    }
    return t;
  }, M1.apply(this, arguments);
}
function oa(t, e) {
  var a = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(t, n).enumerable;
    })), a.push.apply(a, i);
  }
  return a;
}
function A1(t) {
  for (var e = 1; e < arguments.length; e++) {
    var a = arguments[e] != null ? arguments[e] : {};
    e % 2 ? oa(Object(a), !0).forEach(function(i) {
      wn(t, i, a[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(a)) : oa(Object(a)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(a, i));
    });
  }
  return t;
}
function wn(t, e, a) {
  return e = Ct(e), e in t ? Object.defineProperty(t, e, { value: a, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = a, t;
}
function Pt(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Tn(t, e) {
  for (var a = 0; a < e.length; a++) {
    var i = e[a];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, Ct(i.key), i);
  }
}
function Zt(t, e, a) {
  return e && Tn(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function Ct(t) {
  var e = Sn(t, "string");
  return X0(e) == "symbol" ? e : String(e);
}
function Sn(t, e) {
  if (X0(t) != "object" || !t) return t;
  var a = t[Symbol.toPrimitive];
  if (a !== void 0) {
    var i = a.call(t, e || "default");
    if (X0(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function Vt(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && be(t, e);
}
function be(t, e) {
  return be = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, n) {
    return i.__proto__ = n, i;
  }, be(t, e);
}
function Ot(t) {
  var e = Et();
  return function() {
    var i = z1(t), n;
    if (e) {
      var o = z1(this).constructor;
      n = Reflect.construct(i, arguments, o);
    } else
      n = i.apply(this, arguments);
    return Mn(this, n);
  };
}
function Mn(t, e) {
  if (e && (X0(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return An(t);
}
function An(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Et() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Et = function() {
    return !!t;
  })();
}
function z1(t) {
  return z1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(a) {
    return a.__proto__ || Object.getPrototypeOf(a);
  }, z1(t);
}
K0.PrevArrow = /* @__PURE__ */ function(t) {
  Vt(a, t);
  var e = Ot(a);
  function a() {
    return Pt(this, a), e.apply(this, arguments);
  }
  return Zt(a, [{
    key: "clickHandler",
    value: function(n, o) {
      o && o.preventDefault(), this.props.clickHandler(n, o);
    }
  }, {
    key: "render",
    value: function() {
      var n = {
        "slick-arrow": !0,
        "slick-prev": !0
      }, o = this.clickHandler.bind(this, {
        message: "previous"
      });
      !this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow) && (n["slick-disabled"] = !0, o = null);
      var d = {
        key: "0",
        "data-role": "none",
        className: (0, zt.default)(n),
        style: {
          display: "block"
        },
        onClick: o
      }, s = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      }, c;
      return this.props.prevArrow ? c = /* @__PURE__ */ j0.default.cloneElement(this.props.prevArrow, A1(A1({}, d), s)) : c = /* @__PURE__ */ j0.default.createElement("button", M1({
        key: "0",
        type: "button"
      }, d), " ", "Previous"), c;
    }
  }]), a;
}(j0.default.PureComponent);
K0.NextArrow = /* @__PURE__ */ function(t) {
  Vt(a, t);
  var e = Ot(a);
  function a() {
    return Pt(this, a), e.apply(this, arguments);
  }
  return Zt(a, [{
    key: "clickHandler",
    value: function(n, o) {
      o && o.preventDefault(), this.props.clickHandler(n, o);
    }
  }, {
    key: "render",
    value: function() {
      var n = {
        "slick-arrow": !0,
        "slick-next": !0
      }, o = this.clickHandler.bind(this, {
        message: "next"
      });
      (0, _n.canGoNext)(this.props) || (n["slick-disabled"] = !0, o = null);
      var d = {
        key: "1",
        "data-role": "none",
        className: (0, zt.default)(n),
        style: {
          display: "block"
        },
        onClick: o
      }, s = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      }, c;
      return this.props.nextArrow ? c = /* @__PURE__ */ j0.default.cloneElement(this.props.nextArrow, A1(A1({}, d), s)) : c = /* @__PURE__ */ j0.default.createElement("button", M1({
        key: "1",
        type: "button"
      }, d), " ", "Next"), c;
    }
  }]), a;
}(j0.default.PureComponent);
var Ht = function() {
  if (typeof Map < "u")
    return Map;
  function t(e, a) {
    var i = -1;
    return e.some(function(n, o) {
      return n[0] === a ? (i = o, !0) : !1;
    }), i;
  }
  return (
    /** @class */
    function() {
      function e() {
        this.__entries__ = [];
      }
      return Object.defineProperty(e.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.get = function(a) {
        var i = t(this.__entries__, a), n = this.__entries__[i];
        return n && n[1];
      }, e.prototype.set = function(a, i) {
        var n = t(this.__entries__, a);
        ~n ? this.__entries__[n][1] = i : this.__entries__.push([a, i]);
      }, e.prototype.delete = function(a) {
        var i = this.__entries__, n = t(i, a);
        ~n && i.splice(n, 1);
      }, e.prototype.has = function(a) {
        return !!~t(this.__entries__, a);
      }, e.prototype.clear = function() {
        this.__entries__.splice(0);
      }, e.prototype.forEach = function(a, i) {
        i === void 0 && (i = null);
        for (var n = 0, o = this.__entries__; n < o.length; n++) {
          var d = o[n];
          a.call(i, d[1], d[0]);
        }
      }, e;
    }()
  );
}(), ye = typeof window < "u" && typeof document < "u" && window.document === document, x1 = function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), zn = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(x1) : function(t) {
    return setTimeout(function() {
      return t(Date.now());
    }, 1e3 / 60);
  };
}(), xn = 2;
function Pn(t, e) {
  var a = !1, i = !1, n = 0;
  function o() {
    a && (a = !1, t()), i && s();
  }
  function d() {
    zn(o);
  }
  function s() {
    var c = Date.now();
    if (a) {
      if (c - n < xn)
        return;
      i = !0;
    } else
      a = !0, i = !1, setTimeout(d, e);
    n = c;
  }
  return s;
}
var Zn = 20, Cn = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], Vn = typeof MutationObserver < "u", On = (
  /** @class */
  function() {
    function t() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = Pn(this.refresh.bind(this), Zn);
    }
    return t.prototype.addObserver = function(e) {
      ~this.observers_.indexOf(e) || this.observers_.push(e), this.connected_ || this.connect_();
    }, t.prototype.removeObserver = function(e) {
      var a = this.observers_, i = a.indexOf(e);
      ~i && a.splice(i, 1), !a.length && this.connected_ && this.disconnect_();
    }, t.prototype.refresh = function() {
      var e = this.updateObservers_();
      e && this.refresh();
    }, t.prototype.updateObservers_ = function() {
      var e = this.observers_.filter(function(a) {
        return a.gatherActive(), a.hasActive();
      });
      return e.forEach(function(a) {
        return a.broadcastActive();
      }), e.length > 0;
    }, t.prototype.connect_ = function() {
      !ye || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), Vn ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, t.prototype.disconnect_ = function() {
      !ye || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, t.prototype.onTransitionEnd_ = function(e) {
      var a = e.propertyName, i = a === void 0 ? "" : a, n = Cn.some(function(o) {
        return !!~i.indexOf(o);
      });
      n && this.refresh();
    }, t.getInstance = function() {
      return this.instance_ || (this.instance_ = new t()), this.instance_;
    }, t.instance_ = null, t;
  }()
), Lt = function(t, e) {
  for (var a = 0, i = Object.keys(e); a < i.length; a++) {
    var n = i[a];
    Object.defineProperty(t, n, {
      value: e[n],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return t;
}, Q0 = function(t) {
  var e = t && t.ownerDocument && t.ownerDocument.defaultView;
  return e || x1;
}, kt = R1(0, 0, 0, 0);
function P1(t) {
  return parseFloat(t) || 0;
}
function sa(t) {
  for (var e = [], a = 1; a < arguments.length; a++)
    e[a - 1] = arguments[a];
  return e.reduce(function(i, n) {
    var o = t["border-" + n + "-width"];
    return i + P1(o);
  }, 0);
}
function En(t) {
  for (var e = ["top", "right", "bottom", "left"], a = {}, i = 0, n = e; i < n.length; i++) {
    var o = n[i], d = t["padding-" + o];
    a[o] = P1(d);
  }
  return a;
}
function Hn(t) {
  var e = t.getBBox();
  return R1(0, 0, e.width, e.height);
}
function Ln(t) {
  var e = t.clientWidth, a = t.clientHeight;
  if (!e && !a)
    return kt;
  var i = Q0(t).getComputedStyle(t), n = En(i), o = n.left + n.right, d = n.top + n.bottom, s = P1(i.width), c = P1(i.height);
  if (i.boxSizing === "border-box" && (Math.round(s + o) !== e && (s -= sa(i, "left", "right") + o), Math.round(c + d) !== a && (c -= sa(i, "top", "bottom") + d)), !Nn(t)) {
    var m = Math.round(s + o) - e, f = Math.round(c + d) - a;
    Math.abs(m) !== 1 && (s -= m), Math.abs(f) !== 1 && (c -= f);
  }
  return R1(n.left, n.top, s, c);
}
var kn = /* @__PURE__ */ function() {
  return typeof SVGGraphicsElement < "u" ? function(t) {
    return t instanceof Q0(t).SVGGraphicsElement;
  } : function(t) {
    return t instanceof Q0(t).SVGElement && typeof t.getBBox == "function";
  };
}();
function Nn(t) {
  return t === Q0(t).document.documentElement;
}
function Gn(t) {
  return ye ? kn(t) ? Hn(t) : Ln(t) : kt;
}
function In(t) {
  var e = t.x, a = t.y, i = t.width, n = t.height, o = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, d = Object.create(o.prototype);
  return Lt(d, {
    x: e,
    y: a,
    width: i,
    height: n,
    top: a,
    right: e + i,
    bottom: n + a,
    left: e
  }), d;
}
function R1(t, e, a, i) {
  return { x: t, y: e, width: a, height: i };
}
var Fn = (
  /** @class */
  function() {
    function t(e) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = R1(0, 0, 0, 0), this.target = e;
    }
    return t.prototype.isActive = function() {
      var e = Gn(this.target);
      return this.contentRect_ = e, e.width !== this.broadcastWidth || e.height !== this.broadcastHeight;
    }, t.prototype.broadcastRect = function() {
      var e = this.contentRect_;
      return this.broadcastWidth = e.width, this.broadcastHeight = e.height, e;
    }, t;
  }()
), Dn = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e, a) {
      var i = In(a);
      Lt(this, { target: e, contentRect: i });
    }
    return t;
  }()
), Rn = (
  /** @class */
  function() {
    function t(e, a, i) {
      if (this.activeObservations_ = [], this.observations_ = new Ht(), typeof e != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = e, this.controller_ = a, this.callbackCtx_ = i;
    }
    return t.prototype.observe = function(e) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(e instanceof Q0(e).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var a = this.observations_;
        a.has(e) || (a.set(e, new Fn(e)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, t.prototype.unobserve = function(e) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(e instanceof Q0(e).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var a = this.observations_;
        a.has(e) && (a.delete(e), a.size || this.controller_.removeObserver(this));
      }
    }, t.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, t.prototype.gatherActive = function() {
      var e = this;
      this.clearActive(), this.observations_.forEach(function(a) {
        a.isActive() && e.activeObservations_.push(a);
      });
    }, t.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var e = this.callbackCtx_, a = this.activeObservations_.map(function(i) {
          return new Dn(i.target, i.broadcastRect());
        });
        this.callback_.call(e, a, e), this.clearActive();
      }
    }, t.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, t.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, t;
  }()
), Nt = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new Ht(), Gt = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e) {
      if (!(this instanceof t))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var a = On.getInstance(), i = new Rn(e, a, this);
      Nt.set(this, i);
    }
    return t;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(t) {
  Gt.prototype[t] = function() {
    var e;
    return (e = Nt.get(this))[t].apply(e, arguments);
  };
});
var Bn = function() {
  return typeof x1.ResizeObserver < "u" ? x1.ResizeObserver : Gt;
}();
const $n = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Bn
}, Symbol.toStringTag, { value: "Module" })), jn = /* @__PURE__ */ n2($n);
Object.defineProperty(G1, "__esModule", {
  value: !0
});
G1.InnerSlider = void 0;
var _0 = i1(d0), Wn = i1(dt), Un = i1(ki), qn = i1(I1), p0 = B, Yn = F1, Kn = D1, la = K0, Xn = i1(jn);
function i1(t) {
  return t && t.__esModule ? t : { default: t };
}
function B0(t) {
  "@babel/helpers - typeof";
  return B0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, B0(t);
}
function Z1() {
  return Z1 = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var a = arguments[e];
      for (var i in a)
        Object.prototype.hasOwnProperty.call(a, i) && (t[i] = a[i]);
    }
    return t;
  }, Z1.apply(this, arguments);
}
function Qn(t, e) {
  if (t == null) return {};
  var a = Jn(t, e), i, n;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (n = 0; n < o.length; n++)
      i = o[n], !(e.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(t, i) && (a[i] = t[i]);
  }
  return a;
}
function Jn(t, e) {
  if (t == null) return {};
  var a = {}, i = Object.keys(t), n, o;
  for (o = 0; o < i.length; o++)
    n = i[o], !(e.indexOf(n) >= 0) && (a[n] = t[n]);
  return a;
}
function da(t, e) {
  var a = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(t, n).enumerable;
    })), a.push.apply(a, i);
  }
  return a;
}
function a0(t) {
  for (var e = 1; e < arguments.length; e++) {
    var a = arguments[e] != null ? arguments[e] : {};
    e % 2 ? da(Object(a), !0).forEach(function(i) {
      s0(t, i, a[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(a)) : da(Object(a)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(a, i));
    });
  }
  return t;
}
function e3(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function a3(t, e) {
  for (var a = 0; a < e.length; a++) {
    var i = e[a];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, Ft(i.key), i);
  }
}
function t3(t, e, a) {
  return e && a3(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function r3(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _e(t, e);
}
function _e(t, e) {
  return _e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, n) {
    return i.__proto__ = n, i;
  }, _e(t, e);
}
function i3(t) {
  var e = It();
  return function() {
    var i = C1(t), n;
    if (e) {
      var o = C1(this).constructor;
      n = Reflect.construct(i, arguments, o);
    } else
      n = i.apply(this, arguments);
    return n3(this, n);
  };
}
function n3(t, e) {
  if (e && (B0(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return o0(t);
}
function o0(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function It() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (It = function() {
    return !!t;
  })();
}
function C1(t) {
  return C1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(a) {
    return a.__proto__ || Object.getPrototypeOf(a);
  }, C1(t);
}
function s0(t, e, a) {
  return e = Ft(e), e in t ? Object.defineProperty(t, e, { value: a, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = a, t;
}
function Ft(t) {
  var e = o3(t, "string");
  return B0(e) == "symbol" ? e : String(e);
}
function o3(t, e) {
  if (B0(t) != "object" || !t) return t;
  var a = t[Symbol.toPrimitive];
  if (a !== void 0) {
    var i = a.call(t, e || "default");
    if (B0(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
G1.InnerSlider = /* @__PURE__ */ function(t) {
  r3(a, t);
  var e = i3(a);
  function a(i) {
    var n;
    e3(this, a), n = e.call(this, i), s0(o0(n), "listRefHandler", function(d) {
      return n.list = d;
    }), s0(o0(n), "trackRefHandler", function(d) {
      return n.track = d;
    }), s0(o0(n), "adaptHeight", function() {
      if (n.props.adaptiveHeight && n.list) {
        var d = n.list.querySelector('[data-index="'.concat(n.state.currentSlide, '"]'));
        n.list.style.height = (0, p0.getHeight)(d) + "px";
      }
    }), s0(o0(n), "componentDidMount", function() {
      if (n.props.onInit && n.props.onInit(), n.props.lazyLoad) {
        var d = (0, p0.getOnDemandLazySlides)(a0(a0({}, n.props), n.state));
        d.length > 0 && (n.setState(function(c) {
          return {
            lazyLoadedList: c.lazyLoadedList.concat(d)
          };
        }), n.props.onLazyLoad && n.props.onLazyLoad(d));
      }
      var s = a0({
        listRef: n.list,
        trackRef: n.track
      }, n.props);
      n.updateState(s, !0, function() {
        n.adaptHeight(), n.props.autoplay && n.autoPlay("update");
      }), n.props.lazyLoad === "progressive" && (n.lazyLoadTimer = setInterval(n.progressiveLazyLoad, 1e3)), n.ro = new Xn.default(function() {
        n.state.animating ? (n.onWindowResized(!1), n.callbackTimers.push(setTimeout(function() {
          return n.onWindowResized();
        }, n.props.speed))) : n.onWindowResized();
      }), n.ro.observe(n.list), document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function(c) {
        c.onfocus = n.props.pauseOnFocus ? n.onSlideFocus : null, c.onblur = n.props.pauseOnFocus ? n.onSlideBlur : null;
      }), window.addEventListener ? window.addEventListener("resize", n.onWindowResized) : window.attachEvent("onresize", n.onWindowResized);
    }), s0(o0(n), "componentWillUnmount", function() {
      n.animationEndCallback && clearTimeout(n.animationEndCallback), n.lazyLoadTimer && clearInterval(n.lazyLoadTimer), n.callbackTimers.length && (n.callbackTimers.forEach(function(d) {
        return clearTimeout(d);
      }), n.callbackTimers = []), window.addEventListener ? window.removeEventListener("resize", n.onWindowResized) : window.detachEvent("onresize", n.onWindowResized), n.autoplayTimer && clearInterval(n.autoplayTimer), n.ro.disconnect();
    }), s0(o0(n), "componentDidUpdate", function(d) {
      if (n.checkImagesLoad(), n.props.onReInit && n.props.onReInit(), n.props.lazyLoad) {
        var s = (0, p0.getOnDemandLazySlides)(a0(a0({}, n.props), n.state));
        s.length > 0 && (n.setState(function(f) {
          return {
            lazyLoadedList: f.lazyLoadedList.concat(s)
          };
        }), n.props.onLazyLoad && n.props.onLazyLoad(s));
      }
      n.adaptHeight();
      var c = a0(a0({
        listRef: n.list,
        trackRef: n.track
      }, n.props), n.state), m = n.didPropsChange(d);
      m && n.updateState(c, m, function() {
        n.state.currentSlide >= _0.default.Children.count(n.props.children) && n.changeSlide({
          message: "index",
          index: _0.default.Children.count(n.props.children) - n.props.slidesToShow,
          currentSlide: n.state.currentSlide
        }), n.props.autoplay ? n.autoPlay("update") : n.pause("paused");
      });
    }), s0(o0(n), "onWindowResized", function(d) {
      n.debouncedResize && n.debouncedResize.cancel(), n.debouncedResize = (0, Un.default)(function() {
        return n.resizeWindow(d);
      }, 50), n.debouncedResize();
    }), s0(o0(n), "resizeWindow", function() {
      var d = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0, s = !!(n.track && n.track.node);
      if (s) {
        var c = a0(a0({
          listRef: n.list,
          trackRef: n.track
        }, n.props), n.state);
        n.updateState(c, d, function() {
          n.props.autoplay ? n.autoPlay("update") : n.pause("paused");
        }), n.setState({
          animating: !1
        }), clearTimeout(n.animationEndCallback), delete n.animationEndCallback;
      }
    }), s0(o0(n), "updateState", function(d, s, c) {
      var m = (0, p0.initializedState)(d);
      d = a0(a0(a0({}, d), m), {}, {
        slideIndex: m.currentSlide
      });
      var f = (0, p0.getTrackLeft)(d);
      d = a0(a0({}, d), {}, {
        left: f
      });
      var p = (0, p0.getTrackCSS)(d);
      (s || _0.default.Children.count(n.props.children) !== _0.default.Children.count(d.children)) && (m.trackStyle = p), n.setState(m, c);
    }), s0(o0(n), "ssrInit", function() {
      if (n.props.variableWidth) {
        var d = 0, s = 0, c = [], m = (0, p0.getPreClones)(a0(a0(a0({}, n.props), n.state), {}, {
          slideCount: n.props.children.length
        })), f = (0, p0.getPostClones)(a0(a0(a0({}, n.props), n.state), {}, {
          slideCount: n.props.children.length
        }));
        n.props.children.forEach(function(Q) {
          c.push(Q.props.style.width), d += Q.props.style.width;
        });
        for (var p = 0; p < m; p++)
          s += c[c.length - 1 - p], d += c[c.length - 1 - p];
        for (var b = 0; b < f; b++)
          d += c[b];
        for (var y = 0; y < n.state.currentSlide; y++)
          s += c[y];
        var v = {
          width: d + "px",
          left: -s + "px"
        };
        if (n.props.centerMode) {
          var g = "".concat(c[n.state.currentSlide], "px");
          v.left = "calc(".concat(v.left, " + (100% - ").concat(g, ") / 2 ) ");
        }
        return {
          trackStyle: v
        };
      }
      var _ = _0.default.Children.count(n.props.children), M = a0(a0(a0({}, n.props), n.state), {}, {
        slideCount: _
      }), S = (0, p0.getPreClones)(M) + (0, p0.getPostClones)(M) + _, O = 100 / n.props.slidesToShow * S, I = 100 / S, z = -I * ((0, p0.getPreClones)(M) + n.state.currentSlide) * O / 100;
      n.props.centerMode && (z += (100 - I * O / 100) / 2);
      var $ = {
        width: O + "%",
        left: z + "%"
      };
      return {
        slideWidth: I + "%",
        trackStyle: $
      };
    }), s0(o0(n), "checkImagesLoad", function() {
      var d = n.list && n.list.querySelectorAll && n.list.querySelectorAll(".slick-slide img") || [], s = d.length, c = 0;
      Array.prototype.forEach.call(d, function(m) {
        var f = function() {
          return ++c && c >= s && n.onWindowResized();
        };
        if (!m.onclick)
          m.onclick = function() {
            return m.parentNode.focus();
          };
        else {
          var p = m.onclick;
          m.onclick = function(b) {
            p(b), m.parentNode.focus();
          };
        }
        m.onload || (n.props.lazyLoad ? m.onload = function() {
          n.adaptHeight(), n.callbackTimers.push(setTimeout(n.onWindowResized, n.props.speed));
        } : (m.onload = f, m.onerror = function() {
          f(), n.props.onLazyLoadError && n.props.onLazyLoadError();
        }));
      });
    }), s0(o0(n), "progressiveLazyLoad", function() {
      for (var d = [], s = a0(a0({}, n.props), n.state), c = n.state.currentSlide; c < n.state.slideCount + (0, p0.getPostClones)(s); c++)
        if (n.state.lazyLoadedList.indexOf(c) < 0) {
          d.push(c);
          break;
        }
      for (var m = n.state.currentSlide - 1; m >= -(0, p0.getPreClones)(s); m--)
        if (n.state.lazyLoadedList.indexOf(m) < 0) {
          d.push(m);
          break;
        }
      d.length > 0 ? (n.setState(function(f) {
        return {
          lazyLoadedList: f.lazyLoadedList.concat(d)
        };
      }), n.props.onLazyLoad && n.props.onLazyLoad(d)) : n.lazyLoadTimer && (clearInterval(n.lazyLoadTimer), delete n.lazyLoadTimer);
    }), s0(o0(n), "slideHandler", function(d) {
      var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, c = n.props, m = c.asNavFor, f = c.beforeChange, p = c.onLazyLoad, b = c.speed, y = c.afterChange, v = n.state.currentSlide, g = (0, p0.slideHandler)(a0(a0(a0({
        index: d
      }, n.props), n.state), {}, {
        trackRef: n.track,
        useCSS: n.props.useCSS && !s
      })), _ = g.state, M = g.nextState;
      if (_) {
        f && f(v, _.currentSlide);
        var S = _.lazyLoadedList.filter(function(O) {
          return n.state.lazyLoadedList.indexOf(O) < 0;
        });
        p && S.length > 0 && p(S), !n.props.waitForAnimate && n.animationEndCallback && (clearTimeout(n.animationEndCallback), y && y(v), delete n.animationEndCallback), n.setState(_, function() {
          m && n.asNavForIndex !== d && (n.asNavForIndex = d, m.innerSlider.slideHandler(d)), M && (n.animationEndCallback = setTimeout(function() {
            var O = M.animating, I = Qn(M, ["animating"]);
            n.setState(I, function() {
              n.callbackTimers.push(setTimeout(function() {
                return n.setState({
                  animating: O
                });
              }, 10)), y && y(_.currentSlide), delete n.animationEndCallback;
            });
          }, b));
        });
      }
    }), s0(o0(n), "changeSlide", function(d) {
      var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, c = a0(a0({}, n.props), n.state), m = (0, p0.changeSlide)(c, d);
      if (!(m !== 0 && !m) && (s === !0 ? n.slideHandler(m, s) : n.slideHandler(m), n.props.autoplay && n.autoPlay("update"), n.props.focusOnSelect)) {
        var f = n.list.querySelectorAll(".slick-current");
        f[0] && f[0].focus();
      }
    }), s0(o0(n), "clickHandler", function(d) {
      n.clickable === !1 && (d.stopPropagation(), d.preventDefault()), n.clickable = !0;
    }), s0(o0(n), "keyHandler", function(d) {
      var s = (0, p0.keyHandler)(d, n.props.accessibility, n.props.rtl);
      s !== "" && n.changeSlide({
        message: s
      });
    }), s0(o0(n), "selectHandler", function(d) {
      n.changeSlide(d);
    }), s0(o0(n), "disableBodyScroll", function() {
      var d = function(c) {
        c = c || window.event, c.preventDefault && c.preventDefault(), c.returnValue = !1;
      };
      window.ontouchmove = d;
    }), s0(o0(n), "enableBodyScroll", function() {
      window.ontouchmove = null;
    }), s0(o0(n), "swipeStart", function(d) {
      n.props.verticalSwiping && n.disableBodyScroll();
      var s = (0, p0.swipeStart)(d, n.props.swipe, n.props.draggable);
      s !== "" && n.setState(s);
    }), s0(o0(n), "swipeMove", function(d) {
      var s = (0, p0.swipeMove)(d, a0(a0(a0({}, n.props), n.state), {}, {
        trackRef: n.track,
        listRef: n.list,
        slideIndex: n.state.currentSlide
      }));
      s && (s.swiping && (n.clickable = !1), n.setState(s));
    }), s0(o0(n), "swipeEnd", function(d) {
      var s = (0, p0.swipeEnd)(d, a0(a0(a0({}, n.props), n.state), {}, {
        trackRef: n.track,
        listRef: n.list,
        slideIndex: n.state.currentSlide
      }));
      if (s) {
        var c = s.triggerSlideHandler;
        delete s.triggerSlideHandler, n.setState(s), c !== void 0 && (n.slideHandler(c), n.props.verticalSwiping && n.enableBodyScroll());
      }
    }), s0(o0(n), "touchEnd", function(d) {
      n.swipeEnd(d), n.clickable = !0;
    }), s0(o0(n), "slickPrev", function() {
      n.callbackTimers.push(setTimeout(function() {
        return n.changeSlide({
          message: "previous"
        });
      }, 0));
    }), s0(o0(n), "slickNext", function() {
      n.callbackTimers.push(setTimeout(function() {
        return n.changeSlide({
          message: "next"
        });
      }, 0));
    }), s0(o0(n), "slickGoTo", function(d) {
      var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      if (d = Number(d), isNaN(d)) return "";
      n.callbackTimers.push(setTimeout(function() {
        return n.changeSlide({
          message: "index",
          index: d,
          currentSlide: n.state.currentSlide
        }, s);
      }, 0));
    }), s0(o0(n), "play", function() {
      var d;
      if (n.props.rtl)
        d = n.state.currentSlide - n.props.slidesToScroll;
      else if ((0, p0.canGoNext)(a0(a0({}, n.props), n.state)))
        d = n.state.currentSlide + n.props.slidesToScroll;
      else
        return !1;
      n.slideHandler(d);
    }), s0(o0(n), "autoPlay", function(d) {
      n.autoplayTimer && clearInterval(n.autoplayTimer);
      var s = n.state.autoplaying;
      if (d === "update") {
        if (s === "hovered" || s === "focused" || s === "paused")
          return;
      } else if (d === "leave") {
        if (s === "paused" || s === "focused")
          return;
      } else if (d === "blur" && (s === "paused" || s === "hovered"))
        return;
      n.autoplayTimer = setInterval(n.play, n.props.autoplaySpeed + 50), n.setState({
        autoplaying: "playing"
      });
    }), s0(o0(n), "pause", function(d) {
      n.autoplayTimer && (clearInterval(n.autoplayTimer), n.autoplayTimer = null);
      var s = n.state.autoplaying;
      d === "paused" ? n.setState({
        autoplaying: "paused"
      }) : d === "focused" ? (s === "hovered" || s === "playing") && n.setState({
        autoplaying: "focused"
      }) : s === "playing" && n.setState({
        autoplaying: "hovered"
      });
    }), s0(o0(n), "onDotsOver", function() {
      return n.props.autoplay && n.pause("hovered");
    }), s0(o0(n), "onDotsLeave", function() {
      return n.props.autoplay && n.state.autoplaying === "hovered" && n.autoPlay("leave");
    }), s0(o0(n), "onTrackOver", function() {
      return n.props.autoplay && n.pause("hovered");
    }), s0(o0(n), "onTrackLeave", function() {
      return n.props.autoplay && n.state.autoplaying === "hovered" && n.autoPlay("leave");
    }), s0(o0(n), "onSlideFocus", function() {
      return n.props.autoplay && n.pause("focused");
    }), s0(o0(n), "onSlideBlur", function() {
      return n.props.autoplay && n.state.autoplaying === "focused" && n.autoPlay("blur");
    }), s0(o0(n), "render", function() {
      var d = (0, qn.default)("slick-slider", n.props.className, {
        "slick-vertical": n.props.vertical,
        "slick-initialized": !0
      }), s = a0(a0({}, n.props), n.state), c = (0, p0.extractObject)(s, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding", "targetSlide", "useCSS"]), m = n.props.pauseOnHover;
      c = a0(a0({}, c), {}, {
        onMouseEnter: m ? n.onTrackOver : null,
        onMouseLeave: m ? n.onTrackLeave : null,
        onMouseOver: m ? n.onTrackOver : null,
        focusOnSelect: n.props.focusOnSelect && n.clickable ? n.selectHandler : null
      });
      var f;
      if (n.props.dots === !0 && n.state.slideCount >= n.props.slidesToShow) {
        var p = (0, p0.extractObject)(s, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]), b = n.props.pauseOnDotsHover;
        p = a0(a0({}, p), {}, {
          clickHandler: n.changeSlide,
          onMouseEnter: b ? n.onDotsLeave : null,
          onMouseOver: b ? n.onDotsOver : null,
          onMouseLeave: b ? n.onDotsLeave : null
        }), f = /* @__PURE__ */ _0.default.createElement(Kn.Dots, p);
      }
      var y, v, g = (0, p0.extractObject)(s, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      g.clickHandler = n.changeSlide, n.props.arrows && (y = /* @__PURE__ */ _0.default.createElement(la.PrevArrow, g), v = /* @__PURE__ */ _0.default.createElement(la.NextArrow, g));
      var _ = null;
      n.props.vertical && (_ = {
        height: n.state.listHeight
      });
      var M = null;
      n.props.vertical === !1 ? n.props.centerMode === !0 && (M = {
        padding: "0px " + n.props.centerPadding
      }) : n.props.centerMode === !0 && (M = {
        padding: n.props.centerPadding + " 0px"
      });
      var S = a0(a0({}, _), M), O = n.props.touchMove, I = {
        className: "slick-list",
        style: S,
        onClick: n.clickHandler,
        onMouseDown: O ? n.swipeStart : null,
        onMouseMove: n.state.dragging && O ? n.swipeMove : null,
        onMouseUp: O ? n.swipeEnd : null,
        onMouseLeave: n.state.dragging && O ? n.swipeEnd : null,
        onTouchStart: O ? n.swipeStart : null,
        onTouchMove: n.state.dragging && O ? n.swipeMove : null,
        onTouchEnd: O ? n.touchEnd : null,
        onTouchCancel: n.state.dragging && O ? n.swipeEnd : null,
        onKeyDown: n.props.accessibility ? n.keyHandler : null
      }, z = {
        className: d,
        dir: "ltr",
        style: n.props.style
      };
      return n.props.unslick && (I = {
        className: "slick-list"
      }, z = {
        className: d
      }), /* @__PURE__ */ _0.default.createElement("div", z, n.props.unslick ? "" : y, /* @__PURE__ */ _0.default.createElement("div", Z1({
        ref: n.listRefHandler
      }, I), /* @__PURE__ */ _0.default.createElement(Yn.Track, Z1({
        ref: n.trackRefHandler
      }, c), n.props.children)), n.props.unslick ? "" : v, n.props.unslick ? "" : f);
    }), n.list = null, n.track = null, n.state = a0(a0({}, Wn.default), {}, {
      currentSlide: n.props.initialSlide,
      targetSlide: n.props.initialSlide ? n.props.initialSlide : 0,
      slideCount: _0.default.Children.count(n.props.children)
    }), n.callbackTimers = [], n.clickable = !0, n.debouncedResize = null;
    var o = n.ssrInit();
    return n.state = a0(a0({}, n.state), o), n;
  }
  return t3(a, [{
    key: "didPropsChange",
    value: function(n) {
      for (var o = !1, d = 0, s = Object.keys(this.props); d < s.length; d++) {
        var c = s[d];
        if (!n.hasOwnProperty(c)) {
          o = !0;
          break;
        }
        if (!(B0(n[c]) === "object" || typeof n[c] == "function" || isNaN(n[c])) && n[c] !== this.props[c]) {
          o = !0;
          break;
        }
      }
      return o || _0.default.Children.count(this.props.children) !== _0.default.Children.count(n.children);
    }
  }]), a;
}(_0.default.Component);
var s3 = function(t) {
  return t.replace(/[A-Z]/g, function(e) {
    return "-" + e.toLowerCase();
  }).toLowerCase();
}, l3 = s3, d3 = l3, c3 = function(t) {
  var e = /[height|width]$/;
  return e.test(t);
}, ca = function(t) {
  var e = "", a = Object.keys(t);
  return a.forEach(function(i, n) {
    var o = t[i];
    i = d3(i), c3(i) && typeof o == "number" && (o = o + "px"), o === !0 ? e += i : o === !1 ? e += "not " + i : e += "(" + i + ": " + o + ")", n < a.length - 1 && (e += " and ");
  }), e;
}, u3 = function(t) {
  var e = "";
  return typeof t == "string" ? t : t instanceof Array ? (t.forEach(function(a, i) {
    e += ca(a), i < t.length - 1 && (e += ", ");
  }), e) : ca(t);
}, h3 = u3, ie, ua;
function m3() {
  if (ua) return ie;
  ua = 1;
  function t(e) {
    this.options = e, !e.deferSetup && this.setup();
  }
  return t.prototype = {
    constructor: t,
    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup: function() {
      this.options.setup && this.options.setup(), this.initialised = !0;
    },
    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on: function() {
      !this.initialised && this.setup(), this.options.match && this.options.match();
    },
    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off: function() {
      this.options.unmatch && this.options.unmatch();
    },
    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy: function() {
      this.options.destroy ? this.options.destroy() : this.off();
    },
    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals: function(e) {
      return this.options === e || this.options.match === e;
    }
  }, ie = t, ie;
}
var ne, ha;
function Dt() {
  if (ha) return ne;
  ha = 1;
  function t(i, n) {
    var o = 0, d = i.length, s;
    for (o; o < d && (s = n(i[o], o), s !== !1); o++)
      ;
  }
  function e(i) {
    return Object.prototype.toString.apply(i) === "[object Array]";
  }
  function a(i) {
    return typeof i == "function";
  }
  return ne = {
    isFunction: a,
    isArray: e,
    each: t
  }, ne;
}
var oe, ma;
function f3() {
  if (ma) return oe;
  ma = 1;
  var t = m3(), e = Dt().each;
  function a(i, n) {
    this.query = i, this.isUnconditional = n, this.handlers = [], this.mql = window.matchMedia(i);
    var o = this;
    this.listener = function(d) {
      o.mql = d.currentTarget || d, o.assess();
    }, this.mql.addListener(this.listener);
  }
  return a.prototype = {
    constuctor: a,
    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler: function(i) {
      var n = new t(i);
      this.handlers.push(n), this.matches() && n.on();
    },
    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler: function(i) {
      var n = this.handlers;
      e(n, function(o, d) {
        if (o.equals(i))
          return o.destroy(), !n.splice(d, 1);
      });
    },
    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches: function() {
      return this.mql.matches || this.isUnconditional;
    },
    /**
     * Clears all handlers and unbinds events
     */
    clear: function() {
      e(this.handlers, function(i) {
        i.destroy();
      }), this.mql.removeListener(this.listener), this.handlers.length = 0;
    },
    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess: function() {
      var i = this.matches() ? "on" : "off";
      e(this.handlers, function(n) {
        n[i]();
      });
    }
  }, oe = a, oe;
}
var se, fa;
function p3() {
  if (fa) return se;
  fa = 1;
  var t = f3(), e = Dt(), a = e.each, i = e.isFunction, n = e.isArray;
  function o() {
    if (!window.matchMedia)
      throw new Error("matchMedia not present, legacy browsers require a polyfill");
    this.queries = {}, this.browserIsIncapable = !window.matchMedia("only all").matches;
  }
  return o.prototype = {
    constructor: o,
    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register: function(d, s, c) {
      var m = this.queries, f = c && this.browserIsIncapable;
      return m[d] || (m[d] = new t(d, f)), i(s) && (s = { match: s }), n(s) || (s = [s]), a(s, function(p) {
        i(p) && (p = { match: p }), m[d].addHandler(p);
      }), this;
    },
    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister: function(d, s) {
      var c = this.queries[d];
      return c && (s ? c.removeHandler(s) : (c.clear(), delete this.queries[d])), this;
    }
  }, se = o, se;
}
var le, pa;
function g3() {
  if (pa) return le;
  pa = 1;
  var t = p3();
  return le = new t(), le;
}
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var e = d(d0), a = G1, i = d(h3), n = d(Ce), o = B;
  function d(N) {
    return N && N.__esModule ? N : { default: N };
  }
  function s(N) {
    "@babel/helpers - typeof";
    return s = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Z) {
      return typeof Z;
    } : function(Z) {
      return Z && typeof Symbol == "function" && Z.constructor === Symbol && Z !== Symbol.prototype ? "symbol" : typeof Z;
    }, s(N);
  }
  function c() {
    return c = Object.assign ? Object.assign.bind() : function(N) {
      for (var Z = 1; Z < arguments.length; Z++) {
        var k = arguments[Z];
        for (var F in k)
          Object.prototype.hasOwnProperty.call(k, F) && (N[F] = k[F]);
      }
      return N;
    }, c.apply(this, arguments);
  }
  function m(N, Z) {
    var k = Object.keys(N);
    if (Object.getOwnPropertySymbols) {
      var F = Object.getOwnPropertySymbols(N);
      Z && (F = F.filter(function(U) {
        return Object.getOwnPropertyDescriptor(N, U).enumerable;
      })), k.push.apply(k, F);
    }
    return k;
  }
  function f(N) {
    for (var Z = 1; Z < arguments.length; Z++) {
      var k = arguments[Z] != null ? arguments[Z] : {};
      Z % 2 ? m(Object(k), !0).forEach(function(F) {
        z(N, F, k[F]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(N, Object.getOwnPropertyDescriptors(k)) : m(Object(k)).forEach(function(F) {
        Object.defineProperty(N, F, Object.getOwnPropertyDescriptor(k, F));
      });
    }
    return N;
  }
  function p(N, Z) {
    if (!(N instanceof Z))
      throw new TypeError("Cannot call a class as a function");
  }
  function b(N, Z) {
    for (var k = 0; k < Z.length; k++) {
      var F = Z[k];
      F.enumerable = F.enumerable || !1, F.configurable = !0, "value" in F && (F.writable = !0), Object.defineProperty(N, $(F.key), F);
    }
  }
  function y(N, Z, k) {
    return Z && b(N.prototype, Z), Object.defineProperty(N, "prototype", { writable: !1 }), N;
  }
  function v(N, Z) {
    if (typeof Z != "function" && Z !== null)
      throw new TypeError("Super expression must either be null or a function");
    N.prototype = Object.create(Z && Z.prototype, { constructor: { value: N, writable: !0, configurable: !0 } }), Object.defineProperty(N, "prototype", { writable: !1 }), Z && g(N, Z);
  }
  function g(N, Z) {
    return g = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(F, U) {
      return F.__proto__ = U, F;
    }, g(N, Z);
  }
  function _(N) {
    var Z = O();
    return function() {
      var F = I(N), U;
      if (Z) {
        var C = I(this).constructor;
        U = Reflect.construct(F, arguments, C);
      } else
        U = F.apply(this, arguments);
      return M(this, U);
    };
  }
  function M(N, Z) {
    if (Z && (s(Z) === "object" || typeof Z == "function"))
      return Z;
    if (Z !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return S(N);
  }
  function S(N) {
    if (N === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return N;
  }
  function O() {
    try {
      var N = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (O = function() {
      return !!N;
    })();
  }
  function I(N) {
    return I = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(k) {
      return k.__proto__ || Object.getPrototypeOf(k);
    }, I(N);
  }
  function z(N, Z, k) {
    return Z = $(Z), Z in N ? Object.defineProperty(N, Z, { value: k, enumerable: !0, configurable: !0, writable: !0 }) : N[Z] = k, N;
  }
  function $(N) {
    var Z = Q(N, "string");
    return s(Z) == "symbol" ? Z : String(Z);
  }
  function Q(N, Z) {
    if (s(N) != "object" || !N) return N;
    var k = N[Symbol.toPrimitive];
    if (k !== void 0) {
      var F = k.call(N, Z || "default");
      if (s(F) != "object") return F;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (Z === "string" ? String : Number)(N);
  }
  var i0 = (0, o.canUseDOM)() && g3();
  t.default = /* @__PURE__ */ function(N) {
    v(k, N);
    var Z = _(k);
    function k(F) {
      var U;
      return p(this, k), U = Z.call(this, F), z(S(U), "innerSliderRefHandler", function(C) {
        return U.innerSlider = C;
      }), z(S(U), "slickPrev", function() {
        return U.innerSlider.slickPrev();
      }), z(S(U), "slickNext", function() {
        return U.innerSlider.slickNext();
      }), z(S(U), "slickGoTo", function(C) {
        var P = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
        return U.innerSlider.slickGoTo(C, P);
      }), z(S(U), "slickPause", function() {
        return U.innerSlider.pause("paused");
      }), z(S(U), "slickPlay", function() {
        return U.innerSlider.autoPlay("play");
      }), U.state = {
        breakpoint: null
      }, U._responsiveMediaHandlers = [], U;
    }
    return y(k, [{
      key: "media",
      value: function(U, C) {
        i0.register(U, C), this._responsiveMediaHandlers.push({
          query: U,
          handler: C
        });
      }
      // handles responsive breakpoints
    }, {
      key: "componentDidMount",
      value: function() {
        var U = this;
        if (this.props.responsive) {
          var C = this.props.responsive.map(function(x) {
            return x.breakpoint;
          });
          C.sort(function(x, w) {
            return x - w;
          }), C.forEach(function(x, w) {
            var L;
            w === 0 ? L = (0, i.default)({
              minWidth: 0,
              maxWidth: x
            }) : L = (0, i.default)({
              minWidth: C[w - 1] + 1,
              maxWidth: x
            }), (0, o.canUseDOM)() && U.media(L, function() {
              U.setState({
                breakpoint: x
              });
            });
          });
          var P = (0, i.default)({
            minWidth: C.slice(-1)[0]
          });
          (0, o.canUseDOM)() && this.media(P, function() {
            U.setState({
              breakpoint: null
            });
          });
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this._responsiveMediaHandlers.forEach(function(U) {
          i0.unregister(U.query, U.handler);
        });
      }
    }, {
      key: "render",
      value: function() {
        var U = this, C, P;
        this.state.breakpoint ? (P = this.props.responsive.filter(function(X) {
          return X.breakpoint === U.state.breakpoint;
        }), C = P[0].settings === "unslick" ? "unslick" : f(f(f({}, n.default), this.props), P[0].settings)) : C = f(f({}, n.default), this.props), C.centerMode && (C.slidesToScroll > 1 && process.env.NODE_ENV !== "production" && console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(C.slidesToScroll)), C.slidesToScroll = 1), C.fade && (C.slidesToShow > 1 && process.env.NODE_ENV !== "production" && console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(C.slidesToShow)), C.slidesToScroll > 1 && process.env.NODE_ENV !== "production" && console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(C.slidesToScroll)), C.slidesToShow = 1, C.slidesToScroll = 1);
        var x = e.default.Children.toArray(this.props.children);
        x = x.filter(function(X) {
          return typeof X == "string" ? !!X.trim() : !!X;
        }), C.variableWidth && (C.rows > 1 || C.slidesPerRow > 1) && (console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1"), C.variableWidth = !1);
        for (var w = [], L = null, j = 0; j < x.length; j += C.rows * C.slidesPerRow) {
          for (var A = [], E = j; E < j + C.rows * C.slidesPerRow; E += C.slidesPerRow) {
            for (var q = [], W = E; W < E + C.slidesPerRow && (C.variableWidth && x[W].props.style && (L = x[W].props.style.width), !(W >= x.length)); W += 1)
              q.push(/* @__PURE__ */ e.default.cloneElement(x[W], {
                key: 100 * j + 10 * E + W,
                tabIndex: -1,
                style: {
                  width: "".concat(100 / C.slidesPerRow, "%"),
                  display: "inline-block"
                }
              }));
            A.push(/* @__PURE__ */ e.default.createElement("div", {
              key: 10 * j + E
            }, q));
          }
          C.variableWidth ? w.push(/* @__PURE__ */ e.default.createElement("div", {
            key: j,
            style: {
              width: L
            }
          }, A)) : w.push(/* @__PURE__ */ e.default.createElement("div", {
            key: j
          }, A));
        }
        if (C === "unslick") {
          var Y = "regular slider " + (this.props.className || "");
          return /* @__PURE__ */ e.default.createElement("div", {
            className: Y
          }, x);
        } else w.length <= C.slidesToShow && !C.infinite && (C.unslick = !0);
        return /* @__PURE__ */ e.default.createElement(a.InnerSlider, c({
          style: this.props.style,
          ref: this.innerSliderRefHandler
        }, (0, o.filterSettings)(C)), w);
      }
    }]), k;
  }(e.default.Component);
})(lt);
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var e = a(lt);
  function a(i) {
    return i && i.__esModule ? i : { default: i };
  }
  t.default = e.default;
})(st);
const Rt = /* @__PURE__ */ L0(st), ga = ({ className: t, style: e, onClick: a, direction: i }) => /* @__PURE__ */ r(
  V,
  {
    component: "button",
    className: t,
    style: { ...e, display: "flex" },
    onClick: a,
    fontSize: 30,
    width: 40,
    height: 40,
    justifyContent: "center",
    alignItems: "center",
    color: "secondary.700",
    sx: {
      bgcolor: "secondary.50",
      ":hover": { color: "secondary.900", bgcolor: "secondary.50" },
      ":focus": { color: "secondary.900", bgcolor: "secondary.50" }
    },
    borderRadius: 50,
    children: i === "left" ? /* @__PURE__ */ r(Kr, {}) : /* @__PURE__ */ r(nt, {})
  }
), v3 = {
  dots: !0,
  infinite: !0,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: !0,
  autoplaySpeed: 2e3,
  responsive: [
    {
      breakpoint: 900,
      settings: {
        infinite: !0,
        dots: !0,
        arrows: !1
      }
    }
  ],
  customPaging: () => /* @__PURE__ */ r(V, { width: 32, height: 4, borderRadius: 8, bgcolor: "secondary.500" }),
  nextArrow: /* @__PURE__ */ r(ga, { direction: "right" }),
  prevArrow: /* @__PURE__ */ r(ga, { direction: "left" })
}, L6 = (t) => {
  const e = { ...v3, ...t.settings };
  return /* @__PURE__ */ r(Rt, { ...e, className: `cfm-slider ${t.className || ""}`, children: t.content });
}, k6 = ({
  title: t,
  description: e,
  mediaUrl: a,
  altUrl: i,
  cta: n,
  bgColor: o = "surfaces.yellow"
}) => /* @__PURE__ */ h(V, { position: "relative", display: { xs: "block", sm: "flex" }, paddingBottom: "5.4rem", children: [
  /* @__PURE__ */ r(
    V,
    {
      top: { sm: "1.875rem" },
      width: { xs: "100%", sm: "80%" },
      height: { xs: "99%", sm: "90%" },
      position: "absolute",
      zIndex: -1,
      bgcolor: o
    }
  ),
  /* @__PURE__ */ r(V, { width: { xs: "100%", sm: "40%", lg: "50%" }, marginLeft: { sm: 6 }, children: /* @__PURE__ */ r(
    "img",
    {
      loading: "lazy",
      src: a,
      alt: i,
      style: {
        width: "100%",
        height: "100%",
        backgroundColor: "grey",
        objectFit: "cover"
      }
    }
  ) }),
  /* @__PURE__ */ h(
    V,
    {
      marginX: { xs: 2, sm: 0 },
      marginLeft: { sm: 4 },
      marginTop: { xs: 4, sm: 9 },
      width: { xs: "fit-content", sm: "60%" },
      children: [
        typeof t == "string" ? /* @__PURE__ */ r(R, { variant: "h3", marginBottom: 2, children: t }) : t,
        typeof e == "string" ? /* @__PURE__ */ r(R, { variant: "body1", marginBottom: { xs: 4, lg: 7 }, children: e }) : e,
        /* @__PURE__ */ r(V, { textAlign: { xs: "center", sm: "left" }, children: /* @__PURE__ */ r(I0, { cta: n }) })
      ]
    }
  )
] }), b3 = (t) => {
  const { children: e, value: a, index: i } = t;
  return /* @__PURE__ */ r(
    V,
    {
      component: "div",
      role: "tabpanel",
      hidden: a !== i,
      id: `simple-tabpanel-${i}`,
      "aria-labelledby": `simple-tab-${i}`,
      children: a === i && /* @__PURE__ */ r(V, { children: e })
    }
  );
}, N6 = ({
  title: t,
  description: e,
  tabs: a,
  paddingBottom: i = 4,
  paddingTop: n = 4
}) => {
  const [o, d] = d0.useState(0), [s, c] = d0.useState(!1), m = (f, p) => {
    d(p);
  };
  return d0.useEffect(() => {
    const f = document.getElementById("tabs-horizontal-cfm"), p = f == null ? void 0 : f.parentElement, b = f == null ? void 0 : f.querySelector('[role="tablist"]'), y = () => {
      if (p && b) {
        const v = p.offsetWidth, g = b.scrollWidth;
        c(g > v);
      }
    };
    return y(), window.addEventListener("resize", y), () => {
      window.removeEventListener("resize", y);
    };
  }, []), /* @__PURE__ */ h(V, { component: "section", pb: i, pt: n, children: [
    /* @__PURE__ */ r(R0, { title: t }),
    typeof e == "string" ? /* @__PURE__ */ r(R, { variant: "body1", marginBottom: 6, align: "center", children: e }) : e,
    /* @__PURE__ */ r(
      O1,
      {
        id: "tabs-horizontal-cfm",
        value: o,
        onChange: m,
        sx: { marginBottom: { xs: 4, sm: 6 } },
        orientation: "horizontal",
        variant: s ? "scrollable" : "standard",
        scrollButtons: "auto",
        centered: !0,
        children: a.map((f, p) => /* @__PURE__ */ r(
          E1,
          {
            label: f.label,
            value: p,
            sx: {
              marginRight: p === a.length - 1 ? 0 : { xs: 2, md: 6 }
            }
          },
          v0()
        ))
      }
    ),
    a.map((f, p) => /* @__PURE__ */ r(b3, { value: o, index: p, children: f.content }, v0()))
  ] });
}, y3 = (t) => {
  const { children: e, value: a, index: i } = t;
  return /* @__PURE__ */ r(
    V,
    {
      component: "div",
      role: "tabpanel",
      hidden: a !== i,
      id: `simple-tabpanel-${i}`,
      "aria-labelledby": `simple-tab-${i}`,
      children: a === i && /* @__PURE__ */ r(V, { children: e })
    }
  );
}, G6 = ({
  title: t,
  tabs: e,
  paddingBottom: a = 4,
  paddingTop: i = 4
}) => {
  const [n, o] = d0.useState(0), d = k0(), s = V1(d.breakpoints.up("md")), c = d0.useRef([]), [m, f] = d0.useState({
    width: 0,
    top: 0,
    left: 0
  }), p = (b, y) => {
    o(y);
  };
  return d0.useEffect(() => {
    if (c.current[n]) {
      const b = c.current[n].offsetWidth, y = c.current[n].offsetTop;
      f({
        width: b,
        left: 0,
        top: y + c.current[n].offsetHeight - 4
      });
    }
  }, [n]), /* @__PURE__ */ h(V, { component: "section", pb: a, pt: i, children: [
    /* @__PURE__ */ r(R0, { title: t }),
    /* @__PURE__ */ h(h0, { container: !0, children: [
      /* @__PURE__ */ r(h0, { item: !0, xs: 12, md: 3, children: /* @__PURE__ */ r(
        O1,
        {
          value: n,
          onChange: p,
          sx: { marginBottom: { xs: 4, sm: 6 } },
          orientation: s ? "vertical" : "horizontal",
          variant: "scrollable",
          scrollButtons: "auto",
          TabIndicatorProps: { style: s && m },
          children: e.map((b, y) => /* @__PURE__ */ r(
            E1,
            {
              label: b.label,
              value: y,
              ref: (v) => c.current[y] = v,
              sx: {
                marginBottom: s && (y === e.length - 1 ? 0 : 2),
                marginRight: !s && (y === e.length - 1 ? 0 : { xs: 2, md: 6 })
              }
            },
            v0()
          ))
        }
      ) }),
      /* @__PURE__ */ r(h0, { item: !0, md: 9, children: e.map((b, y) => /* @__PURE__ */ r(y3, { value: n, index: y, children: b.content }, v0())) })
    ] })
  ] });
}, _3 = {
  "top-left": { top: 0, left: 0 },
  "top-right": { top: 0, right: 0 },
  "bottom-left": { bottom: 0, left: 0 },
  "bottom-right": { bottom: 0, right: 0 }
}, I6 = ({
  content: t,
  navigationPosition: e = "bottom-right"
}) => {
  const a = W0(null), [i, n] = Z0(0), o = () => {
    a.current && a.current.slickNext();
  }, d = () => {
    a.current && a.current.slickPrev();
  };
  return /* @__PURE__ */ h(
    V,
    {
      sx: {
        backgroundColor: "secondary.700",
        width: "100%",
        position: "relative"
      },
      children: [
        /* @__PURE__ */ r(Rt, { className: "cfm-custom-slider", ref: a, ...{
          dots: !1,
          arrows: !1,
          infinite: !0,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: !1,
          autoplaySpeed: 2e3,
          afterChange: (c) => n(c),
          responsive: [
            {
              breakpoint: 900,
              settings: {
                infinite: !0,
                dots: !1,
                arrows: !1
              }
            }
          ]
        }, children: t }),
        /* @__PURE__ */ r(
          V,
          {
            sx: (c) => ({
              ..._3[e],
              position: "absolute",
              backgroundColor: "primary.main",
              maxWidth: c.spacing(40),
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column"
            }),
            children: /* @__PURE__ */ h(
              V,
              {
                sx: {
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center"
                },
                children: [
                  /* @__PURE__ */ r(
                    D0,
                    {
                      variant: "text",
                      onClick: d,
                      sx: {
                        px: 2,
                        py: 1,
                        fontWeight: "bold",
                        fontSize: { xs: 0, md: 14 },
                        color: "common.white",
                        "&:hover": {
                          color: "primary.dark",
                          backgroundColor: "none"
                        }
                      },
                      endIcon: /* @__PURE__ */ r(Xr, {}),
                      children: "Atrás"
                    }
                  ),
                  /* @__PURE__ */ r(
                    D0,
                    {
                      variant: "text",
                      onClick: o,
                      sx: {
                        px: 2,
                        py: 1,
                        fontWeight: "bold",
                        color: "common.white",
                        fontSize: { xs: 0, md: 14 },
                        "&:hover": {
                          color: "primary.dark",
                          backgroundColor: "none"
                        }
                      },
                      startIcon: /* @__PURE__ */ r(Qr, {}),
                      children: "Siguiente"
                    }
                  ),
                  /* @__PURE__ */ h(
                    R,
                    {
                      sx: {
                        color: "common.white",
                        px: 3,
                        py: 1
                      },
                      children: [
                        i + 1,
                        "/",
                        t.length
                      ]
                    }
                  )
                ]
              }
            )
          }
        )
      ]
    }
  );
}, w3 = (t) => {
  const { children: e, value: a, index: i } = t;
  return /* @__PURE__ */ r(
    V,
    {
      component: "div",
      role: "tabpanel",
      hidden: a !== i,
      id: `simple-tabpanel-${i}`,
      "aria-labelledby": `simple-tab-${i}`,
      children: a === i && /* @__PURE__ */ r(V, { children: e })
    }
  );
}, F6 = ({
  title: t,
  description: e,
  tabs: a,
  paddingBottom: i = 2,
  paddingTop: n = 2,
  bannerMediaUrl: o,
  bannerTitle: d,
  bannerDescription: s
}) => {
  const [c, m] = d0.useState(0), [f, p] = d0.useState(!1), b = (y, v) => {
    m(v);
  };
  return d0.useEffect(() => {
    const y = document.getElementById("tabs-horizontal-cfm"), v = y == null ? void 0 : y.parentElement, g = y == null ? void 0 : y.querySelector('[role="tablist"]'), _ = () => {
      if (v && g) {
        const M = v.offsetWidth, S = g.scrollWidth;
        p(S > M);
      }
    };
    return _(), window.addEventListener("resize", _), () => {
      window.removeEventListener("resize", _);
    };
  }, []), /* @__PURE__ */ h(V, { component: "section", pb: i, pt: n, children: [
    /* @__PURE__ */ r(R0, { title: t }),
    typeof e == "string" ? /* @__PURE__ */ r(R, { variant: "body1", marginBottom: 6, align: "center", children: e }) : e,
    /* @__PURE__ */ h(h0, { container: !0, spacing: 4, children: [
      /* @__PURE__ */ r(h0, { item: !0, xs: 12, md: 6, children: /* @__PURE__ */ r(
        fi,
        {
          mediaUrl: o,
          title: d,
          description: s,
          cta: {
            label: "Conoce esta nueva sede",
            action: "#"
          },
          paddingTop: 25,
          paddingBottom: 4
        }
      ) }),
      /* @__PURE__ */ h(h0, { item: !0, xs: 12, md: 6, children: [
        /* @__PURE__ */ r(
          O1,
          {
            id: "tabs-horizontal-cfm",
            value: c,
            onChange: b,
            sx: { marginBottom: { xs: 4, sm: 6 } },
            orientation: "horizontal",
            variant: f ? "scrollable" : "standard",
            scrollButtons: "auto",
            centered: !0,
            children: a.map((y, v) => /* @__PURE__ */ r(
              E1,
              {
                label: y.label,
                value: v,
                sx: {
                  marginRight: v === a.length - 1 ? 0 : { xs: 2, md: 4 }
                }
              },
              v0()
            ))
          }
        ),
        a.map((y, v) => /* @__PURE__ */ r(w3, { value: c, index: v, children: y.content }, v0()))
      ] })
    ] })
  ] });
};
function T3(t) {
  return b0({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M405 136.798L375.202 107 256 226.202 136.798 107 107 136.798 226.202 256 107 375.202 136.798 405 256 285.798 375.202 405 405 375.202 285.798 256z" }, child: [] }] })(t);
}
const D6 = ({
  children: t,
  icon: e,
  placeholder: a,
  tagsTitle: i,
  tags: n,
  secondaryTags: o,
  inputId: d,
  debouncingValue: s = 500,
  onSubmit: c,
  onInput: m,
  onUpdateTags: f,
  onUpdateSecondaryTags: p,
  containerSx: b,
  suggestionsContainerSx: y,
  tagsTitleSx: v,
  customTagSx: g,
  isLoading: _ = !1,
  loader: M,
  noResultStatus: S = !1,
  noResultsContent: O,
  autoFocus: I = !1
}) => {
  const [z, $] = Z0(/* @__PURE__ */ new Set()), [Q, i0] = Z0(/* @__PURE__ */ new Set()), [N, Z] = Z0(""), [k, F] = Z0(""), [U, C] = Z0(I), P = W0(null), x = W0(null), { spacing: w } = ya(), L = () => C(!0), j = () => {
    F(""), Z("");
  }, A = (D) => {
    x.current && !x.current.contains(D.target) && C(!1);
  }, E = (D) => {
    D.preventDefault(), k && (m == null || m(k), c == null || c());
  }, q = (D) => {
    F(D.target.value), P.current && clearTimeout(P.current), P.current = setTimeout(() => {
      Z(D.target.value);
    }, s);
  }, W = (D, K, n0) => {
    if (K.has(D))
      return K.delete(D), K;
    const [G] = n0.filter((m0) => m0 == null ? void 0 : m0.isHead);
    return D === (G == null ? void 0 : G.content) ? (K.clear(), K.add(D)) : (K.delete(G == null ? void 0 : G.content), K.add(D)), K;
  }, Y = (D, K = "main") => {
    if (K === "secondary") {
      $(
        (n0) => W(D, new Set(n0), o)
      );
      return;
    }
    i0((n0) => W(D, new Set(n0), n));
  }, X = {
    border: `${w(0.125)} solid ${l0.tertiary[300]}`,
    borderRadius: w(1),
    paddingY: w(0.75),
    paddingX: w(1.25),
    "&:hover": {
      cursor: "pointer",
      boxShadow: `${w(0)} ${w(0.5)} ${w(1)} ${w(0)} ${l0.secondary[400]}`,
      backgroundColor: l0.tertiary[600],
      "& .MuiChip-label": {
        color: l0.common.white
      }
    }
  }, e0 = {
    backgroundColor: "transparent",
    paddingBottom: { xs: w(1.75), sm: w(2.75) },
    "&:before": {
      borderBottom: `${w(0.25)} solid ${l0.common.black} !important`
    },
    "&:hover:before": {
      borderBottom: `${w(0.25)} solid ${l0.primary[300]} !important`
    },
    "&:after": {
      borderBottomColor: l0.common.black
    },
    "& .MuiInputBase-input": {
      padding: 0,
      color: "typography.main",
      fontWeight: "500",
      fontSize: "clamp(1.25rem, 0.625vw + 1.125rem, 1.688rem)",
      lineHeight: "clamp(1.563rem, 0.902vw + 1.382rem, 2.194rem)"
    },
    "& .MuiInputBase-input::selection": {
      backgroundColor: l0.info[100]
    }
  }, J = {
    borderRadius: "100%",
    padding: { xs: w(0.655), sm: w(0.7875) },
    backgroundColor: l0.secondary[700],
    width: { xs: w(3.25), sm: w(4.125) },
    height: { xs: w(3.25), sm: w(4.125) },
    "&:hover": {
      backgroundColor: l0.common.black
    }
  }, t0 = {
    "&::-webkit-scrollbar": {
      width: w(0.375)
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: l0.tertiary[300],
      borderRadius: w(2.5)
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: l0.secondary[400],
      border: `${w(0.125)} solid ${l0.secondary[400]}`,
      borderRadius: w(2.5)
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "darkGray",
      borderColor: "darkGray"
    }
  };
  return F0(() => {
    m == null || m(N);
  }, [N]), F0(() => {
    f == null || f([...Q]);
  }, [Q]), F0(() => {
    p == null || p([...z]);
  }, [z]), F0(() => (document.addEventListener("mousedown", A), () => {
    document.removeEventListener("mousedown", A), P.current && clearTimeout(P.current);
  }), []), /* @__PURE__ */ h(
    a1,
    {
      ref: x,
      sx: {
        display: "grid",
        position: "relative",
        borderRadius: w(1.5),
        backgroundColor: U ? "surfaces.light" : "transparent",
        padding: {
          xs: `${w(2.625)} ${w(1.75)} ${w(3.375)}`,
          sm: `${w(4.125)} ${w(3)} ${w(3.625)}`
        },
        boxShadow: U ? `${w(0)} ${w(0.5)} ${w(1)} ${w(0)} ${l0.secondary[400]}` : "transparent",
        ...b
      },
      "data-testid": "filter-search-container",
      children: [
        /* @__PURE__ */ r("form", { onSubmit: E, children: /* @__PURE__ */ r(V, { "aria-label": "Formulario de búsqueda", display: "flex", alignItems: "center", children: /* @__PURE__ */ r(
          wa,
          {
            id: d,
            variant: "standard",
            placeholder: a,
            value: k,
            onChange: q,
            onFocus: L,
            "aria-label": "Campo de texto para la búsqueda",
            InputProps: {
              startAdornment: /* @__PURE__ */ r(de, { position: "start", children: /* @__PURE__ */ r(
                v1,
                {
                  onClick: L,
                  "aria-label": "Buscar",
                  sx: {
                    position: "relative",
                    padding: `${w(2.5)} ${w(1)}`,
                    marginRight: { xs: w(0.655), sm: w(1) },
                    width: { xs: w(2.2975), sm: w(4.054) },
                    height: { xs: w(2.23), sm: w(3.919) },
                    color: "typography.main"
                  },
                  children: e
                }
              ) }),
              endAdornment: /* @__PURE__ */ r(de, { position: "end", children: k && /* @__PURE__ */ r(
                v1,
                {
                  onClick: j,
                  "aria-label": "Limpiar texto escrito",
                  sx: J,
                  children: /* @__PURE__ */ r(T3, { color: l0.common.white, width: "100%", height: "100%" })
                }
              ) }),
              sx: e0
            },
            sx: { width: "100%" }
          }
        ) }) }),
        U && /* @__PURE__ */ h(H0, { children: [
          t && !S && (_ ? /* @__PURE__ */ r(
            V,
            {
              "aria-label": "Cargando",
              display: "flex",
              justifyContent: "center",
              width: "100%",
              height: "fit-content",
              marginY: { xs: w(1.375), sm: w(2.25) },
              children: M
            }
          ) : /* @__PURE__ */ r(
            V,
            {
              height: "fit-content",
              maxHeight: { xs: w(40), sm: w(34) },
              marginY: { xs: w(1.375), sm: w(2.25) },
              overflow: "auto",
              sx: {
                ...t0,
                ...y
              },
              children: t
            }
          )),
          S && /* @__PURE__ */ r(
            V,
            {
              "aria-label": "Mensaje de no resultados",
              display: "flex",
              justifyContent: "center",
              width: "100%",
              height: "fit-content",
              marginY: { xs: w(1.375), sm: w(2.25) },
              children: O
            }
          ),
          /* @__PURE__ */ r(_a, {})
        ] }),
        (n || o) && U && /* @__PURE__ */ h(H0, { children: [
          /* @__PURE__ */ r(
            R,
            {
              component: "h3",
              fontSize: "clamp(1rem, 0.231vw + 0.94rem, 1.125rem) !important",
              lineHeight: "clamp(1.25rem, 0.33vw + 1.165rem, 1.429rem) !important",
              marginY: { xs: w(1.375), sm: w(2.875) },
              sx: v,
              children: i
            }
          ),
          /* @__PURE__ */ h(V, { display: "flex", flexWrap: "wrap", gap: 1, children: [
            n == null ? void 0 : n.map((D) => /* @__PURE__ */ r(
              Oe,
              {
                id: D.id,
                label: D.content,
                onClick: () => Y(D.content),
                "aria-label": `Filtrar por ${D.content}`,
                sx: {
                  ...X,
                  backgroundColor: Q.has(D.content) ? l0.tertiary[600] : l0.common.white,
                  "& .MuiChip-label": {
                    fontWeight: "500",
                    fontSize: w(2.25),
                    lineHeight: w(2.875),
                    color: Q.has(D.content) ? l0.common.white : l0.common.black
                  },
                  ...g
                }
              },
              `${D.id}-${Q.has(D.content)}`
            )),
            o == null ? void 0 : o.map((D) => /* @__PURE__ */ r(
              Oe,
              {
                id: D.id,
                label: D.content,
                onClick: () => Y(D.content, "secondary"),
                "aria-label": `Filtrar por ${D.content}`,
                sx: {
                  ...X,
                  backgroundColor: z.has(D.content) ? l0.tertiary[600] : l0.common.white,
                  "& .MuiChip-label": {
                    fontWeight: "500",
                    fontSize: w(2.25),
                    lineHeight: w(2.875),
                    color: z.has(D.content) ? l0.common.white : l0.common.black
                  },
                  ...g
                }
              },
              `${D.id}-${z.has(D.content)}`
            ))
          ] })
        ] })
      ]
    }
  );
}, S3 = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Generator:%20Adobe%20Illustrator%2022.1.0,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%206.00%20Build%200)%20--%3e%3csvg%20version='1.1'%20id='Layer_1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20width='143.1px'%20height='24px'%20viewBox='0%200%20143.1%2024'%20enable-background='new%200%200%20143.1%2024'%20xml:space='preserve'%3e%3cpath%20id='Combined-Shape'%20fill='%23E7E7E7'%20d='M74.3,0c1.7,0,3.1,0.7,3.1,2.2c0,0.9-0.7,1.6-1.5,1.6c-0.4,0-0.7-0.1-1-0.1%20c-0.7,0-1,0.4-1,1.1v2h1.4c1.4,0,2.1,0.4,2.1,1.5c0,1.1-0.7,1.5-2.1,1.5h-1.4v11.7c0,1.5-0.9,2.3-2.3,2.3c-1.4,0-2.3-0.8-2.3-2.3%20V9.9H68c-1.3,0-1.9-0.5-1.9-1.5c0-1,0.5-1.5,1.9-1.5h1.1V4.5C69.1,1.6,71.5,0,74.3,0z%20M117.2,6.4c3.2,0,5.9,1.5,5.9,5.7v9.6%20c0,1.2-0.5,2.3-2.3,2.3c-1.8,0-2.3-1.1-2.3-2.3v-8.4c0-1.7-0.7-3-2.6-3c-1.8,0-3.4,1.4-3.4,3.6v7.8c0,1.2-0.5,2.3-2.3,2.3%20c-1.8,0-2.3-1.1-2.3-2.3v-8.4c0-1.7-0.7-3-2.6-3c-1.8,0-3.4,1.4-3.4,3.6v7.8c0,1.2-0.5,2.3-2.3,2.3c-1.8,0-2.3-1.1-2.3-2.3V8.8%20c0-1.4,0.8-2.3,2.2-2.3c1.4,0,2.2,0.9,2.2,2.3v0.6h0.1c1.2-1.9,3.3-2.9,5.7-2.9c1.6,0,3.6,0.7,4.5,2.9C113,7.6,114.7,6.4,117.2,6.4z%20M58,6.4c3.2,0,5.9,1.5,5.9,5.7v9.6c0,1.2-0.5,2.3-2.3,2.3c-1.8,0-2.3-1.1-2.3-2.3v-8.4c0-1.7-0.7-3-2.6-3c-1.8,0-3.4,1.4-3.4,3.6%20v7.8c0,1.2-0.5,2.3-2.3,2.3c-1.8,0-2.3-1.1-2.3-2.3v-8.4c0-1.7-0.7-3-2.6-3c-1.8,0-3.4,1.4-3.4,3.6v7.8c0,1.2-0.5,2.3-2.3,2.3%20c-1.8,0-2.3-1.1-2.3-2.3V8.8c0-1.4,0.8-2.3,2.2-2.3c1.4,0,2.2,0.9,2.2,2.3v0.6h0.1c1.2-1.9,3.3-2.9,5.7-2.9c1.6,0,3.6,0.7,4.5,2.9%20C53.8,7.6,55.5,6.4,58,6.4z%20M8.8,6.4c3.9,0,6.8,2.2,6.8,4.4c0,1.3-1,2-2.2,2c-2.2,0-1.4-2.8-4.8-2.8c-1.8,0-4,1.2-4,5.5%20c0,2.9,1.4,4.8,4,4.8c3.3,0,2.6-3,5-3c1.2,0,2,0.9,2,1.8c0,2-2.3,4.9-7.1,4.9C2.7,24,0,20.4,0,15.6C0,10.2,3.1,6.4,8.8,6.4z%20M26.9,6.1c2.1,0.1,4.1,1,5.7,2.6c1.7,1.7,2.6,4,2.6,6.3c0,2.3-0.9,4.6-2.6,6.3c-1.7,1.7-4,2.6-6.3,2.6h0c-2.3,0-4.6-0.9-6.3-2.6%20c-1.7-1.7-2.6-4-2.6-6.3c0-2.3,0.9-4.6,2.6-6.3c0.8-0.8,2.1-0.8,2.9,0c0.8,0.8,0.8,2.1,0,2.9c-1,0.9-1.4,2.2-1.4,3.4%20c0,1.2,0.5,2.5,1.4,3.4c1,0.9,2.2,1.4,3.4,1.4c1.3,0,2.5-0.5,3.4-1.4c1-0.9,1.4-2.2,1.4-3.4c0-1.2-0.5-2.5-1.4-3.4%20c-0.9-0.9-2-1.3-3.1-1.4c-1.1-0.1-2-1-1.9-2.2C24.8,6.9,25.7,6.1,26.9,6.1z%20M134.4,6.5c0.7,0,1.4,0.4,1.8,1.1l6.8,13.4l0,0%20c0.5,1,0.1,2.1-0.9,2.6c-0.3,0.1-0.6,0.2-0.9,0.2c-0.7,0-1.4-0.4-1.8-1.1l-5-9.9l-3.6,7.1l4.3,0c1.1,0,2,0.9,2,1.9%20c0,1.1-0.9,1.9-2,1.9h-7.5c-0.7,0-1.3-0.3-1.7-0.9c-0.4-0.6-0.4-1.3-0.1-1.9l6.7-13.4C132.9,6.9,133.6,6.5,134.4,6.5z%20M87.5,7.5%20L94.2,21c0.3,0.6,0.3,1.3-0.1,1.9c-0.4,0.6-1,0.9-1.7,0.9H78.9c-0.7,0-1.3-0.3-1.7-0.9c-0.4-0.6-0.4-1.3-0.1-1.9l3.8-7.5%20c0.5-1,1.7-1.4,2.6-0.9c1,0.5,1.4,1.7,0.9,2.6l-2.3,4.6h7.1L84,9.3h0c-0.5-1-0.1-2.1,0.9-2.6C85.8,6.2,87,6.6,87.5,7.5z'/%3e%3c/svg%3e";
function M3(t) {
  return b0({ tag: "svg", attr: { viewBox: "0 0 448 512" }, child: [{ tag: "path", attr: { d: "M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z" }, child: [] }] })(t);
}
function A3(t) {
  return b0({ tag: "svg", attr: { viewBox: "0 0 448 512" }, child: [{ tag: "path", attr: { d: "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z" }, child: [] }] })(t);
}
const z3 = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20id='Capa_1'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20142.67%20784'%3e%3cdefs%3e%3cstyle%3e.cls-1{fill:%23595959;}.cls-1,.cls-2,.cls-3,.cls-4{stroke-width:0px;}.cls-2{fill:%23eec031;}.cls-3{fill:%2330407a;}.cls-4{fill:%23c82229;}%3c/style%3e%3c/defs%3e%3cpath%20class='cls-1'%20d='M82.93,521.8c-.82,2.64-1.97,4.87-3.45,6.69l-5.24-2.4c1.45-1.89,2.51-3.89,3.18-5.99.67-2.1,1-4.37,1-6.82,0-2.71-.47-4.8-1.42-6.27-.95-1.47-2.27-2.2-3.98-2.2-1.49,0-2.62.68-3.4,2.03-.78,1.36-1.52,3.61-2.23,6.77-.7,3.27-1.52,5.92-2.45,7.97-.93,2.04-2.12,3.58-3.56,4.62-1.45,1.04-3.29,1.56-5.52,1.56-2.3,0-4.36-.63-6.18-1.89-1.82-1.26-3.24-3.04-4.26-5.35-1.02-2.3-1.53-4.96-1.53-7.97,0-2.75.42-5.37,1.25-7.86.84-2.49,1.98-4.53,3.43-6.13l5.24,2.4c-2.78,3.49-4.18,7.35-4.18,11.59,0,2.53.51,4.52,1.53,5.99,1.02,1.47,2.44,2.2,4.26,2.2,1.52,0,2.69-.65,3.51-1.95.82-1.3,1.58-3.51,2.28-6.63.74-3.31,1.57-5.99,2.48-8.05.91-2.06,2.07-3.64,3.48-4.74,1.41-1.09,3.19-1.64,5.35-1.64,2.34,0,4.39.62,6.16,1.87,1.76,1.24,3.12,3.05,4.07,5.4.95,2.36,1.42,5.13,1.42,8.33,0,3.01-.41,5.83-1.23,8.47Z'/%3e%3cpath%20class='cls-1'%20d='M56.41,466.7h27.24s0,6.8,0,6.8h-4.18c1.49.85,2.63,2.01,3.43,3.45.8,1.45,1.2,3.08,1.2,4.9,0,6.69-3.75,10.03-11.25,10.03h-16.43s0-6.96,0-6.96h16.49c1.93,0,3.36-.39,4.29-1.17.93-.78,1.39-2.01,1.39-3.68,0-1.93-.64-3.48-1.92-4.65-1.28-1.17-2.98-1.75-5.1-1.75h-15.15s0-6.96,0-6.96Z'/%3e%3cpath%20class='cls-1'%20d='M57.53,437.53c1.19-1.84,2.87-3.27,5.04-4.29,2.17-1.02,4.67-1.53,7.49-1.53s5.29.51,7.41,1.53c2.12,1.02,3.75,2.44,4.9,4.26,1.15,1.82,1.73,3.92,1.73,6.3,0,1.93-.41,3.66-1.23,5.18-.82,1.52-1.95,2.69-3.4,3.51h14.21s0,6.96,0,6.96h-37.27s0-6.85,0-6.85h4.12c-1.52-.82-2.7-2-3.54-3.54-.84-1.54-1.25-3.3-1.25-5.26,0-2.34.6-4.43,1.78-6.27ZM76.44,440.52c-1.51-1.23-3.63-1.84-6.38-1.84-2.82,0-5.01.61-6.58,1.84-1.56,1.23-2.34,2.93-2.34,5.13,0,2.23.76,3.95,2.28,5.15,1.52,1.21,3.7,1.81,6.52,1.81,2.79,0,4.94-.6,6.46-1.81,1.52-1.21,2.28-2.92,2.28-5.15,0-2.19-.75-3.9-2.26-5.13Z'/%3e%3cpath%20class='cls-1'%20d='M71.29,402.07v18.55c2.53-.22,4.4-.98,5.63-2.28,1.23-1.3,1.84-3.16,1.84-5.57,0-3.01-.96-5.76-2.9-8.24l4.79-2.01c1.04,1.26,1.88,2.85,2.51,4.76.63,1.91.95,3.84.95,5.77,0,4.46-1.26,7.98-3.79,10.56-2.53,2.58-5.98,3.87-10.36,3.87-2.78,0-5.25-.56-7.41-1.67-2.15-1.11-3.83-2.68-5.01-4.71-1.19-2.02-1.78-4.32-1.78-6.88,0-3.75,1.21-6.71,3.62-8.89s5.74-3.26,9.97-3.26h1.95ZM62.43,418.54c1.19,1.13,2.9,1.83,5.13,2.09v-12.59c-2.27.07-3.98.63-5.15,1.67-1.17,1.04-1.75,2.49-1.75,4.35,0,1.86.59,3.35,1.78,4.48Z'/%3e%3cpath%20class='cls-1'%20d='M61.54,378.45l.39,4.07c.48,4.61,2.82,6.91,7.02,6.91h14.71s0,6.96,0,6.96h-27.24s0-6.63,0-6.63h4.79c-3.27-1.41-5.05-4.33-5.35-8.75l-.17-2.12,5.85-.45Z'/%3e%3cpath%20class='cls-1'%20d='M83.21,371.96c-.59,2.03-1.45,3.74-2.56,5.15l-4.85-1.95c2.12-2.9,3.18-6.22,3.18-9.97,0-1.6-.26-2.81-.78-3.65-.52-.84-1.26-1.25-2.23-1.25-.82,0-1.45.29-1.89.86-.45.58-.85,1.61-1.23,3.09l-1,4.46c-.56,2.53-1.47,4.4-2.73,5.63-1.26,1.23-2.9,1.84-4.9,1.84-1.67,0-3.15-.47-4.43-1.42-1.28-.95-2.27-2.27-2.98-3.96-.7-1.69-1.06-3.65-1.06-5.88,0-1.93.3-3.8.89-5.6.59-1.8,1.43-3.39,2.51-4.76l4.74,1.95c-2.04,2.82-3.06,5.65-3.06,8.47,0,1.52.28,2.71.84,3.57.56.85,1.34,1.28,2.34,1.28.74,0,1.36-.27,1.84-.81s.85-1.4,1.11-2.59l1.06-4.62c.59-2.71,1.53-4.7,2.81-5.96,1.28-1.26,2.96-1.89,5.04-1.89,2.53,0,4.53,1.02,6.02,3.06,1.49,2.04,2.23,4.81,2.23,8.3,0,2.42-.3,4.63-.89,6.66Z'/%3e%3cpath%20class='cls-1'%20d='M56.41,323.3h27.24s0,6.8,0,6.8h-4.18c1.49.85,2.63,2,3.43,3.45.8,1.45,1.2,3.08,1.2,4.9,0,6.68-3.75,10.03-11.25,10.03h-16.43s0-6.96,0-6.96h16.49c1.93,0,3.36-.39,4.29-1.17.93-.78,1.39-2,1.39-3.68,0-1.93-.64-3.48-1.92-4.65-1.28-1.17-2.98-1.76-5.1-1.76h-15.15s0-6.96,0-6.96Z'/%3e%3cpath%20class='cls-1'%20d='M57.47,294.11c1.15-1.82,2.79-3.24,4.9-4.26,2.12-1.02,4.59-1.53,7.41-1.53s5.32.51,7.49,1.53c2.17,1.02,3.85,2.45,5.04,4.29,1.19,1.84,1.78,3.93,1.78,6.27,0,1.97-.43,3.72-1.28,5.26-.85,1.54-2.04,2.72-3.57,3.54h4.4s0,6.85,0,6.85h-39.28s0-6.96,0-6.96h15.99c-1.48-.82-2.63-1.99-3.43-3.51-.8-1.52-1.2-3.25-1.2-5.18,0-2.38.58-4.48,1.73-6.29ZM76.36,297.12c-1.56-1.23-3.75-1.84-6.57-1.84s-4.92.6-6.41,1.81c-1.48,1.21-2.23,2.93-2.23,5.15,0,2.23.75,3.95,2.26,5.15,1.5,1.21,3.67,1.81,6.49,1.81s5-.6,6.52-1.81c1.52-1.21,2.28-2.93,2.28-5.15,0-2.19-.78-3.9-2.34-5.13Z'/%3e%3cpath%20class='cls-1'%20d='M83.21,279.2c-.59,2.03-1.45,3.74-2.56,5.15l-4.85-1.95c2.12-2.9,3.18-6.22,3.18-9.97,0-1.6-.26-2.81-.78-3.65-.52-.84-1.26-1.25-2.23-1.25-.82,0-1.45.29-1.89.86-.45.58-.85,1.61-1.23,3.09l-1,4.46c-.56,2.53-1.47,4.4-2.73,5.63-1.26,1.23-2.9,1.84-4.9,1.84-1.67,0-3.15-.47-4.43-1.42-1.28-.95-2.27-2.27-2.98-3.96-.7-1.69-1.06-3.65-1.06-5.88,0-1.93.3-3.8.89-5.6.59-1.8,1.43-3.39,2.51-4.76l4.74,1.95c-2.04,2.82-3.06,5.65-3.06,8.47,0,1.52.28,2.71.84,3.57.56.85,1.34,1.28,2.34,1.28.74,0,1.36-.27,1.84-.81.48-.54.85-1.4,1.11-2.59l1.06-4.62c.59-2.71,1.53-4.7,2.81-5.96,1.28-1.26,2.96-1.89,5.04-1.89,2.53,0,4.53,1.02,6.02,3.06,1.49,2.04,2.23,4.81,2.23,8.3,0,2.42-.3,4.63-.89,6.66Z'/%3e%3cpath%20class='cls-1'%20d='M43.77,248.26h6.85s0,7.69,0,7.69h-6.85s0-7.69,0-7.69ZM56.41,255.56v-6.96s27.24,0,27.24,0v6.96s-27.24,0-27.24,0Z'/%3e%3cpath%20class='cls-1'%20d='M44.38,215.11h39.28s0,6.91,0,6.91h-4.4c1.52.82,2.71,2,3.57,3.54.85,1.54,1.28,3.3,1.28,5.26,0,2.34-.59,4.43-1.78,6.27-1.19,1.84-2.87,3.27-5.04,4.29-2.17,1.02-4.67,1.53-7.49,1.53s-5.29-.51-7.41-1.53c-2.12-1.02-3.75-2.44-4.9-4.26-1.15-1.82-1.73-3.92-1.73-6.29,0-1.97.41-3.71,1.23-5.24.82-1.52,1.97-2.69,3.45-3.51h-16.05s0-6.96,0-6.96ZM76.41,223.83c-1.52-1.21-3.69-1.81-6.52-1.81-2.82,0-4.99.6-6.49,1.81-1.5,1.21-2.26,2.91-2.26,5.1,0,2.23.74,3.96,2.23,5.18,1.49,1.23,3.62,1.84,6.41,1.84s5.01-.61,6.57-1.84,2.34-2.93,2.34-5.13-.76-3.95-2.28-5.15Z'/%3e%3cpath%20class='cls-1'%20d='M43.77,200.63h6.85s0,7.69,0,7.69h-6.85s0-7.69,0-7.69ZM56.41,207.92v-6.96s27.24,0,27.24,0v6.96s-27.24,0-27.24,0Z'/%3e%3cpath%20class='cls-1'%20d='M82.37,188.67c-1.15,2.1-2.8,3.72-4.96,4.87-2.15,1.15-4.66,1.73-7.52,1.73s-5.36-.58-7.49-1.73c-2.14-1.15-3.78-2.78-4.93-4.87-1.15-2.1-1.73-4.54-1.73-7.33,0-2.79.58-5.23,1.73-7.33,1.15-2.1,2.8-3.71,4.93-4.85,2.14-1.13,4.63-1.7,7.49-1.7,2.86,0,5.37.57,7.52,1.7,2.15,1.13,3.81,2.75,4.96,4.85,1.15,2.1,1.73,4.54,1.73,7.33,0,2.78-.57,5.23-1.73,7.33ZM76.47,176.22c-1.48-1.19-3.68-1.78-6.57-1.78s-5.04.59-6.55,1.78c-1.51,1.19-2.26,2.9-2.26,5.13,0,2.23.75,3.95,2.26,5.15,1.5,1.21,3.69,1.81,6.55,1.81s5.09-.59,6.57-1.78c1.49-1.19,2.23-2.9,2.23-5.13,0-2.27-.74-3.99-2.23-5.18Z'/%3e%3cpath%20class='cls-1'%20d='M45.57,709.54l39.28,17.16v3.96s-39.28,17.16-39.28,17.16v-4.79s33.54-14.37,33.54-14.37l-33.54-14.43v-4.68Z'/%3e%3cpath%20class='cls-1'%20d='M45.96,700.23h5.07s0,5.46,0,5.46h-5.07s0-5.46,0-5.46ZM57.72,705.25v-4.51s27.13,0,27.13,0v4.51s-27.13,0-27.13,0Z'/%3e%3cpath%20class='cls-1'%20d='M57.72,668.04h25.29c4.05,0,7.1,1.04,9.16,3.12,2.06,2.08,3.09,5.16,3.09,9.25,0,4.75-1.23,8.75-3.68,11.98l-3.34-1.5c1.19-1.82,2.04-3.53,2.56-5.13s.78-3.38.78-5.35c0-2.6-.7-4.57-2.09-5.91-1.39-1.33-3.43-2-6.1-2h-4.79c1.75.78,3.08,1.98,4.01,3.59.93,1.62,1.39,3.52,1.39,5.71,0,2.38-.56,4.48-1.67,6.32-1.11,1.84-2.69,3.27-4.74,4.29-2.04,1.02-4.4,1.53-7.07,1.53-2.67,0-5.03-.51-7.08-1.53-2.04-1.02-3.62-2.45-4.74-4.29-1.11-1.84-1.67-3.95-1.67-6.32,0-2.15.46-4.03,1.39-5.63.93-1.6,2.25-2.8,3.96-3.62h-4.68s0-4.51,0-4.51ZM77.69,674.77c-1.73-1.48-4.11-2.23-7.16-2.23s-5.38.73-7.1,2.2c-1.73,1.47-2.59,3.52-2.59,6.15,0,2.64.86,4.71,2.59,6.21,1.73,1.5,4.1,2.26,7.1,2.26s5.43-.75,7.16-2.26c1.73-1.5,2.59-3.57,2.59-6.21,0-2.6-.86-4.64-2.59-6.13Z'/%3e%3cpath%20class='cls-1'%20d='M45.96,654.66h5.07s0,5.46,0,5.46h-5.07s0-5.46,0-5.46ZM57.72,659.68v-4.51s27.13,0,27.13,0v4.51s-27.13,0-27.13,0Z'/%3e%3cpath%20class='cls-1'%20d='M45.57,646.75v-4.51s39.28,0,39.28,0v4.51s-39.28,0-39.28,0Z'/%3e%3cpath%20class='cls-1'%20d='M59.7,615.08c1.76-1.69,4.45-2.53,8.05-2.53h17.1s0,4.4,0,4.4h-4.62c1.6.71,2.83,1.78,3.71,3.23.87,1.45,1.31,3.12,1.31,5.01,0,1.75-.35,3.35-1.06,4.82-.7,1.47-1.69,2.63-2.95,3.48s-2.66,1.28-4.18,1.28c-2.04,0-3.63-.52-4.76-1.56-1.13-1.04-1.95-2.75-2.45-5.13-.5-2.38-.75-5.68-.75-9.92v-1.23s-1.84,0-1.84,0c-2.26,0-3.91.46-4.93,1.39-1.02.93-1.53,2.43-1.53,4.51,0,3.12.97,6.22,2.9,9.3l-3.29,1.5c-1-1.41-1.81-3.11-2.42-5.1-.61-1.99-.92-3.91-.92-5.77,0-3.45.88-6.03,2.65-7.72ZM79.42,619.09c-1.51-1.43-3.45-2.14-5.82-2.14h-1.62v1c0,3.27.14,5.76.42,7.46.28,1.71.74,2.93,1.39,3.65.65.72,1.61,1.09,2.87,1.09,1.45,0,2.65-.53,3.59-1.59.95-1.06,1.42-2.39,1.42-3.98,0-2.23-.75-4.06-2.26-5.49Z'/%3e%3cpath%20class='cls-1'%20d='M45.57,580.23h39.28s0,4.51,0,4.51h-4.96c1.71.82,3.03,2.02,3.96,3.59.93,1.58,1.39,3.43,1.39,5.54,0,2.38-.59,4.48-1.78,6.29-1.19,1.82-2.85,3.23-4.99,4.23-2.14,1-4.61,1.5-7.44,1.5s-5.24-.5-7.35-1.5c-2.12-1-3.75-2.41-4.9-4.23-1.15-1.82-1.73-3.92-1.73-6.29,0-2.12.46-3.96,1.39-5.54.93-1.58,2.25-2.78,3.96-3.59h-16.83s0-4.51,0-4.51ZM78.81,586.89c-1.8-1.43-4.35-2.14-7.66-2.14-3.3,0-5.85.72-7.63,2.14-1.78,1.43-2.67,3.46-2.67,6.1s.89,4.69,2.67,6.16c1.78,1.47,4.29,2.2,7.52,2.2,3.31,0,5.88-.73,7.72-2.2,1.84-1.47,2.76-3.52,2.76-6.16,0-2.64-.9-4.67-2.7-6.1Z'/%3e%3cpath%20class='cls-1'%20d='M83.51,567.39c-1.15,1.95-2.79,3.45-4.93,4.51-2.14,1.06-4.61,1.59-7.44,1.59-2.82,0-5.3-.53-7.44-1.59-2.14-1.06-3.78-2.56-4.93-4.51-1.15-1.95-1.73-4.21-1.73-6.77s.58-4.83,1.73-6.8c1.15-1.97,2.8-3.48,4.93-4.54,2.14-1.06,4.62-1.59,7.44-1.59s5.3.53,7.44,1.59c2.14,1.06,3.78,2.57,4.93,4.54,1.15,1.97,1.73,4.23,1.73,6.8s-.58,4.82-1.73,6.77ZM78.86,554.47c-1.76-1.43-4.34-2.14-7.72-2.14s-5.86.72-7.66,2.17c-1.8,1.45-2.7,3.49-2.7,6.13,0,2.64.9,4.68,2.7,6.13,1.8,1.45,4.35,2.17,7.66,2.17,3.34,0,5.91-.71,7.69-2.14,1.78-1.43,2.67-3.48,2.67-6.16,0-2.67-.88-4.73-2.65-6.16Z'/%3e%3cpath%20class='cls-1'%20d='M75.12,77.34c.2.22.57.32.94.16.06.16.2.3.37.37.08.03.17.04.25.04.2,0,.41-.08.61-.24.25.35.84.44,1.46.44.36,0,.73-.03,1.04-.05.18-.01.33-.02.44-.03.79-.04,1.35-.21,1.77-.74.4.15,1.45.4,2.59-1.16.32-.1,1.98-.71,1.68-2.49.24-.22,1.02-1.05.57-2.11.06-.23.24-1.02-.15-1.4-.07-.17-.44-.91-1.07-1.04-.39-.08-.79.09-1.2.5-.06.06-.24.25-.29.42-.37.21-.52.59-.56.72-.3.15-.46.44-.54.62-.53-.1-1.12.02-1.78.38-.44-.33-.95-.51-1.5-.51,0,0,0,0,0,0-.71-.01-1.41.31-1.96.93-.72.8-1.09,1.96-.98,3.06-.15,0-.31.04-.43.13-.23.16-.38.45-.4.76h0s0,0,0,0c-.31-.02-.58.07-.78.26-.35.4-.26.77-.07.97ZM83.23,71.72c.76.29,1.06,1.13,1.06,1.14l.28-.1s-.34-.98-1.23-1.32c0,0,0,0,0,0,.08-.17.25-.43.53-.48.29-.06.81.1,1.63,1.14l.23-.18c-.67-.86-1.28-1.27-1.79-1.25.08-.15.22-.34.46-.43.37-.14.86,0,1.46.4l.17-.25c-.55-.37-1.03-.53-1.44-.49.02-.03.05-.05.07-.08.33-.34.64-.48.93-.42.55.11.87.88.87.89v.03s.04.02.04.02c.27.24.14.92.07,1.16l-.02.05.02.05c.48,1.05-.49,1.83-.53,1.86l-.07.06.02.09c.34,1.75-1.43,2.22-1.51,2.24h-.05s-.03.06-.03.06c-.88,1.25-1.78,1.24-2.23,1.14.71-1.15.75-2.82.06-4.16-.19-.38-.43-.69-.71-.95.65-.33,1.23-.41,1.72-.22ZM75.41,76.57c.17-.17.42-.18.53-.17.12.02.2-.02.25-.06.04-.04.09-.11.09-.22.01-.22.12-.43.27-.53.16-.11.37-.11.51,0l.27.22-.03-.35c0-.09.02-.17.09-.23.11-.1.33-.15.52-.12.12.01.53.08.61.37l.11.35.17-.33c.18-.36.54-.47.81-.43.27.04.45.23.5.53l.29-.05c-.07-.42-.35-.71-.75-.77-.07-.01-.15-.01-.22,0,.08-.45.38-1.57,1.28-1.81.17.18.31.41.41.68.42,1.04.25,2.42-.39,3.2l.23.19c.72-.87.91-2.34.44-3.5-.33-.81-.91-1.3-1.65-1.38-.59-.06-1.17.2-1.64.74-.43.49-.72,1.16-.81,1.89,0,.02,0,.1-.01.16-.04.02-.07.05-.1.08-.03.03-.06.06-.08.09-.07-1,.27-2.03.91-2.75.5-.55,1.11-.85,1.74-.83h0c.9,0,1.7.55,2.19,1.51.65,1.27.61,2.86-.08,3.92-.26.52-1.14.78-1.64.78-.12,0-.28.02-.46.03-.71.06-2.02.17-2.27-.29l-.05-.08-.08-.22c-.21.25-.52.52-.84.41-.11-.04-.22-.17-.21-.31l.03-.33-.27.2c-.29.21-.6.16-.75,0-.13-.15-.11-.36.07-.56ZM77.59,74.82c.08-.67.34-1.29.74-1.74.4-.46.9-.69,1.39-.64.27.03.52.13.73.29-1.02.41-1.28,1.74-1.33,2.11-.17.07-.32.17-.44.32-.15-.18-.41-.3-.72-.34-.11-.02-.23-.02-.36,0Z'/%3e%3cpath%20class='cls-1'%20d='M57.56,73.63c-.29,1.78,1.36,2.38,1.69,2.49.74,1.02,1.51,1.25,2.07,1.25.36,0,.63-.1.74-.15.28.08.55.12.81.12.34,0,.66-.06.98-.19.08.09.23.16.51.15.28,0,.62-.02.92-.16.1.11.29.17.53.17.49,0,.96-.04,1.34-.29.08.06.2.1.36.1.72.03,1.46.07,2.18-.03.17,0,.29-.09.33-.22.04-.14-.03-.29-.17-.39-.03-.02-.06-.04-.09-.05-.05-.03-.1-.06-.12-.09,0-.01-.01-.02-.02-.03-.02-.04-.04-.08-.08-.12l-.05-.03c-.22-.09-.51-.12-.8-.15-.13-.01-.25-.02-.36-.04-.08-.29-.4-.47-.72-.49-.03,0-.07,0-.08-.01-.01,0-.03-.03-.04-.05-.01-.02-.02-.03-.03-.05-.12-.15-.27-.21-.42-.25.09-1.08-.27-2.18-.98-2.97-.54-.6-1.22-.93-1.91-.93-.02,0-.04,0-.06,0-.55,0-1.06.18-1.5.51-.65-.35-1.25-.48-1.78-.38-.08-.17-.24-.47-.54-.62-.04-.14-.2-.51-.56-.72-.06-.18-.23-.36-.29-.42-.41-.41-.81-.58-1.2-.5-.64.13-1,.87-1.07,1.04-.39.38-.21,1.17-.14,1.4-.45,1.06.33,1.88.57,2.11ZM67.21,75.54l.02.03s.07.1.13.14c.08.05.16.05.25.06.2.01.43.15.44.33v.12s.12.02.12.02c.15.03.32.05.49.06.24.02.5.05.67.11,0,0,0,.01,0,.02.01.02.02.04.03.06.06.1.15.15.22.19.02.01.05.03.07.04.05.03.06.06.06.06h0s-.02.01-.08.02c-.71.09-1.44.06-2.14.03-.15,0-.19-.04-.2-.06l-.07-.22-.17.15c-.31.27-.78.3-1.27.31-.14,0-.31-.03-.32-.1l-.04-.22-.19.12c-.24.16-.54.18-.91.19-.17,0-.28-.03-.3-.08l-.05-.17-.16.07c-.17.08-.37.13-.58.16-.71-.72-.98-2.07-.62-3.19.08-.25.23-.58.49-.86.93.25,1.23,1.52,1.3,1.95h-.21s.01.3.01.3l1.39-.06c.13,0,.25,0,.31.03.14.13.27.19.41.19.08,0,.17,0,.25,0,.25,0,.49,0,.62.16ZM63.39,72.73c.2-.14.44-.26.74-.29.4-.05.84.12,1.22.48.56.53.9,1.35.9,2.13-.04-.02-.08-.05-.12-.09-.16-.11-.37-.11-.51-.1l-.89.04c-.06-.42-.34-1.76-1.34-2.16ZM64.08,71.52s0,0,0,0c.63,0,1.24.28,1.73.83.65.71.98,1.75.91,2.74-.05,0-.09,0-.13,0-.02,0-.04,0-.06,0,.01-.87-.36-1.79-.99-2.38-.45-.42-.97-.62-1.46-.56-.8.09-1.43.67-1.72,1.58-.33,1-.23,2.4.53,3.31-.32.01-.64-.03-.94-.11-.69-1.06-.73-2.65-.07-3.91.49-.96,1.29-1.51,2.2-1.51ZM57.28,71.49c-.07-.24-.21-.93.07-1.16l.03-.02v-.03s.34-.78.88-.89c.29-.06.6.08.93.42.02.02.05.05.07.08-.41-.04-.89.12-1.44.49l.17.25c.6-.4,1.09-.54,1.45-.4.24.09.38.28.46.43-.51-.02-1.11.4-1.79,1.25l.23.18c.82-1.04,1.34-1.19,1.63-1.14.28.05.45.32.53.48,0,0,0,0,0,0-.89.34-1.22,1.28-1.23,1.32l.28.1s.29-.84,1.06-1.13c.49-.19,1.07-.11,1.72.22-.27.26-.51.57-.71.95-.69,1.33-.66,3.01.06,4.15-.45.1-1.35.1-2.22-1.13l-.03-.04h-.05c-.08-.03-1.85-.5-1.51-2.26l.02-.09-.07-.06s-1.01-.82-.53-1.86l.02-.05-.02-.05Z'/%3e%3cpath%20class='cls-1'%20d='M71.78,76.08c-.01.49-.07,1.02-.16,1.57v.06s.03.05.03.05c.01.02.32.43.87.62l.17.06.02-.18c0-.06.18-1.4.03-2.85,1.82-.56,2.38-2.39,2.54-3.16.09-.46.07-.48,0-.53l-.07-.05-.08.03c-1.54.59-2.26,1.73-2.6,2.6-.12-.47-.28-.87-.49-1.2,1.49-.16,2.66-1.42,2.66-2.94,0-.86-.37-1.64-.97-2.18l.73-.9-1.39.16-.42-.71-.71.44-.56-.46-.29.58-1.25-.49.34,1.02c-.96.56-1.42,1.58-1.42,2.54,0,1.22.74,2.56,2.35,2.89.07.09.41.58.57,1.63-.52-.8-1.46-1.74-3.05-2l-.12-.02-.04.12c-.04.13.31.95.69,1.53.49.74,1.33,1.65,2.6,1.79ZM72.66,74.92c.2-.77.77-2.12,2.36-2.84-.12.67-.61,2.55-2.42,3.07l.06-.23ZM73.79,67.45l-.27.33c-.13-.09-.26-.18-.4-.25l.67-.08ZM74.42,70.15c0,1.2-.79,2.21-1.88,2.55,1.75-2.36.52-4.36-.11-5.12,1.14.3,1.99,1.34,1.99,2.57ZM72.57,66.94l.28.47c-.23-.09-.48-.16-.74-.19l.46-.28ZM71.51,66.97l.27.22s-.03,0-.04,0c-.12,0-.24.02-.36.03l.13-.25ZM70.91,67.32c-.16.04-.3.09-.44.16l-.12-.38.57.22ZM69.08,70.15c0-1.09.66-2.28,2.07-2.59-.62.75-1.89,2.76-.15,5.14-1.32-.36-1.93-1.5-1.93-2.55ZM71.61,67.5s.09,0,.13-.01c.07,0,.15,0,.22.01.3.29,2.44,2.52.12,5.3-.11.01-.22.02-.34.02-.1,0-.2-.01-.3-.03-2.29-2.78-.14-5,.16-5.29ZM71.52,73.1c.06,0,.13.01.2.02.31.44.53,1.04.66,1.79l.05.29.02.13c.14,1.14.06,2.27.01,2.71-.26-.13-.44-.31-.52-.4.09-.59.15-1.16.15-1.69v-.14s-.01-.47-.01-.47h0c-.07-1.19-.36-1.9-.55-2.25ZM71.78,75.43l.18.38h-.02c-1.9-.13-2.83-2.12-3.09-2.8,1.74.39,2.58,1.67,2.93,2.42Z'/%3e%3cpath%20class='cls-1'%20d='M61.68,47.99c-.12-.15-.13-.4-.05-.57.03-.05.06-.1.1-.14,0,0,.02-.01.02-.02-.17.08-.42,0-.5-.18-.1-.22.04-.5.27-.59-.19.03-.35.13-.53.2-.18.06-.4.08-.54-.04-.14-.12-.17-.34-.1-.51.06-.17.2-.31.33-.45-.29.07-.56.35-.84.26-.29-.09-.32-.51-.17-.77.15-.26.42-.44.59-.69-.44.21-.91.37-1.38.48-.17.04-.36.07-.49-.04-.09-.08-.08-.24,0-.32l-.67.22c-.16.05-.32.1-.48.06-.16-.05-.28-.24-.19-.37-.24.14-.5.29-.78.26-.17-.02-.29-.09-.37-.24-.1-.17-.02-.25.12-.37-.27.11-.53.43-.45.74.06.22.32.34.55.31.23-.02.44-.14.63-.26-.08.05.16.32.19.34.16.12.4.15.59.11.11-.02.22-.07.32-.12.04-.02.3-.14.3-.18,0,.15.21.19.36.18.3,0,.6-.02.89-.02-.21.19-.27.52-.13.77.14.25.46.38.73.31-.23.25-.05.71.28.81.28.09.59-.05.78-.27-.03.03-.05.08-.07.12-.02.04-.04.08-.06.12-.03.09-.05.18-.03.28.01.08.05.16.09.23.04.06.1.12.17.15.04.01.07.02.11.02.09,0,.17-.04.24-.09-.05.08-.1.17-.15.26-.04.09-.08.18-.09.28-.03.23.17.43.38.46.12.02.25,0,.36-.06.25-.14.39-.42.5-.68-.19.25-.63.26-.83.02Z'/%3e%3cpath%20class='cls-1'%20d='M50.51,44.93c.19-.05.35-.16.51-.26.04-.03.1-.05.14-.02.04.03.04.08.04.13.02.22.25.39.48.41.23.02.45-.08.64-.21,0,.04-.01.08-.02.13.09.15.28.22.45.22.18,0,.35-.05.51-.1.21-.06.44-.14.56-.33-.11.11-.24.22-.39.2-.17-.02-.27-.22-.24-.39.03-.17.14-.31.25-.44-.29.18-.61.31-.94.41-.14.04-.28.07-.42.03-.14-.04-.26-.16-.25-.3,0-.08.05-.15.11-.2.08-.09.18-.16.29-.22-.27.11-.54.22-.81.33-.2.08-.41.16-.62.15-.22-.01-.44-.16-.47-.37-.01-.08,0-.17.05-.24-.03.02-.07.04-.11.07-.14.11-.27.23-.34.38-.07.16-.07.35.04.49.12.15.34.18.53.13Z'/%3e%3cpath%20class='cls-1'%20d='M64.04,40.22s-.06.02-.07.03c-.02,0-.05.02-.07.03-.1.04-.2.06-.3.06-.16,0-.34-.1-.37-.26-.02-.1.01-.23-.05-.31-.06-.09-.19-.09-.3-.07-.24.05-.75.41-.94.1-.03-.05-.03-.11-.02-.17,0-.04.02-.08.04-.11-.21.18-.43.25-.67.37-.24.13-.49.24-.74.35-.15.06-.35.1-.47-.04-.14-.17.01-.46.13-.61.13-.16.13-.16.31-.27-.65.26-1.2.39-1.89.63-.69.24-1.38.55-1.91,1.05-.08.08-.17.17-.19.28-.02.11.03.25.15.27-.77.24-1.45.77-1.88,1.45-.09.14-.16.35-.03.46.06.05.15.06.23.06.23,0,.45-.08.64-.21-.12-.09-.15-.27-.1-.42.05-.14.16-.26.27-.36.44-.41.96-.74,1.52-.97-.09.04-.18-.05-.19-.15s.05-.18.11-.25c.05-.07.11-.13.17-.19.26-.26.57-.46.89-.63.35-.17.71-.31,1.08-.43.05-.02.1-.03.15-.05.02,0,.14-.03.15-.05-.11.35-.13.86.36.86.51,0,1.02-.23,1.35-.62-.11.16-.2.37-.09.53.1.14.32.13.49.09.4-.09.78-.29,1.08-.56-.12.16-.24.41-.1.55.02.02.04.03.06.04.08.04.19.04.29.02.14-.03.27-.07.4-.13.17-.08.32-.18.46-.31.01-.01.09-.08.07-.09Z'/%3e%3cpath%20class='cls-1'%20d='M53.65,48.4c-.6.3-1.25.52-1.92.64-.2.04-.48.01-.51-.18-.01-.09.03-.17.08-.25.23-.34.53-.62.89-.82-.58.28-1.2.47-1.84.57-.26.04-.62-.02-.63-.27,0-.11.06-.2.13-.29.25-.3.55-.56.88-.77-.53.35-1.12.62-1.73.8-.25.07-.54.13-.76-.02-.15-.1-.16-.34-.08-.47-.36.21-.79.32-1.21.3-.08,0-.16-.01-.22-.07-.2-.18.03-.52.2-.7-.24.25-.49.49-.67.79-.09.16-.15.4,0,.5.06.04.14.04.21.04.14,0,.29-.02.44-.04.09-.02.18-.04.26-.06.1-.03.2-.06.3-.1.05-.02.25-.08.27-.13-.14.35.25.73.63.74.38.01.73-.21,1.04-.42-.13.17,0,.44.19.53.2.09.43.06.64.02.38-.08.74-.19,1.09-.34-.14.34-.64.6-.47.93.07.13.23.19.39.22.59.11,1.23-.02,1.73-.36.11-.08.23-.16.36-.16.1,0,.19.07.29.11.2.09.45.07.63-.05-.37.03-.71-.34-.65-.7Z'/%3e%3cpath%20class='cls-1'%20d='M45.71,50.84c-.02-.09,0-.18.03-.26.01-.03.04-.05.05-.08-.03,0-.07.04-.1.06-.03.02-.07.04-.1.06-.07.04-.14.08-.22.11-.15.06-.31.1-.47.12-.11.01-.22.01-.33,0-.06,0-.11-.01-.17-.02-.05,0-.1,0-.13-.05-.04-.04-.06-.1-.07-.16,0-.05,0-.13.01-.18,0-.02.01-.03.02-.05.02-.05.04-.1.07-.14.04-.04.07-.09.11-.12-.35.23-.74.4-1.16.48-.06.01-.14.02-.19-.01-.12-.07-.06-.25.01-.37.34-.53.76-1,1.23-1.42-.5.33-.96.72-1.36,1.16-.17.18-.34.42-.26.65.07.2.31.31.53.29.22-.02.41-.12.6-.23.05-.03.1-.06.15-.08.04-.02.09-.04.14-.07-.05.15-.08.31-.07.47,0,.07.02.14.06.2.03.05.1.11.16.12.08,0,.16,0,.23-.02.11-.03.21-.06.32-.1.16-.06.31-.14.46-.23.11-.07.2-.15.3-.23.02-.02.04-.04.06-.05,0,.03,0,.06-.02.09-.01.04-.02.07-.03.11-.01.07,0,.15.02.22.03.09.09.16.17.2.04.02.07.02.11.02.04,0,.09.01.13,0,.16-.02.3-.1.43-.19.38-.27.7-.65.89-1.07-.43.3-.89.56-1.37.76-.06.02-.25.08-.27,0Z'/%3e%3cpath%20class='cls-1'%20d='M87.57,44.17c.15.12.22.2.12.37-.09.15-.21.22-.37.24-.28.03-.54-.12-.78-.26.09.14-.03.33-.19.37-.16.05-.32,0-.48-.06l-.67-.22c.07.08.08.24,0,.32-.13.11-.33.08-.49.04-.48-.11-.94-.27-1.38-.48.17.25.44.43.59.69.15.26.12.67-.17.77-.29.09-.55-.19-.84-.26.13.13.26.27.33.45.06.17.04.39-.1.51-.15.12-.36.1-.54.04-.18-.06-.34-.17-.53-.2.23.09.37.37.27.59-.08.18-.33.26-.5.18,0,0,.02.01.02.02.04.04.07.09.1.14.08.17.08.42-.05.57-.2.24-.64.23-.83-.02.12.26.25.54.5.68.11.06.24.08.36.06.22-.03.41-.23.38-.46-.01-.1-.05-.19-.09-.28-.04-.09-.09-.17-.15-.26.07.05.15.09.24.09.04,0,.08,0,.11-.02.07-.03.13-.08.17-.15.05-.07.08-.15.09-.23.02-.09,0-.19-.03-.28-.02-.04-.03-.08-.06-.12-.02-.04-.04-.08-.07-.12.19.22.5.36.78.27.33-.1.51-.56.28-.81.28.07.59-.06.73-.31.14-.25.08-.58-.13-.77.3,0,.6.02.89.02.15,0,.35-.04.36-.18,0,.03.27.16.3.18.1.05.21.1.32.12.19.04.43,0,.59-.11.04-.03.28-.29.19-.34.2.12.4.24.63.26.23.02.49-.1.55-.31.09-.3-.18-.63-.45-.74Z'/%3e%3cpath%20class='cls-1'%20d='M90.13,45.11c-.15.02-.28-.09-.39-.2.12.19.35.26.56.33.17.05.34.1.51.1.17,0,.36-.08.45-.22,0-.04-.01-.08-.02-.13.19.13.41.23.64.21.23-.02.46-.18.48-.41,0-.05,0-.1.04-.13.04-.03.1,0,.14.02.17.1.33.21.51.26.19.05.41.02.53-.13.11-.13.11-.33.04-.49-.07-.16-.2-.28-.34-.38-.03-.03-.07-.05-.11-.07.04.08.06.16.05.24-.03.21-.25.35-.47.37-.22.01-.42-.07-.62-.15-.27-.11-.54-.22-.81-.33.11.05.21.13.29.22.05.06.1.13.11.2.01.14-.11.26-.25.3-.14.04-.28,0-.42-.03-.33-.09-.64-.23-.94-.41.11.13.22.27.25.44.03.17-.07.36-.24.39Z'/%3e%3cpath%20class='cls-1'%20d='M79.59,40.31c.13.13.29.23.46.31.13.06.26.1.4.13.1.02.2.02.29-.02.02-.01.04-.02.06-.04.15-.14.02-.39-.1-.55.31.27.68.47,1.08.56.17.04.38.05.49-.09.11-.15.02-.37-.09-.53.34.39.84.62,1.35.62.5,0,.47-.51.36-.86,0,.01.13.04.15.05.05.02.1.03.15.05.37.12.73.25,1.08.43.33.16.64.37.89.63.06.06.12.12.17.19.06.07.12.16.11.25,0,.09-.1.18-.19.15.56.22,1.08.55,1.52.97.11.1.22.22.27.36.05.14.02.33-.1.42.19.13.41.2.64.21.08,0,.17,0,.23-.06.13-.11.06-.32-.03-.46-.43-.69-1.11-1.21-1.88-1.45.11-.02.17-.16.15-.27-.02-.11-.11-.2-.19-.28-.53-.5-1.22-.81-1.91-1.05-.69-.24-1.4-.43-2.07-.74.17.11.35.22.48.38.12.14.27.43.13.61-.12.14-.32.11-.47.04-.25-.11-.5-.22-.74-.35-.24-.13-.46-.19-.67-.37.02.04.03.08.04.11.01.06,0,.12-.02.17-.19.31-.7-.05-.94-.1-.1-.02-.23-.02-.3.07-.06.09-.03.21-.05.31-.03.16-.21.26-.37.26-.1,0-.21-.02-.3-.06-.02,0-.05-.02-.07-.03-.01,0-.06-.03-.07-.03-.03,0,.05.08.07.09Z'/%3e%3cpath%20class='cls-1'%20d='M89.9,49.15c.1-.04.19-.11.29-.11.13,0,.25.08.36.16.5.34,1.13.48,1.73.36.15-.03.32-.08.39-.22.17-.32-.33-.59-.47-.93.35.15.72.26,1.09.34.21.04.45.07.64-.02.2-.09.32-.36.19-.53.32.21.66.44,1.04.42.38-.01.77-.39.63-.74.02.05.22.11.27.13.1.04.2.07.3.1.08.02.17.04.26.06.15.03.3.04.44.04.07,0,.15,0,.21-.04.16-.1.1-.34,0-.5-.18-.31-.43-.54-.67-.79.17.18.4.52.2.7-.06.05-.14.06-.22.07-.42.02-.84-.09-1.21-.3.09.14.07.37-.08.47-.21.15-.51.1-.76.02-.61-.18-1.2-.45-1.73-.8.33.21.63.47.88.77.07.08.14.18.13.29-.01.26-.37.31-.63.27-.64-.1-1.26-.29-1.84-.57.36.2.67.48.89.82.05.07.1.16.08.25-.03.2-.31.22-.51.18-.67-.12-1.31-.34-1.92-.64.06.36-.28.72-.65.7.19.12.43.14.63.05Z'/%3e%3cpath%20class='cls-1'%20d='M97.11,51.16c.13.09.27.17.43.19.05,0,.09,0,.13,0,.04,0,.07,0,.11-.02.08-.04.14-.12.17-.2.03-.07.03-.15.02-.22,0-.04-.02-.07-.03-.11,0-.03-.02-.06-.02-.09.02,0,.04.03.06.05.1.09.19.16.3.23.14.09.3.17.46.23.1.04.21.07.32.1.08.02.16.03.23.02.07,0,.13-.06.16-.12.04-.06.06-.13.06-.2.01-.16-.02-.32-.07-.47.04.03.09.04.14.07.05.03.1.06.15.08.19.11.39.21.6.23.22.02.46-.09.53-.29.08-.23-.09-.47-.26-.65-.4-.44-.86-.84-1.36-1.16.47.42.89.89,1.23,1.42.07.12.13.3.01.37-.06.03-.13.02-.19.01-.41-.08-.81-.25-1.16-.48.04.03.08.08.11.12.03.04.05.09.07.14,0,.02.01.03.02.05.02.05.02.12.01.18,0,.06-.03.12-.07.16-.03.04-.08.04-.13.05-.06.01-.11.02-.17.02-.11,0-.22,0-.33,0-.16-.02-.32-.06-.47-.12-.08-.03-.15-.07-.22-.11-.04-.02-.07-.04-.1-.06-.03-.02-.06-.06-.1-.06,0,.03.04.05.05.08.04.08.06.18.03.26-.02.09-.22.03-.27,0-.48-.2-.95-.45-1.37-.76.2.42.51.8.89,1.07Z'/%3e%3cpath%20class='cls-1'%20d='M70.8,60.61c-1.17-.16-1.53-1.39-1.53-1.39l-.29.46c.78,1.11,1.82.93,1.82.93Z'/%3e%3cpath%20class='cls-1'%20d='M68.44,42.08c-.2,0-.36.16-.36.36s.16.36.36.36.36-.16.36-.36-.16-.36-.36-.36ZM68.44,42.61c-.09,0-.16-.07-.16-.16s.07-.16.16-.16.16.07.16.16-.07.16-.16.16Z'/%3e%3cpath%20class='cls-1'%20d='M110.42,64.42c-.12-.18-.32-.28-.53-.26l-4.88,1.06-.53,2.62-1.28.84c-.02-2.25-.12-4.62-.31-7.05l2.59.56,2.88-3.99c.14-.2.15-.45.02-.66-.12-.18-.32-.28-.53-.26l-4.88,1.06-.53,2.62-11.69,7.65c-.05-1.01-.12-2.02-.22-3.07,0-.04,0-.07,0-.09.28.04.55.06.81.06.65,0,1.21-.13,1.69-.44,1.63-1.05,2.13-4.19,2.22-4.81v-.07s-.15-.1-.15-.1c-.3-.21-1.04-.79-1.25-1.63.26.03.52.09.77.18.22.08.46.2.71.32.67.32,1.46.7,2.41.7.32,0,.65-.04,1-.14,1.53-.51,2.15-1.28,2.17-1.31l.17-.21-1.91-.17.6-1.78-.38.28s-.91.66-1.32.82l-.08.03c-.36.12-.77.25-1.95-.22-.72-.3-1.34-.41-1.88-.34-.68.08-1.16.5-1.58.87-.42.36-.93.82-1.09,1.39v.07c-.04.09-.06.19-.07.28v.04s0,0,0,0c-.02.18-.02.36,0,.54.03.26.11.52.21.76.08.19.18.37.29.55,0,0,0,0,0,0-1.19,0-2.8-.22-4.99-.91h0s0,0,0,0c-1.58-.49-3.15-.74-4.66-.74h0c-2.15,0-3.96.49-5.43,1.15,0-.05-.01-.09-.03-.14-.04-.12-.11-.22-.18-.33-.18-.28-.34-.58-.39-.91-.05-.37.02-.75.07-1.12.08-.53.05-1.03-.09-1.51-.09-.29-.22-.53-.41-.75-.08-.09-.15-.18-.23-.27-.03-.04-.07-.08-.1-.12.18-.29.28-.59.28-.9,0-.03.03-.07.06-.12l.03-.04s.05-.08.08-.12c.05-.06.09-.13.13-.2.1-.18.14-.38.12-.6v-.34c.05-.03.1-.07.14-.11.17.37.47.59.85.6.37.01.79-.19,1.09-.49.07.09.16.18.29.23.32.12.63-.08.73-.15.27-.18.55-.39.75-.67.11.04.21.04.3.02.37-.06.59-.43.72-.72l.02-.06c.06-.14.07-.16.11-.18.28-.14.41-.4.49-.63.04,0,.07-.02.11-.03.13-.06.2-.05.3.04.17.14.39.14.58.05.15.15.35.22.56.19.14-.02.27-.09.38-.18.05.04.11.08.18.1.12.05.2.14.32.31l.05.06c.28.37.57.44.77.44.16,0,.37-.05.6-.27.31.21.57.2.74.16.18-.05.44-.18.62-.58.15-.33.24-.65.27-.95.17-.01.34-.09.47-.23.04.04.09.07.12.1.06.05.12.1.17.13.34.23.7.44,1.07.62.12.06.26.12.42.14.15.02.26-.01.35-.04.04.03.1.07.17.12,1.02.72,1.66,1.06,2.1.8.06-.03.13-.09.19-.18.6.42,1.22.84,1.94,1.09.15.05.31.06.46.01.12-.04.21-.1.27-.17.16.11.32.22.48.34.54.39,1.1.8,1.74,1.04.38.18.63.1.78,0,.2-.13.29-.33.34-.55.34.29.7.6,1.26.76h.03c.29.07.49-.02.62-.13.41.33.84.66,1.35.9.24.12.52.09.72-.07.1-.08.16-.17.2-.26.4.19.78.37,1.13.63.16.12.6.43,1.05.15.09-.06.19-.16.24-.3.22.18.44.36.68.51.2.15.84.58,1.28.34.1-.05.24-.17.29-.4.13.09.27.17.43.27.23.12.45.27.68.43.49.33.99.67,1.6.81h.04s.06.01.1.01c.14,0,.26-.04.36-.13.14-.12.2-.3.18-.52-.08-.86-.63-1.47-1.13-2.01-1.28-1.42-2.8-2.69-4.26-3.92-.55-.46-1.12-.94-1.67-1.42-3.72-3.24-7.57-6.19-11.77-9.01-3.69-2.47-7.43-3.81-11.12-4-1.59-.08-2.84.12-3.82.62-2.27,1.19-1.54,3.64-1.01,5.44l.04.15c.32.97.36,1.66.11,2.05-.1.15-.25.27-.45.34,0-.01-.01-.02-.01-.02l-.05-.05c-.94-1.08-2.42-1.01-2.86-.96-.17-.11-.34-.23-.42-.3.05-.68-.1-1.3-.43-1.81-.11-.17-.24-.32-.39-.46,0,0-.01,0-.02-.01,0,0,0-.02,0-.03-.02-.25-.13-.47-.3-.64-.21-.2-.5-.31-.83-.3-.29,0-.55.1-.74.18l-.06.02c-.17.07-.34.14-.45.11-.02,0-.05-.02-.09-.04.21-1.16,0-2.23-.6-2.94-1.09-1.28-3.18-1.44-4.73-1.35-3.69.18-7.43,1.53-11.12,4-4.21,2.82-8.06,5.76-11.77,9.01-.54.47-1.11.95-1.67,1.41-1.46,1.23-2.98,2.49-4.27,3.93-.49.54-1.04,1.15-1.12,2-.04.35.16.52.25.57.09.05.19.08.31.08.29,0,.67-.16,1.15-.47.27-.18.54-.35.81-.51.22-.13.45-.27.67-.42.09-.06.22-.04.27.05.07.13.18.2.25.24.4.19.93-.08,1.76-.72.08-.06.2-.06.26.02.05.06.11.11.17.15.44.27.87-.04,1.04-.16.3-.22.63-.39.97-.55.08-.04.17,0,.22.07.03.04.07.09.13.13.2.16.48.19.72.08.46-.21.85-.51,1.22-.8.04-.03.09-.07.13-.1.13.11.33.19.62.14h.04c.44-.14.76-.36,1.05-.59.09-.08.24-.05.29.06.06.12.14.23.26.31.15.09.4.17.76,0,.66-.26,1.22-.66,1.77-1.05.16-.12.32-.23.48-.34.06.07.15.13.27.17.15.05.3.04.46-.01.67-.24,1.25-.61,1.81-1,.07-.05.17-.04.23.02.07.06.16.11.26.13.43.1,1.03-.24,1.9-.85.08-.05.14-.1.18-.13.08.03.2.06.35.04h.06c.46-.13.85-.38,1.23-.62l.21-.13s.1-.08.17-.13c.03-.03.07-.06.12-.1.1.11.22.18.35.21.07.02.12.08.13.16.07.53.3,1.15.76,1.35.15.06.41.12.74-.05.07-.04.14-.03.2.02.19.14.37.18.5.18.2,0,.49-.07.77-.44l.05-.06c.13-.17.2-.26.32-.31.07-.03.13-.06.18-.1.11.1.24.16.38.18.21.03.41-.04.56-.19.18.09.41.09.58-.06.1-.09.17-.1.3-.04.04.02.07.03.11.03.07.23.2.5.49.63.04.02.06.04.11.18l.03.07c.13.28.34.65.72.71.09.02.22.01.35-.05,0,0,0,.02,0,.02l.05.21.18-.11c.28-.18.54-.5.74-.89.09.45.27.86.51,1.22-.8.67-1.22,1.76-1.04,2.73l.04.21.18-.11c.3-.18.57-.5.78-.9.09.57.31,1.09.63,1.53-.8.84-.98,1.82-.72,2.75l.06.2.17-.12c.27-.2.51-.53.68-.93.05.28.12.54.23.79.23.52.19.65.62.98-.08.11-.15.24-.22.37-1.42-.6-3.14-1.03-5.15-1.03h0c-1.51,0-3.07.25-4.66.74h0s0,0,0,0c-2.19.69-3.8.91-4.99.91,0,0,0,0,0,0,.11-.17.21-.36.29-.55.1-.24.18-.5.21-.76.02-.18.02-.36,0-.54h0s0-.04,0-.04c-.01-.1-.03-.19-.05-.28v-.07c-.17-.57-.69-1.02-1.11-1.39-.42-.37-.9-.79-1.58-.87-.54-.07-1.16.05-1.88.34-1.18.47-1.59.34-1.95.22l-.08-.03c-.42-.15-1.32-.81-1.32-.82l-.38-.28.6,1.78-1.91.17.17.21s.64.8,2.17,1.31c.35.1.69.14,1,.14.96,0,1.75-.38,2.41-.7.25-.12.49-.23.71-.32.25-.09.51-.15.77-.18-.21.84-.95,1.42-1.25,1.63l-.16.1v.07c.09.62.6,3.77,2.23,4.81.48.31,1.04.44,1.69.44.24,0,.5-.02.77-.05-.1,1.06-.18,2.11-.23,3.14l-11.68-7.64-.53-2.62s-4.88-1.06-4.89-1.06c-.21-.02-.41.08-.53.26-.13.2-.13.46.01.66l2.88,3.99,2.59-.56c-.19,2.43-.29,4.8-.31,7.05l-1.28-.84-.53-2.62s-4.89-1.06-4.89-1.06c-.21-.02-.41.08-.53.26-.13.2-.13.46.02.65l2.88,3.99,2.51-.54c-1.79,13.47.22,22.62,2.23,27.94,2.07,5.47,4.5,8.07,4.89,8.46.66.77,4.99,5.47,11.68,5.47,2.9,0,6.23-.89,9.89-3.36-1.14,3.75-4.08,8.16-4.11,8.21l-.16.24h.29c1.33-.05,2.38.06,3.18.21l-.49,2.02c-.07.19-.05.33-.05.33,0,.1.03.33.23.51.31.28.87.35,1.67.22.36-.06.64-.07.87-.04l.08,2.14s0,.08,0,.13c0,.05.03.1.06.16.26.4,1.22.6,2.85.6s2.58-.2,2.84-.6c.07-.1.08-.21.06-.28l.08-2.14c.22-.02.5-.02.87.04.8.13,1.36.06,1.67-.22.2-.18.23-.4.23-.5,0-.05,0-.09,0-.14-.02-.13-.06-.25-.09-.37-.05-.21-.1-.41-.15-.62-.06-.24-.12-.48-.18-.73-.04-.16-.08-.31-.11-.47,0-.01,0-.03,0-.04.8-.16,1.86-.27,3.18-.22h.29s-.16-.23-.16-.23c-.03-.05-2.98-4.48-4.12-8.23,3.67,2.49,7.01,3.38,9.91,3.38,6.69,0,11.06-4.73,11.72-5.5.11-.11,2.63-2.59,4.84-8.43,2.01-5.32,4.02-14.47,2.23-27.94l2.51.54,2.88-3.99c.14-.2.15-.45.02-.66ZM103.63,58.99l3.77-.82-2.26,3.12-1.89-.41.38-1.9ZM38.72,61.3l-2.26-3.12,3.77.82.38,1.9-1.89.41ZM36.67,68.18l-2.26-3.12,3.77.82.38,1.9-1.89.41ZM96.76,65.61l5.37-3.51c.18,2.45.28,4.84.28,7.09l-6.11,4c.26-2.29.41-4.78.46-7.58ZM90.79,69.52l2.55-1.67c-.11,2.81-.35,5.36-.71,7.75l-1.98,1.3c.19-2.33.24-4.78.15-7.37ZM90.55,77.9l3.17-2.08c-.18,4.36-.77,8.72-2.13,12.87-.69,2.12-1.58,4.19-2.67,6.16-1.07,1.95-2.35,3.8-3.78,5.52-.74.9-1.53,1.76-2.35,2.58-.59-.57-1.03-1.07-1.3-1.41,4.22-5.26,8-13.04,9.05-23.65ZM76.65,101.37c-.08-.13-.22-.18-.34-.22l-.06-.02c-.07-.03-.11-.07-.12-.09,0-.01.05-.04.08-.06.04-.03.08-.05.12-.1.16-.22.16-.47,0-.69-.23-.31-.7-.48-1.02-.37-.15.04-.28.1-.4.17-.06.03-.13.07-.19.09-.09.04-.31.11-.46.01-.05-.03-.09-.09-.13-.14-.06-.07-.12-.15-.21-.21-.14-.09-.3-.1-.43-.11l-1.72-.11c-.23-.02-.37.05-.47.25-.04.03-.11.03-.23.03-.1,0-.21,0-.31.03-.18.06-.29.2-.38.33-.06.08-.11.15-.17.2-.16.12-.39.09-.64.05-.11-.02-.23-.03-.35-.04-.32-.01-.78.14-1.01.44-.14.17-.18.37-.11.59.02.04.04.08.07.12.02.02.03.05.04.07.04.08,0,.2-.08.28-.1.11-.26.12-.45.14-.2.02-.43.04-.6.22-.05.06-.09.13-.12.19-.03.05-.05.1-.09.13-.03.03-.08.05-.13.07-.05.02-.1.04-.15.08-.33.21-.33.6-.33.95,0,.15,0,.27-.02.37-2.73-2.61-5.52-6.26-7.73-11.04h2.24c.05.1.1.2.14.3.32.69.65,1.4,1.26,1.89.16.18.28.39.4.61.12.21.24.43.4.62.24.28.53.48.82.68.81.55,1.73,1.17,2.77,1.39.25.05.51.08.76.11.31.03.6.07.89.14.21.05.4.13.61.21.17.06.34.13.52.18.65.19,1.33.22,1.98.24,1.11.04,2.25.09,3.35-.2l.16-.04c.54-.15,1.1-.3,1.49,0,.15.12.26.3.38.48.2.32.4.64.82.68.1,0,.13.02.13.02.02.02.02.13.02.21,0,.06,0,.11,0,.19.03.2.18.35.4.41.06.02.12.02.18.02.19,0,.37-.08.48-.22.27-.34.13-.86-.17-1.12l-.03-.02s-.06-.05-.07-.07c0-.01,0-.06.07-.17.42-.6,1.11-.99,1.84-1.06.06,0,.11,0,.17-.01.25-.02.52-.03.75-.18l.21-.14-.23-.12c-.16-.08-.3-.18-.44-.29.54-.3,1.13-.4,1.77.31-1.66,2.53-3.46,4.61-5.23,6.25-.04-.06-.06-.14-.07-.24v-.04c-.04-.06-.07-.11-.11-.16-.02-.03-.05-.06-.06-.09-.02-.04-.02-.1-.02-.17,0-.06,0-.11-.01-.17-.05-.29-.3-.53-.71-.66-.11-.04-.15-.06-.16-.08.03-.12.11-.26.2-.39.17-.26.36-.55.21-.91ZM67.84,65.18c-4.7,1.65-8.42.5-10.61-.67.46-.13.93-.26,1.42-.39,4.29-.82,7.5-.13,9.2.45-.03.2-.03.4-.01.6ZM69.49,65.35c.26.36.59.66.95.86l.18.1.03-.21c.06-.37.02-.81-.12-1.26.31-.16.62-.34.94-.52.06.16.14.32.23.47l.11.18.13-.17c.12-.15.22-.34.3-.55,3.08,1.85,5.89,2.49,8.29,2.49,2.95,0,5.3-.96,6.81-1.82.02-.01.15-.09.25-.15.61.17,1.17.32,1.7.44,0,.09.01.2.02.25.49,5.02.4,9.56-.1,13.64h-34.6c-.52-4.15-.62-8.77-.13-13.87.54-.12,1.11-.28,1.73-.45,2.46,1.46,7.33,3.17,13.26.56ZM66.59,54.83h0s-.03-.09-.04-.14c.29.27.64.46,1.01.56l.2.05-.02-.21c-.03-.44-.26-.94-.62-1.37h0c-.25-.27-.62-.58-1.01-.74.05-.23.07-.49.07-.76l1.02.79.28.4.02.82c.04.07.09.13.13.2.03.04.06.08.08.12l.03.04s.06.09.06.12c0,.31.09.61.28.9-.03.04-.07.08-.1.12-.08.1-.15.19-.23.27-.18.19-.3.41-.38.66-.28-.21-.61-.44-.73-.51.07-.4.06-.86-.04-1.33ZM66.97,43.55c0,.19-.03.39-.07.59-.06.32-.17.64-.32.94-.25.47-.59.85-.93,1.06,0-.74.28-1.5.77-2.06.18-.21.36-.38.56-.53ZM66.75,43.01c-.59-.08-1.09.09-1.48.48,0,0,0,0-.02.01-.01-.16.04-.28.09-.4.05-.11.11-.19.17-.27.13-.17.31-.33.52-.45.12-.07.25-.09.38-.09.12,0,.23.02.33.04.12.03.19.11.22.27.02.11.02.19-.07.4,0,0-.01,0-.02,0-.04,0-.08,0-.12,0ZM65.86,48.38h0c0-.13,0-.25,0-.37.26.35.61.64,1,.8l.19.08v-.21c.04-.44-.11-.97-.41-1.44h0c-.2-.29-.5-.63-.85-.85.39-.24.77-.66,1.05-1.18h0c.15-.3.26-.62.33-.94.11.35.26.69.41.95.28.46.68.84,1.14,1.09-.5.88-.55,1.96-.11,2.79l.1.19.14-.16c.25-.29.43-.74.5-1.25.27.57.67,1.03,1.16,1.34-.17.14-.32.33-.47.52-.43.58-.62,1.35-.52,2.05l.03.21.19-.1c.36-.19.69-.58.92-1.08.1.62.36,1.19.75,1.64-.37.24-.7.56-.93.94-.26.42-.4.93-.4,1.44v.21s.2-.07.2-.07c.34-.12.67-.39.95-.77-.03.64.1,1.28.39,1.82-.19.08-.37.18-.56.31-.58.41-1,1.07-1.12,1.78l-.03.2.2-.03c.36-.05.75-.27,1.09-.6-.15.75-.07,1.54.23,2.2-.22.25-.42.55-.58.89-.31.64-.42,1.38-.33,2.08-.43-.39-.99-.82-1.65-1.26-.05-.18-.1-.35-.16-.47h0c-.04-.07-.08-.14-.12-.21.26.1.53.15.81.15.07,0,.14,0,.21-.01l.2-.02-.07-.18c-.16-.4-.53-.81-.99-1.09h0s-.06-.03-.1-.05c-.02-.31-.11-.63-.48-.67-.13-.02-.26,0-.4.03-.03,0-.06,0-.08,0-.02-.01-.03-.04-.03-.06-.08-.25-.13-.52-.16-.78.2.15.43.27.66.35l.19.06v-.2c0-.44-.2-.95-.53-1.4h0s-.1-.1-.18-.17c.03-.08.06-.16.11-.23.19-.31.39-.61.62-.88.04-.04.08-.09.14-.08-.23-.14-.39-.31-.44-.59-.04-.21-.05-.44,0-.65,0-.04.02-.08.06-.09-.15-.04-.26-.19-.31-.35-.04-.15-.05-.35-.03-.5v-.08s-.61-.93-.61-.93c0,0-.63-.01-.98-.55,0-.01-.01-.02-.02-.03-.01-.1-.02-.2-.04-.31.25.21.53.37.82.46l.2.06v-.21c-.02-.44-.23-.95-.57-1.39h0c-.28-.35-.65-.63-1.05-.81.19-.37.32-.83.36-1.33ZM65.6,46.63c.32.19.62.52.79.78.21.34.34.71.37,1.03-.3-.17-.56-.42-.75-.71-.12-.18-.21-.38-.28-.6-.03-.1-.05-.21-.09-.31-.01-.06-.03-.13-.04-.19ZM67.33,43.57c.42.26.79.64,1.06,1.06.27.46.44.97.45,1.41-.4-.23-.75-.57-1-.97-.28-.48-.47-1.03-.51-1.49ZM68.92,46.54c.12.32.18.75.16,1.16-.03.4-.14.77-.31,1.04-.26-.67-.2-1.5.15-2.2ZM69.27,46.46c.41.28.77.67,1.02,1.11.21.39.34.82.38,1.2v.17c-.81-.42-1.31-1.42-1.4-2.48ZM70.64,49.51s0,.09,0,.14c0,.07-.01.14-.02.21-.03.28-.1.55-.2.8-.16.36-.38.66-.62.85-.02-.56.15-1.14.49-1.6.1-.13.23-.29.35-.4ZM72.19,54.49c0,.52-.1,1.02-.28,1.4l-.05-.02c-.32-.62-.43-1.39-.28-2.12.06-.25.12-.55.23-.78.23.47.36,1,.38,1.52ZM72.03,52.28c.3.22.56.51.75.83.19.35.3.73.31,1.06-.43-.29-.78-.76-.94-1.32-.05-.18-.1-.38-.12-.57ZM71.26,62.54c-.11.23-.24.43-.39.59-.17-.71-.09-1.52.25-2.2.12-.25.26-.47.41-.67.04.19.06.38.07.58.01.18,0,.37-.02.56-.11.24-.19.49-.26.78-.03.12-.05.25-.07.37ZM71.27,63.54s-.02.01-.03.02c-.06-.06-.12-.13-.19-.2.06-.07.13-.14.18-.21,0,.13.02.26.04.39ZM69.07,63.24c.4.3.75.71.98,1.15.24.48.36,1,.35,1.44-.57-.39-1.01-1.04-1.19-1.77-.06-.26-.13-.57-.13-.83ZM69.1,64.68s-.05.02-.08.04c-.05-.02-.1-.05-.16-.07.03-.07.05-.14.07-.21h0s.02-.09.03-.13c.04.13.09.25.14.37ZM70.22,64.11c-.29-.49-.69-.93-1.15-1.23,0-.19-.03-.52-.1-.85.7.48,1.26.95,1.66,1.34,0,.02.01.05.02.07l.07.2.1-.08s.09.09.13.13c-.01,0-.02.01-.03.02-.16.09-.32.17-.47.26-.08.04-.15.09-.23.13ZM71.55,62.62c.1-.22.19-.46.25-.72h0c.03-.14.05-.28.07-.42.07.17.14.35.19.54.09.31.13.65.13.99-.01.54-.14,1.05-.34,1.41-.27-.54-.37-1.18-.3-1.81ZM71.87,60.11c.26.26.48.58.62.92.14.36.21.72.18,1.03-.51-.46-.81-1.19-.8-1.94ZM71.62,59.59c-.26-.68-.27-1.49-.03-2.21.09-.27.2-.51.33-.73.06.18.11.37.14.56.06.32.07.66.04,1-.06.54-.24,1.03-.48,1.38ZM71.13,57.35c-.26.29-.56.5-.85.6.15-.54.49-1.04.95-1.36.16-.11.31-.2.47-.27-.03.1-.08.2-.12.29l-.04.09c-.1.23-.25.45-.42.65ZM71.1,49.8c.07.09.15.17.23.25.14.26.26.53.33.81.08.35.11.7.09,1.02l-.02.12s0,.07,0,.1c0,.07-.02.14-.04.2l-.03.02c-.46-.52-.74-1.25-.76-2,0-.15,0-.31,0-.47,0-.08.02-.15.02-.23,0-.01,0-.03,0-.04.05.08.11.15.16.22ZM71.03,49.13c.35.08.69.25.97.47.3.25.55.56.68.86-.4-.07-.78-.28-1.1-.58-.15-.28-.34-.53-.55-.75ZM71.5,52.76c-.04.35-.18.75-.38,1.11-.21.33-.47.59-.73.75.04-.37.15-.74.34-1.05.2-.32.46-.6.77-.81ZM68.59,60.04c.33.2.61.47.78.75-.34,0-.68-.1-.97-.28-.08-.05-.16-.1-.23-.16-.19-.1-.47-.44-.45-.42-.06-.07-.11-.14-.16-.21.36.02.73.13,1.04.31ZM67.8,59.5s.02-.03.03-.04c.06-.08.12-.14.19-.17.04-.02.09-.03.13-.03s.08,0,.11.03c.03.02.05.04.07.06.02.03.03.06.03.09,0,.04.01.08.01.12,0,.03,0,.05,0,.07-.18-.05-.38-.1-.57-.14ZM66.32,50.71c.24.31.41.67.47.99-.33-.15-.63-.4-.87-.71-.11-.28-.24-.55-.41-.8-.02-.06-.05-.12-.06-.18.33.16.63.41.87.7ZM66.01,53.26c.34.15.67.42.88.65.26.3.44.65.52.97-.32-.12-.61-.33-.84-.6-.24-.28-.44-.63-.56-1.01,0,0,0,0,0-.01ZM67.58,57.22c.24.32.4.68.45,1-.47-.21-.87-.63-1.1-1.15-.07-.17-.15-.37-.2-.56.32.17.63.41.85.7ZM67.52,60.16c.12.14.27.27.42.4.2.22.37.46.51.72.24.48.36,1,.35,1.44-.57-.39-1.01-1.04-1.19-1.77-.02-.07-.03-.14-.05-.22-.01-.16-.04-.32-.08-.48,0-.04,0-.09,0-.13.02.01.03.03.05.04ZM68.65,64.34c-.12.37-.3.69-.51.91-.05-.34-.02-.7.08-1.03.12-.38.31-.73.53-.98.04.37,0,.75-.1,1.1ZM75.22,64.88c1.33-.56,4.91-1.74,10.01-.75.45.12.89.24,1.31.36-2.69,1.41-6.57,2.35-11.32.4ZM89.12,79.9c-.65,4.7-1.85,8.79-3.38,12.29h-13.43v-.36l.91-1.92-.86-2.61c.46.07.92.21,1.38.47.09.38.53,1.97,1.25,2.21.26.09.58.12.9.12.63,0,1.27-.14,1.54-.31l.18-.11-.16-.13s-.54-.39-1.06-.92c-.7-.72-.68-2.07-.64-2.78,0-.06.01-.14.02-.24.1-1.01.4-4.1-2.21-4.6-.56-.11-1.13-.11-1.69,0-.49.09-.97.25-1.42.47-.37.18-.73.4-1.06.65-.19.14-.41.28-.58.46-.21.22-.25.44-.29.72-.04.25-.06.51-.06.77,0,.14,0,.32.09.44.18.26.37.19.51.14.03-.01.06-.02.09-.03.05.38-.13,1.86-.35,3.19l-.05.31.27-.16s.9-.52,2.07-.67l-.87,2.61.94,1.92v.36h-13.01c-1.53-3.51-2.75-7.59-3.41-12.29h34.38ZM80.49,97.8c.12.11.25.22.38.31-.11.02-.23.03-.35.04-.06,0-.12,0-.18.01-.81.08-1.58.52-2.06,1.19-.04.06-.18.25-.1.45.04.09.1.14.15.19l.02.02c.19.17.29.5.13.71-.08.1-.24.12-.35.09-.05-.01-.16-.06-.18-.16,0-.05,0-.1,0-.15,0-.15,0-.32-.12-.43-.08-.07-.2-.11-.33-.1-.25-.02-.4-.26-.58-.54-.13-.2-.26-.41-.44-.56-.5-.4-1.16-.21-1.75-.06l-.16.04c-1.06.28-2.18.24-3.26.19-.64-.02-1.3-.05-1.91-.23-.17-.05-.33-.11-.5-.17-.21-.08-.42-.16-.64-.21-.31-.08-.62-.11-.93-.15-.24-.03-.49-.05-.73-.1-.98-.21-1.88-.81-2.66-1.34-.27-.18-.55-.38-.76-.62-.14-.17-.25-.37-.37-.58-.13-.23-.26-.46-.46-.69-.58-.46-.88-1.11-1.19-1.8-.03-.06-.06-.12-.08-.18h24.32c-.81,1.75-1.69,3.35-2.62,4.8-.86-.9-1.69-.57-2.26-.21l-.16.1.14.13ZM70.54,89.88l.87-2.62c.2-.01.41-.02.62,0l.87,2.63-.87,1.85v.46h-.58v-.43l-.91-1.88ZM74.47,83.87c-.31-.69-.9-1.31-1.65-1.43-.62-.1-1.24.14-1.79.45-.46.26-.88.56-1.28.9-.18.16-.35.33-.55.46-.08.05-.21.16-.3.15-.1,0-.14-.13-.15-.21,0-.32.02-.63.07-.95.01-.09.03-.19.07-.27.06-.11.15-.2.25-.28,1.02-.88,2.32-1.47,3.66-1.47.54,0,1.09.1,1.55.4.64.42.99,1.17,1.11,1.93.12.75.05,1.52.02,2.29-.03.76-.01,1.55.27,2.26.26.64.74,1.18,1.34,1.52-.52.18-1.07.24-1.62.17-.18-.02-.36-.06-.51-.16-.17-.11-.28-.29-.38-.47-.23-.41-.4-.86-.5-1.32-.02-.09-.04-.19-.1-.26-.04-.05-.1-.08-.16-.12-.71-.39-1.54-.54-2.34-.5-.81.04-1.6.27-2.33.61.18-.96.28-1.93.3-2.91,0-.05,0-.1.02-.15,0-.01,0-.03.01-.04.03-.05.07-.1.12-.14.56-.52,1.18-.99,1.87-1.32.51-.24,1.1-.41,1.62-.21.3.11.55.33.75.59.58.76.7,1.77.8,2.72.1,0,.19,0,.29-.01-.06-.76-.13-1.53-.44-2.22ZM92.74,57.67c.41-.36.83-.73,1.42-.8.49-.06,1.06.05,1.74.32,1.28.51,1.74.36,2.15.23l.09-.03c.28-.1.72-.38,1.03-.6l-.43,1.26,1.7.15c-.28.25-.86.68-1.82,1-1.31.36-2.31-.12-3.2-.54-.26-.12-.5-.24-.74-.33-.91-.34-1.92-.28-2.74.14.21-.3.51-.56.79-.81ZM91.73,58.97c.51-.36,1.13-.55,1.78-.54.19.91.9,1.54,1.29,1.82-.29.27-1.01.75-2.55.83-.18-.24-.78-1.16-.52-2.11ZM82.25,59.73h0c1.48,0,3.01.25,4.57.73h0c5.06,1.54,7.31.73,8.05.12-.18,1.02-.72,3.39-2.03,4.23-1.21.79-3.09.26-5.69-.47-.59-.16-1.21-.34-1.86-.51-5.53-1.06-9.33.37-10.45.88-.23-.1-.46-.21-.69-.32-.05-.03-.09-.06-.14-.09-.19-.11-.38-.22-.58-.33-.16-.09-.32-.17-.47-.26-.01,0-.02-.01-.03-.02,1.17-1.24,4.32-3.96,9.33-3.96ZM76.43,60.25s.06.1.08.15c.04.07.08.14.08.21,0,.17-.2.23-.34.17-.23-.09-.46-.29-.64-.45-.22-.21-.78-.97-.3-1.2.26-.12.51.16.65.35.18.24.32.51.47.77ZM76.47,44.88c.5-.81.22-1.93-.03-2.7l-.04-.14c-.61-2.05-.95-3.69.61-4.51.85-.43,1.97-.6,3.43-.53,3.54.17,7.15,1.47,10.72,3.86,4.18,2.8,8,5.72,11.69,8.95.55.48,1.12.96,1.68,1.43,1.44,1.21,2.93,2.46,4.19,3.85.36.39.7.77.85,1.22-.33-.14-.64-.35-.97-.57-.24-.16-.49-.33-.74-.47-.47-.29-.72-.45-1.14-.85-.18-.15-.43-.15-.6,0-.17.15-.2.41-.07.61.09.13.14.2.17.26-.09-.05-.19-.11-.28-.18l-.03-.02c-.28-.18-.56-.42-.83-.64-.22-.19-.45-.38-.68-.54l-1.41-1,.84,1.51c.06.11.11.22.15.34,0,0,0,0-.01,0-.46-.34-.97-.57-1.46-.8l-.19-.09c-.17-.08-.37-.07-.52.04-.12.09-.2.23-.2.38-.36-.2-.69-.46-1.04-.74-.09-.07-.19-.15-.28-.22l-.35-.27-.23.38s-.04.08-.06.11c0,0,0,0,0,.01-.37-.12-.62-.34-.91-.59-.14-.12-.29-.25-.46-.37-.15-.11-.35-.13-.51-.05-.17.08-.27.25-.28.44v.03c0,.1,0,.27-.02.39-.01,0-.02,0-.04-.02-.57-.22-1.06-.58-1.59-.96-.28-.21-.58-.42-.88-.61l-.34-.21-.21.34c-.03.05-.05.1-.07.15-.66-.25-1.27-.68-1.86-1.1l-.14-.1c-.09-.07-.35-.26-.62-.09-.08.05-.2.17-.2.4-.19-.08-.53-.27-1.13-.69-.1-.07-.18-.13-.21-.14-.27-.19-.48-.15-.65-.08-.01,0-.02,0-.03.01-.04,0-.12-.04-.17-.06-.33-.16-.66-.35-.96-.56-.03-.02-.06-.05-.1-.08-.2-.18-.48-.42-.81-.35-.15.03-.28.12-.37.26-.19-.07-.35-.06-.48.03-.23.15-.22.42-.21.52.01.27-.05.55-.2.89-.05.11-.09.14-.09.14,0,0-.06-.01-.17-.09,0,0-.02-.02-.03-.03-.08-.07-.24-.22-.47-.18-.1.02-.24.07-.35.25-.08.1-.13.13-.13.13-.01,0-.06-.03-.13-.13l-.04-.06c-.15-.19-.32-.43-.65-.57-.02-.02-.04-.06-.05-.08l-.05-.07c-.1-.15-.27-.23-.44-.22-.18.01-.33.12-.4.28l-.02.04c-.08-.08-.2-.19-.38-.2-.14-.01-.25.03-.34.08-.25-.15-.53-.17-.81-.08-.15-.03-.26,0-.34.03-.22.1-.28.33-.3.4-.02.09-.07.26-.11.3-.32.15-.43.41-.5.58l-.02.04c-.04.1-.08.16-.11.2-.11-.09-.26-.12-.4-.09-.15.03-.28.14-.34.29-.11.25-.34.43-.62.62h0s-.03-.12-.04-.18c-.02-.11-.04-.24-.09-.37l-.37-1.01-.41,1.11c-.02.07-.04.12-.07.19-.1.3-.46.57-.69.55-.04,0-.14,0-.2-.26,0-.02,0-.04,0-.06-.01-.11-.04-.29-.18-.47l-.33.26c-.1-.47-.43-.97-.48-1.09-.1-.21-.03-.59.21-1.05.24-.46-.38-1.56-.38-1.56.86-1.04.39-2.35-.04-3.14.29-.14.52-.34.69-.6ZM74.84,45.22c.06.08.16.15.38.18.01.01.03.03.04.04.35.41.51.84.66,1.36.08.28.11.58.04.86-.05.21-.17.43-.33.58-.1.1-.2.22-.31.31-.02.01-.05.03-.08.06-.25.13-.69.29-1.39.39,0,0-.5.36,1.52-.06.11.13.22.26.31.41.12.19.18.3.13.52,0,.17-.13.39-.18.55-.06.18-.11.37-.1.56.03.48.48.75.6,1.19.06.24,0,.5-.15.69-.06.07-.23.15-.25.23-.03.07.05.2.06.28.02.15,0,.35-.03.5-.04.16-.15.3-.31.35.03.01.05.05.06.09.05.21.04.44,0,.65-.05.28-.21.44-.44.59.05-.01.1.04.14.08.23.28.43.58.62.88.2.33.25.8.26,1.18,0,.41-.05.82-.18,1.2,0,.02-.02.04-.03.06-.02.02-.05.01-.08,0-.13-.02-.26-.05-.4-.03-.44.05-.48.49-.48.86l-.63-.69h0s-.36,1.22-1.53,1.39c0,0,1.01.18,1.79-.89.05.09.1.17.15.26.15.23.33.45.53.64.2.19.42.41.66.54.02.01.05.02.07.03-1.63.88-2.73,1.93-3.31,2.54-.06-.04-.12-.07-.18-.11.02-.14.03-.29.03-.44h0c0-.27-.03-.55-.08-.81.09.09.18.17.28.24l.18.13.05-.21c.1-.4.04-.93-.16-1.45h0c-.19-.46-.51-.88-.88-1.19.26-.38.44-.9.51-1.48h0c.02-.22.02-.45,0-.66.3.4.7.7,1.13.85l.2.07v-.21c0-.44-.19-.96-.51-1.42h0c-.27-.36-.64-.66-1.03-.86.2-.42.31-.95.3-1.53h0c0-.17-.02-.34-.05-.5.21.24.45.44.72.57l.19.09.03-.21c.05-.44-.07-.97-.34-1.47h0c-.24-.41-.59-.78-.98-1.03.03-.36,0-.76-.1-1.16h0c-.03-.12-.07-.23-.11-.35.33.2.69.32,1.06.34h.2s-.05-.18-.05-.18c-.11-.43-.42-.88-.85-1.23h0c-.35-.28-.78-.47-1.21-.55-.03-.44-.18-.93-.43-1.39h0c-.32-.56-.81-1.05-1.34-1.36l-.07-.04c-.02-.49-.19-1.04-.49-1.55h0c-.16-.25-.35-.49-.57-.7.07.03.13.05.17.06.17.04.58.47.73.61.06.06.17.1.28.12l.03.6s.35-.58.72-.62c0,0,.88.36.98,1.26.05.44.06,1.02.16,1.45.02.08.04.17.1.23.06.06.15.08.24.1.54.09,1.14.03,1.61-.25.23-.14.49-.34.51-.62.02-.37-.08-.71-.21-1.05-.08-.21-.18-.42-.29-.62-.06-.1-.12-.2-.2-.29-.08-.1-.18-.18-.27-.28-.02-.03-.04-.05-.05-.07.43-.03,1.58-.04,2.26.78ZM72.13,56.32c.32.18.62.44.84.73.23.32.39.69.44,1.01-.47-.23-.86-.66-1.09-1.19-.07-.17-.15-.37-.19-.55ZM71.23,42.94v.1c-.01.11-.02.21-.04.31-.07.29.08.48.26.64.04.04.09.07.13.09.02.01.04.02.06.04.47.32.84.74,1.12,1.22.19.34.43.75.51,1.13.07.33-.22.62-.48.76-.37.2-.82.25-1.23.14-.04-.01-.09-.03-.12-.06-.05-.05-.05-.14-.05-.22,0-.18,0-.35,0-.53,0,0-.02-.24-.02-.24,0-.04,0-.07-.01-.11v-.03c-.04-.8-.41-1.44-1.13-1.97-.13-.1-.32-.2-.56-.12-.05.02-.11.02-.17.03-.03,0-.05,0-.08,0-.12.01-.2-.01-.28-.09-.5-.46-1.07-.76-1.67-.9,0,0-.01,0-.02-.02.05-.31.05-.57-.04-.86.08-.06.17-.08.26-.13.09-.06.17-.14.26-.21.14-.13.3-.26.49-.27.09,0,.17.02.25.04.07.02.13.02.2.03.17.02.34.03.5-.03.1-.04.2-.11.31-.09.09.02.15.09.22.14.07.04.16.06.24.09.14.04.26,0,.36-.05.03-.01.06-.03.09-.04.47.26.68.65.66,1.18ZM69,40.91c.33.14.68.01.68.01l.06-.03c.22-.1.39-.14.54-.15.16,0,.31.04.4.12.07.06.12.15.14.21.01.04.05.14,0,.24-.03.04-.05.07-.09.1-.15.13-.36.16-.54.07-.14-.07-.24-.21-.39-.25-.16-.04-.25.08-.38.14-.22.1-.46-.02-.7-.05-.46-.06-.77.22-1.06.54-.11.12-.27.25-.44.21-.07-.02-.12-.07-.18-.12-.08-.06-.17-.1-.27-.11-.18-.02-.37.02-.54-.05-.28-.11-.24-.42-.08-.63.21-.27.72-.08.96.07.05.03.1.07.15.07.07,0,.12-.02.17-.06l.1-.1c.69-1.03,1.12-.4,1.46-.26ZM63.88,51.45c-.1.04-.19.12-.27.25-.02-.04-.05-.09-.08-.16l-.02-.05c-.07-.17-.18-.43-.5-.58-.04-.04-.09-.21-.12-.3-.02-.07-.08-.29-.3-.4-.08-.04-.19-.07-.34-.03-.28-.09-.56-.06-.81.08-.08-.05-.2-.1-.34-.08-.17.02-.3.11-.38.2l-.02-.04c-.07-.16-.22-.27-.4-.28-.17-.01-.34.07-.44.22l-.05.07s-.04.06-.06.08c-.32.13-.5.37-.65.57l-.04.06c-.08.1-.12.12-.12.13-.01,0-.06-.03-.15-.15-.04-.05-.16-.22-.38-.24-.1,0-.25.01-.4.16-.12.12-.2.14-.21.15-.13-.05-.32-.56-.31-1.03,0-.1.02-.37-.21-.52-.14-.09-.3-.1-.48-.03-.09-.14-.22-.24-.37-.26-.33-.06-.61.18-.81.35-.04.03-.07.06-.08.07l-.2.13c-.32.21-.63.41-.95.5,0,0-.02,0-.02,0-.17-.06-.38-.11-.63.07-.05.03-.14.09-.24.17-.37.26-.67.45-.89.57-.1.05-.22.01-.26-.09-.03-.08-.09-.16-.19-.22-.27-.15-.51.04-.61.12l-.13.09c-.59.42-1.2.85-1.86,1.1-.02-.05-.04-.1-.07-.15l-.21-.34-.34.21c-.31.19-.6.4-.88.61-.53.38-1.02.74-1.61.97,0,0,0,0-.01,0-.02-.11-.02-.29-.02-.39v-.03c0-.19-.11-.35-.28-.44-.17-.08-.36-.06-.51.04-.17.12-.32.25-.46.37-.3.25-.55.47-.92.59,0-.02-.02-.04-.03-.06-.03-.08-.06-.17-.1-.26-.04-.11-.19-.15-.29-.08-.07.05-.14.11-.21.16-.16.11-.32.24-.48.37-.29.23-.57.44-.87.61,0-.15-.08-.29-.2-.38-.15-.11-.35-.13-.52-.04l-.19.09c-.49.22-1,.46-1.46.79,0,0-.01,0-.02.01.04-.11.09-.22.15-.33,0,0,0-.02.01-.03.05-.19.13-.37.16-.56.05-.28-.24-.26-.43-.15l-.34.21s0,0-.01,0c-.07.05-.17.14-.34.28-.68.58-1.17.95-1.45,1.1.03-.07.08-.14.17-.27.13-.19.1-.44-.07-.6-.17-.16-.43-.16-.62,0-.5.47-1.02.79-1.57,1.12-.27.16-.55.33-.84.53-.13.09-.29.17-.42.24.15-.45.49-.83.86-1.24,1.25-1.38,2.74-2.63,4.18-3.84.56-.47,1.13-.95,1.68-1.42,3.69-3.22,7.51-6.15,11.69-8.95,3.57-2.39,7.17-3.69,10.72-3.86,1.13-.06,3.16-.01,4.09,1.07.44.52.6,1.43.43,2.35-.42-.06-.8.55-.8.55-.22-.12-.47-.2-.72-.16-.42.06-.63.47-.53.88v.04c.02.06.04.11.06.17-.01.02-.03.04-.05.06-.02.02-.04.03-.06.04-.03.02-.06.04-.09.07-.05.05-.11.09-.17.13-.1.08-.21.16-.31.26-.44.47-.57,1.02-.38,1.66,0,.03.02.06.03.11.21.57.13-.37.66-.62.44-.21.83-.25,1.13-.22-.18.14-.35.31-.51.5-.53.61-.83,1.44-.83,2.25-.03,0-.07.02-.1.02h0s0,0,0,0c-.69.16-1.3.77-1.45,1.49l-.04.19h.19c.31-.02.59-.18.78-.32-.21.76-.18,1.57.1,2.27-.49.44-.83,1.04-.95,1.66ZM64.77,51.08c-.02.09-.05.18-.07.26-.12.33-.3.61-.49.82-.02.01-.05.03-.08.04-.06-.7.2-1.45.71-2-.05.26-.06.54-.07.79,0,.03,0,.06,0,.09ZM64.74,47.13c-.18.17-.39.3-.58.36.17-.45.57-.84,1.01-1,0,0,0,.01,0,.02-.07.1-.13.21-.18.33-.07.11-.15.2-.24.29ZM65.03,47.55c.06-.19.13-.4.22-.59.03-.05.06-.09.09-.14.01.03.02.06.03.08.03.12.06.24.1.35.09.36.13.74.1,1.11-.04.46-.16.9-.34,1.24l-.09.12-.02-.04c-.26-.65-.29-1.43-.08-2.13ZM65.07,51.1c.07-.3.1-.6.08-.87v-.02s.07.09.1.13c.05.12.1.24.14.35.07.16.16.31.26.44.05.14.1.29.13.44.1.47.09.93.01,1.32l-.19-.04c-.34-.49-.54-1.12-.56-1.75ZM65.36,53.39c-.06.24-.08.51-.09.76-.03.13-.07.26-.11.37-.15.37-.36.68-.59.88-.05-.73.24-1.5.79-2.04,0,0,0,.02,0,.03ZM65.97,57.92c-.12.38-.3.71-.51.94-.12-.72.1-1.52.59-2.11.06.4,0,.85-.08,1.17ZM66.28,56.37s-.01-.01-.02-.02l-.08-.1-.03-.04c-.38-.53-.6-1.21-.59-1.9,0-.04,0-.08,0-.11.05-.22.08-.45.09-.69.3.4.53.89.64,1.38.11.53.1,1.07-.02,1.48ZM66.64,59c-.25-.58-.33-1.29-.21-2,.32.39.58.87.71,1.36.09.35.12.71.1,1.07v.07s-.04.2-.04.2c0,.01,0,0,0,0,0,.05-.01.09-.02.14-.19-.19-.38-.49-.54-.85ZM66.94,60.83c.07-.16.16-.34.26-.5.01.14.04.28.06.42.02.25,0,.49-.03.73-.08.4-.23.75-.42,1-.14-.53-.09-1.13.13-1.66ZM49.19,58.34c-.23.09-.48.2-.74.33-.89.43-1.89.91-3.2.54-.96-.32-1.53-.75-1.82-1l1.7-.15-.43-1.26c.31.21.75.49,1.03.6l.09.03c.41.13.88.28,2.15-.23.67-.28,1.24-.38,1.74-.32.59.07,1.01.44,1.42.8.28.24.58.51.79.81-.82-.42-1.82-.47-2.74-.14ZM50.37,58.43c.64,0,1.27.18,1.78.54.26.95-.34,1.87-.52,2.11-1.54-.07-2.26-.55-2.55-.83.39-.28,1.1-.92,1.29-1.82ZM51.03,64.81c-1.31-.84-1.85-3.21-2.03-4.23.75.61,3,1.42,8.05-.12h0c1.55-.48,3.09-.73,4.57-.73h0c1.96,0,3.64.42,5.02,1.01-.28.68-.3,1.44-.05,2.09l.08.2.16-.15c.31-.29.55-.76.67-1.31.25.57.64,1.05,1.11,1.38-.28.28-.52.71-.67,1.18-.01.05-.02.1-.03.15-1.76-.59-5-1.28-9.32-.45-.61.16-1.18.32-1.73.47,0,0,0,0,0,0h0s-.09.03-.14.04c-2.6.73-4.48,1.26-5.69.47ZM53.06,69.51c-.09,2.53-.03,4.99.16,7.39l-1.99-1.3c-.36-2.39-.6-4.93-.71-7.75l2.54,1.66ZM53.32,77.9c.65,6.52,2.38,12.49,5.14,17.69,1.14,2.15,2.46,4.16,3.91,5.97-.27.33-.69.81-1.26,1.36-.82-.83-1.61-1.69-2.36-2.59-1.42-1.71-2.7-3.57-3.78-5.52-1.09-1.97-1.98-4.04-2.67-6.16-1.35-4.13-1.94-8.46-2.12-12.8l3.13,2.05ZM41.73,62.09l5.37,3.51c.05,2.8.21,5.29.46,7.58l-6.11-4c0-2.26.1-4.64.28-7.09ZM46.56,104.41s-2.63-2.59-4.77-8.28c-1.95-5.19-3.9-14.1-2.2-27.21l6.42,4.2c.01.78.03,1.55.06,2.33.17,4.47.75,8.95,2.14,13.21.69,2.12,1.58,4.19,2.67,6.16,1.07,1.95,2.35,3.8,3.78,5.52,1.3,1.57,2.73,3.03,4.24,4.38-2.76,1.83-6.86,3.15-11.69.37-.32-.31-.53-.55-.64-.68ZM48.07,105.88c1.68.79,3.26,1.11,4.72,1.11,5.03,0,8.63-3.81,9.76-5.19,1.41,1.74,2.94,3.28,4.52,4.57-9.09,6.14-16.03,2.04-19-.5ZM63.82,115.17c.64-.99,3.05-4.85,4.03-8.18.62.47,1.24.9,1.87,1.28l-1,7.74c-.52-.27-2.06-.9-4.91-.85ZM67.02,115.76c.96.22,1.51.49,1.68.58,0,.02-.01.06-.05.11-.09.11-.34.29-1.1.36-.39.04-.66.16-.86.31l.33-1.37ZM69.5,119.87c-.08.07-.15.15-.21.23l-.05-1.31c.14.04.24.09.31.15.2.15.23.33.23.33h.01c0,.09,0,.34-.3.6ZM69.82,118.77c-.34-.31-.84-.37-1.31-.33-.46.03-.92.14-1.38.1-.18-.02-.36-.06-.49-.18-.21-.21-.18-.57,0-.8.18-.23.48-.34.76-.4.29-.06.58-.08.86-.16.28-.09.55-.26.67-.53.05-.11.06-.24.08-.36l.42-3.26c.07-.54.14-1.09.21-1.63l.21-1.63c.03-.27.07-.54.1-.81,0-.07.02-.14.03-.2,0-.03,0-.07.01-.1.01-.04.03-.01.06,0,.12.07.24.14.36.2.06.03.12.07.18.1-.26,3.33-.52,6.66-.78,9.99ZM74.57,120.09c-.06-.08-.12-.16-.21-.23-.23-.19-.28-.39-.3-.51v-.09s.04-.18.24-.34c.07-.05.17-.11.31-.15l-.05,1.31ZM77.27,118.25s-.04.05-.06.08c-.15.16-.41.21-.64.22-.43.01-.86-.08-1.3-.11-.43-.02-.9.03-1.24.31-.25-3.18-.5-6.35-.75-9.53-.01-.13-.02-.27.03-.39.09-.21.34-.3.57-.36.29,2.4.58,4.8.87,7.2.05.41.12.85.43,1.13.37.33.92.27,1.37.39.42.11,1.03.57.71,1.07ZM77.17,117.12c-.2-.15-.47-.27-.86-.31-.76-.07-1.01-.26-1.1-.37-.04-.05-.05-.09-.05-.11.18-.1.72-.37,1.68-.58l.33,1.37ZM80.04,115.17c-2.85-.05-4.39.58-4.91.85l-1-7.75c.6-.37,1.23-.8,1.87-1.29.98,3.32,3.4,7.2,4.04,8.19ZM71.93,108.14c-1.62-.79-3.52-2.08-5.45-3.89.07-.18.07-.4.07-.6,0-.29,0-.57.19-.7.03-.02.07-.04.1-.05.07-.03.14-.06.21-.12.07-.07.11-.14.15-.21.02-.05.05-.09.07-.12.09-.09.24-.11.42-.13.21-.02.45-.05.63-.23.17-.16.23-.42.14-.61-.02-.04-.04-.08-.07-.12-.02-.02-.03-.05-.04-.06-.03-.11,0-.21.07-.31.17-.21.53-.34.77-.33.1,0,.2.02.32.03.28.04.6.08.86-.11.1-.07.17-.17.24-.26.08-.11.14-.2.23-.23.06-.02.13-.02.21-.01.16,0,.36,0,.48-.16l.02-.03c.04-.09.07-.11.18-.09l1.73.11c.11,0,.22.01.29.06.05.03.09.09.14.15.05.07.11.15.2.2.19.13.46.14.74.02.07-.03.14-.07.21-.1.11-.06.22-.12.35-.15.21-.07.55.06.7.26.09.12.09.23.02.32-.02.02-.04.03-.07.05-.07.05-.16.11-.2.23-.06.2.11.38.3.45l.07.02c.08.03.15.05.16.07.07.18-.03.35-.2.62-.11.17-.23.35-.25.55v.02s0,.02,0,.02c.03.22.25.29.36.33.14.05.47.18.51.44,0,.04,0,.08,0,.12,0,.09,0,.18.05.28.03.06.06.11.1.15.02.03.04.05.05.08.02.15.07.28.14.38-1.86,1.68-3.67,2.89-5.23,3.65ZM76.78,106.36c1.49-1.22,3.03-2.74,4.53-4.57,1.13,1.37,4.72,5.2,9.78,5.2,1.46,0,3.03-.32,4.7-1.11-3.01,2.55-9.95,6.6-19.01.47ZM102.07,96.13c-2.14,5.69-4.69,8.22-4.72,8.24-.11.13-.34.39-.68.72-4.81,2.76-8.88,1.47-11.65-.35,1.51-1.35,2.93-2.8,4.23-4.37,1.42-1.71,2.7-3.57,3.78-5.52,1.09-1.97,1.98-4.04,2.67-6.16,1.39-4.26,1.97-8.73,2.14-13.21.03-.8.05-1.6.06-2.4l6.38-4.17c1.69,13.11-.25,22.02-2.2,27.21ZM107.19,68.18l-1.89-.41.38-1.9,3.77-.82-2.26,3.12Z'/%3e%3cpath%20class='cls-1'%20d='M83.25,61.92c.21.02.42.03.62.05.11.01.19.03.24.06.09.05.13.14.12.26,0,.11-.01.21-.02.31,0,.07,0,.12,0,.15v.06c.12,0,.23.02.34.04v-.04s-.06-.06-.06-.13c0-.04,0-.09,0-.16,0-.08.02-.17.02-.25.01-.11,0-.19-.03-.24-.03-.05-.09-.1-.16-.13.09-.03.17-.08.23-.15.06-.06.1-.15.11-.26.03-.21-.05-.37-.23-.47-.1-.05-.23-.08-.39-.1-.33-.03-.65-.05-.98-.07-.05.62-.09,1.25-.13,1.87.09,0,.18.01.27.02.02-.27.04-.54.06-.8ZM83.32,61.07c.23.02.46.03.69.06.1,0,.17.03.23.06.1.06.14.15.13.29-.02.12-.07.2-.15.24-.08.04-.18.05-.32.04-.21-.02-.42-.04-.64-.05.02-.21.04-.43.05-.64Z'/%3e%3cpath%20class='cls-1'%20d='M86.42,62.73c.11-.14.19-.31.23-.51.06-.25.04-.47-.07-.66-.12-.21-.32-.34-.6-.39-.28-.05-.56-.09-.84-.13-.1.62-.19,1.24-.28,1.85.26.04.52.08.78.12.33.06.59-.04.78-.29ZM85.16,62.72c.07-.47.15-.95.23-1.42.17.03.33.05.49.08.22.04.38.13.45.28.08.14.09.33.04.56-.01.06-.03.12-.06.19-.05.11-.1.2-.17.26-.09.08-.18.13-.29.14-.06,0-.14,0-.22-.01-.15-.02-.31-.05-.46-.07Z'/%3e%3cpath%20class='cls-1'%20d='M88.25,63.38c-.38-.11-.76-.21-1.15-.3.05-.21.1-.41.15-.62.36.08.72.18,1.07.27.02-.07.04-.14.06-.21-.36-.1-.72-.19-1.08-.28.05-.18.09-.37.14-.55.4.09.8.2,1.2.31.02-.07.04-.15.07-.22-.49-.14-.98-.26-1.48-.37-.15.61-.29,1.22-.43,1.83.47.1.93.22,1.39.35.02-.07.04-.14.06-.21Z'/%3e%3cpath%20class='cls-1'%20d='M88.76,63.76c.16-.48.31-.96.47-1.44.18.59.33,1.17.47,1.76.09.03.18.07.27.1.22-.58.45-1.17.68-1.75-.08-.03-.17-.06-.25-.09-.18.47-.36.95-.54,1.42-.13-.59-.29-1.17-.46-1.76-.11-.03-.21-.07-.32-.1-.19.6-.38,1.19-.57,1.79.08.02.16.05.24.07Z'/%3e%3cpath%20class='cls-1'%20d='M78.79,62.83c.09-.01.18-.02.27-.03-.02-.25-.05-.5-.07-.75.22-.4.46-.79.71-1.18-.11,0-.23.02-.34.03-.18.32-.36.64-.53.96-.23-.28-.46-.55-.7-.82-.11.01-.22.03-.34.05.32.33.62.67.92,1.01.03.25.05.5.08.75Z'/%3e%3cpath%20class='cls-1'%20d='M81.6,62.72c.32,0,.57-.1.76-.31.16-.18.25-.41.26-.69.01-.26-.04-.47-.17-.65-.17-.22-.44-.33-.82-.33-.36,0-.64.12-.81.36-.14.19-.2.41-.2.66,0,.28.1.51.25.69.18.19.42.28.72.28ZM81.11,61.17c.14-.13.32-.2.54-.2.23,0,.4.07.52.21.13.14.18.32.17.54,0,.21-.07.39-.18.55-.11.16-.28.23-.52.23-.25,0-.43-.07-.55-.21-.11-.14-.17-.31-.18-.52,0-.26.06-.46.2-.59Z'/%3e%3cpath%20class='cls-1'%20d='M52.41,64.22c-.2-.53-.4-1.07-.61-1.6-.09.03-.18.06-.27.1.24.6.48,1.2.7,1.81.4-.14.81-.28,1.21-.4-.02-.07-.05-.15-.07-.22-.33.1-.65.2-.97.32Z'/%3e%3cpath%20class='cls-1'%20d='M53.22,62.23c.2.61.4,1.23.59,1.85.09-.03.18-.05.26-.08-.18-.62-.37-1.24-.57-1.85-.09.03-.19.05-.28.08Z'/%3e%3cpath%20class='cls-1'%20d='M55.67,62.61c-.06-.04-.15-.06-.26-.08.06-.05.11-.1.14-.14.06-.09.07-.2.04-.32-.02-.1-.08-.19-.15-.25-.14-.11-.33-.14-.58-.08-.3.07-.6.14-.9.22.19.62.37,1.24.54,1.86.27-.07.55-.14.82-.2.26-.06.43-.17.52-.34.06-.11.08-.23.05-.36-.03-.15-.1-.25-.22-.31ZM54.46,62.68c-.05-.19-.11-.38-.17-.57.17-.04.34-.08.51-.12.12-.03.22-.04.29-.03.12.02.2.09.23.21.03.12,0,.22-.09.29-.06.05-.15.08-.26.11-.17.04-.34.08-.5.12ZM55.59,63.19c-.05.1-.15.18-.32.21-.2.05-.39.09-.58.14-.06-.22-.12-.44-.18-.66.18-.05.36-.09.54-.13.11-.03.21-.04.29-.02.14.02.23.1.26.24.02.08.01.16-.02.22Z'/%3e%3cpath%20class='cls-1'%20d='M57.77,62.83c-.41.05-.82.12-1.23.19-.04-.21-.08-.43-.13-.64.38-.07.76-.13,1.14-.18-.01-.07-.02-.15-.04-.22-.39.05-.77.11-1.15.18-.04-.19-.08-.38-.12-.58.42-.07.85-.14,1.28-.2-.01-.08-.03-.16-.04-.23-.53.07-1.05.15-1.57.25.14.63.28,1.26.4,1.9.49-.09.98-.17,1.48-.23-.01-.08-.02-.15-.03-.23Z'/%3e%3cpath%20class='cls-1'%20d='M58.59,62.92c-.03-.27-.07-.55-.1-.82.21-.02.43-.04.65-.06.12,0,.2,0,.26.02.1.04.16.12.17.24.02.11.03.21.05.32,0,.07.02.12.02.15l.03.06c.11,0,.23-.01.34-.02v-.04s-.08-.05-.1-.11c-.01-.04-.02-.09-.03-.16,0-.09-.02-.17-.03-.26-.01-.11-.04-.19-.09-.24-.05-.05-.11-.08-.2-.11.09-.05.16-.11.21-.19.05-.08.07-.17.05-.29-.02-.22-.13-.37-.35-.44-.11-.04-.25-.05-.42-.03-.34.03-.68.06-1.01.1.1.64.19,1.28.27,1.91.09,0,.18-.02.27-.03ZM59.09,61.16c.1,0,.18,0,.25.02.12.04.18.13.2.27.01.13-.02.22-.09.27-.08.06-.18.09-.31.1-.22.02-.44.04-.66.06-.03-.22-.06-.44-.09-.66.24-.02.48-.05.72-.07Z'/%3e%3cpath%20class='cls-1'%20d='M60.65,61.06c.03.57.06,1.14.08,1.7.1,0,.19,0,.28,0-.01-.57-.04-1.14-.06-1.71.25,0,.5,0,.74,0,0-.08,0-.15,0-.23-.6,0-1.2,0-1.8.03,0,.08.01.15.02.23.25-.01.49-.02.74-.03Z'/%3e%3cpath%20class='cls-1'%20d='M61.84,62.76c.08-.19.15-.38.23-.57.28,0,.56.02.85.04.07.2.13.4.19.59.1,0,.21.02.31.02-.21-.66-.46-1.33-.72-1.99-.11,0-.23,0-.34-.01-.28.63-.55,1.27-.81,1.92.09,0,.19,0,.29,0ZM62.51,61.13c.11.29.21.58.31.87-.22-.01-.45-.02-.67-.03.12-.28.24-.56.36-.84Z'/%3e%3cpath%20class='cls-1'%20d='M65.35,62.62c.11-.15.17-.33.2-.54.03-.26-.02-.49-.15-.68-.15-.21-.38-.34-.69-.38-.31-.04-.61-.07-.91-.09-.03.65-.07,1.29-.12,1.93.28.03.56.06.85.09.36.04.63-.07.82-.33ZM63.99,62.67c.04-.49.08-.99.11-1.49.18.02.36.04.54.06.25.03.42.12.51.27.1.15.13.34.1.58,0,.06-.02.13-.04.2-.04.12-.09.21-.16.28-.08.09-.18.14-.3.16-.06,0-.14,0-.24,0-.17-.02-.34-.04-.52-.06Z'/%3e%3cpath%20class='cls-1'%20d='M74.08,96.5h-.03s0-.17,0-.17h-.28v-.48h.53v-1.25h-.01s-.4,0-.4,0h-.12s0-.37,0-.37c0-.1-.04-.18-.12-.23-.08-.05-.18-.05-.27,0-.08.05-.13.13-.13.23v.38h-.44q-.15,0-.36,0h-.1v-.37c0-.1-.05-.18-.13-.23-.08-.05-.19-.05-.27,0-.08.05-.12.14-.12.23v.38h-.1c-.21,0-.36,0-.36,0h-.44v-.37c0-.1-.05-.18-.13-.23-.08-.05-.19-.05-.27,0-.08.05-.12.14-.12.23v.38h-.53v1.25h.53v.48h-.36v.17h-.03s-.35-.45-.35-.45h-1.34l.61.89.75.48,2.35.02h0s0,0,0,0h0s0,0,0,0l2.35-.02.75-.48.61-.89h-1.34l-.35.45ZM73.11,94.89h.89v.66h-.89v-.66ZM73.25,95.84v.48h-.34v.2h-.33s0-.2,0-.2h-.22v-.48h.89ZM71.65,94.89h.1c.2,0,.31-.07.35-.11.05.04.15.11.35.11h.1v.66h-.9v-.66ZM71.84,95.84v.48h-.3v.2h-.33v-.2h-.26v-.48h.89ZM70.2,95.55v-.66h.89v.66h-.89ZM75.21,96.35l-.27.4-.6.38-2.27.02-2.27-.02-.6-.38-.27-.4h.64l.35.44h.47s0-.17,0-.17h.54v.19l.92.02v-.21h.45v.21l.92-.02v-.19h.54v.18h.47s.35-.45.35-.45h.64Z'/%3e%3cpath%20class='cls-1'%20d='M74.08,104.86h-.03s0-.17,0-.17h-.28v-.48h.53v-1.25h-.01s-.4,0-.4,0h-.12s0-.37,0-.37c0-.1-.04-.18-.12-.23-.08-.05-.18-.05-.27,0-.08.05-.13.13-.13.23v.38h-.44q-.15,0-.36,0h-.1v-.37c0-.1-.05-.18-.13-.23-.08-.05-.19-.05-.27,0-.08.05-.12.14-.12.23v.38h-.1c-.21,0-.36,0-.36,0h-.44v-.37c0-.1-.05-.18-.13-.23-.08-.05-.19-.05-.27,0-.08.05-.12.14-.12.23v.38h-.53v1.25h.53v.48h-.36v.17h-.03s-.35-.45-.35-.45h-1.34l.61.89.75.48,2.35.02h0s0,0,0,0h0s0,0,0,0l2.35-.02.75-.48.61-.89h-1.34l-.35.45ZM73.11,103.25h.89v.66h-.89v-.66ZM73.25,104.21v.48h-.34v.2h-.33s0-.2,0-.2h-.22v-.48h.89ZM71.65,103.25h.1c.2,0,.31-.07.35-.11.05.04.15.11.35.11h.1v.66h-.9v-.66ZM71.84,104.21v.48h-.3v.2h-.33v-.2h-.26v-.48h.89ZM70.2,103.91v-.66h.89v.66h-.89ZM75.21,104.71l-.27.4-.6.38-2.27.02-2.27-.02-.6-.38-.27-.4h.64l.35.44h.47s0-.17,0-.17h.54v.19l.92.02v-.21h.45v.21l.92-.02v-.19h.54v.18h.47s.35-.45.35-.45h.64Z'/%3e%3cpath%20class='cls-1'%20d='M67.2,59.7s0,0,0,0c0-.01,0,0,0,0Z'/%3e%3crect%20class='cls-2'%20x='47.82'%20y='111.02'%20width='6.95'%20height='40.11'%20transform='translate(-79.78%20182.37)%20rotate(-90)'/%3e%3crect%20class='cls-3'%20x='77.89'%20y='121.06'%20width='6.95'%20height='20.04'%20transform='translate(-49.71%20212.45)%20rotate(-90)'/%3e%3crect%20class='cls-4'%20x='97.93'%20y='121.06'%20width='6.95'%20height='20.04'%20transform='translate(-29.67%20232.49)%20rotate(-90)'/%3e%3c/svg%3e", x3 = "data:image/webp;base64,UklGRl4EAABXRUJQVlA4TFIEAAAvbkAHEF/iIJIkRcqBY3Bx/hX+jw0HkSQpUg4cg4vzr/B/HESSpEg5cAwuzr/C/3Eb27aqnO/uLtCBhtQBuRdALcTUQQuELplr5i4zAXzfp4ODCAcKREQR8cEHTxxwxhB/fHHBB/OZeeCCV0Tc8cAVd7xnpgQeHKzM9N73ZZ7nuUXEMSKMqkJEnLpbX9f12N3FqppHxGxm1uu6riIiX1VsRPwiYlVVyao6ZaYeEd3uzqHV3fXuxrIs6G5UFWam9///pzPT3Pe9s64rlmVBZrpoZ+YShe5GZg4yU4COxu/3S4G6bWtLm+vBScrGg71Y3am7u93/BR14Xpoz+uV/RP8hOJIct6nV2DmpJakQeQPx6s6PT+9pAWokZydH+1uLk7uL3sH+1sLkitvfWpBcX11eDHY257iUoM7/hBPG7dx5fRicnfTmuXIg6P5CAphz51Fy1Nvd/rWrCi6mf8HwhTqnn6fHhxvuYI7QFFWCkP6hun8bNUcoRO4Azj/k9X1wzX7xcI44cFUSSKQdNZM4mXbsybVmcgtEip3MUoP1mc3idKmnWnZPy/vuTNadls0SS6WvHv/GyTyhGWIiG54yaEMAQKkSTWrWQqUPLI81ESpKDFYJ0RI8alKXN9QSFayF2nwfs76ysr6+vnn7PEL1YBC1NdjAOcSSYghfpwkQm/pEwHP6ANF0qfADR6nKieYUHmymC4PCcWwfKWmuZ6lOguzr/e2JOVlbXl1bW9u4fnrpZBmqjogSPnCMgogUjZQaqbTMIakeZmyXVCKt4csRMaSo/CkPyOSPuU6vzM3VBcvGxuXj09uPpAn4uDrYwClKg83DRs3PjiXAseD98qemqBNUA7mNJaDR4dnsQfjmLvsMLh5678/cBCimQ/lsUdQKqGcmUYJIWgcXkwRibNMz4QFAIL3kIX+cWpoBXmS11H0OrtaWl1luGOlNQC4+cFuELhC2I8iDPUMo02vUUZolEq2CFyZZNiAz9oDAoe/+B6+lnFxdM5/yFkUxr1oeWC08ZDlKTgOMDL5MIGqJaCqJwU40jSFqpwKC6PXpQc7l4PHpnX8aoySpUjawyk/h2AEM4j34jQ5MRtbYZN1ISv7EWQOFr5tL1N32dx3udXQxeJCpLiyZ5iJvkkAnagUymsHvryZ3URBFqE2iJkspYGtvuJIQUUek+z2ztjqiHBXJ1e6dnF1cXd9w8krKFSFQQqAMa/gqO2gCUYPdVBFAIDy4Rg6UUYkEPjMFgki4cQ01Yy0A9liOepdX7Ac/iKiLREYjTCH0phAe/JlGRJ0lAC/iwzR5CbihQWSXQGVRKJopfCIzdBFkTSw0MiIPnpiO5WDUN81fzVgHakc00rbWSN20/FSPEbIbtKMHAdFYdvYZ9ouvHf11RR5g06/1S/5zIHt5pj9Xoiro/9jeHBydMLfPC/BP2fbugP3iIoSItne5S56F+JDhWYwPD3unfRbn2js+b+lfRw==", P3 = "data:image/webp;base64,UklGRm4EAABXRUJQVlA4TGEEAAAvb0AHED9BIAgRY/x/6AaBIESM8f8hAkGIGOP/QwwaSVKcPVw45ud/Cx8Q22YSAGOgwaIiIQLggUBEWDBGEgICQRgwAFhMeCAiAAMZCR07vv8/oO0FCrZtx9Cwi0iiD4UXEkSb+Y+RT/1NDSCi/xOA14MGtxACCAQL8PN1IR2WwnM+oPA6clP002aRsH2zPFomziAmK2fsCH+Xz7GOMsJLbeN04upXSQaxzvieu01u+gcNMVbpcPd829VRbfYBkVyxmN8jwWMGAEydPT220cEBILR5lv7XtP/3koRbAL4ioqPM8ixxaaaoDgGMgZ3fXURXE38xJ69G1ffnipnGP9bzVV0AARB4AFFLRNRvV3dQflDjuiwCEM58j14VPiyuQTNuNeAnA190dkA4jQ/H4bWg6SGYIiA5gzgC9MTN08RlBCBs6Z511Cki96EuZrUDYLIIXwTFqas6+1QQp2qV/VxlmLdlV9yuVPvA+pvsyo8akv5Q/YpGbV12s1XCNABFfUukDqJPSdTNfcd93VvA8y2Z35ztRzGMi6tOdCmCIkw7BBSD0wigTw0RLbdzhaF47YCygRHuqG/ByAWAmIi6qlyJqN6JLsl4XY1XBWAG3JscAIa2dNWFLkHghrTD+BABaCuA0XS7VkTEn6Jrc80D54sFUNF9r/YiF8w5mZueKN5u3oAP3/jzSJsLa1fUB0RfhaorWwUA/GyPq9SGDpOfVdP4tT/KS0bXvnUNVJfMjDkA50NBRHRURESyJFKhNUCQpVv0lw1v8NYEFhg5A8DiAWxheNRsCgGMdoBZZo3ARDwCAhuFBoMNrZ00MNC9Pt7UnOjE4gB42PGv33neiv6mHmjsyzDcOX51TdTWKb3prZnrbPc/yD8IIuqXIt/2KknK3C2LyYnSGHf/ZndudW98euNpkoo/in8gfUj/Euw2fIgoJ7o+Ryrrz0kkDyKBuy/e1AD4AugBgNZ+B8BSACl7Uv/A/uD/crUGAHsRVXSvd7qLlnb9kKmvhM7XJIPLXHKTMwDvx9wl8iZTl43xnua5lLlAKZaNI4eUbhuAqE/sCGC+qHsqH9yxDADAGclXW5ZLcOl9Nu5AdFsn3DcDVFpBH0CY8hTILbBj14DCDqa9nAArz0ABgG3osSmJTrXOmQUAIZSK/AsFXRiIdJ7nYQeCm4sBWJuHT4MCfMYdsIW3HA86d0sxAXO2sIYBgJZt39Yqk0VeNknqAUC3TC4pXmEoR1MMfkE56vUWVgZjNQqHoIIygwqxLG8qrqcMe1DqoZwByDNb9ynGfd6OtjnaI+e4h2KpRVPpNzMAP8Osq4V3cpwAwIvEBcAshUe4hN7JGZEFpgGYwOwqNGbYVZgRAOb6bM1eBfjefcambRx+biznZRmKTvovpuNjbGz4on8OTNHR+Wk+lRPbJpJEpMkyp82nbs/+4PjJoYhjntRUi3Wb7JaIo69Tzhdp8KvDtarVxtzBAMAcq03VUSURfny0DXjUm8GvBgA=", Z3 = ({ text: t, href: e, target: a = "_self" }) => /* @__PURE__ */ r(
  w0,
  {
    href: e,
    target: a,
    underline: "none",
    variant: "subtitle2",
    component: "a",
    color: "typography.light",
    marginBottom: 1.5,
    sx: { display: "block", width: "fit-content" },
    children: t
  }
), C3 = ({ text: t, tel: e, url: a }) => {
  const { breakpoints: i } = k0(), n = V1(i.down("sm"));
  return /* @__PURE__ */ h(H0, { children: [
    /* @__PURE__ */ r(
      R,
      {
        variant: "subtitle2",
        component: "p",
        color: "typography.light",
        fontWeight: "regular",
        children: t
      }
    ),
    /* @__PURE__ */ r(w0, { href: a, underline: "none", sx: { display: "block", width: "fit-content" }, children: n ? /* @__PURE__ */ h(V, { color: "primary.main", display: "flex", marginBottom: 2, alignItems: "center", children: [
      /* @__PURE__ */ r(V, { sx: { rotate: "10deg" }, mr: 1.125, children: /* @__PURE__ */ r(ri, { size: 16 }) }),
      /* @__PURE__ */ r(R, { variant: "subtitle2", component: "p", color: "primary.main", m: 0, children: e })
    ] }) : /* @__PURE__ */ r(
      R,
      {
        variant: "subtitle2",
        component: "p",
        color: "typography.light",
        marginBottom: 2,
        children: e
      }
    ) })
  ] });
}, V3 = ({ text: t, images: e }) => {
  const { spacing: a } = k0();
  return /* @__PURE__ */ h(H0, { children: [
    t && /* @__PURE__ */ r(
      R,
      {
        variant: "subtitle2",
        component: "p",
        color: "typography.light",
        fontWeight: "medium",
        marginBottom: 1,
        children: t
      }
    ),
    /* @__PURE__ */ r(V, { marginBottom: 2, children: e.map((i) => /* @__PURE__ */ r(w0, { href: i.url, target: "_blank", children: /* @__PURE__ */ r(
      "img",
      {
        src: i.src,
        alt: i.alt,
        loading: "lazy",
        style: {
          height: a(5),
          marginRight: a(1)
        }
      }
    ) }, v0())) })
  ] });
}, va = (t, e = 2.5, a = !1) => a && typeof t == "string" && !t ? null : typeof t == "string" ? /* @__PURE__ */ r(
  R,
  {
    variant: "subtitle1",
    component: "p",
    color: "typography.light",
    marginBottom: e,
    visibility: t ? "visible" : "hidden",
    children: t || "not title"
  }
) : t, O3 = (t) => t, ba = {
  Link: Z3,
  LinkTel: C3,
  LinkImg: V3,
  Custom: O3
}, R6 = ({ data: t }) => {
  const e = (/* @__PURE__ */ new Date()).getFullYear(), { breakpoints: a, spacing: i } = k0(), n = V1(a.down("sm")), [o, d] = d0.useState(!1), s = (c) => (m, f) => {
    d(f ? c : !1);
  };
  return /* @__PURE__ */ r(V, { sx: { bgcolor: "surfaces.main" }, component: "footer", children: /* @__PURE__ */ h(V, { maxWidth: "xl", mx: "auto", pt: { xs: 0, md: 4 }, children: [
    /* @__PURE__ */ r(V, { px: { xs: 0, md: 4 }, children: /* @__PURE__ */ r(h0, { container: !0, spacing: 3, padding: 0, children: t.map((c, m) => /* @__PURE__ */ h(
      h0,
      {
        item: !0,
        xs: 12,
        sm: 6,
        md: c.fr || "auto",
        borderTop: n && c.isMobileAccordion && `${i(0.125)} solid ${l0.surfaces.dark}`,
        pt: n && c.isMobileAccordion && c.title && `${i(1)} !important`,
        pb: n && c.isMobileAccordion && 1,
        children: [
          (!n || !c.isMobileAccordion) && /* @__PURE__ */ h(V, { px: 2, mt: n && !c.title && -3, children: [
            va(c.title, 2.5, n),
            c.content.data.map((f) => /* @__PURE__ */ r(d0.Fragment, { children: ba[c.content.type](f) }, v0()))
          ] }),
          n && c.isMobileAccordion && /* @__PURE__ */ h(
            we,
            {
              expanded: o === `panel${m}`,
              onChange: s(`panel${m}`),
              sx: { margin: 0, backgroundColor: `${l0.surfaces.main} !important` },
              children: [
                /* @__PURE__ */ r(
                  Te,
                  {
                    sx: { backgroundColor: `${l0.surfaces.main} !important` },
                    expandIcon: /* @__PURE__ */ r(V, { color: "typography.light", display: "flex", children: o == `panel${m}` ? /* @__PURE__ */ r(M3, {}) : /* @__PURE__ */ r(A3, {}) }),
                    children: va(c.title, 0)
                  }
                ),
                /* @__PURE__ */ r(Se, { sx: { backgroundColor: "surfaces.main" }, children: c.content.data.map((f) => /* @__PURE__ */ r(d0.Fragment, { children: ba[c.content.type](f) }, v0())) })
              ]
            }
          )
        ]
      },
      `footer-column-${m}`
    )) }) }),
    /* @__PURE__ */ r(e1, {}),
    /* @__PURE__ */ r(V, { py: 4, px: { xs: 0, md: 4 }, children: /* @__PURE__ */ h(h0, { container: !0, spacing: 0, padding: 0, children: [
      /* @__PURE__ */ h(h0, { item: !0, xs: 12, sm: 6, md: 6, px: { xs: 1.75, md: 0 }, children: [
        /* @__PURE__ */ r(
          R,
          {
            variant: "subtitle1",
            component: "p",
            marginBottom: 2,
            color: "typography.light",
            children: "Comfama es un sitio seguro."
          }
        ),
        /* @__PURE__ */ h(V, { display: "flex", overflow: "hidden", children: [
          /* @__PURE__ */ r(
            "img",
            {
              src: x3,
              alt: "Logo Asocajas",
              loading: "lazy",
              style: { borderRadius: i(1), marginRight: i(4) }
            }
          ),
          /* @__PURE__ */ r(
            "img",
            {
              src: P3,
              alt: "Logo Red Pacto Global",
              loading: "lazy",
              style: { borderRadius: i(1), marginRight: i(4) }
            }
          )
        ] }),
        /* @__PURE__ */ r(
          R,
          {
            variant: "subtitle2",
            component: "p",
            color: "typography.light",
            marginBottom: 3,
            marginTop: 4,
            fontWeight: "regular",
            children: "Este sitio funciona mejor con Internet Explorer 10 en adelante con vista de compatibilidad activada, Google Chrome y Firefox y en resolución 1024 x 768 px."
          }
        ),
        /* @__PURE__ */ h(
          R,
          {
            variant: "subtitle2",
            component: "p",
            color: "typography.light",
            marginBottom: 2,
            fontWeight: "regular",
            children: [
              /* @__PURE__ */ h("strong", { children: [
                "Copyright © ",
                e
              ] }),
              " Comfama Todos los derechos reservados Medellín - Colombia."
            ]
          }
        )
      ] }),
      /* @__PURE__ */ h(
        h0,
        {
          item: !0,
          xs: 12,
          sm: 6,
          md: 6,
          alignContent: "end",
          textAlign: "right",
          marginBottom: 2,
          children: [
            /* @__PURE__ */ r(V, { display: "inline", mr: { xs: 0, md: 6 }, children: /* @__PURE__ */ r(
              "img",
              {
                src: S3,
                alt: "Comfama",
                loading: "lazy",
                style: {
                  height: i(6),
                  borderRadius: i(1)
                }
              }
            ) }),
            /* @__PURE__ */ r(w0, { href: "https://www.ssf.gov.co/", target: "_blank", underline: "none", children: /* @__PURE__ */ r(
              "img",
              {
                src: z3,
                alt: "Vigilados",
                style: { width: i(4.4) },
                loading: "lazy"
              }
            ) })
          ]
        }
      )
    ] }) })
  ] }) });
}, Bt = (t) => {
  Object.keys(t).forEach((e) => {
    const a = t[e];
    if (typeof a == "function" || typeof a == "object")
      try {
        a.displayName = e;
      } catch {
      }
  });
};
Bt(Wt);
Bt(r2);
export {
  R3 as AcompanamientoIcon,
  B3 as AcompanamientoManosIcon,
  I3 as AcondicionamientoFisicoIcon,
  $3 as AcostarseIcon,
  j3 as ActivoIcon,
  G3 as AdapterDayjs,
  W3 as AfiliadosComfamaIcon,
  U3 as AgilPertinenteIcon,
  q3 as AlertasMercadoIcon,
  Y3 as AliadosIcon,
  K3 as AlternativasFinanciacionIcon,
  X3 as AplicaSubsidioIcon,
  Q3 as AprendeIcon,
  J3 as AprenderHaciendoIcon,
  e4 as AprendizajeDivertidoIcon,
  a4 as AprendizajeInspiradoresIcon,
  t4 as AsesoriaIcon,
  i6 as Avatar,
  fi as BannerCta,
  Z6 as BannerCustom,
  r4 as CapitalismoConscienteIcon,
  w6 as CardEight,
  b6 as CardFive,
  v6 as CardFour,
  T6 as CardNine,
  f6 as CardOne,
  _6 as CardSeven,
  y6 as CardSix,
  g6 as CardThree,
  p6 as CardTwo,
  L6 as Carousel,
  I6 as CarouselBannerCustom,
  i4 as CercanoIcon,
  n4 as CertificadoB2Icon,
  o4 as CertificadosRequeridosIcon,
  s4 as CincoHabitosIcon,
  l4 as ComunidadIcon,
  d4 as ConcienciaIcon,
  c4 as ConexionIcon,
  u4 as ConexionMundoIcon,
  h4 as ConfianzaIcon,
  m4 as ConsolidacionFinancieraIcon,
  f4 as ConsultaCertificadosIcon,
  p4 as ConsultaEstadoSolicitudIcon,
  g4 as ConsultarIcon,
  O6 as ContentMedia,
  v4 as ControlBebeIcon,
  b4 as ControlVacunasIcon,
  y4 as ControlesIcon,
  _4 as CreditoCapitalTrabajoIcon,
  w4 as CreditoConsumoResponsableIcon,
  T4 as CreditoDisminucionIngresosIcon,
  S4 as CreditoEstudiarCESDEIcon,
  M4 as CreditoFacilAccesoIcon,
  A4 as CreditoHipotecarioIcon,
  z4 as CreditoMicroempresasIcon,
  x4 as CreditoSaludIcon,
  P4 as CreditoSectorAgroIcon,
  P4 as CreditoSectorAgro_2Icon,
  Z4 as CubrirImprevistosIcon,
  C4 as CuidaSaludIcon,
  o6 as CurrencyTextField,
  V4 as DiferentesTiposFinanciacionIcon,
  e1 as Divider,
  O4 as DormirIcon,
  E4 as DuranteFormacionIcon,
  H4 as EcosistemaCreativoIcon,
  L4 as EducacionIcon,
  k4 as ElegirIcon,
  N4 as EmocionesIcon,
  G4 as EncuentraCISIcon,
  I4 as EquilibrioIcon,
  F4 as EscuchaEmpaticaIcon,
  D4 as ExperienciaIcon,
  R4 as ExperienciasComfamaIcon,
  B4 as ExploracionIcon,
  $4 as FamiliarIcon,
  c6 as FileCardOne,
  D6 as FilterSearch,
  j4 as FinanciacionIcon,
  R6 as FooterOne,
  W4 as FortalecimientoIcon,
  U4 as GarantiaIcon,
  q4 as GlobalIcon,
  Y4 as GlosarioIcon,
  K4 as HabitosIcon,
  A6 as HeaderOne,
  X4 as HerraminetasEducacionIcon,
  Q4 as HumanidadIcon,
  M6 as IconCard,
  P6 as ImageContent,
  k6 as ImageContentTwo,
  J4 as InerbargabilidadIcon,
  eo as InformacionValorIcon,
  ao as InterdisciplinarioIcon,
  to as LicenciaSlangStorytelIcon,
  h6 as ListCardOne,
  m6 as ListCardTwo,
  ro as LlegarTiempoIcon,
  u6 as LocationCardOne,
  io as ManutencionSemestralIcon,
  no as MeditarIcon,
  oo as MejoraDeCasaIcon,
  so as MujeresLideresIcon,
  lo as NotificaIcon,
  co as NuestraGenteIcon,
  uo as NuevasOportunidadesIcon,
  ho as OdontologiaIcon,
  s6 as OtpInput,
  H6 as PaginationBar,
  mo as PagoMenosIcon,
  fo as PedirAyudaIcon,
  po as PedirCitaMedicaIcon,
  go as PedirIncapacidadIcon,
  S6 as PeopleCardOne,
  vo as PlanAhorroIcon,
  bo as PlaneacionyGestionIcon,
  F3 as PlazoMesesIcon,
  yo as PlenariosIcon,
  _o as PlenariosIndependientesIcon,
  d6 as Popover,
  wo as PortafolioIcon,
  E6 as PricingByCategory,
  To as ProgramasIcon,
  So as ProyectosAgropecuariosIcon,
  Mo as PruebaLaboratorioIcon,
  Ao as PublicacionesIcon,
  n6 as Rating,
  zo as ReflexionIcon,
  D3 as RehabilitacionFisicaIcon,
  xo as RelacionesInternacionalesIcon,
  Po as RentaHospitalizacionIcon,
  Zo as ReportarSintomasIcon,
  Co as RequisitosMinimosIcon,
  Vo as SeguimientoAhorrosTiempoRealIcon,
  Eo as SeguroAccidentesIcon,
  Ho as SeguroHospitalizacionIcon,
  Oo as SeguroIcon,
  Lo as SeguroMascotasIcon,
  ko as SeguroVidaIcon,
  No as SegurosIcon,
  Go as SieteAccionesIcon,
  Io as SinCuotaManejoIcon,
  Fo as SinSalirIcon,
  Do as SolicitaCreditoIcon,
  Ro as SolicitarCitaIcon,
  Bo as SolicitudAntesDeCompraIcon,
  $o as SolicitudVia_webIcon,
  jo as SubirDocumentosIcon,
  Wo as SubsidioViviendaIcon,
  F6 as TabContentListCard,
  N6 as TabsContent,
  G6 as TabsVerticalContent,
  Uo as TalentosIcon,
  qo as TasaBajoInteresIcon,
  Yo as TelemedicinaIcon,
  a6 as ThemeProvider,
  z6 as TitleCards,
  x6 as TitleDescriptionOne,
  C6 as TitleQuestions,
  V6 as TitleRequirement,
  l6 as Tooltip,
  Ko as TrabajoIcon,
  Xo as TransformacionIcon,
  Qo as TraspasoCuotasIcon,
  Jo as VacunacionIcon,
  e6 as ViviendasIcon,
  cr as darkTheme,
  dr as lightTheme,
  r6 as useChangeFontSize,
  k0 as useTheme,
  t6 as useToggleTheme
};
